(function(){

/* ============================================================
   R148-Z41 — FIRST-TIMER GATE
   ============================================================
   The Hall page has TWO faces:

   1. ANON (no email submitted yet): just header + "Add Your Hero"
      CTA + The Hall character grid. No wallet, no Explore the Hall,
      no Three Doors, no heart economy surface at all. The visitor
      should not even know hearts exist until they commit.

   2. SIGNED-IN (after hero submission, which captures email and
      auto-signs them in): everything appears. Wallet, Explore the
      Hall, Three Doors, full economy.

   The gate uses the same token the rest of the code uses
   (localStorage 'hoh-your-hall-token' with a non-empty email).

   The section template adds html.hoh-hall-signed-in synchronously
   in an inline script BEFORE paint so returning users never see a
   flash of the anon view. This helper is the runtime source of
   truth — every gated render path calls it.

   On successful submission OR Your Hall sign-in, the corresponding
   handler dispatches the 'hoh:signed-in' event. Subscribers (the
   wallet pill renderer, the fresh-faces boot) re-run to wake up
   their gated regions.
*/
window.hohIsHallSignedIn = function(){
  try {
    if(typeof window.hohYourHallEmail === 'function'){
      var em = window.hohYourHallEmail();
      if(em && String(em).trim().length) return true;
    }
    var raw = localStorage.getItem('hoh-your-hall-token');
    if(raw){
      var t = JSON.parse(raw);
      return !!(t && t.email && String(t.email).trim().length);
    }
  } catch(_){}
  return false;
};

/* Mirror the html-level class onto <body> so CSS authors can target
   either. Also drives body-scoped JS guards. Called on DOMContentLoaded
   and whenever we get a 'hoh:signed-in' event. */
window.hohApplyHallAnonClass = function(){
  try {
    var signedIn = window.hohIsHallSignedIn();
    var html = document.documentElement;
    var body = document.body;
    if(signedIn){
      html && html.classList.add('hoh-hall-signed-in');
      html && html.classList.remove('hoh-hall-anon');
      body && body.classList.add('hoh-hall-signed-in');
      body && body.classList.remove('hoh-hall-anon');
    } else {
      html && html.classList.remove('hoh-hall-signed-in');
      html && html.classList.add('hoh-hall-anon');
      body && body.classList.remove('hoh-hall-signed-in');
      body && body.classList.add('hoh-hall-anon');
    }
  } catch(_){}
};

/* Centralized sign-in transition. Submission success handlers and
   the Your Hall sign-in form both call this. Idempotent — calling
   it twice in a row just re-applies the class and dispatches the
   event again, which subscribers de-dupe. */
window.hohDispatchSignedIn = function(source){
  try { window.hohApplyHallAnonClass(); } catch(_){}
  try {
    document.dispatchEvent(new CustomEvent('hoh:signed-in', {
      detail: { source: source || 'unknown' }
    }));
  } catch(_){}
};

/* Apply on DOMContentLoaded so <body> gets its class as soon as the
   body element exists. The html element is already set synchronously
   in the inline script in sections/hall-of-heroes.liquid; this call
   adds the matching body class + cleans up the negative-case class
   the inline script doesn't manage. */
if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', function(){
    try { window.hohApplyHallAnonClass(); } catch(_){}
  });
} else {
  try { window.hohApplyHallAnonClass(); } catch(_){}
}

var SUPABASE_URL='https://obadckrukccwkjgpbsxa.supabase.co/';
var SUPABASE_ANON_KEY='sb_publishable_4DntR53dZydUazuyuPI3YQ_zg69PLYZ';
var supabase=window.supabase.createClient(SUPABASE_URL,SUPABASE_ANON_KEY);

var NPC_WORKER_URL='https://quest-ai.fondlyframed.workers.dev/npc-card';

var HOH_KLAVIYO={COMPANY_ID:'UeMxA4',LIST_ID:'TQmrgu'};

/* R-WAVE1: CAPI routed through the quest-ai worker /capi route. The Meta
   token was removed from this file (it shipped to every Hall visitor) and
   lives server side as a worker secret. Payload unchanged. */
var HOH_CAPI_PROXY="https://quest-ai.fondlyframed.workers.dev/capi";
var HOH_FB_TEST_CODE="";

/* ============================================================
   LAZY jsPDF LOADER
   ============================================================
   jsPDF is ~250KB. It's only used by the NPC PDF export and the
   Company PDF export, both of which fire on user click. There is
   no reason to ship it on initial page load. We inject the script
   tag the first time someone actually needs the library, dedupe
   concurrent calls behind a single Promise, and surface load
   failures to the caller. The original <script> tag was removed
   from sections/hall-of-heroes.liquid in the same change. */
window.hohEnsureJsPDF=(function(){
 var inflight=null;
 return function(){
  if(window.jspdf&&window.jspdf.jsPDF)return Promise.resolve();
  if(inflight)return inflight;
  inflight=new Promise(function(resolve,reject){
   var s=document.createElement('script');
   s.src='https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
   s.async=true;
   s.onload=function(){resolve();};
   s.onerror=function(){
    /* Reset so a later click can retry. */
    inflight=null;
    reject(new Error('jsPDF failed to load'));
   };
   document.head.appendChild(s);
  });
  return inflight;
 };
})();

function hohSha256(text){
 if(!text)return Promise.resolve(null);
 var clean=String(text).toLowerCase().trim();
 var data=new TextEncoder().encode(clean);
 return crypto.subtle.digest("SHA-256",data).then(function(buffer){
 var arr=Array.from(new Uint8Array(buffer));
 return arr.map(function(b){return b.toString(16).padStart(2,"0");}).join("");
 });
}

function hohGetCookie(name){
 var match=document.cookie.match(new RegExp("(^| )"+name+"=([^;]+)"));
 return match?match[2]:null;
}

function hohEventId(eventName){
 return eventName+"_"+Date.now()+"_"+Math.random().toString(36).substring(2,11);
}

function trackHoHCAPI(row){
 if(!HOH_CAPI_PROXY){
 console.warn("[HoH CAPI] No proxy URL set, skipping Lead event");
 return;
 }
 row=row||{};
 var emailPromise=row.email?hohSha256(row.email):Promise.resolve(null);
 var firstName=row.player_name||"";
 var namePromise=firstName?hohSha256(firstName):Promise.resolve(null);

 Promise.all([emailPromise,namePromise]).then(function(hashes){
 var userData={client_user_agent:navigator.userAgent};
 if(hashes[0])userData.em=[hashes[0]];
 if(hashes[1])userData.fn=[hashes[1]];
 var fbp=hohGetCookie("_fbp");
 var fbc=hohGetCookie("_fbc");
 if(fbp)userData.fbp=fbp;
 if(fbc)userData.fbc=fbc;

 var payload={
  data:[{
  event_name:"Lead",
  event_time:Math.floor(Date.now()/1000),
  action_source:"website",
  event_source_url:window.location.href,
  event_id:hohEventId("HoHLead"),
  user_data:userData,
  custom_data:{
   content_name:"Hall of Heroes Submission",
   content_category:"Hall of Heroes",
   character_name:row.name||"",
   is_ff_portrait:row.is_ff_portrait?"yes":"no"
  }
  }]
 };
 if(HOH_FB_TEST_CODE&&HOH_FB_TEST_CODE!=="PASTE_TEST_CODE_HERE")payload.test_event_code=HOH_FB_TEST_CODE;

 fetch(HOH_CAPI_PROXY,{
  method:"POST",
  headers:{"Content-Type":"application/json"},
  body:JSON.stringify(payload)
 }).then(function(r){return r.json();}).then(function(d){
  console.log("[HoH CAPI] Lead sent:",d);
 }).catch(function(e){
  console.error("[HoH CAPI] Lead failed:",e);
 });
 });
}

/* Klaviyo profile/subscription logic lives in assets/hoh-klaviyo.js.
 It exposes window.syncHohLeadToKlaviyo with dupe-prevention rules:
 first submission for an email = full sync; subsequent submissions =
 phone/SMS update only (never re-syncs character props). */

/* hohValidEmail / hohStoryQuality / hohNormalizePhone / hohValidPhone live in assets/hoh-data.js */
/* Show / hide the phone input wrapper when the SMS opt-in checkbox flips. */
window.hohToggleSmsField=function(chk){
 var wrap=document.getElementById('hoh-sms-phone-wrap');
 if(!wrap)return;
 var on=chk&&chk.checked;
 wrap.classList.toggle('hoh-sms-phone-wrap-open',on);
 if(on){
 setTimeout(function(){var p=document.getElementById('hoh-f-phone');if(p)p.focus();},220);
 }else{
 hohClearFieldError('hoh-f-phone');
 }
};

/* Live story progress bar + status line.
   R94: Minimum bumped 80 → 120 chars.
   R146: Minimum bumped again 120 → 280 chars. Too many heroes were
   getting submitted with two sentences and a vibe (the user reported
   stories landing under 200 chars feeling thin). 280 forces a real
   paragraph — about 50 words — which is the floor for an NPC card the
   AI worker can do something interesting with. Bar target lifted to
   400 so the visual headroom matches the new tiers. */
function hohUpdateStoryProgress(){
 var s=document.getElementById('hoh-f-story');
 var fill=document.getElementById('hoh-f-story-fill');
 var text=document.getElementById('hoh-f-story-text');
 var prog=document.getElementById('hoh-f-story-progress');
 if(!s||!text||!prog)return;
 var t=s.value||'';
 var trimmed=t.trim();
 var len=trimmed.length;
 var words=trimmed?trimmed.split(/\s+/).filter(function(w){return w.length>0;}).length:0;
 /* Bar fills toward a target of 400 characters but caps at 100. */
 var pct=Math.min(100,Math.max(0,(len/400)*100));
 if(fill)fill.style.width=pct+'%';
 prog.classList.remove('hoh-story-progress-warn','hoh-story-progress-ok','hoh-story-progress-great','hoh-story-progress-empty');
 if(len===0){
 prog.classList.add('hoh-story-progress-empty');
 text.textContent='Start writing your hero\'s story.';
 }else if(len<120){
 prog.classList.add('hoh-story-progress-warn');
 text.textContent=len+' / 280 characters. Quality heroes only. Give them a story.';
 }else if(len<280||words<45){
 prog.classList.add('hoh-story-progress-warn');
 text.textContent=len+' / 280 characters. Almost there. Keep going.';
 }else if(len<400){
 prog.classList.add('hoh-story-progress-ok');
 text.textContent=words+' words. Looking good.';
 }else if(len<600){
 prog.classList.add('hoh-story-progress-great');
 text.textContent=words+' words. Beautiful.';
 }else{
 prog.classList.add('hoh-story-progress-great');
 text.textContent=words+' words. A page worth bookmarking.';
 }
}

/* Show SMS opt-in row when email validates. */
function hohUpdateSmsVisibility(){
 var wrap=document.querySelector('.hoh-sms-wrap');
 if(!wrap)return;
 var emailValid=hohValidEmail((document.getElementById('hoh-f-email')||{}).value);
 wrap.classList.toggle('hoh-sms-wrap-visible',!!emailValid);
 if(!emailValid){
 var smsCk=document.getElementById('hoh-f-sms-optin');
 var phoneWrap=document.getElementById('hoh-sms-phone-wrap');
 if(phoneWrap)phoneWrap.classList.remove('hoh-sms-phone-wrap-open');
 if(smsCk)smsCk.checked=false;
 hohClearFieldError('hoh-f-phone');
 }
}

/* Reveal NPC details panel only after the form essentials are filled. */
function hohUpdateNpcVisibility(){
 var wrap=document.querySelector('.hoh-npc-wrap');
 if(!wrap)return;
 var emailValid=hohValidEmail((document.getElementById('hoh-f-email')||{}).value);
 var name=((document.getElementById('hoh-f-name')||{}).value||'').trim();
 var player=((document.getElementById('hoh-f-player')||{}).value||'').trim();
 var story=((document.getElementById('hoh-f-story')||{}).value||'').trim();
 var race=(document.getElementById('hoh-f-race')||{}).value||'';
 var charClass=(document.getElementById('hoh-f-class')||{}).value||'';
 var hasImage=!!selectedFiles[0];
 /* R146: Story min 120 → 280. NPC details panel only reveals once
    the story has real meat to it. */
 var ready=emailValid&&name&&player&&story.length>=280&&race&&charClass&&hasImage;
 wrap.classList.toggle('hoh-npc-wrap-visible',!!ready);
 /* R140-Z3p: Stats panel uses a SOFTER gate (story length ≥80) so
    the user sees the option appear sooner — right after they've
    invested in their story. The stats panel mounts lazily on first
    reveal so the form doesn't render the field stack until needed. */
 try { hohUpdateNpcStatsVisibility(); } catch(_){}
}
/* R140-Z3p: Stats panel visibility + lazy mount. Hidden until the
   user has typed ≥80 chars of story. Once visible, the panel stays
   visible (so trimming the story below 80 doesn't snap it away — UX
   nuisance). The inner form is mounted exactly once on first reveal. */
var _hohNpcStatsMounted = false;
var _hohNpcStatsReader = null;
var _hohNpcStatsSeed = null; /* Seed value for edit-mode prefill. */
function hohUpdateNpcStatsVisibility(){
 var wrap = document.getElementById('hoh-npc-stats-wrap');
 if(!wrap) return;
 var story = ((document.getElementById('hoh-f-story')||{}).value||'').trim();
 /* PLAYTESTER 2026-10-04: the story gate is for a NEW hero (a 30 field panel
    only once the story has some meat). An owner editing their hero always
    reaches the stat block: since R795b a hero added through the short form
    can have a short or empty story, and its "Add a stat block in the Hall"
    link used to land on an edit form with no stat block in it. */
 var unlock = story.length >= 80 || !!window.hohEditingCharacterId;
 if(unlock){
   wrap.style.display = '';
   /* Lazy mount the form once. */
   if(!_hohNpcStatsMounted){
     var mount = document.getElementById('hoh-npc-stats-mount');
     if(mount && typeof window.hohRenderNpcStatsForm === 'function'){
       _hohNpcStatsReader = window.hohRenderNpcStatsForm(mount, _hohNpcStatsSeed);
     var quickAc=document.getElementById('hoh-f-quick-ac'),fullAc=document.getElementById('hoh-stats-ac-value');
     if(quickAc&&quickAc.value&&fullAc)fullAc.value=quickAc.value;
       _hohNpcStatsMounted = true;
     }
   }
 }
 /* Note: we don't hide the panel once visible — once unlocked, it
    stays visible even if the user shortens the story. Prevents the
    "I just filled in stats and they vanished" trap. */
}
/* R433 · Shared by both DM accordions. An accordion that opens 1500px of
   fields BELOW the fold of a scroll box changes nothing the player can see,
   which is exactly what "it isn't expanding" looks like from their chair.
   Pull the trigger row to the top of the modal's scroll box on open so the
   thing they just asked for is the thing in front of them. One frame of
   delay so the max-height transition has a laid-out height to measure. */
function hohScrollTriggerIntoModal(el){
 try {
   var box = el && el.closest ? el.closest('.hoh-modal-content') : null;
   if(!box) return;
   var reduce = false;
   try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(_){}
   /* the modal's header is position:sticky, so it floats over the first ~68px
      of the scroll box. Landing the trigger at scrollTop means landing it
      UNDERNEATH the header, which is its own small betrayal — measure the
      header and clear it. */
   var hdr = box.querySelector('.hoh-form-header');
   var clear = (hdr ? hdr.getBoundingClientRect().height : 0) + 14;
   requestAnimationFrame(function(){
     try {
       var top = el.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop - clear;
       box.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
     } catch(_){}
   });
 } catch(_){}
}
window.hohScrollTriggerIntoModal = hohScrollTriggerIntoModal;
function hohToggleNpcStatsPanel(){
 var trig = document.getElementById('hoh-npc-stats-trigger');
 var panel = document.getElementById('hoh-npc-stats-panel');
 if(!trig || !panel) return;
 /* R433 (Jan): "the dm stat block page isnt even expanding when you click
    expand." The toggle itself was never the fault. The panel's contents are
    mounted lazily by hohUpdateNpcStatsVisibility, and that only runs while
    the story field is being edited — if hoh-npc-stats.js had not finished
    defining hohRenderNpcStatsForm at that one moment, the mount stayed
    EMPTY and every later call skipped it, because the visibility helper
    exits early once the story is long enough. Clicking then opened an
    accordion onto nothing, which is indistinguishable from a dead button.
    Mounting on demand here closes that race for good. */
 var mount = document.getElementById('hoh-npc-stats-mount');
 if(mount && !mount.firstChild && typeof window.hohRenderNpcStatsForm === 'function'){
   try {
     _hohNpcStatsReader = window.hohRenderNpcStatsForm(mount, _hohNpcStatsSeed);
     var quickAc=document.getElementById('hoh-f-quick-ac'),fullAc=document.getElementById('hoh-stats-ac-value');
     if(quickAc&&quickAc.value&&fullAc)fullAc.value=quickAc.value;
     _hohNpcStatsMounted = true;
   } catch(_){}
 }
 var opening = !panel.classList.contains('hoh-npc-open');
 trig.classList.toggle('hoh-npc-open');
 panel.classList.toggle('hoh-npc-open');
 if(opening) hohScrollTriggerIntoModal(trig);
}
window.hohToggleNpcStatsPanel = hohToggleNpcStatsPanel;
/* Reset module state when the form is reopened so a fresh submit
   doesn't inherit the previous character's stats. Called from
   hohOpenForm + the edit-character flow. */
function hohResetNpcStatsModuleState(seed){
 _hohNpcStatsMounted = false;
 _hohNpcStatsReader = null;
 _hohNpcStatsSeed = seed || null;
 var mount = document.getElementById('hoh-npc-stats-mount');
 if(mount) mount.innerHTML = '';
 var wrap = document.getElementById('hoh-npc-stats-wrap');
 if(wrap) wrap.style.display = 'none';
 var trig = document.getElementById('hoh-npc-stats-trigger');
 var panel = document.getElementById('hoh-npc-stats-panel');
 if(trig) trig.classList.remove('hoh-npc-open');
 if(panel) panel.classList.remove('hoh-npc-open');
}
window.hohResetNpcStatsModuleState = hohResetNpcStatsModuleState;
/* Clear the inline error UI on a single form field. */
function hohClearFieldError(id){
 var input=document.getElementById(id);
 if(input)input.classList.remove('hoh-input-error');
 var err=document.getElementById(id+'-error');
 if(err){err.style.display='none';err.textContent='';}
}

var allCharacters=[],currentDetail=null,selectedFiles=[null,null],currentImgIdx=0,currentSpotlight=null;
/* RACES / CLASSES live in assets/hoh-data.js */

function getImgs(c){var a=[];if(c.image_url)a.push(c.image_url);if(c.image_url_2)a.push(c.image_url_2);return a;}
/* R319: pretty hero links. A hero with a slug shares as ?hero=name-slug,
   everything else keeps the UUID, and checkUrlHero resolves both forever.
   hohSlugifyName mirrors the SQL's hoh_slugify exactly. */
function hohSlugifyName(t){return String(t||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
window.hohSlugifyName=hohSlugifyName;
function hohHeroParam(c){return (c&&c.slug)?c.slug:((c&&c.id)?String(c.id):'');}
window.hohHeroParam=hohHeroParam;
function heroUrl(id){
 var c=null;
 try{c=(allCharacters||[]).find(function(x){return String(x.id)===String(id);})||null;}catch(_){}
 return window.location.origin+'/pages/hall-of-heroes?hero='+encodeURIComponent(c?hohHeroParam(c):String(id));
}
window.heroUrl=heroUrl;
/* ⛔ R795 · THE HERO PAGE (contract §3). HOH_CONFIG.heroPageUrl is Shopify's
   own URL for the page with handle "hero" on the page.hero template; the
   section renders it only once that page exists, so it is EMPTY until Jan
   creates it, and while it is empty every helper below answers '' and the
   Hall behaves exactly as before. Old /pages/hall-of-heroes?hero= links are
   untouched: checkUrlHero still opens the Hall on them.
   ⛔ heroUrl ABOVE STAYS THE HALL LINK. hoh-klaviyo.js writes it into the
   HoH_Character_URL profile property, and the Klaviyo flows that use it are
   not this change's to move. The hero page link is hohHeroShareUrl. */
function hohHeroPageBase(){
 try{
  var u=String((window.HOH_CONFIG&&window.HOH_CONFIG.heroPageUrl)||'').trim();
  return /^\/[A-Za-z0-9\/_.-]+$/.test(u)?u:'';
 }catch(_){ return ''; }
}
window.hohHeroPageBase=hohHeroPageBase;
/* A hero shown in the main Hall has a public page. A hidden or pending one
   answers no_hero to visitors, so it keeps the Hall link (which opens it). */
function hohHeroPageUrl(c,extra){
 var base=hohHeroPageBase();
 if(!base||!c||c.approved===false||c.is_hidden===true) return '';
 var ref=hohHeroParam(c);
 if(!ref) return '';
 return window.location.origin+base+'?h='+encodeURIComponent(ref)+(extra||'');
}
window.hohHeroPageUrl=hohHeroPageUrl;
function hohHeroShareUrl(id){
 var c=null;
 try{c=(allCharacters||[]).find(function(x){return String(x.id)===String(id);})||null;}catch(_){}
 return (c&&hohHeroPageUrl(c))||heroUrl(id);
}
window.hohHeroShareUrl=hohHeroShareUrl;
/* The move to the hero page. The open dialog eases back and a veil in the
   Hall's ground colour fades up (240ms), then the browser follows the link, so
   the Hall never cuts to a white page. Reduced motion gets a short fade. A
   page restored from the back/forward cache clears the veil (pageshow), and a
   navigation that never happens (blocked, cancelled) clears it after 9s, so
   the Hall can never be left covered. */
var _hohHeroNavAt=0;
function hohClearHeroPageVeil(){
 _hohHeroNavAt=0;
 try{ document.documentElement.classList.remove('hoh-leaving-hall'); }catch(_){}
 var v=document.getElementById('hoh-page-veil');
 if(v) v.classList.remove('is-on');
 /* back from the hero page: the card view's button reads its label again */
 try{
  var sp=document.querySelector('#hoh-modal .hoh-hall-view-toggle span');
  if(sp&&sp.__hohBusy){ if(sp.__hohWas) sp.textContent=sp.__hohWas; sp.__hohBusy=0; }
 }catch(_){ }
}
function hohGoToHeroPage(url,heroId){
 if(!url) return false;
 var now=Date.now();
 if(now-_hohHeroNavAt<3000) return true;
 _hohHeroNavAt=now;
 /* HALLHERO: note the way back (whose card, the scroll, the filters) */
 try{ hohStashHeroReturn(heroId||(currentDetail&&currentDetail.id)||''); }catch(_){}
 var reduce=false;
 try{ reduce=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(_){}
 var veil=document.getElementById('hoh-page-veil');
 if(!veil){
  veil=document.createElement('div');
  veil.id='hoh-page-veil';
  veil.className='hoh-page-veil';
  veil.setAttribute('aria-hidden','true');
  document.body.appendChild(veil);
 }
 try{ document.documentElement.classList.add('hoh-leaving-hall'); }catch(_){}
 void veil.offsetWidth;
 veil.classList.add('is-on');
 /* HEROSPEED (2026-10-14, Jan: "show detailed view ... just gives me a black screen", "make sure it works smoothly and
    FAST on mobile"): the hero page used to be requested only after a fixed 260 ms wait, by which time the veil was fully
    black, so a slow phone showed black for that wait plus the whole load. Now the request starts on the next frame and
    the veil keeps fading while the hero page loads; the page cross-fade is skipped on this exit (layout/theme.liquid). */
 var go=function(){ try{ window.location.assign(url); }catch(_){ window.location.href=url; } };
 if(reduce||!window.requestAnimationFrame) setTimeout(go,0); else requestAnimationFrame(function(){ setTimeout(go,0); });
 setTimeout(hohClearHeroPageVeil, 9000);
 return true;
}
window.hohGoToHeroPage=hohGoToHeroPage;
try{ window.addEventListener('pageshow',function(e){ if(e&&e.persisted){ hohClearHeroPageVeil(); try{ hohClearHeroReturn(); }catch(_){} } }); }catch(_){}
/* R415: viewport-aware reveal maintenance. The old body flooded EVERY card
   with .hoh-visible, which killed the scroll-in entrance for the rest of the
   session the first time a modal closed or a heart landed — the grid read as
   a static wall from then on. The job this helper was actually hired for is
   narrower: nothing the user can CURRENTLY see (or has already scrolled past)
   may be stuck at opacity 0. So cards at or above the viewport reveal
   instantly, and main-gallery cards below the fold return to the hidden
   entrance state and are (re)observed, which keeps the scroll reveal alive
   after every modal close, heart, sort, filter and search.
   Rules that keep this safe:
   - Cards OUTSIDE #hoh-gallery (the review-deck clone and any future .hoh-card
     surface) always get the old instant reveal, so nothing that depended on
     the flood can regress. The review deck additionally self-defends with
     opacity:1 !important on its wrapper.
   - .hoh-card-new keeps its own entrance animation and is never touched.
   - .hoh-grid-leaving (mid FLIP fade-out) is never touched: clearing its
     inline opacity would pop a dying card back to full visibility.
   - Reduced motion or no IntersectionObserver → old flood behavior.
   - Before setupScrollAnimations has built the observer (initial boot paint)
     this is a no-op, preserving the staggered first-load cascade.
   - Reads happen in one pass, writes in a second, so the whole pass costs a
     single layout regardless of card count. */
function forceCardsVisible(){hohRefreshCardReveal();}
var _hohRevealSetupRan=false;
function _hohReducedMotion(){try{return window.matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(_){return false;}}
function hohRefreshCardReveal(){
 var all=document.querySelectorAll('.hoh-card');
 if(!all.length)return;
 /* Flood (old behavior) when there is nothing to preserve: no observer
    support, reduced motion, or setup already ran and still left no observer
    (a crashed setup must never strand hidden cards). A null observer BEFORE
    setup has run is the boot paint — leave it alone, setup owns that pass. */
 var flood=!('IntersectionObserver' in window)||_hohReducedMotion()||(!scrollObserver&&_hohRevealSetupRan);
 if(flood){for(var f=0;f<all.length;f++)all[f].classList.add('hoh-visible');return;}
 if(!scrollObserver)return; /* boot: setupScrollAnimations owns the first pass */
 var gal=document.getElementById('hoh-gallery');
 var vh=window.innerHeight||document.documentElement.clientHeight||0;
 var lim=vh+60; /* mirror the observer's 60px early-reveal rootMargin */
 /* Phase 1 — measure only. An inline transition marks a card MID-FLIP
    (hoh-grid-flip sets transition:none before the move and clears it in its
    cleanup pass): stomping its inline opacity/transform mid-animation would
    snap the slide dead. Call sites like "renderGallery();forceCardsVisible();"
    run synchronously between the two, so this comes up in practice. Mid-FLIP
    cards in view still get the class (that is all the OLD flood did, and it is
    safe); everything else about them waits for the afterRender rebalance that
    renderGallery wires up, which runs after the FLIP cleanup. */
 var meta=[],gi=0;
 for(var i=0;i<all.length;i++){
  var el=all[i];
  if(el.classList.contains('hoh-grid-leaving'))continue;
  var inGal=gal?gal.contains(el):false;
  meta.push({el:el,top:el.getBoundingClientRect().top,inGal:inGal,gi:inGal?gi++:-1,isNew:el.classList.contains('hoh-card-new'),flip:!!el.style.transition});
 }
 /* Phase 2 — write only. */
 for(var k=0;k<meta.length;k++){
  var m=meta[k];
  m.el.setAttribute('data-hoh-reveal-idx',String(m.gi));
  if(m.isNew)continue;
  if(!m.inGal||m.top<lim){
   m.el.classList.add('hoh-visible');
   if(m.flip)continue; /* mid-FLIP: class only, leave the animation alone */
   /* FLIP rerenders pin entering cards visible with inline styles; the
      class carries visibility from here, so the pins can go. */
   if(m.el.style.opacity)m.el.style.opacity='';
   if(m.el.style.transform)m.el.style.transform='';
  }else{
   if(m.flip)continue; /* mid-FLIP below the fold: the afterRender pass owns it */
   m.el.classList.remove('hoh-visible');
   if(m.el.style.opacity)m.el.style.opacity='';
   if(m.el.style.transform)m.el.style.transform='';
   scrollObserver.observe(m.el); /* re-observing a watched target is a no-op */
  }
 }
}
window.hohRefreshCardReveal=hohRefreshCardReveal;
function populateFilterDropdowns(){var rf=document.getElementById('hoh-race-filter'),cf=document.getElementById('hoh-class-filter');rf.innerHTML='<option value="">Races</option>';cf.innerHTML='<option value="">Classes</option>';RACES.forEach(function(r){rf.innerHTML+='<option value="'+r+'">'+r+'</option>';});rf.innerHTML+='<option value="Other">Other</option>';CLASSES.forEach(function(c){cf.innerHTML+='<option value="'+c+'">'+c+'</option>';});cf.innerHTML+='<option value="Other">Other</option>';}
/* R472, FOUND IN REVIEW: `n.length` on a null threw, and this sits to the LEFT
   of hohInitial in the detail modal's concatenation, so it fired FIRST and the
   null-name guard never got a turn. A hero with no name is real: the same wave
   documents a live row with one. Same fix, one function earlier. */
function placeholderBg(n){var s=(n==null?'':String(n)),h=0;for(var i=0;i<s.length;i++)h=s.charCodeAt(i)+((h<<5)-h);h=Math.abs(h%360);return'linear-gradient(135deg,hsl('+h+',40%,20%),hsl('+((h+40)%360)+',50%,15%))';}
window.placeholderBg=placeholderBg;
/* hoh-hearts cache: in-memory map invalidated on write + storage event. */
var __hMC=null;
function getHeartMap(){if(__hMC)return __hMC;try{var raw=localStorage.getItem('hoh-hearts');if(!raw)return __hMC={};var v=JSON.parse(raw);if(Array.isArray(v)){var m={};v.forEach(function(id){m[id]=1;});localStorage.setItem('hoh-hearts',JSON.stringify(m));return __hMC=m;}return __hMC=(v||{});}catch(e){return __hMC={};}}
function getHeartCount(id){var m=getHeartMap();return m[id]||0;}
window.getHeartCount=getHeartCount;
function isHearted(id){return getHeartCount(id)>0;}
function fmtMine(n){return n>=100?'99+':String(n);}
window.fmtMine=fmtMine;
function markHearted(id){var m=getHeartMap();m[id]=(m[id]||0)+1;__hMC=m;localStorage.setItem('hoh-hearts',JSON.stringify(m));return m[id];}
try{window.addEventListener('storage',function(e){if(e&&e.key==='hoh-hearts')__hMC=null;});}catch(e){}
/* Three-tier slowdown driven by character total hearts.
 30-49: 2:1, 50-99: 3:1, 100+: 5:1. */
var HOH_RATIO_2X_AT=50;
/* R97: Tier-factor heart absorb mechanic retired entirely. Every
   heart click now adds 1 displayed heart regardless of tier. The
   ratio constants and slow-chip spawner below are kept as no-op
   shims so any cached HTML / external caller still resolves
   without throwing. The corresponding server-side change is to set
   tier_factor := 1 always in increment_hearts_capped. */
var HOH_RATIO_3X_AT=999999; /* effectively never */
var HOH_RATIO_5X_AT=999999;
/* R234: explicit column list for every characters read. This replaces
   select('*') everywhere in the theme because R233 revokes anon SELECT
   on auth_pin_hash and phone_number, and a star-select can fail under
   column-level grants depending on the PostgREST version. If a future
   migration ADDS a characters column the client needs, it must be
   appended HERE and granted in SQL (GRANT SELECT(newcol) ... TO anon,
   authenticated) or clients will never see it. */
var HOH_CHAR_COLS='id,created_at,name,race,character_class,level,campaign,player_name,email,story,image_url,hearts,featured,approved,is_ff_portrait,image_url_2,video_url,npc_card,npc_exports,npc_current_goal,npc_hidden_weakness,npc_habit,npc_catchphrase,npc_secret,npc_enemy,image_thumb_url,image_thumb_url_2,table_use_count,hearts_today,hearts_today_date,auth_email,share_card_url,tickets,guest_tickets,tickets_today,tickets_today_date,last_edited_at,ff_bonus_granted,click_count_today,pending_click_credit,mythic_granted,is_hidden,image_offset_y,image_offset_y_2,unique_hearters,unique_hearters_base,stats_block,xp,xp_last_passive_at,quest_meta,blueprint_url,blueprint_pdf_url,image_offset_x,image_offset_x_2,image_zoom,image_zoom_2,is_animated,is_animated_2,dnd_level,quest2,mythic_bonus_granted,card_meta,slug,artwork_cover';/* R319: slug requires R319-hero-slugs.sql to have run FIRST (SQL before theme, always) */
window.HOH_CHAR_COLS=HOH_CHAR_COLS;
/* ⛔ R795 · THE GRID'S RARITY COMES FROM THE HERO PAGE SCORE (contract §11).
   The roster asks PostgREST to embed hero_rarity(tier), the tier sql/R795B
   stores per hero (the highest it ever reached, never lowered), and the grid
   shows hero_rarity.tier or 'common' (R805: a FramedFantasy portrait at least
   'uncommon'; its stored tier carries its one tier up, Mythic only once earned).
   ⛔ ONLY THE ROSTER READS ASK FOR IT, NOT HOH_CHAR_COLS ITSELF. That string
   also rides on the Quest handoff's find and publish (hohOpenQuestHandoff runs
   in parallel with the roster, on purpose, so an ad browser is not kept
   waiting), on the submit's insert, the edit's update and every single-hero
   read. Before R795B an embed on any of those is a PGRST200, and on the insert
   that is a failed submit. So the embed lives in hohRosterCols() alone, the
   roster retries without it once (the way it already drops guest_tickets), and
   a row read later without the embed takes its tier from the roster by id.
   Until R795B answers, every tier is today's legacy-hearts tier (hohGetRarity),
   so the Hall looks exactly as it does now. */
var HOH_RARITY_EMBED=',hero_rarity(tier)';
var _hohRarityEmbedOn=true;
var _hohRarityTierById=null;
var HOH_HALL_TIER_LABELS={common:'Common',uncommon:'Uncommon',rare:'Rare',epic:'Epic',legendary:'Legendary',mythic:'Mythic'};
function hohRosterCols(){return HOH_CHAR_COLS+(_hohRarityEmbedOn?HOH_RARITY_EMBED:'');}
window.hohRosterCols=hohRosterCols;
/* ⛔ HALL-SPEED-02 · THE GRID PAINTS FROM A LIGHT ROSTER FIRST (Jan, 2026-10-23: "show the first cards sooner on
   phones ... make sure the user experience is intuitive and smooth").
   The roster above is 65 columns of every visible hero, 1.84 MB gzipped per 1,000 (story 31%, npc_card 15%), and the
   grid waited for all of it: about 15 s on a slow phone. Before hoh:characters-loaded the page reads 25 small fields
   (traced row by row on the live roster, signed in and out: harness/hall-speed/trace-roster.cjs): the tiles, the
   rarity order (hero_rarity, quest_meta.jan_featured), the featured and Ember pins, the marquee, the winner
   (quest_meta.winner_month, level, video_url) and the binder's collector tile (card_meta look, epithet, title,
   quote). This list is those fields, 144 KB gzipped per 1,000; a signed-in visitor also gets auth_email and email,
   the owner key behind "My heroes first".
   loadCharacters asks for it first and paints the grid, the marquee and the winner from it (hohRosterSource); the
   full roster follows exactly as before. Nothing else sees the light rows: allCharacters, hohGetAllCharacters and
   hoh:characters-loaded wait for the full roster, so every other surface starts as it always did. A card tapped in
   between answers at once (a gold ring) and opens when the roster lands. Then every tile the light rows drew is
   compared with the full row's tile and repainted if they differ (the grid keeps tile nodes by id): a field a tile,
   the rarity order or the marquee starts reading belongs in this list, or that tile repaints once on every visit. */
var HOH_LIGHT_COLS='id,slug,name,race,character_class,campaign,player_name,created_at,level,dnd_level,featured,hearts,approved,is_hidden,is_ff_portrait,is_animated,video_url,image_url,image_thumb_url,image_offset_x,image_offset_y,image_zoom,qm_jan:quest_meta->jan_featured,qm_won:quest_meta->winner_month,cm_look:card_meta->look,cm_epithet:card_meta->epithet,cm_title:card_meta->title,cm_quote:card_meta->quote';
var HOH_LIGHT_COLS_SIGNED_IN=',auth_email,email';
var HOH_LIGHT_HEAD_START_MS=2000;  /* the full roster waits at most this long for the light one */
var _hohRosterLight=null, _hohRosterLightTried=false, _hohRosterWait=null, _hohSearchHold=false;
/* the grid's, the marquee's and the winner's rows: the full roster once it is here, the light rows until then */
function hohRosterSource(){ return (allCharacters.length||!_hohRosterLight)?allCharacters:_hohRosterLight; }
function hohRosterArriving(){ return !allCharacters.length&&!!_hohRosterLight; }
/* PGRST200 is PostgREST's "no relationship" (the table or its foreign key is
   not there yet), PGRST201 an ambiguous one; a missing grant or table names
   hero_rarity in its message. */
function hohIsRarityEmbedError(err){
 if(!err) return false;
 var code=String(err.code||'');
 var txt=String(err.message||'')+' '+String(err.details||'')+' '+String(err.hint||'');
 return code==='PGRST200'||code==='PGRST201'||/hero_rarity/i.test(txt);
}
function hohRarityEmbedTier(c){
 var r=c&&c.hero_rarity;
 if(r&&Array.isArray(r)) r=r[0];
 var t=r&&r.tier;
 return (t&&Object.prototype.hasOwnProperty.call(HOH_HALL_TIER_LABELS,t))?t:null;
}
/* Only a row that really carried the embed (the key is on it, null or not)
   fills the map, so a roster that fell back to legacy leaves it empty. */
function hohNoteRarityRows(rows){
 if(!rows||!rows.length) return;
 for(var i=0;i<rows.length;i++){
  var c=rows[i];
  if(!c||!Object.prototype.hasOwnProperty.call(c,'hero_rarity')) continue;
  if(!_hohRarityTierById) _hohRarityTierById={};
  _hohRarityTierById[String(c.id)]=hohRarityEmbedTier(c)||'common';
 }
}
/* The tier the grid shows for one hero, as {tier,label}: the stored score tier
   once the roster carried the embed, today's legacy-hearts tier otherwise. A
   hero made after R795B has no row yet, which is Common.
   ⛔ R805 (Jan, 2026-09-25: "ff portraits basically just get +1 tier up ... it
   doesnt just start in mythic"): a FramedFantasy portrait is no longer Mythic on
   sight. The server stores its tier one step above what its page has earned
   (sql/R805B), so the stored tier is shown as it is; a FramedFantasy portrait
   with no row yet is Uncommon, where its climb starts. The same rule is
   hallTier in hoh-hero-data.js (the hero page's More heroes strip).
   ⛔ MYTHICFF (Jan, 2026-09-30): "mythic should only be achievable by an FF
   portrait". Any other hero tops out at Legendary here, whatever its stored
   row or legacy hearts say (two Cortez heroes kept Mythic from 1,200+ legacy
   hearts; sql/MYTHICFF demotes their rows). */
function hohHallTier(c){
 if(!c) return {tier:'common',label:'Common'};
 var own=Object.prototype.hasOwnProperty.call(c,'hero_rarity');
 var t;
 if(own||_hohRarityTierById){
  t=(own?hohRarityEmbedTier(c):null)||(_hohRarityTierById&&_hohRarityTierById[String(c.id)])||'common';
  if(c.is_ff_portrait&&t==='common') t='uncommon';
 }else{
  t=hohGetRarity(c.hearts||0).tier;
 }
 if(!c.is_ff_portrait&&t==='mythic') t='legendary';
 return {tier:t,label:HOH_HALL_TIER_LABELS[t]};
}
window.hohHallTier=hohHallTier;
function hohHallTierFromScore(){return !!_hohRarityTierById;}
/* R769 (Jan, 2026-09-17): the heart ladder moved. Common 0–49, Uncommon
   50–199, Rare 200–499, Epic 500–999, Legendary 1000–1199, Mythic 1200+.
   The same numbers live in ff_tier_for / open_card_packs / hoh_card_tier /
   the Battlegrounds roster builders (R769D SQL) and in the engine's
   HEART_LADDER_V106 ladder; change all of them together. */
var HOH_MYTHIC_AT=1200;
/* R169: Legend Lock band. At 1000 hearts a Legendary hero locks on the grid and
   the detail; the final 200 hearts to reach Mythic (1200) can only be earned in
   Explore the Hall, so the climb to Mythic has to be organic. */
var HOH_LEGEND_LOCK_AT=1000;
function hohSpawnSlowChip(){ /* R97: no-op — fractional clicks no longer happen */ }
/* Combo floater. "+1" or milestone (x5/x10/x20/x50/x100) above the heart. */
function hohSpawnComboFloater(fromEl,count){
 if(!fromEl)return;
 var r=fromEl.getBoundingClientRect();
 var f=document.createElement('div');
 var cls='hoh-combo-floater';
 if(count>=20)cls+=' hoh-combo-floater-pink';
 else if(count>=5)cls+=' hoh-combo-floater-blue';
 var t=count===100?'x100!':count===50?'x50!':count===20?'x20!':count===10?'x10!':count===5?'x5!':'+1';
 f.className=cls;f.textContent=t;
 f.style.left=(r.left+r.width/2)+'px';f.style.top=r.top+'px';
 document.body.appendChild(f);
 setTimeout(function(){if(f.parentNode)f.parentNode.removeChild(f);},900);
}
function getHearted(){
 /* Legacy helper for code that just wants the list of ids the user has ever
  hearted. Works against the new map shape. */
 var m=getHeartMap();
 return Object.keys(m).filter(function(id){return(m[id]||0)>0;});
}
function heartTierClass(n){if(!n||n<10)return'';if(n<30)return'hoh-heart-t2';return'hoh-heart-t5';}
window.heartTierClass=heartTierClass;

/* R97: Rarity ladder rebalanced. Wider ranges, mythic moved to
   1000 hearts (the secret threshold that grants +1 raffle ticket
   server-side via increment_hearts_capped).
     common    0-29
     uncommon  30-99
     rare      100-199
     epic      200-499
     legendary 500-999
     mythic    1000+ */

/* ============================================================
   R329: THE RENOWN MARQUEE — a slow drift of portraits under the
   banner. Square crops that honour each hero's saved reframe, wearing
   their rarity glow, naming themselves on hover, fading out at both
   edges so it reads as a current rather than a list that got cut off.
   Built once after the roster lands. If the Hall has fewer than a
   handful of them the strip stays empty and invisible, because a
   marquee of two looks like a mistake.

   R667 (Jan): THE STRIP IS FRAMEDFANTASY WORK ONLY, not every renowned
   hero. It sits directly under the title, so it is the first picture
   anyone forms of what this place makes, and a player's own uploaded
   image standing in that row says the opposite of what the strip is
   for. is_ff_portrait is the same flag the gallery's FF Portraits sort
   and the detail credit line already read, so there is no second
   definition of "ours" to keep in sync.
   MEASURED 2026-09-04 before the narrowing, because a filter that
   empties this band folds it away and Jan sees nothing: 110 public FF
   portraits, and every one of them is already at 100 hearts or more
   (46 legendary and above, 38 mythic). So the new pool is a strict
   SUBSET of the old rare-and-above one, it clears the six-tile floor
   by a wide margin, and no tile can land on a rarity tier the CSS has
   no glow for.
   ============================================================ */
function hohRenderRarityMarquee(){
 var host=document.getElementById('hoh-marquee');
 if(!host||host.__hohBuilt)return;
 var pool=[];
 try{
  pool=(hohRosterSource()||[]).filter(function(c){ /* HALL-SPEED-02: the light rows until the roster lands */
   if(!c||c.is_hidden===true)return false;
   if(!(c.image_thumb_url||c.image_url))return false;
   /* R667: FramedFantasy portraits only. The hearts test is gone rather
      than kept alongside this one: every FF portrait already clears it,
      so carrying it would only be a second gate that could quietly empty
      the strip if the Hall's heart economy ever moved. */
   return !!c.is_ff_portrait;
  });
 }catch(_){ try{ host.classList.add('hoh-mq-collapsed'); }catch(__){} return; }
 /* R519: the marquee band is now RESERVED in CSS before the roster lands
    (min-height 220px desktop, 166px phone), because Jan on a real iPhone:
    "everything in the main hall of heroes grid on mobile is pushed lower so it
    is harder to see". So an exit that leaves the strip empty must give the
    band back. The class collapses it with a transition; the old
    style.display='none' would snap it shut in one frame, which is the exact
    layout jump this wave exists to remove. */
 if(pool.length<6){ host.classList.add('hoh-mq-collapsed'); return; }
 /* the most renowned lead, then a light shuffle so it is not a leaderboard */
 pool.sort(function(a,b){return (b.hearts||0)-(a.hearts||0);});
 pool=pool.slice(0,28);
 for(var i=pool.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=pool[i];pool[i]=pool[j];pool[j]=t;}
 /* R667: THE FIRST ROW LOADS WITH THE PAGE. Measured live 2026-09-04, 2.5s
    after load at the top of the page: 4 of 56 marquee images had arrived on a
    phone and 5 of 56 on desktop, because every tile was loading="lazy" inside
    a track that is already drifting, so the most prominent band on the page
    showed hollow frames sliding past. The first MQ_EAGER tiles of the visible
    row load eagerly (the second row repeats the same files, so it costs
    nothing extra) and the rest stay lazy. No fetchpriority on purpose: the
    LCP rule allows one to three hints a template and eight would fight the
    hero image for the connection.
    ⛔ AND THE DUPLICATE ROW WAS ONLY HIDDEN FROM SCREEN READERS, NOT FROM THE
    KEYBOARD. aria-hidden removes nothing from the tab order, so a keyboard
    user met every hero twice, the second time on a button that announced
    nothing. The copy's buttons carry tabindex="-1" now. */
 var MQ_EAGER=8;
 function tile(c,eager,dup){
  /* R795: the marquee frame wears the grid's tier */
  var r=hohHallTier(c);
  var pos='50% 50%';
  try{ if(typeof window.hohImgObjPos==='function') pos=window.hohImgObjPos(c.id,'primary'); }catch(_){}
  var cropStyle=(typeof window.hohImgStyle==='function')?window.hohImgStyle(c.id,'primary'):('object-position:'+pos+';');
  var img=c.image_thumb_url||c.image_url||'';
  /* R330: no native title — the browser's own tooltip fired alongside the
     styled label, in the OS font, at the OS delay. aria-label still names the
     hero for assistive tech. R667: name and rarity are joined by a comma. A
     screen reader read the dash aloud, and the voice rules ban it in anything
     a player meets. */
  return '<button type="button" class="hoh-mq-i hoh-mq-'+r.tier+'" data-hero="'+esc(String(c.id))+'"'+(dup?' tabindex="-1"':'')+
   ' aria-label="'+esc((c.name||'Hero')+', '+r.label)+'">'+
   '<img src="'+esc(img)+'" alt="" loading="'+(eager?'eager':'lazy')+'" decoding="async" draggable="false" style="'+esc(cropStyle)+'">'+
   '<span class="hoh-mq-nm">'+esc(c.name||'Hero')+'</span>'+
   '</button>';
 }
 var rowA=pool.map(function(c,i){ return tile(c, i<MQ_EAGER, false); }).join('');
 var rowB=pool.map(function(c){ return tile(c, false, true); }).join('');
 /* the track is doubled so the loop is seamless; the copy is hidden from
    assistive tech and from tab order so nobody meets each hero twice. */
 host.innerHTML='<div class="hoh-mq-track">'+
   '<div class="hoh-mq-row">'+rowA+'</div>'+
   '<div class="hoh-mq-row" aria-hidden="true">'+rowB+'</div>'+
  '</div>';
 host.__hohBuilt=1;
 host.style.display='';
 /* R519: a roster that lands AFTER the 10s watchdog folded the band must
    still get its marquee. Removing the class lets the reservation grow back
    (transitioned), and the populated height equals the min-height exactly,
    so on the normal fast path this line changes nothing at all. */
 try{ host.classList.remove('hoh-mq-collapsed'); }catch(_){}
 /* R667: THE STRIP HOLDS STILL UNDER A FINGER. The track never paused (its
    hover rule said running), so on a phone a tap could land on the neighbour
    that had drifted under it, and there is no hover on a phone to show a
    name first. A pointer down parks the track and it stays parked a beat
    after the pointer lifts, so the tap lands on a still tile. Hover and
    keyboard focus park it in CSS. */
 var _mqHoldT=null;
 function _mqHold(on){
  if(_mqHoldT){ clearTimeout(_mqHoldT); _mqHoldT=null; }
  if(on){ host.classList.add('hoh-mq-hold'); return; }
  _mqHoldT=setTimeout(function(){ host.classList.remove('hoh-mq-hold'); _mqHoldT=null; },260);
 }
 host.addEventListener('pointerdown',function(){ _mqHold(true); },{passive:true});
 host.addEventListener('pointerup',function(){ _mqHold(false); },{passive:true});
 host.addEventListener('pointercancel',function(){ _mqHold(false); },{passive:true});
 host.addEventListener('pointerleave',function(){ _mqHold(false); },{passive:true});
 /* a portrait opens its hero, the same door the grid uses.
    HALLFIX (2026-10-29): the grid moved to the card view (R558) and this row
    still opened the old detail close-up, so it now opens the card view too,
    flying from the tapped portrait, and keeps the grid's own exception (Your
    Heroes opens the detail view). */
 host.addEventListener('click',function(e){
  var b=e.target&&e.target.closest?e.target.closest('.hoh-mq-i'):null;
  if(!b)return;
  var id=b.getAttribute('data-hero');
  if(!id)return;
  if(typeof window.hohOpenHallCard==='function'&&!document.body.classList.contains('hoh-page-mode-yours')){ try{ window.hohOpenHallCard(id,b); }catch(_){} }
  else if(typeof window.hohOpenDetail==='function'){ try{ window.hohOpenDetail(id); }catch(_){} }
 });
}
window.hohRenderRarityMarquee=hohRenderRarityMarquee;
/* R519: THE WATCHDOG FOR THE RESERVED BAND. The marquee's height is now
   pre-booked in CSS so nothing below it moves when it populates (Jan, from a
   real iPhone: "everything in the main hall of heroes grid on mobile is pushed
   lower so it is harder to see"). The cost of a reservation is that a roster
   which never arrives (offline, Supabase outage, a throw before the boot
   renderers run) would leave a permanent blank stripe under the title. Ten
   seconds is past any healthy roster load, including the paged fetches on slow
   mobile. If the strip has not built by then the band folds away via the CSS
   transition; a roster that limps in later still wins, because the renderer
   removes the class and rebuilds. */
(function(){
 function hohMarqueeWatchdog(){
  var host=document.getElementById('hoh-marquee');
  if(!host) return;
  setTimeout(function(){
   if(!host.__hohBuilt){ try{ host.classList.add('hoh-mq-collapsed'); }catch(_){} }
  },10000);
 }
 if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',hohMarqueeWatchdog); }
 else{ hohMarqueeWatchdog(); }
})();

/* R335: PORTRAIT PROTECTION, THE JS HALF.
   One delegated listener on the document rather than an attribute on every
   image: the Hall paints hundreds of portraits and rebuilds them constantly,
   so a per-node handler would have to be re-attached on every render and
   would eventually be missed somewhere. Delegation covers every image that
   ever appears, including ones added later by the marquee, the shop, the
   battlegrounds and any surface built after this was written.

   Scope is deliberate. It cancels the menu on ART ONLY -- portraits inside
   Hall surfaces -- and leaves the rest of the page alone, because blanket
   right-click blocking is hostile: it breaks "open in new tab" on links,
   spellcheck in the submission form, and paste into the PIN fields.

   This is a deterrent, not DRM. The file is still in the network tab and
   still in the cache; nothing rendered in a browser can change that. What it
   does remove is the one-click path an ordinary visitor takes. */
(function(){
  if(window.__hohArtGuard) return;
  window.__hohArtGuard = true;
  var ART_SEL = '.hoh-marquee img,.hoh-card img,.hoh-mq-i img,.hoh-detail-img,' +
                '.hoh-featured img,.hoh-grid img,.ffshop-card img,.hoc-card img,' +
                '.hoc-mfan img,.hoc-fan img,.hoh-slot img,.hoh-slot-img,' +
                /* v20b: the party builder, its shelf, the recruit cards and
                   the bench are art surfaces too — same protection */
                '.ffshop-pb img,.ffshop-tile img,.hoc-recruit img,.hoc-bench img,.hoc-parties img';
  document.addEventListener('contextmenu', function(e){
    var t = e.target;
    if(!t || !t.matches) return;
    /* R346: the god-mode bypass is GONE, at Jan's request — he tests as a
       player, and the exemption is why the save menu appeared on the muster
       in his screenshot. Inspect is still one keyboard shortcut away. */
    try{ if(t.matches(ART_SEL)) e.preventDefault(); }catch(_){}
  }, false);
  /* the drag path, for browsers that ignore the CSS user-drag property */
  document.addEventListener('dragstart', function(e){
    var t = e.target;
    if(!t || t.tagName !== 'IMG' || !t.matches) return;
    if(t.matches(ART_SEL)) e.preventDefault();
  }, false);
})();

function hohGetRarity(hearts){
 var n=hearts||0;
 if(n>=HOH_MYTHIC_AT)return{tier:'mythic',label:'Mythic'};
 if(n>=HOH_LEGEND_LOCK_AT)return{tier:'legendary',label:'Legendary'};
 if(n>=500)return{tier:'epic',label:'Epic'};
 if(n>=200)return{tier:'rare',label:'Rare'};
 if(n>=50)return{tier:'uncommon',label:'Uncommon'};
 return{tier:'common',label:'Common'};
}
window.hohGetRarity=hohGetRarity;
/* R65: Mythic helpers — single source of truth so every surface
   (Fresh Faces card render, host pickers, heart button gate, ticket
   apply, breakdown live update) agrees on what counts as mythic.
   Mythic threshold lives in HOH_MYTHIC_AT (1200 hearts since R769).
   MYTHICFF (Jan, 2026-09-30): only a FramedFantasy portrait is ever Mythic. */
window.hohIsMythicCharacter=function(c){
 if(!c||!c.is_ff_portrait)return false;
 var h=(typeof c.hearts==='number')?c.hearts:0;
 return h>=HOH_MYTHIC_AT;
};
/* R169: Legend Locked = 1000 to 1199 hearts (the whole Legendary tier since
   R769). The grid and detail heart are locked; only Explore the Hall can push
   them toward Mythic. MYTHICFF: any other hero stays Legend Locked past 1200,
   the top of its ladder, so its heart gate is the one it always had. */
window.hohIsLegendLocked=function(c){
 if(!c)return false;
 var h=(typeof c.hearts==='number')?c.hearts:0;
 return h>=HOH_LEGEND_LOCK_AT && (h<HOH_MYTHIC_AT || !c.is_ff_portrait);
};
/* R171: Quest achievement badges. Each quest a hero survives earns a mark. The
   grid shows a small strip of them, the opened card shows full medals with
   flavored lines. Icons are diegetic: the Iron Matron's cup (her trap), the
   dragon's flame. Only EARNED badges render, never locked placeholders. */
/* R194: badge registry. Each badge carries a rarity that tints its medal box
   (standard = gold, mythic = rainbow, brand = FramedFantasy pink/blue) plus the
   icon. The three Hall Contributor ranks use metal shields; FF Portrait is the
   brand badge. Contributor shields reference gradients defined ONCE in a
   persistent <defs> (hohInjectBadgeDefs) so the metal fills never break when a
   card node re-renders and removes whatever SVG happened to hold the def. */
(function(){
  var STAR='M0,-1 L0.225,-0.309 L0.951,-0.309 L0.363,0.118 L0.588,0.809 L0,0.382 L-0.588,0.809 L-0.363,0.118 L-0.951,-0.309 L-0.225,-0.309 Z';
  function star(x,y,s,f){return '<g transform="translate('+x+','+y+') scale('+s+')" fill="'+f+'"><path d="'+STAR+'"/></g>';}
  var SH='M32 6 L54 13.5 V31 C54 44.5 44.5 53.5 32 58.5 C19.5 53.5 10 44.5 10 31 V13.5 Z';
  var IN='M32 11.5 L49 17.5 V31 C49 41.5 41.5 49.5 32 53.5 C22.5 49.5 15 41.5 15 31 V17.5 Z';
  function shield(grad,stroke,inner,stars){return '<svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true"><path d="'+SH+'" fill="url(#'+grad+')" stroke="'+stroke+'" stroke-width="1.6"/><path d="'+IN+'" fill="'+inner+'" opacity="0.32"/>'+stars+'</svg>';}
  var crown='<path d="M24 9 L28 14 L32 7 L36 14 L40 9 L39 16 L25 16 Z" fill="url(#hohGld)" stroke="#7a5a12" stroke-width="0.8"/>';
  window.HOH_QUEST_BADGES = {
    'iron-matron': { name:'Matron Slayer', rarity:'standard', flavor:'Drank from the Iron Matron\'s cup at the Hollow Stump and walked out. Few ever do.', svg:'<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M6 5H18L16.6 11.2Q12 14.4 7.4 11.2Z" fill="currentColor"/><rect x="11" y="13" width="2" height="5" fill="currentColor"/><path d="M7.4 19H16.6L17.6 21H6.4Z" fill="currentColor"/></svg>' },
    'iron-court':  { name:'Born from Fire', rarity:'standard', flavor:'Walked into the dragon\'s fire and came back forged anew.', svg:'<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M12 3 C15 8 16 11 14 15 C16 14 16 11 15 9 C18 13 16 19 12 21 C8 19 6 13 9 9 C8 11 8 14 10 15 C8 11 9 8 12 3 Z" fill="currentColor"/></svg>' },
    'hall-contributor-1': { name:'Hall Contributor I', rarity:'bronze', family:'hall-contributor', tier:1, flavor:'Five or more heroes added to the Hall.', svg:shield('hohBrz','#5e3d16','#241606',star(32,30,8,'#ffe9d2')) },
    'hall-contributor-2': { name:'Hall Contributor II', rarity:'silver', family:'hall-contributor', tier:2, flavor:'Ten or more heroes added to the Hall.', svg:shield('hohSlv','#5b626c','#1b1f26',star(25,30,6,'#ffffff')+star(39,30,6,'#ffffff')) },
    'hall-contributor-3': { name:'Hall Contributor III', rarity:'standard', family:'hall-contributor', tier:3, flavor:'Twenty or more heroes. A pillar of the Hall.', svg:shield('hohGld','#7a5a12','#2a2008',star(23,33,5.2,'#fff4d2')+star(41,33,5.2,'#fff4d2')+star(32,28,6,'#fff4d2')) },
    /* R205: the Mythic tier MUST read brand (FF pink/blue), not gold, so it never
       looks like the Gold tier. This badge is hand-built (crown + shield + stars)
       so it can't ride the currentColor->brand rule the other mythics use; we
       paint it with url(#hohBrand) directly and inline a brand crown (the shared
       gold `crown` helper stays for nothing else). White stars keep the depth. */
    'hall-contributor-4': { name:'Mythic Hall Contributor', rarity:'mythic', family:'hall-contributor', tier:4, flavor:'Thirty or more heroes. A titan of the Hall.', svg:'<svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true"><path d="M24 9 L28 14 L32 7 L36 14 L40 9 L39 16 L25 16 Z" fill="url(#hohBrand)" stroke="#b3f5ee" stroke-width="0.8"/><path d="'+SH+'" fill="url(#hohBrand)" stroke="#b3f5ee" stroke-width="1.6"/><path d="'+IN+'" fill="#1a1422" opacity="0.32"/>'+star(23,33,5.2,'#ffffff')+star(41,33,5.2,'#ffffff')+star(32,28,6,'#ffffff')+'</svg>' },
    'raffle-winner': { name:'Raffle Winner', rarity:'mythic', flavor:'Crowned a winner of the Hall raffle.', svg:'<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M4 8.5 L7.5 12.5 L12 6 L16.5 12.5 L20 8.5 L18.3 17.5 L5.7 17.5 Z" fill="currentColor"/><rect x="5.3" y="18.8" width="13.4" height="2.4" rx="0.6" fill="currentColor"/><circle cx="4" cy="8.5" r="1.3" fill="currentColor"/><circle cx="12" cy="6" r="1.4" fill="currentColor"/><circle cx="20" cy="8.5" r="1.3" fill="currentColor"/></svg>' },
    'completionist': { name:'Completionist', rarity:'standard', flavor:'A fully realized hero. Every detail filled in.', svg:'<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6 L4.6 7.6 L7.8 4.4"/><path d="M3 12 L4.6 13.6 L7.8 10.4"/><path d="M3 18 L4.6 19.6 L7.8 16.4"/><path d="M11 6 H21 M11 12 H21 M11 18 H21"/></g></svg>' },
    'merchants-mark': { name:'Merchant\'s Mark', rarity:'brand', flavor:'Bought from the merchant in starlit robes.', svg:'<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M12 2 L13.7 9.3 L21 11 L13.7 12.7 L12 20 L10.3 12.7 L3 11 L10.3 9.3 Z" fill="url(#hohBrand)"/><circle cx="18.5" cy="5.5" r="1.2" fill="url(#hohBrand)"/><circle cx="5.2" cy="16.5" r="0.95" fill="url(#hohBrand)"/></svg>' }
  };
  /* R198: tiered badge families. One clean icon per family; the tier shows in the
     ring color (bronze, silver, gold, mythic). Generated as real registry entries
     family-1..4 so all existing display/equip/order code treats them like any badge. */
  var icHeart='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M12 20 C12 20 4.5 15.2 4.5 9.8 C4.5 7 6.5 5.5 8.7 5.5 C10.2 5.5 11.4 6.4 12 7.6 C12.6 6.4 13.8 5.5 15.3 5.5 C17.5 5.5 19.5 7 19.5 9.8 C19.5 15.2 12 20 12 20 Z" fill="currentColor"/></svg>';
  var icBook='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M12 6 C9.8 4.6 7 4.4 4.5 5.2 V17.2 C7 16.4 9.8 16.6 12 18 M12 6 C14.2 4.6 17 4.4 19.5 5.2 V17.2 C17 16.4 14.2 16.6 12 18 M12 6 V18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  var icFrame='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><rect x="5" y="4" width="14" height="16" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="10" r="2.3" fill="currentColor"/><path d="M7.8 17 C9.2 14.2 14.8 14.2 16.2 17 Z" fill="currentColor"/></svg>';
  var icBanner='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M6.5 3 H18 V16.5 L12.25 13.8 L6.5 16.5 Z" fill="currentColor"/><line x1="6.5" y1="3" x2="6.5" y2="21" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var icGlass='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M6 3 H18 M6 21 H18 M7.5 3 C7.5 8 12 9 12 12 C12 15 7.5 16 7.5 21 M16.5 3 C16.5 8 12 9 12 12 C12 15 16.5 16 16.5 21" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  /* R214: Powering Up — the Hall Level milestone, an ascending-rank chevron stack.
     Per-hero, climbs by the hero's own level (10/30/50/100 -> bronze/silver/gold/
     mythic). currentColor so it tints per tier and the R203 brand gradient paints
     the strokes at mythic. */
  var icRank='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M6 9 L12 5 L18 9" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 14 L12 10 L18 14" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 19 L12 15 L18 19" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  /* R207: Patron + Beloved merged into ONE badge (see the explicit patron-1..5
     block after this loop). Beloved is retired; Patron is no longer in this
     shared bronze/silver/gold/mythic loop because every one of its tiers is
     brand (mythic) colored. The remaining families keep the four-tier ladder. */
  var _hohFams=[
    {f:'lorekeeper', base:'Lorekeeper', icon:icBook,   fl:['A written past.','A rich, detailed history.','A deep and storied legend.','A saga worthy of the archives.']},
    {f:'veteran',    base:'Veteran',    icon:icGlass,  fl:['One month in the Hall.','Half a year strong.','A full year in the Hall.','Years deep, a pillar of the Hall.']},
    {f:'powering-up',base:'Powering Up',icon:icRank,   fl:['Hall Level 10. Getting started.','Hall Level 30. Picking up steam.','Hall Level 50. A proven hero.','Hall Level 100. Maxed and mythic.']}
  ];
  var _hohRar=['bronze','silver','standard','mythic'], _hohRl=['I','II','III'];
  _hohFams.forEach(function(F){
    for(var t=1;t<=4;t++){
      window.HOH_QUEST_BADGES[F.f+'-'+t]={ name:(t===4?'Mythic '+F.base:F.base+' '+_hohRl[t-1]), rarity:_hohRar[t-1], family:F.f, tier:t, flavor:F.fl[t-1], svg:F.icon };
    }
  });
  /* R207: Patron — the merged FF-portrait badge (old person-icon Patron + the
     Beloved heart, retired into one). Tracks FF portraits owned; EVERY tier is
     brand (mythic) colored because owning FF portraits is the FramedFantasy
     mark, so it just climbs I..V by portrait count with one constant brand
     color, using the heart icon. Rarity 'mythic' on all five → the R203 brand
     gradient paints the heart on every tier. */
  var _patronFl=['Owns a FramedFantasy portrait.','A devoted FramedFantasy patron.','A dedicated patron of the arts.','A grand patron of the Hall.','A legendary FramedFantasy patron.'];
  var _patronRl=['I','II','III','IV','V'];
  for(var _pt=1;_pt<=5;_pt++){
    window.HOH_QUEST_BADGES['patron-'+_pt]={ name:'Patron '+_patronRl[_pt-1], rarity:'mythic', family:'patron', tier:_pt, flavor:_patronFl[_pt-1], svg:icHeart };
  }
  /* R241: APPLIED badges — the Shop achievements. THE DISTINCTION:
     INTRINSIC badges belong to one hero by nature and attach themselves
     (FF Portrait, Completionist, Lorekeeper, Powering Up, trials earned
     by the hero, Raffle Winner placed by hand, Merchant's Mark placed at
     purchase). APPLIED badges are earned by the ACCOUNT — pack counters,
     collection counts — and must be pinned onto ONE chosen hero through
     the apply picker (hohBadgeApplyPicker). `applied:true` marks them;
     everything without the flag is intrinsic. One wearer per family. */
  var icPack='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><rect x="4.2" y="6.6" width="9.6" height="13" rx="1.4" transform="rotate(-9 9 13)" fill="none" stroke="currentColor" stroke-width="1.7"/><rect x="10.4" y="5.6" width="9.6" height="13" rx="1.4" transform="rotate(8 15 12)" fill="currentColor"/><path d="M12 1.6 L12.8 3.6 L14.8 4.4 L12.8 5.2 L12 7.2 L11.2 5.2 L9.2 4.4 L11.2 3.6 Z" fill="currentColor"/></svg>';
  var icDust='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M10.5 19 C10.5 19 4 14.8 4 10.1 C4 7.7 5.8 6.4 7.7 6.4 C9 6.4 10 7.2 10.5 8.2 C11 7.2 12 6.4 13.3 6.4 C15.2 6.4 17 7.7 17 10.1 C17 11 16.7 11.9 16.2 12.7 L10.5 19 Z" fill="currentColor"/><circle cx="18.2" cy="7.4" r="1.25" fill="currentColor"/><circle cx="20.4" cy="10.6" r="0.95" fill="currentColor"/><circle cx="19.4" cy="14" r="0.75" fill="currentColor"/></svg>';
  var icFirst='<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M7 2.8 H17 V21.2 L12 16.9 L7 21.2 Z" fill="currentColor"/><path d="M12 6 L12.9 8.2 L15.2 8.5 L13.5 10.1 L14 12.4 L12 11.2 L10 12.4 L10.5 10.1 L8.8 8.5 L11.1 8.2 Z" fill="#1a1422"/></svg>';
  var _appFams=[
    {f:'packbreaker', base:'Packbreaker', icon:icPack,
      fl:['Ten card packs cracked open.','Fifty card packs cracked open.','A hundred packs. The Hall knows this name.','Two hundred fifty packs. The shopkeeper bows.']},
    {f:'dustdevil',   base:'Dust Devil',  icon:icDust,
      fl:['Twenty-five cards turned to hearts.','A hundred cards turned to hearts.','Four hundred cards turned to hearts.','A thousand cards dusted. Nothing but hearts remain.']}
  ];
  _appFams.forEach(function(F){
    for(var t=1;t<=4;t++){
      window.HOH_QUEST_BADGES[F.f+'-'+t]={ name:(t===4?'Mythic '+F.base:F.base+' '+_hohRl[t-1]), rarity:_hohRar[t-1], family:F.f, tier:t, flavor:F.fl[t-1], applied:true, svg:F.icon };
    }
  });
  /* Curator climbs I, II, III, then GRAND CURATOR — every FramedFantasy
     portrait in the Hall, the rarest badge the Shop can give. Brand tier. */
  var _curFl=['Five FramedFantasy portrait cards collected.','Fifteen FramedFantasy portrait cards collected.','Forty FramedFantasy portrait cards collected.','Every FramedFantasy portrait in the Hall, collected. The rarest badge the Shop can give.'];
  for(var _ct2=1;_ct2<=4;_ct2++){
    window.HOH_QUEST_BADGES['curator-'+_ct2]={ name:(_ct2===4?'Grand Curator':'Curator '+_hohRl[_ct2-1]), rarity:(_ct2===4?'brand':_hohRar[_ct2-1]), family:'curator', tier:_ct2, flavor:_curFl[_ct2-1], applied:true, svg:icFrame };
  }
  window.HOH_QUEST_BADGES['first-edition']={ name:'First Edition', rarity:'mythic', flavor:'Pulled one of their own heroes from a card pack.', applied:true, svg:icFirst };
  window.hohInjectBadgeDefs = function(){
    try{
      if(document.getElementById('hoh-badge-defs')) return;
      var holder=document.createElement('div'); holder.style.cssText='position:absolute;width:0;height:0;overflow:hidden;';
      holder.innerHTML='<svg id="hoh-badge-defs" aria-hidden="true" width="0" height="0"><defs>'
        +'<linearGradient id="hohBrz" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e8ad6e"/><stop offset="0.5" stop-color="#c07f37"/><stop offset="1" stop-color="#8f5b1c"/></linearGradient>'
        +'<linearGradient id="hohSlv" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#d4d9e0"/><stop offset="0.5" stop-color="#a6adba"/><stop offset="1" stop-color="#6f7682"/></linearGradient>'
        +'<linearGradient id="hohGld" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ffe9a8"/><stop offset="0.5" stop-color="#e6bd57"/><stop offset="1" stop-color="#b6891f"/></linearGradient>'
        +'<linearGradient id="hohBrand" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ef94ff"/><stop offset="1" stop-color="#b3f5ee"/></linearGradient>'
        +'</defs></svg>';
      (document.body||document.documentElement).appendChild(holder);
    }catch(_){}
  };
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',window.hohInjectBadgeDefs);}else{window.hohInjectBadgeDefs();}
})();
/* R193: trials are a funnel. Clicking a trial row in the detail view opens a
   prompt inviting the visitor to earn that medal. Iron Matron (Quest 1) routes
   to the character quest; Born from Fire (Quest 2) is not open yet. */
window.hohCloseTrialPrompt = function(){ var m=document.getElementById('hoh-trial-prompt'); if(m){ m.remove(); try{document.body.style.overflow='';}catch(_){} } };
/* R200: the search term a badge popup uses to filter the Hall by that badge.
   Family badges collapse to the family word (any tier counts); specials use a
   stable phrase the search matcher recognizes. null = not badge-searchable. */
function hohBadgeSearchTerm(key, b){
  var famTerms={ 'hall-contributor':'hall contributor','lorekeeper':'lorekeeper','patron':'patron','veteran':'veteran','powering-up':'powering up','packbreaker':'packbreaker','curator':'curator','dustdevil':'dust devil' };
  var fam=(b&&b.family)||(''+(key||'')).replace(/-\d+$/,'');
  if(famTerms[fam]) return famTerms[fam];
  var specials={ 'completionist':'completionist','raffle-winner':'raffle winner','merchants-mark':"merchant's mark",'iron-matron':'matron slayer','iron-court':'born from fire','first-edition':'first edition' };
  return specials[key]||null;
}
/* R200: jump from a badge popup straight to every hero who wears it. Closes the
   popup (and the detail modal if open), fills the Hall search with the badge
   term, runs the filter, and scrolls the search into view so the user watches it
   populate and the grid narrow. Works the same on mobile and desktop. */
window.hohFilterByBadge = function(term){
  try{
    if(typeof window.hohCloseTrialPrompt==='function'){ try{ window.hohCloseTrialPrompt(); }catch(_){} }
    if(typeof window.hohCloseModal==='function'){ try{ window.hohCloseModal(); }catch(_){} }
    /* Make sure no modal left the page scroll-locked, or the scroll below stalls. */
    try{ document.body.style.overflow=''; }catch(_){}
    var s=document.getElementById('hoh-search');
    if(s){ s.value=term; try{ s.focus({preventScroll:true}); }catch(_){} try{ s.dispatchEvent(new Event('input',{bubbles:true})); }catch(_){} }
    if(typeof window.hohApplyFilters==='function'){ try{ window.hohApplyFilters(); }catch(_){} }
    var target=document.getElementById('hoh-search')||document.getElementById('hoh-gallery');
    if(target && target.scrollIntoView){ requestAnimationFrame(function(){ setTimeout(function(){ try{ target.scrollIntoView({behavior:'smooth',block:'center'}); }catch(_){} }, 90); }); }
  }catch(_){}
};
window.hohTrialPrompt = function(key){
  try{
    var reg=window.HOH_QUEST_BADGES||{}; var b=reg[key]; if(!b) return;
    var title=b.name, deed=b.flavor, bodyHtml='', actions='', extra='', tierLadderHtml='';
    if(key==='iron-matron'){
      title='Face the Iron Matron';
      bodyHtml='Want the <strong>Matron Slayer</strong> medal on your own hero? Take the quest and face her.';
      actions='<a href="/pages/dnd-character-quest" class="hoh-btn-primary hoh-trial-prompt-go">Enter the quest</a><button type="button" class="hoh-cancel-btn" onclick="hohCloseTrialPrompt()">Not yet</button>';
    } else if(b.family && window.HOH_TIER_FAMILIES && window.HOH_TIER_FAMILIES[b.family]){
      var _fam=b.family, _fdef=window.HOH_TIER_FAMILIES[_fam];
      var _earn={'hall-contributor':'Add heroes to the Hall to climb this badge.','patron':'Own FramedFantasy portraits to climb this badge.','veteran':'Time in the Hall earns this badge.','lorekeeper':'Write a richer backstory to climb this badge.','powering-up':'Raise this hero\'s Hall Level to climb this badge.'};
      bodyHtml=(_earn[_fam]||'Keep going to climb the tiers.');
      /* R209: Patron is the merged FF badge, so its open box carries the FF
         portrait pitch + the waitlist CTA + brand styling (the standalone FF
         Portrait box is retired). The heart medal + tier ladder stay below. */
      if(_fam==='patron'){
        extra=' hoh-ffprompt';
        bodyHtml='A FramedFantasy original portrait, hand crafted from your hero. Climb a tier for every portrait you add.';
      }
      /* R200: show the whole ladder (bronze, silver, gold, mythic) with each
         rung's requirement, and mark the rung THIS hero is on so they can see
         exactly what the next tier takes. */
      var _cidx=0, _metric=null;
      try{ if(currentDetail && typeof hohFamilyMetric==='function' && typeof hohTierIndex==='function'){ _metric=hohFamilyMetric(_fam,currentDetail); _cidx=hohTierIndex(_metric,_fdef.thresholds); } }catch(_){}
      var _rows='';
      /* R207: walk however many tiers this family actually has (Patron now has 5,
         the rest 4) by probing the registry, not a fixed 4. */
      var _unit={'hall-contributor':'heroes added','patron':'FramedFantasy portraits','veteran':'months in the Hall','lorekeeper':'words in their story','powering-up':'Hall Levels'};
      var _unitOne={'hall-contributor':'hero added','patron':'FramedFantasy portrait','veteran':'month in the Hall','lorekeeper':'word in their story','powering-up':'Hall Level'};
      for(var _t=1;_t<=8;_t++){
        var _tb=reg[_fam+'-'+_t]; if(!_tb) continue;
        var _cur=(_cidx===_t), _earned=(_cidx>=_t);
        /* R210: spell out the exact requirement per rung, e.g. "5 FramedFantasy
           portraits", with singular wording for a count of 1. Falls back to the
           badge flavor if a family ever lacks a unit. */
        var _need=(_fdef && _fdef.thresholds && _fdef.thresholds[_t-1]!=null)?_fdef.thresholds[_t-1]:null;
        var _reqTxt=(_need!=null && _unit[_fam])?(_need+' '+(_need===1?(_unitOne[_fam]||_unit[_fam]):_unit[_fam])):_tb.flavor;
        _rows+='<div class="hoh-tier-row'+(_earned?' hoh-tier-earned':'')+(_cur?' hoh-tier-current':'')+'">'
          +'<span class="hoh-tier-medal hoh-rar-'+(_tb.rarity||'standard')+'" data-badge-key="'+esc(_fam+'-'+_t)+'">'+_tb.svg+'</span>'
          +'<span class="hoh-tier-text"><span class="hoh-tier-name">'+esc(_tb.name)+'</span><span class="hoh-tier-req">'+esc(_reqTxt)+'</span></span>'
          +'<span class="hoh-tier-mark">'+(_cur?'Now':(_earned?'&#10003;':''))+'</span>'
        +'</div>';
      }
      var _prog=(_metric!=null && _unit[_fam])?'<p class="hoh-tier-progress">This hero: <strong>'+_metric+'</strong> '+_unit[_fam]+(_cidx>0?'':' &middot; no tier yet')+'.</p>':'';
      tierLadderHtml='<div class="hoh-tier-ladder">'+_rows+'</div>'+_prog;
      var _go=(_fam==='hall-contributor')?'<a href="/pages/dnd-character-quest" class="hoh-btn-primary hoh-trial-prompt-go">Make a hero</a>':'';
      if(_fam==='patron') _go='<a href="https://framedfantasy.com/products/fantasy-character-commission" target="_blank" rel="noopener" class="hoh-btn-primary hoh-trial-prompt-go hoh-ffprompt-go">Join the waitlist</a>';
      /* R214: Powering Up is a leveling badge, so its open box gets a button that
         jumps straight to the profile tab where leveling happens. Only shown when
         the viewer is signed in (has a profile of their own to level). */
      if(_fam==='powering-up' && window.hohIsHallSignedIn && window.hohIsHallSignedIn()){
        _go='<button type="button" class="hoh-btn-primary hoh-trial-prompt-go" onclick="hohCloseTrialPrompt();try{if(window.hohCloseModal)hohCloseModal();}catch(_){}try{if(window.hohOpenYourHallProfile)hohOpenYourHallProfile();}catch(_){}try{window.scrollTo({top:0,behavior:&quot;smooth&quot;});}catch(_){}">Level up your heroes</button>';
      }
      actions=_go+'<button type="button" class="hoh-cancel-btn" onclick="hohCloseTrialPrompt()">'+(_fam==='patron'?'Maybe later':'Close')+'</button>';
    } else if(key==='completionist'){
      bodyHtml='Fill in all six NPC details and generate the NPC card on a hero, and this badge appears on them automatically.';
      actions='<button type="button" class="hoh-cancel-btn" onclick="hohCloseTrialPrompt()">Close</button>';
    } else if(key==='merchants-mark'){
      bodyHtml='A mythic badge from the Legendary Shop. The hero wearing it earns double hearts in Explore the Hall.';
      actions='<button type="button" class="hoh-cancel-btn" onclick="hohCloseTrialPrompt()">Close</button>';
    } else if(key==='raffle-winner'){
      actions='<button type="button" class="hoh-btn-primary hoh-trial-prompt-go" onclick="hohCloseTrialPrompt();if(typeof window.hohOpenRaffle===\'function\')window.hohOpenRaffle();">How the raffle works</button><button type="button" class="hoh-cancel-btn" onclick="hohCloseTrialPrompt()">Close</button>';
    } else {
      actions='<button type="button" class="hoh-cancel-btn" onclick="hohCloseTrialPrompt()">Close</button>';
    }
    /* R200: every badge popup gets a one-tap "show me everyone with this badge",
       which fills the Hall search with the badge term and runs the filter. */
    var _bterm=hohBadgeSearchTerm(key,b);
    if(_bterm){ actions='<button type="button" class="hoh-badge-filter-btn" onclick="hohFilterByBadge(\''+_bterm.replace(/'/g,"\\'")+'\')">See all heroes with this badge</button>'+actions; }
    hohCloseTrialPrompt();
    var rar=(b.rarity||'standard');
    var m=document.createElement('div'); m.id='hoh-trial-prompt'; m.className='hoh-modal'; m.style.display='flex'; m.style.zIndex='100071'; /* R318: 100070 collided with the pack reveal layer */
    m.addEventListener('click', function(e){ if(e.target===m) hohCloseTrialPrompt(); });
    m.innerHTML='<div class="hoh-modal-content hoh-trial-prompt-content'+extra+'" role="dialog" aria-label="'+title+'">'
      +'<button type="button" class="hoh-close-btn" onclick="hohCloseTrialPrompt()" aria-label="Close">&#10005;</button>'
      +'<div class="hoh-trial-prompt-medal hoh-rar-'+rar+'" data-badge-key="'+esc(key)+'">'+b.svg+'</div>'
      +'<h3 class="hoh-trial-prompt-title">'+title+'</h3>'
      +'<p class="hoh-trial-prompt-deed">'+deed+'</p>'
      +'<p class="hoh-trial-prompt-body">'+bodyHtml+'</p>'
      +tierLadderHtml
      +'<div class="hoh-trial-prompt-actions">'+actions+'</div>'
      +'</div>';
    document.body.appendChild(m);
    try{document.body.style.overflow='hidden';}catch(_){}
  }catch(e){}
};
/* R176: badges split into EARNED vs DISPLAYED.
   - quest_meta.earned : the entitlement. Set by quest completion, the email
     match backfill, or a god grant. Permanent; the owner cannot remove it.
   - quest_meta.hidden : earned keys the owner has UNEQUIPPED. Owner-controlled.
   Displayed = earned minus hidden. Legacy rows are honored: an older
   quest_meta.badges array counts as earned, and a bare quest_meta.source still
   yields the Iron Matron mark, so nothing needs migrating to keep showing.

   hohGetHeroEarnedBadges -> everything the hero is entitled to (for the owner's
   equip UI and god grant UI). hohGetHeroBadges -> what actually shows on the
   card and to visitors (earned minus hidden). Unknown keys are dropped. */
/* R194: badges are now ACCOUNT-WIDE. What a hero owns is the union of three
   things keyed by the account (auth_email): every quest trial any of that
   account's heroes earned, the Hall Contributor tier derived from their approved
   hero count, and any badge an admin granted by hand. The FF Portrait badge is
   the one exception: it is per-hero, derived live from is_ff_portrait, and is
   handled in the display getter, not the entitlement. Maps are built once per
   data load (hohBuildAccountBadgeMaps) so per-card lookups stay O(1). */
var _hohAcctTrials = {};   /* key -> [trial keys earned by any of the account's heroes] */
var _hohAcctCount  = {};   /* key -> approved hero count (authoritative via RPC) */
var _hohAcctGrants = {};   /* key -> [badge keys an admin granted, forever] */
var _hohAcctFFCount = {};   /* R198: key -> # of is_ff_portrait heroes (Patron metric) */
var _hohAcctCampaigns = {}; /* R198: key -> # of distinct campaigns (Adventurer metric) */
var _hohAcctOldest = {};    /* R198: key -> earliest hero created_at in ms (Veteran metric) */
var _hohAcctMapsReady = false;
function hohAccountKey(c){ return ((c && (c.auth_email || c.email)) || '').toString().trim().toLowerCase(); }
window.hohAccountKey = hohAccountKey;
window.hohAccountGrantsFor = function(key){ return (key && _hohAcctGrants[key]) ? _hohAcctGrants[key].slice() : []; };
window.hohSetAccountGrants = function(key, list){ if(key) _hohAcctGrants[key] = Array.isArray(list) ? list.slice() : []; };
/* Contributor tiers stack: 5+ = I, 10+ = II, 20+ = III. */
function hohContribTiers(n){ var t=[]; if(n>=5)t.push('hall-contributor-1'); if(n>=10)t.push('hall-contributor-2'); if(n>=20)t.push('hall-contributor-3'); return t; }
/* R198: tiered badge families. Each climbs I, II, III, Mythic by a metric. Tier
   keys are real registry entries (family-1..4); -4 is the named Mythic tier and
   carries the Explore buff. Account-scope families ride every hero on the account;
   hero-scope families are intrinsic to the one hero that earned them. */
var HOH_TIER_FAMILIES = {
  'hall-contributor': { scope:'account', thresholds:[5,10,20,30] },
  'patron':           { scope:'account', thresholds:[1,5,10,25,50] },
  'veteran':          { scope:'account', thresholds:[1,6,12,24] },
  'lorekeeper':       { scope:'hero',    thresholds:[150,350,600,1000] },
  'powering-up':      { scope:'hero',    thresholds:[10,30,50,100] },
  /* R241: scope 'applied' = earned by the account (Shop counters), worn
     by ONE chosen hero via the apply picker. Never derived here — the
     wearer's quest_meta.earned is the single source. Thresholds are
     documentation + ladder display; the Shop computes progress from its
     server counters. Curator's top tier is dynamic (every FF portrait). */
  'packbreaker':      { scope:'applied', thresholds:[10,50,100,250] },
  'curator':          { scope:'applied', thresholds:[5,15,40,9999] },
  'dustdevil':        { scope:'applied', thresholds:[25,100,400,1000] }
};
window.HOH_TIER_FAMILIES = HOH_TIER_FAMILIES;
function hohTierIndex(metric, th){ var idx=0; for(var i=0;i<th.length;i++){ if(metric>=th[i]) idx=i+1; } return idx; }
function hohWordCount(s){ if(!s) return 0; var t=(''+s).trim(); return t ? t.split(/\s+/).length : 0; }
function hohAcctAgeMonths(key){ var ms=_hohAcctOldest[key]; return ms ? Math.floor((Date.now()-ms)/(1000*60*60*24*30.4)) : 0; }
function hohFamilyMetric(family, c){
  var key=hohAccountKey(c);
  switch(family){
    case 'hall-contributor': return _hohAcctCount[key]||0;
    case 'patron':           return _hohAcctFFCount[key]||0;
    case 'veteran':          return hohAcctAgeMonths(key);
    case 'lorekeeper':       return hohWordCount(c&&c.story);
    /* R247: HALL level ONLY (the xp leveling system in the profile).
       NEVER the level the submitter typed (c.level = "my character is
       level 20 in my campaign") — that is display-only and must not
       mint Powering Up tiers. hohCharLevel loads with hoh-your-hall.js;
       until it exists the metric is simply 0, never the typed level. */
    case 'powering-up':      return (typeof window.hohCharLevel==='function')?(window.hohCharLevel(c)||0):0;
    default: return 0;
  }
}
/* Highest tier key the hero/account currently qualifies for in a family, or null. */
function hohFamilyTierKey(family, c){
  var f=HOH_TIER_FAMILIES[family]; if(!f) return null;
  var idx=hohTierIndex(hohFamilyMetric(family,c), f.thresholds);
  return idx>0 ? family+'-'+idx : null;
}
window.hohFamilyTierKey = hohFamilyTierKey;
window.hohBuildAccountBadgeMaps = async function(){
  try{
    var all = (typeof window.hohGetAllCharactersFull === 'function') ? window.hohGetAllCharactersFull() : [];
    var trials = {}, cnt = {}, ffc = {}, campSets = {}, oldest = {};
    for(var i=0;i<all.length;i++){
      var c = all[i]; if(!c) continue; var k = hohAccountKey(c); if(!k) continue;
      cnt[k] = (cnt[k]||0) + 1; /* fallback count from loaded visible heroes */
      if(c.is_ff_portrait) ffc[k] = (ffc[k]||0) + 1; /* R198: Patron metric */
      var _camp = (c.campaign||'').toString().trim().toLowerCase();
      if(_camp){ if(!campSets[k]) campSets[k] = {}; campSets[k][_camp] = 1; } /* R198: Adventurer metric */
      var _ct = c.created_at ? Date.parse(c.created_at) : 0;
      if(_ct && (!oldest[k] || _ct < oldest[k])) oldest[k] = _ct; /* R198: Veteran metric */
      var qm = c.quest_meta;
      if(qm){
        var e = Array.isArray(qm.earned) ? qm.earned : (Array.isArray(qm.badges) ? qm.badges : (qm.source ? [qm.source] : []));
        if(e && e.length){ if(!trials[k]) trials[k]={}; for(var j=0;j<e.length;j++){ if(e[j]!=='raffle-winner') trials[k][e[j]]=1; } } /* R196: raffle-winner is per-hero, never unioned account-wide */
      }
    }
    var tout = {}; Object.keys(trials).forEach(function(k){ tout[k]=Object.keys(trials[k]); });
    var campCnt = {}; Object.keys(campSets).forEach(function(k){ campCnt[k] = Object.keys(campSets[k]).length; });
    _hohAcctTrials = tout; _hohAcctCount = cnt; _hohAcctFFCount = ffc; _hohAcctCampaigns = campCnt; _hohAcctOldest = oldest;
    /* Authoritative approved counts (includes hidden heroes) when the SQL is live. */
    try{
      var rc = await supabase.rpc('get_contributor_counts');
      if(rc && !rc.error && Array.isArray(rc.data)){ rc.data.forEach(function(r){ if(r && r.auth_email != null) _hohAcctCount[(''+r.auth_email).toLowerCase()] = r.n; }); }
    }catch(_){}
    /* Manual admin grants, forever, when the SQL is live. */
    try{
      var rg = await supabase.from('account_badges').select('auth_email,badges');
      var g = {}; if(rg && !rg.error && Array.isArray(rg.data)){ rg.data.forEach(function(r){ if(r && r.auth_email != null) g[(''+r.auth_email).toLowerCase()] = Array.isArray(r.badges) ? r.badges : []; }); }
      _hohAcctGrants = g;
    }catch(_){ _hohAcctGrants = {}; }
    _hohAcctMapsReady = true;
  }catch(_){ _hohAcctMapsReady = true; }
};
/* Within-rank tiebreak order (rarity rank is the PRIMARY sort below; this only
   breaks ties inside one rank). R200: every tiered family is listed too, so the
   order is fully deterministic instead of leaving family badges in arbitrary
   input order. Grouped by rank for readability; the FF-tinted Mythic Patron sits
   at the end of the mythic group so it reads right beside the brand cluster. */
var HOH_BADGE_ORDER = [
  'raffle-winner','hall-contributor-4','patron-5','patron-4','patron-3','patron-2','patron-1','lorekeeper-4','veteran-4','powering-up-4',
  'merchants-mark',
  'hall-contributor-3','completionist','iron-court','iron-matron','lorekeeper-3','veteran-3','powering-up-3',
  'hall-contributor-2','lorekeeper-2','veteran-2','powering-up-2',
  'hall-contributor-1','lorekeeper-1','veteran-1','powering-up-1'
];
/* R198/R202: badges sort by rarity rank FIRST so the rarest always make the
   card's visible cap. Exactly four tiers now: mythic and brand share the TOP rank
   (0) — "special" badges are mythic — then gold, then silver, bronze last.
   Collectibles rank last so earned badges win the limited slots. Tiebreak within
   a rank by HOH_BADGE_ORDER. */
var HOH_RARITY_RANK = { mythic:0, brand:0, gold:2, standard:2, silver:3, bronze:4 };
function hohOrderBadges(list){
  var reg = window.HOH_QUEST_BADGES || {};
  return list.slice().sort(function(a,b){
    var ba=reg[a]||{}, bb=reg[b]||{};
    var ra = ba.collectible ? 6 : (HOH_RARITY_RANK[ba.rarity]!=null?HOH_RARITY_RANK[ba.rarity]:2);
    var rb = bb.collectible ? 6 : (HOH_RARITY_RANK[bb.rarity]!=null?HOH_RARITY_RANK[bb.rarity]:2);
    if(ra!==rb) return ra-rb;
    var ia=HOH_BADGE_ORDER.indexOf(a), ib=HOH_BADGE_ORDER.indexOf(b);
    if(ia===-1)ia=99; if(ib===-1)ib=99; return ia-ib;
  });
}
window.hohOrderBadges = hohOrderBadges;
/* R196: Hall Contributor is ONE badge that upgrades by tier. Collapse any owned
   tiers down to the single highest, so I, II, III never show as separate badges. */
function hohCollapseContrib(list){
  var out=list.slice();
  Object.keys(HOH_TIER_FAMILIES).forEach(function(fam){
    var hi=null;
    for(var t=4;t>=1;t--){ if(out.indexOf(fam+'-'+t)!==-1){ hi=fam+'-'+t; break; } }
    if(hi) out=out.filter(function(k){ return k.indexOf(fam+'-')!==0 || k===hi; });
  });
  return out;
}
window.hohCollapseContrib = hohCollapseContrib;
window.hohCollapseTiers = hohCollapseContrib;
/* Entitlement = account-wide trials + manual grants + derived contributor tiers.
   Excludes FF (per-hero, added at display time). Falls back to this hero's own
   quest_meta when the maps are not built yet or the hero is off-list (hidden). */
window.hohGetHeroEarnedBadges = function(c){
  try{
    var reg = window.HOH_QUEST_BADGES || {};
    var set = {};
    var key = hohAccountKey(c);
    if(key && _hohAcctMapsReady){
      /* R196: trials are now PER-HERO too. A hero shows only the trials in its own
         quest_meta.earned (read below), so the account-wide union is no longer
         applied and the god toggle always matches what the hero displays. account_badges
         (legacy) is not applied either. Only Hall Contributor stays account-wide,
         derived from the account's approved submission count. */
      Object.keys(HOH_TIER_FAMILIES).forEach(function(fam){
        if(HOH_TIER_FAMILIES[fam].scope!=='account') return;
        var fk=hohFamilyTierKey(fam, c); if(fk) set[fk]=1;
      });
    }
    var qm = c && c.quest_meta;
    if(qm){
      var own = Array.isArray(qm.earned) ? qm.earned : (Array.isArray(qm.badges) ? qm.badges : (qm.source ? [qm.source] : []));
      if(own) own.forEach(function(k){ set[k]=1; });
    }
    /* R196: ff-portrait, merchants-mark, completionist are per-hero (is_ff_portrait,
       quest_meta.merchantsMark, hohIsComplete). They must NEVER be account-wide, so
       even a stale account_badges grant of one is filtered out here. */
    return Object.keys(set).filter(function(k){ return !!reg[k] && k!=='ff-portrait' && k!=='merchants-mark' && k!=='completionist'; });
  }catch(_){ return []; }
};
/* What actually shows on a hero: entitlement minus this hero's hidden set, plus
   the FF badge when this specific hero is an FF portrait (always shown so it is
   visible in the main hall; not hideable). Ordered for display. */
/* R196: a hero is a Completionist when all six NPC detail fields are filled AND
   an NPC card (the 5e stat block) has been generated. Pure read of the row, so
   it is automatic and retroactive with no SQL. */
function hohIsComplete(c){
  if(!c) return false;
  var f=['npc_current_goal','npc_hidden_weakness','npc_habit','npc_catchphrase','npc_secret','npc_enemy'];
  for(var i=0;i<f.length;i++){ var v=c[f[i]]; if(!v || !(''+v).trim()) return false; }
  return !!c.npc_card;
}
window.hohIsComplete = hohIsComplete;
/* R267: completion-ticket gates, one for each rewardable section. NPC-for-DMs
   counts as done when all six flavour fields carry real content. The stat block
   counts as done when it reads as a runnable creature: a creature type, at least
   one action, and at least one customized number (an ability off the default 10,
   or a non-default AC/HP). Each grants a one-time ticket, latched in quest_meta
   so clearing and re-filling can never farm it. */
function _hohNpcFieldsComplete(v){
  if(!v) return false;
  var f=['npc_current_goal','npc_hidden_weakness','npc_habit','npc_catchphrase','npc_secret','npc_enemy'];
  for(var i=0;i<f.length;i++){ var x=v[f[i]]; if(!x || (''+x).trim().length < 2) return false; }
  return true;
}
function _hohStatsComplete(stats){
  try {
    if(!stats || !window.HOH_NPC_STATS || typeof window.HOH_NPC_STATS.normalize!=='function') return false;
    var s = window.HOH_NPC_STATS.normalize(stats);
    var typeSet  = !!(s.type && (''+s.type).trim());
    var hasAction = !!(s.actions && s.actions.length);
    var ab = s.abilities || {};
    var abSet = ['str','dex','con','int','wis','cha'].some(function(k){ return ab[k]!=null && ab[k]!==10; });
    var acHp  = (s.ac && s.ac.value!==12) || (s.hp && s.hp.average!==20);
    return typeSet && hasAction && (abSet || acHp);
  } catch(_){ return false; }
}
window._hohNpcFieldsComplete = _hohNpcFieldsComplete;
window._hohStatsComplete = _hohStatsComplete;
/* The reward uses the same animated rainbow ticket silhouette as Win a Free
   Portrait. Keep this as HTML (rather than textContent) so live completion
   repaints never erase the icon. */
function _hohTicketRewardHtml(earned){
  return '<span class="hoh-npc-reward-count">'+(earned?'Earned':'x1')+'</span><span class="hoh-tk-icon" aria-hidden="true"></span>';
}
/* R267: live completion indicators in the edit form. Shows a check when a
   section is complete and swaps the x1 chip to "Earned" once the character
   already banked that ticket (quest_meta latch), so a creator always knows
   where the reward stands. */
function _hohMarkSet(doneId, rewardId, complete, alreadyGranted){
  var done = document.getElementById(doneId), reward = document.getElementById(rewardId);
  if(done) done.style.display = (complete || alreadyGranted) ? '' : 'none';
  if(reward){
    reward.innerHTML = _hohTicketRewardHtml(alreadyGranted);
    reward.setAttribute('aria-label', alreadyGranted ? 'One raffle ticket earned' : 'Earn one raffle ticket');
    reward.classList.toggle('hoh-npc-reward-earned', !!alreadyGranted);
  }
}
window.hohUpdateCompletionMarks = function(){
  try {
    var pairs = [['npc_current_goal','hoh-f-npc-goal'],['npc_hidden_weakness','hoh-f-npc-weakness'],['npc_habit','hoh-f-npc-habit'],['npc_catchphrase','hoh-f-npc-catchphrase'],['npc_secret','hoh-f-npc-secret'],['npc_enemy','hoh-f-npc-enemy']];
    var npcVals = {};
    pairs.forEach(function(p){ var el = document.getElementById(p[1]); npcVals[p[0]] = el ? el.value : ''; });
    var editC = (window.hohEditingCharacterId && typeof allCharacters!=='undefined' && allCharacters)
      ? allCharacters.find(function(c){ return c && String(c.id)===String(window.hohEditingCharacterId); }) : null;
    var qm = (editC && editC.quest_meta) || {};
    _hohMarkSet('hoh-npc-done','hoh-npc-reward', _hohNpcFieldsComplete(npcVals), !!qm.npcTicketGranted);
    var sb = null; try{ if(typeof _hohNpcStatsReader==='function') sb = _hohNpcStatsReader(); }catch(_){}
    _hohMarkSet('hoh-stats-done','hoh-stats-reward', _hohStatsComplete(sb), !!qm.statsTicketGranted);
  } catch(_){}
};
/* R196: Merchant's Mark held inventory. The shop wallet is client-side, so the
   unapplied count lives in localStorage (max 1). The APPLIED badge lives on the
   hero (quest_meta.merchantsMark) server-side so it persists and powers the buff. */
window.hohMerchHeld = function(){ try{ return parseInt(localStorage.getItem('hoh-merchants-mark-held')||'0',10)||0; }catch(_){ return 0; } };
window.hohSetMerchHeld = function(n){ try{ localStorage.setItem('hoh-merchants-mark-held', String(Math.max(0, n|0))); }catch(_){} };
/* R197: everything this hero COULD display, before the owner's per-card hidden
   choices. Account-derived contributor + per-hero earned (trials, raffle) + the
   per-hero status badges (FF, Completionist, Merchant's Mark). This is the full
   set the owner's equip row offers, so they can show or hide ANY badge per hero. */
window.hohGetHeroDisplayableBadges = function(c){
  try{
    var reg = window.HOH_QUEST_BADGES || {};
    var set = {};
    window.hohGetHeroEarnedBadges(c).forEach(function(k){ set[k]=1; });
    if(c){
      if(reg['completionist'] && hohIsComplete(c)) set['completionist']=1;
      if(c.quest_meta && c.quest_meta.merchantsMark && reg['merchants-mark']) set['merchants-mark']=1;
      Object.keys(HOH_TIER_FAMILIES).forEach(function(fam){
        if(HOH_TIER_FAMILIES[fam].scope!=='hero') return;
        var fk=hohFamilyTierKey(fam, c); if(fk) set[fk]=1;
      });
    }
    return hohOrderBadges(hohCollapseContrib(Object.keys(set).filter(function(k){ return !!reg[k]; })));
  }catch(_){ return []; }
};
/* What actually shows publicly = displayable minus the owner's hidden set. EVERY
   badge (including FF / Completionist / Merchant's Mark) now respects hidden, so
   the owner has full per-card control over what is displayed. */
window.hohGetHeroBadges = function(c){
  try{
    var disp = window.hohGetHeroDisplayableBadges(c);
    var qm = c && c.quest_meta;
    var hidden = (qm && Array.isArray(qm.hidden)) ? qm.hidden : [];
    return hidden.length ? disp.filter(function(k){ return hidden.indexOf(k) === -1; }) : disp;
  }catch(_){ return []; }
};
/* R200: badge search. Maps a search term to the badge keys that satisfy it, so
   the Hall filter can show every hero who publicly wears that badge. Matches the
   whole query (or a >=4 char prefix as the user types) so it never hijacks a
   normal name/story search on a short word. Tier families match any tier (I..
   Mythic). Returns { keys:[...], fam, term } or null. */
window.HOH_BADGE_SEARCH_DEFS = [
  {fam:'lorekeeper',       terms:['lorekeeper']},
  {fam:'patron',           terms:['patron','framedfantasy portrait','framed fantasy portrait','ff portrait']},
  {fam:'veteran',          terms:['veteran']},
  {fam:'powering-up',      terms:['powering up','rising star','hall level','high level']},
  {fam:'hall-contributor', terms:['hall contributor','hall-contributor','contributor']},
  {keys:['completionist'], terms:['completionist']},
  {keys:['raffle-winner'], terms:['raffle winner','raffle-winner','raffle']},
  {keys:['merchants-mark'],terms:["merchant's mark",'merchants mark','merchant']},
  {keys:['iron-matron'],   terms:['matron slayer','matron']},
  {keys:['iron-court'],    terms:['born from fire']},
  {fam:'packbreaker',      terms:['packbreaker']},
  {fam:'curator',          terms:['curator','grand curator']},
  {fam:'dustdevil',        terms:['dust devil','dustdevil']},
  {keys:['first-edition'], terms:['first edition']}
];
window.hohSearchBadgeMatch = function(query){
  try{
    var q=(query||'').toString().trim().toLowerCase().replace(/[‘’ʼ`]/g,"'");
    if(q.length<3) return null;
    var defs=window.HOH_BADGE_SEARCH_DEFS;
    for(var i=0;i<defs.length;i++){
      var d=defs[i];
      for(var j=0;j<d.terms.length;j++){
        var t=d.terms[j];
        if(q===t || (q.length>=4 && t.indexOf(q)===0)){
          var keys=d.keys;
          if(d.fam){ keys=[]; for(var k=1;k<=4;k++) keys.push(d.fam+'-'+k); }
          return { keys:keys, fam:(d.fam||null), term:t };
        }
      }
    }
    return null;
  }catch(_){ return null; }
};
/* R196: place a held Merchant's Mark on one of your own heroes. Owner-gated,
   writes quest_meta.merchantsMark via the same authorized update the owner equip
   uses, then decrements the held count and reopens the detail. */
window.hohEquipMerchantsMark = async function(id){
  if(!id) return;
  var all=(typeof window.hohGetAllCharactersFull==='function')?window.hohGetAllCharactersFull():[];
  var c=all.find(function(x){return x&&String(x.id)===String(id);});
  if(!c && Array.isArray(window.__hohHidden)) c=window.__hohHidden.find(function(x){return x&&String(x.id)===String(id);});
  if(!c) return;
  var isOwner=(typeof window.hohIsCharacterOwner==='function')&&window.hohIsCharacterOwner(c);
  if(!isOwner){ try{alert('Only the owner can place this badge.');}catch(_){} return; }
  if(window.hohMerchHeld()<1){ try{alert('You have no Merchant\'s Mark to place. Buy one from the Legendary Shop.');}catch(_){} return; }
  if(c.quest_meta && c.quest_meta.merchantsMark){ try{alert('This hero already wears the Merchant\'s Mark.');}catch(_){} return; }
  var qm={}; try{qm=Object.assign({},c.quest_meta||{});}catch(_){}
  qm.merchantsMark=true;
  var sb=window.hohSupabaseClient; if(!sb){ try{alert('Database client unavailable.');}catch(_){} return; }
  try{
    var res=await sb.from('characters').update({quest_meta:qm}).eq('id',id).select('id');
    if(res.error){ try{alert('Could not place badge: '+(res.error.message||'error'));}catch(_){} return; }
    c.quest_meta=qm; window.hohSetMerchHeld(window.hohMerchHeld()-1);
    /* R590 (Jan): names the PLACE, not a currency. The bonus only fires
       on the Explore path (mark_heart_explore is called from
       hohCallHeartRpc only when bypassDailyCap is set from
       fromFreshFaces). Saying "double Explore hearts" let a buyer
       reasonably expect it on the main gallery, where it pays nothing. */
    try{ if(typeof window.hohShowHeartToast==='function') window.hohShowHeartToast('Merchant\'s Mark placed', (c.name||'Your hero')+' now wears it. Every heart they are given in Explore the Hall counts twice.'); }catch(_){}
    try{ if(typeof window.hohOpenDetail==='function') window.hohOpenDetail(id); }catch(_){}
  }catch(e){ try{alert('Could not place badge.');}catch(_){} }
};
/* R262: place the Merchant's Mark on a hero for the badge PICKER (auto-prompt on
   purchase). Same server write as hohEquipMerchantsMark — quest_meta.merchantsMark
   grants the double-Explore-hearts buff — but it RESOLVES to { ok, hero } and does
   NOT fire its own toast/reopen, because the picker runs its own claim ceremony.
   Owner-gated; decrements the held count on success. */
window.hohApplyMerchToHero = function(heroId){
  return (async function(){
    try {
      var all=(typeof window.hohGetAllCharactersFull==='function')?(window.hohGetAllCharactersFull()||[]):[];
      var c=all.find(function(x){return x&&String(x.id)===String(heroId);});
      if(!c && Array.isArray(window.__hohHidden)) c=window.__hohHidden.find(function(x){return x&&String(x.id)===String(heroId);});
      if(!c) return { ok:false, msg:'Hero not found.' };
      var isOwner=(typeof window.hohIsCharacterOwner==='function') ? window.hohIsCharacterOwner(c) : true;
      if(!isOwner) return { ok:false, msg:'Only the owner can place this.' };
      if(c.quest_meta && c.quest_meta.merchantsMark) return { ok:false, msg:'This hero already wears the Merchant\'s Mark.' };
      /* R271: never write the buff without a bought mark in hand. The free-grant
         audit found this writer was missing the held gate its sibling
         hohEquipMerchantsMark has, so the mark could be placed for free by a
         direct call. This is the durable guard. */
      if(typeof window.hohMerchHeld === 'function' && window.hohMerchHeld() < 1){
        return { ok:false, msg:'Buy a Merchant\'s Mark from the Legendary Shop first.' };
      }
      var qm={}; try{ qm=Object.assign({},c.quest_meta||{}); }catch(_){}
      qm.merchantsMark=true;
      var sb=window.hohSupabaseClient; if(!sb) return { ok:false, msg:'Database unavailable.' };
      var res=await sb.from('characters').update({quest_meta:qm}).eq('id',heroId).select('id');
      if(res.error) return { ok:false, msg:(res.error.message||'Could not place.') };
      c.quest_meta=qm;
      try{ window.hohSetMerchHeld(Math.max(0, window.hohMerchHeld()-1)); }catch(_){}
      return { ok:true, hero:c };
    } catch(e){ return { ok:false, msg:'Could not place.' }; }
  })();
};
/* ==================== R241: the badge APPLY system ====================
   Applied badges (registry entries flagged applied:true) are earned by
   the ACCOUNT but worn by ONE hero. The wearer's quest_meta.earned is
   the single source of truth — the same array trials use — so the badge
   renders on cards, detail views and every device with zero extra
   plumbing, respects quest_meta.hidden, and god/owner tooling sees it.
   One wearer per family, enforced at apply time. Any feature (Shop
   today, Explore tomorrow) calls hohBadgeApplyPicker(key, opts). */
window.hohBadgeFamilyOf = function(key){
  var reg=window.HOH_QUEST_BADGES||{}; var b=reg[key];
  return (b&&b.family)||String(key||'');
};
window.hohOwnHeroes = function(){
  try{
    var all=(typeof window.hohGetAllCharactersFull==='function')?(window.hohGetAllCharactersFull()||[]):[];
    var seen={};
    return all.filter(function(c){
      if(!c || !(typeof window.hohIsCharacterOwner==='function' && window.hohIsCharacterOwner(c))) return false;
      var k=String(c.id);
      if(seen[k]) return false;
      seen[k]=1;
      return true;
    });
  }catch(_){ return []; }
};
/* earned as an array, honoring the legacy quest_meta shapes the getters honor */
function hohEarnedArr(qm){
  if(!qm) return [];
  if(Array.isArray(qm.earned)) return qm.earned.slice();
  if(Array.isArray(qm.badges)) return qm.badges.slice();
  return qm.source ? [qm.source] : [];
}
/* Who on this account currently wears any tier of a family (or a bare key). */
window.hohBadgeWearer = function(family){
  var own=window.hohOwnHeroes();
  for(var i=0;i<own.length;i++){
    var e=hohEarnedArr(own[i].quest_meta);
    for(var j=0;j<e.length;j++){
      if(e[j]===family || String(e[j]).indexOf(family+'-')===0) return { hero:own[i], key:e[j] };
    }
  }
  return null;
};
/* Write the badge onto one hero and strip the family from every other
   hero of the account (one wearer). Same authorized quest_meta update
   the Merchant's Mark placement uses. Patches the shared caches so the
   whole Hall renders it immediately. */
window.hohApplyAccountBadge = async function(key, heroId){
  var sb=window.hohSupabaseClient;
  if(!sb) return { ok:false, msg:'Database client unavailable.' };
  var reg=window.HOH_QUEST_BADGES||{};
  if(!reg[key]) return { ok:false, msg:'Unknown badge.' };
  var fam=window.hohBadgeFamilyOf(key);
  var own=window.hohOwnHeroes();
  var target=null;
  for(var i=0;i<own.length;i++){ if(String(own[i].id)===String(heroId)) target=own[i]; }
  if(!target) return { ok:false, msg:'That hero is not yours.' };
  function stripFam(list){ return list.filter(function(k){ return k!==fam && String(k).indexOf(fam+'-')!==0; }); }
  try{
    /* strip other wearers first so the account never shows two */
    for(var s=0;s<own.length;s++){
      var c=own[s]; if(String(c.id)===String(heroId)) continue;
      var e=hohEarnedArr(c.quest_meta);
      var kept=stripFam(e);
      if(kept.length!==e.length){
        var qm0={}; try{ qm0=Object.assign({},c.quest_meta||{}); }catch(_){}
        qm0.earned=kept;
        var r0=await sb.from('characters').update({quest_meta:qm0}).eq('id',c.id).select('id');
        if(!r0.error) c.quest_meta=qm0;
      }
    }
    var qm={}; try{ qm=Object.assign({},target.quest_meta||{}); }catch(_){}
    var earned=stripFam(hohEarnedArr(qm));
    earned.push(key);
    qm.earned=earned;
    var res=await sb.from('characters').update({quest_meta:qm}).eq('id',heroId).select('id');
    if(res.error) return { ok:false, msg:res.error.message||'Could not save the badge.' };
    target.quest_meta=qm;
    try{ if(typeof window.hohBuildAccountBadgeMaps==='function') window.hohBuildAccountBadgeMaps(); }catch(_){}
    return { ok:true, hero:target };
  }catch(e){ return { ok:false, msg:'Could not save the badge.' }; }
};
/* The picker: a menu of the account's heroes. One hero: skips the menu
   and plays the ceremony directly on that hero. Dismissing (backdrop,
   Esc, Later) leaves the badge unapplied so callers may re-prompt. */
window.hohBadgeApplyPicker = function(key, opts){
  opts=opts||{};
  var reg=window.HOH_QUEST_BADGES||{}, b=reg[key];
  if(!b) return false;
  /* R271: the Merchant's Mark must be BOUGHT. The picker can only place a mark
     the account actually holds (bought for 1000 hearts in the Legendary Shop),
     so a stale opener or a direct call can never place it for free. */
  if(key === 'merchants-mark' && typeof window.hohMerchHeld === 'function' && window.hohMerchHeld() < 1) return false;
  if(document.getElementById('hoh-badge-pick')) return false;
  var own=window.hohOwnHeroes();
  if(!own.length) return false;
  var reduced=false;
  try{ reduced=!!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(_){}
  var single=(own.length===1);
  var rar=b.rarity||'standard';
  var m=document.createElement('div');
  m.id='hoh-badge-pick';
  /* the dim that cannot be lost: inline, stylesheet-proof */
  m.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;z-index:100082;display:flex;align-items:center;justify-content:center;background:rgba(6,5,10,0.9);padding:18px;';
  try{ m.style.setProperty('-webkit-backdrop-filter','blur(6px)'); m.style.setProperty('backdrop-filter','blur(6px)'); }catch(_){}
  var tiles=own.map(function(c, i){
    var img=c.image_thumb_url||c.image_url||'';
    return '<button type="button" class="ffbp-tile" data-id="'+esc(String(c.id))+'" style="--d:'+Math.min(i*22,420)+'ms">' +
      (img?'<img src="'+esc(img)+'" alt="" loading="lazy" decoding="async" draggable="false">':'') +
      '<span>'+esc(c.name||'Hero')+'</span></button>';
  }).join('');
  m.innerHTML=
    '<div class="ffbp-box" role="dialog" aria-modal="true" aria-label="'+esc(b.name)+'">' +
      '<div class="ffbp-medal ffbp-r-'+esc(rar)+'">'+b.svg+'</div>' +
      '<div class="ffbp-name">'+esc(b.name)+'</div>' +
      '<div class="ffbp-flavor">'+esc(b.flavor||'')+'</div>' +
      '<div class="ffbp-title" id="ffbp-title">'+(single?'It goes to your hero':'Choose who wears it')+'</div>' +
      '<div class="ffbp-grid'+(single?' ffbp-solo':'')+'">'+tiles+'</div>' +
      '<div class="ffbp-later"><button type="button" class="ffbp-later-btn">'+(single?'Not now':'Later')+'</button></div>' +
    '</div>';
  document.body.appendChild(m);
  /* clean fade in (inline-driven, stylesheet-proof), fade out on close */
  m.style.opacity='0';
  m.style.transition='opacity .28s ease';
  requestAnimationFrame(function(){ m.style.opacity='1'; });
  var prevOverflow=document.body.style.overflow;
  document.body.style.overflow='hidden';
  var busy=false, applied=false, closed=false;
  function closePick(){
    if(closed) return; closed=true;
    try{ m.style.opacity='0'; }catch(_){}
    setTimeout(function(){ try{ m.remove(); }catch(_){} }, 240);
    document.body.style.overflow=prevOverflow||'';
    document.removeEventListener('keydown', onKey);
    if(!applied && typeof opts.onDismiss==='function'){ try{ opts.onDismiss(); }catch(_){} }
  }
  function onKey(e){ if(e.key==='Escape' && !busy) closePick(); }
  document.addEventListener('keydown', onKey);
  m.addEventListener('click', function(e){ if(e.target===m && !busy) closePick(); });
  m.querySelector('.ffbp-later-btn').addEventListener('click', function(){ if(!busy) closePick(); });
  /* the ceremony: ring + shards off the chosen tile, medal pulse, then rest */
  function ceremony(tile, hero){
    var title=m.querySelector('#ffbp-title');
    if(title) title.innerHTML=esc(hero.name||'Your hero')+' now wears <strong>'+esc(b.name)+'</strong>';
    var later=m.querySelector('.ffbp-later'); if(later) later.style.visibility='hidden';
    tile.classList.add('ffbp-won');
    var med=m.querySelector('.ffbp-medal'); if(med) med.classList.add('ffbp-medal-pop');
    if(!reduced){
      try{
        var r=tile.getBoundingClientRect();
        var cols={ bronze:['#e8ad6e','#c07f37'], silver:['#d4d9e0','#a6adba'], standard:['#ffe9a8','#e6bd57'], gold:['#ffe9a8','#e6bd57'], mythic:['#ef94ff','#ffe27a','#7ed4ff'], brand:['#ef94ff','#b3f5ee'] }[rar]||['#ffe9a8','#e6bd57'];
        var ring=document.createElement('span');
        ring.className='ffbp-ring';
        ring.style.left=(r.left+r.width/2)+'px'; ring.style.top=(r.top+r.height/2)+'px';
        ring.style.setProperty('--rcol', cols[0]);
        document.body.appendChild(ring);
        setTimeout(function(){ try{ ring.remove(); }catch(_){} }, 1100);
        for(var k=0;k<16;k++){
          var sp=document.createElement('span');
          sp.className='ffbp-shard';
          var ang=(k/16)*Math.PI*2, d=40+Math.random()*54;
          sp.style.left=(r.left+r.width/2)+'px'; sp.style.top=(r.top+r.height/2)+'px';
          sp.style.background=cols[k%cols.length];
          sp.style.setProperty('--bx',(Math.cos(ang)*d).toFixed(0)+'px');
          sp.style.setProperty('--by',(Math.sin(ang)*d).toFixed(0)+'px');
          document.body.appendChild(sp);
          (function(el){ setTimeout(function(){ try{ el.remove(); }catch(_){} }, 1050); })(sp);
        }
      }catch(_){}
    }
    try{ if(typeof window.hohShowHeartToast==='function') window.hohShowHeartToast(b.name+' claimed', (hero.name||'Your hero')+' now wears it across the Hall.'); }catch(_){}
    applied=true;
    setTimeout(function(){ closePick(); if(typeof opts.onApplied==='function'){ try{ opts.onApplied(hero); }catch(_){} } }, reduced?600:1650);
  }
  function pick(tile){
    if(busy) return; busy=true;
    m.querySelectorAll('.ffbp-tile').forEach(function(t){ t.disabled=true; if(t!==tile) t.classList.add('ffbp-dim'); });
    var id=tile.getAttribute('data-id');
    /* R262: opts.applyFn lets a caller place the badge via its OWN mechanism —
       e.g. the Merchant's Mark writes quest_meta.merchantsMark (which powers the
       double-Explore-hearts buff), not the quest-badge array. It must resolve to
       { ok, hero }. Defaults to the standard account-badge apply. */
    var applyFn = (typeof opts.applyFn==='function') ? opts.applyFn : window.hohApplyAccountBadge;
    Promise.resolve(applyFn(key, id)).then(function(res){
      if(res && res.ok){ ceremony(tile, res.hero); }
      else{
        busy=false;
        m.querySelectorAll('.ffbp-tile').forEach(function(t){ t.disabled=false; t.classList.remove('ffbp-dim'); });
        try{ if(typeof window.hohShowHeartToast==='function') window.hohShowHeartToast('Could not apply the badge', (res&&res.msg)||'Try again in a moment.'); }catch(_){}
      }
    });
  }
  m.querySelectorAll('.ffbp-tile').forEach(function(t){
    t.addEventListener('click', function(){ pick(t); });
  });
  /* single hero: the menu is skipped — the one tile is shown and the
     badge lands on it by itself after a beat, ceremony and all */
  if(single){ setTimeout(function(){ var t=m.querySelector('.ffbp-tile'); if(t && !busy && document.body.contains(m)) pick(t); }, 700); }
  return true;
};
/* R177: quest artifacts panel for the opened card. A hero made in the quest
   carries two keepsakes: the archetype share card (public, anyone may view it)
   and the blueprint PDF (private: owner + god only). URLs are read defensively
   across the column and quest_meta, since the quest writes share_card_url /
   blueprint_pdf_url and a future spine may stash them in quest_meta. The panel
   only renders when a real URL exists, so non-quest heroes show nothing. */
window.hohArtifactUrls = function(c){
  var qm = (c && c.quest_meta) || {};
  var card = (c && c.share_card_url) || qm.card_url || qm.share_card_url || '';
  var bp = (c && (c.blueprint_pdf_url || c.blueprint_url)) || qm.blueprint_url || qm.blueprint_pdf_url || '';
  return { card: card || '', blueprint: bp || '' };
};
window.hohBuildQuestArtifacts = function(c){
  try{
    if(!c) return '';
    var u = window.hohArtifactUrls(c);
    var isGod = (typeof window.hohIsGodMode==='function') && window.hohIsGodMode();
    var isOwner = (typeof window.hohIsCharacterOwner==='function') && window.hohIsCharacterOwner(c);
    var canBp = u.blueprint && (isOwner || isGod);
    if(!u.card && !canBp) return '';
    var btns = '';
    if(u.card){
      btns += '<button type="button" class="hoh-artifact-btn" data-artifact-card="'+esc(u.card)+'" onclick="hohOpenArtifactCard(this)">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg> Archetype Card</button>';
    }
    if(canBp){
      btns += '<a class="hoh-artifact-btn hoh-artifact-btn-blueprint" href="'+esc(u.blueprint)+'" target="_blank" rel="noopener noreferrer" title="Your blueprint. Only you and the keeper can open this">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/></svg> Blueprint<span class="hoh-artifact-lock" aria-hidden="true">&#128274;</span></a>';
    }
    return '<div class="hoh-quest-artifacts"><div class="hoh-quest-artifacts-label">From the Character Quest</div><div class="hoh-quest-artifacts-row">'+btns+'</div></div>';
  }catch(_){ return ''; }
};
/* Archetype card opens in a tap-to-close lightbox (the card is a visual, so it
   reads better viewed in place than dumped in a raw browser tab). URL comes off
   a data attribute so there's no quote-escaping in an inline handler. */
window.hohOpenArtifactCard = function(btn){
  try{
    /* R200: exports are account-tied. A signed-out visitor can't pull the
       archetype card — nudge them to submit a hero first, the same gate the
       Character Card uses. */
    if(typeof window.hohIsHallSignedIn==='function' && !window.hohIsHallSignedIn()){
      if(typeof window.hohOpenSubmitToEarnModal==='function'){ try{ window.hohOpenSubmitToEarnModal(null); }catch(_){ } }
      else if(typeof window.hohOpenForm==='function'){ try{ window.hohOpenForm(); }catch(_){ } }
      return;
    }
    var url = btn && btn.getAttribute && btn.getAttribute('data-artifact-card');
    if(!url) return;
    var old = document.getElementById('hoh-artifact-lb'); if(old && old.parentNode) old.parentNode.removeChild(old);
    var lb = document.createElement('div'); lb.id = 'hoh-artifact-lb'; lb.className = 'hoh-artifact-lb';
    var close = document.createElement('button'); close.type='button'; close.className = 'hoh-artifact-lb-close'; close.setAttribute('aria-label','Close'); close.innerHTML = '&times;';
    var img = document.createElement('img'); img.className = 'hoh-artifact-lb-img'; img.alt = 'Archetype card'; img.src = url;
    lb.appendChild(close); lb.appendChild(img);
    function dismiss(){ lb.classList.remove('hoh-artifact-lb-show'); setTimeout(function(){ if(lb.parentNode) lb.parentNode.removeChild(lb); }, 180); }
    lb.addEventListener('click', dismiss); /* tap anywhere (backdrop, image, or X) closes */
    document.body.appendChild(lb);
    void lb.offsetWidth;
    lb.classList.add('hoh-artifact-lb-show');
  }catch(_){}
};
/* R181: the export control. When a hero carries quest artifacts, the share
   button becomes an Export menu (Character Card / Archetype Card / Blueprint).
   Blueprint shows only for the owner and god, with its lock. A hero with no
   artifacts keeps the plain straightforward Character Card button. */
window.hohBuildExportBtnHtml = function(c){
  try {
    if(!c) return '';
    var u = window.hohArtifactUrls(c);
    var isGod = (typeof window.hohIsGodMode==='function') && window.hohIsGodMode();
    var isOwner = (typeof window.hohIsCharacterOwner==='function') && window.hohIsCharacterOwner(c);
    var canBlueprint = u.blueprint && (isOwner || isGod);
    var hasNpc = !!(c && c.npc_card);
    /* ⛔ R609 · THE MENU IS NOW UNCONDITIONAL, because every hero has at least
       two exports: the trading card and the details sheet. The old early
       return handed back a single plain button whenever a hero carried no
       quest artifacts, which would have hidden the card export from most of
       the Hall. */
    /* ⛔ R609 (Jan): "everything should be free and not cost any hearts."
       The price chip and the whole locked ladder are gone from this row. The
       sign-in gate stays, because it is not a price: these exports are tied to
       an account, not bought with one. */
    /* ⛔ ====== R609 · THE CARD, AND THEN THE DETAILS ======
       Jan: "I want the export button inside the detailed character page from
       the main hall as well to include the character's actual card. So maybe
       rename the current character card to, like, character details, and then
       actually have character card above that one as the first option and show,
       like, an icon of, like, a playing card or something to show that it's the
       good-looking version of the character card with just the flavor text."
       Two different artifacts wearing one name was the whole problem: the
       existing export is an information sheet, and the thing people actually
       want to post is the card. The card leads, and the sheet says what it is.
       The icon is a playing card with a rounded corner and a pip, so the two
       rows are told apart at a glance rather than read. */
    var items =
      '<button type="button" class="hoh-export-item" role="menuitem" onclick="hohCloseExportMenus();hohExportCharacterCard(\''+esc(c.id)+'\')">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">'+
          '<rect x="6" y="2.5" width="12" height="19" rx="2.5"/>'+
          '<path d="M12 8.2l2.1 2.5c.7.9.1 2.3-1 2.3-.5 0-.9-.3-1.1-.7-.2.4-.6.7-1.1.7-1.1 0-1.7-1.4-1-2.3z"/>'+
          '<path d="M12 12.8V16"/>'+
        /* R612 (Jan): "remove the words front and back". The export is the
           front only now, so a caption describing two faces was describing
           something that no longer happens. */
        '</svg> <span class="hoh-export-item-label">Character Card</span>'+
      '</button>'+
      '<button type="button" class="hoh-export-item" role="menuitem" onclick="hohCloseExportMenus();hohShareCard(\''+esc(c.id)+'\')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/></svg> <span class="hoh-export-item-label">Character details</span></button>';
    if(u.card){
      items += '<button type="button" class="hoh-export-item" role="menuitem" data-artifact-card="'+esc(u.card)+'" onclick="hohCloseExportMenus();hohOpenArtifactCard(this)"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg> Archetype Card</button>';
    }
    if(hasNpc){
      items += '<button type="button" class="hoh-export-item" role="menuitem" onclick="hohCloseExportMenus();hohNpcDownloadPdf()"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="3" width="16" height="18" rx="2"/><line x1="8" y1="8" x2="16" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="8" y1="16" x2="13" y2="16"/></svg> NPC Card</button>';
    }
    if(canBlueprint){
      items += '<a class="hoh-export-item hoh-export-item-bp" role="menuitem" href="'+esc(u.blueprint)+'" target="_blank" rel="noopener noreferrer" onclick="hohCloseExportMenus()" title="Only you and the keeper can open this"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg> Blueprint<span class="hoh-export-lock" aria-hidden="true">&#128274;</span></a>';
    }
    return '<div class="hoh-export-wrap">'+
      '<button type="button" id="hoh-share-btn" data-hero-id="'+esc(c.id)+'" class="hoh-share-btn hoh-export-btn" aria-haspopup="true" onclick="hohToggleExportMenu(event,this)"><svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg> Export<svg class="hoh-export-caret" viewBox="0 0 14 14" width="13" height="13" fill="none" aria-hidden="true"><path d="M3 5L7 9L11 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'+
      '<div class="hoh-export-menu" role="menu">'+items+'</div>'+
    '</div>';
  } catch(_){
    return (typeof window.hohBuildShareBtnHtml==='function') ? window.hohBuildShareBtnHtml(c) : '';
  }
};
/* ⛔ R609 · the Hall's door into the shop's card renderer.
   The exporter lives in hoh-shop.js because that is where `fullCardHtml` and
   the card stylesheet live, and photographing the real card is the whole point
   of it. This wrapper owns the two things the Hall is responsible for: the
   same account gate every other export uses, and SAYING SO when the shop
   bundle is not on the page, because a menu row that does nothing is worse
   than one that is not there. */
window.hohExportCharacterCard = function(id){
  try{
    if(typeof window.hohIsHallSignedIn==='function' && !window.hohIsHallSignedIn()){
      if(typeof window.hohOpenSubmitToEarnModal==='function'){ try{ window.hohOpenSubmitToEarnModal(null); }catch(_){ } }
      else if(typeof window.hohOpenForm==='function'){ try{ window.hohOpenForm(); }catch(_){ } }
      return;
    }
    if(typeof window.hohShopExportCardPdf !== 'function'){
      if(typeof window.hohShowHallToast==='function') window.hohShowHallToast('The card exporter is still loading. Try again in a moment.');
      return;
    }
    window.hohShopExportCardPdf(id);
  }catch(_){
    if(typeof window.hohShowHallToast==='function') window.hohShowHallToast('That card could not be exported. Reload the Hall and try again.');
  }
};
window.hohCloseExportMenus = function(){
  try { var o=document.querySelectorAll('.hoh-export-wrap.hoh-export-open'); for(var i=0;i<o.length;i++) o[i].classList.remove('hoh-export-open'); } catch(_){}
};
window.hohToggleExportMenu = function(e, btn){
  try {
    if(e && e.stopPropagation) e.stopPropagation();
    var wrap = btn && btn.closest ? btn.closest('.hoh-export-wrap') : null;
    if(!wrap) return;
    var isOpen = wrap.classList.contains('hoh-export-open');
    window.hohCloseExportMenus();
    if(!isOpen) wrap.classList.add('hoh-export-open');
  } catch(_){}
};
if(!window.__hohExportMenuClose){
  window.__hohExportMenuClose = true;
  document.addEventListener('click', function(e){
    try { if(e.target && e.target.closest && e.target.closest('.hoh-export-wrap')) return; window.hohCloseExportMenus(); } catch(_){}
  });
}
/* Returns the pool of mythic-tier characters from the loaded
   gallery, or [] if none. Used by every host picker that wants to
   roll for a mythic host. */
window.hohGetMythicHostPool=function(){
 try {
  if(typeof window.hohGetAllCharacters==='function'){
   var all=window.hohGetAllCharacters()||[];
   return all.filter(function(c){return c && c.id && window.hohIsMythicCharacter(c);});
  }
 } catch(_){}
 return [];
};
/* Probability that a host roll comes from the mythic pool. Default
   ~5% so mythic hosts are a rare flutter. After the user finishes
   the daily wander quest (all 3 ticket milestones claimed today),
   the chance jumps to ~20% (1 in 5) as a reward for engagement.
   R406 slid that ladder to 0/10/20/30/40/50, but m20/m40/m60 below are
   SLOT names rather than heart thresholds and did not move, so this
   check keeps working untouched. */
window.hohMythicHostChance=function(){
 try {
  if(typeof window.hohGetWanderQuestClaimed==='function'){
   var w=window.hohGetWanderQuestClaimed()||{};
   if(w.m20 && w.m40 && w.m60) return 0.20;
  }
 } catch(_){}
 return 0.05;
};
/* Roll a mythic host for the current event. Returns the picked
   mythic character if (a) the pool has any AND (b) the random roll
   came up under hohMythicHostChance. Returns null otherwise so the
   caller falls back to its normal host picker. */
window.hohRollMythicHost=function(){
 try {
  var pool=window.hohGetMythicHostPool();
  if(!pool.length) return null;
  if(Math.random()>=window.hohMythicHostChance()) return null;
  return pool[Math.floor(Math.random()*pool.length)];
 } catch(_){}
 return null;
};
/* HOH_RARITY_LADDER lives in assets/hoh-data.js */
/* Build the rarity info pill + tooltip.
   R70: Mythic tier renders the WORD "MYTHIC" as clean rainbow text
   only — no dot, no question mark, no box, no border. CSS scopes the
   rainbow gradient to the .hoh-rarity-info-label span only so the
   tooltip rows below don\'t inherit the text-fill-color (the bleed
   bug we hit earlier where every dropdown row turned pink). The
   tooltip still appears on hover/tap so users discover the tier. */
function hohBuildRarityInfoHtml(rar){
 /* R793: hearts stopped counting, so each hero keeps the tier its legacy
    hearts reached. The ladder and its foot say that plainly. */
 var _r793Tip=(typeof window.hohR793Live==='function') && window.hohR793Live();
 /* R795: once the tier comes from the hero page score (sql/R795B), the
    heart ranges no longer say how a hero got here, so the ladder shows the
    tiers alone, with no line about Mythic (Jan: it is not explained). */
 var _scoreTip=hohHallTierFromScore();
 var rows=HOH_RARITY_LADDER.map(function(row){
 var active=(row.tier===rar.tier)?' hoh-rarity-tip-row-active':'';
 var hidden=row.hidden?' hoh-rarity-tip-row-hidden':'';
 var name=row.hidden?'???':row.label;
 var range=_scoreTip?'':(row.hidden?'a hidden tier':(_r793Tip?String(row.range).replace(/hearts$/,'legacy hearts'):row.range));
 return'<li class="hoh-rarity-tip-row hoh-rarity-tip-row-'+row.tier+active+hidden+'"><span class="hoh-rarity-dot hoh-rarity-dot-'+row.tier+'"></span><span class="hoh-rarity-tip-name">'+name+'</span><span class="hoh-rarity-tip-range">'+range+'</span></li>';
 }).join('');
 var isMythicPill=(rar.tier==='mythic');
 var ariaLabel=isMythicPill?'Mythic rarity. Tap for tier info.':'Rarity info';
 /* R148-Z1: Mythic now renders the SAME pill structure as every
    other tier (dot + label + ? glyph). Previously Mythic was an
    exception with rainbow-text-only and no chrome, which made it
    look like an afterthought next to Legendary's proper pill. CSS
    keeps the rainbow text + soft lavender glow on the label, but
    the surrounding pill / border / dot / help glyph match the rest
    of the rarity ladder for visual consistency. */
 var inner='<span class="hoh-rarity-dot hoh-rarity-dot-'+rar.tier+'"></span>'+
   '<span class="hoh-rarity-info-label">'+rar.label+'</span>'+
   '<span class="hoh-rarity-info-q" aria-hidden="true">?</span>';
 return'<span class="hoh-rarity-info hoh-rarity-info-'+rar.tier+'" tabindex="0" role="button" aria-label="'+ariaLabel+'" onclick="hohToggleRarityTip(this,event)" onkeydown="if(event.key===\'Enter\'||event.key===\' \'){hohToggleRarityTip(this,event);event.preventDefault();}">'+
 inner+
 '<span class="hoh-rarity-tip" role="tooltip">'+
  '<span class="hoh-rarity-tip-title">'+(_scoreTip?'Rarity':(_r793Tip?'Rarity from legacy hearts':'Rarity grows with hearts'))+'</span>'+
  '<ul class="hoh-rarity-tip-list">'+rows+'</ul>'+
  /* R793.1 fix: the foot names legacy hearts only; the favorite action is
     never called a heart (copy sweep, 2026-09-22) */
  '<span class="hoh-rarity-tip-foot">'+(_scoreTip?'Filling in their hero page raises it.':_r793Tip
    ?'Each hero keeps the tier its legacy hearts reached. Favorites don&rsquo;t change it.'
    :'Players keep hearting heroes they love. More hearts, brighter tier. At 1,000 a Legendary locks, and the final 200 hearts to Mythic come only from Explore the Hall.')+'</span>'+
 '</span>'+
 '</span>';
}
/* Apply rarity tint to the detail modal frame. */
function hohApplyModalRarity(tier){
 var wrap=document.querySelector('#hoh-modal .hoh-modal-content');
 if(!wrap)return;
 ['common','uncommon','rare','epic','legendary','mythic'].forEach(function(t){
 wrap.classList.remove('hoh-modal-rar-'+t);
 });
 if(tier)wrap.classList.add('hoh-modal-rar-'+tier);
}
/* Detail-modal ticket breakdown popup. Tap toggles, same dismiss as rarity tip.
   Exposed on window so hoh-tickets.js (which builds the pill markup
   that embeds this breakdown) can call it across files. Without the
   window assignment the pill rendered with an EMPTY breakdown
   because typeof window.hohBuildTicketBreakdownHtml was undefined. */
/* R230: THE ticket decomposition. Every surface (hover breakdown, winner
   card, entry counts, win %, share card) reads from this one function so
   they can never disagree again. c.tickets IS the total — nothing rides on
   top at render time anymore.
   Why R229 still drifted: the FF +10 was baked into tickets while the
   Mythic +3 was invented live at render (hearts >= 1100), so for mythics
   the hover Total (stored + 3) could never equal the pill or the Supabase
   row (stored) — the reported case: pill 32, hover 35, database 32.
   Second rot R230 found: EVERY submit since the quest spine inserts
   ff_bonus_granted = true on NON-FF heroes too (this file's insert payload
   and character-quest.js, both fixed in R230), so that flag says nothing
   about what is inside the stored number. ~380 live rows carry the latch
   with tickets < 11 — impossible if the 10 were really in there — and a
   5-ticket mythic rendered rows summing to 14 inside a Total of 8.
   The R230 rules (enforced server-side by
   sql/R230-ticket-single-source-of-truth.sql — backfill + a characters
   BEFORE trigger that keeps them true on every future write path):
     tickets >= 1 always. Mythic +3 is BAKED once, latched by the NEW
     mythic_bonus_granted column. FF +10 is baked at grant, and every
     CURRENT FF portrait is topped up to at least 1+10(+3) so its row
     really fits.
   Display claims a bonus row only when its trustworthy flag is set AND the
   amount provably fits inside the stored count, so the rows ALWAYS sum to
   EXACTLY c.tickets — even mid-deploy (before the SQL adds the column) and
   on pathological rows. The FF row keys off is_ff_portrait (the curated
   live flag), never ff_bonus_granted. An ex-FF hero that kept its granted
   10 simply carries it inside the earned bucket, which is honest too. */
function hohDecomposeTickets(c){
 var stored=Math.max(1,(c&&c.tickets)||1);
 var mythic=(c&&c.mythic_bonus_granted&&(stored-1)>=3)?3:0;
 var ff=(c&&c.is_ff_portrait&&(stored-1-mythic)>=10)?10:0;
 return{stored:stored,baseline:1,ff:ff,mythic:mythic,earned:stored-1-ff-mythic};
}
window.hohDecomposeTickets=hohDecomposeTickets;
function hohBuildTicketBreakdownHtml(c){
 /* R230: decompose once, render rows that sum to the stored total. The
    Total row now IS c.tickets — the same number as the pill, the raffle
    weight, the win % numerator and the Supabase row. "Earned & applied"
    replaces the old "Applied tickets" label: that bucket also holds the
    phase4 every-10-hearts grants, the original backfill (1 + hearts/10),
    the legacy server mythic +1 (mythic_granted, paid at 1000 hearts) and
    god grants — calling all of it "applied" overstated what the owner
    actually spent from their wallet. */
 var d=hohDecomposeTickets(c);
 var total=d.stored;
 var rows='';
 rows+='<div class="hoh-tk-bd-row"><span>Baseline</span><span>+1</span></div>';
 /* R95: FramedFantasy row — same row styling as Baseline (no
    highlighted box). The hoh-tk-bd-ff-brand span gets the brand
    cream/burgundy gradient just on the word "FramedFantasy". */
 if(d.ff)rows+='<div class="hoh-tk-bd-row"><span><span class="hoh-tk-bd-ff-brand">FramedFantasy</span> bonus</span><span>+'+d.ff+'</span></div>';
 if(d.mythic)rows+='<div class="hoh-tk-bd-row"><span>Mythic bonus</span><span>+'+d.mythic+'</span></div>';
 if(d.earned)rows+='<div class="hoh-tk-bd-row"><span>Earned &amp; applied</span><span>+'+d.earned+'</span></div>';
 var pct=hohWinPercent(c).toFixed(2);
 /* R64: When the signed-in user owns this hero AND has unspent
    tickets in their wallet, surface an inline hint so they know the
    pill is tappable to apply one. Without this, mobile users (no
    hover) would not discover the apply-on-second-tap gesture. */
 var applyHint = '';
 /* R793: the live Hall has no ticket wallet and no second-tap apply. The
    owner's daily ticket is its own panel under this row. */
 if(!(typeof window.hohR793Live === 'function' && window.hohR793Live())) try {
   var unspent = (typeof window.hohGetUnspentTickets === 'function') ? window.hohGetUnspentTickets() : 0;
   if(unspent > 0 && c && c.id){
     var owns = false;
     var rows2 = (window.hohTicketState && window.hohTicketState.my_characters) || [];
     for(var i=0; i<rows2.length; i++){
       if(rows2[i] && String(rows2[i].id) === String(c.id)){ owns = true; break; }
     }
     if(owns){
       applyHint = '<div class="hoh-tk-bd-apply-hint">' +
         '<span class="hoh-tk-icon" aria-hidden="true"></span>' +
         '<span>Tap again to apply 1 of your <strong>' + unspent + '</strong> ticket' + (unspent === 1 ? '' : 's') + '.</span>' +
         '</div>';
     }
   }
 } catch(_){}
 return '<div class="hoh-tk-bd-title">Raffle ticket breakdown</div>'+
  '<div class="hoh-tk-bd-list">'+rows+'</div>'+
  '<div class="hoh-tk-bd-total"><span>Total</span><span><strong>'+total+'</strong></span></div>'+
  '<div class="hoh-tk-bd-pct"><strong id="hoh-detail-win-pct-num">'+pct+'</strong>% chance to win this month</div>'+
  applyHint;
}
window.hohBuildTicketBreakdownHtml=hohBuildTicketBreakdownHtml;
window.hohToggleTicketTip=function(el,ev){
 if(ev){ev.stopPropagation();ev.preventDefault();}
 if(!el)return;
 var open=el.classList.toggle('hoh-tk-tip-open');
 if(open){
 /* R86: Mobile breakdown popup is position:fixed (CSS) so it can
    escape the modal's overflow clip. Default CSS pinned it to
    top:84px which felt detached from the raffle pill. Compute
    the pill's bounding rect on open and inline-place the popup
    immediately below + slightly inset so it visually attaches
    to the icon while still escaping overflow.
    Desktop is unaffected — the @media(max-width:600px) CSS rule
    only applies position:fixed on phones. */
 try {
   var isMobile = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
   if(isMobile){
     var tip = el.querySelector('.hoh-detail-win-tip, .hoh-tk-tip');
     if(tip){
       var pillRect = el.getBoundingClientRect();
       /* Position right under the pill with an 8px gap. Center
          horizontally on the pill, but never let it slide off
          the viewport edges (16px margin guard). */
       var vw = window.innerWidth || document.documentElement.clientWidth || 360;
       var maxW = Math.min(360, vw - 32);
       var centerX = pillRect.left + (pillRect.width / 2);
       var leftPx = Math.round(centerX - (maxW / 2));
       leftPx = Math.max(16, Math.min(leftPx, vw - 16 - maxW));
       /* If pill is in the upper third, drop the popup below it.
          If pill is in the lower third (rare on detail modal), place
          it above so it doesn't clip the bottom of the screen. */
       var vh = window.innerHeight || document.documentElement.clientHeight || 600;
       var below = pillRect.bottom + 8;
       var above = Math.max(8, pillRect.top - 8 - 220); /* assume ~220px popup */
       var topPx = (pillRect.top < vh * 0.6) ? below : above;
       tip.style.top = topPx + 'px';
       tip.style.left = leftPx + 'px';
       tip.style.right = 'auto';
       tip.style.width = maxW + 'px';
       tip.style.maxWidth = maxW + 'px';
       /* Tiny upward arrow that points back at the pill. Inline
          via a ::before-style div would need CSS; for simplicity
          use a transform-origin shift so it visually leans toward
          the pill. */
     }
   }
 } catch(_){}
 var off=function(e){if(!el.contains(e.target)){el.classList.remove('hoh-tk-tip-open');document.removeEventListener('click',off,true);}};
 setTimeout(function(){document.addEventListener('click',off,true);},0);
 }
};

/* Mobile tap-toggle for the rarity tooltip. */
window.hohToggleRarityTip=function(el,ev){
 if(ev){ev.stopPropagation();}
 if(!el)return;
 var open=el.classList.toggle('hoh-rarity-info-open');
 /* Close on next outside tap. */
 if(open){
 var off=function(e){if(!el.contains(e.target)){el.classList.remove('hoh-rarity-info-open');document.removeEventListener('click',off,true);}};
 setTimeout(function(){document.addEventListener('click',off,true);},0);
 }
};

/* Tier-up pulse: one ring expand + brief halo bump. Mythic gets the
 longest, brightest celebration since reaching it also grants a
 bonus raffle ticket. */
var HOH_TIER_UP_FX={
 uncommon:{duration:500,primary:'#1eff00'},
 rare:{duration:550,primary:'#0070dd'},
 epic:{duration:600,primary:'#a335ee'},
 legendary:{duration:700,primary:'#ffb347'},
 mythic:{duration:1400,primary:'#ff5cf2'}
};

/* Tier-up celebration when a heart crosses a rarity boundary. */
window.hohCelebrateTierUp=hohCelebrateTierUp;
function hohCelebrateTierUp(cardEl,oldTier,newTier,rar){
 var fx=HOH_TIER_UP_FX[newTier];
 if(!fx||!cardEl)return;
 var reduced=false;
 try{reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;}catch(e){}
 if(reduced)return;
 var rect=cardEl.getBoundingClientRect();
 var burst=document.createElement('div');
 burst.className='hoh-tier-up-burst hoh-tier-up-burst-'+newTier;
 burst.style.left=(rect.left+rect.width/2)+'px';
 burst.style.top=(rect.top+rect.height/2)+'px';
 burst.style.setProperty('--tier-color',fx.primary);
 burst.style.setProperty('--burst-w',rect.width+'px');
 burst.style.setProperty('--burst-h',rect.height+'px');
 burst.style.setProperty('--burst-duration',fx.duration+'ms');
 burst.innerHTML='<span class="hoh-tier-up-ring"></span>';
 document.body.appendChild(burst);
 setTimeout(function(){if(burst.parentNode)burst.parentNode.removeChild(burst);},fx.duration+200);
 cardEl.classList.add('hoh-card-tier-up-'+newTier);
 setTimeout(function(){cardEl.classList.remove('hoh-card-tier-up-'+newTier);},fx.duration+200);
}

function hohCelebrateMythic(t,c){if(window.hohMythicCelebrate)window.hohMythicCelebrate(t,c);}
/* Live-refresh rarity class on any visible card after a heart lands. */
function hohRefreshCharacterRarity(id,newTier){
 var ccards=document.querySelectorAll('[data-hero-id="'+id+'"]');
 var tiers=['common','uncommon','rare','epic','legendary'];
 ccards.forEach(function(el){
 tiers.forEach(function(t){el.classList.remove('hoh-card-rar-'+t,'hoh-reel-rar-'+t,'hoh-scene-rar-'+t,'hoh-company-rar-'+t);});
 /* Decide which prefix to add based on which container type we hit. */
 if(el.classList.contains('hoh-card'))el.classList.add('hoh-card-rar-'+newTier);
 if(el.classList.contains('hoh-summon-reel-ticket'))el.classList.add('hoh-reel-rar-'+newTier);
 if(el.classList.contains('hoh-scene-who-body'))el.classList.add('hoh-scene-rar-'+newTier);
 if(el.classList.contains('hoh-company-member'))el.classList.add('hoh-company-rar-'+newTier);
 });
}

/* Hearts are mostly vanity now (rarity tier driver). The real raffle
 entries are tickets. Bumped from 3 to 100 so users can heart freely
 across the Hall without burning through a daily pool. The per-
 character per-day cap (server: 125 user-clicks per R51) is the real
 limit. The cap counts GIVEN clicks (not displayed hearts) so at
 legendary tier (5:1 absorb) a character can still only gain
 floor(125/5)=25 displayed hearts per day. */
var HOH_HEART_BASE=100;
var HOH_HEART_BONUS=7;
var HOH_HEART_BONUS_KEY='hoh-hearts-bonus-day-v1';
/* Trial completion bonus. +5 hearts once/day. */
var HOH_TRIAL_COMP_BONUS=5;
var HOH_TRIAL_COMP_KEY='hoh-trial-comp-day-v1';
/* IG follow bonus. +3 hearts, once ever per device. */
var HOH_IG_BONUS=3;
var HOH_IG_EVER_KEY='hoh-ig-bonus-ever-v1';
function hohIgEverClaimed(){try{return localStorage.getItem(HOH_IG_EVER_KEY)==='1';}catch(e){return false;}}
/* Hidden daily heart claims (+3 each, +5 for the rarity-tier heart).
 Date-flagged, ride dev channel. */
var HOH_RAINBOW_HEART_KEY='hoh-rainbow-heart-day-v1';
var HOH_PORTRAIT_HEART_KEY='hoh-portrait-heart-day-v1';
var HOH_GOLD_HEART_KEY='hoh-gold-heart-day-v1';
var HOH_SUCCESS_HEART_KEY='hoh-success-heart-day-v1';
var HOH_FORM_HEART_KEY='hoh-form-heart-day-v1';
var HOH_RARITY_HEART_KEY='hoh-rarity-heart-day-v1';
function hohRainbowHeartClaimed(){try{return localStorage.getItem(HOH_RAINBOW_HEART_KEY)===hohTodayStr();}catch(e){return false;}}
function hohPortraitHeartClaimed(){try{return localStorage.getItem(HOH_PORTRAIT_HEART_KEY)===hohTodayStr();}catch(e){return false;}}
function hohGoldHeartClaimed(){try{return localStorage.getItem(HOH_GOLD_HEART_KEY)===hohTodayStr();}catch(e){return false;}}
function hohSuccessHeartClaimed(){try{return localStorage.getItem(HOH_SUCCESS_HEART_KEY)===hohTodayStr();}catch(e){return false;}}
function hohRarityHeartClaimed(){try{return localStorage.getItem(HOH_RARITY_HEART_KEY)===hohTodayStr();}catch(e){return false;}}
window.hohClaimRarityHeart=function(el,evt){
 if(evt){evt.preventDefault();evt.stopPropagation();}
 if(hohRarityHeartClaimed())return false;
 try{localStorage.setItem(HOH_RARITY_HEART_KEY,hohTodayStr());}catch(e){}
 hohGrantDevHearts(5);
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(5);
 hohUpdateHeartCounter();
 hohFlyHeartsToPill(el,5);
 setTimeout(function(){
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(5,true);
 if(typeof hohShowHeartToast==='function')hohShowHeartToast('The rarity heart','Claimed for today.',true);
 },280);
 if(el)el.classList.add('hoh-rarity-heart-claimed');
 return false;
};
window.hohClaimSuccessHeart=function(el,evt){
 if(evt){evt.preventDefault();evt.stopPropagation();}
 if(hohSuccessHeartClaimed())return false;
 try{localStorage.setItem(HOH_SUCCESS_HEART_KEY,hohTodayStr());}catch(e){}
 hohGrantDevHearts(3);
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(3);
 hohUpdateHeartCounter();
 hohFlyHeartsToPill(el,3);
 setTimeout(function(){
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(3,true);
 if(typeof hohShowHeartToast==='function')hohShowHeartToast('Another hidden one','Found.',true);
 },280);
 if(el)el.classList.add('hoh-success-bonus-icon-claimed');
 return false;
};
function hohFormHeartClaimed(){try{return localStorage.getItem(HOH_FORM_HEART_KEY)===hohTodayStr();}catch(e){return false;}}
window.hohClaimFormHeart=function(el,evt){
 if(evt){evt.preventDefault();evt.stopPropagation();}
 if(hohFormHeartClaimed())return false;
 try{localStorage.setItem(HOH_FORM_HEART_KEY,hohTodayStr());}catch(e){}
 /* Glowing yellow heart claim grants 7 SPENDABLE hearts (matches the
    copy "Submitting unlocks 7 bonus hearts"). Adds to the bank so
    the user can immediately spend them, and bumps the cap so the
    bank can hold the new total. Resets daily via HOH_FORM_HEART_KEY. */
 hohGrantDevHearts(7);
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(7);
 hohUpdateHeartCounter();
 hohFlyHeartsToPill(el,7);
 setTimeout(function(){
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(7,true);
 if(typeof hohShowHeartToast==='function')hohShowHeartToast('The hidden bonus','Claimed for today.',true);
 },280);
 if(el)el.classList.add('hoh-form-intro-dot-claimed');
 return false;
};
window.hohClaimGoldHeart=function(el,evt){
 if(evt){evt.preventDefault();evt.stopPropagation();}
 if(hohGoldHeartClaimed())return false;
 try{localStorage.setItem(HOH_GOLD_HEART_KEY,hohTodayStr());}catch(e){}
 hohGrantDevHearts(3);
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(3);
 hohUpdateHeartCounter();
 hohFlyHeartsToPill(el,3);
 setTimeout(function(){
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(3,true);
 if(typeof hohShowHeartToast==='function')hohShowHeartToast('Found one','You found another hidden one.',true);
 },280);
 if(el)el.classList.add('hoh-rules-entry-icon-claimed');
 return false;
};
window.hohClaimRainbowHeart=function(el,evt){
 if(evt){evt.preventDefault();evt.stopPropagation();}
 if(hohRainbowHeartClaimed())return false;
 try{localStorage.setItem(HOH_RAINBOW_HEART_KEY,hohTodayStr());}catch(e){}
 hohGrantDevHearts(3);
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(3);
 hohUpdateHeartCounter();
 hohFlyHeartsToPill(el,3);
 setTimeout(function(){
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(3,true);
 if(typeof hohShowHeartToast==='function')hohShowHeartToast('Three found','You found three of the hidden ones.',true);
 },280);
 if(el){
 el.classList.add('hoh-rules-inline-link-claimed');
 el.textContent='Found';
 }
 return false;
};
window.hohClaimPortraitHeart=function(el,evt){
 if(evt){evt.preventDefault();evt.stopPropagation();}
 if(hohPortraitHeartClaimed())return false;
 try{localStorage.setItem(HOH_PORTRAIT_HEART_KEY,hohTodayStr());}catch(e){}
 hohGrantDevHearts(3);
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(3);
 hohUpdateHeartCounter();
 hohFlyHeartsToPill(el,3);
 setTimeout(function(){
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(3,true);
 if(typeof hohShowHeartToast==='function')hohShowHeartToast('Found it','You found the heart.',true);
 },280);
 if(el){el.classList.add('hoh-explain-icon-claimed');}
 return false;
};
/* Apply already-claimed UI states on page load so the user sees the
 dimmed / disabled labels if they reload after claiming today. */
function hohSyncDailyClaimsInitial(){
 if(hohRainbowHeartClaimed()){
 var rl=document.querySelector('.hoh-rules-entry-tri-heart');
 if(rl){rl.classList.add('hoh-rules-inline-link-claimed');rl.textContent='Found';}
 }
 if(hohPortraitHeartClaimed()){
 var pi=document.querySelector('.hoh-explain-icon-clickable');
 if(pi)pi.classList.add('hoh-explain-icon-claimed');
 }
 if(hohGoldHeartClaimed()){
 var gh=document.querySelector('.hoh-rules-entry-icon-clickable');
 if(gh)gh.classList.add('hoh-rules-entry-icon-claimed');
 }
 if(hohSuccessHeartClaimed()){
 var sh=document.querySelector('.hoh-success-bonus-icon-clickable');
 if(sh)sh.classList.add('hoh-success-bonus-icon-claimed');
 }
 if(hohFormHeartClaimed()){
 var fh=document.querySelector('.hoh-form-intro-dot-clickable');
 if(fh)fh.classList.add('hoh-form-intro-dot-claimed');
 }
 if(hohRarityHeartClaimed()){
 var rh=document.querySelector('.hoh-rules-rarity-heart-clickable');
 if(rh)rh.classList.add('hoh-rarity-heart-claimed');
 }
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',hohSyncDailyClaimsInitial);}else{hohSyncDailyClaimsInitial();}

/* Dice max-roll bonuses. Each die's max value, once per day, grants
 hearts (+1 for d4-d20, +10 for d100). Bonuses accumulate into a single
 daily total tracked in HOH_DICE_BONUS_KEY so the cap formula has one
 number to read. Per-die "claimed today" flags keyed by die size. */
var HOH_DICE_BONUS_KEY='hoh-dice-bonus-total-day-v1';
function hohDiceBonusTotal(){try{var raw=localStorage.getItem(HOH_DICE_BONUS_KEY);if(!raw)return 0;var o=JSON.parse(raw);if(!o||o.date!==hohTodayStr())return 0;return parseInt(o.count,10)||0;}catch(e){return 0;}}
function hohAddDiceBonus(amount){try{var cur=hohDiceBonusTotal();var next=cur+(amount||0);localStorage.setItem(HOH_DICE_BONUS_KEY,JSON.stringify({date:hohTodayStr(),count:next}));}catch(e){}return amount;}
function hohDiceMaxClaimedKey(sides){return'hoh-dice-max-'+sides+'-day-'+hohTodayStr();}
function hohDiceMaxClaimedToday(sides){try{return localStorage.getItem(hohDiceMaxClaimedKey(sides))==='1';}catch(e){return false;}}
function hohMarkDiceMaxClaimed(sides){try{localStorage.setItem(hohDiceMaxClaimedKey(sides),'1');}catch(e){}}
var HOH_DEV_HEARTS_KEY='hoh-dev-hearts';
function hohTodayStr(){var d=new Date();return d.getFullYear()+'-'+(d.getMonth()+1)+'-'+d.getDate();}
function hohHeartsBonusActive(){try{return localStorage.getItem(HOH_HEART_BONUS_KEY)===hohTodayStr();}catch(e){return false;}}
function hohGrantHeartsBonus(){try{localStorage.setItem(HOH_HEART_BONUS_KEY,hohTodayStr());}catch(e){}}
/* Secret dev-mode bonus hearts, keyed by date so they reset at midnight with
 the rest of the heart system. Added on top of base + submission bonus. */
function hohGetDevHearts(){
 try{
 var raw=localStorage.getItem(HOH_DEV_HEARTS_KEY);
 if(!raw)return 0;
 var obj=JSON.parse(raw);
 if(!obj||obj.date!==hohTodayStr())return 0;
 return parseInt(obj.count,10)||0;
 }catch(e){return 0;}
}
function hohGrantDevHearts(amount){
 var cur=hohGetDevHearts();
 var next=cur+(amount||0);
 try{localStorage.setItem(HOH_DEV_HEARTS_KEY,JSON.stringify({date:hohTodayStr(),count:next}));}catch(e){}
 return next;
}
/* Daily action bonus: +3 hearts on first daily use of summon/scene/
 tavern/company/simulate. Date-keyed; resets at midnight. Plays full
 heart-fly + refill + toast. */
function hohClaimActionHeart(action,fromEl,subtitle){
 try{
 var key='hoh-action-'+action+'-'+hohTodayStr();
 if(localStorage.getItem(key)==='1')return false;
 localStorage.setItem(key,'1');
 hohGrantDevHearts(3);
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(3);
 hohUpdateHeartCounter();
 setTimeout(function(){
  if(fromEl&&typeof hohFlyHeartsToPill==='function')hohFlyHeartsToPill(fromEl,3);
  if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(3,true);
  if(typeof hohShowHeartToast==='function')hohShowHeartToast('A small thanks',subtitle||'For exploring the Hall.',true);
 },220);
 return true;
 }catch(e){return false;}
}
window.hohClaimActionHeart=hohClaimActionHeart;
function hohTrialCompBonusActive(){try{return localStorage.getItem(HOH_TRIAL_COMP_KEY)===hohTodayStr();}catch(e){return false;}}
/* Returns true if this call actually granted the bonus (false if it
 was already granted earlier today). The Trial calls this on summary
 mount; the host plays the refill animation only on the true return
 so re-entries to the summary do not re-fire the celebration. */
window.hohGrantTrialCompBonus=function(){
 if(hohTrialCompBonusActive())return false;
 try{localStorage.setItem(HOH_TRIAL_COMP_KEY,hohTodayStr());}catch(e){}
 /* Also push to the spendable bank so the visible counter ticks
  up by HOH_TRIAL_COMP_BONUS (5). Without this, completing the
  trial only marked a flag — the wallet stayed unchanged. */
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(HOH_TRIAL_COMP_BONUS);
 hohUpdateHeartCounter();
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(HOH_TRIAL_COMP_BONUS,true);
 return true;
};
function heartsCapToday(){return HOH_HEART_BASE+(hohHeartsBonusActive()?HOH_HEART_BONUS:0)+(hohTrialCompBonusActive()?HOH_TRIAL_COMP_BONUS:0)+hohDiceBonusTotal()+hohGetDevHearts()+(window.hohBlessingHeartsToday?window.hohBlessingHeartsToday():0);}

/* Instagram bonus heart click handler. Grants +3 hearts instantly to
 today's cap (via the dev-heart channel which already adds to today's
 pool and resets at midnight). Sets a permanent "ever claimed" flag so
 the button is greyed out forever once used. The link still opens
 Instagram in a new tab via the anchor's natural behavior. */
window.hohIgFollowClick=function(btn){
 if(hohIgEverClaimed()){return true;}
 try{localStorage.setItem(HOH_IG_EVER_KEY,'1');}catch(e){}
 /* Add to today's cap AND to the spendable bank — without the bank
  add the visible counter wouldn't change, even though the user
  earned the bonus. */
 hohGrantDevHearts(HOH_IG_BONUS);
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(HOH_IG_BONUS);
 if(typeof hohUpdateHeartCounter==='function')hohUpdateHeartCounter();
 setTimeout(function(){
 /* the hearts pop on the button; nothing flies to the wallet (Jan, 2026-09-27) */
 if(btn&&typeof window.hohHeartBurst==='function')window.hohHeartBurst(btn,{n:HOH_IG_BONUS});
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(HOH_IG_BONUS,true);
 if(typeof hohShowHeartToast==='function')hohShowHeartToast('Thanks for following','@framedfantasyart',true);
 },240);
 if(btn){
 btn.classList.add('hoh-rules-ig-btn-disabled');
 btn.setAttribute('aria-disabled','true');
 }
 /* Let the anchor open Instagram naturally — do not preventDefault. */
 return true;
};
/* On page load, if the user has ever claimed the bonus, grey out the
 IG button so they cannot try again. */
function hohSyncIgBtnInitial(){
 if(!hohIgEverClaimed())return;
 var btn=document.querySelector('.hoh-rules-ig-btn');
 if(!btn)return;
 btn.classList.add('hoh-rules-ig-btn-disabled');
 btn.setAttribute('aria-disabled','true');
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',hohSyncIgBtnInitial);}else{hohSyncIgBtnInitial();}

/* ===== Dice color customization =====
 Players choose from a small palette; selection persists across rolls.
 Stored as a class name (e.g. "blue") that maps to a CSS variable on
 the dice container. Default purple matches the original Satchel theme. */
var HOH_DICE_COLOR_KEY='hoh-dice-color-v1';
var HOH_DICE_COLORS=['purple','blue','green','crimson','gold','frost'];
function hohGetDiceColor(){try{var v=localStorage.getItem(HOH_DICE_COLOR_KEY);return HOH_DICE_COLORS.indexOf(v)>=0?v:'purple';}catch(e){return'purple';}}
function hohSetDiceColor(c){
 if(HOH_DICE_COLORS.indexOf(c)<0)return;
 try{localStorage.setItem(HOH_DICE_COLOR_KEY,c);}catch(e){}
 /* Apply the theme to the dice stage, the modal content (so border,
  buttons, and selectors theme together), and the modal wrapper itself
  for any descendant selectors that target the wrapper. */
 var stage=document.querySelector('.hoh-dice-stage');
 var content=document.querySelector('#hoh-dice-modal .hoh-pouch-modal-content');
 var modal=document.getElementById('hoh-dice-modal');
 [stage,content,modal].forEach(function(el){
 if(!el)return;
 HOH_DICE_COLORS.forEach(function(co){el.classList.remove('hoh-dice-c-'+co);});
 el.classList.add('hoh-dice-c-'+c);
 });
 var picks=document.querySelectorAll('.hoh-dice-color-pick');
 picks.forEach(function(p){p.classList.toggle('hoh-dice-color-pick-active',p.getAttribute('data-color')===c);});
}
window.hohSetDiceColor=hohSetDiceColor;
function getDailyHearts(){
 try{
 var raw=localStorage.getItem('hoh-hearts-daily');
 if(!raw)return{date:hohTodayStr(),count:0};
 var obj=JSON.parse(raw);
 if(obj.date!==hohTodayStr())return{date:hohTodayStr(),count:0};
 var count=typeof obj.count==='number'?obj.count:(Array.isArray(obj.ids)?obj.ids.length:0);
 return{date:obj.date,count:count};
 }catch(e){return{date:hohTodayStr(),count:0};}
}
function saveDailyHearts(obj){try{localStorage.setItem('hoh-hearts-daily',JSON.stringify(obj));}catch(e){}}
/* Heart BANK model. Hearts accumulate (no daily reset). Signed-in
 users do NOT get a daily handout — every heart in their bank is
 EARNED via quests, bounties, blessings, dice rolls, daily-claim
 hidden hearts, submitting a hero (+7), etc. The HOH_HEART_BASE
 constant (100) is the per-character daily SPEND CAP enforced by the
 server, NOT a daily grant. Loading the Hall or reading a wallet
 never grants hearts; existing balances and earned rewards remain. */
var HEART_BANK_KEY='hoh-heart-bank-v1';

/* ============================================================
   HEART LEDGER (R275) — fire-and-forget economy telemetry.
   One interceptor on localStorage.setItem watches the bank key and
   logs every real balance change to Supabase (insert-only table,
   nobody can read it from the browser). Call sites that know WHY a
   change is happening drop a one-shot hint just before mutating:
     window.hohHeartHint('spend_shop_pack', heroIdOptional)
   Unhinted changes still get logged as earn_other / spend_other by
   sign, so nothing escapes measurement. Signed-in accounts only, per
   Jan (July 5 2026): no email, no row. hohHeartHint('skip') marks a
   non-economy write (cap clamps, migrations) as not-a-transaction.
   Logging must never break the Hall: everything is try/caught.
   ============================================================ */
(function(){
  if(window.__ffHeartLedgerInstalled) return;
  window.__ffHeartLedgerInstalled = true;
  window.hohHeartHint = function(reason, heroId){
    window.__hohHeartHint = { reason: reason, heroId: heroId || null, exp: Date.now() + 2500 };
  };
  function takeHint(){
    var h = window.__hohHeartHint;
    window.__hohHeartHint = null;
    if(h && h.exp > Date.now()) return h;
    return null;
  }
  function accountEmail(){
    try{
      var em = (typeof window.hohYourHallEmail === 'function') ? window.hohYourHallEmail() : '';
      em = String(em || '').trim().toLowerCase();
      return (em && em.indexOf('@') > 0) ? em : '';
    }catch(e){ return ''; }
  }
  window.hohLogHeartEvent = function(delta, reason, heroId){
    try{
      delta = parseInt(delta, 10);
      /* R284: cap raised 500 -> 2000 in lockstep with the heart_events CHECK
         constraint. The old 500 silently dropped Battlegrounds pots of
         501..600 (POT_CAP is 600 in hoh-contract-data.js). Keep this number
         and the SQL constraint identical or big wins vanish from the ledger. */
      if(!delta || Math.abs(delta) > 2000) return;
      var em = accountEmail();
      if(!em) return;
      if(!reason) reason = delta > 0 ? 'earn_other' : 'spend_other';
      fetch(SUPABASE_URL.replace(/\/+$/,'') + '/rest/v1/heart_events', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'apikey': SUPABASE_ANON_KEY,
                   'Authorization': 'Bearer ' + SUPABASE_ANON_KEY, 'Prefer': 'return=minimal' },
        body: JSON.stringify({ account: em, delta: delta, reason: reason, hero_id: heroId || null })
      }).catch(function(){});
    }catch(e){}
  };
  try{
    var origSet = localStorage.setItem.bind(localStorage);
    localStorage.setItem = function(key, value){
      if(key === HEART_BANK_KEY){
        try{
          var before = parseInt(localStorage.getItem(HEART_BANK_KEY) || '0', 10) || 0;
          var after = parseInt(value, 10) || 0;
          var delta = after - before;
          if(delta !== 0){
            var hint = takeHint();
            if(!hint || hint.reason !== 'skip'){
              var reason = hint && hint.reason ? hint.reason : (delta > 0 ? 'earn_other' : 'spend_other');
              window.hohLogHeartEvent(delta, reason, hint && hint.heroId);
            }
          }
        }catch(e){}
      }
      return origSet(key, value);
    };
  }catch(e){}
})();

var HEART_ANON_STARTER_KEY='hoh-heart-anon-starter-v1';
/* Read signed-in state directly from localStorage so we don't depend
 on hoh-your-hall.js being loaded yet. The token shape was set by
 hoh-your-hall.js as { email, pin, savedAt } — same key we read from
 multiple other surfaces. Fail soft to false on parse errors. */
function hohIsSignedInRobust(){
 try {
  var raw=localStorage.getItem('hoh-your-hall-token');
  if(!raw)return false;
  var t=JSON.parse(raw);
  return !!(t && t.email && t.pin);
 } catch(_){ return false; }
}
/* Sanity ceiling for the heart bank. Any single user reaching
 9999 hearts via legitimate play would take many months of daily
 quests + bonuses. Anything above this almost certainly means
 someone edited localStorage directly in dev tools. We clamp on
 read AND on write — read clamps the displayed/spendable value,
 write clamps so a buggy grant can't push past the ceiling. The
 server-side per-character daily cap is the real defense; this
 just prevents trivial bank inflation via dev-tools edit. */
var HEART_BANK_MAX = 9999;
/* R135-B: Wallet read cache. getHeartBank() is called on every heart
   click, every hold-tick (~20/sec at peak), every recomputePageHearts,
   every paintPageHearts, every applyOutOfHeartsState, every
   canHeartToday gate. Each call did localStorage.getItem + parseInt,
   which is synchronous and forces a main-thread tick.
   The cache is invalidated on:
     - setHeartBank (any write through the chokepoint)
     - hoh:hearts-bumped event (cross-module wallet mutations)
     - storage events (other-tab writes)
   Reading the wallet never grants hearts. Wallet correctness is
   preserved because every earned reward or spend funnels through
   setHeartBank and updates the cache. */
var __hohBankCache = null;
function getHeartBank(){
 if(__hohBankCache !== null) return __hohBankCache;
 var raw = 0;
 try { raw = parseInt(localStorage.getItem(HEART_BANK_KEY)||'0',10) || 0; }
 catch(e){ __hohBankCache = 0; return 0; }
 if(raw < 0){ __hohBankCache = 0; return 0; }
 if(raw > HEART_BANK_MAX){
  /* Persisted value is over the ceiling. Clamp the persisted value
     too so the visible counter and the stored value stay in sync. */
  try { window.hohHeartHint && window.hohHeartHint('skip'); }catch(e){}
  try { localStorage.setItem(HEART_BANK_KEY, String(HEART_BANK_MAX)); } catch(e){}
  __hohBankCache = HEART_BANK_MAX;
  return HEART_BANK_MAX;
 }
 __hohBankCache = raw;
 return raw;
}
/* Single chokepoint for ALL bank writes. After persisting to
 localStorage, immediately refresh the visible counter pill
 (#hoh-tk-header) so spends, grants, and refunds all keep the
 visible number in sync with reality — no more stale counters
 after hidden-heart claims, ticket rewards, refunds, etc. */
function setHeartBank(n){
 var clamped = Math.max(0, Math.min(HEART_BANK_MAX, n));
 /* R135-B: Update cache synchronously to the clamped value we just
    persisted. Every read path will see the new value without
    touching localStorage again. */
 __hohBankCache = clamped;
 try{localStorage.setItem(HEART_BANK_KEY,String(clamped));}catch(e){}
 if(typeof window.hohRenderHeaderCounter==='function'){
  try{window.hohRenderHeaderCounter();}catch(e){}
 }
}
/* R135-B: Cross-tab + cross-module cache invalidation. */
try {
 window.addEventListener('storage', function(e){
  if(e && e.key === HEART_BANK_KEY){ __hohBankCache = null; }
 });
} catch(e){}
try {
 document.addEventListener('hoh:hearts-bumped', function(){ __hohBankCache = null; });
} catch(e){}
function heartsRemainingToday(){return getHeartBank();}
window.heartsRemainingToday=heartsRemainingToday;
window.hohAddHeartsToBank=function(n,reason){
 if(!n||n<=0)return;
 /* R280 ledger attribution. An explicit reason wins. Otherwise, if the specific
    call site already set a fresh hint, keep it; if not, default to a real
    category so the action log never shows "Uncategorized" again. Pure telemetry,
    fire-and-forget, does not change how many hearts are granted. */
 try{
   if(window.hohHeartHint){
     var _pend=window.__hohHeartHint;
     if(reason)window.hohHeartHint(reason);
     else if(!(_pend&&_pend.exp>Date.now()))window.hohHeartHint('earn_hall_reward');
   }
 }catch(_e){}
 setHeartBank(getHeartBank()+n);
 /* Notify same-tab listeners (storage event only fires across tabs)
    so surfaces like Fresh Faces' page-hearts counter and auto-bar
    can react to the wallet bump immediately. */
 try { document.dispatchEvent(new CustomEvent('hoh:hearts-bumped', { detail: { added: n } })); } catch(_){}
};
/* R57: Bank decrement for guess-event penalties. Distinct from
   recordDailyHeart() (which counts toward the wander quest) — losing
   a guess should NOT bump the daily heart count. We just shrink the
   wallet so the user feels the cost. Returns the number actually
   removed (capped by current bank so we never go negative). */
window.hohRemoveHeartsFromBank=function(n,reason){
 if(!n||n<=0)return 0;
 var have=getHeartBank();
 var take=Math.min(n,have);
 if(take<=0)return 0;
 /* R281: attribute the spend. Explicit reason wins; else if no fresh hint is
    pending, default to a real category so nothing logs as "Uncategorized". */
 try{
   if(window.hohHeartHint){
     var _pd=window.__hohHeartHint;
     if(reason)window.hohHeartHint(reason);
     else if(!(_pd&&_pd.exp>Date.now()))window.hohHeartHint('spend_penalty');
   }
 }catch(_e){}
 setHeartBank(have-take);
 try { document.dispatchEvent(new CustomEvent('hoh:hearts-bumped', { detail: { spent: take, penalty: true } })); } catch(_){}
 return take;
};
/* R134-A: Wallet is the absolute heart gate. Removed the god-mode
   bypass that previously let Jangela heart infinitely at 0 wallet —
   user reported "I have 0 hearts but the detail modal still
   registers hearts." God-mode is intended for editing / admin
   surfaces (image reframe, hide/unhide, debug buttons), NOT for
   unlimited heart-spending. The wallet pill is the source of truth;
   if it shows 0, every heart-give path bails with the Out of Hearts
   toast across main grid, detail modal, Fresh Faces, themed phases,
   stream events. */
function canHeartToday(){return heartsRemainingToday()>0;}
function recordDailyHeart(heroId){
 /* R280: the main "give a heart to a hero" action. Categorize it so the log
    and by-source chart show hearting, not "Uncategorized spends".
    R282: callers now pass the hero's id so the Data Hub action log can say
    WHICH hero was hearted ("spent Hearts given to heroes · Thrain"). The id
    rides the existing fire-and-forget hint, so this costs nothing at click
    time. No id (defensive) still logs a plain spend_heart. */
 try{ if(window.hohHeartHint) window.hohHeartHint('spend_heart', heroId||null); }catch(_){}
 setHeartBank(getHeartBank()-1);
 var d=getDailyHearts();
 d.count=(d.count||0)+1;
 saveDailyHearts(d);
 /* Notify same-tab listeners that the wallet just shrank. The
    storage event only fires across tabs, so without this, surfaces
    like Fresh Faces' page-hearts chip, auto-bar pause, and refresh-
    icon lock wouldn't update until the next render. The bridge
    reuses the same hoh:hearts-bumped event the bank-add path
    dispatches; listeners read the live wallet themselves so they
    handle both add and subtract. */
 try { document.dispatchEvent(new CustomEvent('hoh:hearts-bumped', { detail: { spent: 1 } })); } catch(_){}
}

var hohToastTimer=null;
/* ==================== R247: quest-hero claim discovery ====================
   Typing an email into ADD YOUR HERO that already owns quest-forged heroes
   surfaces them side by side with the in-progress submission, so players
   claim instead of duplicating. Claim opens the existing Your Hall claim
   modal for that hero (email + PIN), after which it is editable and lives
   in their profile; adding an image sends it to review (R245). New
   submissions only — never fires in edit mode. Inline-styled so no
   stylesheet vintage can break it. */
async function hohScanClaimable(raw){
  if(hohQuestHandoff)return;
  var box=document.getElementById('hoh-claim-scan');
  if(!box) return;
  var em=String(raw||'').trim().toLowerCase();
  if(!em || em.indexOf('@')===-1 || window.hohEditingCharacterId){ box.innerHTML=''; box.__lastEm=''; return; }
  if(box.__lastEm===em) return;
  box.__lastEm=em;
  var res=null;
  try{
    res=await supabase.from('characters')
      .select('id,name,race,character_class,email,auth_email,image_url,image_thumb_url,is_hidden,quest_meta')
      .or('auth_email.eq.'+em+',email.eq.'+em)
      .limit(8);
  }catch(_){ return; }
  if(!res||res.error||!Array.isArray(res.data)) return;
  var mine=res.data.filter(function(c){
    var qm=(c&&c.quest_meta)||{};
    return c && (qm.from_quest===true||qm.from_quest==='true'||qm.source==='iron-matron');
  });
  /* R384 (Jan): the scan now also catches REGULAR heroes under this email
     while the visitor is signed out — a returning player on a new device.
     One quiet notice, a PIN, and their old heroes link to this submission
     through the existing verify + session path. Quest-forged heroes keep
     their claim tiles below, untouched. */
  try {
    var others=res.data.filter(function(c){
      var qm=(c&&c.quest_meta)||{};
      return c && !(qm.from_quest===true||qm.from_quest==='true'||qm.source==='iron-matron');
    });
    var signedAs='';
    try { var tk=JSON.parse(localStorage.getItem('hoh-your-hall-token')||'null'); signedAs=(tk&&tk.email)?String(tk.email).toLowerCase():''; } catch(_){}
    var syncBox=document.getElementById('hoh-claim-sync');
    if(!syncBox){
      syncBox=document.createElement('div');
      syncBox.id='hoh-claim-sync';
      box.parentNode.insertBefore(syncBox, box);
    }
    if(others.length && signedAs!==em){
      var n=others.length;
      syncBox.innerHTML=
        '<div style="margin:10px 0 4px;padding:12px 14px;border:1px solid rgba(232,201,122,.45);border-radius:10px;background:rgba(232,201,122,.05)">'
        +'<div style="font-family:\'Cinzel\',serif;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#e8c97a;margin-bottom:6px;text-align:center">'+n+(n===1?' hero already lives':' heroes already live')+' under this email</div>'
        +'<div style="font-size:12.5px;color:#a09aae;text-align:center;margin-bottom:10px">Enter your Hall PIN to link them with this submission.</div>'
        +'<div style="display:flex;gap:8px;justify-content:center;align-items:center;flex-wrap:wrap">'
        +'<input type="text" inputmode="numeric" pattern="[0-9]{4}" maxlength="4" id="hoh-claim-sync-pin" autocomplete="off" placeholder="1234" style="box-sizing:border-box;width:96px;min-height:44px;text-align:center;letter-spacing:.3em;font-size:16px;border-radius:9px;border:1px solid rgba(200,164,94,.4);background:rgba(14,11,20,.85);color:#e8e2f2">'
        +'<button type="button" id="hoh-claim-sync-go" style="cursor:pointer;font-family:\'Cinzel\',serif;font-size:10.5px;letter-spacing:.08em;text-transform:uppercase;color:#1a1108;background:linear-gradient(120deg,#f2d98e,#c8a45e);border:none;border-radius:999px;padding:12px 20px;min-height:44px">Link my heroes</button>'
        +'</div>'
        +'<div id="hoh-claim-sync-err" style="display:none;font-size:12px;color:#e08a8a;text-align:center;margin-top:8px">That PIN does not match. Try again.</div>'
        +'</div>';
      var goBtn=document.getElementById('hoh-claim-sync-go');
      if(goBtn && !goBtn.__wired){
        goBtn.__wired=1;
        goBtn.addEventListener('click', function(){
          var pv=((document.getElementById('hoh-claim-sync-pin')||{}).value||'').trim();
          var errEl=document.getElementById('hoh-claim-sync-err');
          if(!/^\d{4}$/.test(pv)){ if(errEl){errEl.style.display='';errEl.textContent='Enter your 4 digit PIN.';} return; }
          goBtn.disabled=true;
          supabase.rpc('verify_pin',{user_email:em,user_pin:pv}).then(function(r){
            goBtn.disabled=false;
            var okN=(r&&typeof r.data==='number')?r.data:0;
            if(!okN){ if(errEl){errEl.style.display='';errEl.textContent='That PIN does not match. Try again.';} return; }
            try { if(window.hohYourHallSetSession) window.hohYourHallSetSession(em,pv); } catch(_){}
            syncBox.innerHTML=
              '<div style="margin:10px 0 4px;padding:12px 14px;border:1px solid rgba(126,212,154,.5);border-radius:10px;background:rgba(126,212,154,.06);text-align:center">'
              +'<div style="font-family:\'Cinzel\',serif;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#8ee0a8">Linked. You are signed in.</div>'
              +'<div style="font-size:12px;color:#a09aae;margin-top:5px">This hero will join the others in your hall.</div>'
              +'</div>';
            /* the form is open mid-fill: hide the now-redundant PIN field */
            try {
              var pe=document.getElementById('hoh-f-pin');
              var pf=pe&&pe.closest?pe.closest('.hoh-field'):null;
              if(pf) pf.style.display='none';
            } catch(_){}
            try { if(typeof window.hohShowHeartToast==='function') window.hohShowHeartToast('Heroes linked','Signed in as '+em+'.'); } catch(_){}
          },function(){ goBtn.disabled=false; if(errEl){errEl.style.display='';errEl.textContent='Could not check right now. Try again.';} });
        });
      }
    } else {
      syncBox.innerHTML='';
    }
  } catch(_){}
  if(!mine.length){ box.innerHTML=''; return; }
  var typed=((document.getElementById('hoh-f-name')||{}).value||'').trim();
  function esc2(s){ var d=document.createElement('div'); d.textContent=(s==null?'':s); return d.innerHTML; }
  function tile(c){
    var img=c.image_thumb_url||c.image_url||'';
    var art=img
      ?('<img src="'+esc2(img)+'" alt="" style="width:100%;height:86px;object-fit:cover;border-radius:8px 8px 0 0;display:block">')
      :('<div style="width:100%;height:86px;display:flex;align-items:center;justify-content:center;font-family:\'Cinzel\',serif;font-size:30px;color:#c8a45e;background:#1c1528;border-radius:8px 8px 0 0">'+esc2((c.name||'?').charAt(0).toUpperCase())+'</div>');
    return '<div style="flex:1 1 150px;max-width:190px;border:1px solid rgba(200,164,94,.45);border-radius:9px;background:#14101e;overflow:hidden;text-align:center">'
      +art
      +'<div style="padding:8px 8px 10px">'
      +'<div style="font-family:\'Cinzel\',serif;font-weight:700;font-size:12.5px;color:#f2d98e;line-height:1.2">'+esc2(c.name||'Hero')+'</div>'
      +'<div style="font-size:11px;color:#a09aae;margin:3px 0 '+(c.is_hidden?'3px':'8px')+'">'+esc2([c.race,c.character_class].filter(Boolean).join(' · '))+'</div>'
      +(c.is_hidden?'<div style="font-size:10px;color:#8a90a0;font-style:italic;margin-bottom:8px">not public yet — add an image and it goes to review</div>':'')
      +'<button type="button" data-hoh-claim="'+esc2(String(c.id))+'" style="cursor:pointer;font-family:\'Cinzel\',serif;font-size:10px;letter-spacing:.08em;text-transform:uppercase;color:#1a1108;background:linear-gradient(120deg,#f2d98e,#c8a45e);border:none;border-radius:8px;padding:7px 12px">Claim &amp; edit</button>'
      +'</div></div>';
  }
  box.innerHTML=
    '<div style="margin:10px 0 4px;padding:12px;border:1px solid rgba(126,212,154,.5);border-radius:10px;background:rgba(126,212,154,.06)">'
    +'<div style="font-family:\'Cinzel\',serif;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#8ee0a8;margin-bottom:9px;text-align:center">The quest already forged '+(mine.length===1?'a hero':'heroes')+' for this email</div>'
    +'<div style="display:flex;gap:10px;flex-wrap:wrap;align-items:stretch;justify-content:center">'
    +mine.slice(0,3).map(tile).join('')
    +'<div style="flex:0 0 auto;display:flex;align-items:center;font-family:\'Cinzel\',serif;font-size:11px;color:#6a6478">vs</div>'
    +'<div style="flex:1 1 150px;max-width:190px;border:1px dashed rgba(160,154,174,.5);border-radius:9px;background:rgba(160,154,174,.04);display:flex;flex-direction:column;align-items:center;justify-content:center;padding:14px 8px;text-align:center">'
      +'<div style="font-family:\'Cinzel\',serif;font-weight:700;font-size:12.5px;color:#e8e0d0">'+esc2(typed||'Your new hero')+'</div>'
      +'<div style="font-size:11px;color:#a09aae;margin-top:3px">the one you\'re adding now</div>'
    +'</div>'
    +'</div>'
    +'<p style="font-size:12px;color:#a09aae;font-style:italic;margin:10px 0 0;text-align:center">Claiming signs you in and opens your quest hero to edit — it shows in your profile, and adding an image sends it to review. Or keep going below to add this brand-new hero too.</p>'
    +'</div>';
  box.querySelectorAll('[data-hoh-claim]').forEach(function(b){
    b.addEventListener('click', function(){
      var id=b.getAttribute('data-hoh-claim'), hero=null;
      for(var j=0;j<mine.length;j++){ if(String(mine[j].id)===String(id)) hero=mine[j]; }
      if(hero && typeof window.hohOpenClaimCharacter==='function'){ window.hohOpenClaimCharacter(hero); }
      else if(typeof window.hohOpenDetail==='function'){ window.hohOpenDetail(id); }
    });
  });
}
document.addEventListener('focusout', function(e){
  if(e.target && e.target.id==='hoh-f-email') hohScanClaimable(e.target.value);
});
/* R250: deploy-safe UX rules injected over whatever stylesheet vintage is
   live. Mobile detail modal: vertical-only touch (no sideways wander, no
   pinch chaos), contained overscroll, sized to the DYNAMIC viewport so
   the bottom is actually reachable under iOS Safari's collapsing bar,
   safe-area padding so the last row clears the browser chrome. Plus the
   hub pills centered (the live css lacks the repo's justify-content). */
(function(){
  if(document.getElementById('hoh-r250-css')) return;
  var st=document.createElement('style'); st.id='hoh-r250-css';
  st.textContent=
    '.hoh-yh-subtabs{justify-content:center !important}'+
    '@media (max-width:820px){'+
      '#hoh-modal{touch-action:pan-y}'+
      /* The shared viewport-modal layer now owns the live lightbox sizing.
         Keep this older fallback only for a detail modal that has not yet
         been promoted, otherwise its !important max-height can overrun the
         safe bottom inset on iOS. */
      '#hoh-modal:not(.hoh-viewport-modal) .hoh-modal-content{'+
        'touch-action:pan-y;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;'+
        'overflow-x:hidden;'+
        'max-height:calc(100dvh - 10px) !important;'+
        'padding-bottom:calc(30px + env(safe-area-inset-bottom,0px)) !important;'+
      '}'+
      '#hoh-modal .hoh-detail-img img{touch-action:pan-y}'+
    '}'+
    /* R257: submitter ticket-incentive chrome. The two DM-section ticket
       rewards stay visible on a first submission; they are the reason to
       open those optional rows. The FF bonus and legacy required stars keep
       their quieter returning-submitter treatment. */
    '.hoh-req-star{color:#e8c97a;margin-left:3px;font-weight:700}'+
    '.hoh-req-legend{font-family:\'Cormorant Garamond\',Georgia,serif;font-style:italic;'+
      'font-size:12.5px;color:#8a90a0;margin:4px 0 10px;line-height:1.4}'+
    '.hoh-first-run .hoh-ff-toggle-reward,.hoh-first-run .hoh-req-star{display:none !important}'+
    /* R259: the NEW corner whisper (grid) + name chip (detail), 3-day window */
    '.hoh-newtag{position:absolute;top:8px;left:8px;z-index:3;display:inline-flex;align-items:center;gap:5px;'+
      'padding:3px 8px;border-radius:999px;background:rgba(10,8,16,.72);border:1px solid rgba(242,217,142,.38);'+
      '-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);pointer-events:none}'+
    '.hoh-newtag i{width:4px;height:4px;border-radius:50%;background:#f2d98e;'+
      'box-shadow:0 0 6px rgba(242,217,142,.9);animation:hohNewBreathe 2.6s ease-in-out infinite}'+
    '.hoh-newtag b{font-family:\'Cinzel\',serif;font-weight:600;font-size:8px;letter-spacing:.3em;'+
      'color:#f2d98e;text-transform:uppercase;transform:translateX(1px)}'+
    '@keyframes hohNewBreathe{0%,100%{opacity:.55}50%{opacity:1}}'+
    '@media (prefers-reduced-motion: reduce){.hoh-newtag i{animation:none}}'+
    /* R444: was {position:static;margin-left:10px} to sit inline beside the
       name. It sits on the art now, so it goes back to absolute and simply
       inherits the base rule's corner. Bigger than the grid version on
       purpose: the detail image is several times the size of a card tile, and
       the 8px inset that reads as a neat corner whisper on a 150px tile reads
       as debris on a 380px one. 14px inset, roomier chip, one step up in type. */
    '.hoh-newtag-detail{top:14px;left:14px;padding:5px 12px;gap:6px}'+
    '.hoh-newtag-detail b{font-size:9.5px;letter-spacing:.28em}'+
    '.hoh-newtag-detail i{width:5px;height:5px}'+
    '@media(max-width:600px){.hoh-newtag-detail{top:11px;left:11px;padding:4px 10px}'+
      '.hoh-newtag-detail b{font-size:9px}}';
  (document.head||document.documentElement).appendChild(st);
})();
/* R250: the "Hearted by you" view only exists once the viewer has hearted
   something — before that it is an empty promise in the dropdown. The
   option returns the moment their first heart lands. */
var _hohLikedOpt = null;
function hohSyncLikedOption(){
  try{
    var sel=document.getElementById('hoh-sort'); if(!sel) return;
    var has=false;
    /* R793: in the live Hall the list is the account's favourites from the
       server, never the device's old heart map.
       R793.1 (Jan): "have a filter called favorited". It is there for every
       signed-in player from the start, not only after a first favourite (an
       empty list says how to add one), and never for a signed-out visitor.
       R793.1 fix: the live rule holds from the first paint, before the
       doors have answered (hohR793Words). Read through window, as the old
       check was, so the function still stands on its own (r667 runs it
       sliced out of this file). */
    if(typeof window.hohR793Words==='function' && window.hohR793Words()){
      try{ has=(typeof window.hohIsHallSignedIn==='function') && !!window.hohIsHallSignedIn(); }catch(_){}
    } else {
      try{ var hm=getHeartMap(); for(var k in hm){ if((hm[k]|0)>0){ has=true; break; } } }catch(_){}
    }
    var op=sel.querySelector('option[value="liked"]');
    if(!has && op){
      _hohLikedOpt=op;
      /* R667: falls back to the default sort, which is Most hearts for
         everybody now, not Newest. */
      if(sel.value==='liked') sel.value='most';
      op.remove();
      try{ if(typeof hohResizeSort==='function') hohResizeSort(); }catch(_){}
    } else if(has && !op && _hohLikedOpt){
      var nw=sel.querySelector('option[value="newest"]');
      sel.insertBefore(_hohLikedOpt, nw||null);
    }
  }catch(_){}
}
window.hohSyncLikedOption=hohSyncLikedOption;
/* R249: first-time visitors browse by NEWEST and get no personal Hidden
   view. The signed-in default stays Most hearts. All deferred scripts run
   before DOMContentLoaded, so hohIsHallSignedIn exists here.
   R667 (Jan): "make the default sort by highest hearts instead of new even
   on new accounts." So the signed-out downgrade below is GONE and Most
   hearts is now the one default for everybody. The markup has always
   shipped <option value="most" selected>, so this line was the only thing
   moving a brand new visitor off it, which is why the dropdown said Most
   hearts in the source and read Newest on the screen. Every fallback in
   this file that used to land on 'newest' when an option is removed now
   lands on 'most' as well, so a viewer never gets dropped onto a sort
   nobody chose. */
document.addEventListener('DOMContentLoaded', function(){
  try{
    try{ hohSyncLikedOption(); }catch(_){}
    var sel = document.getElementById('hoh-sort');
    if(!sel) return;
    /* R318: the 'hidden' (debug) option only belongs to god mode. It exposes the
       server review pool of not-yet-public heroes, so it must never be selectable
       by the public, signed in or not. 'mine_hidden' (Hidden by me) stays for
       everyone — it is just their own local dismiss list. */
    var _godNow = (typeof window.hohIsGodMode==='function') && window.hohIsGodMode();
    if(!_godNow){
      var opDbg = sel.querySelector('option[value="hidden"]');
      if(opDbg) opDbg.remove();
      if(sel.value==='hidden') sel.value='most';
    }
    /* HALLHERO (Jan, 2026-09-23): "remove the hidden by me filter". The
       markup no longer ships 'mine_hidden'; a cached copy of the old markup
       loses it here, and a saved or restored value lands on Rarity. Heroes a
       player hid in Explore stay recoverable: the quiet "Show them" line at the
       end of the grid (hohRenderHiddenReset) and the Undo right after a hide. */
    var opMine = sel.querySelector('option[value="mine_hidden"]');
    if(opMine) opMine.remove();
    if(sel.value==='mine_hidden') sel.value='most';
    /* R793.1 (Jan): "dont do fewest legacy hearts just remove that filter".
       The markup no longer ships it; a cached copy of the old markup loses
       it here too. */
    var opLeast = sel.querySelector('option[value="least"]');
    if(opLeast) opLeast.remove();
    if(sel.value==='least') sel.value='most';
    /* R793: the live Hall's labels (R793.1: Rarity, Favorited). */
    try{ hohR793RelabelSort(); }catch(_){}
    try{ if(typeof hohResizeSort==='function') hohResizeSort(); }catch(_){}
  }catch(_){}
});
function hohShowHeartToast(title,sub,earn){
 /* R793: the live Hall has no heart wallet on screen, so "+N hearts" earn
    toasts (hidden hearts, blessings, the crown and friends) announce a
    balance nobody can see. They go quiet there. Every other toast, and every
    toast in legacy mode, is untouched.
    HEARTCOPY (Jan, 2026-09-30: "dont say they get +X hearts"): those toasts
    no longer name a count, so they say what they are with earn===true and
    stay exactly as quiet in the live Hall as before. */
 if((earn===true || /^\s*\+\s*\d+\s+hearts?\b/i.test(String(title||''))) && typeof window.hohR793Live==='function' && window.hohR793Live()) return;
 var existing=document.getElementById('hoh-heart-toast');
 if(existing)existing.remove();
 var toast=document.createElement('div');
 toast.id='hoh-heart-toast';
 toast.className='hoh-heart-toast';
 /* R244: the stylesheet z (99999) sits UNDER the pack modal (100070) and
    the badge picker (100082), so claim/dust toasts fired while those are
    open were invisible. Inline wins over any deployed css vintage. */
 toast.style.zIndex='100095';
 toast.innerHTML='<div class="hoh-heart-toast-title">'+title+'</div><div class="hoh-heart-toast-sub">'+sub+'</div>';
 document.body.appendChild(toast);
 requestAnimationFrame(function(){toast.classList.add('hoh-heart-toast-visible');});
 clearTimeout(hohToastTimer);
 hohToastTimer=setTimeout(function(){
 toast.classList.remove('hoh-heart-toast-visible');
 setTimeout(function(){toast.remove();},300);
 },3200);
}
/* BUG-9 (2026-08-06): this function was never put on window, so every
   cross-file call site (hoh-shop, hoh-tickets, hoh-your-hall, hoh-extras,
   hoh-fresh-faces, hoh-earn-tickets — 160+ of them, all typeof-guarded)
   has been a silent no-op since the day it was written. Confirmations like
   "+10 hearts / Welcome back" simply never showed. One assignment restores
   every one of them. The function itself is single-instance (it removes the
   previous toast first), so restoring it cannot stack or spam. */
window.hohShowHeartToast=hohShowHeartToast;

/* A heart given to a hero pops on the button it was given from. Jan,
 2026-09-27: hearts no longer fly out of the wallet pill (the live Hall hides
 that pill, so the throw started in the top-left corner). hohHeartBurst
 (hoh-wallet.js) keeps the snapshot fallback: a caller such as Fresh Faces
 quick-heart stashes el.__hohRectSnap before async work can detach the
 button. heartNumber stays for the callers; count (optional) is how many
 hearts one give carried, so a multi-give is one burst, not a volley. */
function hohThrowHeartAt(targetEl,heartNumber,count){
 if(!targetEl||typeof window.hohHeartBurst!=='function')return;
 window.hohHeartBurst(targetEl,{n:count||1});
}

/* Pulse the pill to announce that hearts were just granted. Called on the
 submission bonus path and on any future day-reset refresh.
 Jan, 2026-09-27: the "+N" bubble that floated over the pill is gone with
 the wallet flights. The live Hall hides the pill, so the bubble rose from
 the top-left corner; the hearts now pop where they were found
 (hohHeartBurst). grantedCount stays for the callers. */
function hohRefillHeartsAnimation(grantedCount,isBonus){
 /* Prefer the visible bottom-corner ticket pill (#hoh-tk-header). */
 var pill=document.getElementById('hoh-tk-header')||document.getElementById('hoh-heart-remaining');
 if(!pill)return;
 pill.classList.remove('hoh-heart-refill-pulse','hoh-heart-refill-pulse-bonus');
 void pill.offsetWidth;
 /* classList.add doesn't accept space-separated tokens — that throws
    InvalidCharacterError. Pass each class as its own argument. */
 pill.classList.add('hoh-heart-refill-pulse');
 if(isBonus) pill.classList.add('hoh-heart-refill-pulse-bonus');
 setTimeout(function(){pill.classList.remove('hoh-heart-refill-pulse','hoh-heart-refill-pulse-bonus');},1300);
}
window.hohRefillHeartsAnimation=hohRefillHeartsAnimation;
window.hohSetHeartBankBalance=function(n){
 if(!Number.isFinite(Number(n)))return;
 setHeartBank(Number(n));
 try { document.dispatchEvent(new CustomEvent('hoh:hearts-bumped', { detail: { balance: Number(n) } })); } catch(_){}
};

/* Small text under the counter showing when hearts refill. Updates on a
 60-second cadence — seconds are not worth rerendering for this. */
function hohFormatRefillIn(){
 var now=new Date();
 var midnight=new Date(now);
 midnight.setHours(24,0,0,0);
 var diffMin=Math.max(0,Math.floor((midnight-now)/60000));
 var h=Math.floor(diffMin/60);
 var m=diffMin%60;
 if(h<=0)return'Refills in '+m+'m';
 return'Refills in '+h+'h '+m+'m';
}
function hohUpdateHeartTimer(){
 var el=document.getElementById('hoh-heart-timer');
 if(!el)return;
 el.textContent=hohFormatRefillIn();
}
var hohHeartTimerInterval=null;
function hohStartHeartTimer(){
 if(hohHeartTimerInterval)return;
 hohUpdateHeartTimer();
 hohHeartTimerInterval=setInterval(hohUpdateHeartTimer,60000);
}

/* Seconds-resolution countdown for the final phase, formatted as
 Hh Mm Ss so it reads at a glance and always takes the same visual
 width (leading zeros on minutes and seconds). */
function hohFormatRefillCountdown(){
 var now=new Date();
 var midnight=new Date(now);
 midnight.setHours(24,0,0,0);
 var total=Math.max(0,Math.floor((midnight-now)/1000));
 var h=Math.floor(total/3600);
 var m=Math.floor((total%3600)/60);
 var s=total%60;
 function pad(n){return n<10?'0'+n:String(n);}
 if(h>0)return h+'h '+pad(m)+'m '+pad(s)+'s';
 if(m>0)return m+'m '+pad(s)+'s';
 return s+'s';
}
var hohSecondTimerInterval=null;
function hohStartSecondTimer(){
 if(hohSecondTimerInterval)return;
 hohSecondTimerInterval=setInterval(function(){
  if(document.hidden)return; /* PERF-6: no countdown work in a hidden tab */
  var el=document.getElementById('hoh-heart-timer');
  if(!el)return;
  el.textContent=hohFormatRefillCountdown();
  /* At midnight the timer hits zero. Re-render the pill so a fresh
   day's hearts are reflected immediately rather than waiting for the
   next user action. */
  if(el.textContent==='0s'){
   setTimeout(hohUpdateHeartCounter,1100);
  }
 },1000);
}
function hohStopSecondTimer(){if(hohSecondTimerInterval){clearInterval(hohSecondTimerInterval);hohSecondTimerInterval=null;}}

/* Heart counter pill.  Four progressive phases:
   1  idle          hearts remaining, show count
   2  form nudge    base spent, no submission bonus yet
   3  coin mystery  bonus spent, Trial not unlocked today
   4  final         all paths tapped, live countdown with seconds
 No "X of Y" phrasing anywhere. Each phase communicates the single next
 action the user can take. Layout shell is the same across phases so the
 pill never jumps sizes when copy changes. */
function hohUpdateHeartCounter(){
 var remaining=heartsRemainingToday();
 var bonus=hohHeartsBonusActive();
 var trial=typeof hohTrialUnlockedToday==='function'?hohTrialUnlockedToday():false;
 var el=document.getElementById('hoh-heart-remaining');
 if(!el){
 el=document.createElement('div');
 el.id='hoh-heart-remaining';
 el.className='hoh-heart-remaining';
 document.body.appendChild(el);
 }
 el.classList.remove('hoh-heart-remaining-bonus','hoh-heart-remaining-cta','hoh-heart-remaining-mystery','hoh-heart-remaining-idle','hoh-heart-remaining-final');
 el.onclick=null;
 el.style.cursor='default';
 el.style.pointerEvents='none';
 hohStopSecondTimer();
 if(hohHeartTimerInterval){clearInterval(hohHeartTimerInterval);hohHeartTimerInterval=null;}
 if(remaining>0){
 el.classList.add('hoh-heart-remaining-idle');
 if(bonus)el.classList.add('hoh-heart-remaining-bonus');
 el.innerHTML='<span class="hoh-heart-remaining-icon">&#9829;&#xFE0E;</span>'+
  '<span class="hoh-heart-remaining-main">'+
   '<span class="hoh-heart-remaining-top"><strong>'+remaining+'</strong> heart'+(remaining===1?'':'s')+'</span>'+
   '<span class="hoh-heart-remaining-sub">to spend today</span>'+
  '</span>';
 } else if(!bonus){
 el.classList.add('hoh-heart-remaining-cta');
 el.style.cursor='pointer';
 el.style.pointerEvents='auto';
 el.onclick=function(){if(typeof hohOpenForm==='function')hohOpenForm();};
 el.innerHTML='<span class="hoh-heart-remaining-icon">&#9998;&#xFE0E;</span>'+
  '<span class="hoh-heart-remaining-main">'+
   '<span class="hoh-heart-remaining-top"><strong>Summon a hero</strong></span>'+
   '<span class="hoh-heart-remaining-sub">Add yours to the Hall &rarr;</span>'+
  '</span>';
 } else if(getDailyHearts().count<30){
 el.classList.add('hoh-heart-remaining-cta');
 el.style.cursor='pointer';
 el.style.pointerEvents='auto';
 el.onclick=function(){hohOpenRules();};
 el.innerHTML='<span class="hoh-heart-remaining-icon">&#10022;&#xFE0E;</span>'+
  '<span class="hoh-heart-remaining-main">'+
   '<span class="hoh-heart-remaining-top"><strong>Want more hearts?</strong></span>'+
   '<span class="hoh-heart-remaining-sub">See how to find them &rarr;</span>'+
  '</span>';
 } else {
 el.classList.add('hoh-heart-remaining-final');
 el.innerHTML='<span class="hoh-heart-remaining-icon">&#9202;&#xFE0E;</span>'+
  '<span class="hoh-heart-remaining-main">'+
   '<span class="hoh-heart-remaining-top">Hearts refill at midnight</span>'+
   '<span class="hoh-heart-remaining-sub" id="hoh-heart-timer">'+hohFormatRefillCountdown()+'</span>'+
  '</span>';
 hohStartSecondTimer();
 }
}
/* Show heart counter for 4s after a heart action, then auto-hide. */
var hohHcTimer=null;
function hohShowHeartCounter(){hohUpdateHeartCounter();var el=document.getElementById('hoh-heart-remaining');if(!el)return;if(hohHcTimer)clearTimeout(hohHcTimer);requestAnimationFrame(function(){el.classList.add('hoh-heart-visible');});hohHcTimer=setTimeout(function(){el.classList.remove('hoh-heart-visible');hohHcTimer=null;},4000);}
function esc(s){if(!s)return'';var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
window.esc=esc;
/* Image fallback: swap broken portrait URLs for a letter placeholder.
   When an image fails to load (404 from storage CDN, CORS rejection
   because crossorigin=anonymous can\'t get an ACAO header back, or
   any network error), the browser fires onerror and we run this.
   Until R42 we always inserted a <div class="hoh-card-letter">, but
   that class only styles color/font — no width/height/centering. It
   renders correctly inside the legacy .hoh-card-img wrapper (which
   sizes its children via flex/aspect-ratio) but invisibly inside
   .hoh-fresh-media (which expects a child with intrinsic sizing).
   The Fresh Faces / event / detail-modal cards use .hoh-fresh-media
   wrappers, which is why broken portraits there showed as totally
   empty cards instead of falling back to a letter.
   The fix: detect the parent\'s class and pick the matching letter
   class (.hoh-fresh-letter for fresh-media, .hoh-card-letter for
   legacy). Layer inline sizing styles as a safety net so even if a
   future class doesn\'t exist yet, the placeholder still fills the
   parent and centers the letter. */
window.hohImgFallback=function(img,letterClass){
 if(!img)return;
 img.onerror=null;
 var letter=img.getAttribute('data-letter')||'?';
 var fb=document.createElement('div');
 /* Pick the right letter class for the wrapper, with explicit
    fallback if the caller passed one. */
 if(!letterClass){
  var parent=img.parentNode;
  var pcls=parent && parent.className ? String(parent.className) : '';
  if(pcls.indexOf('hoh-fresh-media')!==-1) letterClass='hoh-fresh-letter';
  else if(pcls.indexOf('hoh-detail-img')!==-1 || pcls.indexOf('hoh-modal-img')!==-1) letterClass='hoh-fresh-letter';
  else letterClass='hoh-card-letter';
 }
 fb.className=letterClass;
 fb.textContent=letter;
 /* Safety net inline styles — even if the chosen class is missing or
    overridden, the placeholder still fills the parent and centers
    the letter. Without these, a broken image inside a wrapper that
    relies on a child\'s intrinsic sizing would render as invisible
    blank space (the original Fresh Faces bug). */
 fb.style.width='100%';
 fb.style.height='100%';
 fb.style.display='flex';
 fb.style.alignItems='center';
 fb.style.justifyContent='center';
 fb.style.fontFamily="'Cinzel',serif";
 fb.style.fontSize='48px';
 fb.style.color='rgba(200,164,94,0.4)';
 if(img.parentNode)img.parentNode.replaceChild(fb,img);
 /* Optional debug breadcrumb so the broken URL is recoverable from
    the console. Helps the site owner identify which character\'s
    portrait file is missing on the CDN. */
 try {
  if(window.console && console.warn) console.warn('[hoh] portrait failed to load:', img.src || '(empty)');
 } catch(_){}
};
function isStandardRace(r){return RACES.indexOf(r)!==-1;}
function isStandardClass(c){return CLASSES.indexOf(c)!==-1;}

function hohRenderHeaderTicker(){/* Ticker DOM removed in the new layout — Fresh Faces replaces it. Kept as a no-op so legacy callers don't crash. */}

/* HALL-SPEED-02: the light roster (HOH_LIGHT_COLS), in the full roster's order. The first two pages go out together;
   any refusal or error means no early paint, and the full roster comes as it always did. */
async function hohLoadLightRoster(){
 var signedIn=false;
 try{ signedIn=(typeof window.hohIsHallSignedIn==='function')&&!!window.hohIsHallSignedIn(); }catch(_){}
 var cols=HOH_LIGHT_COLS+(signedIn?HOH_LIGHT_COLS_SIGNED_IN:'')+(_hohRarityEmbedOn?HOH_RARITY_EMBED:'');
 /* .then() is what sends a PostgREST request, so both first pages are on their way before either is awaited */
 var page=function(from){
  return supabase.from('characters').select(cols)
   .eq('approved',true).or('is_hidden.is.null,is_hidden.eq.false')
   .order('created_at',{ascending:false}).order('id',{ascending:false})
   .range(from,from+999).then(function(res){ return res; });
 };
 var out=[];
 try{
  var first=page(0), ahead=page(1000);
  ahead.catch(function(){});  /* answered or not, it never surfaces as an unhandled rejection */
  for(var from=0,g=0;g<60;g++,from+=1000){
   var r=await (from===0?first:from===1000?ahead:page(from));
   if(!r||r.error) return null;
   var chunk=r.data||[];
   out=out.concat(chunk);
   if(chunk.length<1000) break;
  }
 }catch(_){ return null; }
 for(var i=0;i<out.length;i++) hohLightRowShape(out[i]);
 return out;
}
/* the JSON keys the light list asks for, back in the objects every reader expects (a row that already carries the
   whole object, as a test double's does, keeps it) */
function hohLightRowShape(r){
 if(!r) return r;
 var own=Object.prototype.hasOwnProperty;
 if(!own.call(r,'quest_meta')){
  var qm={};
  if(r.qm_jan!=null) qm.jan_featured=r.qm_jan;
  if(r.qm_won!=null) qm.winner_month=r.qm_won;
  r.quest_meta=Object.keys(qm).length?qm:null;
 }
 if(!own.call(r,'card_meta')){
  var cm={};
  if(r.cm_look!=null) cm.look=r.cm_look;
  if(r.cm_epithet!=null) cm.epithet=r.cm_epithet;
  if(r.cm_title!=null) cm.title=r.cm_title;
  if(r.cm_quote!=null) cm.quote=r.cm_quote;
  r.card_meta=Object.keys(cm).length?cm:null;
 }
 delete r.qm_jan; delete r.qm_won; delete r.cm_look; delete r.cm_epithet; delete r.cm_title; delete r.cm_quote;
 return r;
}
/* The grid, the marquee and the winner, painted from the light rows while the full roster is on its way. The marquee
   builds once (host.__hohBuilt), the winner writes only a change and the grid keeps every tile node by id, so the
   full roster's renders change nothing on screen; the veil lifts as soon as there is a Hall to see. */
function hohPaintLightRoster(rows){
 if(!rows||!rows.length||allCharacters.length) return;
 _hohRosterLight=rows;
 hohNoteRarityRows(rows);
 try{
  document.getElementById('hoh-loading').style.display='none';
  document.getElementById('hoh-gallery').style.display='grid';
 }catch(_){}
 [renderFeatured,hohHeroReturnFilters,renderGallery,hohRenderRarityMarquee]
   .forEach(function(fn){ try{ fn(); }catch(e){ try{console.error('[hoh] early render failed:',e);}catch(_){}} });
 try{ hohScheduleVeilDismiss(); }catch(_){}
 /* which control was pressed, for the answer hohQueueRosterOpen gives a button (only until the roster lands) */
 try{ document.addEventListener('pointerdown',hohNotePress,true); document.addEventListener('keydown',hohNoteKey,true); }catch(_){}
 /* a hero link (?hero=, also what the card view writes into the address) still opens its card when the roster lands
    (checkUrlHero); meanwhile its tile wears the ring, and a press in between wins instead (hohPressedInGap) */
 try{ var hp=new URLSearchParams(location.search).get('hero'); if(hp) hohQueueRosterOpen('link',hohLightLinkId(rows,hp),null); }catch(_){}
}
/* checkUrlHero's own match (id, stored slug, then the oldest hero whose name makes that slug), on the light rows */
function hohLightLinkId(rows,hero){
 var hp=String(hero).toLowerCase(), m=null, i;
 for(i=0;i<rows.length&&!m;i++){ if(rows[i]&&rows[i].id===hero) m=rows[i]; }
 for(i=0;i<rows.length&&!m;i++){ if(rows[i]&&rows[i].slug===hp) m=rows[i]; }
 if(!m){
  var c=rows.filter(function(r){ return r&&hohSlugifyName(r.name)===hp; });
  c.sort(function(a,b){ return String(a.created_at||'').localeCompare(String(b.created_at||'')); });
  m=c[0]||null;
 }
 return m?m.id:null;
}
/* Once the full roster is here, each tile the light rows drew is built again from its full row, a few dozen per idle
   moment, and repainted if the two differ. The count lands in window.__hohLightReconcile for the harness. */
function hohReconcileLightTiles(light){
 var g=document.getElementById('hoh-gallery');
 if(!g||typeof window.hohBuildCardHtml!=='function') return;
 var lightById={}, fullById={}, i;
 for(i=0;i<light.length;i++){ if(light[i]) lightById[String(light[i].id)]=light[i]; }
 for(i=0;i<allCharacters.length;i++){ if(allCharacters[i]) fullById[String(allCharacters[i].id)]=allCharacters[i]; }
 var kids=Array.prototype.slice.call(g.children), at=0;
 var stat=window.__hohLightReconcile={checked:0,repainted:0,done:false};
 var later=window.requestIdleCallback?function(fn){ window.requestIdleCallback(fn,{timeout:600}); }:function(fn){ setTimeout(fn,40); };
 (function step(){
  later(function(){
   var stale=[];
   for(var n=0;at<kids.length&&n<60;at++,n++){
    var el=kids[at], id=el.getAttribute&&el.getAttribute('data-hero-id');
    var lr=id&&lightById[id], fr=id&&fullById[id];
    if(!lr||!fr||!el.isConnected) continue;
    stat.checked++;
    try{ if(window.hohBuildCardHtml(lr,at)!==window.hohBuildCardHtml(fr,at)) stale.push(id); }catch(_){}
   }
   if(stale.length){ stat.repainted+=stale.length; try{ hohRepaintGridCards(stale); }catch(_){} }
   if(at<kids.length) step(); else stat.done=true;
  });
 })();
}
/* Something that needs the full roster, asked for while only the light rows are here: a card, the winner or a marquee
   portrait (opens), Summon (the button under Add Your Hero or the DM Tools tile), the draw simulation, a Scene or Tavern
   roll. What was pressed answers at once (a card tile: a gold ring; a button or the winner's picture: a gold outline;
   both aria-busy) and the action runs
   the moment the full roster lands, never with half a roster. The latest press wins; one older than 25 s is let go,
   and so is one whose own panel was closed, or (cards, the winner, Summon) one made before another panel opened. */
var _hohLastPress=null;
function hohNotePress(e){ _hohLastPress={el:e&&e.target,at:Date.now()}; }
function hohNoteKey(e){ if(e&&(e.key==='Enter'||e.key===' ')) hohNotePress(e); }  /* a keyboard press answers the same way */
function hohQueueRosterOpen(kind,id,opener,arg){
 hohClearRosterWait();
 var el=null, cls='hoh-roster-wait';
 try{
  if(kind==='card'||kind==='link'){
   cls='hoh-card-opening';
   el=(opener&&opener.closest&&opener.closest('#hoh-gallery .hoh-card'))||null;
   if(!el){ var all=document.querySelectorAll('#hoh-gallery .hoh-card[data-hero-id]'); for(var i=0;i<all.length;i++){ if(all[i].getAttribute('data-hero-id')===String(id)){ el=all[i]; break; } } }
  } else {
   var src=opener||(_hohLastPress&&Date.now()-_hohLastPress.at<1500?_hohLastPress.el:null);
   el=(src&&src.closest&&src.closest('button,[role="button"],.hoh-pouch-hero,.hoh-spotlight-winner-media'))||null;
  }
 }catch(_){ el=null; }
 _hohRosterWait={kind:kind,id:id==null?'':String(id),arg:arg,el:el,cls:cls,at:Date.now()};
 if(el){ el.classList.add(cls); el.setAttribute('aria-busy','true'); }
}
function hohClearRosterWait(){
 var w=_hohRosterWait; _hohRosterWait=null;
 if(w&&w.el){ try{ w.el.classList.remove(w.cls); w.el.removeAttribute('aria-busy'); }catch(_){} }
 return w;
}
/* pressed while the roster was on its way: that press, not the link the page was opened on, says what to open */
function hohPressedInGap(){ var w=_hohRosterWait; return !!(w&&w.kind!=='link'&&Date.now()-w.at<=25000); }
function hohBootUrlHero(){ if(!hohPressedInGap()) checkUrlHero(); }
function hohBootHeroReturnScroll(){ if(hohPressedInGap()) hohClearHeroReturn(); else hohHeroReturnScroll(); }
function hohRosterPanelOpen(id){ var m=document.getElementById(id); return !!(m&&m.isConnected&&getComputedStyle(m).display!=='none'); }
function hohOpenRosterWait(){
 var w=hohClearRosterWait();
 if(!w||w.kind==='link'||Date.now()-w.at>25000) return;  /* a hero link was opened by checkUrlHero already */
 /* the actions inside a panel need their panel still open */
 if(w.kind==='raffle'){ if(hohRosterPanelOpen('hoh-raffle-modal')&&typeof window.hohRunRaffle==='function'){ var db=(w.el&&w.el.isConnected)?w.el:document.querySelector('#hoh-raffle-modal .hoh-raffle-draw-btn'); window.hohRunRaffle(db||null); } return; }
 if(w.kind==='scene'){ if(hohRosterPanelOpen('hoh-scene-modal')&&typeof window.hohRollScene==='function') window.hohRollScene(); return; }
 if(w.kind==='tavern'){ if(hohRosterPanelOpen('hoh-tavern-modal')&&typeof window.hohRollTavern==='function') window.hohRollTavern(); return; }
 /* the rest open something new, so not over a panel opened meanwhile */
 try{
  var m=document.getElementById('hoh-modal');
  if((m&&hohViewportModalVisible(m))||document.body.style.overflow==='hidden'||document.querySelector('.ffb-veil.is-on')) return;
 }catch(_){}
 if(w.kind==='summon'){ if(typeof window.hohSummonRandomNpc==='function') window.hohSummonRandomNpc(w.arg); return; }
 if(w.kind==='detail'){ if(typeof window.hohOpenDetail==='function') window.hohOpenDetail(w.id,w.arg); return; }
 var tile=null, onScreen=false;
 try{
  var all=document.querySelectorAll('#hoh-gallery .hoh-card[data-hero-id]');
  for(var i=0;i<all.length;i++){ if(all[i].getAttribute('data-hero-id')===w.id){ tile=all[i]; break; } }
  if(tile){ var r=tile.getBoundingClientRect(); onScreen=r.width>0&&r.bottom>0&&r.top<window.innerHeight; }
 }catch(_){}
 if(typeof window.hohOpenHallCard==='function') window.hohOpenHallCard(w.id,onScreen?tile:null);
}

async function loadCharacters(){
 document.getElementById('hoh-loading').style.display='flex';
 document.getElementById('hoh-gallery').style.display='none';
 /* HALL-SPEED-02: on the first load, the light roster goes first (HOH_LIGHT_COLS) and paints in its own task, after
    the full roster's first request below is on its way. A reload (hohReloadCharacters) has the full roster already. */
 if(!allCharacters.length&&!_hohRosterLightTried){
  _hohRosterLightTried=true;
  var _hohLight=hohLoadLightRoster();
  _hohLight.then(function(lr){ if(lr) setTimeout(function(){ hohPaintLightRoster(lr); },0); },function(){});
  try{ await Promise.race([_hohLight,new Promise(function(done){ setTimeout(done,HOH_LIGHT_HEAD_START_MS); })]); }catch(_){}
 }
 /* R167: fetch only VISIBLE rows. The backfill added ~1.4k approved-but-hidden
    quest heroes; Supabase caps the result set (~1000 rows) so fetching hidden
    rows too pushed older visible heroes out of the fetch entirely. Hidden heroes
    are reached on demand instead: direct URL (checkUrlHero) and the god-mode
    review tool both fetch by id / their own query. */
 /* R271: PAGINATE. PostgREST caps an unbounded select at ~1000 rows, so the
    moment the Hall passed 1000 VISIBLE heroes the grid silently stopped loading
    anyone past 1000 and the "N heroes found" counter froze at exactly 1000.
    We now pull 1000-row pages with .range() until a short page comes back, so
    every visible hero loads and the count is the real total. created_at can tie
    on bulk inserts, so id is added as a deterministic tiebreaker — without it a
    paged query can duplicate or skip rows across page boundaries. Partial
    results are kept if a later page fails, so the Hall degrades gracefully
    instead of blanking out. */
 var rows = [];
 var error = null;
 try {
  var HOH_PAGE_SIZE = 1000;
  var _pageFrom = 0;
  for(var _pageGuard = 0; _pageGuard < 60; _pageGuard++){ /* hard stop ~60k rows */
   var _pageRes = await supabase.from('characters').select(hohRosterCols())
     .eq('approved',true).or('is_hidden.is.null,is_hidden.eq.false')
     .order('created_at',{ascending:false}).order('id',{ascending:false})
     .range(_pageFrom, _pageFrom + HOH_PAGE_SIZE - 1);
   /* R795: the hero_rarity(tier) embed needs sql/R795B. Before it runs,
      PostgREST refuses the embed (PGRST200). Drop it for this visit, forget
      any tier an earlier page carried so every hero falls back together, and
      retry the same page: the Hall opens on today's legacy tiers. */
   if(_pageRes && _pageRes.error && _hohRarityEmbedOn && hohIsRarityEmbedError(_pageRes.error)){
     _hohRarityEmbedOn = false;
     _hohRarityTierById = null;
     for(var _rri = 0; _rri < rows.length; _rri++){ try{ delete rows[_rri].hero_rarity; }catch(_){} }
     try { console.warn('[Hall] hero_rarity embed unavailable, using legacy tiers. Run sql/R795B.'); } catch(_){}
     continue;
   }
   /* R735: guest_tickets is a new column (sql/R735B). If the theme lands
      before that SQL, PostgREST answers 42703 for the unknown column. Drop
      it from the list once and retry the same page, so the Hall never
      opens empty over a release-order slip. */
   if(_pageRes && _pageRes.error && HOH_CHAR_COLS.indexOf(',guest_tickets') !== -1
      && (String(_pageRes.error.code || '') === '42703' || /guest_tickets/.test(String(_pageRes.error.message || '')))){
     HOH_CHAR_COLS = HOH_CHAR_COLS.replace(',guest_tickets', '');
     window.HOH_CHAR_COLS = HOH_CHAR_COLS;
     try { console.warn('[Hall] guest_tickets column missing, retrying without it. Run sql/R735B.'); } catch(_){}
     continue;
   }
   if(_pageRes && _pageRes.error){ error = _pageRes.error; break; }
   var _chunk = (_pageRes && _pageRes.data) || [];
   hohNoteRarityRows(_chunk);
   rows = rows.concat(_chunk);
   if(_chunk.length < HOH_PAGE_SIZE) break; /* short page = last page */
   _pageFrom += HOH_PAGE_SIZE;
  }
 } catch(e){ error = e; }
 document.getElementById('hoh-loading').style.display='none';
 document.getElementById('hoh-gallery').style.display='grid';
 /* R318: a failed boot fetch used to fall through to the normal empty state —
    "No heroes match those filters yet. Be the first to add one" — which reads
    as an EMPTY HALL during an outage. Say what happened and offer a retry. */
 if(error && !rows.length){
  try {
   var _em0=document.getElementById('hoh-empty');
   if(_em0){ _em0.innerHTML='<p style="margin:0 0 14px">The Hall could not be reached just now. The heroes are safe, this is a connection hiccup. Try again in a moment.</p><button type="button" class="hoh-cancel-btn" onclick="location.reload()">Knock again</button>'; }
  } catch(_){}
 }
 /* R46 / R140-Z3h: Hidden characters STAY in allCharacters so direct
    URL lookups (?hero=ID) and exact-name search still surface them.
    Per-surface filters (renderGallery, Fresh Faces / Explore the
    Hall, featured pool, raffle pool) drop is_hidden chars at the
    point of use. The exception path is exact-name search in the
    main gallery: typing a hidden char's full name brings them up
    so a creator can share a permalink and the recipient can find
    them by name. Jangela (god mode) sees hidden chars everywhere.
    Required SQL migration:
      ALTER TABLE characters ADD COLUMN IF NOT EXISTS is_hidden boolean NOT NULL DEFAULT false;
      CREATE INDEX IF NOT EXISTS idx_characters_visible ON characters(is_hidden) WHERE is_hidden = false; */
 allCharacters=rows;
 /* HALL-SPEED-02: the full roster is here (or failed for good): the light rows step aside, so the renders below and a
    failure's "Knock again" behave exactly as before */
 var _hohLightDrawn=_hohRosterLight; _hohRosterLight=null;
 try{ document.removeEventListener('pointerdown',hohNotePress,true); document.removeEventListener('keydown',hohNoteKey,true); }catch(_){} _hohLastPress=null;
 /* R140-Z3k: hohGetAllCharacters now FILTERS hidden chars by default
    so every downstream consumer (Trial swiper, Fresh Faces pickers,
    duel/brawl combatant pools, raffle eligibility) automatically
    excludes hidden heroes. The full unfiltered list is exposed
    separately as hohGetAllCharactersFull for surfaces that need
    everything — the main gallery filter (so search-by-name can
    surface a hidden hero on exact match) and the direct URL hero
    open (?hero=ID). God mode (Jangela) gets the full list everywhere
    because she's the one curating the hidden set.
    The change closes the leak where hidden chars could host events
    even after the source filter was relaxed in R140-Z3h. */
 /* R148-Z17: Hidden chars are now filtered for EVERYONE, including
    god-mode. Per user: "a hidden character... should not show up
    anywhere in the hall, not in the main hall, nor in the explore
    the hall, it can show up in the personal hall but thats it."
    Previously god-mode users saw hidden chars in main hall + Explore
    because they bypassed the filter; this defeated the point of
    hiding a hero. God-mode owners can still reach their hidden
    chars via:
      - Direct URL (?hero=ID)
      - Exact-name search (line ~1580 below)
      - Your Hall personal view (uses SOURCE_ROWS, not this list)
    The hohGetAllCharactersFull export still returns the unfiltered
    list for any surface that legitimately needs hidden chars
    (e.g. an admin-only god-mode dashboard). */
 window.hohGetAllCharactersFull = function(){ return allCharacters; };
 window.hohGetAllCharacters = function(){
   return allCharacters.filter(function(c){ return !(c && c.is_hidden === true); });
 };
 window.hohSupabaseClient=supabase;
 try{ if(typeof window.hohInjectBadgeDefs==='function') window.hohInjectBadgeDefs(); }catch(_){}
 try{ if(typeof window.hohBuildAccountBadgeMaps==='function') await window.hohBuildAccountBadgeMaps(); }catch(_){}
 /* R472: five independent renderers on one line, and a throw in any of
    them used to reject loadCharacters and blank the page. They are
    independent, so they fail independently now. */
 /* HALL-SPEED-02: after a light paint the filters a return put back are already in place, and the visitor may have
    changed them since, so they are not put back twice */
 [renderFeatured,_hohLightDrawn?function(){}:hohHeroReturnFilters,renderGallery,hohBootUrlHero,hohBootHeroReturnScroll,hohRenderHeaderTicker,hohRenderRarityMarquee]
   .forEach(function(fn){ try{ fn(); }catch(e){ try{console.error('[hoh] boot render failed:',e);}catch(_){}} });
 try{ if(typeof window.hohInitSummonMorph==='function') window.hohInitSummonMorph(); }catch(_){}
 /* HALL-SPEED-02: tiles the light rows drew are checked against the full rows, and a card tapped meanwhile opens in
    the next task, after hoh:characters-loaded has gone out (as a tap after the grid appeared always did) */
 if(_hohLightDrawn&&allCharacters.length){ try{ hohReconcileLightTiles(_hohLightDrawn); }catch(_){} }
 if(_hohLightDrawn&&allCharacters.length){ try{ if(hohRosterPanelOpen('hoh-raffle-modal')) hohShowRaffleIntro(); }catch(_){} }
 if(allCharacters.length){ setTimeout(function(){ try{ hohOpenRosterWait(); }catch(_){} },0); } else hohClearRosterWait();
 /* R170: the Hidden sort is public and loads the hidden set lazily (see
    hohEnsureHiddenChars). Reset to null = "not loaded" on every reload so it
    re-fetches fresh after edits, approvals, hides, and deletes. */
 window.__hohHidden = null;
 window.__hohHiddenLoading = false;
 /* OWNHIDDEN: the owner's hidden heroes come after the roster, so the grid is never held for them */
 try{ hohLoadOwnHidden(); }catch(_){}
}
/* R46: expose a public reload trigger so god-mode actions (hide /
   unhide a character) can refresh every surface in a single
   round-trip. Public name avoids touching the internal loadCharacters
   signature. */
window.hohReloadCharacters = function(){ return loadCharacters(); };
/* R170: lazy-load the hidden character set for the public Hidden sort. Fetched
   once, on demand, the first time anyone selects Hidden, then cached until the
   next reload. */
window.hohEnsureHiddenChars = function(){
  if(window.__hohHidden != null || window.__hohHiddenLoading) return;
  window.__hohHiddenLoading = true;
  /* R271: PAGINATE. The old .limit(2000) was a lie — PostgREST caps a request at
     ~1000 rows, so with ~1.4k approved-but-hidden quest heroes the review pool
     silently lost everyone past 1000 and those heroes could never be reviewed.
     Same 1000-row paging as the main grid, with id as the tiebreaker. */
  (async function(){
    var out = [];
    try {
      var PAGE = 1000, from = 0;
      for(var g = 0; g < 60; g++){
        var r = await supabase.from('characters').select(hohRosterCols())
          .eq('approved',true).eq('is_hidden',true)
          .order('created_at',{ascending:false}).order('id',{ascending:false})
          .range(from, from + PAGE - 1);
        /* R795: same one-time fallback as the roster */
        if(r && r.error && _hohRarityEmbedOn && hohIsRarityEmbedError(r.error)){ _hohRarityEmbedOn = false; _hohRarityTierById = null; g--; continue; }
        if(r && r.error) break;
        var chunk = (r && r.data) || [];
        hohNoteRarityRows(chunk);
        out = out.concat(chunk);
        if(chunk.length < PAGE) break;
        from += PAGE;
      }
    } catch(_){}
    window.__hohHidden = out;
    window.__hohHiddenLoading = false;
    try{ var s=document.getElementById('hoh-sort'); if(s && s.value==='hidden' && typeof renderGallery==='function') renderGallery(); }catch(_){}
  })();
};

/* ⛔ ====== R663 · THE HIDDEN HERO'S CARD, AND WHY THIS IS A SECOND READER ======
   Jan: "these removed characters from the hall or hidden are still visible as
   cards in the cards collected grid ... if anyone still owns it it just
   disappears from their owned cards."

   The collection grid has carried the right filter since R432 and R609 found
   why it removes nothing: it tests `hohGetAllCharactersFull()` for a row that
   is present AND hidden, and the Hall's boot fetch excludes hidden rows from
   the query outright, so "present and hidden" is unsatisfiable and the id set
   builds empty on every paint. The filter was never wrong. It had nothing to
   read.

   ⛔ AND THE OBVIOUS FIX IS THE ONE R609 ALREADY REJECTED, CORRECTLY.
   `hohEnsureHiddenChars` above would answer the question, but it reads
   HOH_CHAR_COLS — every one of ~57 columns including stories, stat blocks and
   quest metadata — across roughly 1,400 hidden rows. That is not a cost a
   phone should pay to paint a collection grid. This asks the same question
   with `select('id')`, so the answer is a list of identifiers and nothing
   else, and it fills the SAME `_hiddenIds` set the existing filter builds.

   ⛔ IT FAILS TOWARD SHOWING THE CARD, DELIBERATELY. A failed or partial read
   leaves the set NULL rather than empty, and a null set filters nothing. The
   two mistakes here are not equal: leaving a hidden card on screen for one
   more session is the bug Jan is reporting, while wrongly hiding a card a
   player really owns looks to them like the game ate their collection. Only
   a complete answer is allowed to remove anything.

   ⛔ THIS IS THE DISPLAY HALF ONLY. The rows still exist in the collection and
   the complete cure is the R609B purge, which is still waiting on Jan running
   `sql/R609A-READ-ONLY-hidden-hero-purge-authority.sql`. */
window.__hohHiddenIds = null;          /* null = no complete answer yet */
window.__hohHiddenIdsLoading = false;
window.hohEnsureHiddenIds = function(onDone){
  if(window.__hohHiddenIds != null){
    if(onDone){ try{ onDone(window.__hohHiddenIds); }catch(_){} }
    return;
  }
  /* A second caller while a read is in flight is dropped rather than queued:
     the first caller's repaint refreshes every surface anyway. */
  if(window.__hohHiddenIdsLoading) return;
  window.__hohHiddenIdsLoading = true;
  (async function(){
    var map = null;
    try {
      /* Same 1000-row paging as every other list read in this file, because
         PostgREST caps a request at ~1000 rows and `.limit()` past that is a
         lie that loses rows silently (the R271 lesson). */
      var out = {}, PAGE = 1000, from = 0, complete = false;
      for(var g = 0; g < 60; g++){
        var r = await supabase.from('characters').select('id')
          .eq('is_hidden', true)
          .order('id', {ascending:false})
          .range(from, from + PAGE - 1);
        if(r && r.error) break;
        var chunk = (r && r.data) || [];
        for(var i = 0; i < chunk.length; i++){
          if(chunk[i] && chunk[i].id != null) out[String(chunk[i].id)] = 1;
        }
        if(chunk.length < PAGE){ complete = true; break; }
        from += PAGE;
      }
      /* Only a walk that reached the end of the list is an answer. A break on
         an error mid-page would otherwise publish a partial set, and a hidden
         hero missing from a partial set renders as a card. */
      if(complete) map = out;
    } catch(_){ map = null; }
    window.__hohHiddenIds = map;
    window.__hohHiddenIdsLoading = false;
    if(onDone){ try{ onDone(map); }catch(_){} }
  })();
};
/* Returns the id set, or null when no complete answer has landed. Callers must
   treat null as "ask nothing", never as "nothing is hidden". */
window.hohHiddenIdSet = function(){ return window.__hohHiddenIds; };

/* ============ R472 · A NULL NAME MUST NOT BLANK THE HALL ============
   Jan: "sometimes explore the hall also isn't loading, like I just click on
   the page and the entire page is blank."

   ROOT CAUSE, and it is one unguarded character. esc() tolerates a null, and
   `f.name.charAt(0)` does not. renderFeatured falls back to allCharacters[0]
   when no row is flagged featured, and the query orders created_at desc, so
   the fallback is THE MOST RECENTLY SUBMITTED HERO. One approved row with a
   missing name threw here, for every visitor, until somebody else submitted
   and pushed it off the top. That is exactly the shape of an intermittent
   fault that heals itself and comes back.

   The blast radius was the whole page rather than one spotlight, because the
   throw travelled up an async function whose .then had no .catch: the boot
   never dispatched hoh:characters-loaded, never relocated #hoh-fresh-faces
   into #hoh-yh-page, and body.hoh-page-mode-yours hides everything else with
   !important. So the page went blank and nothing logged.

   Fixed in three places, on purpose. This helper is the actual bug. The
   per-call guards below are so the NEXT unguarded field cannot do it again. */
function hohInitial(n){
  var s = (n == null ? '' : String(n)).trim();
  return s ? s.charAt(0) : '?';
}

function renderFeatured(){
 var el=document.getElementById('hoh-spotlight-winner');
 if(!el)return;
 var src=hohRosterSource(); /* HALL-SPEED-02: the light rows until the roster lands */
 var f=src.find(function(c){return c.featured;})||src[0];
 if(!f){el.innerHTML='';el.__hohFeatHtml='';return;}
 var media;
 /* R366: the Win a Free Portrait spotlight now honours the saved reframe.
    This surface shipped with no object-position at all, so object-fit:cover
    centred every portrait and a hero Jan had re-cropped on the hall card
    still rendered head-cropped here. Reads the same hohImgObjPos getter every
    other surface uses (cards, detail modal, party slots), so the crop can
    never drift between the spotlight and the rest of the Hall. */
 var featPos=(typeof window.hohImgObjPos==='function')?window.hohImgObjPos(f.id,'primary'):'50% 50%';
 var featStyle=(typeof window.hohImgStyle==='function')?window.hohImgStyle(f.id,'primary'):('object-position:'+featPos+';');
 if(f.video_url){media='<video src="'+f.video_url+'" autoplay loop muted playsinline style="'+featStyle+'"></video>';}
 else if(f.image_url){media='<img src="'+f.image_url+'" alt="'+esc(f.name)+'" decoding="async" crossorigin="anonymous" data-letter="'+esc(hohInitial(f.name))+'" style="'+featStyle+'" onerror="hohImgFallback(this,\'hoh-spotlight-winner-letter\')">';}
 else{media='<div class="hoh-spotlight-winner-letter">'+esc(hohInitial(f.name))+'</div>';}
 var lv=f.level?' &middot; Level '+f.level:'';
 var cp=f.campaign?' &middot; '+esc(f.campaign):'';
 /* Dynamic month name on the winner label. The Hall names the winner for
  the CURRENT calendar month, so September's featured winner reads
  "September's Winner" throughout September. hohMonthName sets the date to
  the 1st before applying an optional offset, avoiding month-overflow edge
  cases. */
 var winnerMonth='Month';
 try{winnerMonth=(typeof hohMonthName==='function')?hohMonthName():new Date().toLocaleString('en-US',{month:'long'});}catch(_){}
 /* DRAWDAY: the featured hero is the winner whose announcement window has
    closed. The draw lands on the 1st at noon Eastern and the window runs 24
    hours, so that is the Eastern month of (now - 36h): until noon on the 2nd
    the last winner keeps last month's name and never reads as the new one
    beside "Jan is picking the winner". */
 try{winnerMonth=new Intl.DateTimeFormat('en-US',{month:'long',timeZone:'America/New_York'}).format(new Date(Date.now()-36*3600000));}catch(_){}
 /* WINNERPICK: a winner crowned from debug mode carries the month they won
    (quest_meta.winner_month), so they read as that month's winner at once */
 var _wonMonth=hohMonthKeyName(hohWinnerMonthOf(f));
 if(_wonMonth)winnerMonth=_wonMonth;
 var html=
 '<div class="hoh-spotlight-winner-label">'+esc(winnerMonth)+'’s Winner</div>'+
 '<h3 class="hoh-spotlight-winner-name">'+esc(f.name)+'</h3>'+
 '<div class="hoh-spotlight-winner-media" data-hero-id="'+esc(String(f.id))+'" onclick="event.stopPropagation();hohOpenDetail(\''+f.id+'\')">'+media+'</div>'+
 '<p class="hoh-spotlight-winner-meta">'+esc(f.race)+' '+esc(f.character_class)+lv+cp+'</p>'+
 '<p class="hoh-spotlight-winner-byline">Submitted by '+esc(f.player_name)+'</p>';
 /* HALL-SPEED-02: the same winner again (the light rows' paint, then the full roster's) keeps its nodes, so the
    portrait or video never reloads */
 if(el.__hohFeatHtml===html&&el.firstChild)return;
 el.__hohFeatHtml=html;
 el.innerHTML=html;
}

/* Relevance rank for the search bar. Lower number wins. 0 exact name
 match, 1 starts-with or whole-word match, 2 substring match, 99 the
 match landed somewhere else in the haystack (race, class, story...). */
function hohNameMatchRank(name,q){
 if(!name||!q)return 99;
 var ln=String(name).toLowerCase();
 if(ln===q)return 0;
 if(ln.indexOf(q)===0)return 1;
 var words=ln.split(/\s+/);
 for(var i=0;i<words.length;i++){if(words[i]===q)return 1;}
 if(ln.indexOf(q)!==-1)return 2;
 return 99;
}
/* R140-Z3o: One-time auto-default to "Hearted by you" sort when the
   user has hearted 30+ heroes. Stays sticky once toggled — flag is
   per-device in localStorage so it survives reloads but doesn't
   toggle off if the user later un-hearts some. The user explicitly
   asked for this to fire exactly once and stay as their default. */
var HOH_LIKED_DEFAULT_KEY = 'hoh-liked-sort-default-applied';
var HOH_LIKED_DEFAULT_THRESHOLD = 30;
function hohMaybeApplyLikedSortDefault(){
 try {
  /* R793: favourites are a list you open on purpose, never a default. */
  if(typeof window.hohR793Live==='function' && window.hohR793Live()) return;
  if(localStorage.getItem(HOH_LIKED_DEFAULT_KEY) === '1') return;
  var hMap = getHeartMap();
  var heartedCount = 0;
  for(var k in hMap){ if(hMap.hasOwnProperty(k) && hMap[k] > 0) heartedCount++; }
  if(heartedCount < HOH_LIKED_DEFAULT_THRESHOLD) return;
  /* Promote 'liked' to the default sort. We set the dropdown value
     AND stamp the localStorage flag so this only fires once. The
     user can still manually pick a different sort after; the flag
     just guarantees we don't override their choice on every load. */
  var sel = document.getElementById('hoh-sort');
  if(sel){
   sel.value = 'liked';
  }
  localStorage.setItem(HOH_LIKED_DEFAULT_KEY, '1');
 } catch(_){}
}

/* R793.1 · RARITY ORDER, OWN HEROES FIRST, AN EMPTY FAVORITED VIEW
   The tier is the one the card's border shows (hohGetRarity, the same call
   hoh-card-render.js makes for hoh-card-rar-<tier>), highest first; ties go
   to FF portraits, then more legacy hearts, then the newest hero. Keys are computed once per
   hero, so a 1,100 hero sort stays a few milliseconds.
   R795: the border's tier is hohHallTier now (the hero page score once
   sql/R795B answers, the legacy-hearts tier until then), so the sort reads
   the same call. The tie-breaks are unchanged. */
/* its own name: HOH_RARITY_RANK (line ~1160) is the badge order map */
var HOH_HALL_TIER_RANK={mythic:5,legendary:4,epic:3,rare:2,uncommon:1,common:0};
function hohSortByRarity(list){
 var keyed=(list||[]).map(function(c,i){
  var h=(c&&c.hearts)||0, t=Date.parse((c&&c.created_at)||'');
  var tier='common'; try{ tier=hohHallTier(c).tier; }catch(_){}
  /* JANFAV (Jan, 2026-10-19: "the mythic should be on top, with jans favorites at the highest of those"):
     within a tier, Jan's featured heroes (quest_meta.jan_featured) lead. hohIsJanFeatured is defined
     further down this file; it is only read when the sort runs. */
  var jf=0; try{ jf=hohIsJanFeatured(c)?1:0; }catch(_){}
  return {c:c,r:HOH_HALL_TIER_RANK[tier]||0,jf:jf,ff:c&&c.is_ff_portrait?1:0,h:h,t:isNaN(t)?0:t,i:i};
 });
 keyed.sort(function(a,b){ return (b.r-a.r)||(b.jf-a.jf)||(b.ff-a.ff)||(b.h-a.h)||(b.t-a.t)||(a.i-b.i); });
 return keyed.map(function(k){ return k.c; });
}
window.hohSortByRarity=hohSortByRarity;
/* The signed-in account, the way the R793 doors read it. */
function hohHallAccountEmail(){
 try{
  if(typeof window.hohIsHallSignedIn==='function' && !window.hohIsHallSignedIn()) return '';
  return String((typeof window.hohYourHallEmail==='function' && window.hohYourHallEmail())||'').trim().toLowerCase();
 }catch(_){ return ''; }
}
/* The R793 ticket doors' owner rule: auth_email when it is not blank, else
   the form email, trimmed and lowercased; an approved hero that is not hidden. */
function hohHallOwnerKey(c){
 var a=String(c.auth_email==null?'':c.auth_email).trim();
 return (a||String(c.email==null?'':c.email).trim()).toLowerCase();
}
function hohIsOwnHallHero(c,me){
 if(!c||!me||c.approved===false||c.is_hidden===true) return false;
 var k=hohHallOwnerKey(c);
 return !!k && k===me;
}
window.hohIsOwnHallHero=hohIsOwnHallHero;
/* R793.1 fix (code review): the same owner test for the client halves of the
   R793 doors (today's ticket panel, Explore's pick). They used
   hohIsCharacterOwner, which reads the form email only, so a hero whose
   auth_email is the player's but whose form email is not sorted first yet
   offered no ticket, and the reverse offered a ticket the door refuses
   (not_owner). Owner only: a hidden hero still gets the door's own answer. */
function hohIsHallDoorOwner(c){
 var me=hohHallAccountEmail();
 if(!c||!me) return false;
 var k=hohHallOwnerKey(c);
 return !!k && k===me;
}
window.hohIsHallDoorOwner=hohIsHallDoorOwner;
/* ⛔ OWNHIDDEN (Jan, 2026-10-29): "if they're logged into their account and then they sort by ... their own heroes,
   it should still show all of their heroes even if it's hidden or even if it doesn't have an image ... just don't
   let other people ever see that character. So only from their account that submitted that character should it work."
   The roster fetch keeps hidden heroes out for everyone, and still does. The signed-in owner's own browser asks
   get_my_characters (the account's session or PIN proves the email) for the account's heroes and keeps the hidden
   ones here. Only the grid, search, opening the hero and Edit read this list. hohGetAllCharacters still drops hidden
   rows, so tickets, Explore, battles and packs never take them. Another account, or signing out, reads it empty. */
var _hohOwnHidden=[], _hohOwnHiddenFor='', _hohOwnHiddenBusy='';
function hohOwnHiddenRows(){
 var me=hohHallAccountEmail();
 return (me&&me===_hohOwnHiddenFor)?_hohOwnHidden:[];
}
function hohFindOwnHidden(id){
 var sid=String(id), rows=hohOwnHiddenRows();
 for(var i=0;i<rows.length;i++){ if(rows[i]&&String(rows[i].id)===sid) return rows[i]; }
 return null;
}
window.hohFindOwnHidden=hohFindOwnHidden;
window.hohIsOwnHiddenHero=function(c){ return !!(c&&c.is_hidden===true&&hohFindOwnHidden(c.id)); };
function hohKeepOwnHidden(row,me){ return !!(row&&row.is_hidden===true&&row.approved!==false&&hohHallOwnerKey(row)===me); }
function hohLoadOwnHidden(){
 var me=hohHallAccountEmail();
 if(!me||_hohOwnHiddenBusy===me) return;
 var t=null;
 try{ t=(window.ffSignIn&&window.ffSignIn.session)?window.ffSignIn.session():JSON.parse(localStorage.getItem('hoh-your-hall-token')||'null'); }catch(_){ t=null; }
 if(!t||String(t.email||'').trim().toLowerCase()!==me||!t.pin) return;
 _hohOwnHiddenBusy=me;
 Promise.resolve(supabase.rpc('get_my_characters',{user_email:me,user_pin:t.pin})).then(function(r){
  _hohOwnHiddenBusy='';
  if(hohHallAccountEmail()!==me||!r||r.error||!Array.isArray(r.data)) return;
  var had=hohOwnHiddenRows().length;
  _hohOwnHidden=r.data.filter(function(c){ return hohKeepOwnHidden(c,me); });
  _hohOwnHiddenFor=me;
  if(had||_hohOwnHidden.length){ try{ renderGallery(); }catch(_){} }
 },function(){ _hohOwnHiddenBusy=''; });
}
window.hohLoadOwnHidden=hohLoadOwnHidden;
/* A save or a live change to one of them lands here too. A hero Jan puts back on the wall leaves the list (the roster
   has it again), and one Jan hides while its owner watches joins it. True when the list changed. */
function hohOwnHiddenPatch(row){
 var me=hohHallAccountEmail();
 if(!row||!row.id||!me||me!==_hohOwnHiddenFor) return false;
 var i=_hohOwnHidden.findIndex(function(c){ return c&&String(c.id)===String(row.id); });
 if(hohKeepOwnHidden(row,me)){ if(i>=0) _hohOwnHidden[i]=row; else _hohOwnHidden.push(row); return true; }
 if(i>=0){ _hohOwnHidden.splice(i,1); return true; }
 return false;
}
/* A hidden hero's link opens for its owner and for Jan, and for nobody else. */
function hohLinkMayOpenHidden(c){
 var me=hohHallAccountEmail();
 if(me&&hohHallOwnerKey(c)===me) return true;
 return (typeof window.hohIsGodMode==='function')&&!!window.hohIsGodMode();
}
function hohSetGalleryEmptyState(em,kind){
 if(!em) return;
 if(em.__hohEmptyDefault==null) em.__hohEmptyDefault=em.innerHTML;
 if((em.__hohEmptyKind||'')===kind) return;
 em.__hohEmptyKind=kind;
 em.innerHTML=(kind==='favorites')
  ? '<div class="hoh-empty-icon" aria-hidden="true">&#9825;&#xFE0E;</div><p>No favorites yet.</p><p class="hoh-empty-sub">Open a hero and tap Favorite.</p>'
  : em.__hohEmptyDefault;
}
/* HALLHERO · "MY HEROES FIRST" (Jan, 2026-09-23: "a checkbox to show yours
   at the top ... or if you uncheck it, it goes where they belong").
   The box (#hoh-ownfirst, in the count row) shows only to a signed-in player
   who owns at least one hero in the Hall. On (the default, the R793.1 order)
   pins their heroes first; off leaves them where the sort puts them. The
   choice is remembered on this device. It fades out, keeping its place, in
   the views where the pin never applies (a search, Favorited, FF portraits). */
var HOH_OWN_FIRST_KEY='hoh-own-first';
function hohOwnFirstOn(){
 try{ return localStorage.getItem(HOH_OWN_FIRST_KEY)!=='0'; }catch(_){ return true; }
}
window.hohOwnFirstOn=hohOwnFirstOn;
function hohOwnHallCount(me){
 if(!me) return 0;
 var n=0, list=allCharacters||[];
 for(var i=0;i<list.length;i++){ if(hohIsOwnHallHero(list[i],me)) n++; }
 return n;
}
function hohSyncOwnFirstBox(me,applies){
 var box=document.getElementById('hoh-ownfirst'); if(!box) return;
 var cb=document.getElementById('hoh-ownfirst-cb');
 if(cb) cb.checked=hohOwnFirstOn();
 if(!(me && hohOwnHallCount(me)>0)){ box.hidden=true; return; }
 if(box.hidden){ box.hidden=false; box.classList.remove('is-in'); void box.offsetWidth; box.classList.add('is-in'); }
 box.classList.toggle('is-na',!applies);
 if(cb){ cb.disabled=!applies; }
}
window.hohSetOwnFirst=function(on){
 try{ localStorage.setItem(HOH_OWN_FIRST_KEY,on?'1':'0'); }catch(_){}
 var g=document.getElementById('hoh-gallery');
 try{ window.hohApplyFilters(); }catch(_){ try{ renderGallery(); }catch(__){} }
 /* the FLIP grid slides the cards (hoh-grid-flip.js, 200-240ms) and snaps
    under reduced motion, which gets a short fade instead */
 if(_hohReducedMotion() && g && g.animate){ try{ g.animate([{opacity:.3},{opacity:1}],{duration:200,easing:'ease-out'}); }catch(_){} }
};
/* HALLHERO · the quiet way back for heroes hidden in Explore. The "Hidden by
   me" view is gone, so the end of the grid says how many matching heroes this
   device hid, with one button that brings exactly those back. */
function hohRenderHiddenReset(ids){
 ids=ids||[];
 var host=document.getElementById('hoh-hidden-reset');
 if(!host){
  if(!ids.length) return;
  var em=document.getElementById('hoh-empty'); if(!em||!em.parentNode) return;
  host=document.createElement('p'); host.id='hoh-hidden-reset'; host.className='hoh-hidden-reset';
  em.parentNode.insertBefore(host,em.nextSibling);
 }
 host.__hohIds=ids.slice();
 if(!ids.length){ host.hidden=true; host.classList.remove('is-out'); host.removeAttribute('data-n'); return; }
 var n=ids.length;
 if(host.getAttribute('data-n')!==String(n)){
  host.setAttribute('data-n',String(n));
  host.innerHTML='<span>'+n+(n===1?' hero you hid isn’t':' heroes you hid aren’t')+' shown.</span><button type="button" class="hoh-hidden-reset-btn" onclick="hohShowHiddenHeroes(this)">Show '+(n===1?'it':'them')+'</button>';
 }
 if(host.hidden||host.classList.contains('is-out')){ host.hidden=false; host.classList.remove('is-out','is-in'); void host.offsetWidth; host.classList.add('is-in'); }
}
window.hohShowHiddenHeroes=function(btn){
 var host=document.getElementById('hoh-hidden-reset');
 var ids=(host&&host.__hohIds)||[];
 ids.forEach(function(id){ try{ if(typeof window.hohRestoreCharacter==='function') window.hohRestoreCharacter(id); }catch(_){} });
 if(host) host.classList.add('is-out');
 setTimeout(function(){ try{ window.hohApplyFilters(); }catch(_){} }, _hohReducedMotion()?0:180);
};
/* HALLHERO · THE WAY BACK FROM A HERO PAGE (Jan, 2026-09-23: "a simple back
   button that takes them back into the page they were just on with this
   character open seamlessly"). Leaving for a hero page notes, in this tab's
   sessionStorage, whose card was open, how far the grid was scrolled and the
   filters in use. The hero page's Back is history.back(), so:
   - a back/forward-cache return is this page exactly as it was (card open,
     scroll kept): pageshow only drops the note;
   - a fresh load comes back on ?hero=<slug> (the card view wrote it into the
     address), so checkUrlHero reopens the card; the boot chain puts the
     filters back before the grid paints and the scroll back under the card.
   The note is used once and lives 30 minutes. */
var HOH_HERO_RETURN_KEY='hoh-hero-return';
function hohHeroTile(id){
 if(!id) return null;
 try{ return document.querySelector('#hoh-gallery .hoh-card[data-hero-id="'+(window.CSS&&CSS.escape?CSS.escape(String(id)):String(id))+'"]'); }catch(_){ return null; }
}
function hohStashHeroReturn(heroId){
 try{
  var val=function(id){ var e=document.getElementById(id); return e?String(e.value||''):''; };
  var y=document.body.__hohScrollLocked?(document.body.__hohScrollY||0):(window.scrollY||window.pageYOffset||0);
  /* where this hero's tile sat on screen: the return lines the tile up again,
     which survives rows above the grid that paint later on a fresh load */
  var tile=hohHeroTile(heroId), t=tile?Math.round(tile.getBoundingClientRect().top):null;
  sessionStorage.setItem(HOH_HERO_RETURN_KEY,JSON.stringify({id:String(heroId||''),y:Math.max(0,Math.round(y)),t:t,sort:val('hoh-sort'),race:val('hoh-race-filter'),cls:val('hoh-class-filter'),q:val('hoh-search'),at:Date.now()}));
 }catch(_){}
}
function hohReadHeroReturn(){
 try{
  var n=JSON.parse(sessionStorage.getItem(HOH_HERO_RETURN_KEY)||'null');
  return (n&&n.at&&(Date.now()-n.at)<1800000)?n:null;
 }catch(_){ return null; }
}
function hohClearHeroReturn(){ try{ sessionStorage.removeItem(HOH_HERO_RETURN_KEY); }catch(_){} }
function hohIsBackForwardLoad(){
 try{ var e=performance.getEntriesByType('navigation')[0]; if(e) return e.type==='back_forward'; }catch(_){}
 try{ return performance.navigation&&performance.navigation.type===2; }catch(_){ return false; }
}
window.hohHeroReturnState=function(){ return hohReadHeroReturn(); };
/* before the grid paints: the filters the player left with */
function hohHeroReturnFilters(){
 var n=hohReadHeroReturn(); if(!n) return;
 if(!hohIsBackForwardLoad()){ hohClearHeroReturn(); return; }
 var set=function(id,v){
  var e=document.getElementById(id); if(!e||v==null) return;
  if(e.tagName==='SELECT'){ if(Array.prototype.some.call(e.options,function(o){ return o.value===v; })) e.value=v; }
  else e.value=v;
 };
 set('hoh-sort',n.sort==='mine_hidden'?'most':n.sort);
 set('hoh-race-filter',n.race); set('hoh-class-filter',n.cls); set('hoh-search',n.q);
 try{ _hohSyncFfSortStyle(); }catch(_){}
 try{ hohResizeSort(); }catch(_){}
}
/* after checkUrlHero: the card open, and the grid under it where it was */
function hohAlignHeroReturn(n){
 var locked=!!document.body.__hohScrollLocked;
 var cur=locked?(document.body.__hohScrollY||0):(window.scrollY||window.pageYOffset||0);
 var y=Math.max(0,n.y|0), tile=hohHeroTile(n.id);
 if(tile&&typeof n.t==='number') y=Math.max(0,Math.round(tile.getBoundingClientRect().top+cur-n.t));
 if(locked){ document.body.__hohScrollY=y; document.body.style.top=(-y)+'px'; }
 else{ try{ window.scrollTo({top:y,left:0,behavior:'instant'}); }catch(_){ window.scrollTo(0,y); } }
}
function hohHeroReturnScroll(){
 var n=hohReadHeroReturn(); if(!n) return;
 hohClearHeroReturn();
 if(!hohIsBackForwardLoad()) return;
 try{
  var modal=document.getElementById('hoh-modal');
  var o=window.__hohHallCardOrigin;
  var open=!!(modal&&hohViewportModalVisible(modal)&&o&&String(o.id)===n.id);
  if(!open&&n.id&&hohFindModalHero(n.id)&&typeof window.hohOpenHallCard==='function') window.hohOpenHallCard(n.id);
 }catch(_){}
 hohAlignHeroReturn(n);
 /* rows above the grid can still paint after this; while the card is up the
    page is pinned under the dim, so lining the tile up again is invisible */
 var again=function(){
  try{
   var m=document.getElementById('hoh-modal'), o2=window.__hohHallCardOrigin;
   if(m&&hohViewportModalVisible(m)&&o2&&String(o2.id)===n.id) hohAlignHeroReturn(n);
  }catch(_){}
 };
 setTimeout(again,450); setTimeout(again,1100);
}
function renderGallery(newId){
 /* R140-Z3o: Apply the one-shot default before reading sortVal. */
 try { hohMaybeApplyLikedSortDefault(); } catch(_){}
 /* R250: keep the "Hearted by you" option in sync with reality — it
    (re)appears the moment the viewer's first heart exists. */
 try { hohSyncLikedOption(); } catch(_){}
 var rv=document.getElementById('hoh-race-filter').value,cv=document.getElementById('hoh-class-filter').value,sv=(document.getElementById('hoh-search').value||'').trim().toLowerCase();
 /* R200: badge search. When the whole query names a badge, switch to badge mode:
    keep only heroes who publicly show that badge, and skip the text match so the
    badge word isn't also required in the hero's name/story. Account-scope badge
    families (Hall Contributor, Patron, Adventurer, Veteran) need the account maps,
    so kick a build if they aren't ready yet. */
 var badgeMatch=(typeof window.hohSearchBadgeMatch==='function' && sv)?window.hohSearchBadgeMatch(sv):null;
 if(badgeMatch && badgeMatch.fam && window.HOH_TIER_FAMILIES && window.HOH_TIER_FAMILIES[badgeMatch.fam] && window.HOH_TIER_FAMILIES[badgeMatch.fam].scope==='account' && !_hohAcctMapsReady && typeof window.hohBuildAccountBadgeMaps==='function'){ try{ var _bmp=window.hohBuildAccountBadgeMaps(); if(_bmp&&_bmp.then){ _bmp.then(function(){ if(typeof window.hohApplyFilters==='function') window.hohApplyFilters(); }); } }catch(_){} }
 /* Rarity keyword shortcut. Any word in the search that matches a rarity
  name (or the color shorthand players recognize from card games) switches
  the result set to that tier. Remaining words fall through to the normal
  substring match. So "rare elf" = Rare-tier Elves, "blue" alone = Rare
  tier. Aliases cover grey/gray, green, blue, purple, orange, yellow. */
 var RAR_MAP={common:'common',grey:'common',gray:'common',uncommon:'uncommon',green:'uncommon',rare:'rare',blue:'rare',epic:'epic',purple:'epic',legendary:'legendary',orange:'legendary',yellow:'legendary'};
 var searchWords=(sv && !badgeMatch)?sv.split(/\s+/):[];
 var rarityKeyword=null;
 var textWords=[];
 searchWords.forEach(function(w){if(RAR_MAP[w]&&!rarityKeyword){rarityKeyword=RAR_MAP[w];}else{textWords.push(w);}});
 /* R140-Z3h + R148-Z17: Hidden-character visibility rule. Hidden
    chars are excluded by default; the only path that surfaces them
    in this gallery view is EXACT-name search (the user typed the
    full name, so they already know who they're looking for). The
    god-mode bypass was REMOVED so the owner of a hidden hero also
    stops seeing them in the main hall — matching the new "hidden
    means hidden everywhere except personal hall" semantics. */
 var fullNameQuery = (sv || '').toLowerCase();
 /* R318: the Hidden sort is DEBUG-ONLY now. A user-submitted hero that is still
    hidden (the creator has not made it public) must not be browsable by anyone,
    and its art must not be reachable through this view. Only god/debug mode
    resolves the Hidden sort; for everyone else the selector never carries the
    option (see the signed-in guard below), and even if 'hidden' is forced into
    the value, a non-god viewer falls through to the normal allCharacters source
    and the per-row is_hidden gate drops the rows. So the hidden pool is never
    fetched, never rendered, and its images are never requested for the public. */
 /* R318: TWO separate "hidden" ideas, kept apart on purpose.
    1. REAL hidden ('hidden' sort) = server is_hidden, a creator's hero not yet
       public. Debug-only. Never fetched or rendered for the public, art included.
    2. HIDDEN BY ME ('mine_hidden' sort) = the personal X-dismiss, stored only in
       this browser's localStorage, affects nobody else. Stays available to
       everyone as their own "things I hid" list.
    A direct permalink (?hero=slug) still opens a real-hidden hero, because
    checkUrlHero fetches it straight from the server and never touches this grid. */
 var _sortNow = document.getElementById('hoh-sort').value;
 var _god = (typeof window.hohIsGodMode === 'function') && window.hohIsGodMode();
 var _hohMod = _god && (_sortNow === 'hidden');
 if(_hohMod && window.__hohHidden == null && typeof window.hohEnsureHiddenChars === 'function'){ try{ window.hohEnsureHiddenChars(); }catch(_){} }
 var _hohSource = _hohMod ? (window.__hohHidden || []) : hohRosterSource(); /* HALL-SPEED-02: the light rows until the roster lands */
 /* OWNHIDDEN: the signed-in owner's own hidden heroes join their grid and their search (nobody else has the list) */
 var _ownHid={};
 if(!_hohMod){
  var _ohRows=hohOwnHiddenRows();
  if(_ohRows.length){
   var _ohHave={};
   _hohSource.forEach(function(c){ if(c) _ohHave[String(c.id)]=1; });
   _ohRows.forEach(function(c){ _ownHid[String(c.id)]=1; });
   _hohSource=_hohSource.concat(_ohRows.filter(function(c){ return !_ohHave[String(c.id)]; }));
  }
 }
 /* R265: in debug/god review (the Hidden sort), only surface hidden heroes
    that actually HAVE an image — those are the ones worth approving. Heroes
    auto-hidden for a missing image are skipped so the review queue is all
    reviewable cards. Scoped to god so the public Hidden sort is unchanged. */
 if(_hohMod && (typeof window.hohIsGodMode === 'function') && window.hohIsGodMode()){
   _hohSource = _hohSource.filter(function(c){ return c && (c.image_url || c.image_thumb_url); });
 }
 var filtered=_hohSource.filter(function(c){
 if(!_hohMod && c && c.is_hidden === true && !_ownHid[String(c.id)]){
   /* Allow only when the search box matches this char's name exactly
      (case-insensitive). Lets a creator share their hidden hero's
      name and have it surface for the recipient. */
   if(!fullNameQuery || (c.name || '').toLowerCase() !== fullNameQuery) return false;
 }
 if(rv){if(rv==='Other'){if(isStandardRace(c.race))return false;}else{if(c.race!==rv)return false;}}
 if(cv){if(cv==='Other'){if(isStandardClass(c.character_class))return false;}else{if(c.character_class!==cv)return false;}}
 /* R795: the keyword matches the tier the border shows */
 if(rarityKeyword&&hohHallTier(c).tier!==rarityKeyword)return false;
 if(badgeMatch){
  var _hb=(typeof window.hohGetHeroBadges==='function')?window.hohGetHeroBadges(c):[];
  var _hasBadge=false; for(var _bi=0;_bi<_hb.length;_bi++){ if(badgeMatch.keys.indexOf(_hb[_bi])!==-1){ _hasBadge=true; break; } }
  if(!_hasBadge)return false;
 }
 if(textWords.length){
  /* Smart haystack: name, race, class, campaign, author name, and story
   text. Author match is why typing "sabella" surfaces heroes submitted
   by Sabella. Story match lets players search by plot snippets they
   half-remember. All substring-based so partial names still land. */
  var ss=(c.name+' '+(c.race||'')+' '+(c.character_class||'')+' '+(c.campaign||'')+' '+(c.player_name||'')+' '+(c.story||'')).toLowerCase();
  if(!textWords.every(function(w){return ss.indexOf(w)!==-1;}))return false;
 }
 return true;
 });
 var sortVal=document.getElementById('hoh-sort').value;
 /* R793.1 (Jan, 2026-09-22): "remove 'most legacy hearts' from the filter,
    just name it rarity and dont do fewest legacy hearts just remove that
    filter". The default option (value 'most', so every saved sort keeps
    working) orders by the tier the card's border shows, highest first, then
    FF portraits within each tier, then legacy hearts, then newest. Fewest is gone from the markup; a stale
    'least' value simply falls through unsorted like Newest. */
 if(sortVal==='most'){filtered=hohSortByRarity(filtered);}
 else if(sortVal==='liked'){
  /* R793: Hearted (R793.1: Favorited) is the account's favourites from
     hoh_hall_hearts_list, ordered like the default view (rarity). Legacy
     keeps the old device heart map, most-hearted-by-you first. */
  if(hohR793Words()){filtered=hohSortByRarity(filtered.filter(function(c){return hohFavIsOn(c.id);}));}
  else{filtered=filtered.filter(function(c){return isHearted(c.id);}).sort(function(a,b){return getHeartCount(b.id)-getHeartCount(a.id);});}
 }
 /* R140-Z3: FF Portraits — keep only chars marked as is_ff_portrait,
    sort by hearts desc. Only activates when the user explicitly clicks
    an FF logo (which adds the option to the dropdown via
    hohActivateFfPortraitsSort). Composes with the rest of the pipeline
    so search text + dismiss filter still work inside the FF view. */
 /* JANFAV (Jan, 2026-10-19): the FF Portraits view keeps the Rarity order (Mythic first, Jan's favorites
    first inside each tier) instead of raw legacy hearts, which had Uncommons above Mythics. */
 else if(sortVal==='ffportraits'){filtered=hohSortByRarity(filtered.filter(function(c){return !!c.is_ff_portrait;}));}
 /* HALLHERO (Jan, 2026-09-23): the "Hidden by me" view is gone. Heroes this
    device hid in Explore still leave the grid, and the count of the ones that
    would have matched feeds the quiet "Show them" line after the grid, so a
    hide is never a dead end. */
 var _hohHiddenIds=[];
 if(!_hohMod && typeof window.hohApplyDismissFilter==='function'){
  var _hohPreDismiss=filtered;
  filtered=window.hohApplyDismissFilter(filtered,sortVal);
  if(filtered.length<_hohPreDismiss.length){
   var _hohKept={}; filtered.forEach(function(c){ if(c&&c.id) _hohKept[c.id]=1; });
   _hohPreDismiss.forEach(function(c){ if(c&&c.id&&!_hohKept[c.id]) _hohHiddenIds.push(c.id); });
  }
 }
 /* Name-match relevance bump. Whenever the user typed text, promote
  exact name matches to the top, then prefix and whole-word matches,
  then everything else. Modern Array.sort is stable so the user's
  chosen sort (most/least hearts) still orders ties within each rank. */
 if(textWords.length){
 var nq=textWords.join(' ');
 filtered.sort(function(a,b){return hohNameMatchRank(a.name,nq)-hohNameMatchRank(b.name,nq);});
 }
 /* R230: Pin the featured hero to slot 1 so the Hall always opens on it.
    We move it to the front of the already filtered and already sorted
    list, but only when it survived the current filters. We do NOT force
    it in when a search or rarity filter excluded it, so searching by
    author or rarity still shows only matching heroes. Blanket pinning
    was pulled before precisely because it buried unrelated search
    results under the featured hero, so this keeps the pin for normal
    browsing while leaving an active search clean. */
 try {
   for(var _fi=0; _fi<filtered.length; _fi++){
     if(filtered[_fi] && filtered[_fi].featured){
       if(_fi>0){ filtered.unshift(filtered.splice(_fi,1)[0]); }
       break;
     }
   }
 } catch(_){}
 /* EMBERPIN (Jan, 2026-10-20): "always just put ember first in the grid after the
    featured character, even for the rarity sort". Ember (slug ember, the home hero
    deck's lead) takes the slot right after the featured pin in every sort, under
    the same rule: only when she survived the current filters.
    EMBERPIN-02 (Jan, 2026-10-28): "make sure Jan's Ember doesnt retain when they sort by Newest, she should
    only be first when srting by rarity". The pin now runs under Rarity only; every other sort shows her
    where she falls. The featured pin above still holds in every sort. */
 if(sortVal==='most') try {
   var _emSlot=(filtered[0]&&filtered[0].featured)?1:0;
   for(var _ei=_emSlot; _ei<filtered.length; _ei++){
     if(filtered[_ei] && filtered[_ei].slug==='ember'){
       if(_ei>_emSlot){ filtered.splice(_emSlot,0,filtered.splice(_ei,1)[0]); }
       break;
     }
   }
 } catch(_){}
 /* R793.1 (Jan, 2026-09-22): "the first characters in the main should
    always be the user submitted characters in rarity order". A signed-in
    player's own heroes lead normal browsing (Rarity or Newest, nothing typed
    in the search), highest tier first, ahead of the featured pin above.
    Favorited, FF portraits and a search keep their own order, and a
    signed-out visitor sees the Hall exactly as before.
    HALLHERO (Jan, 2026-09-23): "a checkbox to show yours at the top ... or if
    you uncheck it, it goes where they belong". The pin now follows the
    "My heroes first" box (on by default, remembered on this device). */
 try {
   var _me=hohHallAccountEmail();
   var _ownApplies=!!_me && !sv && !_hohMod && (sortVal==='most' || sortVal==='newest');
   if(_ownApplies && hohOwnFirstOn()){
     var _own=[], _rest=[];
     for(var _oi=0; _oi<filtered.length; _oi++){ var _oc=filtered[_oi]; ((hohIsOwnHallHero(_oc,_me)||(_oc&&_ownHid[String(_oc.id)]))?_own:_rest).push(_oc); }
     if(_own.length) filtered=hohSortByRarity(_own).concat(_rest);
   }
   hohSyncOwnFirstBox(_me,_ownApplies);
 } catch(_){}
 /* HALLNAV (Jan, 2026-09-30): the card view's arrows walk this exact order,
    the sort and filters the player is looking at (hohHallNavList). */
 window.__hohGridOrder=filtered;
 document.getElementById('hoh-count').textContent=filtered.length+(filtered.length===1?' hero':' heroes')+' found';
 var g=document.getElementById('hoh-gallery'),em=document.getElementById('hoh-empty');
 try{ hohRenderHiddenReset(_hohHiddenIds); }catch(_){}
 /* R793.1: an empty Favorited view says how to fill it */
 try{ hohSetGalleryEmptyState(em, (!filtered.length && sortVal==='liked' && hohR793Words()) ? 'favorites' : ''); }catch(_){}
 /* HALL-SPEED-02: a search no light row matches can still match a story or a badge, so until the full roster is here
    the skeleton stays up instead of "No heroes match" (the roster's own paint gives the answer) */
 var _ld=document.getElementById('hoh-loading');
 if(!filtered.length&&sv&&hohRosterArriving()){ _hohSearchHold=true; document.getElementById('hoh-count').textContent=''; g.style.display='none'; em.style.display='none'; if(_ld) _ld.style.display='flex'; return; }
 if(_hohSearchHold){ _hohSearchHold=false; if(_ld) _ld.style.display='none'; }
 if(!filtered.length){g.style.display='none';em.style.display='block';return;}
 g.style.display='grid';em.style.display='none';
 hohSmoothGridUpdate(g,filtered,{key:function(c){return c.id;},build:function(c,i){return hohBuildCardHtml(c,i,newId);},
  /* R415: every gallery render re-arms the scroll reveal. FLIP pins entering
     cards visible inline (correct mid-animation); once the pass settles, the
     rebalance hands below-fold cards back to the IntersectionObserver so the
     scroll-in entrance works after sorts, filters and searches too — not just
     on the first paint. On the empty-container first paint this fires before
     the observer exists and is a deliberate no-op (boot owns that cascade). */
 afterRender:function(){try{hohRefreshCardReveal();}catch(_){}}});
}

/* A first submission paints the new card just before its email token is stored.
   Repaint once the central sign-in transition lands so the anonymous rarity
   label immediately becomes the normal signed-in heart/lock treatment. */
try {
 document.addEventListener('hoh:signed-in', function(){
  try { renderGallery(); forceCardsVisible(); } catch(_){}
  try { hohLoadOwnHidden(); } catch(_){}
 });
} catch(_){}

/* R444 (Jan): "the NEW icon on mobile and desktop, just put it on the top
   right of the image or something, not randomly added in the names section.
   make sure theres padding."
   WHY IT LOOKED RANDOM. R259 put the same .hoh-newtag on the grid card and in
   the detail view, then overrode the detail one with .hoh-newtag-detail
   {position:static;margin-left:10px} so it sat inline beside the name. On
   desktop that reads as a chip after the rarity pill. On a phone the name row
   is flex-direction:column, so a static inline chip has nowhere to sit BESIDE
   anything and drops onto its own line, wedged between the rarity pill and
   "Dwarf Wizard". It is not a badge at that point, it is a stray word in the
   middle of the type block.
   WHERE IT GOES. On the art, in the SAME corner the grid card uses, so a hero
   that wore NEW in the grid wears it in the same place when you open them.
   Top LEFT rather than the top right Jan named, because .hoh-close-top owns
   the top right with an 80px hit area (64px on a phone) and a badge under it
   would either be covered or push the X out of the corner every phone user
   reaches for first. Same corner as the grid is the stronger consistency, and
   nothing is hidden either way.
   Living inside buildDetailImgHtml also means hohImgNav, which rebuilds this
   block by outerHTML on every arrow tap, carries the badge with it. The old
   placement was outside that block and would have survived by accident. */
function hohDetailNewTagHtml(c){
  try{
    if(!c || !c.created_at) return '';
    var t = new Date(c.created_at).getTime();
    if(isNaN(t) || (Date.now() - t) > 3*24*60*60*1000) return '';
    return '<span class="hoh-newtag hoh-newtag-detail" aria-label="New this week"><i></i><b>New</b></span>';
  }catch(_){ return ''; }
}
function buildDetailImgHtml(c,idx){
 var imgs=getImgs(c);
 if(!imgs.length)return'<div class="hoh-detail-img hoh-detail-img-empty" style="background:'+placeholderBg(c.name)+'"><div class="hoh-detail-letter">'+esc(hohInitial(c.name))+'</div>'+hohDetailNewTagHtml(c)+'<button type="button" class="hoh-close-top" onclick="hohCloseModal()" aria-label="Close hero details">&#10005;</button></div>';
 var nav='';
 if(imgs.length>1){
 nav='<button class="hoh-img-nav hoh-img-prev" onclick="hohImgNav(-1)">&#8249;</button><button class="hoh-img-nav hoh-img-next" onclick="hohImgNav(1)">&#8250;</button><div class="hoh-img-dots">';
 for(var i=0;i<imgs.length;i++)nav+='<button class="hoh-img-dot'+(i===idx?' active':'')+'" onclick="hohImgNav('+i+',true)"></button>';
 nav+='</div>';
 }
 /* Apply the user's stored vertical offset (from edit-form drag) so
    the head/body sit where they intended within the square crop.
    Slot is 'primary' for the first image, 'secondary' for the second. */
 var detailSlot = (idx === 0) ? 'primary' : 'secondary';
 var detailPos = (typeof window.hohImgObjPos === 'function') ? window.hohImgObjPos(c.id, detailSlot) : ('50% '+((typeof window.hohGetImageOffsetY === 'function') ? window.hohGetImageOffsetY(c.id, detailSlot) : 50)+'%');
 var detailStyle = (typeof window.hohImgStyle === 'function') ? window.hohImgStyle(c.id, detailSlot) : ('object-position:'+detailPos+';');
 /* R249: same save-guard the grid images carry — right-click, drag and
    long-press save are blocked on the detail art (casual protection). */
 return'<div class="hoh-detail-img" style="background:#0a0a0f" oncontextmenu="return false"><img src="'+imgs[idx]+'" alt="'+esc(c.name)+'" loading="eager" fetchpriority="high" decoding="async" crossorigin="anonymous" draggable="false" oncontextmenu="return false" data-letter="'+esc(hohInitial(c.name))+'" style="'+detailStyle+'-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;" onerror="hohImgFallback(this,\'hoh-detail-letter\')">'+nav+hohDetailNewTagHtml(c)+'<button type="button" class="hoh-close-top" onclick="hohCloseModal()" aria-label="Close hero details">&#10005;</button></div>';
}

window.hohImgNav=function(v,absolute){
 var c=currentDetail;if(!c)return;
 var imgs=getImgs(c);
 if(absolute){currentImgIdx=v;}
 else{currentImgIdx=currentImgIdx+v;if(currentImgIdx<0)currentImgIdx=imgs.length-1;if(currentImgIdx>=imgs.length)currentImgIdx=0;}
 var container=document.querySelector('.hoh-detail-img');
 if(container)container.outerHTML=buildDetailImgHtml(c,currentImgIdx);
};

/* ============================================================
 NPC CARD GENERATION + RENDERING
 ============================================================ */
function renderNpcSection(c,spotlight){
 if(c.npc_card){return renderNpcCardHtml(c.npc_card,spotlight);}
 return '<div class="hoh-npc-loading" id="hoh-npc-loading-'+c.id+'"><div class="hoh-npc-loading-spinner"></div><p class="hoh-npc-loading-text">Bringing '+esc(c.name)+' to life as an NPC...</p></div>';
}

function renderSpotlightBox(card,spotlight){
 if(!spotlight)return'';
 var spotHook='',spotLabel='',spotSub='';
 if(spotlight==='ally'){spotHook=card.ally_hook||'';spotLabel='Using them as an ally';spotSub='How they fit as a friend, contact, or helper';}
 else if(spotlight==='villain'){spotHook=card.enemy_hook||'';spotLabel='Using them as a villain';spotSub='How they fit as an antagonist or threat';}
 else if(spotlight==='shopkeeper'){spotHook=card.quest_hook||'';spotLabel='Using them as a shopkeeper';spotSub='How they fit as a merchant or townsfolk';}
 else if(spotlight==='wild'){return'';}
 if(!spotHook)return'';
 return '<div class="hoh-npc-spotlight">'+
 '<div class="hoh-npc-spotlight-label">'+esc(spotLabel)+'</div>'+
 '<p class="hoh-npc-spotlight-hook">'+esc(spotHook)+'</p>'+
 '<div class="hoh-npc-spotlight-sub">'+esc(spotSub)+'. Full card below.</div>'+
 '</div>';
}

function renderNpcCardHtml(card,spotlight){
 if(!card||typeof card!=='object')return renderNpcRetryHtml();
 var disp=card.disposition||'Neutral';
 return renderSpotlightBox(card,spotlight)+
 '<div class="hoh-npc-card">'+
 '<div class="hoh-npc-disp">'+esc(disp)+' &middot; '+esc(card.occupation||'Adventurer')+'</div>'+
 '<p class="hoh-npc-hook">'+esc(card.hook||'')+'</p>'+
 '<div class="hoh-npc-grid">'+
  '<div class="hoh-npc-field"><span class="hoh-npc-field-label">Wants</span><span class="hoh-npc-field-value">'+esc(card.wants||'')+'</span></div>'+
  '<div class="hoh-npc-field"><span class="hoh-npc-field-label">Fears</span><span class="hoh-npc-field-value">'+esc(card.fears||'')+'</span></div>'+
  '<div class="hoh-npc-field"><span class="hoh-npc-field-label">Voice</span><span class="hoh-npc-field-value">'+esc(card.voice||'')+'</span></div>'+
  '<div class="hoh-npc-field"><span class="hoh-npc-field-label">Tell</span><span class="hoh-npc-field-value">'+esc(card.tic||'')+'</span></div>'+
 '</div>'+
 '<div class="hoh-npc-hooks">'+
  '<div class="hoh-npc-hooks-label">Three ways to drop them into your game</div>'+
  '<div class="hoh-npc-hook-item'+(spotlight==='ally'?' hoh-npc-hook-active':'')+'"><span class="hoh-npc-hook-type">Ally</span><span>'+esc(card.ally_hook||'')+'</span></div>'+
  '<div class="hoh-npc-hook-item'+(spotlight==='villain'?' hoh-npc-hook-active':'')+'"><span class="hoh-npc-hook-type">Enemy</span><span>'+esc(card.enemy_hook||'')+'</span></div>'+
  '<div class="hoh-npc-hook-item'+(spotlight==='shopkeeper'?' hoh-npc-hook-active':'')+'"><span class="hoh-npc-hook-type">Quest</span><span>'+esc(card.quest_hook||'')+'</span></div>'+
 '</div>'+
 '<div class="hoh-npc-actions">'+
  '<button class="hoh-npc-btn" onclick="hohNpcDownloadPdf()">&#8615; Download NPC Card</button>'+
  '<button class="hoh-npc-btn" onclick="hohNpcCopyText()">&#9783; Copy as Text</button>'+
 '</div>'+
 /* R140-Z3p: NPC stat block mount. Renders the D&D 5e stat block
    when the current character has stats_block set AND the user has
    unlocked it. Unlock check today is always true; future hearts-
    paywall flips it. Empty container when no stats — zero DOM cost. */
 '<div id="hoh-npc-stats-display-mount" class="hoh-npc-stats-display-mount"></div>'+
 '</div>';
}
/* R140-Z3p: Wire the stat block into the NPC section after the
   existing card renders. Called from the render flow. Pulls the
   current character's stats_block from the cached row. */
function hohRenderCurrentNpcStats(c){
 try {
   var mount = document.getElementById('hoh-npc-stats-display-mount');
   if(!mount) return;
   if(!c || !c.stats_block){
     mount.innerHTML = '';
     return;
   }
   /* Permission gate — paywall hook. */
   if(typeof window.hohNpcStatsAreUnlocked === 'function' && !window.hohNpcStatsAreUnlocked(c.id)){
     mount.innerHTML = '';
     return;
   }
   if(typeof window.hohRenderNpcStatsDisplay === 'function'){
     window.hohRenderNpcStatsDisplay(mount, c.stats_block);
   }
 } catch(_){}
}
window.hohRenderCurrentNpcStats = hohRenderCurrentNpcStats;

function renderNpcRetryHtml(){
 return '<div class="hoh-npc-retry"><p class="hoh-npc-retry-text">Something snagged while generating the NPC card.</p><button class="hoh-npc-retry-btn" onclick="hohNpcGenerate()">Try again</button></div>';
}

async function generateNpcCard(c){
 try{
 if(window.hohTools){
  var next=await window.hohTools.generate(c,true);
  if(!next)return null;
  return {hook:next.opening,wants:next.wants,fears:next.pressure,voice:next.play,tic:next.play,ally_hook:next.help,enemy_hook:next.push,quest_hook:next.connection,disposition:'Neutral',occupation:c.character_class||'Adventurer'};
 }
 var resp=await fetch(NPC_WORKER_URL,{
  method:'POST',
  headers:{'Content-Type':'application/json'},
  body:JSON.stringify({
  name:c.name,race:c.race,character_class:c.character_class,level:c.level,campaign:c.campaign,story:c.story,
  npc_current_goal:c.npc_current_goal,npc_hidden_weakness:c.npc_hidden_weakness,npc_habit:c.npc_habit,
  npc_catchphrase:c.npc_catchphrase,npc_secret:c.npc_secret,npc_enemy:c.npc_enemy
  })
 });
 if(!resp.ok){console.error('[NPC] Worker HTTP',resp.status,resp.statusText);throw new Error('worker '+resp.status);}
 var data=await resp.json();
 if(!data.success||!data.card){console.error('[NPC] Worker payload error:',data);throw new Error(data.error||'generation failed');}
 var saveRes=await supabase.from('characters').update({npc_card:data.card}).eq('id',c.id);
 if(saveRes&&saveRes.error)console.error('[NPC] Supabase save failed (RLS or schema?):',saveRes.error);
 c.npc_card=data.card;
 var idx=allCharacters.findIndex(function(x){return x.id===c.id;});
 if(idx>=0)allCharacters[idx].npc_card=data.card;
 return data.card;
 }catch(e){
 console.error('[NPC] Generation error:',e);
 return null;
 }
}

window.hohNpcGenerate=async function(){
 if(!currentDetail)return;
 var container=document.getElementById('hoh-npc-content');
 if(container)container.innerHTML='<div class="hoh-npc-loading"><div class="hoh-npc-loading-spinner"></div><p class="hoh-npc-loading-text">Bringing '+esc(currentDetail.name)+' to life as an NPC...</p></div>';
 var card=await generateNpcCard(currentDetail);
 if(container){container.innerHTML=card?renderNpcCardHtml(card,currentSpotlight):renderNpcRetryHtml();}
 /* R140-Z3p: After the NPC card renders, append the D&D 5e stat
    block (if the character has one + the user is unlocked). The
    container's inner HTML includes the empty mount div, so this
    just fills it. */
 try { hohRenderCurrentNpcStats(currentDetail); } catch(_){}
};

/* R143-D: hohScrollToNpc is now the SINGLE entry point that both
   reveals the NPC panel (it's collapsed by default) and scrolls it
   into view. The "Use as NPC" button at the top of the modal is the
   only thing that triggers this. The header itself is non-interactive
   per user spec — it's a label, not a toggle.

   Sequencing matters here:
   1. Remove the collapsed class so the CSS max-height transition
      starts unfurling the panel.
   2. Kick off the smooth-scroll on the NEXT frame (rAF) — by then
      the panel has begun expanding, so scrollTo lands on the right
      target position. If we scrolled first, we'd scroll to where the
      collapsed section USED to be (a much shorter target).
   3. After the expand transition completes (~380ms), trigger the
      stat-block "build in" animation so the stats fade up after the
      persona card is settled. This creates a sequenced reveal: card
      first, then stats. */
window.hohScrollToNpc=function(){
 var section=document.getElementById('hoh-npc-section');
 if(!section)return;
 var alreadyOpen = !section.classList.contains('hoh-npc-section-collapsed');
 if(!alreadyOpen){
   section.classList.remove('hoh-npc-section-collapsed');
   section.classList.add('hoh-npc-section-opening');
   /* The stat block lives at #hoh-npc-stats-display-mount. We tag
      it with a one-shot animation class after the section expand
      completes so the stats slide+fade in last. */
   setTimeout(function(){
     try {
       var statMount = document.getElementById('hoh-npc-stats-display-mount');
       if(statMount) statMount.classList.add('hoh-npc-stats-build-in');
     } catch(_){}
   }, 380);
   /* Remove the "opening" hint after the transition so subsequent
      taps don't re-trigger the animation. */
   setTimeout(function(){
     try { section.classList.remove('hoh-npc-section-opening'); } catch(_){}
   }, 800);
 }
 requestAnimationFrame(function(){
   var scrollContainer=section.closest('.hoh-modal-content');
   if(scrollContainer&&typeof scrollContainer.scrollTo==='function'){
     var headerOffset=16;
     var targetTop=section.offsetTop-headerOffset;
     scrollContainer.scrollTo({top:targetTop,behavior:'smooth'});
   }else{
     section.scrollIntoView({behavior:'smooth',block:'start'});
   }
 });
};

window.hohNpcCopyText=function(){
 if(!currentDetail||!currentDetail.npc_card)return;
 var c=currentDetail,card=c.npc_card;
 var text=c.name+'\n'+c.race+' '+c.character_class+(c.level?' (Level '+c.level+')':'')+'\n'+
 (card.disposition||'')+' '+(card.occupation||'')+'\n\n'+
 (card.hook||'')+'\n\n'+
 'Wants: '+(card.wants||'')+'\n'+
 'Fears: '+(card.fears||'')+'\n'+
 'Voice: '+(card.voice||'')+'\n'+
 'Tell: '+(card.tic||'')+'\n\n'+
 'Ally: '+(card.ally_hook||'')+'\n'+
 'Enemy: '+(card.enemy_hook||'')+'\n'+
 'Quest: '+(card.quest_hook||'')+'\n\n'+
 'From the Hall of Heroes at FramedFantasy.com/HoH';
 navigator.clipboard.writeText(text).then(function(){
 hohTrackExport(c.id);
 var btn=document.querySelector('.hoh-npc-actions .hoh-npc-btn:last-child');
 if(btn){var o=btn.innerHTML;btn.innerHTML='Copied!';setTimeout(function(){btn.innerHTML=o;},2000);}
 });
};

function loadImageForPdf(url){
 return new Promise(function(resolve){
 if(!url){resolve(null);return;}
 var img=new Image();
 img.crossOrigin='anonymous';
 img.onload=function(){
  try{
  var canvas=document.createElement('canvas');
  var maxDim=900;
  var w=img.naturalWidth,h=img.naturalHeight;
  if(w>maxDim||h>maxDim){
   var ratio=Math.min(maxDim/w,maxDim/h);
   w=Math.round(w*ratio);h=Math.round(h*ratio);
  }
  canvas.width=w;canvas.height=h;
  var ctx=canvas.getContext('2d');
  ctx.fillStyle='#0a0a0f';ctx.fillRect(0,0,w,h);
  ctx.drawImage(img,0,0,w,h);
  var dataUrl=canvas.toDataURL('image/jpeg',0.82);
  resolve({dataUrl:dataUrl,width:w,height:h});
  }catch(e){console.error('Canvas extract failed',e);resolve(null);}
 };
 img.onerror=function(){resolve(null);};
 img.src=url;
 });
}

/* R143-E: NPC PDF rewrite.
   Changes from previous version:
     - Dropped the "HoH NPC Summoner" header banner. The page now opens
       directly with the character's name + meta line so the user gets
       to the content immediately. The brand still lives in the footer.
     - Tighter vertical rhythm. Name + meta + disposition tag stack
       up top, image sits centered below, persona hook reads under
       the image, then the Wants/Fears/Voice/Tell quadrant + the
       three game-hooks. Less chrome, more content.
     - Page 2 appended automatically when c.stats_block is present.
       Renders the full D&D 5e stat block: ability table, saves/skills/
       senses, traits, actions, bonus actions, reactions. If a stat
       category overflows, page 3 is added on the fly.
     - Footer kept simple \u2014 submitter byline + FramedFantasy URL.
       Dropped the long "Every character submitted..." line, it was
       marketing copy on a tool that DMs print for their table. */
window.hohNpcDownloadPdf=async function(){
 if(!currentDetail||!currentDetail.npc_card)return;
 /* R200: account-tied export — a signed-out visitor can't download the NPC
    card. Nudge them to submit a hero first (same gate as the other exports). */
 if(typeof window.hohIsHallSignedIn==='function' && !window.hohIsHallSignedIn()){
   if(typeof window.hohOpenSubmitToEarnModal==='function'){ try{ window.hohOpenSubmitToEarnModal(null); }catch(_){ } }
   else if(typeof window.hohOpenForm==='function'){ try{ window.hohOpenForm(); }catch(_){ } }
   return;
 }
 var c=currentDetail,card=c.npc_card;
 var btn=document.querySelector('.hoh-npc-actions .hoh-npc-btn:first-child');
 if(btn){btn.disabled=true;btn.innerHTML='Preparing...';}
 try{
 try{await window.hohEnsureJsPDF();}
 catch(loadErr){
  if(btn){btn.disabled=false;btn.innerHTML='&#8615; Download NPC Card';}
  alert('PDF library failed to load. Check your connection and try again.');
  return;
 }
 var imgs=getImgs(c);
 var loaded=await Promise.all(imgs.slice(0,2).map(loadImageForPdf));
 var img1=loaded[0],img2=loaded[1];

 var jsPDF=window.jspdf.jsPDF;
 var pdf=new jsPDF({unit:'pt',format:'letter'});
 var pageW=612,pageH=792,margin=48;
 var contentW=pageW-margin*2;

 /* Shared footer renderer so page 1 + page 2 close consistently. */
 function drawFooter(pageNum, totalPages){
   var footerY = pageH - 36;
   pdf.setDrawColor(200,164,94);
   pdf.setLineWidth(0.3);
   pdf.line(margin, footerY - 8, pageW - margin, footerY - 8);
   pdf.setFont('helvetica','italic');
   pdf.setFontSize(8);
   pdf.setTextColor(120,114,134);
   pdf.text('Submitted by ' + (c.player_name || 'Anonymous'), margin, footerY + 2);
   pdf.setFont('helvetica','normal');
   pdf.setTextColor(140,134,154);
   var brand = 'FramedFantasy.com / Hall of Heroes';
   if(totalPages > 1){
     brand += '   \u00b7   ' + pageNum + ' / ' + totalPages;
   }
   pdf.text(brand, pageW - margin, footerY + 2, { align: 'right' });
 }

 /* ============================ PAGE 1 ============================ */
 /* No banner band. Name + meta lead. */
 var y = margin + 6;

 /* R166: Page-break helper used throughout page 1 so long submissions
    (multi-line hooks, novella-length wants/fears, very long action
    names) don't get clipped at the bottom of the page. Mirrors the
    ensureRoom() inside page 2 \u2014 when the next section wouldn't fit
    above the footer band, we addPage() and reset y. Long content now
    flows onto page 2 (or 3, etc.) instead of vanishing below the
    page edge. */
 function ensureRoomPg1(needed){
   if(y + needed > pageH - 60){
     pdf.addPage();
     y = margin + 6;
   }
 }

 /* R166: Title wraps to contentW so a long name (e.g. "Lady
    Marguerite Eldris Vaszily of the Eastern Reaches") wraps onto a
    second line instead of running off both sides of the page. Center
    alignment is preserved for the wrapped lines. */
 pdf.setFont('helvetica','bold');
 pdf.setFontSize(26);
 pdf.setTextColor(200,164,94);
 var titleLines = pdf.splitTextToSize(c.name || 'Unnamed', contentW);
 pdf.text(titleLines, pageW/2, y, { align: 'center' });
 y += 22 + (titleLines.length - 1) * 26;

 /* R166: Meta line wraps too. Long campaign names ("The Adventures
    of Tel'Ambar \u2014 Volume Two") would have run off the page edge. */
 pdf.setFont('helvetica','normal');
 pdf.setFontSize(11.5);
 pdf.setTextColor(120,114,134);
 var metaLine = [c.race || '', c.character_class || ''].filter(Boolean).join(' ');
 if(c.level) metaLine += '  \u00b7  Level ' + c.level;
 if(c.campaign) metaLine += '  \u00b7  ' + c.campaign;
 var metaLines = pdf.splitTextToSize(metaLine, contentW);
 pdf.text(metaLines, pageW/2, y, { align: 'center' });
 y += 14 + (metaLines.length - 1) * 14;

 /* Disposition \u00b7 Occupation tag \u2014 small blue chip centered under meta.
    R166: Auto-shrink the font + clamp the chip width so a long
    "ENIGMATIC TRAVELLING WIZARD-OF-THE-NORTH" occupation can't
    extend past the page margins. We start at 8.5pt and step down to
    a 6pt floor; if it still won't fit, the chip clamps to contentW
    and the text scales with it via splitTextToSize as a last resort. */
 pdf.setFillColor(164,216,255);
 pdf.setTextColor(10,10,15);
 pdf.setFont('helvetica','bold');
 var tagText = (card.disposition || 'Neutral').toUpperCase()
   + '  \u00b7  ' + (card.occupation || 'Adventurer').toUpperCase();
 var tagFs = 8.5;
 pdf.setFontSize(tagFs);
 var tagW = pdf.getTextWidth(tagText) + 18;
 while(tagW > contentW && tagFs > 6){
   tagFs -= 0.5;
   pdf.setFontSize(tagFs);
   tagW = pdf.getTextWidth(tagText) + 18;
 }
 if(tagW > contentW){
   /* Still too wide at 6pt \u2014 clamp and ellipsize. */
   tagW = contentW;
   var clamped = tagText;
   while(pdf.getTextWidth(clamped + '\u2026') + 18 > contentW && clamped.length > 4){
     clamped = clamped.slice(0, -1);
   }
   tagText = clamped + '\u2026';
 }
 var tagX = (pageW - tagW) / 2;
 pdf.roundedRect(tagX, y - 2, tagW, 16, 2, 2, 'F');
 pdf.text(tagText, pageW/2, y + 9, { align: 'center' });
 y += 24;

 /* Image(s). Centered, single image at 0.48 contentW, dual side-by-side. */
 function drawImageFit(imgData, x, y, boxW, boxH){
   if(!imgData) return { drew:false, bottom:y };
   var ratio = imgData.width / imgData.height;
   var drawW = boxW, drawH = boxW / ratio;
   if(drawH > boxH){ drawH = boxH; drawW = boxH * ratio; }
   var offsetX = x + (boxW - drawW) / 2;
   var offsetY = y + (boxH - drawH) / 2;
   pdf.setDrawColor(200,164,94);
   pdf.setLineWidth(0.8);
   pdf.rect(offsetX - 1, offsetY - 1, drawW + 2, drawH + 2);
   pdf.addImage(imgData.dataUrl, 'JPEG', offsetX, offsetY, drawW, drawH);
   pdf.setLineWidth(0.2);
   return { drew:true, bottom: offsetY + drawH };
 }

 var imgMaxH = 220;
 var imgBottom = y;
 if(img1 && img2){
   var gap = 20;
   var eachW = (contentW - gap) / 2;
   var groupW = eachW * 2 + gap;
   var groupX = margin + (contentW - groupW) / 2;
   var r1 = drawImageFit(img1, groupX, y, eachW, imgMaxH);
   var r2 = drawImageFit(img2, groupX + eachW + gap, y, eachW, imgMaxH);
   imgBottom = Math.max(r1.bottom, r2.bottom);
 } else if(img1){
   var singleW = contentW * 0.46;
   var rS = drawImageFit(img1, margin + (contentW - singleW) / 2, y, singleW, imgMaxH);
   imgBottom = rS.bottom;
 }
 y = imgBottom + 10;

 /* Portrait byline directly under the image. */
 if(img1 || img2){
   pdf.setFont('helvetica','italic');
   pdf.setFontSize(8.5);
   if(c.is_ff_portrait){
     pdf.setTextColor(200,164,94);
     pdf.text('Portrait by Jan at FramedFantasy', pageW/2, y, { align: 'center' });
   } else {
     pdf.setTextColor(140,134,154);
     pdf.text('Image uploaded by submitter', pageW/2, y, { align: 'center' });
   }
   y += 16;
 }

 /* Hook quote \u2014 italic, slightly larger, centered.
    R166: ensureRoomPg1 prevents a long quote from clipping past the
    page bottom \u2014 if it won't fit, the hook flows onto page 2. */
 if(card.hook){
   pdf.setFont('helvetica','italic');
   pdf.setFontSize(12.5);
   pdf.setTextColor(40,40,52);
   var hookLines = pdf.splitTextToSize('\u201c' + card.hook + '\u201d', contentW - 30);
   ensureRoomPg1(hookLines.length * 16 + 14);
   pdf.text(hookLines, pageW/2, y + 2, { align: 'center' });
   y += hookLines.length * 16 + 10;
 }

 /* Dashed divider. */
 pdf.setDrawColor(164,216,255);
 pdf.setLineDashPattern([2,3], 0);
 pdf.line(margin, y, pageW - margin, y);
 pdf.setLineDashPattern([], 0);
 y += 16;

 /* Wants/Fears/Voice/Tell quadrant.
    R166: drawTraitField now MEASURES the wrapped lines first and the
    caller reserves room for the tallest column before drawing. This
    keeps the two side-by-side fields aligned AND prevents a very
    long value from running off the page bottom. */
 function drawTraitField(label, value, xStart, yStart){
   pdf.setFont('helvetica','normal');
   pdf.setFontSize(11);
   var colW = (contentW - 20) / 2;
   var valueLines = pdf.splitTextToSize(value || '', colW);
   pdf.setFont('helvetica','bold');
   pdf.setFontSize(8.5);
   pdf.setTextColor(80,140,200);
   pdf.text(label.toUpperCase(), xStart, yStart);
   pdf.setFont('helvetica','normal');
   pdf.setFontSize(11);
   pdf.setTextColor(30,30,40);
   pdf.text(valueLines, xStart, yStart + 13);
   return valueLines.length * 13 + 18;
 }
 /* Measure each cell's needed height before drawing so we can
    ensureRoom for the tallest cell across both rows. */
 function measureTraitField(value){
   pdf.setFont('helvetica','normal');
   pdf.setFontSize(11);
   var colW = (contentW - 20) / 2;
   var valueLines = pdf.splitTextToSize(value || '', colW);
   return valueLines.length * 13 + 18;
 }
 var col1X = margin, col2X = margin + contentW/2 + 10;
 var row1Needed = Math.max(measureTraitField(card.wants), measureTraitField(card.fears));
 var row2Needed = Math.max(measureTraitField(card.voice), measureTraitField(card.tic));
 ensureRoomPg1(row1Needed + row2Needed + 8);
 var rowY = y;
 var hA = drawTraitField('Wants', card.wants, col1X, rowY);
 var hB = drawTraitField('Fears', card.fears, col2X, rowY);
 rowY += Math.max(hA, hB);
 var hC = drawTraitField('Voice', card.voice, col1X, rowY);
 var hD = drawTraitField('Tell', card.tic, col2X, rowY);
 y = rowY + Math.max(hC, hD) + 4;

 /* Dashed divider. */
 pdf.setDrawColor(164,216,255);
 pdf.setLineDashPattern([2,3], 0);
 pdf.line(margin, y, pageW - margin, y);
 pdf.setLineDashPattern([], 0);
 y += 16;

 /* Three game-hook deployments.
    R166: Each hook now reserves room before drawing so a long
    ally/enemy/quest description wraps within contentW AND flows to
    a new page if it would clip the footer. */
 ensureRoomPg1(20 + 18 * 3);
 pdf.setFont('helvetica','bold');
 pdf.setFontSize(9.5);
 pdf.setTextColor(80,140,200);
 pdf.text('THREE WAYS TO DROP THEM INTO YOUR GAME', margin, y);
 y += 20;

 function drawDeployHook(type, text){
   /* Pre-measure so ensureRoomPg1 can break the page before drawing
      half a hook. */
   pdf.setFont('helvetica','normal');
   pdf.setFontSize(11);
   var lines = pdf.splitTextToSize(text || '', contentW - 66);
   var needed = Math.max(18, lines.length * 13) + 6;
   ensureRoomPg1(needed);
   var labelY = y;
   pdf.setFillColor(230,242,252);
   pdf.roundedRect(margin, labelY - 9, 52, 15, 2, 2, 'F');
   pdf.setFont('helvetica','bold');
   pdf.setFontSize(8);
   pdf.setTextColor(60,120,180);
   pdf.text(type.toUpperCase(), margin + 26, labelY + 1, { align: 'center' });
   pdf.setFont('helvetica','normal');
   pdf.setFontSize(11);
   pdf.setTextColor(30,30,40);
   pdf.text(lines, margin + 60, y);
   return needed;
 }
 y += drawDeployHook('Ally', card.ally_hook);
 y += drawDeployHook('Enemy', card.enemy_hook);
 y += drawDeployHook('Quest', card.quest_hook);

 /* ============================ PAGE 2: Stat Block ============================ */
 /* Only when the character actually has a stats_block. We use the
    HOH_NPC_STATS.normalize helper so missing fields are filled in
    with safe defaults; hasContent() is checked elsewhere. */
 var hasStatBlock = !!(c.stats_block && window.HOH_NPC_STATS
   && typeof window.HOH_NPC_STATS.hasContent === 'function'
   && window.HOH_NPC_STATS.hasContent(c.stats_block));
 var totalPages = hasStatBlock ? 2 : 1;

 if(hasStatBlock){
   pdf.addPage();
   var stats = window.HOH_NPC_STATS.normalize(c.stats_block);
   var sy = margin + 6;

   function modOfScore(score){
     var n = parseInt(score, 10);
     if(isNaN(n)) return 0;
     return Math.floor((n - 10) / 2);
   }
   function fmtModNum(m){ return (m >= 0 ? '+' : '') + m; }
   function fmtModMap(m){
     if(!m) return '';
     return Object.keys(m).map(function(k){
       var v = m[k];
       return k.charAt(0).toUpperCase() + k.slice(1) + ' ' + fmtModNum(parseInt(v,10)||0);
     }).join(', ');
   }
   /* Page-break guard. Call before drawing anything that needs N px.
      If insufficient space, add a fresh page and reset sy. The footer
      is drawn for ALL pages at the very end (after we know the final
      page count), so we don't draw it here. */
   function ensureRoom(needed){
     if(sy + needed > pageH - 60){
       pdf.addPage();
       totalPages++;
       sy = margin + 6;
     }
   }

   /* Header: character name + "Stat Block" label */
   pdf.setFont('helvetica','bold');
   pdf.setFontSize(20);
   pdf.setTextColor(200,164,94);
   pdf.text(c.name || 'Unnamed', pageW/2, sy, { align: 'center' });
   sy += 18;
   pdf.setFont('helvetica','bold');
   pdf.setFontSize(10);
   pdf.setTextColor(80,140,200);
   pdf.text('NPC STAT BLOCK', pageW/2, sy, { align: 'center' });
   sy += 14;

   /* Meta italic: Size Type Alignment */
   pdf.setFont('helvetica','italic');
   pdf.setFontSize(10.5);
   pdf.setTextColor(80,76,90);
   var sMeta = [stats.size, stats.type, stats.alignment].filter(Boolean).join(' ');
   if(sMeta){
     pdf.text(sMeta, pageW/2, sy, { align: 'center' });
   }
   sy += 18;

   /* Gold rule divider */
   pdf.setDrawColor(200,164,94);
   pdf.setLineWidth(0.5);
   pdf.line(margin, sy, pageW - margin, sy);
   pdf.setLineWidth(0.2);
   sy += 14;

   /* AC / HP / Speed \u2014 wraps via splitTextToSize.
      R166: ensureRoom now uses the ACTUAL wrapped line count, not a
      flat 16-unit guess. The old code reserved space for one line
      then drew N lines \u2014 when "Saving Throws" or "Languages" had
      enough entries to wrap 3-4 times, lines 2..N ran off the page
      bottom (or onto the footer). Pre-measure \u2192 reserve \u2192 draw. */
   function statLine(label, value){
     if(!value && value !== 0) return;
     pdf.setFont('helvetica','bold');
     pdf.setFontSize(11);
     var labelW = pdf.getTextWidth(label) + 4;
     pdf.setFont('helvetica','normal');
     var lines = pdf.splitTextToSize(String(value), Math.max(40, contentW - labelW));
     var needed = Math.max(14, lines.length * 13) + 2;
     ensureRoom(needed);
     pdf.setFont('helvetica','bold');
     pdf.setFontSize(11);
     pdf.setTextColor(80,140,200);
     pdf.text(label, margin, sy);
     pdf.setFont('helvetica','normal');
     pdf.setTextColor(30,30,40);
     pdf.text(lines, margin + labelW, sy);
     sy += Math.max(14, lines.length * 13);
   }
   var acStr = stats.ac.value
     ? stats.ac.value + (stats.ac.source ? ' (' + stats.ac.source + ')' : '')
     : null;
   var hpStr = stats.hp.average
     ? stats.hp.average + (stats.hp.formula ? ' (' + stats.hp.formula + ')' : '')
     : null;
   statLine('Armor Class', acStr);
   statLine('Hit Points', hpStr);
   statLine('Speed', stats.speed);

   sy += 4;
   pdf.setDrawColor(200,164,94);
   pdf.setLineWidth(0.5);
   pdf.line(margin, sy, pageW - margin, sy);
   pdf.setLineWidth(0.2);
   sy += 14;

   /* 6-ability score table \u2014 bordered cells, label on top, score+mod below */
   ensureRoom(50);
   var ab = stats.abilities;
   var abList = ['str','dex','con','int','wis','cha'];
   var cellW = contentW / 6;
   var cellH = 40;
   pdf.setDrawColor(200,164,94);
   pdf.setLineWidth(0.5);
   for(var ai = 0; ai < abList.length; ai++){
     var cx = margin + ai * cellW;
     pdf.setFillColor(248,244,232);
     pdf.rect(cx + 2, sy, cellW - 4, cellH, 'F');
     pdf.rect(cx + 2, sy, cellW - 4, cellH);
     pdf.setFont('helvetica','bold');
     pdf.setFontSize(9);
     pdf.setTextColor(80,140,200);
     pdf.text(abList[ai].toUpperCase(), cx + cellW/2, sy + 12, { align: 'center' });
     pdf.setFont('helvetica','normal');
     pdf.setFontSize(11);
     pdf.setTextColor(30,30,40);
     var score = ab[abList[ai]];
     var mod = modOfScore(score);
     pdf.text(score + ' (' + fmtModNum(mod) + ')', cx + cellW/2, sy + 28, { align: 'center' });
   }
   pdf.setLineWidth(0.2);
   sy += cellH + 14;

   pdf.setDrawColor(200,164,94);
   pdf.setLineWidth(0.5);
   pdf.line(margin, sy, pageW - margin, sy);
   pdf.setLineWidth(0.2);
   sy += 14;

   /* Saves / Skills / Senses / Languages / Challenge \u2014 same line style */
   var savesStr = Object.keys(stats.saves).length ? fmtModMap(stats.saves) : null;
   var skillsStr = Object.keys(stats.skills).length ? fmtModMap(stats.skills) : null;
   var crStr = stats.challenge.cr
     ? stats.challenge.cr + (stats.challenge.xp ? ' (' + stats.challenge.xp + ' XP)' : '')
     : null;
   statLine('Saving Throws', savesStr);
   statLine('Skills', skillsStr);
   statLine('Senses', stats.senses);
   statLine('Languages', stats.languages);
   statLine('Challenge', crStr);

   /* Traits / Actions / Bonus Actions / Reactions \u2014 each section has
      a colored heading + per-entry "Name. description" line. */
   function entrySection(label, entries){
     if(!entries || !entries.length) return;
     ensureRoom(28);
     sy += 8;
     pdf.setDrawColor(200,164,94);
     pdf.setLineWidth(0.5);
     pdf.line(margin, sy, pageW - margin, sy);
     pdf.setLineWidth(0.2);
     sy += 14;
     pdf.setFont('helvetica','bold');
     pdf.setFontSize(11.5);
     pdf.setTextColor(80,140,200);
     pdf.text(label, margin, sy);
     sy += 14;
     entries.forEach(function(e){
       if(!e || !e.name) return;
       var name = (e.name || '').trim();
       var desc = (e.desc || '').trim();
       pdf.setFont('helvetica','bolditalic');
       pdf.setFontSize(10.5);
       pdf.setTextColor(30,30,40);
       var nameStr = name + '.  ';
       var nameW = pdf.getTextWidth(nameStr);
       /* R166: Two layout modes depending on how wide the bold name is.
          INLINE (the common case): bold "Name." hugs the start of the
            first description line, body wraps below.
          STACKED (long name): if the name eats more than ~75% of the
            content width OR is wider than contentW, the inline gap
            for the first description line collapses (or goes
            negative — splitTextToSize would crash) — so we draw the
            name on its OWN line (wrapping if necessary) and the
            description on subsequent lines below at full width.
            This handles long action names like "Multiattack with
            Greatsword and Spell Reflection (Recharge 5-6)" without
            chopping them in half mid-render. */
       var MIN_FIRSTLINE_W = Math.max(80, contentW * 0.25);
       var firstW = contentW - nameW;
       if(nameW >= contentW || firstW < MIN_FIRSTLINE_W){
         /* STACKED layout. */
         pdf.setFont('helvetica','bolditalic');
         var nameLines = pdf.splitTextToSize(name + '.', contentW);
         pdf.setFont('helvetica','normal');
         var descLines = desc ? pdf.splitTextToSize(desc, contentW) : [];
         ensureRoom(nameLines.length * 13 + descLines.length * 12 + 6);
         pdf.setFont('helvetica','bolditalic');
         pdf.text(nameLines, margin, sy);
         sy += nameLines.length * 13;
         if(descLines.length){
           pdf.setFont('helvetica','normal');
           pdf.text(descLines, margin, sy);
           sy += descLines.length * 12;
         }
         sy += 4;
       } else {
         /* INLINE layout — original behaviour. */
         pdf.setFont('helvetica','normal');
         var lines = pdf.splitTextToSize(desc, firstW);
         var firstLine = lines.shift() || '';
         var rest = lines.length ? pdf.splitTextToSize(lines.join(' '), contentW) : [];
         ensureRoom(13 + rest.length * 12 + 4);
         pdf.setFont('helvetica','bolditalic');
         pdf.text(nameStr, margin, sy);
         pdf.setFont('helvetica','normal');
         pdf.text(firstLine, margin + nameW, sy);
         sy += 13;
         if(rest.length){
           pdf.text(rest, margin, sy);
           sy += rest.length * 12;
         }
         sy += 4;
       }
     });
   }
   entrySection('Traits', stats.traits);
   entrySection('Actions', stats.actions);
   entrySection('Bonus Actions', stats.bonus_actions);
   entrySection('Reactions', stats.reactions);
 }

 /* Footers go on every page at the end. We use jsPDF's internal page
    count rather than our totalPages tracker so it's always correct
    even if a code path forgot to increment. */
 var finalPages = pdf.internal.getNumberOfPages();
 for(var fp = 1; fp <= finalPages; fp++){
   pdf.setPage(fp);
   drawFooter(fp, finalPages);
 }

 var fileName = (c.name || 'character').replace(/[^a-zA-Z0-9]/g, '_') + '_NPC_Card.pdf';
 pdf.save(fileName);
 hohTrackExport(c.id);
 if(btn){ btn.disabled = false; btn.innerHTML = '&#8615; Download NPC Card'; }
 }catch(e){
 console.error('[NPC] PDF error:', e);
 alert('Could not generate PDF. Please try again.');
 if(btn){ btn.disabled = false; btn.innerHTML = '&#8615; Download NPC Card'; }
 }
};

function hohTrackExport(charId){
 var key='hoh-npc-exports';
 var exported;
 try{exported=JSON.parse(localStorage.getItem(key)||'[]');}catch(e){exported=[];}
 if(exported.indexOf(charId)!==-1)return;
 exported.push(charId);
 localStorage.setItem(key,JSON.stringify(exported));
 supabase.rpc('increment_npc_exports',{row_id:charId}).then(function(){
 var ch=allCharacters.find(function(x){return x.id===charId;});
 if(ch)ch.npc_exports=(ch.npc_exports||0)+1;
 }).catch(function(e){console.error(e);});
}

var SHOPKEEPER_WORDS=['shopkeeper','merchant','trader','blacksmith','apothecary','tavern','innkeeper','keeper','baker','smith','seller','vendor','brewer','cook','tailor','herbalist','bookseller'];

function matchesArchetype(c,archetype){
 if(archetype==='ally'||archetype==='villain'||archetype==='wild')return!!c.npc_card;
 if(archetype==='shopkeeper'){
 if(!c.npc_card)return false;
 var occ=(c.npc_card.occupation||'').toLowerCase();
 return SHOPKEEPER_WORDS.some(function(w){return occ.indexOf(w)!==-1;});
 }
 return true;
}

window.hohSummonRandomNpc=function(directArchetype){
 /* HALL-SPEED-02: pressed before the full roster landed: it answers now and summons when it lands */
 if(!allCharacters.length){ if(hohRosterArriving()) hohQueueRosterOpen('summon',null,null,directArchetype); return; }
 /* R198: when an archetype is passed (the logged-out "Summon a Random Hero" CTA
    passes 'wild'), open the modal and spin that archetype IMMEDIATELY, skipping the
    choice screen. Reuses the exact normal flow with an empty summon body so the
    heart-claim anchor and the reel render targets both exist. */
 if(directArchetype){
  document.getElementById('hoh-modal-body').innerHTML='<div class="hoh-summon-modal-body"></div>';
  document.getElementById('hoh-modal').style.display='flex';
  document.body.style.overflow='hidden';
  hohSummonArchetype(directArchetype);
  return;
 }
 var count=allCharacters.length;
 document.getElementById('hoh-modal-body').innerHTML=
 '<div class="hoh-summon-modal-body">'+
  '<div class="hoh-summon-modal-crest"><span class="hoh-summon-modal-crest-icon">&#9876;</span><span class="hoh-summon-modal-crest-ring" aria-hidden="true"></span></div>'+
  '<h2 class="hoh-summon-modal-title">Summon a Hero NPC</h2>'+
  '<p class="hoh-summon-modal-lead"><strong>'+count+' real heroes</strong> submitted by the community are waiting to walk into your next session.</p>'+
  '<div class="hoh-summon-choices">'+
  '<button class="hoh-summon-choice hoh-summon-choice-ally" onclick="hohSummonArchetype(\'ally\')"><span class="hoh-summon-choice-icon">&#9733;</span><span class="hoh-summon-choice-label">An Ally</span><span class="hoh-summon-choice-sub">Friend, contact, or helper</span></button>'+
  '<button class="hoh-summon-choice hoh-summon-choice-villain" onclick="hohSummonArchetype(\'villain\')"><span class="hoh-summon-choice-icon">&#9876;</span><span class="hoh-summon-choice-label">A Villain</span><span class="hoh-summon-choice-sub">Antagonist or threat</span></button>'+
  '<button class="hoh-summon-choice hoh-summon-choice-shop" onclick="hohSummonArchetype(\'shopkeeper\')"><span class="hoh-summon-choice-icon">&#9873;</span><span class="hoh-summon-choice-label">A Shopkeeper</span><span class="hoh-summon-choice-sub">Merchant or townsfolk</span></button>'+
  '<button class="hoh-summon-choice hoh-summon-choice-wild" onclick="hohSummonArchetype(\'wild\')"><span class="hoh-summon-choice-icon">&#10022;</span><span class="hoh-summon-choice-label">Wild Card</span><span class="hoh-summon-choice-sub">Surprise me</span></button>'+
  '</div>'+
  /* Filter row — Only my liked heroes + Only my Cast as one
     unified UI. The cast pill uses the SAME .hoh-tool-liked class
     as the liked pill so both render identically. */
  ((hohLikedFilterEligible() || (typeof hohCastFilterEligible==='function' && hohCastFilterEligible())) ? (
    '<div class="hoh-tool-filter-row">' +
      (hohLikedFilterEligible()?'<button type="button" class="hoh-tool-liked'+(hohLikedOnlyActive('summon')?' hoh-tool-liked-on':'')+'" id="hoh-summon-liked-toggle" onclick="hohToggleLikedOnly(\'summon\',this)"><span class="hoh-tool-liked-check">&#10003;</span><span>Only my liked heroes</span></button>':'') +
      ((typeof hohCastFilterEligible==='function' && hohCastFilterEligible())?'<button type="button" class="hoh-tool-liked hoh-tool-cast'+(hohCastOnlyActive('summon')?' hoh-tool-liked-on':'')+'" data-tool-cast="summon" onclick="hohToggleCastOnly(\'summon\',this)"><span class="hoh-tool-liked-check">&#10003;</span><span>Only my Favorites</span></button>':'') +
    '</div>'
  ) : '') +
  '<button class="hoh-cancel-btn hoh-summon-close-btn" onclick="hohCloseModal()">Close</button>'+
 '</div>';
 document.getElementById('hoh-modal').style.display='flex';
 document.body.style.overflow='hidden';
};

window.hohSummonArchetype=function(archetype){
 var pool=allCharacters.filter(function(c){
 if(archetype==='random')return c.story&&c.story.length>10;
 return matchesArchetype(c,archetype);
 });
 if(!pool.length){
 pool=allCharacters.filter(function(c){return c.npc_card;});
 }
 if(!pool.length){
 pool=allCharacters.filter(function(c){return c.story&&c.story.length>10;});
 }
 if(hohCastOnlyActive('summon'))pool=hohFilterPoolCast(pool);
 if(hohLikedOnlyActive('summon'))pool=hohFilterPoolLiked(pool);
 if(!pool.length)return;
 hohClaimActionHeart('summon',document.querySelector('.hoh-summon-modal-body'),'For summoning a hero NPC.');
 var lastId=sessionStorage.getItem('hoh-last-summon-'+archetype);
 if(lastId&&pool.length>1){
 pool=pool.filter(function(c){return c.id!==lastId;});
 }
 // Wild Card: 3x weight for non-standard race/class.
 var pickPool=pool;
 if(archetype==='wild'){
 var weighted=[];
 pool.forEach(function(c){
  var isOther=!isStandardRace(c.race)||!isStandardClass(c.character_class);
  var weight=isOther?3:1;
  for(var i=0;i<weight;i++)weighted.push(c);
 });
 if(weighted.length)pickPool=weighted;
 }
 var pick=pickPool[Math.floor(Math.random()*pickPool.length)];
 sessionStorage.setItem('hoh-last-summon-'+archetype,pick.id);
 hohSummonReel(archetype,pick,pool,function(){
 /* R198: just open the character card. Previously this also scrolled the page to
    #hoh-npc-section after 500ms, which yanked the view; the detail is an overlay
    so no scroll is needed. */
 hohOpenDetail(pick.id,archetype);
 });
};

function archetypeLabel(a){
 if(a==='ally')return'An Ally';
 if(a==='villain')return'A Villain';
 if(a==='shopkeeper')return'A Shopkeeper';
 if(a==='wild')return'A Wild Card';
 if(a==='summon')return'A Hero';
 return'An NPC';
}

/* ============================================================
   R199: The Morphing Summon button. A logged-out-only secondary CTA that warps
   through the Hall's most popular classes, races, and rarity tiers — each with
   its own palette + themed particles — and, when clicked, summons exactly what
   it shows. Targets are built data-driven from the loaded heroes (most popular,
   curated to a punchy set) so the cycle grows as the Hall does. Respects
   prefers-reduced-motion (static default, no cycle, no particles).
   ============================================================ */
var HOH_SUMMON_THEMES = {
  'default':   {label:'Random Hero',   c1:'#e6c879',c2:'#9c7a2c',glow:'#ffe9a8',txt:'#2a2008',p:'gold'},
  'barbarian': {label:'Raging Barbarian',    c1:'#ff5a4d',c2:'#7a1410',glow:'#ff5a4d',txt:'#fff0ec',p:'ember'},
  'bard':      {label:'Charismatic Bard',    c1:'#e85ad8',c2:'#5a1a6e',glow:'#e85ad8',txt:'#fce8fa',p:'spark'},
  'cleric':    {label:'Devout Cleric',       c1:'#f5d878',c2:'#a07a14',glow:'#ffe9a8',txt:'#2a2008',p:'holy'},
  'druid':     {label:'Wild Druid',          c1:'#5fd680',c2:'#1e5e2e',glow:'#5fd680',txt:'#eafce8',p:'leaf'},
  'fighter':   {label:'Stalwart Fighter',    c1:'#c0c8d4',c2:'#3a4452',glow:'#dce4f0',txt:'#1a2028',p:'glint'},
  'monk':      {label:'Disciplined Monk',    c1:'#4fe0c8',c2:'#1e7a6e',glow:'#4fe0c8',txt:'#eafcf8',p:'spark'},
  'paladin':   {label:'Oathsworn Paladin',   c1:'#f5c84a',c2:'#3a6ea0',glow:'#ffe0a0',txt:'#2a2008',p:'holy'},
  'ranger':    {label:'Wandering Ranger',    c1:'#8ab84a',c2:'#3a4a22',glow:'#a8d86a',txt:'#f0f8e0',p:'leaf'},
  'rogue':     {label:'Cunning Rogue',       c1:'#7a6a9a',c2:'#2a1a3a',glow:'#9a7ad0',txt:'#f0eafc',p:'shadow'},
  'sorcerer':  {label:'Innate Sorcerer',     c1:'#ff8a3d',c2:'#c0185a',glow:'#ff7a8a',txt:'#fff0e8',p:'chaos'},
  'warlock':   {label:'Pact-Bound Warlock',  c1:'#a04fe8',c2:'#3a1060',glow:'#c080ff',txt:'#f4eafc',p:'eldritch'},
  'wizard':    {label:'Arcane Wizard',       c1:'#5a8aff',c2:'#1e2a7a',glow:'#7aa8ff',txt:'#eaf0fc',p:'arcane'},
  'artificer': {label:'Clever Artificer',    c1:'#e0a04a',c2:'#7a4a1a',glow:'#f0c070',txt:'#fcf0e0',p:'gear'},
  'human':     {label:'Ambitious Human',     c1:'#dcb888',c2:'#7a5a3a',glow:'#f0d8b0',txt:'#2a2014',p:'gold'},
  'elf':       {label:'Graceful Elf',        c1:'#5fd6a8',c2:'#2a6e5a',glow:'#a8f0d0',txt:'#eafcf4',p:'leaf'},
  'dwarf':     {label:'Stout Dwarf',         c1:'#d0923c',c2:'#5a5048',glow:'#f0b860',txt:'#2a1e10',p:'ember'},
  'halfling':  {label:'Lucky Halfling',      c1:'#9ac24a',c2:'#7a6028',glow:'#c0e070',txt:'#f4f8e0',p:'leaf'},
  'dragonborn':{label:'Proud Dragonborn',    c1:'#e0532a',c2:'#7a1e10',glow:'#ff8a4a',txt:'#fff0e8',p:'ember'},
  'gnome':     {label:'Curious Gnome',       c1:'#3dd6e0',c2:'#b0860c',glow:'#7af0f0',txt:'#0e2a2e',p:'spark'},
  'half-elf':  {label:'Charming Half-Elf',   c1:'#5fd0b0',c2:'#8a7a3a',glow:'#a8e8d0',txt:'#eafcf4',p:'leaf'},
  'half-orc':  {label:'Fierce Half-Orc',     c1:'#6a9a3a',c2:'#3a3a2a',glow:'#9ac060',txt:'#f0f8e0',p:'shadow'},
  'tiefling':  {label:'Infernal Tiefling',   c1:'#e8456a',c2:'#4a1040',glow:'#ff6a9a',txt:'#fceaf2',p:'ember'},
  'orc':       {label:'Savage Orc',          c1:'#7a9a3a',c2:'#2a3a1a',glow:'#a0c060',txt:'#f0f8e0',p:'shadow'},
  'aasimar':   {label:'Radiant Aasimar',     c1:'#f4ecd0',c2:'#e0b84a',glow:'#fff8e0',txt:'#3a2e10',p:'holy'},
  'goliath':   {label:'Towering Goliath',    c1:'#8a94a8',c2:'#3a4a5a',glow:'#c0cce0',txt:'#1a2028',p:'glint'},
  'tabaxi':    {label:'Nimble Tabaxi',       c1:'#e0a04a',c2:'#8a5a2a',glow:'#f0c070',txt:'#2a1e10',p:'spark'},
  'common':    {label:'Common Hero',   c1:'#b8b0a0',c2:'#5a544a',glow:'#dcd4c4',txt:'#2a2620',p:'glint'},
  'uncommon':  {label:'Uncommon Hero', c1:'#5fd680',c2:'#2a6e3a',glow:'#a8f0c0',txt:'#eafcf0',p:'spark'},
  'rare':      {label:'Rare Hero',     c1:'#5a9aff',c2:'#1e3a8a',glow:'#a0c8ff',txt:'#eaf0fc',p:'spark'},
  'epic':      {label:'Epic Hero',     c1:'#b05ae8',c2:'#4a1a7a',glow:'#d0a0ff',txt:'#f4eafc',p:'spark'},
  'legendary': {label:'Legendary Hero',c1:'#ffb84a',c2:'#c0601a',glow:'#ffd080',txt:'#2a1808',p:'gold'},
  'mythic':    {label:'Mythic Hero',   c1:'mythic',c2:'mythic',glow:'#ef94ff',txt:'#ffffff',p:'rainbow'},
  /* Funny wildcard summons — a quirky personality on the button, but each one
     rolls a completely random hero (kind 'all'). Flavor up front, real surprise
     underneath. */
  'fun-stranger':{label:'Mysterious Stranger',    c1:'#8a78ae',c2:'#241a34',glow:'#c0a4e6',txt:'#f0eafc',p:'shadow'},
  'fun-brawler': {label:'Tavern Brawler',         c1:'#e8743a',c2:'#5a2410',glow:'#ff9a5a',txt:'#fff0e8',p:'ember'},
  'fun-loot':    {label:'Loot Goblin',            c1:'#b4c24a',c2:'#5a5018',glow:'#e2e070',txt:'#2a2810',p:'gold'},
  'fun-chaos':   {label:'Chaotic Neutral',        c1:'#ff6ab0',c2:'#6e1a4a',glow:'#ff9ad0',txt:'#fceaf4',p:'chaos'},
  'fun-gambler': {label:'Cursed Gambler',         c1:'#4fc28a',c2:'#1e4a3a',glow:'#8af0c0',txt:'#eafcf4',p:'eldritch'},
  'fun-veteran': {label:'Grizzled Veteran',       c1:'#a0a8b8',c2:'#3a4250',glow:'#cdd6e6',txt:'#1a2028',p:'glint'},
  'fun-cryptid': {label:'Local Cryptid',          c1:'#3dc2c8',c2:'#145a5e',glow:'#7af0f0',txt:'#0e2a2e',p:'spark'},
  'fun-chosen':  {label:'Chosen One',             c1:'#f0c24a',c2:'#7a5a14',glow:'#ffe49a',txt:'#2a2008',p:'holy'},
  'fun-trench':  {label:'Trenchcoat Goblin',      c1:'#7aa83a',c2:'#2a3a18',glow:'#a8d860',txt:'#f0f8e0',p:'leaf'},
  /* R227: Natural 20 removed (not a character). More themed wildcard
     summons added — each shows a flavorful persona on the button but
     rolls a completely random hero underneath. */
  'fun-nemesis': {label:'Your Future Nemesis',    c1:'#b0506a',c2:'#3a1020',glow:'#ff7a9a',txt:'#fceaf0',p:'shadow'},
  'fun-doomed':  {label:'A Doomed Adventurer',    c1:'#7a8a6a',c2:'#2a3020',glow:'#aab89a',txt:'#eef2e6',p:'eldritch'},
  'fun-tavern':  {label:'A Tavern Legend',        c1:'#e0a84a',c2:'#7a4a18',glow:'#ffce78',txt:'#2a1c08',p:'ember'},
  'fun-mimic':   {label:'Totally Not a Mimic',    c1:'#c2a24a',c2:'#5a4518',glow:'#ecd070',txt:'#2a2410',p:'gold'},
  'fun-witch':   {label:'A Hedge Witch',          c1:'#5fb87a',c2:'#1e4a2e',glow:'#9af0b0',txt:'#eafcf0',p:'eldritch'},
  'fun-dragon':  {label:'A Dragon in Disguise',   c1:'#e0532a',c2:'#6a1810',glow:'#ff8a4a',txt:'#fff0e8',p:'ember'},
  'fun-ghost':   {label:'A Restless Spirit',      c1:'#6aa8d8',c2:'#1e3a5a',glow:'#a8d8ff',txt:'#eaf2fc',p:'arcane'},
  'fun-sellsword':{label:'A Sellsword for Hire',  c1:'#9aa4b4',c2:'#3a4250',glow:'#c8d2e2',txt:'#1a2028',p:'glint'},
  'fun-fae':     {label:'A Trickster Fae',        c1:'#e85ad0',c2:'#5a1a6e',glow:'#ff9ae8',txt:'#fceafa',p:'spark'},
  'fun-knight':  {label:'A Knight Errant',        c1:'#d0c0a0',c2:'#6a5a3a',glow:'#f0e0b8',txt:'#2a2414',p:'glint'}
};
var _HOH_CLASS_KEYS=['barbarian','bard','cleric','druid','fighter','monk','paladin','ranger','rogue','sorcerer','warlock','wizard','artificer'];
var _HOH_RACE_KEYS=['half-elf','half-orc','dragonborn','tiefling','aasimar','goliath','tabaxi','halfling','human','dwarf','gnome','elf','orc'];
var _HOH_FUN_KEYS=['fun-stranger','fun-brawler','fun-loot','fun-chaos','fun-gambler','fun-veteran','fun-cryptid','fun-chosen','fun-trench','fun-nemesis','fun-doomed','fun-tavern','fun-mimic','fun-witch','fun-dragon','fun-ghost','fun-sellsword','fun-fae','fun-knight'];
function _hohSummonKey(s,keys){ var n=(''+(s||'')).toLowerCase().replace(/\s+/g,'-'); for(var i=0;i<keys.length;i++){ if(n.indexOf(keys[i])!==-1) return keys[i]; } return null; }
/* Every funny roll is a real filter, not a costume over a random pick. A hero answers
   one by its class or race outright, or by a word from its own sheet: name, race,
   class, story, and the NPC card's occupation, wants, fears, voice and hooks. A roll
   that the Hall cannot answer never joins the cycle, so the button can never promise a
   Loot Goblin and hand over a paladin. */
var HOH_SUMMON_FUN_MATCH={
  'fun-stranger': {words:['mysterious','stranger','hooded','cloak','veiled','secretive','wanderer','drifter','nameless','enigma']},
  'fun-brawler':  {cls:['barbarian','monk','fighter'],words:['brawl','tavern','fistfight','punch','wrestl','bouncer','bar fight']},
  'fun-loot':     {cls:['rogue'],words:['goblin','loot','treasure','hoard','coin','steal','stole','thief','thiev','pickpocket','greed','shiny']},
  'fun-chaos':    {words:['chaotic','chaos','unpredictab','reckless','impulsive','mischief','wild card','wildcard']},
  'fun-gambler':  {words:['gambl','dice','wager','cards','lucky','unlucky','fortune','odds','cursed','tavern game']},
  'fun-veteran':  {words:['veteran','soldier','battle-worn','grizzled','scars','scarred','retired','warrior','campaign','survivor','the war']},
  'fun-cryptid':  {race:['tabaxi','goliath'],words:['cryptid','beast','creature','monster','feral','claws','swamp','woods','sighting']},
  'fun-chosen':   {cls:['paladin','cleric'],words:['chosen','prophec','destin','foretold','oracle','omen','divine','sacred']},
  'fun-trench':   {race:['halfling','gnome'],words:['goblin','kobold','sneak','disguise','small','scrappy']},
  'fun-nemesis':  {words:['nemesis','rival','revenge','vengeance','grudge','betray','wanted','hunts']},
  'fun-doomed':   {words:['doom','cursed','dying','tragic','haunted','condemned','borrowed time']},
  'fun-tavern':   {cls:['bard'],words:['tavern','innkeep','barkeep','alehouse','mead','ballad','song','drunk','pub ','minstrel']},
  'fun-mimic':    {words:['mimic','disguise','shapeshift','changeling','doppel','illusion','impostor','imposter','pretend']},
  'fun-witch':    {cls:['warlock','druid'],words:['witch','hex','coven','herb','potion','brew','cauldron','curse']},
  'fun-dragon':   {race:['dragonborn'],words:['dragon','draconic','wyrm','wyvern','scales']},
  'fun-ghost':    {words:['ghost','undead','revenant','haunt','wraith','spectre','specter','phantom','banshee','graveyard','the dead']},
  'fun-sellsword':{cls:['fighter','ranger'],words:['mercenar','sellsword','for hire','bounty','contract','hired','guard']},
  'fun-fae':      {words:['faerie','fey','eladrin','satyr','pixie','sprite','trickster','glamour']},
  'fun-knight':   {cls:['paladin'],words:['knight','oath','squire','chivalr','honor','honour','order of','cavalier']}
};
function _hohSummonBlob(c){
  if(!c) return '';
  if(c._hohFunBlob) return c._hohFunBlob;
  var n=c.npc_card||{};
  var s=[c.name,c.race,c.character_class,c.campaign,c.story,n.occupation,n.disposition,n.voice,n.tic,n.wants,n.fears,n.hook,n.quest_hook,n.ally_hook,n.enemy_hook].join(' ').toLowerCase();
  try{ Object.defineProperty(c,'_hohFunBlob',{value:s,enumerable:false,configurable:true}); }catch(_){ c._hohFunBlob=s; }
  return s;
}
/* 2 = the hero IS the thing: its class, race or name says so, and you can see that on
   the ticket. 1 = its story says so, which reads true but is not on the card. */
function _hohSummonFunRank(key,c){
  var spec=HOH_SUMMON_FUN_MATCH[key];
  if(!spec||!c) return 0;
  if(spec.cls){ var ck=_hohSummonKey(c.character_class,_HOH_CLASS_KEYS); if(ck && spec.cls.indexOf(ck)!==-1) return 2; }
  if(spec.race){ var rk=_hohSummonKey(c.race,_HOH_RACE_KEYS); if(rk && spec.race.indexOf(rk)!==-1) return 2; }
  var face=[c.name,c.race,c.character_class].join(' ').toLowerCase();
  var i;
  for(i=0;i<spec.words.length;i++){ if(face.indexOf(spec.words[i])!==-1) return 2; }
  var b=_hohSummonBlob(c);
  for(i=0;i<spec.words.length;i++){ if(b.indexOf(spec.words[i])!==-1) return 1; }
  return 0;
}
function _hohSummonFunMatch(key,c){ return _hohSummonFunRank(key,c)>0; }
/* Roll from the heroes who wear it when there are enough of them; only reach for the
   ones who merely mention it when the Hall cannot fill a roll on the obvious matches. */
function _hohSummonFunPool(key,chars){
  var list=chars||((typeof allCharacters!=='undefined'&&allCharacters)?allCharacters:[]);
  var strong=[],weak=[];
  list.forEach(function(c){ var r=_hohSummonFunRank(key,c); if(r===2) strong.push(c); else if(r===1) weak.push(c); });
  return strong.length>=6 ? strong : strong.concat(weak);
}
function _hohSummonArticle(label){ return /^[AEIOU]/i.test(label) ? 'An ' : 'A '; }
function _hohSummonMkTarget(kind,value,themeKey){ var th=HOH_SUMMON_THEMES[themeKey]; var lab=th.label; var art=_hohSummonArticle(lab); return { kind:kind, value:value, themeKey:themeKey, theme:th, word:art.toLowerCase()+lab, btnText:'Summon '+art.toLowerCase()+lab, reelTitle:art+lab, accent:(th.c1==='mythic'?th.glow:th.c1), mythic:(th.c1==='mythic') }; }
/* Data-driven, curated cycle: Random Hero default + the most popular classes,
   races, and the exciting rarity tiers actually present, interleaved by kind so
   adjacent palettes always differ, capped to a punchy set. */
window.hohBuildSummonTargets = function(){
  var chars=(typeof allCharacters!=='undefined'&&allCharacters)?allCharacters:[];
  var cc={},rc={},rr={};
  for(var i=0;i<chars.length;i++){ var c=chars[i]; if(!c) continue;
    var ck=_hohSummonKey(c.character_class,_HOH_CLASS_KEYS); if(ck) cc[ck]=(cc[ck]||0)+1;
    var rk=_hohSummonKey(c.race,_HOH_RACE_KEYS); if(rk) rc[rk]=(rc[rk]||0)+1;
    try{ var rar=(typeof hohGetRarity==='function')?hohGetRarity(c.hearts).tier:null; if(rar&&HOH_SUMMON_THEMES[rar]) rr[rar]=(rr[rar]||0)+1; }catch(_){}
  }
  var topC=Object.keys(cc).sort(function(a,b){return cc[b]-cc[a];}).slice(0,9);
  var topR=Object.keys(rc).sort(function(a,b){return rc[b]-rc[a];}).slice(0,8);
  /* R228: every rarity present gets its own themed roll now, common and
     uncommon included, ordered rarest first so the flashy tiers lead. */
  var rars=['mythic','legendary','epic','rare','uncommon','common'].filter(function(r){return rr[r];});
  var out=[_hohSummonMkTarget('all','all','default')];
  var n=Math.max(topC.length,topR.length,rars.length);
  for(var j=0;j<n;j++){
    if(topC[j]) out.push(_hohSummonMkTarget('class',topC[j],topC[j]));
    if(topR[j]) out.push(_hohSummonMkTarget('race',topR[j],topR[j]));
    if(rars[j]) out.push(_hohSummonMkTarget('rarity',rars[j],rars[j]));
  }
  /* Sprinkle a few funny summons through the cycle — spaced out so a quirky label
     surfaces every so often between the class/race/rarity ones. Each one rolls from
     the heroes that actually fit it, and a roll the Hall cannot fill is left out
     rather than quietly falling back to any hero at all. */
  var funKeys=hohReelShuffle(_HOH_FUN_KEYS).filter(function(k){ return _hohSummonFunPool(k,chars).length>=3; }).slice(0,6);
  for(var f=0;f<funKeys.length;f++){
    out.splice(Math.min(out.length,3+f*3),0,_hohSummonMkTarget('fun',funKeys[f],funKeys[f]));
  }
  out=out.slice(0,26);
  /* R225: the Hero Pack is now a single entry in the rotation, about as rare as any one
     summon (it used to be injected after every third target, ~1 in 4). One pack, dropped
     mid-list so it is not always near the start, in the same rotation as everything else. */
  out.splice(Math.min(out.length,7),0,_hohSummonMkPackTarget());
  /* R226: one "Summon a Commissioned Character" entry (FF portraits only), spaced from the
     pack so the two FF-colored rolls do not sit adjacent. */
  out.splice(Math.min(out.length,12),0,_hohSummonMkFFTarget());
  return out;
};
/* R221: the special "Open a Hero Pack" morph target. Mythic colored, opens the hero pack. */
function _hohSummonMkPackTarget(){
  var th=HOH_SUMMON_THEMES['mythic'];
  return { kind:'pack', value:'pack', themeKey:'mythic', theme:th, word:'a Hero Pack', btnText:'Open a Hero Pack', reelTitle:'a Hero Pack', pre:'Open', accent:th.glow, mythic:true };
}
/* R226: "Summon a Commissioned Character" — FF brand colored (mythic theme), summons only
   from the real FramedFantasy commissioned portraits (is_ff_portrait). */
function _hohSummonMkFFTarget(){
  var th=HOH_SUMMON_THEMES['mythic'];
  return { kind:'ff', value:'ff', themeKey:'mythic', theme:th, word:'a Commissioned Character', btnText:'Summon a Commissioned Character', reelTitle:'a Commissioned Character', accent:th.glow, mythic:true };
}
/* R224: promo link morph targets. The Summon button occasionally surfaces one of these
   instead of a hero. The label has no "Summon"/"Open" prefix (it is the full phrase) and
   clicking it opens the matching FramedFantasy page in a new tab. */
function _hohSummonMkLinkTarget(word,url,accent){
  return { kind:'link', value:'link', url:url, themeKey:'default', theme:{glow:accent,c1:accent}, word:word, btnText:word, reelTitle:word, pre:'', accent:accent, mythic:false };
}
var _HOH_SUMMON_LINKS=null;
function _hohSummonLinks(){
  if(_HOH_SUMMON_LINKS) return _HOH_SUMMON_LINKS;
  _HOH_SUMMON_LINKS={
    commission:_hohSummonMkLinkTarget('Commission a Portrait','https://framedfantasy.com/products/fantasy-character-commission','#e0b24f'),
    gift:_hohSummonMkLinkTarget('Give a Gift','https://framedfantasy.com/pages/design-their-gift','#f29ab6'),
    world:_hohSummonMkLinkTarget('Build a World','https://framedfantasy.com/products/fantasy-landscape-commission','#7cc887'),
    stump:_hohSummonMkLinkTarget('Visit the Hollow Stump','https://framedfantasy.com/pages/dnd-character-quest','#b98ce0')
  };
  return _HOH_SUMMON_LINKS;
}
/* R227: Waitlist roll removed by request. Remaining promo odds:
   commission 1 in 20, gift 1 in 50, world 1 in 50, stump 1 in 50.
   Returns a link target, or null for the normal hero cycle. */
function _hohSummonRollLink(){
  /* R335: THE SUMMON BUTTON ONLY SUMMONS HEROES NOW.
     It used to roll a promo link 11% of the time -- Commission a Portrait
     (1 in 20), Give a Gift, Build a World, Visit the Hollow Stump -- and
     every one of them navigated AWAY to another page. That breaks the one
     promise the button makes. A player pressing a button that has shown them
     a hero nine times running does not expect the tenth press to leave the
     Hall, and a mis-press costs them their place. Returning null here means
     the roll is always a hero.
     The link factory and the kind:'link' rendering branch are left in place
     and simply go unreached: they are the machinery, not the policy, and
     deleting them would spread this change across half a dozen call sites
     for no behavioural gain. */
  return null;
}
var _hohSummon={targets:[],idx:0,timer:null,raf:null,ctx:null,parts:[],emit:null,cur:null,reduced:false,style:'morph',busy:false,_sizeBound:false};
var _HOH_SLOT_ROW=22; /* must match .hoh-summon-word line-height in CSS */
/* Dispatcher: reads the Shopify-chosen style off the button (data-summon-style) and
   starts the matching behavior. Shown to everyone now — logged in or out. */
window.hohInitSummonButton=function(){
  var btn=document.getElementById('hoh-summon-cta-btn'); if(!btn) return;
  try{ _hohSummon.reduced=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(_){}
  _hohSummon.style=(btn.getAttribute('data-summon-style')||'morph');
  _hohSummon.targets=window.hohBuildSummonTargets();
  if(!_hohSummon.targets.length) return;
  _hohSummon.idx=0;
  _hohSummonPaint(_hohSummon.targets[0],true);
  if(_hohSummon.style==='plain') return;
  if(_hohSummon.style==='spinner'){ _hohSummonCanvas(); return; } /* static until click; canvas powers only the landing burst */
  if(_hohSummon.reduced) return;
  /* morph: clean color/word/glow only — no ambient particles, no canvas. */
  if(!btn._hohBound){ btn._hohBound=true;
    btn.addEventListener('mouseenter',_hohSummonCrazyStart);
    btn.addEventListener('mouseleave',_hohSummonCrazyStop);
  }
  _hohSummonMorphSchedule();
};
window.hohInitSummonMorph=window.hohInitSummonButton; /* back-compat alias for the load hook */
/* Clean look: the accent color rides the edge, glow, and word; the dark panel is
   fixed. instant skips the word crossfade (initial paint). */
/* R216: morph the slot width to the current word so the Summon button hugs its text
   (no fixed floor) and resizes smoothly. The hover "crazy" flicker disables the slot
   transition in CSS, so calling this per word there snaps the width without clipping. */
function _hohSummonFitSlot(){
  var slot=document.getElementById('hoh-summon-slot');
  var word=document.getElementById('hoh-summon-word');
  if(!slot||!word||_hohSummon.style!=='morph') return;
  var w=Math.ceil(word.getBoundingClientRect().width);
  if(w>0) slot.style.width=w+'px';
}
function _hohSummonPaint(t,instant){
  var btn=document.getElementById('hoh-summon-cta-btn'); var word=document.getElementById('hoh-summon-word'); if(!btn) return;
  _hohSummon.cur=t; _hohSummon.emit=t.theme;
  /* Set the accent + mythic class TOGETHER with the text so the new color only ever
     paints the NEW word — never a muddy mid-transition or a rainbow flash on the old
     text. The new word then slides up into place. */
  btn.classList.toggle('hoh-summon-mythic', !!t.mythic);
  btn.classList.toggle('hoh-summon-pack', t.kind==='pack');
  btn.classList.toggle('hoh-summon-link', t.kind==='link');
  btn.style.setProperty('--sm-c1', t.accent);
  /* R221: the pack target reads "Open a Pack" — swap the static "Summon" prefix. */
  try{ var _pre=btn.querySelector('.hoh-summon-pre'); if(_pre) _pre.textContent=(t.kind==='link')?'':((t.kind==='pack'?'Open':'Summon')+' '); }catch(_){}
  if(word){ word.textContent=t.word; if(!instant && !_hohSummon.reduced){ word.classList.remove('hoh-summon-word-in'); void word.offsetWidth; word.classList.add('hoh-summon-word-in'); } }
  try{ _hohSummonFitSlot(); }catch(_){} /* R216: morph the button to fit the new word */
}
function _hohSummonMorphApply(i){ var t=_hohSummon.targets[i]; if(!t) return; _hohSummon.idx=i; _hohSummonPaint(t,false); }
/* R225: a target's identity for the no-repeat guard. The visible word is what matters, so
   the button never morphs into the very thing it is already showing. */
function _hohSummonTargetKey(t){ return (t && t.word) ? t.word : ''; }
/* R225: advance to the next NON-pack target that differs from what is showing. Used on pack
   close so the button leaves "Open a Hero Pack" the instant the modal clears. */
function _hohSummonForceAdvance(){
  var T=_hohSummon.targets; if(!T||!T.length) return;
  var lastKey=_hohSummonTargetKey(_hohSummon.cur), i=_hohSummon.idx;
  for(var n=0;n<T.length;n++){ i=(i+1)%T.length; var t=T[i]; if(t.kind!=='pack' && _hohSummonTargetKey(t)!==lastKey){ _hohSummon.idx=i; _hohSummonPaint(t,false); return; } }
}
function _hohSummonMorphNext(){
  if(!_hohSummon.targets.length||_hohSummon.busy) return;
  var lastKey=_hohSummonTargetKey(_hohSummon.cur);
  /* R225: roll the promo odds, but skip a promo when one is already showing (no two promos
     back to back) and never repeat the exact CTA showing — that is the "Commission a Portrait
     refreshing into itself" bug. */
  var lk=(_hohSummon.cur && _hohSummon.cur.kind==='link') ? null : _hohSummonRollLink();
  if(lk && _hohSummonTargetKey(lk)!==lastKey){ _hohSummonPaint(lk,false); _hohSummonMorphSchedule(); return; }
  /* Advance to the next target whose word differs from what is showing, so every tick is a
     real change and the button is always morphing to something new. */
  var T=_hohSummon.targets, i=_hohSummon.idx;
  for(var n=0;n<T.length;n++){ i=(i+1)%T.length; if(_hohSummonTargetKey(T[i])!==lastKey){ _hohSummon.idx=i; _hohSummonPaint(T[i],false); _hohSummonMorphSchedule(); return; } }
  _hohSummonMorphApply((_hohSummon.idx+1)%T.length); _hohSummonMorphSchedule();
}
function _hohSummonMorphSchedule(){ if(_hohSummon.reduced||_hohSummon.style!=='morph') return; clearTimeout(_hohSummon.timer); _hohSummon.timer=setTimeout(_hohSummonMorphNext, 3400); }
/* Hover (morph only): the button GOES CRAZY — rapid word flicker + an intense
   animated rainbow mythic glow — until the cursor leaves, then it settles on the
   last shown one and resumes the calm cycle. Started/stopped cleanly (single
   interval, guarded) so rapid enter/leave can never double-fire or leak. */
function _hohSummonCrazyStart(){
  /* R225: hover no longer rapid-flickers or freezes. The old flicker cycled random words at
     230ms and promo links were never in that pool, so a calm-cycle promo got swapped away the
     instant the cursor arrived. That forced the R224 hold, which left the button stuck on a
     promo (the reported bug). Hover is now inert: the calm 3.4s cycle keeps auto-advancing
     whether or not the cursor is over the button, so it never freezes and every CTA (summon,
     pack, or promo) stays clickable for its full window. */
}
function _hohSummonCrazyStop(){
  if(_hohSummon.crazy){ clearInterval(_hohSummon.crazy); _hohSummon.crazy=null; }
  var btn=document.getElementById('hoh-summon-cta-btn'); if(btn) btn.classList.remove('hoh-summon-crazy');
  if(_hohSummon.cur) _hohSummonPaint(_hohSummon.cur, true); /* settle on the last shown, accent + word in sync */
  if(_hohSummon.style==='morph' && !_hohSummon.reduced) _hohSummonMorphSchedule();
}
/* Click. morph: summon what it shows. spinner: slot-spin then summon. plain: random. */
window.hohSummonMorphClick=function(){
  if(_hohSummon.busy) return;
  /* R224: debounce rapid re-clicks (exit a pack and instantly reroll) so opens cannot
     stack and spam. */
  var _nowC=Date.now(); if(_hohSummon._lastClick && (_nowC-_hohSummon._lastClick)<650) return; _hohSummon._lastClick=_nowC;
  _hohSummonCrazyStop();
  if(_hohSummon.style==='spinner'){ _hohSummonSpin(); return; }
  var t=_hohSummon.cur||_hohSummon.targets[0];
  if(t && t.kind==='link'){ try{ window.open(t.url,'_blank','noopener,noreferrer'); }catch(_){} return; }
  if(t && t.kind==='pack'){ try{ if(typeof window.hohOpenHeroPack==='function') window.hohOpenHeroPack(); }catch(_){} return; }
  /* R224: lock the button through the summon reveal (reel + result) so a fast exit and
     reroll can't stack summons. Released a beat after the modal closes (hohCloseModal),
     with a long fallback so it can never stick. */
  _hohSummon.busy=true; _hohSummon._didSummon=true; try{ clearTimeout(_hohSummon.timer); }catch(_){}
  if(_hohSummon._summonRelease) clearTimeout(_hohSummon._summonRelease);
  _hohSummon._summonRelease=setTimeout(function(){ _hohSummon.busy=false; _hohSummon._summonRelease=null; try{ _hohSummonMorphSchedule(); }catch(_){} }, 9000);
  if(!t){ if(typeof window.hohSummonRandomNpc==='function') window.hohSummonRandomNpc('wild'); return; }
  window.hohSummonTarget(t.kind,t.value,t.reelTitle);
};
/* ============================================================
   R221: HERO PACK — a Hearthstone-style pack opening. The morphing Summon button
   sometimes reads "Open a Pack" (mythic). Clicking fans five hero cards face down,
   each pre-lit by its REAL rarity tier. Click a card to flip + reveal; legendary and
   mythic get a heavier spin, brighter glow, and a particle burst. Click a revealed
   card to open that hero. Free + purely cosmetic. allCharacters, hohGetRarity,
   hohBuildCardHtml, hohOpenDetail, and esc are all in scope in this file.
   ============================================================ */
var _HOH_PACK_RANK={common:0,uncommon:1,rare:2,epic:3,legendary:4,mythic:5};
function _hohPackTier(c){ try{ return hohGetRarity(c.hearts).tier; }catch(_){ return 'common'; } }
/* R222: per-card rarity roll modeled on Hearthstone's published odds (common ~70,
   rare ~22, epic ~4, legendary ~1) with our extra uncommon + a tiny mythic. Each
   card rolls independently, so all five CAN come up high. */
function _hohPackRollOne(){
  var r=Math.random()*100;
  if(r<0.3) return 'mythic';
  if(r<1.5) return 'legendary';
  if(r<6.0) return 'epic';
  if(r<26.0) return 'rare';
  if(r<42.0) return 'uncommon';
  return 'common';
}
function _hohPackPick(pool){
  var byTier={}; pool.forEach(function(c){ var t=_hohPackTier(c); (byTier[t]=byTier[t]||[]).push(c); });
  var used={};
  function takeTier(tier){ var a=(byTier[tier]||[]).filter(function(c){return !used[c.id];}); if(!a.length)return null; var h=a[(Math.random()*a.length)|0]; used[h.id]=1; return h; }
  function takeNearest(tier){ var want=_HOH_PACK_RANK[tier]; var best=null,bd=99; pool.forEach(function(c){ if(used[c.id])return; var d=Math.abs(_HOH_PACK_RANK[_hohPackTier(c)]-want); if(d<bd){bd=d;best=c;} }); if(best)used[best.id]=1; return best; }
  function takeAtLeast(minRank){ var cand=[]; pool.forEach(function(c){ if(!used[c.id] && _HOH_PACK_RANK[_hohPackTier(c)]>=minRank) cand.push(c); }); if(!cand.length)return null; var h=cand[(Math.random()*cand.length)|0]; used[h.id]=1; return h; }
  var picks=[];
  for(var i=0;i<5;i++){ var tgt=_hohPackRollOne(); var h=takeTier(tgt)||takeNearest(tgt); if(h) picks.push(h); }
  while(picks.length<5){ var x=null; for(var k=0;k<pool.length;k++){ if(!used[pool[k].id]){x=pool[k];used[x.id]=1;break;} } if(!x)break; picks.push(x); }
  var out=picks.slice(0,5).map(function(h){ return {hero:h, tier:_hohPackTier(h)}; });
  /* R223: Guarantee at least TWO rare-or-better per pack. A touch more generous
     than Hearthstone, which guarantees one. Replace the current lowest card with a
     fresh rare+ hero until two exist (or the pool runs out of rare+). */
  var _rareN=function(){ return out.filter(function(o){ return _HOH_PACK_RANK[o.tier]>=_HOH_PACK_RANK.rare; }).length; };
  var _rg=0;
  while(_rareN()<2 && _rg++<6){
    var rp=takeAtLeast(_HOH_PACK_RANK.rare);
    if(!rp) break;
    out.sort(function(a,b){ return _HOH_PACK_RANK[a.tier]-_HOH_PACK_RANK[b.tier]; });
    out[0]={hero:rp, tier:_hohPackTier(rp)};
  }
  /* Sort ascending so the lowest opens first on the left and the best is last on the right. */
  out.sort(function(a,b){ return _HOH_PACK_RANK[a.tier]-_HOH_PACK_RANK[b.tier]; });
  return out;
}
var _HOH_PACK_LOGO='https://cdn.shopify.com/s/files/1/0884/2389/1261/files/Logo_Clean.webp?v=1775168383';
var _HOH_PACK_PALETTES={common:['#cfc7da','#a9a2bd'],uncommon:['#7ee6a0','#bdf5cf'],rare:['#8fc0ff','#cfe2ff'],epic:['#d6a4ff','#b06aff'],legendary:['#ffd27a','#ffb84a','#fff0c8'],mythic:['#ef94ff','#b3f5ee','#ffffff']};
/* The Hall pack is the shop pack's twin: same back, same face, same deal, same flip,
   same spark ladder, all of it from the .ffshop-pack styles this page already loads.
   The one difference is the ending. Nothing here is owned, so the pack closes instead
   of collecting, and the shop's own opener is left alone. */
function _hohPackBackHtml(){ return '<div class="ffshop-miniback"><img src="'+_HOH_PACK_LOGO+'" alt="" draggable="false" oncontextmenu="return false"><span>Hall of Heroes</span></div>'; }
function _hohPackFaceHtml(p){
  var c=(p&&p.hero)||{}, img=c.image_thumb_url||c.image_url||'';
  var ff=c.is_ff_portrait?('<span class="ffshop-mini-ff"><img src="'+_HOH_PACK_LOGO+'" alt="FramedFantasy"></span>'):'';
  return '<div class="ffshop-mini">'+
    (img?'<img class="ffshop-mini-art" src="'+esc(img)+'" alt="" decoding="async" draggable="false" oncontextmenu="return false">':'')+
    '<div class="ffshop-mini-body">'+ff+
      '<div class="ffshop-mini-name">'+esc(c.name||'Hero')+'</div>'+
      '<div class="ffshop-mini-tier">'+esc(p.tier||'common')+'</div>'+
    '</div></div>';
}
/* The dim sits on the modal itself, the way the shop's hardenModal puts it there:
   one light veil so the Hall still reads faintly behind the cards. */
function _hohPackHarden(m){
  try{
    m.style.background='rgba(6,5,10,0.58)';
    try{ m.style.setProperty('-webkit-backdrop-filter','blur(3px)'); }catch(_){}
    try{ m.style.setProperty('backdrop-filter','blur(3px)'); }catch(_){}
  }catch(_){}
}
/* Rare and up simmer with sparks on the back, so a good pull announces itself
   before the flip. */
var _hohPackIdle=[];
function _hohPackIdleClear(){ _hohPackIdle.forEach(function(t){ try{ clearInterval(t); }catch(_){} }); _hohPackIdle=[]; }
function _hohPackIdleStart(el,tier,reduced){
  if(reduced) return;
  var rank=_HOH_PACK_RANK[tier]||0;
  if(rank<2) return;
  var layer=document.createElement('div'); layer.className='ffshop-idlefx'; el.appendChild(layer);
  var cols=_HOH_PACK_PALETTES[tier]||_HOH_PACK_PALETTES.common;
  var period=rank>=5?190:rank===4?260:rank===3?420:640;
  var t=setInterval(function(){
    if(!layer.isConnected){ try{ clearInterval(t); }catch(_){} return; }
    var s=document.createElement('span'); s.className='ffshop-idle';
    s.style.left=(8+Math.random()*84)+'%';
    s.style.setProperty('--icol',cols[(Math.random()*cols.length)|0]);
    s.style.setProperty('--idur',(1100+Math.random()*700|0)+'ms');
    s.style.setProperty('--idx',((Math.random()*20-10)|0)+'px');
    if(rank>=5){ s.style.width='6px'; s.style.height='6px'; }
    layer.appendChild(s);
    setTimeout(function(){ try{ s.remove(); }catch(_){} },2000);
  },period);
  _hohPackIdle.push(t);
}
var _hohPackHideTimer=null;
window.hohOpenHeroPack=function(){
  try{
    var ex=document.getElementById('hoh-pack-modal'); if(ex && ex.classList.contains('hoh-pack-open')) return;
    /* R224: cancel any pending close-hide timer so it can't wipe the modal we're about to
       rebuild, and cancel a pending busy-release so the lock stays clean. */
    if(_hohPackHideTimer){ clearTimeout(_hohPackHideTimer); _hohPackHideTimer=null; }
    if(_hohSummon._packRelease){ clearTimeout(_hohSummon._packRelease); _hohSummon._packRelease=null; }
    var chars=(typeof allCharacters!=='undefined'&&allCharacters)?allCharacters:[];
    var pool=chars.filter(function(c){ return c && (c.image_url||c.image_thumb_url) && !c.is_hidden; });
    if(pool.length<5){ if(typeof window.hohSummonRandomNpc==='function') window.hohSummonRandomNpc('wild'); return; }
    var picks=_hohPackPick(pool);
    var reduced=false; try{ reduced=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(_){}
    var m=ex; if(!m){ m=document.createElement('div'); m.id='hoh-pack-modal'; document.body.appendChild(m); }
    m.className='hoh-pack-modal ffshop-pack';
    var cardsHtml=picks.map(function(p,i){
      var hid=((p.hero&&p.hero.id!=null)?(''+p.hero.id):'').replace(/"/g,'');
      /* epic and above glow on the card BACK so the table leans in before the flip */
      var aura=(!reduced && (_HOH_PACK_RANK[p.tier]||0)>=3)?' ffshop-aura':'';
      return '<div class="hoh-pack-card hoh-pack-rar-'+p.tier+aura+'" data-idx="'+i+'" data-hero-id="'+hid+'" style="--pack-i:'+i+';">'+
        '<div class="hoh-pack-card-inner">'+
          '<div class="hoh-pack-card-back">'+_hohPackBackHtml()+'</div>'+
          '<div class="hoh-pack-card-face">'+_hohPackFaceHtml(p)+'</div>'+
        '</div>'+
        '<div class="hoh-pack-card-fx" aria-hidden="true"></div></div>';
    }).join('');
    m.innerHTML='<div class="hoh-pack-backdrop"></div><div class="hoh-pack-stage" role="dialog" aria-modal="true" aria-label="Hero pack">'+
      '<div class="hoh-pack-eyebrow">A Pack of Heroes</div>'+
      '<div class="hoh-pack-cards" id="hoh-pack-cards">'+cardsHtml+'</div>'+
      '<button type="button" class="hoh-pack-done" id="hoh-pack-done">Reveal</button></div>';
    _hohPackHarden(m);
    _hohSummon.busy=true; try{ clearTimeout(_hohSummon.timer); }catch(_){} /* R224: lock the button + pause the morph while a pack is open */
    m.style.display='flex'; document.body.style.overflow='hidden';
    /* Replay the deal every time: a forced reflow between the remove and the add makes
       the browser treat the class toggle as a real change, which a single rAF on a
       just-shown modal routinely misses. */
    m.classList.remove('hoh-pack-open');
    void m.offsetWidth;
    m.classList.add('hoh-pack-open');
    _hohPackIdleClear();
    Array.prototype.forEach.call(m.querySelectorAll('.hoh-pack-card'),function(el,i){ _hohPackIdleStart(el,picks[i]?picks[i].tier:'common',reduced); });
    _hohPackWire(m,picks,reduced);
  }catch(e){ try{ console.warn('[HeroPack]',e); }catch(_){} }
};
function _hohPackWire(m,picks,reduced){
  var done=m.querySelector('#hoh-pack-done');
  var bd=m.querySelector('.hoh-pack-backdrop');
  var cards=m.querySelectorAll('.hoh-pack-card');
  var revealed=0, revealing=false, allDone=false;
  function flip(card){
    if(card.classList.contains('hoh-pack-flipped')) return;
    card.classList.remove('ffshop-aura');
    var il=card.querySelector('.ffshop-idlefx'); if(il){ try{ il.remove(); }catch(_){} }
    card.classList.remove('ffshop-flipping'); void card.offsetWidth; card.classList.add('ffshop-flipping');
    card.classList.add('hoh-pack-flipped');
    var p=picks[+card.getAttribute('data-idx')]||{}; var tier=p.tier||'common';
    /* the sparks land over the middle of the turn, where the faces cross */
    if(!reduced) setTimeout(function(){ try{ _hohPackBurst(card,tier); }catch(_){} },160);
    setTimeout(function(){ try{ card.classList.remove('ffshop-flipping'); }catch(_){} },560);
    revealed++;
    if(revealed>=cards.length){ allDone=true; m.classList.add('hoh-pack-all-revealed'); if(done) done.textContent='Close'; }
  }
  /* Reveal turns the whole hand a card at a time, the way the shop pack does.
     Nothing is owned here, so once the hand is up the button just closes. */
  function revealAll(){
    if(revealing||allDone) return; revealing=true;
    var order=[]; Array.prototype.forEach.call(cards,function(el,i){ if(!el.classList.contains('hoh-pack-flipped')) order.push(i); });
    (function run(k){ if(k>=order.length){ revealing=false; return; } flip(cards[order[k]]); setTimeout(function(){ run(k+1); },300); })(0);
  }
  if(done) done.addEventListener('click', function(){ if(allDone) window.hohClosePack(); else revealAll(); });
  if(bd) bd.addEventListener('click', function(e){ if(e.target===bd) window.hohClosePack(); });
  Array.prototype.forEach.call(cards,function(card){
    card.addEventListener('click',function(){
      if(!card.classList.contains('hoh-pack-flipped')){ flip(card); return; }
      var id=card.getAttribute('data-hero-id'); window.hohClosePack();
      if(id){ try{ if(window.hohOpenDetail) window.hohOpenDetail(/^\d+$/.test(id)?(+id):id); }catch(_){} }
    });
  });
  if(!document._hohPackEscBound){ document._hohPackEscBound=true; document.addEventListener('keydown',function(ev){ if(ev.key==='Escape'){ var mm=document.getElementById('hoh-pack-modal'); if(mm&&mm.classList.contains('hoh-pack-open')) window.hohClosePack(); } }); }
}
/* A burst on every reveal, scaled by rarity: epic and up add a shockwave ring and a
   colour flash, legendary and mythic rattle the card, mythic brings confetti. */
function _hohPackBurst(card,tier){
  var fx=card.querySelector('.hoh-pack-card-fx'); if(!fx) return;
  var rank=_HOH_PACK_RANK[tier]||0;
  var cols=_HOH_PACK_PALETTES[tier]||_HOH_PACK_PALETTES.common;
  var n=(tier==='mythic')?46:(8+rank*7);
  var html='';
  if(rank>=3){
    html+='<span class="ffshop-flash" style="--fcol:'+cols[0]+'"></span>';
    html+='<span class="ffshop-ring" style="--rcol:'+cols[0]+'"></span>';
    if(tier==='mythic') html+='<span class="ffshop-ring" style="--rcol:'+cols[1]+';animation-delay:150ms;"></span>';
  }
  for(var i=0;i<n;i++){ var ang=Math.random()*Math.PI*2, dist=36+Math.random()*(rank>=3?130:90); html+='<span class="hoh-pack-particle" style="--pdx:'+(Math.cos(ang)*dist).toFixed(0)+'px;--pdy:'+(Math.sin(ang)*dist).toFixed(0)+'px;--pcol:'+cols[i%cols.length]+';--pdur:'+((700+Math.random()*(rank>=3?900:700))|0)+'ms;"></span>'; }
  fx.innerHTML=html;
  if(rank>=4){
    var inner=card.querySelector('.hoh-pack-card-inner');
    if(inner){ inner.classList.add('ffshop-shake'); setTimeout(function(){ try{ inner.classList.remove('ffshop-shake'); }catch(_){} },560); }
  }
  if(tier==='mythic'){ try{ if(typeof window.hohFireConfetti==='function') window.hohFireConfetti(); }catch(_){} }
  setTimeout(function(){ try{ fx.innerHTML=''; }catch(_){} }, rank>=3?2300:1800);
}
window.hohClosePack=function(){
  var m=document.getElementById('hoh-pack-modal'); if(!m) return;
  _hohPackIdleClear();
  m.classList.remove('hoh-pack-open'); document.body.style.overflow='';
  if(_hohPackHideTimer) clearTimeout(_hohPackHideTimer);
  _hohPackHideTimer=setTimeout(function(){ try{ m.style.display='none'; m.innerHTML=''; }catch(_){} _hohPackHideTimer=null; },240);
  /* R225: move the button off "Open a Hero Pack" right away so it is a different CTA the
     moment the modal clears and cannot be reopened immediately. */
  try{ if(_hohSummon.cur && _hohSummon.cur.kind==='pack') _hohSummonForceAdvance(); }catch(_){}
  /* R224: keep the Summon button locked for a beat after close so a rapid reroll can't
     race the hide animation; then release it and resume the calm morph cycle. */
  if(_hohSummon._packRelease) clearTimeout(_hohSummon._packRelease);
  _hohSummon._packRelease=setTimeout(function(){ _hohSummon.busy=false; _hohSummon._packRelease=null; try{ _hohSummonMorphSchedule(); }catch(_){} },650);
};
/* Slot machine: a column of random target words eases to a stop on a random final
   (~1.85s smooth ease), tints the accent, bursts particles, then opens that reel. */
function _hohSummonSpin(){
  var btn=document.getElementById('hoh-summon-cta-btn'); var slot=document.getElementById('hoh-summon-slot'); var T=_hohSummon.targets; if(!btn||!slot||!T.length) return;
  var finalT=T[Math.floor(Math.random()*T.length)];
  if(_hohSummon.reduced){ _hohSummonPaint(finalT,true); window.hohSummonTarget(finalT.kind,finalT.value,finalT.reelTitle); return; }
  _hohSummon.busy=true; _hohSummonCanvas();
  var LEN=24, seq=[]; for(var i=0;i<LEN-1;i++){ seq.push(T[Math.floor(Math.random()*T.length)]); } seq.push(finalT);
  slot.innerHTML='<span class="hoh-summon-col" id="hoh-summon-col">'+seq.map(function(s){return '<span class="hoh-summon-word">'+(''+s.word).replace(/</g,'&lt;')+'</span>';}).join('')+'</span>';
  var colEl=document.getElementById('hoh-summon-col'); if(!colEl){ _hohSummon.busy=false; return; }
  btn.classList.add('hoh-summon-spinning');
  var ci=0, cyc=setInterval(function(){ var th=T[(ci++)%T.length]; btn.style.setProperty('--sm-c1', th.accent); btn.classList.toggle('hoh-summon-mythic', !!th.mythic); }, 80);
  colEl.style.transition='none'; colEl.style.transform='translateY(0)'; void colEl.offsetWidth;
  colEl.style.transition='transform 1.85s cubic-bezier(.11,.72,.18,1)'; colEl.style.transform='translateY(-'+((LEN-1)*_HOH_SLOT_ROW)+'px)';
  setTimeout(function(){
    clearInterval(cyc); _hohSummon.busy=false; btn.classList.remove('hoh-summon-spinning');
    _hohSummon.cur=finalT; _hohSummon.emit=finalT.theme;
    btn.style.setProperty('--sm-c1', finalT.accent); btn.classList.toggle('hoh-summon-mythic', !!finalT.mythic);
    _hohSummonBurst(finalT.accent);
    setTimeout(function(){ try{ slot.innerHTML='<span class="hoh-summon-word" id="hoh-summon-word">'+(''+finalT.word).replace(/</g,'&lt;')+'</span>'; }catch(_){} }, 60);
    setTimeout(function(){ window.hohSummonTarget(finalT.kind,finalT.value,finalT.reelTitle); }, 520);
  }, 1900);
}
/* Particle canvas behind the button. MORPH: a few gentle ambient particles in the
   accent. SPINNER: idle, only the landing burst draws. Respects reduced-motion. */
function _hohSummonCanvas(){
  var btn=document.getElementById('hoh-summon-cta-btn'); var cv=document.getElementById('hoh-summon-fx'); if(!btn||!cv) return;
  if(_hohSummon.ctx) return; var ctx=cv.getContext('2d'); _hohSummon.ctx=ctx;
  var mobile=false; try{ mobile=!!(window.matchMedia&&window.matchMedia('(max-width: 600px)').matches); }catch(_){}
  function size(){ var r=btn.getBoundingClientRect(); cv.width=Math.max(1,r.width+90); cv.height=Math.max(1,r.height+64); }
  size(); if(!_hohSummon._sizeBound){ _hohSummon._sizeBound=true; window.addEventListener('resize',size); }
  function hue(){ return 'hsl('+Math.floor(Math.random()*360)+',90%,68%)'; }
  function frame(){ if(!ctx) return; ctx.clearRect(0,0,cv.width,cv.height);
    /* PERF-5 (2026-08-06): the loop had no exit, so after the first burst it
       cleared and recomposited this canvas at 60fps for the rest of the
       session with zero particles in the array. It now parks itself when the
       stage is empty; _hohSummonBurst kicks it awake. The clearRect above has
       already wiped the last frame, so parking leaves a clean canvas. */
    if(!_hohSummon.parts.length){ _hohSummon.raf=null; return; }
    /* R199: no ambient particles. The canvas only renders the spinner's deliberate
       landing burst; the morph is clean color/word/glow with nothing floating. */
    if(_hohSummon.parts.length>170) _hohSummon.parts.splice(0,_hohSummon.parts.length-170);
    for(var i=_hohSummon.parts.length-1;i>=0;i--){ var o=_hohSummon.parts[i]; o.x+=o.vx; o.y+=o.vy; if(o.g) o.vy+=o.g; o.life-=o.decay; if(o.life<=0){ _hohSummon.parts.splice(i,1); continue; } ctx.globalAlpha=Math.max(0,o.life*.5); ctx.fillStyle=o.col; ctx.beginPath(); ctx.arc(o.x,o.y,o.r*o.life,0,6.28); ctx.fill(); }
    ctx.globalAlpha=1; _hohSummon.raf=requestAnimationFrame(frame);
  }
  _hohSummon.kick=function(){ if(!_hohSummon.raf && ctx) frame(); };
  if(!_hohSummon.raf) frame();
}
function _hohSummonBurst(col){ var cv=document.getElementById('hoh-summon-fx'); if(!cv) return; var cx=cv.width/2,cy=cv.height/2; for(var i=0;i<22;i++){ var a=Math.random()*6.28,s=.5+Math.random()*1.6; _hohSummon.parts.push({x:cx,y:cy,vx:Math.cos(a)*s,vy:Math.sin(a)*s-.3,g:.012,life:1,decay:.018+Math.random()*.02,r:1+Math.random()*1.5,col:col}); } if(_hohSummon.kick) _hohSummon.kick(); }
/* Summon exactly what the button shows: filter the pool by class/race/rarity (or
   all), open the roll, and pass the reel its title so the inside screen reads
   "Summoning a Barbarian", "Summoning a Mythic Hero", etc. */
window.hohSummonTarget=function(kind,value,reelTitle){
  if(typeof allCharacters==='undefined'||!allCharacters.length) return;
  try{ document.getElementById('hoh-modal-body').innerHTML='<div class="hoh-summon-modal-body"></div>'; document.getElementById('hoh-modal').style.display='flex'; document.body.style.overflow='hidden'; }catch(_){}
  var pool;
  if(kind==='class') pool=allCharacters.filter(function(c){ return _hohSummonKey(c.character_class,_HOH_CLASS_KEYS)===value; });
  else if(kind==='race') pool=allCharacters.filter(function(c){ return _hohSummonKey(c.race,_HOH_RACE_KEYS)===value; });
  else if(kind==='rarity') pool=allCharacters.filter(function(c){ try{ return hohGetRarity(c.hearts).tier===value; }catch(_){ return false; } });
  else if(kind==='ff') pool=allCharacters.filter(function(c){ return c && c.is_ff_portrait; });
  else if(kind==='fun') pool=_hohSummonFunPool(value,allCharacters);
  else pool=allCharacters.slice();
  if(!pool||!pool.length) pool=allCharacters.filter(function(c){ return c.story&&c.story.length>10; });
  if(!pool.length) pool=allCharacters.slice();
  try{ hohClaimActionHeart('summon',document.querySelector('.hoh-summon-modal-body'),'For summoning a hero NPC.'); }catch(_){}
  var pick=pool[Math.floor(Math.random()*pool.length)];
  hohSummonReel('summon',pick,pool,function(){ hohOpenDetail(pick.id); }, reelTitle);
};

function hohReelShuffle(arr){
 var a=arr.slice();
 for(var i=a.length-1;i>0;i--){
 var j=Math.floor(Math.random()*(i+1));
 var t=a[i];a[i]=a[j];a[j]=t;
 }
 return a;
}

function hohReelTicketHtml(c){
 var img=c.image_thumb_url||c.image_url||'';
 var initial=(c.name||'?').charAt(0).toUpperCase();
 var avatar=img
 ? '<img class="hoh-summon-reel-img" src="'+esc(img)+'" alt="" loading="eager"/>'
 : '<div class="hoh-summon-reel-letter">'+esc(initial)+'</div>';
 var meta=[];
 if(c.race)meta.push(esc(c.race));
 if(c.character_class)meta.push(esc(c.character_class));
 if(c.level)meta.push('Lv '+esc(c.level));
 /* Subtle rarity accent on each ticker row so the scroll-past reveals a
  mix of tiers. Uses the same tier classes as the grid cards, styled
  as a left-edge band in the CSS so it does not wrap the whole row. */
 var rar=hohGetRarity(c.hearts);
 return '<div class="hoh-summon-reel-ticket hoh-reel-rar-'+rar.tier+'">'+avatar+
 '<div class="hoh-summon-reel-info">'+
  '<div class="hoh-summon-reel-name">'+esc(c.name||'Unknown')+'</div>'+
  '<div class="hoh-summon-reel-meta">'+meta.join(' &middot; ')+'</div>'+
 '</div>'+
 '</div>';
}

var _hohReelGen=0;
window.hohSummonReel=function(archetype,winner,pool,onComplete,titleLabel){
 /* R224: each reel claims a generation. A newer summon or a modal close bumps the
    counter, so this reel's deferred callbacks (highlight, fade, onComplete) go silent
    instead of firing on a fresh reel — that stacking was the reroll spam. */
 var _rgen=++_hohReelGen;
 var modalBody=document.getElementById('hoh-modal-body');
 if(!modalBody){if(onComplete)onComplete();return;}

 var source=(pool&&pool.length)?pool:[winner];
 /* Distinct-hero count. When the pool really has more than one hero we keep
    the reel from showing the same face twice in a row. A one-hero pool (a
    narrow rigged summon) has no choice but to repeat — that's allowed. */
 var _seen={},uniqueCount=0;
 for(var u=0;u<source.length;u++){ var _uid=source[u]&&source[u].id; if(_uid!=null&&!_seen[_uid]){_seen[_uid]=1;uniqueCount++;} }
 /* A longer strip = a longer, smoother roll. Fill it by cycling reshuffled
    copies of the pool, skipping any card that would land back-to-back with
    the one before it (only when the pool can spare a different face). */
 var target=44;
 var queue=[];
 var last=null;
 var guard=0;
 while(queue.length<target && guard<target*40){
 guard++;
 var shuffled=hohReelShuffle(source);
 for(var i=0;i<shuffled.length&&queue.length<target;i++){
  var cand=shuffled[i];
  if(uniqueCount>1 && last && cand && cand.id===last.id) continue;
  queue.push(cand); last=cand;
 }
 }
 /* Safety pad if the no-repeat guard ever bails on a pathological pool;
    still dodges a back-to-back repeat when the pool can spare one. */
 while(queue.length<target){
 var pad=source[queue.length%source.length];
 if(uniqueCount>1 && last && pad && pad.id===last.id) pad=source[(queue.length+1)%source.length];
 queue.push(pad); last=pad;
 }
 /* Land the winner deep in the strip so there's a long run-up before it.
    Prefer a slot where the shuffle ALREADY placed the winner — its
    neighbours are then guaranteed different faces (the build never repeats
    back-to-back), so the landing reads as one clean hero under the playhead.
    A winner that isn't in the pool (defensive) is written in directly. */
 var want=33+Math.floor(Math.random()*3);
 var winnerIdx=-1;
 /* 1) Snap to a slot near `want` where the shuffle ALREADY dealt the winner:
    its neighbours are clean for free. Bounded window keeps the depth (and the
    run-up) consistent — a sparse winner in a big pool won't drag the landing
    to the very start or end of the strip. */
 for(var off=0;off<=3 && winnerIdx<0;off++){
 var a=want-off,b=want+off;
 if(a>=1&&a<target-1&&queue[a]&&winner&&queue[a].id===winner.id){winnerIdx=a;break;}
 if(b>=1&&b<target-1&&queue[b]&&winner&&queue[b].id===winner.id){winnerIdx=b;break;}
 }
 /* 2) Otherwise drop the winner in at `want` and repair its two neighbours,
    choosing a face that dodges both the winner and the card beyond it so no
    doubled face appears around the landing (only a one/two-hero pool can't). */
 if(winnerIdx<0){
 winnerIdx=want; queue[winnerIdx]=winner;
 var _fixNbr=function(idx){
  if(idx<1||idx>=target-1||uniqueCount<=1)return;
  if(!(queue[idx]&&winner&&queue[idx].id===winner.id))return;
  var prev=queue[idx-1],next=queue[idx+1],sh=hohReelShuffle(source),pick=null;
  for(var s=0;s<sh.length;s++){ var cd=sh[s];
   if(!cd||cd.id===winner.id)continue;
   if(prev&&cd.id===prev.id)continue;
   if(next&&cd.id===next.id)continue;
   pick=cd;break; }
  if(pick)queue[idx]=pick;
 };
 _fixNbr(winnerIdx-1); _fixNbr(winnerIdx+1);
 }

 /* R225: render the summon reel with the raffle ticket rows (ticket count hidden) so the
    spinner reads identically to the monthly raffle draw. */
 var ticketsHtml='';
 for(var t=0;t<queue.length;t++){
 ticketsHtml+=hohTicketHtml(queue[t],t,t===winnerIdx,true);
 }

 /* R225: no archetype label, no eyebrow or subtitle, no themed color — just the bare
    raffle-style spinner. The queue above already filtered to exactly what the button asked
    for, so the wheel still shows only those heroes, it just is not announced. */
 modalBody.innerHTML=
 '<div class="hoh-raffle-stage hoh-summon-reel-raffle">'+
  '<div class="hoh-raffle-stage-line"></div>'+
  '<div class="hoh-raffle-ticker" id="hoh-summon-reel-ticker">'+ticketsHtml+'</div>'+
 '</div>';

 var track=document.getElementById('hoh-summon-reel-ticker');
 var stage=modalBody.querySelector('.hoh-raffle-stage');
 if(!track||!stage){if(onComplete)onComplete();return;}

 var sfx=document.getElementById('hoh-dice-sfx');
 if(sfx&&sfx.querySelector('source')){
 try{sfx.currentTime=0;var pp=sfx.play();if(pp&&pp.catch)pp.catch(function(){});}catch(e){}
 }

 track.style.transition='none';
 track.style.transform='translate3d(0,560px,0)';

 requestAnimationFrame(function(){
 requestAnimationFrame(function(){
  if(_rgen!==_hohReelGen) return;
  var winnerEl=track.querySelector('[data-winner="true"]')||track.children[winnerIdx];
  if(!winnerEl){if(onComplete)onComplete();return;}
  var winnerCenter=winnerEl.offsetTop+(winnerEl.offsetHeight/2);
  /* R225: match the raffle draw — a 4.2s settle with the same easing onto the winner under
     the playhead window, then open the hero. */
  track.style.transition='transform 4.2s cubic-bezier(0.12,0.62,0.26,1)';
  track.style.transform='translate3d(0,'+(-Math.round(winnerCenter))+'px,0)';

  setTimeout(function(){
  if(_rgen!==_hohReelGen) return;
  if(onComplete)onComplete();
  },4550);
 });
 });
};

/* R201: the backfilled Hall story is built as [archetype description] + "Defining
   moment: ..." + [personality], joined by blank lines. Leading with the AI
   archetype before the player's own backstory reads backwards, so for DISPLAY we
   lift the "Defining moment" paragraph to the front (the archetype then follows
   it). Pure reorder of existing paragraphs — nothing is added, removed, or
   rewritten — and a story with no "Defining moment" line is returned untouched.
   Reordering at display means it covers all 886 existing heroes and every future
   one, with no risky rewrite of the stored text. */
function hohReorderStory(s){
  s = String(s || '');
  var paras = s.split(/\n{2,}/).map(function(p){ return p.trim(); }).filter(function(p){ return p; });
  if(paras.length < 2) return s;
  var dmIdx = -1;
  for(var i=0;i<paras.length;i++){ if(/^\s*defining moment\s*:/i.test(paras[i])){ dmIdx = i; break; } }
  if(dmIdx < 0) return s; /* no labeled defining moment — leave the story untouched */
  var dm = paras[dmIdx];
  /* Backfill structure is [archetype] + "Defining moment: ..." + [personality].
     So the part before the defining moment is the archetype narrative, and the
     part after it is the personality line. Label both so all three read alike,
     and lead with the defining moment. */
  var before = paras.slice(0, dmIdx).join('\n\n');
  var after  = paras.slice(dmIdx + 1).join('\n\n');
  var out = [dm];
  if(before) out.push(/^\s*archetype\s*:/i.test(before) ? before : ('Archetype: ' + before));
  if(after)  out.push(/^\s*personality\s*:/i.test(after) ? after : ('Personality: ' + after));
  return out.join('\n\n');
}
window.hohReorderStory = hohReorderStory;

/* Viewport-modal lifecycle for the three long, primary Hall flows.
   These overlays are authored inside #hoh-app, which is useful for keeping the
   section self-contained but makes a fixed descendant vulnerable to any
   containing block / clipping rule introduced by the theme or a browser.
   Promote only the active primary overlay to <body> so fixed positioning is
   unambiguously relative to the visual viewport. The matching CSS restores
   the Hall font + box sizing after the move and owns dynamic-viewport sizing.

   This helper also centralizes the pieces the old one-line open functions
   missed: start every state at scrollTop 0, expose the dialog to assistive
   tech only while open, put focus on its close control, and return focus to
   the control that launched it. */
var HOH_VIEWPORT_MODAL_IDS = ['hoh-modal','hoh-raffle-modal','hoh-form-modal'];
function hohViewportModalVisible(modal){
 if(!modal)return false;
 return modal.style.display !== 'none' && modal.style.display !== '';
}
function hohAnyViewportModalOpen(){
 for(var i=0;i<HOH_VIEWPORT_MODAL_IDS.length;i++){
  if(hohViewportModalVisible(document.getElementById(HOH_VIEWPORT_MODAL_IDS[i])))return true;
 }
 return false;
}
/* ⛔ R609 · THE CORNER WALLET STANDS ASIDE FOR THE HERO FORM, AND ONLY FOR IT.
   `.hoh-tk-header-fixed` is z-index 100001, two above `.hoh-modal`, because the
   standing rule in the stylesheet is that the counter owns the bottom-right
   corner. That is right for the Hall and wrong over a full-height form: in
   Jan's edit screenshot the pill is sitting on the submission rules.
   ⛔ IT IS THE FORM ONLY, DELIBERATELY. Every heart and crystal flight in this
   theme targets `cornerPill()`, and the hero DETAIL modal is where hearts are
   given — hiding the counter under that one would delete the animation that
   says the heart landed. The form spends nothing and animates nothing into the
   corner, so it is the one dialog that can take the whole screen. */
function hohSyncFormModalBodyClass(){
 try{
  document.body.classList.toggle('hoh-form-modal-open',
   hohViewportModalVisible(document.getElementById('hoh-form-modal')));
 }catch(_){ }
}
function hohSetViewportBackgroundBlocked(blocked){
 var nodes=document.querySelectorAll('#hoh-app > .hoh-header, #hoh-app > .hoh-content');
 for(var i=0;i<nodes.length;i++){
  var node=nodes[i];
  if(blocked){
   if(node.__hohViewportBackgroundBlocked)continue;
   node.__hohViewportBackgroundBlocked=true;
   node.__hohViewportHadInert=node.hasAttribute('inert');
   node.__hohViewportHadAriaHidden=node.hasAttribute('aria-hidden');
   node.__hohViewportAriaHidden=node.getAttribute('aria-hidden');
   node.setAttribute('inert','');
   node.setAttribute('aria-hidden','true');
  }else if(node.__hohViewportBackgroundBlocked){
   if(!node.__hohViewportHadInert)node.removeAttribute('inert');
   if(node.__hohViewportHadAriaHidden)node.setAttribute('aria-hidden',node.__hohViewportAriaHidden);
   else node.removeAttribute('aria-hidden');
   delete node.__hohViewportBackgroundBlocked;
   delete node.__hohViewportHadInert;
   delete node.__hohViewportHadAriaHidden;
   delete node.__hohViewportAriaHidden;
  }
 }
}
window.hohResetViewportModal=function(modal){
 if(typeof modal==='string')modal=document.getElementById(modal);
 if(!modal)return;
 try{modal.scrollTop=0;}catch(_){}
 var scroller=modal.querySelector('.hoh-modal-content, .hoh-raffle-content');
 if(scroller){try{scroller.scrollTop=0;}catch(_){}}
 var step=modal.querySelector('.hoh-wiz-step.hoh-wiz-on');
 if(step){try{step.scrollTop=0;}catch(_){}}
 /* R609: edit mode has no wizard step, so the body itself is the scroller on
    a phone. It is a different node from the two above and it starts wherever
    the previous open left it unless it is named here. */
 var body=modal.querySelector('.hoh-form-body');
 if(body){try{body.scrollTop=0;}catch(_){}}
};
/* ⛔ ============ R580 · THE PAGE ACTUALLY HOLDS STILL NOW ============
   Jan: "try to lock the page when the card is opened so they cant randomly tap
   around and make the image larger/scroll the page behind it."
   `document.body.style.overflow='hidden'` was already here, and iOS SAFARI
   IGNORES IT for touch scrolling. It is the most common wrong answer to this
   problem, it works on every desktop browser, and it is exactly why the gallery
   keeps sliding behind his card while the code looks like it locked.
   What does work is pinning the body with position:fixed and carrying the
   scroll offset on `top`, then putting the page back where it was on release.
   Without restoring that offset the page jumps to the top the moment a card
   closes, which is a worse bug than the one being fixed.
   ⛔ IT MUST BE RE-ENTRANT. hohPresentViewportModal is called AGAIN on a modal
   that is already open, because the card-to-dossier swap keeps the same one.
   Locking twice would read a scroll offset of 0 off an already-pinned body and
   then "restore" the player to the top of the Hall. The latch stops that, and
   the unlock refuses while any viewport modal is still up. */
function hohLockPageScroll(){
 try{
  if(document.body.__hohScrollLocked) return;
  var y=window.scrollY||window.pageYOffset||document.documentElement.scrollTop||0;
  /* R793.1 fix (code review): on a desktop whose scrollbar takes room
     (Windows), pinning the body took the page scrollbar away and the whole
     Hall reflowed by its width, under the dim at the moment the card view
     lands and again the moment it lands back on its tile. The gutter stays
     reserved while the page is pinned, so the page keeps its width.
     Overlay scrollbars (phones, a default Mac) measure 0 and change nothing. */
  var gutter=0;
  try{ gutter=(window.innerWidth||0)-(document.documentElement.clientWidth||0); }catch(_){ gutter=0; }
  if(gutter>0&&!(window.CSS&&CSS.supports&&!CSS.supports('scrollbar-gutter','stable'))){
   document.documentElement.style.scrollbarGutter='stable';
   document.body.__hohScrollGutter=1;
  }
  document.body.__hohScrollLocked=1;
  document.body.__hohScrollY=y;
  document.body.style.position='fixed';
  document.body.style.top=(-y)+'px';
  document.body.style.left='0';
  document.body.style.right='0';
  document.body.style.width='100%';
  document.body.style.overflow='hidden';
 }catch(_){ }
}
function hohUnlockPageScroll(){
 try{
  if(!document.body.__hohScrollLocked) return;
  /* another modal may still be up, and unlocking under it would let the page
     slide away behind whatever is still on screen */
  if(typeof hohAnyViewportModalOpen==='function'&&hohAnyViewportModalOpen()) return;
  var y=document.body.__hohScrollY||0;
  document.body.__hohScrollLocked=0;
  document.body.style.position='';
  document.body.style.top='';
  document.body.style.left='';
  document.body.style.right='';
  document.body.style.width='';
  document.body.style.overflow='';
  if(document.body.__hohScrollGutter){
   document.body.__hohScrollGutter=0;
   document.documentElement.style.scrollbarGutter='';
  }
  window.scrollTo(0,y);
 }catch(_){ }
}
window.hohLockPageScroll=hohLockPageScroll;
window.hohUnlockPageScroll=hohUnlockPageScroll;
window.hohPresentViewportModal=function(modal,opts){
 if(typeof modal==='string')modal=document.getElementById(modal);
 if(!modal)return null;
 var wasOpen=hohViewportModalVisible(modal);
 if(!wasOpen){
  try{modal.__hohViewportOpener=document.activeElement;}catch(_){modal.__hohViewportOpener=null;}
 }
 /* Appending an existing node preserves its listeners and state. */
 if(modal.parentNode!==document.body)document.body.appendChild(modal);
 modal.classList.add('hoh-viewport-modal');
 modal.setAttribute('aria-hidden','false');
 modal.style.display='flex';
 document.body.classList.add('hoh-viewport-modal-open');
 hohSyncFormModalBodyClass();
 /* R793.1: the Hall card view opens with a move from the tapped tile, and the
    page-wide work (inert on the whole Hall, the position:fixed scroll lock)
    restyles and relays out a 1,100 tile page. Measured at 4x CPU that was
    the bulk of a 60ms tap task plus a full relayout in the next one, right
    where the first frames of the open should be. deferPage holds that work
    until the move has landed (hohSettleViewportPage); the full-screen dialog
    already takes every tap in the meantime. Every other caller is unchanged. */
 if(opts&&opts.deferPage&&!wasOpen){
  modal.__hohPageDeferred=true;
 }else if(!modal.__hohPageDeferred){
  hohSetViewportBackgroundBlocked(true);
  hohLockPageScroll();
 }
 window.hohResetViewportModal(modal);
 /* A Hall card/detail fade keeps this same modal open. Its transition owner
    moves focus exactly once after the replacement has faded in, so capture
    the defer state now and do not let this queued first-paint callback cause
    a close-button -> toggle -> close-button focus jump. */
 var deferFocus=!!modal.__hohViewportDeferFocus;
 setTimeout(function(){
  window.hohResetViewportModal(modal);
  if(deferFocus||modal.__hohViewportDeferFocus)return;
  /* ⛔ R580: FOCUS THE DIALOG, NOT ITS CLOSE BUTTON. Dawn's global
     *:focus-visible rule paints a ring around whatever is focused, and this
     button is a 64px invisible box whose visible mark is a 48px circle
     inside it. Focusing it therefore drew a big light square around a small
     x on every open, which is the box in Jan's screenshot. Moving focus to
     the dialog itself is the standard pattern anyway, keeps a screen reader
     oriented, and paints nothing. Keyboard users Tab straight to Close. */
  try{
   if(!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex','-1');
   modal.focus({preventScroll:true});
  }catch(_){ try{ modal.focus(); }catch(__){ } }
 },0);
 return modal;
};
/* R793.1: the page-side half of hohPresentViewportModal, once a deferred
   open has landed. A no-op for a modal that closed first. */
function hohSettleViewportPage(modal){
 if(!modal||!modal.__hohPageDeferred)return;
 modal.__hohPageDeferred=false;
 if(!hohViewportModalVisible(modal))return;
 /* R793.1 fix (measured at 4x CPU): pin first, while the layout is clean,
    and make the Hall inert in the next task. inert restyles the whole Hall,
    and set first it was forced into this task by the pin's own reads (a
    72ms task the moment the card landed). Two short tasks now; the
    full-screen dialog already takes every tap and holds focus in between. */
 hohLockPageScroll();
 setTimeout(function(){
  if(hohViewportModalVisible(modal)&&!modal.__hohPageDeferred)hohSetViewportBackgroundBlocked(true);
 },0);
}
window.hohDismissViewportModal=function(modal){
 if(typeof modal==='string')modal=document.getElementById(modal);
 if(!modal)return;
 modal.__hohPageDeferred=false;
 modal.style.display='none';
 modal.setAttribute('aria-hidden','true');
 var opener=modal.__hohViewportOpener;
 modal.__hohViewportOpener=null;
 /* R609: recomputed from the form's own visibility, never from "is anything
    open" — closing the form while the hero detail is still up must still give
    the corner wallet back. */
 hohSyncFormModalBodyClass();
 if(!hohAnyViewportModalOpen()){
  document.body.classList.remove('hoh-viewport-modal-open');
  hohSetViewportBackgroundBlocked(false);
  /* ⛔ R580: released only once nothing is left open, and it puts the page back
     on the exact row they were looking at. The display:none above already ran,
     so this modal is correctly excluded from that check. */
  hohUnlockPageScroll();
  setTimeout(function(){
   if(opener&&opener.focus&&document.contains(opener)){
    try{opener.focus({preventScroll:true});}catch(_){try{opener.focus();}catch(__){}}
   }
  },0);
 }
};
/* Escape and a small focus loop complete the dialog contract. If a secondary
   confirmation is open above one of these dialogs, leave the event alone so
   we never close the parent out from under its child. */
if(!document.__hohViewportModalKeys){
 document.__hohViewportModalKeys=true;
 document.addEventListener('keydown',function(ev){
  var blockers=['hoh-ff-confirm-modal','hoh-ff-qualify-modal','hoh-company-modal'];
  for(var b=0;b<blockers.length;b++){
   var blocker=document.getElementById(blockers[b]);
   if(blocker&&blocker.style.display&&blocker.style.display!=='none')return;
  }
  var modal=null;
  for(var i=HOH_VIEWPORT_MODAL_IDS.length-1;i>=0;i--){
   var candidate=document.getElementById(HOH_VIEWPORT_MODAL_IDS[i]);
   if(hohViewportModalVisible(candidate)){modal=candidate;break;}
  }
  if(!modal)return;
  if(ev.key==='Escape'){
   ev.preventDefault();
   if(modal.id==='hoh-form-modal'&&typeof window.hohCloseForm==='function')window.hohCloseForm();
   else if(modal.id==='hoh-raffle-modal'&&typeof window.hohCloseRaffle==='function')window.hohCloseRaffle();
   /* R793.1: the card view goes back to its tile; any other view closes as before */
   else if(modal.id==='hoh-modal'&&typeof window.hohHallCardClose==='function')window.hohHallCardClose();
   else if(modal.id==='hoh-modal'&&typeof window.hohCloseModal==='function')window.hohCloseModal();
   return;
  }
  if(ev.key!=='Tab')return;
  var nodes=modal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
  var focusable=[];
  for(var n=0;n<nodes.length;n++){
   if(nodes[n].getClientRects&&nodes[n].getClientRects().length)focusable.push(nodes[n]);
  }
  if(!focusable.length){ev.preventDefault();return;}
  var first=focusable[0],last=focusable[focusable.length-1];
  if(ev.shiftKey&&document.activeElement===first){ev.preventDefault();last.focus();}
  else if(!ev.shiftKey&&document.activeElement===last){ev.preventDefault();first.focus();}
 });
}

/* ============================================================
   R558 — MAIN HALL CARD-FIRST VIEW
   The public Hall grid opens the real trading card before the long character
   dossier. Public Hall permalinks use that same card-first door; marquee cards,
   moderation tools and every other existing hohOpenDetail caller retain the
   established detailed/NPC view. The card is mounted in the existing primary
   modal so backdrop close, Escape, inert background, focus return and URL
   cleanup continue to have one owner.
   ============================================================ */
function hohHallJsString(value){
 return String(value == null ? '' : value)
  .replace(/\\/g,'\\\\')
  .replace(/'/g,"\\'")
  .replace(/[\r\n\u2028\u2029]/g,' ')
  .replace(/&/g,'&amp;')
  .replace(/"/g,'&quot;')
  .replace(/</g,'&lt;')
  .replace(/>/g,'&gt;');
}
function hohFindModalHero(id){
 var sid=String(id);
 var visible=allCharacters.find(function(ch){return ch&&String(ch.id)===sid;});
 if(visible)return visible;
 return (window.__hohHidden||[]).find(function(ch){return ch&&String(ch.id)===sid;})||hohFindOwnHidden(sid);
}
function hohStopHallCardObserver(){
 var modal=document.getElementById('hoh-modal');
 if(!modal||!modal.__hohHallCardObserver)return;
 try{modal.__hohHallCardObserver.disconnect();}catch(_){}
 modal.__hohHallCardObserver=null;
}
function hohSetHallModalMode(mode){
 var modal=document.getElementById('hoh-modal');
 if(!modal)return;
 var content=modal.querySelector('.hoh-modal-content');
 modal.classList.remove('hoh-hall-card-modal','hoh-hall-detail-return-modal');
 if(content)content.classList.remove('hoh-hall-card-content');
 if(mode==='card'){
  modal.classList.add('hoh-hall-card-modal');
  if(content)content.classList.add('hoh-hall-card-content');
 }else{
  hohStopHallCardObserver();
  if(mode==='detail')modal.classList.add('hoh-hall-detail-return-modal');
 }
}
/* R793: the card view's actions row: for your own hero, the compact daily
   ticket from hoh-tickets.js.
   R793.1 (Jan, 2026-09-22): "remove the 'heart' from the card view, its
   badly formatted and unintuitive, they can heart it when they are inside
   the detailed view." The favourite toggle is gone from here; favouriting
   lives in the detailed view and on the grid tile. Anyone else's hero has
   no row at all, so nothing is left floating between the card number and
   Show detailed view. */
/* R793.1 (Jan, 2026-09-22): "the card page should be clean and back to what it
   was, all these details and giving tickets need to be inside the character
   details page." The ticket left the card view too; it lives in the detailed
   view (hohHallTicketPanelHtml(c,'detail')), so the card view is just the
   card, its number, Show detailed view and Close. */
function hohHallCardActsHtml(c){
 return '';
}
function hohHallViewToggleHtml(c,detailOn){
 var id=hohHallJsString(c&&c.id);
 var label=detailOn?'Show card view':'Show detailed view';
 var fn=detailOn?'hohShowHallCard':'hohShowHallDetail';
 return '<div class="hoh-hall-view-toggle-wrap'+(detailOn?' hoh-hall-view-toggle-wrap-detail':'')+'">'+
  '<button type="button" class="hoh-hall-view-toggle" onclick="event.stopPropagation();'+fn+'(\''+id+'\')">'+
   '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="3.5" width="16" height="17" rx="2"></rect><path d="M8 8h8M8 16h5M8 12h8"></path></svg>'+
   '<span>'+label+'</span>'+
  '</button>'+
 '</div>';
}
/* Admin actions stay on the opened card; framing uses the same primary slot
   as the Hall grid, and hiding keeps the existing moderation reason sheet. */
/* ⛔ OWNERREFRAME (Jan, 2026-10-07): "if someone owns their own card, show the
   reframe button here as well for them". The signed-in owner (the Edit hero
   rule, hohYourHallCanEditCharacter: the hero's auth_email is them) gets
   Reframe portrait on their own card view. Hide, Jan's featured and the
   winner picker stay debug-only. Their save is the same owner-or-admin RPC
   the edit form uses (hohPersistOffsetServer: set_character_image_reframe
   with their email and PIN). */
function hohHallCanReframe(c){
 if(!c)return false;
 if(typeof window.hohIsGodMode==='function'&&window.hohIsGodMode())return true;
 return typeof window.hohYourHallCanEditCharacter==='function'&&!!window.hohYourHallCanEditCharacter(c);
}
function hohHallCardAdminHtml(c){
 if(!c)return '';
 var god=typeof window.hohIsGodMode==='function'&&window.hohIsGodMode();
 var hasArt=!!(c.image_url||c.image_thumb_url);
 if(!god&&!(hasArt&&hohHallCanReframe(c)))return '';
 var id=hohHallJsString(c.id);
 /* the owner's row is the last one, so it keeps 8px clear of the Close row that tucks up under it */
 return '<div class="hoh-hall-card-admin'+(god?'':' hoh-hall-card-admin-owner')+'">'+
  '<div class="hoh-hall-card-admin-actions">'+
   (hasArt?'<button type="button" class="hoh-hall-view-toggle" data-hall-reframe aria-expanded="false" aria-controls="hoh-hall-reframe-tools" onclick="event.stopPropagation();hohToggleHallCardReframe(\''+id+'\')">Reframe portrait</button>':'')+
   (god?'<button type="button" class="hoh-hall-view-toggle" data-hall-hide onclick="event.stopPropagation();hohJangelaToggleHidden(\''+id+'\')">Hide from Hall</button>':'')+
  '</div>'+
  /* JANNONFF (2026-10-23): FF portraits carry "Jan’s featured", every other hero "Jan’s NON FF Favorites" (a hero
     ticked featured before this split keeps its box, so it can still be unticked) */
  (god?(c.is_ff_portrait||hohIsJanFeatured(c)?hohHallJanFeaturedHtml(c):'')+(c.is_ff_portrait?'':hohHallJanNonFFHtml(c))+hohHallWinnerBtnHtml(c):'')+
  /* FITEDITOR: hohToggleHallCardReframe fills this with the fit editor's
     controls (help line, Hall tile, zoom, Undo) when it opens */
  '<div id="hoh-hall-reframe-tools" class="hoh-hall-reframe-tools" hidden></div>'+
  '<div class="hoh-hall-reframe-status" data-hall-reframe-status role="status" aria-live="polite"></div>'+
 '</div>';
}
/* WINNERPICK: debug mode's one-tap way to crown this month's winner
   (hohSetMonthWinner). Once crowned it reads as a quiet gold label. */
/* ⛔ JANFEATURED (Jan, 2026-10-02): "a backend marking i want to add to the best
   heroes to showcase ... whenever the hall is used for other areas of the
   website or like for scrolling images ... a checkbox under each character so
   its saved properly". Debug mode's card view carries a "Jan's featured"
   checkbox. It saves at once on the hero as quest_meta.jan_featured (true, or
   the key removed), the same JSON the other debug flags live in, merged so no
   other key is touched. Anything on the site can ask for the set:
   hohJanFeaturedHeroes() in the Hall, or PostgREST
   characters?quest_meta->>jan_featured=eq.true anywhere else.
   Not the monthly FEATURED winner (characters.featured). */
function hohIsJanFeatured(c){ var q=c&&c.quest_meta; return !!(q&&typeof q==='object'&&q.jan_featured===true); }
window.hohIsJanFeatured=hohIsJanFeatured;
window.hohJanFeaturedHeroes=function(){ return (allCharacters||[]).filter(function(c){ return c&&c.is_hidden!==true&&hohIsJanFeatured(c); }); };
function hohJanFeaturedCountText(){ var n=window.hohJanFeaturedHeroes().length; return n+(n===1?' hero':' heroes'); }
function hohHallJanFeaturedHtml(c){
 return '<label class="hoh-hall-janfeat" onclick="event.stopPropagation();">'+
  '<input type="checkbox" data-hall-janfeat'+(hohIsJanFeatured(c)?' checked':'')+' onchange="hohToggleJanFeatured(\''+hohHallJsString(c.id)+'\',this)">'+
  '<span class="hoh-hall-janfeat-box" aria-hidden="true"></span>'+
  '<span class="hoh-hall-janfeat-text">Jan’s featured</span>'+
  '<span class="hoh-hall-janfeat-count" data-hall-janfeat-count>'+hohJanFeaturedCountText()+'</span>'+
 '</label>';
}
window.hohToggleJanFeatured=async function(id,input){
 if(!id||!input||typeof window.hohIsGodMode!=='function'||!window.hohIsGodMode())return;
 var c=(allCharacters||[]).find(function(x){return x&&String(x.id)===String(id);});
 if(!c){ input.checked=!input.checked; return; }
 var want=!!input.checked;
 var qm={}; try{ qm=Object.assign({},c.quest_meta||{}); }catch(_){}
 if(want)qm.jan_featured=true; else delete qm.jan_featured;
 input.disabled=true;
 var saved=false;
 try{
  var res=await supabase.from('characters').update({quest_meta:qm}).eq('id',c.id).select('id');
  saved=!res.error&&!!res.data&&!!res.data.length;
  if(!saved){ try{ alert('Could not save Jan’s featured'+(res.error&&res.error.message?': '+res.error.message:'. The database did not accept the change.')); }catch(_){} }
 }catch(e){ try{ alert('Could not save Jan’s featured.'); }catch(_){} }
 input.disabled=false;
 if(!saved){ input.checked=!want; return; }
 c.quest_meta=qm;
 try{ var cnt=input.parentNode&&input.parentNode.querySelector('[data-hall-janfeat-count]'); if(cnt)cnt.textContent=hohJanFeaturedCountText(); }catch(_){}
 try{ if(typeof window.hohShowHallToast==='function')window.hohShowHallToast((want?'Added to':'Removed from')+' Jan’s featured.'); }catch(_){}
};
/* JANNONFF (Jan, 2026-10-23: "allow me to actually mark non ff portraits as Jan's Favorites as well but its a
   separate category ... call them like Jan's NON FF Favorites so i can pick some so then you can grab those as the
   enemies the player must fight through"). Debug mode's card view carries a "Jan’s NON FF Favorites" checkbox on heroes
   that are not FF portraits. It saves at once on the hero as quest_meta.jan_nonff_featured (true, or the key removed),
   merged like jan_featured so no other key is touched. The Unbound game page reads the set
   (characters?quest_meta->>jan_nonff_featured=eq.true) for the squads it fights between its bosses. */
function hohIsJanNonFF(c){ var q=c&&c.quest_meta; return !!(q&&typeof q==='object'&&q.jan_nonff_featured===true); }
window.hohIsJanNonFF=hohIsJanNonFF;
window.hohJanNonFFHeroes=function(){ return (allCharacters||[]).filter(function(c){ return c&&c.is_hidden!==true&&hohIsJanNonFF(c); }); };
function hohJanNonFFCountText(){ var n=window.hohJanNonFFHeroes().length; return n+(n===1?' hero':' heroes'); }
function hohHallJanNonFFHtml(c){
 return '<label class="hoh-hall-janfeat hoh-hall-jannonff" onclick="event.stopPropagation();">'+
  '<input type="checkbox" data-hall-jannonff'+(hohIsJanNonFF(c)?' checked':'')+' onchange="hohToggleJanNonFF(\''+hohHallJsString(c.id)+'\',this)">'+
  '<span class="hoh-hall-janfeat-box" aria-hidden="true"></span>'+
  '<span class="hoh-hall-janfeat-text">Jan’s NON FF Favorites</span>'+
  '<span class="hoh-hall-janfeat-count" data-hall-jannonff-count>'+hohJanNonFFCountText()+'</span>'+
 '</label>';
}
window.hohToggleJanNonFF=async function(id,input){
 if(!id||!input||typeof window.hohIsGodMode!=='function'||!window.hohIsGodMode())return;
 var c=(allCharacters||[]).find(function(x){return x&&String(x.id)===String(id);});
 if(!c){ input.checked=!input.checked; return; }
 var want=!!input.checked;
 var qm={}; try{ qm=Object.assign({},c.quest_meta||{}); }catch(_){}
 if(want)qm.jan_nonff_featured=true; else delete qm.jan_nonff_featured;
 input.disabled=true;
 var saved=false;
 try{
  var res=await supabase.from('characters').update({quest_meta:qm}).eq('id',c.id).select('id');
  saved=!res.error&&!!res.data&&!!res.data.length;
  if(!saved){ try{ alert('Could not save Jan’s NON FF Favorites'+(res.error&&res.error.message?': '+res.error.message:'. The database did not accept the change.')); }catch(_){} }
 }catch(e){ try{ alert('Could not save Jan’s NON FF Favorites.'); }catch(_){} }
 input.disabled=false;
 if(!saved){ input.checked=!want; return; }
 c.quest_meta=qm;
 try{ var cnt=input.parentNode&&input.parentNode.querySelector('[data-hall-jannonff-count]'); if(cnt)cnt.textContent=hohJanNonFFCountText(); }catch(_){}
 try{ if(typeof window.hohShowHallToast==='function')window.hohShowHallToast((want?'Added to':'Removed from')+' Jan’s NON FF Favorites.'); }catch(_){}
};
/* WINNERPICK (Jan, 2026-10-02): "once i pick it for the month ... it can go away
   until next month". With the month's winner crowned the picker leaves every
   other hero until the next draw (noon Eastern on the 1st turns the draw month
   over and it comes back). The winner's card keeps its label plus "Pick someone
   else", which brings the picker back for this visit only; nothing is written
   until another hero is crowned. */
var _hohWinnerRepick=false;
window.hohWinnerRepick=function(){
 _hohWinnerRepick=true;
 try{
  var view=document.querySelector('#hoh-modal .hoh-hall-card-view');
  var id=view&&view.getAttribute('data-hero-id');
  if(id&&typeof window.hohOpenHallCard==='function')window.hohOpenHallCard(id,null,true);
 }catch(_){}
 try{ if(typeof window.hohShowHallToast==='function')window.hohShowHallToast('Open the hero you want and make them the winner.'); }catch(_){}
};
function hohHallWinnerBtnHtml(c){
 var month=hohMonthKeyName(hohDrawMonthKey());
 if(c.featured&&hohWinnerMonthOf(c)===hohDrawMonthKey()){
  return '<div class="hoh-hall-winner-row">'+
   '<span class="hoh-hall-winner-done" role="status">'+esc(month)+'’s winner</span>'+
   (_hohWinnerRepick?'':'<button type="button" class="hoh-hall-winner-redo" onclick="event.stopPropagation();hohWinnerRepick()">Pick someone else</button>')+
  '</div>';
 }
 if(hohDrawWinnerChosen()&&!_hohWinnerRepick)return '';
 return '<button type="button" class="hoh-hall-winner-btn" data-hall-winner onclick="event.stopPropagation();hohSetMonthWinner(\''+hohHallJsString(c.id)+'\')">Make '+esc(month)+'’s winner</button>';
}
var _hohHallReframeSaves={};
/* FITEDITOR: the save status never claims more than the server confirmed.
   "Saving", then "Saved for everyone" only on the server's ok, or "Not saved.
   Tap to try again" (a real button that sends the same framing again). */
function hohReframeStatusHtml(state){
 if(state==='saving')return '<span>Saving</span>';
 if(state==='saved')return '<b>Saved for everyone</b>';
 if(state==='failed')return '<button type="button" class="hoh-fit-retry" data-fit-retry>Not saved. Tap to try again</button>';
 return '';
}
function hohHallReframeStatus(id,state){
 var view=document.querySelector('#hoh-modal .hoh-hall-card-view');
 if(view && view.getAttribute('data-hero-id')===String(id)){
  var status=view.querySelector('[data-hall-reframe-status]');
  if(!status)return;
  status.innerHTML=hohReframeStatusHtml(state);
  status.setAttribute('data-state',state||'');
  var retry=status.querySelector('[data-fit-retry]');
  if(retry)retry.onclick=function(e){e.stopPropagation();hohSaveHallCardReframe(id,true);};
 }
}
function hohSaveHallCardReframe(id,now){
 if(!hohHallCanReframe(hohFindModalHero(id)))return;
 var job=_hohHallReframeSaves[id]||(_hohHallReframeSaves[id]={version:0,busy:false,status:'',timer:0});
 job.version++;
 /* One write at a time per hero, 400ms after the last release. A movement
    during a save sends the latest framing next, even if the card was closed
    or another hero was opened. */
 clearTimeout(job.timer);job.timer=0;
 function save(){
  job.timer=0;
  if(job.busy)return;
  job.busy=true;
  var version=job.version;
  job.status='saving';hohHallReframeStatus(id,job.status);
  function finish(ok){
   job.busy=false;
   if(version!==job.version){if(!job.timer)save();return;}
   job.status=ok?'saved':'failed';
   hohHallReframeStatus(id,job.status);
  }
  try{Promise.resolve(window.hohPersistOffsetServer(id,'primary')).then(finish,function(){finish(false);});}
  catch(_){finish(false);}
 }
 job.flush=save;
 if(now)save();else job.timer=setTimeout(save,400);
}
window.hohToggleHallCardReframe=function(id){
 if(!hohHallCanReframe(hohFindModalHero(id)))return;
 var view=document.querySelector('#hoh-modal .hoh-hall-card-view');
 if(!view || view.getAttribute('data-hero-id')!==String(id))return;
 var c=hohFindModalHero(id), stage=view.querySelector('.hoh-hall-card-stage');
 var card=stage&&stage.querySelector('.ffshop-card');
 var frame=card&&card.querySelector('.is-front .ffshop-art,.is-front .ffshop-artfull');
 if(!c || !frame || !frame.querySelector('img'))return;
 /* A card opened on its back returns through the normal card renderer. */
 if(card.classList.contains('on') || card.classList.contains('ffshop-turn')){
  window.hohOpenHallCard(id);window.hohToggleHallCardReframe(id);return;
 }
 var active=!view.classList.contains('hoh-hall-reframing');
 view.classList.toggle('hoh-hall-reframing',active);
 var btn=view.querySelector('[data-hall-reframe]');
 btn.setAttribute('aria-expanded',String(active));btn.textContent=active?'Done reframing':'Reframe portrait';
 view.querySelector('.hoh-hall-reframe-tools').hidden=!active;
 frame.__hohReframeEnabled=active;
 frame.classList.toggle('hoh-edit-img-frame',active);
 /* FITEDITOR: the card's own art window becomes the fit editor (grip,
    outline, thirds grid and the cut-off part while a finger is down, pinch,
    tap to centre, keys), its controls fill the tools row (help line, the Hall
    tile, zoom, Undo), and each release autosaves after 400ms. The in-memory
    row only changes when the server says ok (hohPersistOffsetServer). */
 var tools=view.querySelector('.hoh-hall-reframe-tools');
 if(active){
  frame.setAttribute('data-charid',String(id));frame.setAttribute('data-slot','primary');
  if(frame.__hohFit){try{frame.__hohFit.destroy();}catch(_){}}
  tools.innerHTML='';
  frame.__hohFit=hohFitEditor(tools,{mode:'owner',id:String(id),slot:'primary',frame:frame,name:c.name||'',
   enabled:function(){return view.classList.contains('hoh-hall-reframing');},
   onChange:function(){hohSaveHallCardReframe(id);}});
  if(!frame.__hohHallReframeWired){
   frame.__hohHallReframeWired=true;
   stage.addEventListener('click',function(e){
    if(view.classList.contains('hoh-hall-reframing')){e.preventDefault();e.stopImmediatePropagation();}
   },true);
  }
  var job=_hohHallReframeSaves[id];
  hohHallReframeStatus(id,(job&&job.status)||'');
 }else{
  if(frame.__hohFit){try{frame.__hohFit.destroy();}catch(_){}frame.__hohFit=null;}
  tools.innerHTML='';
  /* closing sends a save still waiting out its 400ms right away */
  var pend=_hohHallReframeSaves[id];
  if(pend&&pend.timer&&pend.flush){clearTimeout(pend.timer);pend.flush();}
 }
 var flip=stage.querySelector('[data-hall-card-flip]');
 if(flip)flip.disabled=active;
 hohFitHallCardView();
};
/* ⛔ R568 (Jan): "show card view should be an option on the bottom as a text in
   the same style as the edit hero and stuff for the users end ... but its not
   supposed to be a separate panel on top of them."
   The boxed toggle above is still right on the CARD side, where it is the only
   control on screen and has room to be a proper button. On the DETAIL side it
   was landing as its own bordered panel directly above the row of plain gold
   text links, so the same screen offered two different visual languages for
   the same kind of action, and the panel read as more important than Edit Hero
   while doing less. This is the same action as a sibling of those links.
   It is emitted BY the owner-row builder rather than beside it, because two
   adjacent `.hoh-detail-edit-row`s are two rows — and one row is the ask. */
function hohHallViewToggleLinkHtml(c){
 var id=hohHallJsString(c&&c.id);
 return '<button type="button" class="hoh-edit-link-bottom hoh-edit-link-bottom-view"'+
   ' onclick="event.stopPropagation();hohShowHallCard(\''+id+'\')">Show card view</button>';
}
/* ⛔ OWNER-ONLY, and the test is AUTHORSHIP rather than whether the card sits
   in somebody's collection. `save_card_text` writes to `characters.card_meta`,
   which is GLOBAL — whatever is typed here, every collector of that card sees
   — so the gate has to be the same one the server enforces
   (`auth_email` matches, or Jan). `hohYourHallCanEditCharacter` is exactly
   that test, and reusing it means the button can never offer a door the RPC
   will refuse. */
function hohHallEditTextLinkHtml(c){
 if(!c || !c.id) return '';
 var can=false;
 try{ can = (typeof window.hohYourHallCanEditCharacter==='function') && window.hohYourHallCanEditCharacter(c); }catch(_){ can=false; }
 if(!can) return '';
 /* the editor lives in hoh-shop.js. If that asset is not on the page there is
    nothing to open, so the link does not appear rather than appearing dead. */
 if(typeof window.hohShopEditCardText!=='function') return '';
 var id=hohHallJsString(c.id);
 return '<button type="button" class="hoh-edit-link-bottom hoh-edit-link-bottom-cardtext"'+
   ' onclick="event.stopPropagation();hohHallEditCardText(\''+id+'\')">Edit card text</button>';
}
/* ⛔ THE EDIT ENDS ON THE CARD, not back on the page it started from.
   The words being edited are printed on the trading card, and the owner is
   standing on the DETAIL view when they tap this — so saving and returning to
   the detail would end the whole loop with a toast and nothing visibly
   different. Landing on the card view is the only feedback that actually shows
   them what they wrote. Falls back to a detail repaint if the card view is
   unavailable, so the editor can never save into a dead end. */
window.hohHallEditCardText=function(id){
 if(!id||typeof window.hohShopEditCardText!=='function')return;
 window.hohShopEditCardText(id,{onSaved:function(){
  try{
   if(typeof window.hohShowHallCard==='function'){window.hohShowHallCard(String(id));return;}
   if(typeof window.hohOpenDetail==='function')window.hohOpenDetail(String(id));
  }catch(_){ }
 }});
};
/* R558c: card and dossier are two views of one open Hall dialog. Fade the
   persistent modal content to transparent, replace the body only while it is
   invisible, then fade it back. A generation token is the hard boundary for
   Escape/backdrop-close races: a stale timer can never repaint a closed modal
   or restore its ?hero URL. */
var _hohHallViewTransitionToken=0;
var _hohHallViewTransitionTimer=null;
var _hohHallViewTransitionBusy=false;
function hohHallViewReducedMotion(){
 try{return !!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);}catch(_){return false;}
}
function hohRestoreHallTransitionFocusHost(modal){
 if(!modal)return;
 try{
  if(modal.__hohHallViewHadTabIndex)modal.setAttribute('tabindex',modal.__hohHallViewTabIndex);
  else modal.removeAttribute('tabindex');
 }catch(_){ }
 delete modal.__hohHallViewHadTabIndex;
 delete modal.__hohHallViewTabIndex;
}
function hohFocusHallTransitionTarget(modal){
 if(!modal)return;
 var close=modal.querySelector('.hoh-close-top');
 if(close&&close.focus){try{close.focus({preventScroll:true});}catch(_){try{close.focus();}catch(__){}}}
 hohRestoreHallTransitionFocusHost(modal);
}
function hohCancelHallViewTransition(){
 _hohHallViewTransitionToken++;
 if(_hohHallViewTransitionTimer){clearTimeout(_hohHallViewTransitionTimer);_hohHallViewTransitionTimer=null;}
 _hohHallViewTransitionBusy=false;
 var modal=document.getElementById('hoh-modal');
 if(!modal)return;
 modal.__hohViewportDeferFocus=false;
 modal.removeAttribute('aria-busy');
 var content=modal.querySelector('.hoh-modal-content');
 if(content)content.classList.remove('hoh-hall-view-transition','hoh-hall-view-faded');
 var toggle=modal.querySelector('.hoh-hall-view-toggle');
 if(toggle)toggle.disabled=false;
 /* R572: put the real label back if this toggle survived an aborted swap */
 try{
  var _sp=toggle&&toggle.querySelector('span');
  if(_sp&&_sp.__hohBusy){ if(_sp.__hohWas)_sp.textContent=_sp.__hohWas; _sp.__hohBusy=0; }
 }catch(_){ }
 hohRestoreHallTransitionFocusHost(modal);
}
/* ⛔ R576 · THE SAME REPAINT KICK, FOR THE SAME REASON. Jan: "show detailed view
   still doesnt work." The handler fires and the modal's contents really are
   replaced, measured at 860ms, so the press was never being lost. On the very
   screen where a card face swaps in the DOM and iOS keeps showing the old
   pixels, a whole modal body swapping and not being painted is the same fault
   wearing a bigger coat, and it looks identical from the outside: you press it
   and nothing happens.
   Removing the element from the render tree and putting it back is the one
   instruction the compositor cannot defer. It is safe here because this runs
   AFTER the render, once the fade classes are already off. */
function hohForceModalRepaint(){
 try{
  var box=document.querySelector('#hoh-modal .hoh-modal-content');
  if(!box) return;
  var prev=box.style.display;
  box.style.display='none';
  void box.offsetHeight;
  box.style.display=prev||'';
  void box.offsetHeight;
 }catch(_){ }
}
function hohRenderHallView(target,c){
 var modal=document.getElementById('hoh-modal');
 if(!modal||!c)return;
 if(target==='detail'){
  window.__hohHallCardOrigin={id:String(c.id),mode:'detail'};
  window.hohOpenDetail(c.id);
 }else{
  window.hohOpenHallCard(c.id,null,true);
 }
 window.hohResetViewportModal(modal);
 hohForceModalRepaint();
}
/* ⛔ R572 (Jan): "pressing show detailed view does nothing" and "after maybe 20
   seconds on the backside it will load the character details". The swap really
   does work, but the ONLY acknowledgement of a press was the disabled state's
   drop to 52% opacity, and on a phone that is both easy to miss and, while
   WebKit is behind on painting, sometimes not drawn at all. Worse, a press
   arriving while a swap is already running returned in total silence.
   So say something, in words, immediately. Text survives a missed repaint far
   better than an opacity change, and the label is replaced wholesale by the
   render that follows, so nothing has to put it back. */
function hohHallViewToggleBusyLabel(modal){
 try{
  var span=modal&&modal.querySelector('.hoh-hall-view-toggle span');
  /* remember the real label: if the swap ABORTS (stale token, modal closed)
     the render that would have replaced this never happens, and a button
     frozen on "Opening…" is worse than the silence it replaced */
  if(span&&!span.__hohBusy){ span.__hohBusy=1; span.__hohWas=span.textContent; span.textContent='Opening…'; }
 }catch(_){ }
}
function hohTransitionHallView(target,c){
 var modal=document.getElementById('hoh-modal');
 if(!modal||!c||!hohViewportModalVisible(modal))return;
 /* R793.1: a press that lands while the card is still flying in from its
    tile no longer lands the card first (that snapped it to its place, then
    faded it). The move finishes under the fade-through, which only touches
    the content's opacity, and the landing does the held page work as usual
    (a detail render meanwhile finds it pending and leaves it). Only the art
    copy above the content bows out (hohHallCardGhostAway). */
 try{ hohHallCardGhostAway(); }catch(_){ }
 /* a second press during a swap is not a no-op any more: it re-states that the
    first one was heard, rather than looking like a dead button */
 if(_hohHallViewTransitionBusy){ hohHallViewToggleBusyLabel(modal); return; }
 hohHallViewToggleBusyLabel(modal);
 _hohHallViewTransitionBusy=true;
 var token=++_hohHallViewTransitionToken;
 var content=modal.querySelector('.hoh-modal-content');
 if(!content){_hohHallViewTransitionBusy=false;hohRenderHallView(target,c);return;}
 modal.setAttribute('aria-busy','true');
 modal.__hohViewportDeferFocus=true;
 var toggle=modal.querySelector('.hoh-hall-view-toggle');
 if(toggle)toggle.disabled=true;
 try{
  modal.__hohHallViewHadTabIndex=modal.hasAttribute('tabindex');
  modal.__hohHallViewTabIndex=modal.getAttribute('tabindex');
  modal.setAttribute('tabindex','-1');
  modal.focus({preventScroll:true});
 }catch(_){ }
 /* ⛔ R576/R577 · A LATCH THAT GATES A CONTROL MUST NEVER BE ABLE TO LEAK.
    hohTransitionHallView opens with `if(busy) return`, so ANY path that leaves
    without clearing _hohHallViewTransitionBusy disables "Show detailed view"
    for the rest of the page's life, silently and with nothing logged. That is
    exactly the shape of Jan's report that it "still doesnt work".
    ⛔ THERE WERE FOUR SUCH PATHS AND R576 CLOSED ONLY ONE. Fixing finish() could
    not have been enough, because on two of the others finish() is never reached
    at all: the rAF and the 150ms timer each bailed with a bare return before
    the timer that schedules it was ever set, and the render between them was
    unguarded so a throw skipped it too. Every exit routes through here now.
    ⛔ ONLY THIS TRANSITION'S OWN LATCH IS RELEASED. If the token has moved on, a
    NEWER swap owns it, and clearing it here would strip that one of its guard
    and let a third press interleave. */
 function releaseIfMine(){
  if(token === _hohHallViewTransitionToken){
   _hohHallViewTransitionBusy=false;
   _hohHallViewTransitionTimer=null;
  }
 }
 function finish(){
  var mine = (token === _hohHallViewTransitionToken);
  releaseIfMine();
  if(!mine || !hohViewportModalVisible(modal)) return;
  var liveContent=modal.querySelector('.hoh-modal-content');
  if(liveContent)liveContent.classList.remove('hoh-hall-view-transition','hoh-hall-view-faded');
  modal.classList.add('hoh-hall-view-swapped');
  modal.removeAttribute('aria-busy');
  modal.__hohViewportDeferFocus=false;
  hohFocusHallTransitionTarget(modal);
  /* the fade has ended and this content is now what the player should be
     looking at, so this is the moment that has to reach the screen */
  hohForceModalRepaint();
 }
 if(hohHallViewReducedMotion()){
  hohRenderHallView(target,c);
  finish();
  return;
 }
 content.classList.add('hoh-hall-view-transition');
 requestAnimationFrame(function(){
  /* ⛔ R577 · THE OTHER TWO LEAKS. R576 made finish() always release the latch,
     which was necessary and NOT sufficient, because on these two paths finish()
     is never called at all: each bailed with a bare `return`, so the timer that
     schedules finish() was never even set and the latch stayed TRUE for the
     rest of the page's life. Every exit releases now.
     ⛔ WHY THIS IS AN iPHONE FAULT AND NOT A DESKTOP ONE: it is the width of the
     abort window. Desktop runs this swap in about 340ms of un-throttled rAF and
     timers, so the window is almost unhittable. On iOS the same swap was
     measured at 860ms and Jan reports up to 20 seconds, because WebKit defers
     rAF and timers under load, and a modal closed or re-opened anywhere in that
     stretch lands exactly here. */
  if(token!==_hohHallViewTransitionToken||!hohViewportModalVisible(modal)){ releaseIfMine(); return; }
  content.classList.add('hoh-hall-view-faded');
  _hohHallViewTransitionTimer=setTimeout(function(){
   if(token!==_hohHallViewTransitionToken||!hohViewportModalVisible(modal)){ releaseIfMine(); return; }
   /* ⛔ AND THE THIRD LEAK: this render was UNGUARDED, so anything it throws
      skipped the setTimeout(finish,190) below and latched the button dead.
      hohOpenDetail writes innerHTML and calls history.replaceState, and WebKit
      throws a SecurityError on replaceState past roughly 100 calls in 30
      seconds, which is a limit a real browsing session reaches and Chrome does
      not enforce. A throw must cost this one swap, never the control. */
   try{
    hohRenderHallView(target,c);
   }catch(_){
    /* hohCancelHallViewTransition is the full reset: it clears the latch and
       the timer, bumps the token so any pending finish is stale, drops
       aria-busy and re-enables the toggle. That is exactly what a failed swap
       needs, and it leaves the control usable. */
    try{ hohCancelHallViewTransition(); }catch(__){ releaseIfMine(); }
    return;
   }
   var nextContent=modal.querySelector('.hoh-modal-content');
   if(nextContent){
    nextContent.classList.add('hoh-hall-view-transition','hoh-hall-view-faded');
    /* Commit the transparent state before beginning the incoming fade. */
    void nextContent.offsetWidth;
    nextContent.classList.remove('hoh-hall-view-faded');
   }
   _hohHallViewTransitionTimer=setTimeout(finish,190);
  },150);
 });
}
/* ⛔ R663 (Jan): "make the card a bit bigger as well just scaling up keep the
   proportions the same ... dont touch mobile". The ceiling below used to be a
   hard 1, so a desktop window with 300px of slack still drew the card at its
   authored 380x650 and no bigger. One scalar drives BOTH the stage box and the
   card's own transform, so scaling up cannot change the card's proportions, and
   the two fit terms beside it still bound the card to the window. Mobile keeps
   the ceiling of exactly 1 it has always had, which is the whole of "don't
   touch mobile" for this half. */
var HOH_HALL_CARD_DESKTOP_MAX=1.15;
function hohFitHallCardView(){
 var modal=document.getElementById('hoh-modal');
 if(!modal||!modal.classList.contains('hoh-hall-card-modal'))return;
 /* R793.1: while the card flies in from its tile the stage carries a move,
    and every rect below would read the moving card. The open fits once
    before the move starts and once when it lands (hohHallCardSettle). */
 if(_hohCardAnim&&_hohCardAnim.running)return;
 var view=modal.querySelector('.hoh-hall-card-view');
 var stage=modal.querySelector('.hoh-hall-card-stage');
 var card=stage&&stage.querySelector('.ffshop-card');
 if(!view||!stage||!card)return;
 var viewport=window.visualViewport;
 var vw=Math.max(1,Math.round((viewport&&viewport.width)||window.innerWidth||380));
 var vh=Math.max(1,Math.round((viewport&&viewport.height)||window.innerHeight||700));
 var mobile=vw<=820;
 var shortLandscape=vh<=430&&vw>vh;
 var naturalH=Math.max(650,card.offsetHeight||650);
 /* Measure the non-card chrome instead of assuming the view has only one
    control. The Profile-style portrait ordinal is deliberately outside the
    scaled stage, so it stays readable while the physical card shrinks. */
 var viewStyle=window.getComputedStyle?window.getComputedStyle(view):null;
 var px=function(value){var n=parseFloat(value);return isFinite(n)?n:0;};
 var outerH=function(node){
  if(!node)return 0;
  var style=window.getComputedStyle?window.getComputedStyle(node):null;
  return (node.offsetHeight||0)+(style?px(style.marginTop)+px(style.marginBottom):0);
 };
 var collector=view.querySelector('.hoh-hall-card-collector');
 var toggle=view.querySelector('.hoh-hall-view-toggle-wrap');
 /* R793: the favourite and daily-ticket row sits under the card too. */
 var acts=view.querySelector('.hoh-hall-card-acts');
 var admin=view.querySelector('.hoh-hall-card-admin');
 var adminClose=admin&&view.querySelector('.hoh-hall-close-row');
 var lastAdmin=adminClose&&adminClose.offsetHeight?adminClose:admin;
 var gap=viewStyle?px(viewStyle.rowGap||viewStyle.gap):12;
 var paddingY=viewStyle?px(viewStyle.paddingTop)+px(viewStyle.paddingBottom):0;
 var chromeH=paddingY+outerH(toggle)+outerH(collector)+outerH(acts)+gap*((collector?2:1)+(acts?1:0))+8;
 if(admin)chromeH+=outerH(admin)+outerH(adminClose)+gap*(adminClose&&adminClose.offsetHeight?2:1);
 var availableW=Math.max(1,view.clientWidth||vw);
 var availableH=Math.max(1,view.clientHeight||vh);
 var maxW=Math.max(160,availableW-(mobile?8:28));
 /* A short landscape phone gets a deliberately legible 260–300px card and
    lets the outer modal travel a small distance vertically. Pure fit-to-height
    reduced the object to 104x180 at 667x375, which technically fit but no
    longer functioned as a card view. */
 var maxH=shortLandscape?Math.max(260,Math.min(300,vh-70)):Math.max(180,availableH-chromeH);
 var scale=Math.min(mobile?1:HOH_HALL_CARD_DESKTOP_MAX,maxW/380,maxH/naturalH);
 if(!isFinite(scale)||scale<=0)scale=1;
 view.style.setProperty('--hoh-hall-card-scale',String(scale));
 /* R663: the centring spacer is applied at the very end, so every measurement
    between here and there sees the same layout the fitter has always seen. A
    stale spacer left on from the previous run would corrupt them all, so it is
    cleared before anything is measured rather than after. */
 stage.style.marginTop='';
 stage.style.width=Math.round(380*scale)+'px';
 stage.style.height=Math.round(naturalH*scale)+'px';
 /* ⛔ R583: the chevrons sit on the CARD's middle, not the view's. A fixed
    percentage was 22px low and would drift again with every row added or
    removed under the card, and it already differs between a hero that prints a
    collector number and one that does not. The fitter is the one place that
    knows where the card actually ended up, so it states it. */
 try{
  var _vr=view.getBoundingClientRect(), _sr=stage.getBoundingClientRect();
  if(_vr.height>0) view.style.setProperty('--hoh-nav-y',
    (((_sr.top-_vr.top)+_sr.height/2)/_vr.height*100).toFixed(2)+'%');
  /* ⛔ R585 (Jan): "on desktop the arrows dont need to be so far out it should be
     next to the card ... put the arrows like just outside the glow range."
     On a phone the card nearly fills the modal, so anchoring the chevrons to the
     modal's edge put them beside the card by accident. On a desktop the modal is
     the whole window and the card is 380px in the middle of it, so the same rule
     stranded them 404px away, measured. The card's own inset is the only honest
     anchor, and the fitter is the one place that knows it. */
  view.style.setProperty('--hoh-card-edge', Math.round(_sr.left-_vr.left)+'px');
 }catch(_){ }
 /* ⛔ R573 · ONE CORRECTIVE PASS, BECAUSE THE ESTIMATE ABOVE HAS ALWAYS BEEN
    OPTIMISTIC. Measured at 375x812 on the live site: the detail toggle finished
    6px BELOW the fold, and it did so at every gutter setting I tried, because
    chromeH under-counts by a stubborn margin and the fitter then hands the
    difference to the card. A fudge constant would only drift again the next
    time a row is added to this view, so measure what actually happened and
    correct once. Single pass, never recursive.
    Skipped in short landscape on purpose: that mode deliberately lets the modal
    scroll rather than shrink the card to an unreadable size, so an overflow
    there is the design, not a fault. */
 if(!shortLandscape){
  try{
   var vrect=view.getBoundingClientRect();
   var limit=vrect.bottom-(viewStyle?px(viewStyle.paddingBottom):0);
   var lastNode=lastAdmin||toggle||collector||stage;
   var over=lastNode.getBoundingClientRect().bottom-limit;
   if(over>0.5){
    var corrected=Math.max(0.2,(Math.round(naturalH*scale)-over)/naturalH);
    if(corrected<scale){
     view.style.setProperty('--hoh-hall-card-scale',String(corrected));
     stage.style.width=Math.round(380*corrected)+'px';
     stage.style.height=Math.round(naturalH*corrected)+'px';
    }
   }
  }catch(_){ }
 }
 /* ⛔ R663 (Jan): "center the card better", desktop only.
    The view is a CENTRED flex column of [card][ordinal][detail link], so what
    is centred is the whole column and the card therefore sits half the chrome
    height above the middle. Measured on a 1001x945 window: the card's centre
    landed 70px high, which is exactly half of what hangs beneath it.
    A spacer above the card fixes it, and in a centred column a spacer of m
    moves the first child down by m/2, never m. Rather than trust that model,
    the shift is asked for and then CORRECTED once against what actually
    happened, the same way the height pass above corrects its own estimate.
    Capped by the room under the last row, so a window too short to centre keeps
    the biggest card instead of pushing its own controls off the bottom, and
    skipped entirely on mobile and in short landscape where the card already
    fills the view. */
 if(!mobile&&!shortLandscape){
  try{
   var lastRow=lastAdmin||toggle||collector||stage;
   var padBottom=viewStyle?px(viewStyle.paddingBottom):0;
   var lift=0;
   for(var pass=0;pass<2;pass++){
    var vRect=view.getBoundingClientRect();
    var sRect=stage.getBoundingClientRect();
    var want=((vRect.top+vRect.bottom)/2)-((sRect.top+sRect.bottom)/2);
    var room=vRect.bottom-padBottom-lastRow.getBoundingClientRect().bottom;
    if(!(want>0.5)||!(room>0.5))break;
    lift+=Math.min(want*2,room*2);
    stage.style.marginTop=Math.round(lift)+'px';
   }
  }catch(_){ }
 }
}
/* ⛔ ================= R573 · THE CARD LEANS, AND IT BREATHES =================
   Jan: "on mobile, i want it so that when you tilt your phone, it actually the
   card sort of tilts with the phone's direction ... that side tilt thing that we
   kind of have with the gift card", and "based on the rarity, have the rarity
   glow also be kind of pulsing a little bit, very subtly."

   THE LAYER RULE, TAKEN STRAIGHT FROM THE GIFT CARD. gift-quiz.js puts its
   mouse lean on a dedicated wrapper between the perspective container and the
   flip element, with the note "Separate layers so the two transforms never
   fight". The same rule decides where this can live: `.ffshop-tiltwrap` already
   carries `transform:scale(...)!important` for the Hall's fit, so a tilt
   written there is discarded by the cascade, which is exactly why R563 stood
   the hover tilt down on this screen. `.hoh-hall-card-stage` is the free layer,
   measured as carrying no transform of its own.

   ⛔ AND IT IS THE ONLY SAFE LAYER. The close button is `position:fixed` and
   lives inside `.hoh-hall-card-view`. A transform on an ancestor becomes the
   containing block for fixed descendants, so tilting the VIEW would tear the
   close button off the corner. Measured: the button is NOT inside the stage,
   so tilting the stage cannot reach it. This is the same trap the view
   transition already documents when it explains why it fades instead of moving.

   ⛔ iOS NEEDS PERMISSION AND IT MUST COME FROM A TAP. On iOS 13+,
   DeviceOrientationEvent.requestPermission() exists and refuses to run outside a
   user gesture, so tilt CANNOT be switched on silently there. Android needs
   nothing and simply works. Rather than fire a system dialog at somebody the
   first time they open a card, the icon beside "Show detailed view" asks, and
   only on the devices that need asking. Once answered either way it never
   appears again. */
/* ⛔ R582: HOH_TILT_KEY, hohTiltNeedsPermission and hohTiltPref are DELETED with
   the feature they served. Nothing reads device motion any more, so a stored
   permission answer has nothing to gate and a feature-detect for
   DeviceOrientationEvent.requestPermission has nothing to detect for. */
var _hohTilt=null;
/* R578: one reader for "is this a touch device", asked at the moment it
   matters rather than trusted from parse. */
function hohCoarsePointer(){
 try{ return !!(window.matchMedia&&window.matchMedia('(pointer: coarse)').matches); }
 catch(_){ return false; }
}
function hohTiltReduced(){
 try{ return !!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(_){ return false; }
}
function hohUnbindHallTilt(){
 var s=_hohTilt; if(!s) return;
 _hohTilt=null;
 /* R742: the mote goes with the lean. A card that closes while the pointer is
    still on it must never leave a light behind, or a page with no cursor. */
 try{ if(s.release) s.release(); }catch(_){ }
}
function hohBindHallTilt(stage){
 hohUnbindHallTilt();
 if(!stage) return;
 /* ⛔ HEROPOLISH (2026-09-25): THE LEAN AND THE MOTE LIVE IN hoh-shop.js NOW
    (window.hohCardLean), moved there word for word so the hero page's card
    lightbox runs the same code as this card (Jan: "make sure it also has the
    same effects as the hall"). hoh-shop.js loads before this file on the Hall.
    Every ruling below still holds, inside hohCardLean:
    · reduced motion: no lean and no mote, the ordinary arrow;
    ⛔ ===== R582 · NOTHING ON THIS CARD REACTS TO TOUCH ANY MORE =====
    Jan: "on mobile just tapping the card to trigger the tilt and stuff is
    lagging it out and breaking it so just disable that only let them hit the
    x button or show detailed view, tapping the card does nothing now so it
    doesnt lag out anymore."
    His phone cannot carry a live transform on this element, whatever is
    driving it, so a coarse pointer binds nothing: the card is a picture on a
    phone. The finger lean and the device lean are DELETED, not left behind an
    early return (dead code that binds listeners is not inert).
    · a fine pointer with hover leans the card toward the cursor (5 degrees at
    most, a low pass of .18) and, R742, turns the arrow into a warm mote of light
    fixed to the viewport, added on the first move and gone on leave. */
 if(typeof window.hohCardLean==='function') _hohTilt=window.hohCardLean(stage);
}
/* The one-time ask. Only rendered where permission is actually required, and
   removed for good the moment it is answered either way. */
/* ⛔ R576 · THE ASK MOVED OUT OF AN ICON AND INTO THE TAP. Jan: "remove the
   iphone icon with the 2 things next to it, its very ugly the icon ... when the
   card is opened just ask the permissions without them having to click on the
   icon."
   Called from the top of hohOpenHallCard, which a grid tile's onclick reaches
   synchronously, so this is still inside the user gesture iOS demands. It must
   never be moved below an await, a promise or a setTimeout, because every one
   of those ends the gesture and iOS then refuses outright.
   Asked at most once per device: a device that needs no permission, one that
   has already answered, and anyone who asked for reduced motion are all left
   alone. */
/* ⛔ R582: hohAskTiltPermission is DELETED, not left dangling. It existed only
   to unlock the device lean, and the lean is gone on every device that would
   have needed the permission. A live function that fires an iOS motion prompt
   with nothing behind it is the kind of thing that gets re-wired by accident
   later, so it goes rather than sitting there uncalled.
   ⛔ AND hohTiltNeedsPermission AND hohTiltPref WENT WITH IT. An earlier draft of
   this very comment claimed they stayed because "the desktop path still consults
   them", which was simply wrong: the desktop lean reads hohTiltReduced, and
   those two had no caller left at all. */
/* The glow the card already wears, made to breathe. It is painted on the STAGE
   and not the card, because `.ffshop-card` is overflow:hidden and would clip its
   own glow, and because opacity on a separate layer is the cheap thing to
   animate. Intensity, floor and speed all climb with rarity, mirroring the tier
   box-shadows in hoh-shop.css so the two never disagree about which tier looks
   richest. */
/* ⛔ R584 (Jan): "the glow from mythics and legendaries are a bit too strong
   make it more subtle and not as big across all the card glows on the opened
   card." TWO glows were stacking on this surface and I had only been counting
   one: the card carries its own per-tier box-shadow from hoh-shop.css, and R573
   then laid a second, PULSING one on the stage behind it. At mythic that was a
   42px halo under a 44px breathing halo, which is why it read as a lamp rather
   than a sheen.
   Every radius here is cut by about 40% and the pulse now peaks well below full
   opacity, so it reads as the card breathing rather than glowing. The ladder
   still climbs with rarity, which was the point of it. */
var HOH_GLOW_TIERS={
 common:    ['11px','.42','5.2s'], uncommon:['13px','.44','4.8s'],
 rare:      ['16px','.46','4.4s'], epic:    ['19px','.48','4.0s'],
 legendary: ['22px','.50','3.6s'], mythic:  ['26px','.52','3.2s']
};
function hohPaintHallGlow(stage){
 if(!stage) return;
 var card=stage.querySelector('.ffshop-card');
 if(!card){ stage.removeAttribute('data-glow'); return; }
 var tier='';
 for(var k in HOH_GLOW_TIERS){ if(card.classList.contains('ffshop-card-'+k)){ tier=k; break; } }
 if(!tier){ stage.removeAttribute('data-glow'); return; }
 var col='';
 try{ col=getComputedStyle(card).getPropertyValue('--rar').trim(); }catch(_){ }
 if(!col){ stage.removeAttribute('data-glow'); return; }
 var t=HOH_GLOW_TIERS[tier];
 stage.style.setProperty('--hoh-glow-col',col);
 stage.style.setProperty('--hoh-glow-size',t[0]);
 stage.style.setProperty('--hoh-glow-min',t[1]);
 stage.style.setProperty('--hoh-glow-dur',t[2]);
 stage.setAttribute('data-glow',tier);
}
function hohPrepareHallCardView(c){
 var modal=document.getElementById('hoh-modal');
 if(!modal||!modal.classList.contains('hoh-hall-card-modal'))return;
 var stage=modal.querySelector('.hoh-hall-card-stage');
 if(!stage)return;
 /* The shared renderer owns both the ordinal and its denominator. Hoist that
    exact Profile markup out of the scaled stage so it reads as card metadata,
    never becomes part of the flip target, and remains crisp on small phones. */
 /* ⛔ R583: the spacing under the card used to key off `stage + toggle`
    adjacency, which silently stopped matching the moment anything was inserted
    between them, and R583 inserted two chevrons. A class states the fact
    outright and survives any future reorder of this markup. */
 var collectors=stage.querySelectorAll('.ffshop-collno');
 for(var i=0;i<collectors.length;i++){
  var collector=collectors[i];
  if(i>0){if(collector.parentNode)collector.parentNode.removeChild(collector);continue;}
  collector.classList.add('hoh-hall-card-collector');
  if(stage.parentNode)stage.parentNode.insertBefore(collector,stage.nextSibling);
 }
 /* R583: state whether this hero prints a collector number, so the spacing rule
    under the card does not have to infer it from sibling adjacency. */
 try{
  var _view=modal.querySelector('.hoh-hall-card-view');
  if(_view) _view.classList.toggle('hoh-hall-no-collno', !stage.parentNode.querySelector('.hoh-hall-card-collector'));
 }catch(_){ }
 var wrap=stage.querySelector('.ffshop-tiltwrap');
 if(wrap&&typeof window.hohShopWireCard==='function')window.hohShopWireCard(wrap);
 var card=stage.querySelector('.ffshop-card');
 if(card){
  /* Pointer users still tap the physical card. Keyboard/SR users get the
     adjacent real button below, avoiding pseudo-button semantics on an
     article that contains the card's own descendants. */
  card.setAttribute('tabindex','-1');
  var creditDesc=modal.querySelector('#hoh-hall-card-credit');
  if(creditDesc)card.setAttribute('aria-describedby','hoh-hall-card-credit');
  else card.removeAttribute('aria-describedby');
  /* The portrait-credit tooltip is useful content, but it must not interrupt
     the modal's primary order (Close → Flip → detailed view). The hidden
     description below preserves the credit for assistive technology. */
  var credit=card.querySelector('.ffshop-ffm-wrap');
  if(credit)credit.setAttribute('tabindex','-1');
  var flip=stage.querySelector('[data-hall-card-flip]');
  if(flip&&!flip.__hohFlipWired){
   flip.__hohFlipWired=true;
   flip.addEventListener('click',function(e){
    e.preventDefault();e.stopPropagation();card.click();
   });
  }
 }
 requestAnimationFrame(hohFitHallCardView);
 try{
  if(document.fonts&&document.fonts.ready&&document.fonts.ready.then){
   document.fonts.ready.then(function(){
    if(document.body.contains(stage))hohFitHallCardView();
   });
  }
 }catch(_){}
 setTimeout(hohFitHallCardView,100);
 setTimeout(hohFitHallCardView,700);
 /* R573: the lean and the breath. Bound LAST, once the stage holds its card,
    and bound unconditionally: hohBindHallTilt drops any previous binding first,
    chooses pointer or device by capability, and stands down entirely under
    reduced motion or an iOS permission nobody has granted yet. */
 try{ hohPaintHallGlow(stage); hohBindHallTilt(stage); }catch(_){ }
}
if(!window.__hohHallCardResizeBound){
 window.__hohHallCardResizeBound=true;
 var _hohHallCardResizeTimer=null;
 var _hohHallCardResize=function(){
  if(_hohHallCardResizeTimer)clearTimeout(_hohHallCardResizeTimer);
  _hohHallCardResizeTimer=setTimeout(hohFitHallCardView,90);
 };
 window.addEventListener('resize',_hohHallCardResize,{passive:true});
 try{if(window.visualViewport)window.visualViewport.addEventListener('resize',_hohHallCardResize,{passive:true});}catch(_){}
}
/* ⛔ ========= R583 · STEPPING BETWEEN HEROES, AND IT WRAPS =========
   Jan: "on the left and right sides outside of the card, i now want them to be
   able to go to the next/previous card where it loops so it never hits a dead
   end ... and there will be a smooth animation as the current card goes away
   and the new card comes in."
   HALLNAV (Jan, 2026-09-30): "depending on what sort they have, it should just
   go left/right to the next character next to it in the grid, not some random
   character, and dim the arrow if its like the first character in the grid."
   The order is the grid as last rendered (renderGallery stores it after every
   sort, filter and search), and the walk STOPS at both ends instead of
   wrapping: the first card's back arrow and the last card's next arrow are
   dimmed and disabled. A hero opened from outside the grid (the marquee, a
   link) that the current filters leave out walks the whole roster instead. */
function hohHallNavList(id){
 try{
  var grid=window.__hohGridOrder;
  if(grid&&grid.length){
   for(var g=0;g<grid.length;g++){ if(grid[g]&&String(grid[g].id)===String(id)) return grid; }
  }
  return (typeof window.hohGetAllCharacters==='function')?(window.hohGetAllCharacters()||[]):[];
 }catch(_){ return []; }
}
/* {list, i}: the hero's place in the order the arrows walk (i is -1 if absent) */
function hohHallNavPos(id){
 var list=hohHallNavList(id), i=-1;
 for(var k=0;k<list.length;k++){ if(list[k]&&String(list[k].id)===String(id)){ i=k; break; } }
 return {list:list,i:i};
}
function hohHallNavCount(){ return hohHallNavList().length; }
window.hohHallNavCount=hohHallNavCount;
var _hohCardNavBusy=false;
window.hohHallCardNav=function(dir){
 if(_hohCardNavBusy) return;
 try{ hohHallCardSettleNow(); }catch(_){ }
 var origin=window.__hohHallCardOrigin;
 if(!origin||origin.mode!=='card') return;
 var pos=hohHallNavPos(origin.id);
 if(pos.i<0) return;
 var j=pos.i+dir;
 if(j<0||j>=pos.list.length) return;
 var next=pos.list[j];
 if(!next||!next.id||String(next.id)===String(origin.id)) return;
 var view=document.querySelector('.hoh-hall-card-view');
 var stage=view&&view.querySelector('.hoh-hall-card-stage');
 var reduced=false;
 try{ reduced=hohHallViewReducedMotion(); }catch(_){ }
 _hohCardNavBusy=true;
 function land(){
  try{ window.hohOpenHallCard(next.id,null,true); }catch(_){ }
  try{
   var v2=document.querySelector('.hoh-hall-card-view');
   var s2=v2&&v2.querySelector('.hoh-hall-card-stage');
   if(s2&&!reduced){
    s2.classList.add(dir>0?'hoh-hall-cardin-right':'hoh-hall-cardin-left');
    setTimeout(function(){
     try{ s2.classList.remove('hoh-hall-cardin-right','hoh-hall-cardin-left'); }catch(_){ }
    },300);
   }
  }catch(_){ }
  /* ⛔ RELEASED ON EVERY PATH. R577 was a whole wave about a latch that gated a
     control and could leak, so this one is cleared before anything that could
     throw is allowed to matter. */
  _hohCardNavBusy=false;
 }
 if(!stage||reduced){ land(); return; }
 stage.classList.add(dir>0?'hoh-hall-cardout-left':'hoh-hall-cardout-right');
 /* ⛔ A TIMER, NOT transitionend. R571 paid for this lesson on this exact
    screen: a beat hung on an animation event never arrives when the animation
    does not run, and this card has twice proved it may not. The animation is
    decoration; the card change happens either way. */
 setTimeout(land,170);
};
/* ⛔ ========= R793.1 · THE CARD OPENS FROM THE TILE YOU TAPPED =========
   Jan (2026-09-22): "when people click on a portrait in the hall and it opens
   the card view, make sure its a smooth open with an animation instead of
   being so jagged."
   WHAT MADE IT JAGGED, MEASURED (390x844, 1,100 heroes, 4x CPU, screencast):
    1. The whole Hall vanished on the tap frame. On a phone
       body.hoh-viewport-modal-open hides #hoh-app, so the grid cut to black,
       and the grid hearts (transition:all, visibility included) lingered on
       the black for a beat.
    2. The card painted with an EMPTY art box. The card asks for image_url,
       the full-size original, while the grid tile showed image_thumb_url,
       so nothing was cached and the art popped in once the original arrived.
    3. Two unrelated entrances (the dialog's hohFadeIn .3s and the content's
       hohSlideUp .4s) faded a card in from nowhere, unconnected to the tile.
    4. The tap was one 60ms task (the card build plus inert and a scroll lock
       that restyled and relaid out the whole page), and the next task did a
       full relayout (1,823 of 1,888 objects) right on the first frames.
   WHAT IT DOES NOW:
    · The art starts on the tile's own thumbnail (cached and decoded, the
      same crop through hohImgStyle), the original is fetched and decoded
      off screen and swapped in once the card has landed.
    · The card flies from the tile's image to its place: one transform on the
      stage (translate + scale from the tile, FLIP), 320ms, a gentle ease-out,
      while it fades in over the first 120ms and the backdrop fades in over the
      same 320ms. The chrome under the card fades in behind it. Transform and
      opacity only, so the compositor carries it.
    · The page-side work waits until the card has landed (deferPage), and so
      does hiding the Hall behind it, so nothing is restyled or relaid out
      while anything moves.
    · Close is the reverse: 260ms back onto the tile (or a small fade and
      shrink when the tile is off screen), then the ordinary hohCloseModal.
    · Reduced motion gets a 160ms fade and no movement.
   Every timer is a real timer, never an animation event (R571), and a token
   stops a stale finish from touching a newer open (the R576/R577 lesson). */
var HOH_CARD_OPEN_MS=320, HOH_CARD_CLOSE_MS=260, HOH_CARD_FADE_MS=160, HOH_CARD_ART_FADE_MS=220;
var HOH_CARD_EASE_OUT='cubic-bezier(.22,.8,.24,1)';
var HOH_CARD_EASE_INOUT='cubic-bezier(.4,0,.2,1)';
var _hohCardAnim={token:0,running:null};
window.__hohCardAnim=_hohCardAnim;
function hohRectOnScreen(r){
 if(!r||!(r.width>8)||!(r.height>8))return false;
 var vw=window.innerWidth||0, vh=window.innerHeight||0;
 return r.bottom>0&&r.right>0&&r.top<vh&&r.left<vw;
}
/* Where the move starts: the tapped grid tile's image, or Explore's portrait. */
function hohHallCardOriginEl(opener,id){
 try{
  if(!opener||!opener.closest)return null;
  var tile=opener.closest('.hoh-card');
  if(tile&&String(tile.getAttribute('data-hero-id'))===String(id))return tile.querySelector('.hoh-card-img')||tile;
  var xh=opener.closest('.hoh-xev-hero');
  if(xh&&String(xh.getAttribute('data-hero-id'))===String(id))return xh.querySelector('.hoh-xev-portrait');
  /* HALLFIX: the opening row's portrait */
  var mq=opener.closest('.hoh-mq-i');
  if(mq&&String(mq.getAttribute('data-hero'))===String(id))return mq;
 }catch(_){ }
 return null;
}
/* The card's own art window: .ffshop-art is a square; a full-art face uses
   its top square, which is where its portrait reads. */
function hohHallCardArtRect(stage){
 var art=stage.querySelector('.ffshop-art');
 if(art){ var ar=art.getBoundingClientRect(); if(ar.width>4)return ar; }
 var card=stage.querySelector('.ffshop-card')||stage;
 var cr=card.getBoundingClientRect();
 return {left:cr.left,top:cr.top,width:cr.width,height:cr.width};
}
/* FLIP: the transform (origin top left) that lays the card's art window
   exactly over the target rect. */
function hohHallCardFlipTransform(sr,ar,to){
 var s=to.width/Math.max(1,ar.width);
 var tx=to.left-sr.left-s*(ar.left-sr.left);
 var ty=to.top-sr.top-s*(ar.top-sr.top);
 return 'translate('+tx.toFixed(2)+'px,'+ty.toFixed(2)+'px) scale('+s.toFixed(4)+')';
}
/* The same FLIP for a box that itself sits on the art window (the art
   ghost below): the translate and scale that lay it over the target rect.
   With the stage's easing it tracks the stage's art window exactly, since
   both interpolate one translate and one scale between the same two rects. */
function hohHallCardBoxTransform(ar,to){
 var s=to.width/Math.max(1,ar.width);
 return 'translate('+(to.left-ar.left).toFixed(2)+'px,'+(to.top-ar.top).toFixed(2)+'px) scale('+s.toFixed(4)+')';
}
/* A layer of its own for the dim, so it can fade while the card does not.
   It copies the dialog's computed fill and blur, and the dialog goes
   transparent under hoh-hall-card-animating until the move lands. */
function hohHallCardBackdropOn(modal){
 var bd=modal.__hohCardBd;
 if(!bd||bd.parentNode!==modal){
  bd=document.createElement('div');
  bd.className='hoh-hall-card-backdrop';
  bd.setAttribute('aria-hidden','true');
  modal.__hohCardBd=bd;
 }
 if(!modal.classList.contains('hoh-hall-card-animating')){
  try{
   var cs=getComputedStyle(modal);
   bd.style.background=cs.backgroundColor;
   var f=cs.backdropFilter||cs.webkitBackdropFilter||'';
   bd.style.backdropFilter=f; bd.style.webkitBackdropFilter=f;
  }catch(_){ }
 }
 if(bd.parentNode!==modal)modal.insertBefore(bd,modal.firstChild);
 return bd;
}
function hohHallCardBackdropOff(modal){
 var bd=modal&&modal.__hohCardBd;
 if(bd&&bd.parentNode)bd.parentNode.removeChild(bd);
}
function hohHallCardChrome(view,stage){
 var out=[];
 for(var i=0;i<view.children.length;i++){
  var el=view.children[i];
  if(el!==stage&&!el.classList.contains('hoh-hall-visually-hidden'))out.push(el);
 }
 return out;
}
/* ⛔ R793.1 fix (browser QA, 2026-09-22): THE ART IS SOLID FROM THE FIRST
   FRAME. The card used to fade in from nothing over 120ms while the ease-out
   had already carried it half way, so for three frames a see-through card,
   art included, lay over the grid's text. Now the card is solid at time 0,
   where it sits on the tile at the tile's size, and this copy of the tapped
   tile's own image (the same decoded thumbnail, the same crop and zoom)
   rides on top of the card's art window along the very same path. It stays
   solid for the first 40% of the move and is gone by 85%, so it hands over
   to the card's own art in flight: invisibly on a classic card (the same
   picture under it) and as a short cross-fade on a full-art FramedFantasy
   face, whose art box frames the portrait a little differently. No decoded
   image on the tile (a letter placeholder, a lazy tile still loading) means
   no copy, and the card fades in as before. */
function hohHallCardGhost(modal,originEl,ar,originRect){
 if(!modal||!originEl||!ar||!originRect)return null;
 var src=null;
 try{ src=originEl.querySelector('img:not(.hoh-ff-badge):not(.hoh-card-anim)'); }catch(_){ src=null; }
 if(!src||!src.complete||!(src.naturalWidth>0))return null;
 var g=document.createElement('div');
 g.className='hoh-hall-card-ghost';
 g.setAttribute('aria-hidden','true');
 var s=originRect.width/Math.max(1,ar.width);
 /* the tile's 8px corner where the move starts, scaled with it */
 g.style.cssText='left:'+ar.left.toFixed(2)+'px;top:'+ar.top.toFixed(2)+'px;width:'+ar.width.toFixed(2)+'px;height:'+ar.height.toFixed(2)+'px;border-radius:'+(8/Math.max(.05,s)).toFixed(1)+'px;';
 var im=src.cloneNode(false);
 ['onerror','onload','loading','id','class','srcset','sizes'].forEach(function(a){ try{ im.removeAttribute(a); }catch(_){ } });
 /* the resource the tile is actually showing, in the same CORS mode (the
    clone keeps crossorigin), so it is the same cached, decoded picture */
 try{ if(src.currentSrc)im.setAttribute('src',src.currentSrc); }catch(_){ }
 im.alt='';
 im.draggable=false;
 g.appendChild(im);
 /* the grid tile darkens the foot of its picture into the tile's body
    (.hoh-card-gradient); the copy carries the same shade, so its first frame
    is the tile's own picture exactly */
 try{
  var fade=originEl.querySelector('.hoh-card-gradient');
  if(fade){ var f2=fade.cloneNode(false); f2.removeAttribute('id'); g.appendChild(f2); }
 }catch(_){ }
 modal.appendChild(g);
 return g;
}
function hohHallCardGhostOff(modal){
 if(!modal)return;
 try{
  var gs=modal.querySelectorAll('.hoh-hall-card-ghost');
  for(var i=0;i<gs.length;i++){ if(gs[i].parentNode)gs[i].parentNode.removeChild(gs[i]); }
 }catch(_){ }
}
/* The stage's MutationObserver re-runs the whole card prep on any child
   change; a node this file adds and removes for a moment (the art
   cross-fade below) is not a change to the card, so its records are
   dropped before they can be delivered. */
function hohHallCardQuiet(fn){
 var modal=document.getElementById('hoh-modal');
 try{ fn(); }finally{
  try{ var o=modal&&modal.__hohHallCardObserver; if(o&&o.takeRecords)o.takeRecords(); }catch(_){ }
 }
}
/* Thumbnail first: the tile's image is cached and decoded, the original is
   not. Start on the thumbnail, fetch and decode the original off screen, and
   swap it in once nothing is moving. A thumbnail that fails falls straight
   through to the original, and an original that fails keeps the thumbnail. */
function hohHallCardPrepArt(stage,c){
 var img=stage&&stage.querySelector('.ffshop-art img, .ffshop-artfull img');
 if(!img||!c)return img||null;
 var full=String(c.image_url||''), thumb=String(c.image_thumb_url||'');
 if(!full||!thumb||full===thumb||img.getAttribute('src')!==full)return img;
 img.onerror=function(){
  img.onerror=function(){ try{ if(window.hohShopArtFail)window.hohShopArtFail(img); }catch(_){ } };
  img.__hohFullSrc=null;
  img.removeAttribute('crossorigin');
  img.setAttribute('src',full);
 };
 /* the grid tile loads its thumbnail with crossorigin="anonymous", and only
    the same URL in the same CORS mode is the same cached, decoded image, so
    the art asks for it the same way and is complete on the spot. The
    original goes back to today's plain request (hohHallCardSwapFullArt).
    HALLFIX (2026-10-29): a FramedFantasy portrait's grid tile is its collector
    tile (ff-binder.js), and the opening row's tile, which ask for the
    thumbnail with no crossorigin, so a crossorigin request for it missed the
    cache and the art sat blank while the thumbnail downloaded again (about a
    second on a phone). The art now asks the way the picture already showing
    it did. */
 var co='anonymous';
 try{
  for(var di=0;di<document.images.length;di++){
   var seen=document.images[di];
   if(seen!==img&&seen.complete&&seen.naturalWidth>0&&(seen.currentSrc||seen.getAttribute('src'))===thumb){ co=seen.getAttribute('crossorigin'); break; }
  }
 }catch(_){ }
 if(co===null)img.removeAttribute('crossorigin'); else img.setAttribute('crossorigin',co);
 img.setAttribute('src',thumb);
 img.__hohFullSrc=full;
 try{
  var pre=new Image();
  pre.decoding='async';
  pre.src=full;
  img.__hohFullReady=(typeof pre.decode==='function')
   ? pre.decode().then(function(){return true;},function(){return false;})
   : new Promise(function(res){ pre.onload=function(){res(true);}; pre.onerror=function(){res(false);}; });
  img.__hohFullReady.then(function(ok){ if(ok&&!(_hohCardAnim&&_hohCardAnim.running))hohHallCardSwapFullArt(img); });
 }catch(_){ }
 return img;
}
/* ⛔ R793.1 fix (browser QA and code review, 2026-09-22): THE SHARP ORIGINAL
   FADES IN; it no longer replaces the thumbnail in one frame (at 1280 a
   217px tile opens into a 627px card, so that frame was a visible jolt from
   soft to sharp). A copy of the thumbnail (same decoded picture, same crop,
   laid exactly over the art) holds the old picture on top while the
   original goes in underneath, then fades away over 220ms. The original is
   already decoded (hohHallCardPrepArt), so nothing blank is ever uncovered.
   Reduced motion, or no Web Animations, swaps in place as before. */
function hohHallCardSwapFullArt(img){
 if(!img||!img.__hohFullSrc||!img.isConnected)return;
 var full=img.__hohFullSrc;
 img.__hohFullSrc=null;
 var cover=null;
 if(!hohHallViewReducedMotion()&&typeof img.animate==='function'&&img.complete&&img.naturalWidth>0&&img.parentNode){
  try{
   hohHallCardQuiet(function(){
    cover=img.cloneNode(false);
    ['onerror','onload','id'].forEach(function(a){ cover.removeAttribute(a); });
    cover.alt='';
    cover.setAttribute('aria-hidden','true');
    cover.classList.add('hoh-hall-art-cover');
    img.parentNode.insertBefore(cover,img.nextSibling);
   });
  }catch(_){ cover=null; }
 }
 img.onerror=function(){
  try{ if(cover&&cover.parentNode)hohHallCardQuiet(function(){ cover.parentNode.removeChild(cover); }); }catch(_){ }
  try{ if(window.hohShopArtFail)window.hohShopArtFail(img); }catch(_){ }
 };
 img.removeAttribute('crossorigin');
 if(img.getAttribute('src')!==full)img.setAttribute('src',full);
 if(!cover)return;
 var gone=false;
 function drop(){
  if(gone)return; gone=true;
  try{ if(cover.parentNode)hohHallCardQuiet(function(){ cover.parentNode.removeChild(cover); }); }catch(_){ }
 }
 try{
  var a=cover.animate([{opacity:1},{opacity:0}],{duration:HOH_CARD_ART_FADE_MS,easing:'ease-in-out',fill:'forwards'});
  a.finished.then(drop,drop);
 }catch(_){ drop(); }
 /* a real timer too (R571): an animation event is never the only way out */
 setTimeout(drop,HOH_CARD_ART_FADE_MS+200);
}
function hohHallCardSwapFullArtWhenReady(modal){
 var img=modal&&modal.querySelector('.hoh-hall-card-stage .ffshop-art img, .hoh-hall-card-stage .ffshop-artfull img');
 if(img&&img.__hohFullSrc&&img.__hohFullReady)img.__hohFullReady.then(function(ok){ if(ok&&!(_hohCardAnim&&_hohCardAnim.running))hohHallCardSwapFullArt(img); });
}
/* Everything the move put on the page comes off, in one task, so nothing
   paints half-restored. */
function hohHallCardAnimClear(modal){
 var run=_hohCardAnim.running;
 _hohCardAnim.running=null;
 if(run&&run.anims)run.anims.forEach(function(a){ try{a.cancel();}catch(_){ } });
 if(!modal)return;
 modal.classList.remove('hoh-hall-card-animating');
 modal.__hohCardClosing=false;
 var view=modal.querySelector('.hoh-hall-card-view');
 if(view)view.classList.remove('hoh-hall-card-pre');
 hohHallCardBackdropOff(modal);
 hohHallCardGhostOff(modal);
 document.body.classList.remove('hoh-hall-card-anim');
}
/* The open has landed: clear the move, hide the Hall behind the card again,
   make it inert and hold the page still (the deferred half of present),
   fit once more and swap the original art in. */
function hohHallCardSettle(modal,token){
 if(token!==_hohCardAnim.token)return;
 if(!_hohCardAnim.running||_hohCardAnim.running.kind!=='open')return;
 hohHallCardAnimClear(modal);
 if(!modal||!hohViewportModalVisible(modal))return;
 hohSettleViewportPage(modal);
 try{ hohFitHallCardView(); }catch(_){ }
 hohHallCardSwapFullArtWhenReady(modal);
}
function hohHallCardSettleNow(){
 var modal=document.getElementById('hoh-modal');
 if(_hohCardAnim.running&&_hohCardAnim.running.kind==='open')hohHallCardSettle(modal,_hohCardAnim.token);
}
window.hohHallCardSettleNow=hohHallCardSettleNow;
/* run: {kind, token, anims, ...the pieces it moves}. The landing is the
   first of the animations' finished promise and a real timer. */
function hohHallCardRun(run,maxMs,done){
 run.t0=(window.performance&&performance.now)?performance.now():Date.now();
 _hohCardAnim.running=run;
 _hohCardAnim.last={kind:run.kind,t0:run.t0,ms:maxMs};
 var fired=false;
 function fin(){ if(fired)return; fired=true; done(); }
 try{ Promise.all(run.anims.map(function(a){ return a.finished; })).then(fin,function(){}); }catch(_){ }
 setTimeout(fin,maxMs+80);
}
function hohHallCardAnimateOpen(modal,originRect,artImg,originEl){
 var token=++_hohCardAnim.token;
 var view=modal.querySelector('.hoh-hall-card-view');
 var stage=view&&view.querySelector('.hoh-hall-card-stage');
 var reduced=hohHallViewReducedMotion();
 if(!view||!stage||typeof stage.animate!=='function'){
  _hohCardAnim.running={kind:'open',token:token,anims:[]};
  hohHallCardSettle(modal,token);
  return;
 }
 /* the final place, measured once: the dialog is up, the page untouched */
 try{ hohFitHallCardView(); }catch(_){ }
 var sr=stage.getBoundingClientRect(), ar=hohHallCardArtRect(stage);
 var from=(!reduced&&hohRectOnScreen(originRect))?hohHallCardFlipTransform(sr,ar,originRect):null;
 var bd=hohHallCardBackdropOn(modal);
 bd.style.opacity='0';
 /* the run carries every piece it moves, so a way out pressed mid-flight
    (hohHallCardClose) can turn each one around from where it is */
 var run={kind:'open',token:token,anims:[],started:false,view:view,stage:stage,bd:bd,ghost:null,chrome:[],sr:sr,ar:ar};
 _hohCardAnim.running=run;
 function go(){
  if(run.started)return;
  run.started=true;
  if(token!==_hohCardAnim.token)return;
  if(!hohViewportModalVisible(modal)||!document.body.contains(stage)){ hohHallCardSettle(modal,token); return; }
  var anims=run.anims, maxMs;
  if(reduced){
   anims.push(bd.animate([{opacity:0},{opacity:1}],{duration:HOH_CARD_FADE_MS,easing:'linear'}));
   anims.push(view.animate([{opacity:0},{opacity:1}],{duration:HOH_CARD_FADE_MS,easing:'linear'}));
   maxMs=HOH_CARD_FADE_MS;
  }else{
   anims.push(bd.animate([{opacity:0},{opacity:1}],{duration:HOH_CARD_OPEN_MS,easing:'cubic-bezier(.3,0,.25,1)'}));
   if(from){
    anims.push(stage.animate([{transform:from,transformOrigin:'0 0'},{transform:'none',transformOrigin:'0 0'}],{duration:HOH_CARD_OPEN_MS,easing:HOH_CARD_EASE_OUT}));
    var ghost=hohHallCardGhost(modal,originEl,ar,originRect);
    if(ghost){
     run.ghost=ghost;
     anims.push(ghost.animate([{transform:hohHallCardBoxTransform(ar,originRect),transformOrigin:'0 0'},{transform:'none',transformOrigin:'0 0'}],{duration:HOH_CARD_OPEN_MS,easing:HOH_CARD_EASE_OUT}));
     anims.push(ghost.animate([{opacity:1,offset:0},{opacity:1,offset:.4},{opacity:0,offset:.85},{opacity:0,offset:1}],{duration:HOH_CARD_OPEN_MS,easing:'linear',fill:'forwards'}));
    }else{
     anims.push(stage.animate([{opacity:0},{opacity:1}],{duration:120,easing:'ease-out'}));
    }
   }else{
    anims.push(stage.animate([{transform:'scale(.94)',opacity:0},{transform:'none',opacity:1}],{duration:HOH_CARD_OPEN_MS-40,easing:HOH_CARD_EASE_OUT}));
   }
   run.chrome=hohHallCardChrome(view,stage);
   run.chrome.forEach(function(el){
    anims.push(el.animate([{opacity:0},{opacity:1}],{duration:180,delay:140,easing:'ease-out',fill:'backwards'}));
   });
   maxMs=HOH_CARD_OPEN_MS;
  }
  bd.style.opacity='';
  view.classList.remove('hoh-hall-card-pre');
  hohHallCardRun(run,maxMs,function(){ hohHallCardSettle(modal,token); });
 }
 /* the art is decoded before anything moves. The tile's thumbnail is
    normally already in the image cache (complete on the spot), so the move
    starts on the very next frame; otherwise it waits for decode(), for at
    most 90ms, and the tile's own picture riding on top covers the rest. */
 if(!artImg||(artImg.complete&&artImg.naturalWidth>0)){ go(); }
 else{
  var ready=(typeof artImg.decode==='function')?artImg.decode().then(null,function(){}):Promise.resolve();
  var cap=new Promise(function(res){ setTimeout(res,90); });
  Promise.race([ready,cap]).then(go,go);
 }
 /* a timer backstop in case neither promise ever settles */
 setTimeout(go,200);
}
/* ⛔ R793.1 fix (code review, 2026-09-22): SHOW DETAILED VIEW PRESSED WHILE
   THE CARD IS STILL FLYING IN lets the move finish under the fade-through.
   It used to land the card first, which snapped it to its place before the
   fade began. Only the art copy, which rides above the dialog's content and
   so would not fade with it, bows out quickly (a later animation on the
   same property wins, so its path is untouched). */
function hohHallCardGhostAway(){
 var run=_hohCardAnim.running;
 if(!run||run.kind!=='open'||!run.ghost||!run.ghost.isConnected)return;
 var o=1;
 try{ o=+getComputedStyle(run.ghost).opacity; }catch(_){ }
 if(!(o>0.01))return;
 try{ run.anims.push(run.ghost.animate([{opacity:o},{opacity:0}],{duration:120,easing:'ease-out',fill:'forwards'})); }catch(_){ }
}
/* ⛔ R793.1 fix (code review, 2026-09-22): A WAY OUT PRESSED WHILE THE CARD
   IS STILL FLYING IN (Escape, the dim, Close) TURNS IT AROUND FROM WHERE IT
   IS. It used to land the card first, a jump to its final place, and then
   fly it back; landing also ran the whole page-side half (inert and the
   scroll lock) just before the close undid it. This reads what every
   running piece shows at this instant, stops the open (the page work it was
   holding never runs), and the close starts from exactly those values in
   the same task, so no frame shows anything in between. */
function hohHallCardFreeze(run){
 function cs(el){ try{ return el?getComputedStyle(el):null; }catch(_){ return null; } }
 var s=cs(run.stage), b=cs(run.bd), g=cs(run.ghost), v=cs(run.view);
 var f={
  stageT:(s&&s.transform)||'none', stageOrigin:(s&&s.transformOrigin)||'0px 0px', stageO:s?+s.opacity:1,
  bdO:b?+b.opacity:1, viewO:v?+v.opacity:1,
  ghostT:(g&&g.transform)||'none', ghostO:g?+g.opacity:0,
  chrome:(run.chrome||[]).map(function(el){ var c=cs(el); return {el:el,o:c?+c.opacity:1}; })
 };
 (run.anims||[]).forEach(function(a){ try{a.cancel();}catch(_){ } });
 run.anims=[];
 return f;
}
/* The rect to fly back to: where the card came from (Explore's portrait, or
   the tile that was tapped) when it is still on screen, else this hero's
   grid tile. R793.1 fix (code review): the grid tile used to be tried
   first, so a card opened from Explore flew home to a grid tile that just
   happened to be on screen. */
function hohHallCardHomeRect(modal,id){
 var sid=String(id||'');
 if(!sid)return null;
 try{
  var o=modal.__hohCardOriginEl;
  if(o&&o.isConnected&&modal.__hohCardOriginId===sid){
   var ro=o.getBoundingClientRect();
   if(hohRectOnScreen(ro))return ro;
  }
  var tiles=document.querySelectorAll('#hoh-gallery .hoh-card[data-hero-id]');
  for(var i=0;i<tiles.length;i++){
   if(tiles[i].getAttribute('data-hero-id')!==sid)continue;
   var im=tiles[i].querySelector('.hoh-card-img')||tiles[i];
   var r=im.getBoundingClientRect();
   if(hohRectOnScreen(r))return r;
   break;
  }
 }catch(_){ }
 return null;
}
/* The card view's ways out (its Close, its backdrop, the dialog's own edge
   and Escape) come here. Anything that is not the card view, or a close in
   the middle of the card to dossier swap, closes exactly as before. */
window.hohHallCardClose=function(){
 var modal=document.getElementById('hoh-modal');
 if(!modal||!hohViewportModalVisible(modal)||!modal.classList.contains('hoh-hall-card-modal')||_hohHallViewTransitionBusy){ window.hohCloseModal(); return; }
 if(modal.__hohCardClosing)return;
 var view=modal.querySelector('.hoh-hall-card-view');
 var stage=view&&view.querySelector('.hoh-hall-card-stage');
 if(!view||!stage||typeof stage.animate!=='function'){ window.hohCloseModal(); return; }
 var run=_hohCardAnim.running, f=null, geo=null;
 if(run&&run.kind==='open'&&run.stage===stage){
  /* nothing has shown yet (the art was still decoding): just close */
  if(!run.started){ window.hohCloseModal(); return; }
  f=hohHallCardFreeze(run);
  geo={sr:run.sr,ar:run.ar,ghost:run.ghost};
 }else{
  hohHallCardSettleNow();
 }
 var token=++_hohCardAnim.token;
 modal.__hohCardClosing=true;
 var reduced=hohHallViewReducedMotion();
 var origin=window.__hohHallCardOrigin;
 /* the Hall shows again under the fading dim (a phone hides it behind the card) */
 document.body.classList.add('hoh-hall-card-anim');
 var to=reduced?null:hohHallCardHomeRect(modal,origin&&origin.id);
 var sr=geo?geo.sr:stage.getBoundingClientRect(), ar=geo?geo.ar:hohHallCardArtRect(stage);
 var bd=hohHallCardBackdropOn(modal);
 modal.classList.add('hoh-hall-card-animating');
 var ghost=(geo&&geo.ghost&&geo.ghost.isConnected)?geo.ghost:null;
 var bdO=f?f.bdO:1, stO=f?f.stageO:1, stT=f?f.stageT:'none', gO=f?f.ghostO:0;
 var anims=[], maxMs;
 if(ghost)ghost.style.opacity=String(gO);
 if(reduced){
  anims.push(bd.animate([{opacity:bdO},{opacity:0}],{duration:HOH_CARD_FADE_MS,easing:'linear',fill:'forwards'}));
  anims.push(view.animate([{opacity:f?f.viewO:1},{opacity:0}],{duration:HOH_CARD_FADE_MS,easing:'linear',fill:'forwards'}));
  if(ghost)anims.push(ghost.animate([{opacity:gO},{opacity:0}],{duration:HOH_CARD_FADE_MS,easing:'linear',fill:'forwards'}));
  maxMs=HOH_CARD_FADE_MS;
 }else{
  anims.push(bd.animate([{opacity:bdO},{opacity:0}],{duration:HOH_CARD_CLOSE_MS,easing:'cubic-bezier(.4,0,.6,1)',fill:'forwards'}));
  if(to){
   anims.push(stage.animate([{transform:stT,transformOrigin:f?f.stageOrigin:'0 0'},{transform:hohHallCardFlipTransform(sr,ar,to),transformOrigin:'0 0'}],{duration:HOH_CARD_CLOSE_MS,easing:HOH_CARD_EASE_INOUT,fill:'forwards'}));
   anims.push(stage.animate([{opacity:stO,offset:0},{opacity:stO,offset:.62},{opacity:0,offset:1}],{duration:HOH_CARD_CLOSE_MS,easing:'linear',fill:'forwards'}));
   /* a copy still showing rides home on top and ends on the tile's own
      identical picture, so the card's fade underneath shows nothing new */
   if(ghost)anims.push(ghost.animate([{transform:f.ghostT,transformOrigin:'0 0'},{transform:hohHallCardBoxTransform(ar,to),transformOrigin:'0 0'}],{duration:HOH_CARD_CLOSE_MS,easing:HOH_CARD_EASE_INOUT,fill:'forwards'}));
  }else{
   anims.push(stage.animate([{transform:stT,transformOrigin:f?f.stageOrigin:'50% 50%',opacity:stO},{transform:'scale(.94)',transformOrigin:'50% 50%',opacity:0}],{duration:HOH_CARD_CLOSE_MS-40,easing:HOH_CARD_EASE_INOUT,fill:'forwards'}));
   if(ghost)anims.push(ghost.animate([{opacity:gO},{opacity:0}],{duration:HOH_CARD_CLOSE_MS-40,easing:HOH_CARD_EASE_INOUT,fill:'forwards'}));
  }
  (f?f.chrome:hohHallCardChrome(view,stage).map(function(el){ return {el:el,o:1}; })).forEach(function(c){
   anims.push(c.el.animate([{opacity:c.o},{opacity:0}],{duration:120,easing:'ease-out',fill:'forwards'}));
  });
  maxMs=HOH_CARD_CLOSE_MS;
 }
 hohHallCardRun({kind:'close',token:token,anims:anims,view:view,stage:stage,bd:bd,ghost:ghost},maxMs,function(){
  if(token!==_hohCardAnim.token)return;
  window.hohCloseModal();
 });
};
window.hohOpenHallCard=function(id,opener,returningFromDetail){
 try{if(window.hohStopAllCardAnim)window.hohStopAllCardAnim();}catch(_){}
 /* ⛔ R576 (Jan): "remove the iphone icon with the 2 things next to it, its very
    ugly the icon ... when the card is opened just ask the permissions without
    them having to click on the icon."
    THE TAP THAT OPENS THE CARD IS THE GESTURE. iOS refuses
    DeviceOrientationEvent.requestPermission() outside a user gesture, and a
    grid tile's onclick calls this function SYNCHRONOUSLY (hoh-card-render.js
    builds `hohOpenHallCard('id',this)`), so asking on this line is still inside
    the tap and iOS accepts it. It must stay ABOVE every await, promise and
    setTimeout below, because any of those ends the gesture.
    ⛔ ONLY WHEN `opener` IS PRESENT. A tile tap passes the element; the deep
    link paths (?hero=, search) call this with nothing and are NOT gestures, so
    asking there would be refused and would burn the one answer we get by
    recording a denial the player never saw. */
 /* ⛔ R582: the motion prompt is retired with the lean it existed to enable.
    Asking iOS for orientation access and then never reading it would spend a
    permission dialog on a feature that no longer runs. */
 var c=hohFindModalHero(id);
 /* HALL-SPEED-02: a tile the light roster drew, tapped before the full roster landed, opens when it does */
 if(!c){ if(hohRosterArriving()) hohQueueRosterOpen('card',id,opener); return; }
 /* R793.1: a fresh open from a tile (or Explore's portrait) flies the card out
    of it. Read where it starts before anything on the page changes. */
 var _openWasUp=hohViewportModalVisible(document.getElementById('hoh-modal'));
 var _originEl=_openWasUp?null:hohHallCardOriginEl(opener,c.id);
 var _originRect=null;
 try{ if(_originEl)_originRect=_originEl.getBoundingClientRect(); }catch(_){ _originRect=null; }
 if(opener&&opener.focus){
  try{opener.focus({preventScroll:true});}catch(_){try{opener.focus();}catch(__){}}
 }
 /* Hidden moderation cards need owner/god controls immediately. Their detailed
    view is an operational surface, so the decorative card-first stop would be
    friction and could conceal the Unhide action. */
 if(c.is_hidden){
  window.__hohHallCardOrigin=null;
  hohSetHallModalMode('');
  window.hohOpenDetail(c.id);
  return;
 }
 if(typeof window.hohShopCardHtml!=='function'){
  window.__hohHallCardOrigin=null;
  hohSetHallModalMode('');
  window.hohOpenDetail(c.id);
  return;
 }
 /* RARITYMATCH: the opened card wears the same tier as the grid border */
 var cardHtml=window.hohShopCardHtml(c.id,{showCollectorNumber:true,back:'brand',context:'public-hall',hideHearts:true,tier:hohHallTier(c).tier});
 if(!cardHtml){
  window.__hohHallCardOrigin=null;
  hohSetHallModalMode('');
  window.hohOpenDetail(c.id);
  return;
 }
 var modal=document.getElementById('hoh-modal');
 var body=document.getElementById('hoh-modal-body');
 if(!modal||!body)return;
 currentDetail=c;currentImgIdx=0;currentSpotlight=null;
 window.__hohHallCardOrigin={id:String(c.id),mode:'card'};
 hohApplyModalRarity(null);
 hohSetHallModalMode('card');
 modal.setAttribute('aria-label',(c.name||'Hero')+' card');
 var navPos=hohHallNavPos(c.id);
 body.innerHTML='<div class="hoh-hall-card-view" data-hero-id="'+esc(c.id)+'" onclick="if(event.target===this)hohHallCardClose()">'+
  /* ⛔ R583 (Jan): "instead of having the x with the circle remove it entirely
     and instead have a simple Close text in white under show detailed view".
     The corner mark is GONE. Two waves tried to tame it and the disc survived
     both, because `.hoh-close-top::after` sits later in the stylesheet with
     identical specificity and simply won. A measurement caught that after I
     had twice reported it fixed. Deleting the control ends the argument, and a
     worded control beats a glyph nobody is sure is tappable. */
  /* ⛔ R583: step to the neighbouring hero in the grid's order. HALLNAV: the
     walk stops at the ends, so the first card's back arrow and the last
     card's next arrow render dimmed and disabled. Only rendered when there is
     somewhere else to go. */
  (navPos.i>=0&&navPos.list.length>1
    ? '<button type="button" class="hoh-hall-cardnav hoh-hall-cardnav-prev" onclick="event.stopPropagation();hohHallCardNav(-1)" aria-label="Previous hero"'+(navPos.i<=0?' disabled':'')+'></button>'+
      '<button type="button" class="hoh-hall-cardnav hoh-hall-cardnav-next" onclick="event.stopPropagation();hohHallCardNav(1)" aria-label="Next hero"'+(navPos.i>=navPos.list.length-1?' disabled':'')+'></button>'
    : '')+
  '<div class="hoh-hall-card-stage">'+cardHtml+
   /* ⛔ R578: the flip is OFF on a coarse pointer, so this control must not be
     offered there. It is pointer-events:none, but it is still FOCUSABLE, so
     leaving it in would hand a VoiceOver user a button that does nothing at
     all. A control that cannot act should not be announced.
     HALLFLIP (2026-10-29): the flip is back on phones (hoh-shop.js .ffshop-3d),
     so the control is offered everywhere again. */
  '<button type="button" class="hoh-hall-card-flip-control" data-hall-card-flip="1" aria-describedby="hoh-hall-card-flip-hint" aria-label="Flip '+esc(c.name||'hero')+' card back"></button>'+
  '</div>'+
  '<span id="hoh-hall-card-flip-hint" class="hoh-hall-visually-hidden">Activate the card to flip between its front and back.</span>'+
  (c.is_ff_portrait?'<span id="hoh-hall-card-credit" class="hoh-hall-visually-hidden">FramedFantasy portrait by Jan.</span>':'')+
  /* R793: your own hero gets today's ticket under the card, so the action
     is where the hero is (R793.1: the favourite toggle left this view). */
  (hohR793Live()?hohHallCardActsHtml(c):'')+
  hohHallViewToggleHtml(c,false)+
  hohHallCardAdminHtml(c)+
  /* ⛔ R583 (Jan): "a simple Close text in white under show detailed view so
     they can just click close the text it should be the same size and style
     as the show detailed view but just white and kinda grey instead so its
     easier to see." With the corner mark gone this is the dialog's only
     stated way out, so it is a real button with a real label rather than a
     glyph, and it sits in the reading order where the eye already is. */
  '<div class="hoh-hall-close-row"><button type="button" class="hoh-hall-close-text" onclick="event.stopPropagation();hohHallCardClose()">Close</button></div>'+
 '</div>';
 /* R793.1: the art starts on the tile's cached thumbnail */
 var _artImg=null;
 try{ _artImg=hohHallCardPrepArt(body.querySelector('.hoh-hall-card-stage'),c); }catch(_){ _artImg=null; }
 hohStopHallCardObserver();
 if(typeof MutationObserver!=='undefined'){
  modal.__hohHallCardObserver=new MutationObserver(function(){hohPrepareHallCardView(c);});
  try{modal.__hohHallCardObserver.observe(body.querySelector('.hoh-hall-card-stage'),{childList:true,subtree:true});}catch(_){}
 }
 hohPrepareHallCardView(c);
 /* R793.1: a fresh open runs its own entrance (hohHallCardAnimateOpen), so
    the dialog's CSS fades stand down for as long as it stays open, the dim
    gets its own layer, and the page-wide work waits for the card to land. */
 var _animOpen=!_openWasUp && typeof body.animate==='function';
 if(_animOpen){
  /* the dim copies the dialog's own fill and blur before the dialog goes clear */
  try{ hohHallCardBackdropOn(modal).style.opacity='0'; }catch(_){ }
  modal.classList.add('hoh-hall-card-flip','hoh-hall-card-animating');
  var _v0=body.querySelector('.hoh-hall-card-view'); if(_v0)_v0.classList.add('hoh-hall-card-pre');
  document.body.classList.add('hoh-hall-card-anim');
  modal.__hohCardOriginEl=_originEl; modal.__hohCardOriginId=String(c.id);
 }
 window.hohPresentViewportModal(modal,_animOpen?{deferPage:true}:null);
 if(_animOpen){
  try{ hohHallCardAnimateOpen(modal,_originRect,_artImg,_originEl); }
  catch(_){ try{ hohHallCardAnimClear(modal); hohSettleViewportPage(modal); }catch(__){ } }
 }
 try{ if(hohR793Live() && window.hohHallTicketPanelMount) window.hohHallTicketPanelMount(body); }catch(_){}
 /* ⛔ R577: WebKit throws a SecurityError on history.replaceState past roughly
    100 calls in 30 seconds, a limit a real browsing session reaches and Chrome
    does not enforce. Unguarded, that throw propagated out of hohOpenDetail and
    latched "Show detailed view" dead. The address bar is a nicety; it must
    never be able to take a control down with it. */
 try{ history.replaceState(null,'',window.location.pathname+'?hero='+encodeURIComponent(hohHeroParam(c)||c.id)); }catch(_){ }
 if(returningFromDetail&&!modal.__hohViewportDeferFocus){
  setTimeout(function(){
   var toggle=modal.querySelector('.hoh-hall-view-toggle');
   if(toggle&&toggle.focus)try{toggle.focus({preventScroll:true});}catch(_){try{toggle.focus();}catch(__){}}
  },30);
 }
};
window.hohShowHallDetail=function(id){
 var c=hohFindModalHero(id);
 if(!c)return;
 /* R795: once the hero page exists, the detailed view IS the hero page. The
    button says it heard the press ("Opening…") while the Hall fades out. */
 var _hp=hohHeroPageUrl(c);
 if(_hp){
  try{ hohHallViewToggleBusyLabel(document.getElementById('hoh-modal')); }catch(_){ }
  /* HEROSPEED: hand the portrait's address to the hero page's inline preload (hhp:img:<ref>), so it starts at once */
  try{ var _ref=new URL(_hp,location.origin).searchParams.get('h'); if(_ref&&c.image_url) localStorage.setItem('hhp:img:'+String(_ref).toLowerCase(), String(c.image_url)); }catch(_){ }
  hohGoToHeroPage(_hp,c.id);
  return;
 }
 hohTransitionHallView('detail',c);
};
window.hohShowHallCard=function(id){
 var c=hohFindModalHero(id);
 if(!c)return;
 hohTransitionHallView('card',c);
};

window.hohOpenDetail=function(id,spotlightArchetype){
 /* R204: pause all grid animations while a detail card is open to save CPU. */
 try{ if(window.hohStopAllCardAnim) window.hohStopAllCardAnim(); }catch(_){}
 /* R168: also look in the god-mode hidden cache so clicking a hidden hero
    in the Hidden moderation view opens its detail (and its Unhide button). */
 var c=allCharacters.find(function(ch){return ch.id===id;}) || ((window.__hohHidden||[]).find(function(ch){return ch && ch.id===id;})) || hohFindOwnHidden(id);
 /* HALL-SPEED-02: the winner (or a hero) tapped before the full roster landed opens when it does */
 if(!c&&hohRosterArriving()){ hohQueueRosterOpen('detail',id,null,spotlightArchetype); return; }
 if(!c){
   /* R198: a hidden hero whose cache was reset (e.g. right after a god delete).
      Lazy-load the hidden set, then reopen once it lands, so the moderation view
      can always open the next hidden card. */
   if(window.__hohHidden==null && typeof window.hohEnsureHiddenChars==='function'){
     window.hohEnsureHiddenChars();
     var _hohRetry=0, _hohIv=setInterval(function(){ _hohRetry++;
       if(window.__hohHidden!=null){ clearInterval(_hohIv); if((window.__hohHidden||[]).some(function(x){return x&&String(x.id)===String(id);})) window.hohOpenDetail(id, spotlightArchetype); }
       else if(_hohRetry>40){ clearInterval(_hohIv); }
     }, 60);
   }
   return;
 }
 var _hohHallReturn=!!(window.__hohHallCardOrigin&&window.__hohHallCardOrigin.mode==='detail'&&String(window.__hohHallCardOrigin.id)===String(c.id));
 if(_hohHallReturn)hohSetHallModalMode('detail');
 else{
  window.__hohHallCardOrigin=null;
  hohSetHallModalMode('');
 }
 currentDetail=c;currentImgIdx=0;
 currentSpotlight=spotlightArchetype||null;
 var hc=getHeartCount(c.id),h=hc>0,ht=heartTierClass(hc);
 var _dndLv=parseInt(c.dnd_level,10); var lv=(_dndLv>=1)?' &middot; Level '+Math.min(20,_dndLv):''; /* R224: static D&D level (1-20), not the My Hall XP level */
 var cp=c.campaign?'<div class="hoh-detail-campaign-box"><span class="hoh-detail-campaign-label">Campaign</span><p class="hoh-detail-campaign-name">'+esc(c.campaign)+'</p></div>':'';
 /* R176: Trials survived. Medals show what the hero has earned. Visitors see
    only what the owner has equipped (earned minus hidden). The owner sees every
    earned trial, with hidden ones dimmed, plus equip/unequip controls to choose
    what shows on their card. God mode keeps grant/revoke over the entitlement
    itself. Owner cannot equip a trial they never earned. */
 var trialsHtml='';
 try {
   var _reg=window.HOH_QUEST_BADGES||{};
   var _earned=(typeof window.hohGetHeroEarnedBadges==='function')?window.hohGetHeroEarnedBadges(c):[];
   var _shown=(typeof window.hohGetHeroBadges==='function')?window.hohGetHeroBadges(c):[];
   var _disp=(typeof window.hohGetHeroDisplayableBadges==='function')?window.hohGetHeroDisplayableBadges(c):_shown;
   var _signedIn=(typeof window.hohIsHallSignedIn==='function')?window.hohIsHallSignedIn():true;
   var _godT=(typeof window.hohIsGodMode==='function')&&window.hohIsGodMode();
   var _ownT=(typeof window.hohIsCharacterOwner==='function')&&window.hohIsCharacterOwner(c);
   /* R198: in "See public profile" preview, render the badge section exactly as a
      visitor sees it — no editor, no hidden-but-dimmed badges, just the equipped set. */
   if((typeof window.hohIsViewingAsPublic==='function') && window.hohIsViewingAsPublic(c)){ _ownT=false; _godT=false; }
   /* Owner/god see all earned (so they can manage hidden ones); visitors see
      only the equipped set. */
   /* R196: owner/god see everything the hero DISPLAYS (_shown, which already has
      the per-hero ff/completionist/merchants-mark) PLUS any account entitlement
      they have hidden (_earned minus _shown), so the detail always matches the
      card. Deduped, contributor collapsed to its top tier, then ordered. */
   /* Owner/god see the full displayable set (hidden ones dimmed so they can re-show
      them); visitors see only the equipped set. Whole panel is gated to signed-in. */
   /* R198: owner inline loadout edit. Default view stays clean (only what the card
      shows). Tapping Edit reveals every badge this hero can display with on/off
      toggles. Scoped to this hero via _hohBadgeEditHero. */
   var _edit=!!window._hohBadgeEdit && String(window._hohBadgeEditHero)===String(c.id) && _ownT && !_godT;
   var _list=(_godT||_edit)?_disp:_shown;
   /* R202: re-assert the rarity sort right before render so the grid is ALWAYS
      mythic, gold, silver, bronze top to bottom, no matter the upstream order. */
   if(typeof hohOrderBadges==='function'){ try{ _list=hohOrderBadges(_list); }catch(_){} }
   if(_signedIn && (_list.length||(_ownT&&_disp.length)||_godT||(_ownT && typeof window.hohMerchHeld==='function' && window.hohMerchHeld()>0))){
     var _medals=_list.map(function(key){
       var b=_reg[key];if(!b)return '';
       var on=_shown.indexOf(key)!==-1; /* equipped (shown) on this hero */
       var _tip=esc(b.name)+'. '+esc(b.flavor);
       if(_edit){
         return '<button type="button" class="hoh-badge-cell hoh-rar-'+(b.rarity||'standard')+(on?'':' hoh-badge-off')+'" data-badge-key="'+esc(key)+'" aria-label="'+esc(b.name)+(on?'. Showing. Tap to hide.':'. Hidden. Tap to show.')+'" onclick="hohOwnerToggleBadge(\''+c.id+'\',\''+key+'\')">'+b.svg+(on?'<span class="hoh-badge-check">&#10003;</span>':'')+'</button>';
       }
       return '<button type="button" class="hoh-badge-cell hoh-rar-'+(b.rarity||'standard')+(on?'':' hoh-badge-off')+'" data-badge-key="'+esc(key)+'" aria-label="'+_tip+'" onclick="hohTrialPrompt(\''+key+'\')">'+b.svg+'</button>';
     }).join('');
     /* God grant/revoke row over the entitlement (earned). */
     var _gt='';
     if(_godT){var _ownE=(c.quest_meta&&(Array.isArray(c.quest_meta.earned)?c.quest_meta.earned:(Array.isArray(c.quest_meta.badges)?c.quest_meta.badges:(c.quest_meta.source?[c.quest_meta.source]:[]))))||[];_gt='<div class="hoh-trial-god"><div class="hoh-trial-owner-label">Grant or revoke (god)</div>'+['iron-matron','iron-court','raffle-winner'].filter(function(k){return _reg[k];}).map(function(key){var on=_ownE.indexOf(key)!==-1;return '<button type="button" class="hoh-trial-toggle'+(on?' hoh-trial-toggle-on':'')+'" onclick="hohJangelaToggleBadge(\''+c.id+'\',\''+key+'\')">'+(on?'&#10003; ':'+ ')+esc(_reg[key].name)+'</button>';}).join('')+'</div>';}
     /* Merchant's Mark place control, surfaced inside the loadout editor. */
     var _mm='';
     if(_edit && typeof window.hohMerchHeld==='function' && window.hohMerchHeld()>0 && !(c.quest_meta&&c.quest_meta.merchantsMark)){
       _mm='<div class="hoh-merch-equip"><button type="button" class="hoh-merch-equip-btn" onclick="hohEquipMerchantsMark(\''+c.id+'\')">Place your Merchant&rsquo;s Mark here</button><div class="hoh-merch-equip-hint">You are holding one. Every heart this hero is given in Explore the Hall will count twice.</div></div>';
     }
     var _hasMerch=(typeof window.hohMerchHeld==='function' && window.hohMerchHeld()>0);
     var _editBtn=(_ownT&&!_godT&&(_disp.length||_hasMerch))?'<button type="button" class="hoh-badge-edit-btn" onclick="hohToggleBadgeEdit(\''+c.id+'\')">'+(_edit?'Done':'Edit')+'</button>':'';
     var _editHint=_edit?'<div class="hoh-badge-edit-hint">Tap a badge to show or hide it on this hero. Dim means hidden.</div>':'';
     var _gridHtml=_medals?'<div class="hoh-badge-grid'+(_edit?' hoh-badge-grid-edit':'')+'">'+_medals+'</div>':'<div class="hoh-badge-empty">'+(_edit?'No badges to place here yet.':'Nothing shown yet. Tap Edit to choose badges.')+'</div>';
     trialsHtml='<div class="hoh-trials"><div class="hoh-trials-head"><span class="hoh-trials-label">Badges</span>'+_editBtn+'</div>'+_editHint+_gridHtml+'</div>'+_mm+_gt;
   }
 } catch(_){}
 var dt=c.created_at?c.created_at.split('T')[0]:'';
 /* Byline becomes a click-to-filter affordance: tapping the author
    name puts that name into the gallery search field and re-runs the
    filter so the user sees every character that author has submitted.
    Closes the detail modal first so the filtered gallery is visible. */
 /* A nameless (Quest) hero has no author to filter by, so it gets plain text. */
 /* BYLINE (Jan, 2026-10-20): a FramedFantasy portrait shows the first name only,
    here and in the search box the link fills (hohBylineName, hoh-card-render.js). */
 var _byName=(typeof window.hohBylineName==='function')?window.hohBylineName(c):String(c.player_name||'').trim();
 var byline='<p class="hoh-detail-byline">Submitted by '+
   (_byName?
   '<a href="#" class="hoh-detail-byline-link" onclick="hohFilterByAuthor(\''+esc(_byName.replace(/\\/g,"\\\\").replace(/'/g,"\\'"))+'\');return false;" title="See more from this author">'+esc(_byName)+'</a>':
   'a hooded stranger')+
 '</p>';
 /* ⛔ R574 (Jan): "an author credit thing where they can literally write in the
    artist who did it". This line is where that credit belongs: it is already
    the picture's credit, and for a Hall hero it currently says only "Image
    uploaded by submitter", which credits the uploader rather than the artist.
    A FramedFantasy portrait keeps its own line untouched, because that art was
    painted by the studio and a second artist there would contradict it, which
    is also why the form hides the field when that box is ticked. Escaped, not
    trusted: this is a stranger's free text rendered into the page. */
 var _artist='';
 try{ _artist=(c.card_meta&&c.card_meta.artist)?String(c.card_meta.artist).slice(0,60):''; }catch(_){ }
 var pc='';
 if(c.artwork_cover&&window.hohTools){
   var _coverCredit=window.hohTools.credit(c.artwork_cover);
   if(_coverCredit) pc='<span class="ht-credit">'+_coverCredit+'</span>';
 }
 if(!pc) pc=c.is_ff_portrait?'<a href="https://framedfantasy.com/products/dnd-character-commission" class="hoh-detail-credit-link">Art by FramedFantasy</a>':(_artist?'<span class="hoh-detail-credit-text">Art by '+esc(_artist)+'</span>':'');
 /* Compute rarity up front so the modal border, name accent, and rarity
  pill + tooltip can all speak the same tier.
  R795: the same tier the grid tile's border shows (hohHallTier). */
 var rar=hohHallTier(c);
 /* Rarity pill sits next to the name. Small colored dot plus the tier
  label. On desktop, hovering reveals the ladder tooltip; on mobile, the
  pill toggles open on tap (handled in hohToggleRarityTip). */
 var rarityInfo=hohBuildRarityInfoHtml(rar);
 /* Tint the modal frame to match the rarity. hohApplyModalRarity also
  clears any previous tier class. */
 hohApplyModalRarity(rar.tier);

 /* R148-Z16: Unified detail-modal heart pill. Per user, Mythic now
    renders the SAME clean heart pill as every other rarity — no lock
    glyph, no special chrome. The old mythic-locked variant existed
    because the heart was once tappable for non-mythic chars; the lock
    visually told mythic users "tapping is blocked here". But R140-Z3j
    made the heart DISPLAY-ONLY for everyone, so the lock is now
    misleading. Drop the branch, keep the mythic-specific tooltip text
    so hovers still tell the story. */
 var isMythicDetail = (typeof window.hohIsMythicCharacter === 'function') && window.hohIsMythicCharacter(c);
 /* R140-Z3n: Unique-hearters calculation. The shim returns null when
    no server data is wired yet, so the line just stays hidden. */
 var uniqueHearters = null;
 try {
   if(typeof window.hohGetUniqueHearters === 'function'){
     uniqueHearters = window.hohGetUniqueHearters(c.id);
   } else if(typeof c.unique_hearters === 'number'){
     uniqueHearters = c.unique_hearters;
   }
 } catch(_){}
 var uniqueLine = '';
 if(typeof uniqueHearters === 'number' && uniqueHearters > 0){
   uniqueLine = '<span class="hoh-detail-heart-tip-unique" id="hoh-detail-heart-tip-unique" data-unique-hearters="' + uniqueHearters + '">'
     + 'From <strong>' + uniqueHearters + '</strong> unique '
     + (uniqueHearters === 1 ? 'player' : 'players') + '.'
     + '</span>';
 }
 var personalLine = '';
 if(hc > 0){
   personalLine = '<span class="hoh-detail-heart-tip-personal">'
     + 'Your hearts: <strong>' + hc + '</strong>'
     + '</span>';
 }
 /* Tooltip strong-text varies for mythic so hovers still surface the
    "this hero has reached mythic" flavor without putting a lock icon
    on the visible pill. */
 /* R169: Legend Locked detail state (1000-1199 hearts). */
 var isLegendLockedDetail = (typeof window.hohIsLegendLocked === 'function') && window.hohIsLegendLocked(c);
 var tipStrong = isMythicDetail
   ? '<strong>This hero has reached mythic.</strong> Heart them in Explore the Hall to keep feeding them.'
   : isLegendLockedDetail
   ? '<strong>Legend Locked.</strong> Heart this hero in Explore the Hall to push them to Mythic.'
   : '<strong>Hearts are votes.</strong> Give them in the main hall to raise this hero\'s tier.';
 /* R166: If this hero is currently on the soft cooldown when the
    modal opens, apply the paused class immediately so the visual
    state is correct from the first paint (not just toggled later
    by the document listener if the cooldown changes mid-open). */
 var detailCooldownCls = (typeof window.hohIsCharOnCooldown === 'function' && window.hohIsCharOnCooldown(c.id))
   ? ' hoh-detail-heart-on-cooldown' : '';
 var detailHeartBtn =
   '<div id="hoh-detail-heart" class="hoh-detail-heart-btn hoh-detail-heart-btn-display' + detailCooldownCls + '" data-mine="' + hc + '" role="button" aria-label="Heart count for this hero">'
     + '<span class="hoh-detail-heart-icon" aria-hidden="true"></span>'
     + '<span class="hoh-detail-heart-count" id="hoh-detail-heart-count">' + c.hearts + '</span>'
     + '<span class="hoh-detail-icon-tip hoh-detail-heart-tip" aria-hidden="true">'
       + tipStrong
       + personalLine
       + uniqueLine
     + '</span>'
   + '</div>';
 /* R793: in the live Hall the heart box is the favourite toggle, with a word
    so it reads as an action. It keeps the box class so it sits at the same
    height as the rarity and ticket boxes beside it.
    R793.1 (Jan): the words are Favorite / Favorited (2026-09-23: "just write
    favorite"; it was Add to favorites). They are the
    button's name as written (no aria-label, so a screen reader and a voice
    command meet the same words), and they already say the state, so there
    is no aria-pressed (a changing label plus pressed read "Remove X from
    favorites, pressed"). */
 var _r793=hohR793Live();
 if(_r793){
  var _favOn=hohFavIsOn(c.id);
  detailHeartBtn='<button type="button" id="hoh-detail-heart" class="hoh-detail-heart-btn hoh-detail-fav'+(_favOn?' is-on hearted':'')+'" data-fav-id="'+esc(c.id)+'" onclick="hohHeartDetail()">'+
   '<span class="hoh-fav-glyph" aria-hidden="true">'+(_favOn?HOH_FAV_SOLID:HOH_FAV_OUTLINE)+'</span>'+
   '<span class="hoh-fav-label">'+(_favOn?'Favorited':'Favorite')+'</span>'+
  '</button>';
 }
 /* R212: Hall Level pill for the opened card — surfaces the hero's level next to
    hearts + tickets (previously only visible in the owner's own profile). */
 /* R437 (Jan): "just remove the hall level entirely since its now
    battlegrounds based right so different people who own the card will have
    different levels for that character so its no longer a thing."
    Correct, and it was worse than redundant. A hero's Battlegrounds level
    lives per COLLECTOR in card_xp keyed by email_hash, so the number this
    pill showed was one person's progress printed on a page every visitor
    reads. Two people opening the same hero saw two different fours. The
    chip and its tooltip are gone; hohCharLevel itself stays, because Your
    Hall's own level ring, the Powering Up badge tier and the Battlegrounds
    card level all read it independently and all of those ARE per-viewer
    surfaces where the number is true. */
 var _hallLevelPill = '';
 document.getElementById('hoh-modal-body').innerHTML=
 buildDetailImgHtml(c,0)+
 '<div class="hoh-detail-body">'+
  '<div class="hoh-detail-heart-wrap"><div class="hoh-detail-name-col"><div class="hoh-detail-name-row"><h2 class="hoh-detail-name hoh-detail-name-rar-'+rar.tier+'">'+esc(c.name)+'</h2>'+
  /* R444: the NEW whisper used to be inlined here, beside the name. It lives
     on the art now, in buildDetailImgHtml. See the note above that function. */
  '</div><p class="hoh-detail-meta">'+esc(c.race)+' '+esc(c.character_class)+lv+'</p>'+byline+
  /* R793: the frozen count was shown here as the Legacy hearts badge.
     HALLHERO (Jan, 2026-09-23: "the legacy hearts just remove that for now"):
     not shown on any hero or card surface. hohLegacyHeartsHtml stays for when
     it comes back; the count stays in the data. */
  '</div>'+
  '<div class="hoh-detail-heart-side">'+
   /* R140-Z3n: Heart pill first, ticket pill second. The heart is the
      community-vote primary signal, ticket is the raffle-stake
      secondary read — leading with the heart matches how the rest
      of the page reads. */
   /* Jan (2026-09-17): the rarity pill left the name and sits between the
      hearts and the tickets as a box of the same height: one stat row. */
   detailHeartBtn+
   rarityInfo+
   (window.hohRenderDetailRewardPill?window.hohRenderDetailRewardPill(c):'')+
   _hallLevelPill+
   /* R380 (2026-08-06, Jan): favoriting is retired. The save star is gone
      from the detail view. hohDetailToggleSave below stays as a no-op so
      any stale onclick in a cached render cannot throw. */
  '</div></div>'+
  /* R793: your own hero's daily ticket, given here and only here in the
     main Hall. The builder returns nothing for anyone else's hero.
     OWNHIDDEN: nor for a hidden one, whose ticket the door refuses (a winner hangs on the public wall). */
  ((_r793&&window.hohHallTicketPanelHtml&&c.is_hidden!==true)?window.hohHallTicketPanelHtml(c,'detail'):'')+
  (c.featured&&window.hohRenderDetailWinnerNote?window.hohRenderDetailWinnerNote(c):'')+
  '<div class="hoh-share-row">'+
  /* R148-Z1: Share button HTML now built by hohBuildShareBtnHtml so
     the right state (free / locked / signed-out) renders for this
     specific user + character. Defaults gracefully if the helper
     hasn't loaded yet (returns the plain free-style button). */
  /* R181: the share button becomes an Export menu when this hero carries quest
     artifacts (archetype card / blueprint). A non-quest hero with nothing extra
     keeps the plain straightforward Character Card button. The old "From the
     Character Quest" panel is gone; those two items now live inside the menu. */
  ((typeof window.hohBuildExportBtnHtml === 'function')
    ? window.hohBuildExportBtnHtml(c)
    : '<button id="hoh-share-btn" class="hoh-share-btn" onclick="hohShareCard(\''+c.id+'\')"><svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg> Character Card</button>')+
  '<button id="hoh-copy-btn" class="hoh-copy-btn" onclick="hohCopyLink(\''+c.id+'\')"><svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg> Copy Link</button>'+
  '<button class="hoh-npc-jump-btn" onclick="hohScrollToNpc()"><span class="hoh-npc-jump-icon">&#9876;&#xFE0E;</span> Use as NPC</button>'+
  '</div>'+
  trialsHtml+
  cp+
  '<div class="hoh-detail-story-label">Their Story</div>'+
  '<p class="hoh-detail-story">'+esc(hohReorderStory(c.story))+'</p>'+
  /* Personal notes — only renders when the user is in Your Hall
     mode AND the hero is saved in their hall. Notes are stored
     locally per device (hoh-saved-v1.heroes[i].notes), capped at
     280 chars by the data layer, and auto-save on input. */
  hohBuildNotesHtml(c)+
  '<div id="hoh-hearter-list" class="hoh-hearter-list" style="display:none;"></div>'+
  /* R143-D: NPC section is collapsed by default. The header stays
     visible as a quiet label so the user knows the tooling exists,
     but the persona block + stat block don't unfurl until the user
     explicitly hits "Use as NPC" up top. Per user spec the header
     itself is non-interactive — only the top button opens this. */
  '<div class="hoh-npc-section hoh-npc-section-collapsed" id="hoh-npc-section">'+
  '<div class="hoh-npc-header">'+
   '<div class="hoh-npc-label"><span class="hoh-npc-label-icon">&#9876;</span>Use them as an NPC</div>'+
   '<span class="hoh-npc-sub">DM prep, ready in seconds.</span>'+
  '</div>'+
  '<div id="hoh-npc-collapsible" class="hoh-npc-collapsible">'+
   '<div id="hoh-npc-content">'+renderNpcSection(c,currentSpotlight)+'</div>'+
  '</div>'+
  '</div>'+
  '<div class="hoh-detail-footer">'+pc+'<span class="hoh-detail-date">'+dt+'</span></div>'+
 /* R568: both of these are links INSIDE the owner row now — see
    hohYourHallEditButtonHtml's second argument. */
 (window.hohYourHallEditButtonHtml
   ? window.hohYourHallEditButtonHtml(c,(_hohHallReturn?hohHallViewToggleLinkHtml(c):'')+hohHallEditTextLinkHtml(c))
   : ((_hohHallReturn?hohHallViewToggleHtml(c,true):'')))+
 '</div>';

 var detailModal=document.getElementById('hoh-modal');
 if(detailModal)detailModal.setAttribute('aria-label',(c.name||'Hero')+' details');
 window.hohPresentViewportModal('hoh-modal');
 /* R793: the ticket panel asks its door for today's state once it is on screen. */
 try{ if(_r793 && window.hohHallTicketPanelMount) window.hohHallTicketPanelMount(document.getElementById('hoh-modal-body')); }catch(_){}
 /* R200: a long name wraps the rarity pill onto its own line under the name's
    underline. Detect that wrap and center + pad the pill (desktop only); a short
    name keeps the pill inline, untouched. Runs next frame so layout is settled,
    and once more shortly after in case a late font reflow changes the wrap. */
 try{ if(typeof window.hohAlignDetailRarityPill==='function'){ requestAnimationFrame(window.hohAlignDetailRarityPill); setTimeout(window.hohAlignDetailRarityPill,180); } }catch(_){}
 /* R148-Z1: Ensure the card-unlock cache is loaded for the current
    user. If the user signed in mid-session (after page boot), the
    boot-time load fired with an empty email and bailed. This call
    is a no-op when already loaded; otherwise it fetches and then
    automatically refreshes the share button to the right state. */
 try { if(typeof window.hohLoadCardUnlocks === 'function') window.hohLoadCardUnlocks(); } catch(_){}
 if(typeof window.hohOnDetailOpen==='function')window.hohOnDetailOpen(c);
 if(window.hohTools)window.hohTools.attachProfile(c);

 if(window.hohJustSubmitted){window.hohJustSubmitted=false;if(typeof window.hohShowSpendCoach==='function')window.hohShowSpendCoach(c);}
 if(typeof window.hohRenderHearterList==='function')window.hohRenderHearterList(c.id);
 /* Wire the notes textarea if the section was rendered (only happens
    in Your Hall mode for saved heroes — see hohBuildNotesHtml). */
 hohWireDetailNotes(c);

 /* R558: the modal has explicit backdrop, close-button and Escape exits. Its
    three historical double-tap closers made the new card flip indistinguishable
    from dismiss, and also closed detailed views while users zoomed or tapped a
    control twice. Clear any property handler left by an older cached open. */
 var mb=document.getElementById('hoh-modal-body');
 if(mb)mb.ontouchend=null;
 try{ history.replaceState(null,'',window.location.pathname+'?hero='+encodeURIComponent(hohHeroParam(c)||c.id)); }catch(_){ } /* R319: the address bar shows the pretty handle */

 if(!c.npc_card && !window.hohTools){
 (async function(){
  var card=await generateNpcCard(c);
  var container=document.getElementById('hoh-npc-content');
  if(container){container.innerHTML=card?renderNpcCardHtml(card,currentSpotlight):renderNpcRetryHtml();}
  /* R140-Z3p: Render stat block after the NPC card lands. */
  try { hohRenderCurrentNpcStats(c); } catch(_){}
 })();
 } else {
 /* R140-Z3p: NPC card already exists in DB → was rendered inline by
    renderNpcSection. Still need to mount the stat block. */
 try { hohRenderCurrentNpcStats(c); } catch(_){}
 }
};

/* R795: the hero page's link once that page exists (hohHeroShareUrl), the
   Hall permalink until then. */
window.hohCopyLink=function(id){var url=hohHeroShareUrl(id);navigator.clipboard.writeText(url).then(function(){var b=document.getElementById('hoh-copy-btn');if(b){b.innerHTML='Copied!';setTimeout(function(){b.innerHTML='<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg> Copy Link';},2000);}});};
/* Toggle save state for the currently open detail hero. Filled star
   means in-hall; outline means not. Removing pushes the id into the
   explicit removed list so a heart will not auto-re-add. */
/* Build the Notes section HTML for the detail modal. Only renders
   when the user is in Your Hall mode AND the hero is saved in
   their hall. Returns empty string otherwise so the modal stays
   identical for the public main-hall view. */
function hohBuildNotesHtml(c){
 if(!c || !c.id) return '';
 if(!document.body || !document.body.classList.contains('hoh-page-mode-yours')) return '';
 if(typeof window.hohHallIsSaved !== 'function' || !window.hohHallIsSaved(c.id)) return '';
 var hall = (typeof window.hohHallGet === 'function') ? window.hohHallGet() : { heroes: [] };
 var hero = (hall.heroes || []).find(function(h){ return h && h.id === c.id; });
 var existing = (hero && hero.notes) ? hero.notes : '';
 return ''+
  '<div class="hoh-detail-notes" data-hero-id="'+esc(c.id)+'">'+
   '<div class="hoh-detail-notes-label">Your Notes</div>'+
   '<div class="hoh-detail-notes-sub">A quiet place for what only you need to remember about them. Saves automatically. Stays on this device.</div>'+
   '<textarea class="hoh-detail-notes-input" maxlength="280" rows="3" placeholder="What would you write in your DM binder about them?" data-hero-id="'+esc(c.id)+'">'+esc(existing)+'</textarea>'+
   '<div class="hoh-detail-notes-meta"><span class="hoh-detail-notes-saved" data-hero-id="'+esc(c.id)+'">Saved</span><span class="hoh-detail-notes-count">'+(existing.length)+' / 280</span></div>'+
  '</div>';
}

/* Wire input listener for the notes textarea. Called once per detail
   modal open. Debounces saves to 400ms so each keystroke doesn't hit
   localStorage. The data layer caps notes at 280 chars (matches the
   maxlength on the textarea, so users never type beyond the cap). */
function hohWireDetailNotes(c){
 if(!c || !c.id) return;
 var ta = document.querySelector('.hoh-detail-notes-input[data-hero-id="'+c.id+'"]');
 if(!ta) return;
 var savedEl = document.querySelector('.hoh-detail-notes-saved[data-hero-id="'+c.id+'"]');
 var countEl = ta.parentNode.parentNode.querySelector('.hoh-detail-notes-count');
 var t = null;
 ta.addEventListener('input', function(){
  if(savedEl){ savedEl.textContent = 'Saving…'; savedEl.classList.remove('hoh-detail-notes-saved-on'); }
  if(countEl) countEl.textContent = (ta.value.length) + ' / 280';
  clearTimeout(t);
  t = setTimeout(function(){
   if(typeof window.hohHallSetNotes === 'function'){
    window.hohHallSetNotes(c.id, ta.value);
   }
   if(savedEl){ savedEl.textContent = 'Saved'; savedEl.classList.add('hoh-detail-notes-saved-on'); }
  }, 400);
 });
}

window.hohDetailToggleSave=function(id){
 /* R380: favoriting removed. Kept as a no-op for stale onclick handlers. */
};
window.hohCloseModal=function(){
 /* Cancel before clearing mode/history. Otherwise a pending transparent swap
    can repaint the hero and put ?hero back after the dialog has closed. */
 hohCancelHallViewTransition();
 /* R793.1: a card entrance or exit still in flight stops here, and its late
    finish can no longer touch this dialog (the token moves on). All of it
    comes off in this task, before the dialog is hidden, so nothing paints
    half-restored. */
 try{ _hohCardAnim.token++; hohHallCardAnimClear(document.getElementById('hoh-modal')); }catch(_){ }
 /* R224: invalidate any in-flight summon reel so its deferred callbacks stop firing,
    and release the Summon button lock a beat after close so a reroll can't fire instantly. */
 try{ _hohReelGen++; }catch(_){}
 /* R226: after a summon closes, force the button off the option that was just summoned so it
    never sits on the same thing the visitor clicked — one guaranteed refresh per summon. */
 try{ if(_hohSummon && _hohSummon._didSummon){ _hohSummon._didSummon=false; _hohSummonForceAdvance(); } }catch(_){}
 try{ if(_hohSummon && _hohSummon._summonRelease){ clearTimeout(_hohSummon._summonRelease); _hohSummon._summonRelease=setTimeout(function(){ _hohSummon.busy=false; _hohSummon._summonRelease=null; try{ _hohSummonMorphSchedule(); }catch(_){} }, 650); } }catch(_){}
 /* R198: exit "See public profile" preview on close so reopening any hero starts
    in the owner's normal view, never stuck in the public preview. */
 window._hohViewAsPublic=false;
 window.__hohHallCardOrigin=null;
 hohSetHallModalMode('');
 if(typeof window.hohDismissViewportModal==='function')window.hohDismissViewportModal('hoh-modal');
 else document.getElementById('hoh-modal').style.display='none';
 var closedHallModal=document.getElementById('hoh-modal');
 if(closedHallModal)closedHallModal.classList.remove('hoh-hall-view-swapped','hoh-hall-card-flip');
 /* Drop the rarity tint so the next modal open starts with a clean frame. */
 hohApplyModalRarity(null);
 /* Tear down the post-submit coaching state if it is active. The
  hoh-onboarded-spend flag is set elsewhere; we only clean up DOM
  here so the next modal open does not inherit beacon classes. */
 if(typeof window.hohDeactivateSpendMode==='function')window.hohDeactivateSpendMode();
 var companyModal=document.getElementById('hoh-company-modal');
 var otherOpen=companyModal&&companyModal.style.display==='flex';
 if(!otherOpen)document.body.style.overflow='';
 currentDetail=null;
 try{ history.replaceState(null,'',window.location.pathname); }catch(_){ }
 forceCardsVisible();
};
/* R200: tag the detail name row when the rarity pill has wrapped onto its own
   line below the name (long names). The CSS then centers + pads it. The row is
   only ever taller than the name itself when the pill spilled to a new line, so
   that height delta is the wrap signal. No-op for short names (pill stays inline)
   and harmless on mobile, where the desktop-only CSS rule doesn't apply. */
window.hohAlignDetailRarityPill=function(){
  try{
    var modal=document.getElementById('hoh-modal');
    if(!modal || modal.style.display==='none') return;
    var row=modal.querySelector('.hoh-detail-name-row');
    if(!row) return;
    var name=row.querySelector('.hoh-detail-name');
    if(!name) return;
    var wrapped = row.offsetHeight > name.offsetHeight + 6;
    row.classList.toggle('hoh-detail-name-row-wrapped', wrapped);
  }catch(_){}
};
if(!window.__hohRarityPillResizeBound){
  window.__hohRarityPillResizeBound=true;
  var _hohRpT=null;
  window.addEventListener('resize', function(){ if(_hohRpT) clearTimeout(_hohRpT); _hohRpT=setTimeout(function(){ try{ window.hohAlignDetailRarityPill(); }catch(_){} }, 120); });
}
/* PLAYTESTER 2026-10-04 · THE HERO PAGE'S EDIT LINKS OPEN THE EDITOR.
   A playtester: "The 'Edit the story in the hall' and 'Edit the sheet in the
   hall' links all go back to her main card." They were plain ?hero= links, so
   the Hall did what a shared link does and opened the card. The hero page now
   adds &edit=story, &edit=sheet or &edit=hero, always with the hero's id.
   Here: the owner (or god mode) gets this hero's own edit form at that part,
   through hohOpenEditForm, so the owner check, the edit cooldown and the save
   are exactly the Edit button's. Anyone else gets the card, as before, plus the
   same "Sign in to edit" note the Edit button gives. The edit= value is taken
   out of the address once read, so a reload or a copied link opens the card. */
var HOH_EDIT_PARTS={story:1,sheet:1,hero:1};
function hohEditPartFromUrl(params){
 var p=String((params&&params.get('edit'))||'').toLowerCase();
 return HOH_EDIT_PARTS[p]?p:'';
}
function hohStripEditParam(){
 try{
  var u=new URL(window.location.href);
  if(!u.searchParams.has('edit'))return;
  u.searchParams.delete('edit');
  history.replaceState(history.state,'',u.pathname+u.search+u.hash);
 }catch(_){ }
}
function hohOpenHeroFromLink(c,part){
 if(!c||!c.id)return;
 var can=false;
 if(part){ try{ can=typeof window.hohYourHallCanEditCharacter==='function'&&!!window.hohYourHallCanEditCharacter(c); }catch(_){ can=false; } }
 if(part&&can&&typeof window.hohOpenEditForm==='function'){ window.hohOpenEditForm(c.id,{part:part}); return; }
 hohOpenHallCard(c.id);
 if(part){ try{ hohShowHeartToast('Sign in to edit','Open Your Hall and sign in to edit your hero.'); }catch(_){ } }
}
function checkUrlHero(){var params=new URLSearchParams(window.location.search);var hero=params.get('hero');if(!hero)return;
 var editPart=hohEditPartFromUrl(params);
 if(params.has('edit'))hohStripEditParam();
 /* R319: the param can be a UUID (old links stay canonical forever) OR a
    name slug (pretty links). Resolve in order: exact id, stored slug,
    slugified name (covers rows minted before the backfill), then the
    server. A name collision goes to the OLDEST hero, deterministically —
    later namesakes carry -2 style slugs from the SQL side. */
 var match=allCharacters.find(function(c){return c.id===hero;});
 if(!match){
  var hp=String(hero).toLowerCase();
  match=allCharacters.find(function(c){return c.slug===hp;});
  if(!match){
   var cands=allCharacters.filter(function(c){return hohSlugifyName(c.name)===hp;});
   if(cands.length>1){cands.sort(function(a,b){return String(a.created_at||'').localeCompare(String(b.created_at||''));});}
   match=cands[0]||null;
  }
 }
 /* A shared Hall permalink is the same gallery journey as selecting that hero
    from the public grid: open the physical card first, then let the visitor
    choose the dossier. Hidden moderation rows and renderer failures still
    fall through inside hohOpenHallCard to the operational detail view. */
 if(match){hohOpenHeroFromLink(match,editPart);return;}
 /* R167: the hero isn't in the visible set (hidden, or beyond the fetch).
    Pull it from the server so permalinks to hidden/awaiting heroes still
    open. R319: fetch by id for UUID params, by slug for pretty ones. */
 try{
  var isId=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(hero);
  var q=isId?supabase.from('characters').select(HOH_CHAR_COLS).eq('id',hero).limit(1)
            :supabase.from('characters').select(HOH_CHAR_COLS).eq('slug',String(hero).toLowerCase()).limit(1);
  q.then(function(r){
   if(r&&r.data&&r.data[0]){var h=r.data[0];
    /* OWNHIDDEN (Jan, 2026-10-29: "just don't let other people ever see that character"): a hidden hero's link
       opens for its owner and for Jan only. Anyone else hears it is not in the Hall, and its owner how to see it. */
    if(h.is_hidden===true&&!hohLinkMayOpenHidden(h)){ try{ hohShowHeartToast('Not in the Hall right now','If this hero is yours, sign in to see it.'); }catch(_){ } return; }
    if(!allCharacters.find(function(c){return c.id===h.id;}))allCharacters.push(h);hohOpenHeroFromLink(h,editPart);}
  });
 }catch(_){}}

/* ============================================================
   R321 — THE WELCOME (master plan item 6). A first-time visitor who
   lands on a hero deep link gets ONE quiet card of orientation before
   the Hall swallows them: this hero hangs here, hearts are favor, come
   back tomorrow. The plan's scripted visit one, nothing more.
   Rules: fires once ever (hoh-welcome-seen-v1, stamped at mount), only
   on ?hero= arrivals, never for god mode, never for a signed-in account
   that holds a real PIN (they live here already). Quest 2 and the
   reveal email may append &mine=1 to the link, which switches the
   opener to second person. Zero mention of commissions or buying
   anything, per the design law: day one smells like a gallery, not a
   store. Styles are inline (deploy-safe over any live stylesheet age).
   ============================================================ */
var HOH_WELCOME_KEY='hoh-welcome-seen-v1';
/* ⛔ R568 (Jan): "remove this 'X hangs here now' pop up in general when they
   first view a characters page."
   RETIRED, NOT REWORDED. It was a three-paragraph modal that covered the very
   thing the visitor had just followed a link to look at — the portrait — and
   it fired on the FIRST ?hero= arrival, which is exactly the moment a shared
   link is doing its job. The Hall explains itself; a wall of italic text in
   front of the painting does not.
   The function stays as a no-op that still stamps the seen key, because an
   older cached page can still call it and because leaving the key unwritten
   would re-arm nothing but would look, to a future reader, like the flag had
   been abandoned mid-flight. Its two call sites are gone. */
function hohMaybeQuestWelcome(){
 try{ localStorage.setItem(HOH_WELCOME_KEY,'1'); }catch(_){ }
}
function hohApplyHeartTier(btn,tier){
 btn.classList.remove('hoh-heart-t1','hoh-heart-t2','hoh-heart-t3','hoh-heart-t4','hoh-heart-t5');
 var cls=heartTierClass(tier);if(cls)btn.classList.add(cls);
 btn.setAttribute('data-mine',String(tier));
}
/* Click-and-hold heart spending lives in assets/hoh-heart-hold.js. */
/* R590 (Jan): THE MERCHANT'S MARK BONUS, MADE VISIBLE.

   ⛔ THIS IS THE BUG A CUSTOMER REPORTED, AND THE BUFF WAS NEVER BROKEN.
   Noam: "I have two [Merchant's Marks] and hearted one of them today,
   but it did not get doubled."

   The buff has worked since R196. sql/R208-ff-portrait-explore-scaling
   line 105 adds +1 to a marked hero on every Explore heart. What the
   player sees is +1 anyway, for two compounding reasons:

     1. The optimistic write below paints prevDisplayCount + 1 BEFORE
        the network call, and
     2. the reconcile afterwards reads rpc.data.hearts from
        increment_hearts_capped, which returns the count after ITS OWN
        +1 and before mark_heart_explore has run. mark_heart_explore is
        dispatched fire-and-forget with a bare .catch() and is never
        awaited, so its bonus lands in the database a moment after the
        number on screen was already decided.

   So the database really does hold 2. The screen says 1, and keeps
   saying 1 until the page is reloaded. Nothing was broken except the
   feedback, which is the part the customer can see.

   SCOPE, STATED HONESTLY: this predicts the MERCHANT'S MARK only.
   mark_heart_explore also pays for raffle-winner, hall-contributor-4,
   veteran-4, lorekeeper-4 and the scaling FF-portrait perk (R208:100).
   Those remain under-reported on screen exactly as they are today.
   Mirroring the whole ladder client-side would put a second copy of a
   payout rule in a second language, which is the mistake CLAUDE.md
   records under "THE PAYOUT LIVES IN TWO PLACES". One narrow, checked
   case is worth it because a customer paid 1000 hearts for it. The
   rest wants a server round-trip, not a guess.

   The hidden-badge test mirrors the SQL exactly:
     NOT (v_hidden ? 'merchants-mark'), v_hidden := quest_meta->'hidden'
   A player who hides the badge switches the buff off, and the display
   must not promise what the server will not pay. */
function hohExploreMarkBonus(ch, fromFreshFaces){
 /* The bonus rides mark_heart_explore, and hohCallHeartRpc only calls
    that when bypassDailyCap is set, which is set from fromFreshFaces.
    Off the Explore path the bonus does not exist. */
 if(!fromFreshFaces || !ch) return 0;
 try {
  var qm = ch.quest_meta;
  if(typeof qm === 'string'){ try { qm = JSON.parse(qm); } catch(_){ return 0; } }
  if(!qm || qm.merchantsMark !== true) return 0;
  var hid = qm.hidden;
  if(hid && typeof hid.indexOf === 'function' && hid.indexOf('merchants-mark') !== -1) return 0;
  return 1;
 } catch(_){ return 0; }
}
window.hohExploreMarkBonus = hohExploreMarkBonus;

/* Heart RPC wrapper used by both heart handlers. */
async function hohCallHeartRpc(id, opts){
 var a=(typeof window.hohGetHearterAttribution==='function')?window.hohGetHearterAttribution():{sessionId:null,name:'',public:false};
 var em=(typeof window.hohYourHallEmail==='function')?window.hohYourHallEmail():'';
 /* R110-D: Daily-cap bypass flag. Per-character daily heart cap is
    100 server-side. Hearts cast from Fresh Faces (Explore the Hall)
    must bypass that cap so users can always finish an Explore batch,
    even if the hero already hit cap from gallery clicks earlier. The
    server-side function reads p_bypass_daily_cap to skip the gate. */
 var bypassDailyCap = !!(opts && opts.bypassDailyCap);
 var rpc = await supabase.rpc('increment_hearts_capped',{
  row_id:id,
  hearter_session_id:a.sessionId,
  hearter_name:(a.public?a.name:null),
  is_public:!!a.public,
  hearter_email:em||null,
  p_bypass_daily_cap: bypassDailyCap
 });
 /* R148-Z36: After the heart lands, if it was from Fresh Faces, flag
    the just-inserted attribution row as is_explore=true via a separate
    helper RPC. Decoupling this from increment_hearts_capped avoids
    touching that function's signature (back-compat for existing
    callers + the SQL migration is purely additive). If the helper
    RPC isn't deployed yet, the call fails silently and unique_hearters
    behavior degrades to the pre-Z36 state — client-side scoping in
    hohHeart still gives correct local counts. */
 if(bypassDailyCap && rpc && !rpc.error){
   try {
     supabase.rpc('mark_heart_explore', {
       p_character_id: id,
       p_hearter_session_id: a.sessionId
     }).catch(function(){});
   } catch(_){}
 }
 return rpc;
}
function hohRpcHearts(rpc){var d=rpc&&rpc.data;if(d==null)return null;if(typeof d==='number')return d;if(typeof d==='object')return(d.hearts==null?null:d.hearts);return null;}
/* R140-Z3m: Unique-hearter count lookup. Tooltip on the detail-modal
   heart button shows "From N unique players" when this returns a
   number. Tries (in order):
     1. Cached value from a previous lookup THIS session
     2. The character row's `unique_hearters` column (zero-cost if the
        column exists; just a row read)
     3. A `get_character_unique_hearters` RPC (server-defined; falls
        through to null if the RPC doesn't exist yet)
   The cache lives at module scope, keyed by character id. The
   heart_attributions table tracks (character_id, hearter_session_id)
   pairs server-side, so the RPC body is
     SELECT COUNT(DISTINCT hearter_session_id)
     FROM heart_attributions
     WHERE character_id = $1.
   The tooltip silently hides the unique line when null is returned,
   so lighting this up is purely additive — no UI regression if the
   server data isn't ready. */
var _hohUniqueHeartersCache = Object.create(null);
/* R140-Z3n: Optimistic local bump. When THIS user hearts a hero for
   the first time, the server-side trigger will bump unique_hearters
   on the next attribution insert. But the local view won't pick up
   the new value until the next page load / RPC re-fetch. To make
   the count feel responsive, we bump the cache + the row's
   unique_hearters field locally the moment a first-time heart fires.
   Callers should invoke this AFTER they confirm the heart succeeded
   AND that this user hadn't already hearted the hero (mineCount went
   0 → 1). Safe to call multiple times — second call is a no-op
   because the cached value already reflects the bump. */
window.hohBumpUniqueHeartersLocal = function(charId){
 if(!charId) return;
 try {
  /* R145-B: Resolve current value in priority order — cache → row.
     If neither has a real number we BAIL and instead trigger an RPC
     refetch so we don't visibly reset the count from "22 unique
     players" to "1" (which is what happened when the row hadn't
     loaded unique_hearters yet). */
  var cur = _hohUniqueHeartersCache[charId];
  if(cur == null && typeof allCharacters !== 'undefined' && Array.isArray(allCharacters)){
   for(var i = 0; i < allCharacters.length; i++){
    var c = allCharacters[i];
    if(c && c.id === charId && typeof c.unique_hearters === 'number'){
     cur = c.unique_hearters;
     break;
    }
   }
  }
  if(cur == null){
   /* No baseline available — kick off an RPC fetch so the next modal
      open shows the real value. Don't bump now. */
   try {
    if(typeof supabase === 'object' && supabase && typeof supabase.rpc === 'function'){
     supabase.rpc('get_character_unique_hearters', { character_id: charId })
      .then(function(res){
       if(res && res.data != null){
        var n = (typeof res.data === 'number') ? res.data
              : (res.data && typeof res.data.count === 'number') ? res.data.count
              : null;
        if(n != null){ _hohUniqueHeartersCache[charId] = n; }
       }
      })
      .catch(function(){});
    }
   } catch(_){}
   return;
  }
  var next = cur + 1;
  _hohUniqueHeartersCache[charId] = next;
  /* Mirror onto the row so the next render of the detail modal picks
     up the bumped value through the cheap path. */
  if(typeof allCharacters !== 'undefined' && Array.isArray(allCharacters)){
   for(var j = 0; j < allCharacters.length; j++){
    var ch = allCharacters[j];
    if(ch && ch.id === charId){ ch.unique_hearters = next; break; }
   }
  }
  /* Live update the tooltip if it's currently rendered for this hero. */
  try {
   var tipEl = document.getElementById('hoh-detail-heart-tip-unique');
   if(tipEl){
    tipEl.setAttribute('data-unique-hearters', String(next));
    tipEl.innerHTML = 'From <strong>' + next + '</strong> unique '
                    + (next === 1 ? 'player' : 'players') + '.';
   }
  } catch(_){}
 } catch(_){}
};
window.hohGetUniqueHearters = function(charId){
 if(!charId) return null;
 if(_hohUniqueHeartersCache[charId] != null) return _hohUniqueHeartersCache[charId];
 /* Cheap path: the character row may already carry the count. */
 try {
  if(typeof allCharacters !== 'undefined' && Array.isArray(allCharacters)){
   for(var i=0;i<allCharacters.length;i++){
    var c=allCharacters[i];
    if(c && c.id === charId && typeof c.unique_hearters === 'number'){
     _hohUniqueHeartersCache[charId] = c.unique_hearters;
     return c.unique_hearters;
    }
   }
  }
 } catch(_){}
 /* RPC fallback. Fires async; the tooltip won't show the unique
    line on FIRST open if the row didn't carry the count, but the
    next open will (cached). Trade-off favors not blocking the
    detail modal render on a network call. */
 try {
  if(typeof supabase === 'object' && supabase && typeof supabase.rpc === 'function'){
   supabase.rpc('get_character_unique_hearters', { character_id: charId })
    .then(function(res){
     if(res && res.data != null){
      var n = (typeof res.data === 'number') ? res.data
            : (res.data && typeof res.data.count === 'number') ? res.data.count
            : null;
      if(n != null){ _hohUniqueHeartersCache[charId] = n; }
     }
    })
    .catch(function(){ /* RPC not defined yet — silent. */ });
  }
 } catch(_){}
 return null;
};
/* R165: Per-user-per-character daily cap tracker.
   ===============================================
   THE BUG (pre-R165): The old "capped-today" ledger marked a hero as
   permanently disabled-for-today the moment the server returned
   cap_rejected on any heart. But the server's cap_rejected fires on
   a GLOBAL per-character counter (characters.click_count_today) that
   bumps for every user's heart. So if 60 other users hearted Oksana
   today, your 41st heart got rejected and Oksana was disabled for
   YOU even though YOU only gave 40. The toast claimed "you hit your
   cap of 100" which was a lie.
   THE FIX: The disabled state is now gated on the USER's own count
   for THIS hero TODAY (hohGetMineToday), not on a server rejection
   flag. The button only disables when the user has personally given
   ≥ MAIN_HALL_PER_CHAR_DAILY_CAP (100) to this hero today.
   If the server rejects for OTHER reasons (e.g. its broken global
   counter), we refund the heart and show a softer "this hero is
   taking a breather" toast without permanently disabling the button.
   That way the user can keep trying — the server will let them
   through as soon as the (broken) global counter resets, and once
   the SQL migration (R165) lands the rejection will only ever fire
   when the user is actually at their personal cap.
   The hoh-mine-today-YYYY-MM-DD localStorage key auto-resets at
   midnight. Fresh Faces hearts skip the bump (they're bypass-cap
   server-side, so they shouldn't count toward the user's main-hall
   cap either). */
var MAIN_HALL_PER_CHAR_DAILY_CAP = 100;
function hohMineTodayKey(){
 var d=new Date();
 var y=d.getFullYear();
 var m=String(d.getMonth()+1).padStart(2,'0');
 var dd=String(d.getDate()).padStart(2,'0');
 return 'hoh-mine-today-'+y+'-'+m+'-'+dd;
}
function hohReadMineToday(){
 try{
  var raw=localStorage.getItem(hohMineTodayKey());
  if(!raw) return {};
  var parsed=JSON.parse(raw);
  return (parsed && typeof parsed==='object') ? parsed : {};
 }catch(_){ return {}; }
}
function hohWriteMineToday(map){
 try{ localStorage.setItem(hohMineTodayKey(), JSON.stringify(map||{})); }catch(_){}
}
window.hohGetMineToday=function(id){
 if(!id) return 0;
 try{ return (hohReadMineToday()[String(id)] | 0) || 0; }catch(_){ return 0; }
};
window.hohBumpMineToday=function(id){
 if(!id) return 0;
 var map=hohReadMineToday();
 var k=String(id);
 map[k]=(map[k] | 0) + 1;
 hohWriteMineToday(map);
 /* If the bump JUST tipped this hero over the cap, notify every
    rendered surface so they can repaint the heart button as disabled. */
 if(map[k] === MAIN_HALL_PER_CHAR_DAILY_CAP){
  try{
   document.dispatchEvent(new CustomEvent('hoh:char-capped-today',{detail:{charId:k}}));
  }catch(_){}
 }
 return map[k];
};
/* The disabled state is purely a function of how many hearts THIS user
   has given to this hero TODAY from the main hall. No more relying on
   a server-rejection flag that might fire for unrelated reasons. */
window.hohIsCharCappedToday=function(id){
 if(!id) return false;
 try{ return window.hohGetMineToday(id) >= MAIN_HALL_PER_CHAR_DAILY_CAP; }catch(_){ return false; }
};
/* ============================================================
   R267 — BULK HEARTS (double-click a grid heart)
   ============================================================
   A slider popup pours many hearts into a hero at once from the main
   grid. The max is the smallest of three real limits so a confirm can
   never fail or overshoot:
     - per-user-per-character daily cap   (100 - mine today)
     - the daily heart wallet             (heartsRemainingToday)
     - the LEGEND LOCK at 1000            (1000 - current hearts)
   Explore the Hall stays uncapped (separate bypass path), so a
   legend-locked hero can still climb the last 100 out there.
   The grant runs through the increment_hearts_bulk RPC (one round-trip,
   cap + legend safe server-side too). */
function hohBulkRoom(id){
  var ch = allCharacters.find(function(c){ return c && c.id===id; });
  var cur = ch ? (ch.hearts||0) : 0;
  var perChar = MAIN_HALL_PER_CHAR_DAILY_CAP - ((typeof window.hohGetMineToday==='function') ? window.hohGetMineToday(id) : 0);
  var wallet  = (typeof heartsRemainingToday==='function') ? heartsRemainingToday() : 0;
  var legend  = 1000 - cur;
  var maxN = Math.max(0, Math.min(perChar, wallet, legend));
  return { cur:cur, perChar:Math.max(0,perChar), wallet:Math.max(0,wallet), legend:Math.max(0,legend), max:maxN, ch:ch };
}
window.hohBulkHeart = async function(id, amount, opts){
  opts = opts || {};
  if(!id) return { ok:false };
  /* R793: hearts no longer add up, so no bulk grant is ever sent. */
  if(typeof window.hohR793Live==='function' && window.hohR793Live()) return { ok:false, reason:'retired' };
  amount = parseInt(amount,10) || 0;
  var room = hohBulkRoom(id);
  amount = Math.min(amount, room.max);
  if(amount < 1) return { ok:false, reason:'no_room' };
  var a  = (typeof window.hohGetHearterAttribution==='function') ? window.hohGetHearterAttribution() : { sessionId:null, name:'', public:false };
  var em = (typeof window.hohYourHallEmail==='function') ? window.hohYourHallEmail() : '';
  var res;
  try {
    /* R372: naming an account now means proving it. hearter_email has been sent
       since R267 and the server never checked it, so anyone holding the public
       anon key could sign hearts under someone else's address. The pin travels
       from the same token every other authenticated call reads. Sent only when
       there is an email to prove — an anonymous hearter is unchanged. */
    var _pin = '';
    try { var _t = JSON.parse(localStorage.getItem('hoh-your-hall-token') || 'null'); _pin = (_t && _t.pin) || ''; } catch(_e){}
    res = await supabase.rpc('increment_hearts_bulk', {
      row_id:id, hearter_session_id:a.sessionId, hearter_name:(a.public?a.name:null),
      is_public:!!a.public, hearter_email:em||null, p_amount:amount,
      p_pin:(em && _pin) ? _pin : null
    });
  } catch(e){ res = { error:e }; }
  if(!res || res.error || !res.data){ try{ hohShowHeartToast('Could not give hearts','Please try again in a moment.'); }catch(_){} return { ok:false }; }
  var d = res.data;
  var granted = d.granted | 0;
  var newHearts = (d.hearts==null) ? (room.cur+granted) : (d.hearts|0);
  if(granted < 1){
    /* R372 added two reasons and a customer must never read a raw one. The
       hero-cap line names the hero rather than the player, because this is the
       one refusal that is not about anything they did. */
    var msg = (d.reason==='legend_locked') ? 'This hero is Legend Locked. Heart them in Explore the Hall to push them to Mythic.'
            : (d.reason==='user_cap_hit') ? 'You have maxed this hero today. Heart them in Explore the Hall instead. It has no daily cap.'
            : (d.reason==='hero_day_cap') ? 'This hero has taken all the hearts they can hold today. Come back tomorrow.'
            : (d.reason==='pin_required' || d.reason==='bad_account') ? 'Open Your Hall and sign in again, then give from there.'
            : 'Could not give right now. Try again in a moment.';
    try{ hohShowHeartToast('No hearts given', msg); }catch(_){}
    return { ok:false, reason:d.reason };
  }
  /* Cache */
  if(room.ch) room.ch.hearts = newHearts;
  /* Wallet: shrink the bank by granted + count toward the daily tally. */
  try {
    /* R281: bulk hearting a hero via the slider. Log as hearts-given WITH the
       hero id so the action log shows "spent 91 · <hero>". */
    try{ if(window.hohHeartHint) window.hohHeartHint('spend_heart', id); }catch(_e){}
    if(typeof setHeartBank==='function' && typeof getHeartBank==='function') setHeartBank(Math.max(0, getHeartBank() - granted));
    if(typeof getDailyHearts==='function' && typeof saveDailyHearts==='function'){ var dh=getDailyHearts(); dh.count=(dh.count||0)+granted; saveDailyHearts(dh); }
    document.dispatchEvent(new CustomEvent('hoh:hearts-bumped',{ detail:{ spent:granted } }));
  } catch(_){}
  /* Per-character today count (drives the capped/disabled state). */
  try {
    var mm = hohReadMineToday(); var k=String(id); var before = mm[k]|0;
    mm[k] = before + granted; hohWriteMineToday(mm);
    if(before < MAIN_HALL_PER_CHAR_DAILY_CAP && mm[k] >= MAIN_HALL_PER_CHAR_DAILY_CAP){
      document.dispatchEvent(new CustomEvent('hoh:char-capped-today',{ detail:{ charId:k } }));
    }
  } catch(_){}
  /* Total "mine" (the x2 pill). */
  try { var hm=getHeartMap(); hm[id]=(hm[id]||0)+granted; __hMC=hm; localStorage.setItem('hoh-hearts',JSON.stringify(hm)); } catch(_){}
  /* Repaint wallet + grid so the new count + pills show at once. */
  try { if(typeof hohShowHeartCounter==='function') hohShowHeartCounter(); } catch(_){}
  try { if(typeof renderGallery==='function') renderGallery(); } catch(_){}
  /* R247: paint the card ITSELF immediately. renderGallery reuses the
     existing node (FLIP smooth update), so the count and the xN chip on
     the card go stale without this. Same in-place pattern as the
     single-heart path, plus the pulse so the give feels like it landed. */
  try {
    var cardBtn = document.querySelector('.hoh-card[data-hero-id="'+String(id).replace(/"/g,'\\"')+'"] .hoh-heart-btn');
    if(cardBtn){
      var ce2 = cardBtn.querySelector('.hoh-heart-count');
      if(ce2) ce2.textContent = String(newHearts);
      var mineNow = 0; try{ mineNow = (getHeartMap()[id]|0); }catch(_){}
      if(mineNow > 1){
        var me2 = cardBtn.querySelector('.hoh-heart-mine');
        if(!me2){ me2 = document.createElement('span'); me2.className='hoh-heart-mine'; cardBtn.appendChild(me2); }
        me2.textContent = 'x' + (typeof fmtMine==='function' ? fmtMine(mineNow) : mineNow);
        me2.style.display = '';
      }
      try{ cardBtn.setAttribute('data-mine', String(mineNow)); }catch(_){}
      cardBtn.classList.remove('hoh-heart-pulse'); void cardBtn.offsetWidth; cardBtn.classList.add('hoh-heart-pulse');
      setTimeout(function(){ try{ cardBtn.classList.remove('hoh-heart-pulse'); }catch(_){} }, 460);
    }
  } catch(_){}
  /* One heart burst on the button, sized by the give (hohHeartBurst caps it
     at 10 particles, so a 90-give never spawns 90 nodes). renderGallery just
     rebuilt the grid via FLIP, so opts.btn may be a detached node now:
     re-find the freshly mounted heart button for this hero so the burst
     plays at the right spot, not the top-left. */
  try {
    var animBtn = null;
    try { animBtn = document.querySelector('.hoh-card[data-hero-id="'+String(id).replace(/"/g,'\\"')+'"] .hoh-heart-btn'); } catch(_){}
    animBtn = animBtn || opts.btn;
    if(animBtn && typeof hohThrowHeartAt==='function'){
      try{ hohThrowHeartAt(animBtn, newHearts, granted); }catch(_){}
    }
  } catch(_){}
  /* R444: the two halves of this line join with a full stop now that the em
     dash is gone, so they have to be joined conditionally. A hero with no
     name resolved would otherwise open the toast with an orphan period. */
  try {
    var _who = (room.ch && room.ch.name) ? ('to ' + room.ch.name) : '';
    var _cap = (granted < amount) ? 'Daily cap reached.' : '';
    hohShowHeartToast('Gave '+granted+(granted===1?' heart':' hearts'), (_who && _cap) ? (_who + '. ' + _cap) : (_who || _cap));
  } catch(_){}
  try { if(typeof window.hohBroadcastHeroChange==='function') window.hohBroadcastHeroChange(id); } catch(_){}
  return { ok:true, granted:granted, hearts:newHearts };
};
function hohCloseBulkHeart(){
  var m = document.getElementById('hoh-bulk-modal');
  if(m){ m.classList.remove('on'); setTimeout(function(){ try{ if(m.parentNode) m.parentNode.removeChild(m); }catch(_){} }, 200); }
  try { document.body.style.overflow=''; } catch(_){}
}
window.hohCloseBulkHeart = hohCloseBulkHeart;
window.hohOpenBulkHeart = function(id, btn){
  if(!id) return;
  /* R793: a favourite is one tap. There is nothing to pour. */
  if(typeof window.hohR793Live==='function' && window.hohR793Live()) return;
  /* R249: visitors never see the bulk sheet or a popup — the double-tap's
     first tap already gave their one silent heart; nothing more happens. */
  if(typeof window.hohIsHallSignedIn==='function' && !window.hohIsHallSignedIn()){
    return;
  }
  var room = hohBulkRoom(id);
  var ch = room.ch;
  var name = (ch && ch.name) || 'this hero';
  /* Mythic (>= HOH_MYTHIC_AT) never accepts hearts anywhere. */
  if(ch && ((ch.hearts||0) >= HOH_MYTHIC_AT || (typeof window.hohIsMythicCharacter==='function' && window.hohIsMythicCharacter(ch)))){
    try{ hohShowHeartToast('A mythic hero','Heart this hero in Explore the Hall to keep feeding them. Mythic heroes take hearts nowhere else.'); }catch(_){}
    return;
  }
  if(room.max <= 0){
    var why = (room.legend <= 0) ? 'Legend Locked at 1,000. Heart this hero in Explore the Hall to push them to Mythic.'
            : (room.perChar <= 0) ? 'You have maxed '+name+' today. Heart them in Explore the Hall instead. It has no daily cap.'
            : 'You are out of hearts today. Earn more around the Hall.';
    try{ hohShowHeartToast('No room right now', why); }catch(_){}
    return;
  }
  var maxN = room.max;
  var def = maxN; /* default to the full amount; the confirm button makes it deliberate */
  var mineToday = (typeof window.hohGetMineToday==='function') ? window.hohGetMineToday(id) : 0;
  var img = ch && (ch.image_thumb_url || ch.image_url);
  var pos = (typeof window.hohImgObjPos==='function') ? window.hohImgObjPos(id,'primary') : '50% 50%';
  var cropStyle = (typeof window.hohImgStyle==='function') ? window.hohImgStyle(id,'primary') : ('object-position:'+pos+';');
  var thumb = img
    ? '<img src="'+esc(img)+'" alt="" decoding="async" style="'+esc(cropStyle)+'" draggable="false">'
    : '<span class="hoh-bulk-thumb-letter">'+esc(hohInitial(name))+'</span>';
  /* Explain a small max when the LEGEND LOCK is the binding limit. */
  var legendNote = (room.legend === maxN && room.legend < room.perChar && room.legend < room.wallet)
    ? '<div class="hoh-bulk-note">This hero hits the <b>Legend Lock</b> at 1,000. The last 200 hearts to Mythic come only from Explore the Hall.</div>'
    : (room.wallet === maxN && room.wallet < room.perChar)
      ? '<div class="hoh-bulk-note">Capped by your <b>hearts left today</b>. Earn more around the Hall.</div>'
      : '';
  hohCloseBulkHeart();
  var m = document.createElement('div');
  m.id = 'hoh-bulk-modal';
  m.className = 'hoh-bulk-modal';
  m.innerHTML =
    '<div class="hoh-bulk-backdrop"></div>'+
    '<div class="hoh-bulk-sheet" role="dialog" aria-label="Give hearts to '+esc(name)+'">'+
      '<button type="button" class="hoh-bulk-close" aria-label="Close">&times;</button>'+
      '<div class="hoh-bulk-head">'+
        '<span class="hoh-bulk-thumb">'+thumb+'</span>'+
        '<span class="hoh-bulk-headtext">'+
          '<span class="hoh-bulk-name">'+esc(name)+'</span>'+
          '<span class="hoh-bulk-sub">'+(mineToday>0?('You have given '+mineToday+' today'):'Give this hero a boost')+'</span>'+
        '</span>'+
      '</div>'+
      '<div class="hoh-bulk-val"><span class="hoh-bulk-heart" aria-hidden="true">&#9829;&#xFE0E;</span><span class="hoh-bulk-num" id="hoh-bulk-num">'+def+'</span></div>'+
      '<input type="range" class="hoh-bulk-slider" id="hoh-bulk-slider" min="0" max="'+maxN+'" value="'+def+'" step="1" aria-label="Hearts to give">'+
      '<div class="hoh-bulk-row">'+
        '<input type="number" class="hoh-bulk-input" id="hoh-bulk-input" min="0" max="'+maxN+'" value="'+def+'" inputmode="numeric">'+
        '<span class="hoh-bulk-maxlbl">of '+maxN+' left</span>'+
      '</div>'+
      legendNote+
      '<div class="hoh-bulk-actions">'+
        '<button type="button" class="hoh-bulk-cancel">Cancel</button>'+
        '<button type="button" class="hoh-bulk-give" id="hoh-bulk-give">Give '+def+' hearts</button>'+
      '</div>'+
    '</div>';
  document.body.appendChild(m);
  try { document.body.style.overflow='hidden'; } catch(_){}
  requestAnimationFrame(function(){ m.classList.add('on'); });
  var slider = m.querySelector('#hoh-bulk-slider');
  var input  = m.querySelector('#hoh-bulk-input');
  var numEl  = m.querySelector('#hoh-bulk-num');
  var giveEl = m.querySelector('#hoh-bulk-give');
  function clampV(v){ v = parseInt(v,10); if(isNaN(v)) v=0; return Math.max(0, Math.min(maxN, v)); }
  function sync(v, from){
    v = clampV(v);
    if(slider && from!=='slider') slider.value = v;
    if(input && from!=='input') input.value = v;
    if(numEl) numEl.textContent = v;
    if(giveEl){ giveEl.textContent = v>0 ? ('Give '+v+(v===1?' heart':' hearts')) : 'Give hearts'; giveEl.disabled = (v<1); }
  }
  if(slider) slider.addEventListener('input', function(){ sync(slider.value,'slider'); });
  if(input){ input.addEventListener('input', function(){ sync(input.value,'input'); }); input.addEventListener('blur', function(){ sync(input.value); }); }
  function doGive(){
    var v = clampV(input ? input.value : def);
    if(v < 1){ hohCloseBulkHeart(); return; }
    if(giveEl){ giveEl.disabled=true; giveEl.textContent='Giving…'; }
    Promise.resolve(window.hohBulkHeart(id, v, { btn:btn })).then(function(){ hohCloseBulkHeart(); }, function(){ hohCloseBulkHeart(); });
  }
  if(giveEl) giveEl.addEventListener('click', doGive);
  m.querySelector('.hoh-bulk-cancel').addEventListener('click', hohCloseBulkHeart);
  m.querySelector('.hoh-bulk-close').addEventListener('click', hohCloseBulkHeart);
  m.querySelector('.hoh-bulk-backdrop').addEventListener('click', hohCloseBulkHeart);
  sync(def);
};
/* R166: Per-character SOFT cooldown after a non-user cap rejection.
   ==========================================================
   When the server rejects a heart for a reason OTHER than the user
   personally hitting their per-day cap (i.e. it's the legacy global
   per-character cap miss-firing because other users hearted this
   hero today), we set a short cooldown on that character. During
   the cooldown:
     - hohHeart / hohHeartDetail pre-empt the click locally — no
       RPC, no wallet decrement, just a soft toast.
     - hold-to-stream stops on this hero.
     - A subtle visual class dims the card so the user understands.
   The cooldown auto-clears after CHAR_COOLDOWN_MS so the user can
   try again once the global counter naturally rolls back (other
   users stop hearting, midnight reset, or the R165 SQL ships).
   This is the primary fix for "I gave 50 hearts and got the cap
   toast" — instead of 50 clicks firing 50 parallel RPCs that all
   wait for a roundtrip and all rejection-toast over each other,
   the FIRST rejection sets the cooldown and subsequent clicks
   pre-empt locally with zero wait. */
var __hohCharCooldownUntil = {};
var __HOH_CHAR_COOLDOWN_MS = 30000; /* 30 seconds */
window.hohSetCharCooldown = function(id, ms){
 if(!id) return;
 var dur = (ms == null) ? __HOH_CHAR_COOLDOWN_MS : ms;
 var key = String(id);
 __hohCharCooldownUntil[key] = Date.now() + dur;
 try { document.dispatchEvent(new CustomEvent('hoh:char-cooldown-start', { detail: { charId: key, durationMs: dur } })); } catch(_){}
 /* Schedule end notification so the visual auto-clears without
    requiring the user to interact. Idempotent if the cooldown was
    extended in the meantime — re-checks the timestamp. */
 setTimeout(function(){
   var until = __hohCharCooldownUntil[key];
   if(until && Date.now() >= until){
     delete __hohCharCooldownUntil[key];
     try { document.dispatchEvent(new CustomEvent('hoh:char-cooldown-end', { detail: { charId: key } })); } catch(_){}
   }
 }, dur + 100);
};
window.hohIsCharOnCooldown = function(id){
 if(!id) return false;
 var until = __hohCharCooldownUntil[String(id)];
 if(!until) return false;
 if(Date.now() >= until){
   delete __hohCharCooldownUntil[String(id)];
   try { document.dispatchEvent(new CustomEvent('hoh:char-cooldown-end', { detail: { charId: String(id) } })); } catch(_){}
   return false;
 }
 return true;
};
window.hohGetCharCooldownRemainingMs = function(id){
 if(!id) return 0;
 var until = __hohCharCooldownUntil[String(id)];
 if(!until) return 0;
 var r = until - Date.now();
 return r > 0 ? r : 0;
};
window.hohClearCharCooldown = function(id){
 if(!id) return;
 var key = String(id);
 if(__hohCharCooldownUntil[key]){
   delete __hohCharCooldownUntil[key];
   try { document.dispatchEvent(new CustomEvent('hoh:char-cooldown-end', { detail: { charId: key } })); } catch(_){}
 }
};
/* Document-level listener that toggles a `hoh-card-on-cooldown` class
   on every rendered card for the affected hero. Runs once per session;
   cards rendered AFTER cooldown starts pick the state up at render
   time via hohIsCharOnCooldown (wired in hoh-card-render.js). */
(function(){
 function applyCooldownClass(charId, on){
   try {
     var cards = document.querySelectorAll('.hoh-card[data-hero-id="' + String(charId).replace(/"/g, '\\"') + '"]');
     for(var i = 0; i < cards.length; i++){
       if(on) cards[i].classList.add('hoh-card-on-cooldown');
       else   cards[i].classList.remove('hoh-card-on-cooldown');
     }
     /* Detail modal heart button: scope its own cooldown visual. */
     if(currentDetail && currentDetail.id === charId){
       var modalBtn = document.getElementById('hoh-detail-heart');
       if(modalBtn){
         if(on) modalBtn.classList.add('hoh-detail-heart-on-cooldown');
         else   modalBtn.classList.remove('hoh-detail-heart-on-cooldown');
       }
     }
   } catch(_){}
 }
 try {
   document.addEventListener('hoh:char-cooldown-start', function(ev){
     if(!ev || !ev.detail || !ev.detail.charId) return;
     applyCooldownClass(ev.detail.charId, true);
   });
   document.addEventListener('hoh:char-cooldown-end', function(ev){
     if(!ev || !ev.detail || !ev.detail.charId) return;
     applyCooldownClass(ev.detail.charId, false);
   });
 } catch(_){}
})();
/* Back-compat alias: external callers still invoke hohMarkCharCappedToday
   from a couple of fallback paths. Forwarding to hohBumpMineToday keeps
   them working — they'll bump the user's counter to the cap so the
   gate reads as "capped" without lying about the source of truth. */
window.hohMarkCharCappedToday=function(id){
 if(!id) return;
 var cur = window.hohGetMineToday(id);
 if(cur < MAIN_HALL_PER_CHAR_DAILY_CAP){
  var map=hohReadMineToday();
  map[String(id)] = MAIN_HALL_PER_CHAR_DAILY_CAP;
  hohWriteMineToday(map);
  try{
   document.dispatchEvent(new CustomEvent('hoh:char-capped-today',{detail:{charId:String(id)}}));
  }catch(_){}
 }
};
function hohOnCapRejected(id,btn,reason){
 if(currentDetail&&currentDetail.id===id&&typeof window.hohSpendCoachCapHit==='function'){
 var ch=allCharacters.find(function(x){return x.id===id;});
 window.hohSpendCoachCapHit(ch?ch.name:'');
 }
 /* R69: Stop any active heart streams the instant the cap is hit.
    Without this, the user holding on a stream target keeps spending
    into a wall — every subsequent fire returns null from the server
    and burns a wallet heart. */
 try{ if(typeof window.hohOnStreamCapHit==='function') window.hohOnStreamCapHit(id); }catch(_){}
 /* R166: Reason-aware rejection routing.
    The server returns one of:
      - 'user_cap_hit'      — R165 SQL: this user gave 100 to this hero today
      - 'cap_hit'           — legacy R110-D: per-character GLOBAL cap (100 across all users)
      - 'global_daily_cap'  — legacy R97: per-user across-character daily cap (60 hearts/day total)
      - 'not_found'         — character row missing
      - null/undefined      — unknown (treat as soft miss-fire)
    user_cap_hit → permanently lock this hero for the day via the
      mineToday counter (the gate already disables it). No cooldown
      needed; the button stays capped until midnight.
    Everything else → 30s soft cooldown so the user can keep playing
      without spamming the wall. The cooldown is the primary defence
      against the avalanche of failed RPCs on rapid taps. */
 try {
  var mine = window.hohGetMineToday(id);
  if(reason === 'user_cap_hit' || mine >= MAIN_HALL_PER_CHAR_DAILY_CAP){
   /* Force mineToday to the cap so hohIsCharCappedToday returns true
      on the next render. If the server told us we're capped but our
      local count says otherwise, the server is right — sync up. */
   if(typeof window.hohMarkCharCappedToday === 'function'){
    try { window.hohMarkCharCappedToday(id); } catch(_){}
   }
  } else {
   /* Soft cooldown — stops the avalanche after the first rejection. */
   if(typeof window.hohSetCharCooldown === 'function'){
    try { window.hohSetCharCooldown(id, 30000); } catch(_){}
   }
  }
 } catch(_){}
 if(typeof window.hohHandleCapRejection==='function')window.hohHandleCapRejection(id,btn);
}
/* R166: Parse the reason field from an increment_hearts_capped response.
   Returns the string when the call was a rejection (hearts == null),
   null when the call succeeded. The handler then routes on reason. */
function hohRpcReason(rpc){
 try {
   var d = rpc && rpc.data;
   if(d == null) return 'unknown';
   if(typeof d === 'number') return null; /* legacy: plain number means success */
   if(typeof d === 'object'){
     if(d.hearts != null) return null; /* success */
     return (typeof d.reason === 'string' && d.reason) ? d.reason : 'unknown';
   }
 } catch(_){}
 return null;
}
/* R249: visitors (signed-out) give exactly ONE silent heart per hero.
   No popup, no wallet — the same capped server RPC every heart uses,
   session-scoped, so it counts inside the hero's 100/day like any other
   heart. Any further click on that hero does nothing at all. */
var _hohAnonBusy = {};
/* R425: the two small helpers the visitor-heart messages lean on. Named so
   the message can say WHO it is talking about — "this hero" reads like a
   template, the hero's own name reads like the Hall knows them. */
/* R444: hohAnonHeroName, hohAnonHeartSay and the _hohAnonSaidAt throttle they
   shared lived here. All three existed only to word the three visitor toasts
   that R444 removed, so all three went with them. Nothing else ever called
   them. Left as a note rather than a silent deletion so the next person
   looking for "why does a visitor's second tap say nothing" finds the answer
   here instead of concluding it is a bug. */
async function hohAnonHeart(id, btn){
  try{
    if(!id || _hohAnonBusy[id]) return;
    var given = 0; try{ given = (getHeartMap()[id]|0); }catch(_){}
    /* R425 gave each of these three exits a toast, on the reasoning that
       silence after a tap is ambiguous.
       R444 (Jan) reverses it, and the reasoning was wrong in the visitor's
       case: "let them heart each character once and have the heart be filled
       in and thats it. if they click it again nothing happens, no
       notification or things saying no hearts."
       She is right, because the ambiguity R425 worried about does not exist
       here. The heart is ALREADY FILLED from the first tap. The button is its
       own receipt, permanently, and a toast on top of a filled heart is the
       site explaining something the button has already said. Worse, it turned
       an idle second tap into a sales pitch about signing in, which is the one
       thing a visitor who has not signed in has already declined.
       Capped and mythic go quiet for the same reason: neither is the
       visitor's problem, neither is actionable without an account, and both
       are rare enough that a modal is a bad trade for them.
       Every exit below is now a bare return. Nothing is announced, nothing is
       earned, nothing is counted, until they sign in. */
    if(given >= 1) return;
    if(typeof window.hohIsCharCappedToday==='function' && window.hohIsCharCappedToday(id)) return;
    var ch = null;
    try{ ch = allCharacters.find(function(c){ return c && String(c.id)===String(id); }); }catch(_){}
    if(ch && (ch.hearts||0) >= HOH_MYTHIC_AT) return; /* mythic: the grid is closed */
    _hohAnonBusy[id] = 1;
    var rpc = await hohCallHeartRpc(id, { bypassDailyCap:false });
    delete _hohAnonBusy[id];
    if(!rpc || rpc.error || !rpc.data) return;
    var newHearts = (rpc.data && typeof rpc.data.hearts==='number') ? rpc.data.hearts : (((ch&&ch.hearts)||0)+1);
    if(ch) ch.hearts = newHearts;
    try{ var hm=getHeartMap(); hm[id]=1; __hMC=hm; localStorage.setItem('hoh-hearts',JSON.stringify(hm)); }catch(_){}
    try{ var mm=hohReadMineToday(); mm[String(id)]=(mm[String(id)]|0)+1; hohWriteMineToday(mm); }catch(_){}
    if(btn){
      try{
        btn.classList.add('hearted');
        /* R251: the FILL is the glyph swap (outline ♡ → solid ♥ in
           .hoh-heart-icon), same as the signed give path — the class
           alone styles color but leaves the outline character. */
        var icA=btn.querySelector('.hoh-heart-icon');
        if(icA) icA.innerHTML='&#9829;&#xFE0E;';
        try{ btn.setAttribute('data-mine','1'); }catch(_){}
        var ceA=btn.querySelector('.hoh-heart-count');
        if(ceA) ceA.textContent=String(newHearts);
        btn.classList.remove('hoh-heart-pulse'); void btn.offsetWidth; btn.classList.add('hoh-heart-pulse');
        setTimeout(function(){ try{ btn.classList.remove('hoh-heart-pulse'); }catch(_){} }, 460);
        /* R250: no fly-in for visitors — it launched from the top-right
           corner where the (hidden) wallet sits and read as a glitch.
           The fill + pulse + count bump are the whole ceremony. */
      }catch(_){}
    }
    try{ if(typeof hohSyncLikedOption==='function') hohSyncLikedOption(); }catch(_){}
  }catch(_){ try{ delete _hohAnonBusy[id]; }catch(_){} }
}
/* ============================================================
   R793 · A HEART IS A FAVOURITE NOW (Jan, 2026-09-22)
   ============================================================
   "you can heart each hero once in the main Hall; it saves to a
   Hearted filter so you can find them again." No counts go up
   anywhere: hoh_hall_heart_set records one favourite per account and
   hero and never touches characters.hearts. The old count is frozen
   and shown as the Legacy hearts badge.

   Every heart control in the main Hall (grid, detail, hold, the
   double-tap slider, Explore) arrives at hohHeart or hohHeartDetail,
   so the switch lives here once. In LEGACY mode (R793B not installed,
   see HOHHallDoors in hoh-data.js) both fall straight through to the
   old heart path below, untouched.

   Signed out, a tap asks the visitor to sign in (or add a hero, which
   is how an account is made here). Nothing is saved on the device. */
function hohR793Live(){ return (typeof window.hohR793Live==='function') && window.hohR793Live(); }
function hohR793Unknown(){ return !!(window.HOHHallDoors && window.HOHHallDoors.mode()==='unknown'); }
/* R793.1 fix (copy sweep, 2026-09-22): which WORDS the Hall shows. Until the
   doors first answer (a first visit, or a cached mode older than a day) the
   sort menu, the Favorited view and the grid footers already wear the live
   Hall's words, because R793B is installed and legacy is now the rare case;
   a Hall that turns out to be legacy repaints them (hoh:r793-mode below).
   What a tap DOES still waits for the answer (hohHeart holds it). */
function hohR793Words(){ return hohR793Live() || hohR793Unknown(); }
window.hohR793Words=hohR793Words;
function hohFavIsOn(id){ return !!(window.HOHHallDoors && window.HOHHallDoors.favourites.has(id)); }
window.hohFavIsOn=hohFavIsOn;
var HOH_FAV_OUTLINE='&#9825;&#xFE0E;', HOH_FAV_SOLID='&#9829;&#xFE0E;';
/* Paint every rendered heart control for one hero: the grid footer, the
   detail button, the card view and Explore all carry data-fav-id. */
function hohFavPaint(id){
 var on=hohFavIsOn(id);
 var ch=null; try{ ch=allCharacters.find(function(c){ return c && String(c.id)===String(id); }); }catch(_){}
 var name=(ch&&ch.name)?ch.name:'this hero';
 var nodes=document.querySelectorAll('[data-fav-id]');
 for(var i=0;i<nodes.length;i++){
  var b=nodes[i];
  if(b.getAttribute('data-fav-id')!==String(id)) continue;
  hohFavPaintNode(b,on,name);
 }
}
window.hohFavPaint=hohFavPaint;
/* R793.1 (Jan): "instead of calling it 'heart' just keep it favorite".
   Every favourite control says the same words: Add to favorites, and
   Favorited once it is on. A worded button (detailed view, Explore) is
   named by those words alone; the grid's heart-only toggle carries a label
   that names the hero. The words say the state, so none of them carries
   aria-pressed ("Remove X from favorites, pressed" contradicted itself). */
function hohFavPaintNode(b,on,name){
 b.classList.toggle('is-on',on);
 b.classList.toggle('hearted',on);
 b.removeAttribute('aria-pressed');
 var ic=b.querySelector('.hoh-heart-icon,.hoh-fav-glyph'); if(ic) ic.innerHTML=on?HOH_FAV_SOLID:HOH_FAV_OUTLINE;
 var lb=b.querySelector('.hoh-fav-label');
 if(lb){ lb.textContent=on?'Favorited':'Favorite'; b.removeAttribute('aria-label'); }
 else b.setAttribute('aria-label',on?('Remove '+name+' from favorites'):('Add '+name+' to favorites'));
}
/* One pass over every rendered heart when the whole list changes (first
   load, a new account), instead of re-rendering the gallery. */
function hohFavPaintAll(){
 var nodes=document.querySelectorAll('[data-fav-id]');
 for(var i=0;i<nodes.length;i++){
  var b=nodes[i], fid=b.getAttribute('data-fav-id'), on=hohFavIsOn(fid);
  if(b.classList.contains('is-on')===on && !b.hasAttribute('aria-pressed')) continue;
  var ch=null; try{ ch=__hohCharById(fid); }catch(_){}
  hohFavPaintNode(b,on,(ch&&ch.name)?ch.name:'this hero');
 }
}
function hohFavPulse(btn){
 if(!btn) return;
 try{
  btn.classList.remove('hoh-fav-pop'); void btn.offsetWidth; btn.classList.add('hoh-fav-pop');
  setTimeout(function(){ try{ btn.classList.remove('hoh-fav-pop'); }catch(_){} }, 520);
 }catch(_){}
}
/* The sign-in ask. One small panel, reused, never stacked. It names the
   two real ways to have an account here: sign in, or add a hero. */
window.hohFavSignInPrompt=function(anchor){
 var el=document.getElementById('hoh-fav-signin');
 if(!el){
  el=document.createElement('div');
  el.id='hoh-fav-signin';
  el.className='hoh-fav-signin';
  el.setAttribute('role','dialog');
  el.setAttribute('aria-modal','false');
  el.setAttribute('aria-labelledby','hoh-fav-signin-title');
  el.innerHTML=
   '<div class="hoh-fav-signin-title" id="hoh-fav-signin-title"><span class="hoh-fav-glyph" aria-hidden="true">'+HOH_FAV_SOLID+'</span>Sign in to save favorites</div>'+
   '<p class="hoh-fav-signin-text">Your favorites wait for you under Favorited in the Hall. Your account is the email and PIN from the hero you added.</p>'+
   '<div class="hoh-fav-signin-actions">'+
    '<button type="button" class="hoh-fav-signin-go" data-fav-signin="in">Sign in</button>'+
    '<button type="button" class="hoh-fav-signin-add" data-fav-signin="add">Add your hero</button>'+
    '<button type="button" class="hoh-fav-signin-close" data-fav-signin="close">Not now</button>'+
   '</div>';
  el.addEventListener('click',function(e){
   var t=e.target&&e.target.closest?e.target.closest('[data-fav-signin]'):null;
   if(!t) return;
   var k=t.getAttribute('data-fav-signin');
   el.classList.remove('is-open');
   if(k==='in'){
    try{ if(typeof window.hohCloseModal==='function') window.hohCloseModal(); }catch(_){}
    if(typeof window.hohSignInToYourHall==='function'){ window.hohSignInToYourHall(); try{ window.scrollTo({top:0}); }catch(_){} }
   } else if(k==='add'){
    try{ if(typeof window.hohCloseModal==='function') window.hohCloseModal(); }catch(_){}
    if(typeof window.hohOpenForm==='function') window.hohOpenForm();
   }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && el.classList.contains('is-open')) el.classList.remove('is-open'); });
  document.body.appendChild(el);
 }
 el.classList.remove('is-open'); void el.offsetWidth; el.classList.add('is-open');
 clearTimeout(el.__hide); el.__hide=setTimeout(function(){ el.classList.remove('is-open'); }, 9000);
 try{ var go=el.querySelector('.hoh-fav-signin-go'); if(go) go.focus({preventScroll:true}); }catch(_){}
};
/* The toggle itself. Paints first (the tap is the receipt), asks the door,
   and puts the heart back if the door refuses. */
window.hohFavToggle=async function(id,btn){
 if(!id) return;
 if(typeof window.hohIsHallSignedIn==='function' && !window.hohIsHallSignedIn()){ window.hohFavSignInPrompt(btn); return; }
 var D=window.HOHHallDoors; if(!D) return;
 var next=!hohFavIsOn(id);
 var p=D.favourites.set(id,next);
 hohFavPaint(id);
 if(next) hohFavPulse(btn);
 var r=await p;
 hohFavPaint(id);
 if(!r || !r.ok){
  if(r && r.reason==='sign_in_required'){ window.hohFavSignInPrompt(btn); return; }
  if(r && r.missing) return; /* the page just learned it is in legacy mode; nothing was saved */
  try{ hohShowHeartToast('Not saved', /bad_account|pin/i.test(String(r&&r.reason||''))?'Sign in again, then try once more.':'That favorite did not save. Try again in a moment.'); }catch(_){}
 }
};
/* Hearted is a view of the gallery, so a change there re-renders it. */
document.addEventListener('hoh:favourites-changed',function(e){
 try{
  var d=(e&&e.detail)||{};
  if(d.id!=null) hohFavPaint(d.id);
  else hohFavPaintAll();
  try{ hohSyncLikedOption(); }catch(_){}
  /* only the Hearted view changes WHICH heroes show */
  var sel=document.getElementById('hoh-sort');
  if(!d.optimistic && sel && sel.value==='liked' && typeof window.hohApplyFilters==='function' && hohR793Live()) window.hohApplyFilters();
 }catch(_){}
});
/* R793 QA: the gallery keeps a card's node whenever its hero stays in view
   (hohSmoothGridUpdate reuses keyed nodes), so re-running the filters alone
   left every card rendered before the flip with the legacy footer: heart
   counts, the "Heart this hero in Explore" Mythic lock and no favourite
   toggle. Rebuild just the footer of each rendered card, and drop the
   counted-heart dimming in the live Hall. The footer keeps its height in
   both modes, so nothing on the page moves. */
function hohR793RepaintCardFooters(){
 var g=document.getElementById('hoh-gallery');
 if(!g || typeof window.hohBuildCardHtml!=='function') return;
 var byId={};
 try{ (hohRosterSource()||[]).forEach(function(c){ if(c && c.id!=null) byId[String(c.id)]=c; }); }catch(_){ return; }  /* HALL-SPEED-02: the light rows' tiles too */
 var live=hohR793Live(), cards=g.querySelectorAll('.hoh-card[data-hero-id]'), tmp=document.createElement('div');
 for(var i=0;i<cards.length;i++){
  var card=cards[i], c=byId[card.getAttribute('data-hero-id')];
  var old=c && card.querySelector('.hoh-card-footer');
  if(!old) continue;
  try{ tmp.innerHTML=window.hohBuildCardHtml(c,i); }catch(_){ continue; }
  var fresh=tmp.querySelector('.hoh-card-footer');
  if(fresh) old.replaceWith(fresh);
  if(live) card.classList.remove('hoh-card-capped-today','hoh-card-on-cooldown');
 }
 tmp.innerHTML='';
}
/* The mode can flip once per page (first answer from the doors). Repaint
   the gallery and relabel the sort so the page matches the Hall it is. */
document.addEventListener('hoh:r793-mode',function(e){
 var d=(e&&e.detail)||{};
 /* R793.1 fix: unknown now wears the live words in the sort and the grid
    footers (hohR793Words), so unknown -> legacy has to repaint those too;
    there is no early return any more. It happens at most once a page. */
 try{ hohR793RelabelSort(); }catch(_){}
 try{ hohSyncLikedOption(); }catch(_){}
 try{ if(typeof window.hohApplyFilters==='function') window.hohApplyFilters(); }catch(_){}
 try{ hohR793RepaintCardFooters(); }catch(_){}
 try{ if(typeof window.hohRenderHeaderCounter==='function') window.hohRenderHeaderCounter(); }catch(_){}
});
/* Hearts no longer grow, so "Most hearts" would promise a number that
   moves. The option VALUES are untouched: every saved sort keeps working.
   R793.1 (Jan): the default is named Rarity (it orders by the border's tier,
   see hohSortByRarity), the favourites view is Favorited, and the Fewest
   option is gone in both modes. */
var HOH_SORT_LABELS_OLD={most:'Most hearts',liked:'Hearted by you'};
var HOH_SORT_LABELS_R793={most:'Rarity',liked:'Favorited'};
function hohR793RelabelSort(){
 var sel=document.getElementById('hoh-sort'); if(!sel) return;
 /* R793.1 fix: only a Hall known to be legacy reads the old labels */
 var labels=hohR793Words()?HOH_SORT_LABELS_R793:HOH_SORT_LABELS_OLD;
 Object.keys(labels).forEach(function(v){
  var op=sel.querySelector('option[value="'+v+'"]')||((v==='liked'&&_hohLikedOpt)?_hohLikedOpt:null);
  if(op) op.textContent=labels[v];
 });
 try{ if(typeof hohResizeSort==='function') hohResizeSort(); }catch(_){}
}
window.hohR793RelabelSort=hohR793RelabelSort;
/* The frozen count, as a badge. Zero shows nothing. The tip is a real
   element so a tap on a phone can open it (hover does the rest). */
function hohLegacyHeartsHtml(c,variant){
 var n=(c&&c.hearts)|0;
 if(n<=0) return '';
 var num=n.toLocaleString('en-US');
 var tip='Hearts this hero earned before hearts were retired.';
 return '<span class="hoh-legacy-hearts'+(variant?' hoh-legacy-hearts-'+variant:'')+'" tabindex="0" role="note" aria-label="Legacy hearts '+num+'. '+tip+'" onclick="event.stopPropagation();this.classList.toggle(\'is-tip\')" onblur="this.classList.remove(\'is-tip\')">'+
  '<span class="hoh-legacy-hearts-glyph" aria-hidden="true">'+HOH_FAV_SOLID+'</span>'+
  '<span class="hoh-legacy-hearts-text">Legacy hearts <b>'+num+'</b></span>'+
  '<span class="hoh-legacy-hearts-tip" aria-hidden="true">'+tip+'</span>'+
 '</span>';
}
window.hohLegacyHeartsHtml=hohLegacyHeartsHtml;

window.hohHeart=async function(id,btn){
 /* R793: until the doors answer (first visit only) wait briefly, so a tap
    never gives a legacy heart on a Hall where hearts are retired. */
 if(hohR793Unknown() && window.HOHHallDoors){ try{ await window.HOHHallDoors.ready(2500); }catch(_){} }
 if(hohR793Live()) return window.hohFavToggle(id,btn);
 /* R150-Z45 (amended by R249): hohHeart is the universal heart-give
    chokepoint (wander rail, Bustling Streets, conveyer, detail modal,
    hold-to-stream all route here). Signed-out visitors no longer see
    the "Start earning hearts" popup — they give one silent heart per
    hero and further clicks are inert. */
 if(typeof window.hohIsHallSignedIn === 'function' && !window.hohIsHallSignedIn()){
  return hohAnonHeart(id, btn);
 }
 if(!canHeartToday()){
 hohShowHeartToast('Out of hearts','You\'ve spent today\'s. More are scattered around the Hall, if you know where to look.');
 return;
 }
 /* R110-D: Fresh Faces (Explore the Hall) bypasses the per-character
    daily cap. Detected the same way the R65 mythic gate does — by
    walking the btn's ancestors looking for #hoh-fresh-faces. The
    flag is reused below for both the mythic gate and the cap bypass. */
 var fromFreshFaces=false;
 try {
  if(btn && btn.closest && btn.closest('#hoh-fresh-faces')) fromFreshFaces=true;
 } catch(_){}
 /* R133-A: Cap pre-flight — if this hero is in the capped-today
    ledger AND this click isn't from Fresh Faces (which bypasses the
    cap), reject the click locally without firing the RPC. No
    optimistic decrement, no animation, no refund. The user gets the
    cap toast immediately and the heart button stays disabled. */
 if(!fromFreshFaces && typeof window.hohIsCharCappedToday==='function' && window.hohIsCharCappedToday(id)){
  if(typeof window.hohHandleCapRejection==='function'){
   try{ window.hohHandleCapRejection(id,btn); }catch(_){}
  }
  /* Also stop any in-progress stream so the hold loop terminates. */
  try{ if(typeof window.hohOnStreamCapHit==='function') window.hohOnStreamCapHit(id); }catch(_){}
  return;
 }
 /* R166: Soft-cooldown pre-flight. After ANY non-user-cap rejection on
    this hero, we set a 30s cooldown so subsequent clicks pre-empt
    locally instead of firing RPC after RPC into the same wall. This
    is the primary defence against the "I gave 50 hearts and got an
    error toast" experience — the FIRST rejection paints the cooldown,
    every click within the next 30s skips the server entirely with a
    soft, debounced toast. Fresh Faces bypasses cooldown (it bypasses
    the server cap, so it should never deadlock on this gate). */
 if(!fromFreshFaces && typeof window.hohIsCharOnCooldown === 'function' && window.hohIsCharOnCooldown(id)){
  try {
   var remainingMs = (typeof window.hohGetCharCooldownRemainingMs === 'function') ? window.hohGetCharCooldownRemainingMs(id) : 0;
   var secs = Math.max(1, Math.ceil(remainingMs / 1000));
   /* Debounce repeat-tap spam so the user doesn't get 20 toasts. */
   if(!window.__hohCooldownToastedAt || (Date.now() - window.__hohCooldownToastedAt) > 1500){
    window.__hohCooldownToastedAt = Date.now();
    hohShowHeartToast('Hero is paused', 'Try again in ' + secs + 's, or heart them in Explore the Hall.');
   }
  } catch(_){}
  try{ if(typeof window.hohOnStreamCapHit==='function') window.hohOnStreamCapHit(id); }catch(_){}
  return;
 }
 /* R65: Mythic gate. Mythic characters can\'t accept hearts from
    the regular card-spam paths — only via Explore the Hall. */
 try {
  var ch=allCharacters.find(function(c){return c.id===id;});
  if(ch && typeof window.hohIsMythicCharacter==='function' && window.hohIsMythicCharacter(ch) && !fromFreshFaces){
   /* R267: mythic heroes are GRID-locked, NOT a hard cap (reverts R169). They
      keep taking hearts from Explore the Hall — only the main grid and detail
      are closed to them, matching the original R65 intent. The !fromFreshFaces
      guard lets an Explore-the-Hall heart fall through to the grant below. */
   hohShowHeartToast('A mythic hero', 'Heart this hero in Explore the Hall to keep feeding them. Mythic heroes take hearts nowhere else.');
   return;
  }
  if(ch && typeof window.hohIsLegendLocked==='function' && window.hohIsLegendLocked(ch) && !fromFreshFaces){
   /* R169: Legend Locked (1000-1199). The grid and detail are locked here; the
      last 200 hearts to Mythic come only from Explore the Hall. */
   hohShowHeartToast('Legend Locked', 'Heart this hero in Explore the Hall to push them to Mythic. These last 200 hearts count nowhere else.');
   return;
  }
 } catch(_){}
 var heartNumber=Math.max(1,getHeartCount(id)+1);
 /* OPTIMISTIC EVERYTHING. Wallet decrement, heart fly, count bump,
    button pulse, mineCount pip — all fire SYNCHRONOUSLY on click so
    the user sees instant feedback. The RPC roundtrip happens in the
    background; on failure we revert the visuals below.
    R110-C: tier_factor absorb is fully retired — every click adds
    exactly 1 heart at every tier. The old "Skip optimistic bump for
    Epic/Legendary/Mythic" gate is gone; we now always bump the count
    by 1 and reconcile with the server. */
 var ch=allCharacters.find(function(c){return c.id===id;});
 var prevServerHearts=ch?ch.hearts:0;
 var bumpOptimisticCount = true;

 /* 1. Wallet decrement (already optimistic — kept). Passes the hero id so
    the heart ledger hint (R282) can name who got hearted in the Data Hub. */
 recordDailyHeart(id);
 hohShowHeartCounter();

 /* 2. Heart fly — fires INSTANTLY, no longer waits for RPC. */
 hohThrowHeartAt(btn,heartNumber);

 /* 3. mineCount + button state. localStorage write is sync. */
 var mineCount=markHearted(id);
 /* R148-Z36: Scope the unique_hearters bump to Explore-the-Hall
    hearts ONLY. The previous behavior bumped on every heart, which
    inflated the "unique players" stat by counting main-hall repeat-
    clicks from the same person as multiple "unique" votes. The user
    framed the unique counter as a REACH metric: each Explore-the-
    Hall heart is a discovery (someone stumbled onto the hero), each
    main-hall heart is repeat affinity (the same person re-engaging).
    Repeat affinity already shows up in the main `hearts` count;
    `unique_hearters` should track distinct discovery events.
    Implementation: only fire the local bump when the heart originated
    inside #hoh-fresh-faces (fromFreshFaces was set above by walking
    the btn ancestry). The server-side trigger
    (refresh_unique_hearters) also needs to read a fresh-faces flag
    on the heart_attributions row — captured below via the RPC's
    bypassDailyCap context which is already fresh-faces-only. */
 if(fromFreshFaces && typeof window.hohBumpUniqueHeartersLocal === 'function'){
  try { window.hohBumpUniqueHeartersLocal(id); } catch(_){}
 }
 hohSpawnComboFloater(btn,mineCount);
 btn.classList.add('hearted');btn.classList.add('hoh-heart-pulse');
 hohApplyHeartTier(btn,mineCount);
 setTimeout(function(){btn.classList.remove('hoh-heart-pulse');},420);
 var iconEl=btn.querySelector('.hoh-heart-icon');
 if(iconEl) iconEl.innerHTML='&#9829;&#xFE0E;';

 /* 4. Optimistic count bump (only for non-fractional tiers). */
 var ce=btn.querySelector('.hoh-heart-count');
 var prevDisplayCount=ce?(parseInt(ce.textContent)||0):0;
 /* R590: a marked hero really gains 2 per Explore heart. Show 2.
    See hohExploreMarkBonus for why the server's own reply cannot
    tell us this. */
 var markBonus = hohExploreMarkBonus(ch, fromFreshFaces);
 if(ce && bumpOptimisticCount){
  ce.textContent=String(prevDisplayCount+1+markBonus);
 }

 /* 5. Mine pip update. */
 var mineEl=btn.querySelector('.hoh-heart-mine');
 if(mineCount>1){
  if(!mineEl){mineEl=document.createElement('span');mineEl.className='hoh-heart-mine';btn.appendChild(mineEl);}
  mineEl.textContent='x'+fmtMine(mineCount);
  mineEl.style.display='';
 }

 /* 6. Now hit the server — no UI is waiting on this. */
 var rpc=await hohCallHeartRpc(id, { bypassDailyCap: fromFreshFaces });

 /* R148-Z2: REVERTED R111-E. Per user, hearts given on the main
    gallery should NOT advance the Explore the Hall progress bar —
    "only heroes liked in the explore the hall counts towards that
    progress bar". This matches the original design intent stated
    in the comment at the top of bumpFfHeartsToday in hoh-fresh-
    faces.js ("Hearts on the main gallery do NOT progress this
    quest; hearts here DO").
    R111-E had expanded the bar to include all heart sources; that
    expansion is gone. The bar now reflects only inline hearts on
    Explore-the-Hall cards (Wandering Heroes grid, themed rolls,
    Bustling Streets, special-event cards) — those surfaces still
    call bumpFfHeartsToday() directly from their own handlers
    BEFORE hitting hohHeart, so removing this redundant call doesn't
    affect them. Main-gallery clicks (this branch) no longer count. */

 if(hohRpcHearts(rpc)==null){
  /* Cap or RPC error — REVERT the optimistic visuals so the UI
     stays truthful. Refund wallet, undo count bump, undo localStorage
     mineCount, undo button hearted state if this was the user's first
     heart on this hero.
     R166: Two desyncs fixed here vs the previous version:
       (1) The display revert used `prevDisplayCount` — a snapshot from
           the moment THIS click fired. With multiple parallel clicks,
           a late-arriving failure would rewrite the display back to
           the old count, wiping the optimistic bumps from sibling
           clicks that succeeded in the meantime. Now we use
           ch.hearts (the server-authoritative count from the latest
           successful response) as the source of truth.
       (2) The mineEl pip text was set during the optimistic phase
           with the captured mineCount, but rejection only touched
           hMap — never re-rendered the pip. Result: pip showed x41
           while hMap was actually 33. Now we re-render mineEl text
           from the current hMap value after the decrement so what
           the user sees matches what's stored. */
  hohAddHeartsToBank(1);
  hohShowHeartCounter();
  var truthDisp = (ch && typeof ch.hearts === 'number') ? ch.hearts : prevDisplayCount;
  if(ce && bumpOptimisticCount) ce.textContent = String(truthDisp);
  /* Decrement local mineCount. Edge: clamp at 0. */
  var currentMineAfter = 0;
  try {
   var hMap=getHeartMap();
   if(hMap[id]>0){ hMap[id]--; if(hMap[id]<=0) delete hMap[id]; __hMC=hMap; localStorage.setItem('hoh-hearts',JSON.stringify(hMap)); }
   currentMineAfter = hMap[id] || 0;
  } catch(_){}
  /* Re-render the mine pip from the post-decrement hMap so the visible
     "xN" matches reality. Without this the pip drifts upward whenever
     a click fails after a sibling click succeeded. */
  if(mineEl){
    if(currentMineAfter > 1){
      mineEl.textContent = 'x' + fmtMine(currentMineAfter);
      mineEl.style.display = '';
    } else {
      mineEl.style.display = 'none';
      mineEl.textContent = '';
    }
  }
  /* If this rejection was the user's FIRST heart on this hero,
     also undo the hearted button class so the heart icon resets. */
  if(currentMineAfter <= 0){
   btn.classList.remove('hearted');
   if(iconEl) iconEl.innerHTML='&#9825;&#xFE0E;';
   if(mineEl) mineEl.style.display='none';
  }
  /* R166: Forward the server's rejection reason so hohOnCapRejected
     can route between "user really capped" (permanent today) and
     "global counter miss-fire" (30s soft cooldown). */
  hohOnCapRejected(id, btn, hohRpcReason(rpc));
  return;
 }
 /* R97: tier_factor absorb branch retired. With the server now using
    factor=1 always, every click_added is true. The handler below
    just reconciles the visible count with the server's authoritative
    number — no fractional click feedback needed. */
 /* R165: Track per-user-per-character daily clicks locally so the
    capped-today gate keys off the USER's own count (not a global
    rejection flag). Skip Fresh Faces hearts — they bypass the cap
    server-side and shouldn't burn against the main-hall per-user
    cap conceptually. */
 if(!fromFreshFaces && typeof window.hohBumpMineToday==='function'){
  try{ window.hohBumpMineToday(id); }catch(_){}
 }
 /* R166: Successful heart on a hero that had been on cooldown clears
    the cooldown so the user isn't blocked once the wall lifts. */
 if(typeof window.hohClearCharCooldown === 'function'){
  try { window.hohClearCharCooldown(id); } catch(_){}
 }
 /* Reconcile the visible count with the server's authoritative
    number. Optimistic +1 should always match the server's report. */
 /* R590: rpc.data.hearts is the count AFTER increment_hearts_capped's
    own +1 and BEFORE mark_heart_explore's bonus, which is dispatched
    fire-and-forget and never awaited. Add the Mark's +1 back so the
    reconcile does not undo the optimistic bump a line above and make
    the number visibly jump 2 to 1 in front of the player. */
 var srv=(rpc.data&&typeof rpc.data.hearts==='number')?(rpc.data.hearts+markBonus):(prevDisplayCount+1+markBonus);
 if(ce) ce.textContent=String(srv);
 if(ch) ch.hearts=srv;
 /* R166: Re-render the mine pip from the authoritative hMap[id] so
    it always matches reality — guards against drift when multiple
    clicks are in flight and rejection/success interleave. */
 try {
  var hMapS = getHeartMap();
  var currentMineS = hMapS[id] || 0;
  if(mineEl && currentMineS > 1){
    mineEl.textContent = 'x' + fmtMine(currentMineS);
    mineEl.style.display = '';
  }
 } catch(_){}
 hohShowHeartCounter();
 if(typeof window.hohMaybeShowAttributionPrompt==='function')window.hohMaybeShowAttributionPrompt(btn);
 /* Tier upgrade: compare rarity before/after the server-confirmed
    heart count. Mythic gets a louder celebration since reaching it
    also banks a bonus raffle ticket. */
 if(ch){
  var beforeRar=hohGetRarity(prevServerHearts);
  var nextRar=hohGetRarity(ch.hearts);
  if(beforeRar.tier!==nextRar.tier){
   var cardEl=btn.closest('.hoh-card')||btn;
   if(cardEl&&cardEl.classList.contains('hoh-card')){
   ['common','uncommon','rare','epic','legendary','mythic'].forEach(function(t){cardEl.classList.remove('hoh-card-rar-'+t);});
   cardEl.classList.add('hoh-card-rar-'+nextRar.tier);
   }
   hohCelebrateTierUp(cardEl,beforeRar.tier,nextRar.tier,nextRar);
  }
  if(rpc.data&&rpc.data.mythic_unlocked){hohCelebrateMythic(btn.closest('.hoh-card')||btn,ch);}
 }
};
window.hohHeartDetail=async function(){
 if(!currentDetail)return;
 /* R793: the detail heart is the favourite toggle in the live Hall. */
 if(hohR793Unknown() && window.HOHHallDoors){ try{ await window.HOHHallDoors.ready(2500); }catch(_){} }
 if(hohR793Live()) return window.hohFavToggle(currentDetail.id, document.getElementById('hoh-detail-heart'));
 /* R444 (Jan): the grid heart routed visitors to hohAnonHeart. This one, the
    detail modal's heart, never did, so it fell straight through to the wallet
    check below and announced "Out of hearts" to someone who has no wallet.
    Same door, same rule: one silent heart per hero. */
 if(typeof window.hohIsHallSignedIn === 'function' && !window.hohIsHallSignedIn()){
  return hohAnonHeart(currentDetail.id, document.getElementById('hoh-detail-heart'));
 }
 if(!canHeartToday()){
 hohShowHeartToast('Out of hearts','You\'ve spent today\'s. More are scattered around the Hall, if you know where to look.');
 return;
 }
 /* R133-A: Detail-modal cap pre-flight. If this hero is in the
    capped-today ledger AND isn't on the current Fresh Faces batch
    (which bypasses the cap), reject the click without firing the
    RPC. Avoids the "click → animation → refund → toast" cycle and
    immediately stops any in-flight stream. */
 try {
   var detailFreshEarly=false;
   if(typeof window.hohFreshFacesIsOnCurrentBatch==='function'){
     detailFreshEarly=!!window.hohFreshFacesIsOnCurrentBatch(currentDetail.id);
   }
   if(!detailFreshEarly && typeof window.hohIsCharCappedToday==='function' && window.hohIsCharCappedToday(currentDetail.id)){
     var detailBtnEarly=document.getElementById('hoh-detail-heart');
     if(typeof window.hohHandleCapRejection==='function'){
       try{ window.hohHandleCapRejection(currentDetail.id,detailBtnEarly); }catch(_){}
     }
     try{ if(typeof window.hohOnStreamCapHit==='function') window.hohOnStreamCapHit(currentDetail.id); }catch(_){}
     return;
   }
   /* R166: Detail-modal cooldown pre-flight — mirror hohHeart's gate
      so a hero on cooldown doesn't burn a wallet heart from the
      detail modal either. */
   if(!detailFreshEarly && typeof window.hohIsCharOnCooldown === 'function' && window.hohIsCharOnCooldown(currentDetail.id)){
     var remMs = (typeof window.hohGetCharCooldownRemainingMs === 'function') ? window.hohGetCharCooldownRemainingMs(currentDetail.id) : 0;
     var rSec = Math.max(1, Math.ceil(remMs / 1000));
     try {
       if(!window.__hohCooldownToastedAt || (Date.now() - window.__hohCooldownToastedAt) > 1500){
         window.__hohCooldownToastedAt = Date.now();
         hohShowHeartToast('Hero is paused', 'Try again in ' + rSec + 's, or heart them in Explore the Hall.');
       }
     } catch(_){}
     try{ if(typeof window.hohOnStreamCapHit==='function') window.hohOnStreamCapHit(currentDetail.id); }catch(_){}
     return;
   }
 } catch(_){}
 var detailBtn=document.getElementById('hoh-detail-heart');
 var heartNumDetail=Math.max(1,getHeartCount(currentDetail.id)+1);
 /* Capture the fresh-faces "on current batch" flag BEFORE the wallet
    decrement. recordDailyHeart dispatches hoh:hearts-bumped, which
    can synchronously trigger syncWalletState's wallet→0 reset and
    clear lastRenderedIds. By snapshotting first, the bridge can still
    progress the Explore quest counter and mark the card hearted even
    if the section reset under it. */
 var freshSnapshot=false;
 try {
   if(typeof window.hohFreshFacesIsOnCurrentBatch==='function'){
     freshSnapshot=window.hohFreshFacesIsOnCurrentBatch(currentDetail.id);
   }
 } catch(_){}
 /* Per-batch allowance gate. If the user's hearting a hero who's on
    the current Fresh Faces batch AND the chip already says "Spent
    here" (page allowance exhausted), reject the heart so the chip's
    visual state stays truthful. The previous behavior let the user
    bypass the allowance by hearting from the detail modal — chip
    said "Spent here" but the wallet was still draining.
    The gate only applies when the hero is on the fresh-faces batch
    AND the user hasn't already counted them this batch (so a 2nd
    fractional click on the same Epic still goes through). */
 try {
   if(freshSnapshot && typeof window.hohFreshFacesGetPageAllowanceState === 'function'){
     var pa = window.hohFreshFacesGetPageAllowanceState();
     /* Only gate if the page allowance is exhausted AND this character
        wouldn't have been a free re-click. Re-clicks on the same card
        within a batch don't increment the spent counter, so they're
        always allowed regardless of allowance state. */
     var alreadyCounted = (typeof window.hohFreshFacesIsCountedThisBatch === 'function')
       ? window.hohFreshFacesIsCountedThisBatch(currentDetail.id) : false;
     if(pa && pa.remaining <= 0 && pa.max > 0 && !alreadyCounted){
       hohShowHeartToast('Spent on this batch', 'You\'ve given everything you can to this batch. Refresh to find a new one.');
       /* Pulse the page-hearts chip red so the user sees why the
          click didn't land. Same R16 deny pulse used by the small
          card heart click. */
       try {
         var chipEl = document.querySelector('#hoh-fresh-page-hearts');
         if(chipEl){
           chipEl.classList.remove('hoh-fresh-page-hearts-deny');
           void chipEl.offsetWidth;
           chipEl.classList.add('hoh-fresh-page-hearts-deny');
           setTimeout(function(){ if(chipEl) chipEl.classList.remove('hoh-fresh-page-hearts-deny'); }, 950);
         }
       } catch(_){}
       return;
     }
   }
 } catch(_){}
 /* OPTIMISTIC WALLET DECREMENT — see hohHeart() for the full reasoning.
  Counter ticks immediately so click-and-hold feels smooth; refunded
  below if the RPC rejects (cap or network error). Hero id rides the
  R282 ledger hint so the Data Hub log names the hearted hero. */
 recordDailyHeart(currentDetail.id);
 hohShowHeartCounter();
 /* R110-D: If this hero is on the current Fresh Faces batch, the
    detail-modal heart bypasses the per-character daily cap (Explore
    the Hall always lands a +1, even if the hero hit cap elsewhere). */
 var rpcD=await hohCallHeartRpc(currentDetail.id, { bypassDailyCap: !!freshSnapshot });

 /* R148-Z2: REVERTED R111-E. The detail modal's heart button no
    longer advances the Explore the Hall bar, regardless of where
    the modal was opened from. Per user: "only heroes liked in the
    explore the hall counts towards that progress bar" — clicking
    a heart inside the modal is "liked in the modal", not in the
    Explore section. Inline hearts on Explore-the-Hall cards (the
    small heart button on each card) still count via the rail's
    own bumpFfHeartsToday calls. */
 if(hohRpcHearts(rpcD)==null){
  hohAddHeartsToBank(1);
  hohShowHeartCounter();
  /* R166: Forward server reason so the cooldown / cap-disable routing
     applies on the detail-modal path too. */
  hohOnCapRejected(currentDetail.id, detailBtn, hohRpcReason(rpcD));
  return;
 }
 /* R166: A successful detail-modal heart clears any soft cooldown
    that might have been set from a prior rejection. */
 if(typeof window.hohClearCharCooldown === 'function'){
  try { window.hohClearCharCooldown(currentDetail.id); } catch(_){}
 }
 /* R97: Fractional-click absorb branch retired. tier_factor is
    now always 1 server-side, so click_added is always true and we
    fall through to the normal heart-add flow below. */
 /* Per-heart ticket grants are retired (see gallery hohHeart). */
 if(detailBtn)hohThrowHeartAt(detailBtn,heartNumDetail);
 var mineCount=markHearted(currentDetail.id);
 /* R165: Bump per-user mineToday for the cap gate (skip Fresh Faces
    detail hearts — they bypass cap). See main hohHeart for rationale. */
 if(!freshSnapshot && typeof window.hohBumpMineToday==='function'){
  try{ window.hohBumpMineToday(currentDetail.id); }catch(_){}
 }
 /* R148-Z36: Detail-modal hearts do NOT bump unique_hearters. The
    detail modal is a deep-dive into a character the user has already
    discovered (via main hall, Your Hall, search, share link, etc.) —
    those clicks are repeat affinity, not discovery. The unique
    counter tracks distinct discovery events from Explore the Hall
    only. See main hohHeart() for the matching gate. */
 /* Auto-favorite on heart removed by request. Hearting another
    user's hero no longer adds them to My Favorites — only the user's
    own submitted characters auto-favorite (handled at submit time).
    To favorite someone else's hero the user clicks the star directly. */
 hohSpawnComboFloater(detailBtn,mineCount);
 var btn=document.getElementById('hoh-detail-heart');
 btn.classList.add('hearted');btn.classList.add('hoh-heart-pulse');
 hohApplyHeartTier(btn,mineCount);
 setTimeout(function(){btn.classList.remove('hoh-heart-pulse');},420);
 btn.querySelector('span').innerHTML='&#9829;&#xFE0E;';
 var ce=document.getElementById('hoh-detail-heart-count'),cur=parseInt(ce.textContent)||0,srvD=(rpcD.data&&typeof rpcD.data.hearts==='number')?rpcD.data.hearts:cur+1;ce.textContent=srvD;
 var mineEl=document.getElementById('hoh-detail-heart-mine');
 if(mineEl&&mineCount>1){mineEl.textContent='x'+fmtMine(mineCount);mineEl.style.display='';}
 if(typeof window.hohMaybeShowAttributionPrompt==='function')window.hohMaybeShowAttributionPrompt(btn);
 var ch=allCharacters.find(function(c){return c.id===currentDetail.id;});
 var prevHd=ch?ch.hearts:cur;
 if(ch)ch.hearts=(rpcD.data&&typeof rpcD.data.hearts==='number')?rpcD.data.hearts:cur+1;
 /* R244: mirror the R230 trigger locally — crossing HOH_MYTHIC_AT hearts
    (1200 since R769D) bakes +3 tickets server-side exactly once
    (mythic_bonus_granted latch). Without this the modal shows the stale
    ticket count until the next full fetch. */
 if(ch && (ch.hearts||0)>=HOH_MYTHIC_AT && !ch.mythic_bonus_granted){ ch.mythic_bonus_granted=true; ch.tickets=(ch.tickets||1)+3; }
 var pctEl=document.getElementById('hoh-detail-win-pct-num');
 if(pctEl&&ch)pctEl.textContent=hohWinPercent(ch).toFixed(2);
 var tkEl=document.getElementById('hoh-detail-tk-count');
 if(tkEl&&ch)tkEl.textContent=ch.tickets||1;
 var tkTip=document.getElementById('hoh-detail-tk-tip');
 if(tkTip&&ch)tkTip.innerHTML=hohBuildTicketBreakdownHtml(ch);
 if(typeof window.hohUpdateSpendCoach==='function')window.hohUpdateSpendCoach();
 renderGallery();forceCardsVisible();
 hohShowHeartCounter();
 /* Tier upgrade: fire celebration if hearts crossed a threshold. */
 if(ch){
 var prevRarD=hohGetRarity(prevHd);
 var nextRarD=hohGetRarity(ch.hearts);
 if(prevRarD.tier!==nextRarD.tier){
  hohApplyModalRarity(nextRarD.tier);
  var nameEl=document.querySelector('.hoh-detail-name');
  if(nameEl){['common','uncommon','rare','epic','legendary','mythic'].forEach(function(t){nameEl.classList.remove('hoh-detail-name-rar-'+t);});nameEl.classList.add('hoh-detail-name-rar-'+nextRarD.tier);}
  var pill=document.querySelector('.hoh-rarity-info');
  if(pill&&pill.parentNode){
  var fresh=document.createElement('div');fresh.innerHTML=hohBuildRarityInfoHtml(nextRarD);
  pill.parentNode.replaceChild(fresh.firstChild,pill);
  }
  hohCelebrateTierUp(document.querySelector('#hoh-modal .hoh-modal-content'),prevRarD.tier,nextRarD.tier,nextRarD);
 }
 if(rpcD.data&&rpcD.data.mythic_unlocked){hohCelebrateMythic(document.querySelector('#hoh-modal .hoh-modal-content'),ch);}
 }
 /* Bridge to fresh-faces bookkeeping. If the user opened the detail
    modal from a card currently rendered in the Explore the Hall
    section, this notifies fresh-faces so the daily Explore quest
    counter ticks, the per-page heart allowance decrements, and the
    underlying card flips to its hearted state. No-op for hearts on
    characters outside fresh-faces (gallery, your hall, etc.). We
    pass the freshSnapshot captured before the wallet decrement so
    the bridge runs even if the wallet→0 sync cleared lastRenderedIds
    in between. */
 if(freshSnapshot){
   try {
     if(typeof window.hohFreshFacesNoteExternalHeart === 'function'){
       window.hohFreshFacesNoteExternalHeart(currentDetail.id, { inFreshFaces: true });
     }
   } catch(_){}
 }
};
function hohResizeSort(){var s=document.getElementById('hoh-sort');if(!s)return;var t=document.createElement('span');t.style.cssText='font-size:13px;font-family:Cormorant Garamond,serif;visibility:hidden;position:absolute;white-space:nowrap;';t.textContent=s.options[s.selectedIndex].text;document.body.appendChild(t);s.style.width=(t.offsetWidth+18)+'px';t.remove();}
/* R140-Z3: Hidden FF Portraits sort. Activated only when the user
   clicks the FF logo on a card. Adds an "FF Portraits" option to the
   sort dropdown, selects it, applies filters. The option is kept on
   the dropdown ONLY while it's the active sort — switching to anything
   else removes it, so it stays a discovery surface rather than a
   permanent UI element. Re-clicking any FF logo re-activates the
   option. The filter logic itself lives inside renderGallery's switch
   on sortVal so the existing pipeline (search, dismiss filter, etc.)
   composes cleanly. */
var FF_SORT_VALUE = 'ffportraits';
var FF_SORT_LABEL = 'FF Portraits';
/* R228: paint the sort label in the FramedFantasy brand gradient while
   the FF Portraits filter is the active sort. We toggle a class on the
   native select and let CSS handle the gradient text (with a solid
   brand fallback). Kept in sync from hohApplyFilters so every path that
   changes the sort — the FF logo click, the dropdown itself, switching
   away — lands on the right state. */
function _hohSyncFfSortStyle(){
  var sel = document.getElementById('hoh-sort');
  if(!sel) return;
  if(sel.value === FF_SORT_VALUE) sel.classList.add('hoh-sort-ff');
  else sel.classList.remove('hoh-sort-ff');
}
function _ensureFfSortOption(){
 var sel=document.getElementById('hoh-sort');
 if(!sel) return null;
 for(var i=0;i<sel.options.length;i++){
  if(sel.options[i].value===FF_SORT_VALUE) return sel;
 }
 var opt=document.createElement('option');
 opt.value=FF_SORT_VALUE;
 opt.textContent=FF_SORT_LABEL;
 /* Insert at the TOP so the user sees the new sort first when the
    dropdown opens. */
 sel.insertBefore(opt,sel.firstChild);
 return sel;
}
function _removeFfSortOption(){
 var sel=document.getElementById('hoh-sort');
 if(!sel) return;
 for(var i=sel.options.length-1;i>=0;i--){
  if(sel.options[i].value===FF_SORT_VALUE){ sel.removeChild(sel.options[i]); }
 }
}
/* R140-Z3b: First-of-day bonus. The FIRST time a user clicks the FF
   logo on any given day, they get +20 hearts plus a hidden-achievement
   lightbox in brand colors. Subsequent activations same day just flip
   the sort silently. Gate is per-day localStorage so it auto-resets at
   midnight. The flag is per-device — same as other daily nudges in
   the app — accepted because the bonus is small and tied to the
   discovery moment of finding the badge, not a raffle stake. */
function _hohFfBonusKey(){
 try { return 'hoh-ff-bonus-' + new Date().toISOString().slice(0,10); }
 catch(_){ return 'hoh-ff-bonus-unknown'; }
}
function _hohFfBonusClaimedToday(){
 try { return localStorage.getItem(_hohFfBonusKey()) === '1'; }
 catch(_){ return false; }
}
function _hohMarkFfBonusClaimedToday(){
 try { localStorage.setItem(_hohFfBonusKey(), '1'); } catch(_){}
}
function _hohShowFfAchievementLightbox(){
 var existing=document.getElementById('hoh-ff-ach-lightbox');
 if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
 var lb=document.createElement('div');
 lb.id='hoh-ff-ach-lightbox';
 lb.className='hoh-ff-ach-lightbox';
 lb.setAttribute('role','status');
 lb.setAttribute('aria-live','polite');
 /* R140-Z3h: Clearer copy explaining what the user just unlocked,
    so it reads as a feature reveal rather than a mystery. Reward
    dropped 20 → 10 hearts. */
 lb.innerHTML=
  '<div class="hoh-ff-ach-card">'+
   '<div class="hoh-ff-ach-eyebrow">Hidden Achievement Unlocked</div>'+
   '<div class="hoh-ff-ach-title">Patron of the Frame</div>'+
   '<div class="hoh-ff-ach-sub">Tapping any FF logo on a card sorts the Hall to FramedFantasy portraits only.</div>'+
   '<div class="hoh-ff-ach-tap">Tap to close</div>'+
  '</div>';
 lb.addEventListener('click',function(){
  /* R228: tap just closes. The +10 is granted silently on trigger for
     signed-in users (see hohActivateFfPortraitsSort), so there is
     nothing to claim here and no reward graphic on the card. */
  try { lb.classList.add('hoh-ff-ach-leaving'); } catch(_){}
  setTimeout(function(){ if(lb.parentNode) lb.parentNode.removeChild(lb); }, 260);
 });
 document.body.appendChild(lb);
 /* R202: no auto-dismiss. The hearts fly to the wallet on their own, but the
    card stays so the user can actually read it and only closes when they tap it. */
}
/* R202: a subtle, self-dismissing toast for REPEAT taps of an FF logo, after the
   once-a-day achievement has been claimed. Tells the user the Hall just sorted to
   FramedFantasy portraits without taking over the screen. */
function _hohShowFfSortToast(){
 try {
  var existing=document.getElementById('hoh-ff-sort-toast');
  if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
  var t=document.createElement('div');
  t.id='hoh-ff-sort-toast';
  t.className='hoh-ff-sort-toast';
  t.setAttribute('role','status');
  t.setAttribute('aria-live','polite');
  t.innerHTML='<span class="hoh-ff-sort-toast-heart" aria-hidden="true">&#9829;&#xFE0E;</span> Sorted by FramedFantasy portraits';
  document.body.appendChild(t);
  requestAnimationFrame(function(){ try{ t.classList.add('hoh-ff-sort-toast-in'); }catch(_){} });
  setTimeout(function(){
   if(!t.parentNode) return;
   t.classList.remove('hoh-ff-sort-toast-in');
   setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); }, 300);
  }, 2000);
 } catch(_){}
}
window.hohActivateFfPortraitsSort=function(srcEl){
 /* R140-Z3c: Sweep stuck FF tooltips immediately on click. When the
    user clicks a badge, mouseleave doesn't always fire (especially
    when the gallery rerenders mid-tooltip), and the tooltip stays
    orphaned on screen. */
 if(typeof hohClearFfTooltips==='function') hohClearFfTooltips();
 /* R140-Z3c: Capture the badge's screen rect SYNCHRONOUSLY before any
    rerender / smooth-scroll mutates the DOM. The original heart-fly
    grabbed srcEl.getBoundingClientRect() at fire time (280ms later),
    by which point hohApplyFilters had re-rendered the grid and the
    original badge node was either detached or moved — flyDiceTrader
    HeartsToPill bails when the source rect has zero width, killing
    the animation silently. We pin a ghost anchor div at fixed coords
    based on the rect captured here so the fly source survives the
    rerender. */
 var clickRect=null;
 try {
  if(srcEl && srcEl.getBoundingClientRect){
   var r=srcEl.getBoundingClientRect();
   if(r.width>0 && r.height>0) clickRect=r;
  }
 } catch(_){}
 var sel=_ensureFfSortOption();
 if(!sel) return;
 sel.value=FF_SORT_VALUE;
 if(typeof window.hohApplyFilters==='function') window.hohApplyFilters();
 /* Scroll the grid into view so the user sees the filter take effect.
    Mobile users especially need this — the FF logo lives on the card
    art, which can be off-screen mid-scroll. */
 try {
  var g=document.getElementById('hoh-gallery');
  if(g && g.scrollIntoView) g.scrollIntoView({ behavior:'smooth', block:'start' });
 } catch(_){}
 /* R140-Z3b: First-of-day bonus path. Once-per-day +20 hearts +
    achievement lightbox. Gate is checked AFTER the sort flip so the
    user always gets the filter response on every click; the bonus
    just rides along the first time. */
 /* R228: First-of-day FF sort. Show the achievement card, then silently
    bank +10 hearts for signed-in users with a quiet fly animation. The
    user never taps to claim and never sees a reward chip — the hearts
    just land in the wallet. Anonymous visitors get the card but no
    hearts. The notification is gated to once a day for everyone. */
 if(_hohFfBonusClaimedToday()){ try{ _hohShowFfSortToast(); }catch(_){} return; }
 _hohMarkFfBonusClaimedToday();
 try { _hohShowFfAchievementLightbox(); } catch(_){}
 var _ffSignedIn = true;
 try { if(typeof window.hohIsHallSignedIn === 'function') _ffSignedIn = !!window.hohIsHallSignedIn(); } catch(_){}
 if(_ffSignedIn){
  try { if(typeof window.hohAddHeartsToBank==='function') window.hohAddHeartsToBank(10); } catch(_){}
  try { if(typeof window.hohRenderHeaderCounter==='function') window.hohRenderHeaderCounter(); } catch(_){}
  /* Fly source — the achievement card if it mounted, else a ghost anchor
     pinned to the click point so the hearts still travel cleanly. */
  var _ffGX=(window.innerWidth||800)/2, _ffGY=(window.innerHeight||600)/2;
  if(clickRect){ _ffGX=clickRect.left+clickRect.width/2; _ffGY=clickRect.top+clickRect.height/2; }
  var _ffGhost=document.createElement('div');
  _ffGhost.style.cssText='position:fixed;left:'+(_ffGX-1)+'px;top:'+(_ffGY-1)+'px;width:2px;height:2px;pointer-events:none;z-index:100050;';
  document.body.appendChild(_ffGhost);
  setTimeout(function(){
   var src=document.querySelector('#hoh-ff-ach-lightbox .hoh-ff-ach-card')||_ffGhost;
   try {
    if(typeof window.flyDiceTraderHeartsToPill==='function') window.flyDiceTraderHeartsToPill(src,10);
    else if(typeof window.hohFlyHeartsToPill==='function') window.hohFlyHeartsToPill(src,10);
   } catch(_){}
  }, 600);
  setTimeout(function(){ if(_ffGhost.parentNode) _ffGhost.parentNode.removeChild(_ffGhost); }, 3000);
 }
};
/* Hook into the sort dropdown's change event: when the user switches
   AWAY from FF Portraits, remove the option from the dropdown. The
   inline onchange="hohApplyFilters()" already fires renderGallery; we
   just piggyback on the same event. Capturing phase listener so it
   runs BEFORE the inline handler so the dropdown is correct by the
   time renderGallery reads its value. */
document.addEventListener('change',function(e){
 if(!e || !e.target || e.target.id !== 'hoh-sort') return;
 if(e.target.value !== FF_SORT_VALUE){
  _removeFfSortOption();
 }
},true);
window.hohApplyFilters=function(){
 /* R140-Z3c: Sweep any stuck FF tooltips before rerender. Whenever
    the gallery re-renders, badges that the cursor was hovering can
    detach from the DOM mid-tooltip — mouseleave never fires and the
    tooltip stays orphaned on screen. Calling the sweep up front means
    every filter / sort change leaves a clean tooltip state. */
 if(typeof hohClearFfTooltips==='function') hohClearFfTooltips();
 try { _hohSyncFfSortStyle(); } catch(_){}
 hohResizeSort();renderGallery();setTimeout(observeElements,50);
};
/* Filter the main gallery to a single author. Drops the player's
   typed name into the search field, fires the existing filter
   pipeline (which already searches across player_name in renderGallery
   line 1190), closes the detail modal, scrolls the gallery into view.
   Wired from the byline link in hohOpenDetail. */
window.hohFilterByAuthor=function(name){
 if(!name) return false;
 try {
  /* Close the detail modal first so the filtered gallery is what
     the user sees next. */
  if(typeof window.hohCloseModal==='function') window.hohCloseModal();
  /* If the user is currently inside Your Hall mode (the body class
     hides the main gallery via CSS), exit back to the main hall so
     the search/filter actually has something visible to land in.
     Without this, the user clicks the byline and nothing visible
     happens — Your Hall is still on top. */
  try {
   if(document.body && document.body.classList.contains('hoh-page-mode-yours')){
    document.body.classList.remove('hoh-page-mode-yours');
    if(typeof window.hohYhSetHeaderModeHome==='function'){
     try { window.hohYhSetHeaderModeHome(); } catch(_){}
    }
    if(typeof window.hohRefreshYhToggle==='function'){
     try { window.hohRefreshYhToggle(); } catch(_){}
    }
   }
  } catch(_){}
  var search=document.getElementById('hoh-search');
  if(search){
   search.value=name;
   /* Fire input event so any debounced wrapper picks it up too. */
   try { search.dispatchEvent(new Event('input',{bubbles:true})); } catch(_){}
   if(typeof window.hohApplyFilters==='function') window.hohApplyFilters();
   /* Scroll the gallery into view so the user can see the filtered
      results immediately. Wrapped in rAF so the layout settles
      after the Your-Hall mode flip before we measure scroll target. */
   var gallery=document.getElementById('hoh-gallery');
   if(gallery && typeof gallery.scrollIntoView==='function'){
    requestAnimationFrame(function(){
     setTimeout(function(){ gallery.scrollIntoView({behavior:'smooth',block:'start'}); }, 80);
    });
   }
  }
 } catch(_){}
 return false;
};
/* Debounced search wrapper: avoids 200-card re-render on every keystroke. */
var __hohST=null;
window.hohDebouncedSearch=function(){if(__hohST)clearTimeout(__hohST);__hohST=setTimeout(window.hohApplyFilters,220);};
window.hohToggleSpotlight=function(){var el=document.querySelector('.hoh-spotlight');if(!el)return;el.classList.toggle('hoh-open');};
/* R183: the Win a Free Portrait box (now the first item in #hoh-three-doors) is
   collapsible. Toggle hoh-open and sync aria-expanded.
   R663 (Jan): it starts CLOSED on every load. The saved choice is still written
   here, but NOTHING reads it back — R219 removed the load-time restore and R663
   kept that removal, so the landing state is the markup's and only the markup's.
   The key is kept so a future "remember my choice" has its history to read. */
window.hohToggleStaticSpotlight=function(){var el=document.getElementById('hoh-spotlight-static');if(!el)return;var open=el.classList.toggle('hoh-open');var bar=el.querySelector('.hoh-spotlight-bar');if(bar)bar.setAttribute('aria-expanded',open?'true':'false');try{localStorage.setItem('hoh-spotlight-collapsed',open?'0':'1');}catch(e){}if(open)hohSpotlightIntoView(el);};
/* SPOTLIGHT-FIT (Jan 2026-10-29: "when expanded i want it to at MOST fill the viewport but not make them scroll"):
   the open panel fits one screen (hall-of-heroes.css SPOTLIGHT-FIT), so opening it scrolls just far enough to show
   all of it, and never past its own top. The inner's scrollHeight is its open height while the rows still animate.
   A second look once the rows have opened measures the real height and catches anything that moved the page
   meanwhile (a late image above). */
function hohSpotlightIntoView(el,again){try{var inner=el.querySelector('.hoh-spotlight-inner'),bar=el.querySelector('.hoh-spotlight-bar');if(!inner||!bar)return;var r=el.getBoundingClientRect(),h=again?el.offsetHeight:bar.offsetHeight+inner.scrollHeight+56,over=r.top+h-(window.innerHeight-8);if(!again)setTimeout(function(){if(el.classList.contains('hoh-open'))hohSpotlightIntoView(el,true);},420);if(over<=0&&r.top>=0)return;var by=r.top<0?r.top-8:Math.min(over,r.top-8);if(Math.abs(by)<2)return;var still=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;window.scrollTo({top:window.scrollY+by,behavior:still?'auto':'smooth'});}catch(_){}}

/* ============================================================
 THE DM'S SATCHEL: hero cards + utility pills with lightbox tools
 Separate namespace from the Summon NPC d20 animation.
 ============================================================ */
var HOH_POUCH_SELECTED=20;
var HOH_POUCH_ADV='normal';
/* Roll modifier for the dice tool. Range -10 to +20 covers every real DnD
 situation without letting the user set absurd values. Reset on each open. */
var HOH_POUCH_MOD=0;
var HOH_LAST_SPARK_INDEX=-1;
window.hohAdjustMod=function(delta){
 HOH_POUCH_MOD=Math.max(-10,Math.min(20,HOH_POUCH_MOD+delta));
 var el=document.getElementById('hoh-dice-mod-value');
 if(el)el.textContent=(HOH_POUCH_MOD>=0?'+':'')+HOH_POUCH_MOD;
};
function hohFormatMod(){return(HOH_POUCH_MOD>=0?'+':'')+HOH_POUCH_MOD;}
/* Append "raw +/- mod = total." to a roll result string. Omits the math
 line entirely when the modifier is zero so casual rolls stay clean. */
function hohApplyMod(rawResult){
 if(!HOH_POUCH_MOD)return{total:rawResult,suffix:''};
 var total=rawResult+HOH_POUCH_MOD;
 var sign=HOH_POUCH_MOD>=0?' + '+HOH_POUCH_MOD:' \u2212 '+Math.abs(HOH_POUCH_MOD);
 return{total:total,suffix:sign+' = '+total};
}

window.hohTogglePouch=function(){
 var el=document.querySelector('.hoh-pouch');
 if(!el)return;
 /* R136-satchel-lock: never toggle open while locked — any entry
    point (the hint button on the cosmetic explain row, the bar
    itself, future programmatic openers) gets gated here. The bar's
    onclick routes locked clicks through hohSatchelBarClick → unlock
    flow before hohTogglePouch is reached. */
 if(el.classList.contains('hoh-pouch-locked')) return;
 el.classList.toggle('hoh-open');
};

/* R136-satchel-lock: Daily lock on the DM's Satchel.
   The pouch starts each day locked. The user spends 5 hearts to break
   the seal; after that the pouch behaves normally for the rest of the
   day. localStorage flag keyed by ISO date (YYYY-MM-DD) so the lock
   resets at midnight automatically.

   Click flow:
     - locked: hohSatchelBarClick → hohSatchelTryUnlock → spend hearts,
       fly animation, mark unlocked, transition class.
     - unlocked: hohSatchelBarClick → hohTogglePouch (existing).

   The bar renders with .hoh-pouch-locked by default in liquid; this
   init function removes the class on page load if today's unlock flag
   is already set (e.g., user reloads after unlocking). */
function hohSatchelTodayKey(){
 /* R179: one-time unlock instead of a daily reset. The flag is now a single
    permanent key, so once a user spends the 10 hearts the satchel stays open
    forever on that device. (Name kept for its callers; it is no longer daily.) */
 return 'hoh-dm-satchel-unlocked';
}
window.hohIsSatchelUnlockedToday = function(){
 try { return localStorage.getItem(hohSatchelTodayKey()) === '1'; } catch(_){ return false; }
};
window.hohMarkSatchelUnlockedToday = function(){
 try { localStorage.setItem(hohSatchelTodayKey(), '1'); } catch(_){}
};
function hohSatchelInitLockState(){
 var el = document.querySelector('.hoh-pouch');
 if(!el) return;
 if(window.hohIsSatchelUnlockedToday && window.hohIsSatchelUnlockedToday()){
  el.classList.remove('hoh-pouch-locked');
 }
}
/* Run init after DOM is ready. Defensive: try immediately + on
   DOMContentLoaded so we cover both early-defer and late-defer
   loading paths. */
if(document.readyState === 'loading'){
 document.addEventListener('DOMContentLoaded', hohSatchelInitLockState);
} else {
 hohSatchelInitLockState();
}

window.hohSatchelBarClick = function(e){
 var el = document.querySelector('.hoh-pouch');
 if(!el) return;
 if(el.classList.contains('hoh-pouch-locked')){
  if(e && typeof e.stopPropagation === 'function') e.stopPropagation();
  hohSatchelTryUnlock(el);
  return;
 }
 /* Already unlocked → behave like before. */
 window.hohTogglePouch();
};

/* Hearts spent on a target (the satchel unlock, a share unlock) pop AT the
   target. Jan, 2026-09-27: nothing streams out of the wallet pill any more;
   the live Hall hides that pill, so the volley started in the top-left
   corner. The name stays for its callers. */
function hohFlyHeartsFromPillToTarget(targetEl, n){
 if(!targetEl || !n || typeof window.hohHeartBurst !== 'function') return;
 window.hohHeartBurst(targetEl, { n: n });
}
window.hohFlyHeartsFromPillToTarget = hohFlyHeartsFromPillToTarget;

/* R148-Z10: Generic two-element fly helper. Same animation as the
   wallet-to-target variant above, but accepts BOTH source and target
   elements so callers can use it for any direction. Used by the
   page-completion reward (heart flies from the "Hearts to give here"
   pill BACK to the wallet) — the existing variant hardcoded the
   source as the wallet pill, which is the wrong direction here.
   R148-Z22c: Optional `opts.variant` parameter — pass 'xp' to render
   BLUE hearts (used for the Your-Hall XP stream so the visual
   distinguishes from heart-giving). */
function hohFlyHeartsBetween(srcEl, dstEl, n, opts){
 if(!srcEl || !dstEl || !n) return;
 var sr = srcEl.getBoundingClientRect();
 var tr = dstEl.getBoundingClientRect();
 if(!sr.width || !tr.width) return;
 var variant = (opts && opts.variant) ? String(opts.variant) : '';
 var extraClass = (variant === 'xp') ? ' hoh-pouch-fly-heart-xp' : '';
 var startX = sr.left + sr.width / 2;
 var startY = sr.top + sr.height / 2;
 var endX = tr.left + tr.width / 2;
 var endY = tr.top + tr.height / 2;
 for(var i = 0; i < n; i++){
  (function(idx){
   setTimeout(function(){
    var heart = document.createElement('div');
    heart.className = 'hoh-fresh-quiz-fly-heart hoh-pouch-fly-heart' + extraClass;
    heart.innerHTML = '&#9829;&#xFE0E;';
    var jitterX = (Math.random() * 22 - 11);
    var jitterY = (Math.random() * 14 - 7);
    heart.style.left = (startX + jitterX) + 'px';
    heart.style.top = (startY + jitterY) + 'px';
    heart.style.transform = 'translate(-50%, -50%) scale(0.55)';
    heart.style.opacity = '0';
    document.body.appendChild(heart);
    var dx = endX - (startX + jitterX);
    var dy = endY - (startY + jitterY);
    requestAnimationFrame(function(){
     heart.style.transition = 'opacity 0.18s ease-out, transform 0.22s cubic-bezier(0.2, 0.8, 0.2, 1)';
     heart.style.opacity = '1';
     heart.style.transform = 'translate(-50%, -50%) scale(1)';
    });
    setTimeout(function(){
     heart.style.transition = 'opacity 0.55s ease-in, transform 0.85s cubic-bezier(0.55, 0.05, 0.5, 1)';
     heart.style.transform = 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(0.65)';
     heart.style.opacity = '0';
    }, 220);
    setTimeout(function(){ if(heart.parentNode) heart.parentNode.removeChild(heart); }, 1300);
   }, idx * 95);
  })(i);
 }
}
window.hohFlyHeartsBetween = hohFlyHeartsBetween;

function hohSatchelTryUnlock(el){
 if(el.classList.contains('hoh-pouch-unlocking')) return;
 /* R136-satchel-cost: 5 → 10 → 150 (R226). The unlock is permanent (a one-off key), so this
    is a meaningful one-time investment, not a daily fee. The displayed cost in the lock pill
    (liquid) and the locked subtitle copy must stay in sync with this number. */
 var COST = 150;
 /* Heart-bank check. The host page's heartsRemainingToday is the
    canonical wallet read; fall back to direct localStorage if it's
    not exposed (defensive). */
 var bank = 0;
 try {
  if(typeof window.heartsRemainingToday === 'function') bank = window.heartsRemainingToday();
  else bank = parseInt(localStorage.getItem('hoh-heart-bank-v1') || '0', 10) || 0;
 } catch(_){}
 if(bank < COST){
  /* Soft fail: shake the lock pill + toast. No hearts spent. */
  el.classList.add('hoh-pouch-lock-deny');
  setTimeout(function(){ el.classList.remove('hoh-pouch-lock-deny'); }, 600);
  try {
   if(typeof window.hohShowHeartToast === 'function'){
    window.hohShowHeartToast('Need 150 hearts', 'Explore the Hall to earn more.');
   }
  } catch(_){}
  return;
 }
 el.classList.add('hoh-pouch-unlocking');
 /* Direct ledger spend — same channel the dice-trader uses so the
    chip + section sync via the hoh:hearts-bumped event. */
 try {
  var raw = parseInt(localStorage.getItem('hoh-heart-bank-v1') || '0', 10) || 0;
  var next = Math.max(0, raw - COST);
  try { window.hohHeartHint && window.hohHeartHint('spend_pouch_unlock'); }catch(_){}
  localStorage.setItem('hoh-heart-bank-v1', String(next));
  try { document.dispatchEvent(new CustomEvent('hoh:hearts-bumped', { detail: { spent: COST } })); } catch(_){}
 } catch(_){}
 if(typeof window.hohRenderHeaderCounter === 'function'){
  try { window.hohRenderHeaderCounter(); } catch(_){}
 }
 /* R226: fly a small capped burst of hearts (not all 150) from the wallet pill toward the
    lock pill (or the bar icon if the lock pill is offscreen). */
 var target = el.querySelector('.hoh-pouch-lock-pill') || el.querySelector('.hoh-pouch-bar-icon') || el;
 try { hohFlyHeartsFromPillToTarget(target, Math.min(COST, 12)); } catch(_){}
 /* After the fly animation crests, swap to unlocked state. The
    sequence is intentional: hearts arrive (~0.85s), satchel pulses
    + lock dissolves, subtitle crossfades to the unlocked copy. */
 setTimeout(function(){
  el.classList.add('hoh-pouch-just-unlocked');
  el.classList.remove('hoh-pouch-locked');
  try {
   if(window.hohMarkSatchelUnlockedToday) window.hohMarkSatchelUnlockedToday();
  } catch(_){}
  setTimeout(function(){
   el.classList.remove('hoh-pouch-unlocking', 'hoh-pouch-just-unlocked');
  }, 1200);
 }, 800);
}
window.hohSatchelTryUnlock = hohSatchelTryUnlock;

/* R136-doors: Outer Three Doors collapse toggle. The section starts
   collapsed via the .is-collapsed class set in the liquid template;
   clicking the bar removes it and updates aria-expanded for a11y.
   The inner accordions (Your Hall tab, Spotlight, Pouch) keep their
   own toggle state and stay collapsed by default — opening the outer
   panel does NOT auto-open any of the three doors. */
window.hohToggleThreeDoors = function(e){
 if(e && typeof e.stopPropagation === 'function') e.stopPropagation();
 /* Keyboard support: when the head (role=button) is focused and the
    user presses Enter or Space, toggle. Other keys fall through. */
 if(e && e.type === 'keydown'){
   if(e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
   if(typeof e.preventDefault === 'function') e.preventDefault();
 }
 var section = document.getElementById('hoh-three-doors');
 var bar = document.getElementById('hoh-three-doors-bar');
 var body = document.getElementById('hoh-three-doors-body');
 if(!section) return;
 /* R140-T: Animate to / from the body's MEASURED scrollHeight instead of
    the previous fixed max-height:2400px transition. The old approach
    eased uniformly across 2400px, but the actual content height is
    closer to ~600-1200px — so the visible portion of the animation
    finished in a fraction of the duration and felt fast and clunky to
    the user. Measuring the real content lets the bezier ease over the
    actual visible distance, producing a smooth drawer-like reveal at
    every content size. After the open transition completes we clear
    the inline max-height so inner accordions (Spotlight, Pouch) can
    grow without bumping into a hard cap. Falls back to the CSS-only
    behavior if the body element can't be resolved. */
 var willCollapse = !section.classList.contains('is-collapsed');
 if(body && body.style){
   if(willCollapse){
     /* Collapsing: pin to current rendered height first so the
        transition has a non-auto starting frame, then drop to 0. */
     var currentH = body.scrollHeight;
     body.style.maxHeight = currentH + 'px';
     /* Force layout so the browser commits the starting frame before
        the class flip swaps in the collapsed transition. */
     void body.offsetWidth;
     section.classList.add('is-collapsed');
     /* Defer the 0px set by one rAF so the transition fires from the
        explicit current-height starting point rather than the auto/
        2400px implicit one. */
     requestAnimationFrame(function(){
       body.style.maxHeight = '0px';
     });
   } else {
     /* Expanding: remove the collapsed class first so the body's
        natural scrollHeight reflects the actual content, then pin
        max-height to that measured value. */
     section.classList.remove('is-collapsed');
     /* Reset any prior inline max-height so scrollHeight reads true. */
     body.style.maxHeight = '';
     /* Read the natural height. */
     var targetH = body.scrollHeight;
     /* Set max-height to 0 first so the transition starts from
        collapsed, then in the next frame raise to the measured
        height. Without the 0 starting point the transition would
        try to ease from "auto" which browsers can't animate. */
     body.style.maxHeight = '0px';
     void body.offsetWidth;
     requestAnimationFrame(function(){
       body.style.maxHeight = targetH + 'px';
     });
     /* After the open transition completes, clear the inline
        max-height so nested accordions can grow naturally. The
        timeout matches the CSS transition duration (0.62s) plus a
        small buffer for the easing tail. */
     setTimeout(function(){
       /* Defensive: only clear if we're still expanded (user might
          have collapsed mid-transition). */
       if(!section.classList.contains('is-collapsed')){
         body.style.maxHeight = '';
       }
     }, 720);
   }
 } else {
   /* No body element — fall back to the simple class toggle. */
   section.classList.toggle('is-collapsed');
 }
 if(bar) bar.setAttribute('aria-expanded', willCollapse ? 'false' : 'true');
};
/* Wire keydown on the head element so Enter/Space toggles when it's
   focused. Click is already handled by onclick in the markup. */
document.addEventListener('keydown', function(e){
 var t = e.target;
 if(!t || !t.classList) return;
 if(t.classList.contains('hoh-features-head')){
   window.hohToggleThreeDoors(e);
 }
});

function hohPouchSecureRoll(sides){
 if(window.crypto&&window.crypto.getRandomValues){
 var arr=new Uint32Array(1);
 var max=Math.floor(0xFFFFFFFF/sides)*sides;
 do{window.crypto.getRandomValues(arr);}while(arr[0]>=max);
 return(arr[0]%sides)+1;
 }
 return Math.floor(Math.random()*sides)+1;
}

function hohDieShapeSvg(sides){
 var base='<svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">';
 /* Gradient stops bind to CSS vars set by .hoh-dice-c-{color}. */
 var grad='<defs><linearGradient id="hohPouchDieGrad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:var(--hoh-dice-grad1,#c4a8e8);stop-opacity:0.95"/><stop offset="100%" style="stop-color:var(--hoh-dice-grad2,#6d4fa8);stop-opacity:0.95"/></linearGradient><linearGradient id="hohPouchDieInner" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#2a1f3a"/><stop offset="100%" stop-color="#120a1f"/></linearGradient></defs>';
 var shape='';
 if(sides===4){
 shape=
  '<polygon points="80,18 142,134 18,134" fill="url(#hohPouchDieGrad)" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>'+
  '<line x1="80" y1="18" x2="80" y2="95" stroke="currentColor" stroke-width="1.2" stroke-opacity="0.45"/>'+
  '<line x1="18" y1="134" x2="80" y2="95" stroke="currentColor" stroke-width="1.2" stroke-opacity="0.45"/>'+
  '<line x1="142" y1="134" x2="80" y2="95" stroke="currentColor" stroke-width="1.2" stroke-opacity="0.45"/>';
 }else if(sides===6){
 shape=
  '<rect x="22" y="22" width="116" height="116" rx="14" fill="url(#hohPouchDieGrad)" stroke="currentColor" stroke-width="2"/>'+
  '<rect x="38" y="38" width="84" height="84" rx="8" fill="url(#hohPouchDieInner)" stroke="currentColor" stroke-width="1" stroke-opacity="0.5"/>';
 }else if(sides===8){
 shape=
  '<polygon points="80,12 148,80 80,148 12,80" fill="url(#hohPouchDieGrad)" stroke="currentColor" stroke-width="2"/>'+
  '<line x1="12" y1="80" x2="148" y2="80" stroke="currentColor" stroke-width="1" stroke-opacity="0.5"/>'+
  '<polygon points="80,12 80,148 148,80" fill="url(#hohPouchDieInner)" fill-opacity="0.3" stroke="currentColor" stroke-width="0.8" stroke-opacity="0.4"/>';
 }else if(sides===10){
 shape=
  '<polygon points="80,10 140,50 130,110 80,150 30,110 20,50" fill="url(#hohPouchDieGrad)" stroke="currentColor" stroke-width="2"/>'+
  '<line x1="80" y1="10" x2="80" y2="150" stroke="currentColor" stroke-width="1" stroke-opacity="0.4"/>'+
  '<line x1="20" y1="50" x2="140" y2="50" stroke="currentColor" stroke-width="1" stroke-opacity="0.4"/>'+
  '<line x1="30" y1="110" x2="130" y2="110" stroke="currentColor" stroke-width="1" stroke-opacity="0.4"/>';
 }else if(sides===12){
 shape=
  '<polygon points="80,12 148,60 120,142 40,142 12,60" fill="url(#hohPouchDieGrad)" stroke="currentColor" stroke-width="2"/>'+
  '<polygon points="80,40 124,72 108,122 52,122 36,72" fill="url(#hohPouchDieInner)" stroke="currentColor" stroke-width="1" stroke-opacity="0.5"/>';
 }else if(sides===20){
 shape=
  '<polygon points="80,8 146,44 146,116 80,152 14,116 14,44" fill="url(#hohPouchDieGrad)" stroke="currentColor" stroke-width="2"/>'+
  '<polygon points="80,28 126,52 126,108 80,132 34,108 34,52" fill="url(#hohPouchDieInner)" stroke="currentColor" stroke-width="1" stroke-opacity="0.5"/>'+
  '<line x1="80" y1="8" x2="80" y2="28" stroke="currentColor" stroke-width="0.8" stroke-opacity="0.4"/>'+
  '<line x1="146" y1="44" x2="126" y2="52" stroke="currentColor" stroke-width="0.8" stroke-opacity="0.4"/>'+
  '<line x1="146" y1="116" x2="126" y2="108" stroke="currentColor" stroke-width="0.8" stroke-opacity="0.4"/>'+
  '<line x1="80" y1="152" x2="80" y2="132" stroke="currentColor" stroke-width="0.8" stroke-opacity="0.4"/>'+
  '<line x1="14" y1="116" x2="34" y2="108" stroke="currentColor" stroke-width="0.8" stroke-opacity="0.4"/>'+
  '<line x1="14" y1="44" x2="34" y2="52" stroke="currentColor" stroke-width="0.8" stroke-opacity="0.4"/>';
 }else if(sides===100){
 shape=
  '<g transform="translate(-18,0)"><polygon points="80,18 130,52 122,110 80,140 38,110 30,52" fill="url(#hohPouchDieGrad)" stroke="currentColor" stroke-width="2"/></g>'+
  '<g transform="translate(18,0)"><polygon points="80,18 130,52 122,110 80,140 38,110 30,52" fill="url(#hohPouchDieGrad)" stroke="currentColor" stroke-width="2"/></g>';
 }
 return base+grad+shape+'</svg>';
}

function hohPouchLabelFor(sides){return'd'+sides;}

window.hohOpenDiceTool=function(){
 HOH_POUCH_SELECTED=20;
 HOH_POUCH_ADV='normal';
 HOH_POUCH_MOD=0;
 hohSelectDie(20,true);
 var advButtons=document.querySelectorAll('.hoh-dice-adv-btn');
 advButtons.forEach(function(b){b.classList.remove('hoh-adv-active');});
 var normalBtn=document.querySelector('.hoh-dice-adv-btn[data-mode="normal"]');
 if(normalBtn)normalBtn.classList.add('hoh-adv-active');
 var modEl=document.getElementById('hoh-dice-mod-value');
 if(modEl)modEl.textContent='+0';
 document.getElementById('hoh-dice-modal').style.display='flex';
 document.body.style.overflow='hidden';
 /* Restore the user's saved dice color choice on every open. */
 hohSetDiceColor(hohGetDiceColor());
 /* Reset the themed quote to a neutral default each open so a fresh
  session does not start mid-rotation on a leftover line. */
 hohResetQuote();
};
window.hohCloseDiceTool=function(){
 document.getElementById('hoh-dice-modal').style.display='none';
 document.body.style.overflow='';
};

window.hohSelectDie=function(sides,silent){
 HOH_POUCH_SELECTED=sides;
 var picks=document.querySelectorAll('.hoh-dice-pick');
 picks.forEach(function(b){b.classList.remove('hoh-dice-pick-active');});
 var active=document.querySelector('.hoh-dice-pick[data-sides="'+sides+'"]');
 if(active)active.classList.add('hoh-dice-pick-active');

 var shape=document.getElementById('hoh-dice-shape');
 if(shape){
 shape.classList.remove('hoh-rolling','hoh-landed');
 shape.innerHTML=hohDieShapeSvg(sides);
 }
 var num=document.getElementById('hoh-dice-number');
 if(num){num.classList.remove('hoh-visible','hoh-nat20','hoh-nat1');num.textContent='';}
 var detail=document.getElementById('hoh-dice-detail');
 if(detail)detail.innerHTML=silent?'Tap Roll when ready':'';

 var advWrap=document.getElementById('hoh-dice-adv');
 if(advWrap)advWrap.style.display=sides===20?'flex':'none';
};

window.hohSetAdvMode=function(mode,btn){
 HOH_POUCH_ADV=mode;
 var buttons=document.querySelectorAll('.hoh-dice-adv-btn');
 buttons.forEach(function(b){b.classList.remove('hoh-adv-active');});
 if(btn)btn.classList.add('hoh-adv-active');
};

/* Anti-spam guard. Set true at roll start, cleared when the result reveal
 finishes. The roll button reads this flag and refuses to fire until the
 current roll lands. */
window.HOH_POUCH_ROLLING=false;
function hohSetRollLock(locked){
 window.HOH_POUCH_ROLLING=!!locked;
 var btn=document.querySelector('.hoh-pouch-roll-btn');
 if(btn){btn.disabled=!!locked;btn.classList.toggle('hoh-rolling-busy',!!locked);}
}
/* First-roll-of-day grant. d4/d6/d8 award the natural value. d10+
 award ceil(natural/2) so the bigger dice cap at 5/6/10 instead of
 the full face value. d100 stays floor(natural/10) (max 10).
 Advantage/disadvantage also consume the d20's first-roll.
 Rainbow glow + heart fly. */
function hohClaimDiceFirstRoll(sides,natural){
 if(hohDiceMaxClaimedToday(sides))return 0;
 var hearts=(sides===100)?Math.floor(natural/10):(sides>=10?Math.ceil(natural/2):natural);
 if(hearts<=0)return 0;
 hohMarkDiceMaxClaimed(sides);
 hohAddDiceBonus(hearts);
 /* Also push to the spendable bank so the visible counter ticks
  up immediately. Without this, dice rewards only count toward
  the cap and the user sees no change in their wallet. */
 if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(hearts);
 hohUpdateHeartCounter();
 var stage=document.querySelector('.hoh-dice-stage');
 if(stage){stage.classList.add('hoh-dice-stage-rainbow');setTimeout(function(){stage.classList.remove('hoh-dice-stage-rainbow');},2400);}
 setTimeout(function(){
 hohFlyHeartsToPill(stage||document.getElementById('hoh-dice-shape'),hearts,sides);
 setTimeout(function(){
  if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(hearts,true);
  if(typeof hohShowHeartToast==='function'){
  var t='First roll today';
  var s='Your first d'+sides+' roll of the day.';
  if(sides===100&&natural===100){t='Centurion';s='A perfect d100 roll.';}
  /* the first-roll toast was an earn toast (quiet in the live Hall); Centurion always showed */
  hohShowHeartToast(t,s,t!=='Centurion');
  }
 },140+Math.min(hearts,12)*60);
 },220);
 if(sides===100&&natural===100){
 try{
  if(typeof confetti==='function'){
  var rect=stage?stage.getBoundingClientRect():null;
  var ox=rect?(rect.left+rect.width/2)/window.innerWidth:0.5;
  var oy=rect?(rect.top+rect.height/2)/window.innerHeight:0.4;
  confetti({particleCount:140,spread:90,startVelocity:50,gravity:0.4,ticks:240,origin:{x:ox,y:oy},colors:['#ffd966','#c8a45e','#ED97FE','#a4d8ff','#7ed49a','#ff8c66'],zIndex:999999});
  }
 }catch(e){}
 }
 return hearts;
}

/* Hearts found at the dice (or any element) pop right there. Jan,
 2026-09-27: they used to fly to the wallet pill, which the live Hall
 hides (display:none measures 0,0), so they landed in the top-left
 corner. sidesContext (the die) stays for its callers. */
function hohFlyHeartsToPill(fromEl,count,sidesContext){
 if(!fromEl||!count||typeof window.hohHeartBurst!=='function')return;
 window.hohHeartBurst(fromEl,{n:count});
}

/* Themed quote rotation. The subtitle under the dice title shifts per
 roll based on the result band so the flavor commentary tracks what
 just happened. Pools rotate in order so a player rolling a streak
 sees variety, not the same line over and over. */
var HOH_DICE_QUOTES={
 default:[
 'Let fate rest on the edge of a die.',
 'The dice are watching.',
 'Roll first. Justify later.',
 'Initiative, then conscience.'
 ],
 nat1:[
 'Critical fumble. The bard adds it to the setlist.',
 'Even the goblin is pity-laughing.',
 'Your foot is in the bucket.',
 'The DM is writing this down.',
 'The weapon flies into the next room.'
 ],
 low:[
 'The DM goes quiet. That is worse.',
 'A roll only the bard could love.',
 'Within the realm of possibility. Just.',
 'Mid Charisma energy.',
 'A noble effort, doomed by gravity.'
 ],
 mid:[
 'Functional. Mostly.',
 'Roll with it.',
 'Nothing happens. That is fine.',
 'The DM allows it. Reluctantly.',
 'Adequate, in the loosest sense.'
 ],
 high:[
 'The party visibly relaxes.',
 'DM sighs. Updates the notes.',
 'Your god is paying attention.',
 'Roleplay reward incoming.',
 'The barbarian is impressed.'
 ],
 natmax:[
 'Maximum rolled. The DM eyes you.',
 'All faces, accounted for.',
 'Oddly perfect.',
 'The dice have decided in your favor.'
 ],
 nat20:[
 'Twenty. Inspiration restored.',
 'Every NPC nearby starts taking notes.',
 'Critical hit. The DM writes "fine."',
 'The barbarian weeps with joy.'
 ],
 nat100:[
 'Centurion. The dice gods bow.',
 'One in a hundred. The bard composes a ballad.',
 'Perfect roll. The kingdom shifts.',
 'The fates are in good humor today.'
 ]
};
var HOH_QUOTE_INDEX={};
function hohQuoteCategory(sides,natural){
 if(natural===1)return'nat1';
 if(sides===20&&natural===20)return'nat20';
 if(sides===100&&natural===100)return'nat100';
 if(natural===sides)return'natmax';
 var ratio=natural/sides;
 if(ratio<=0.33)return'low';
 if(ratio>=0.75)return'high';
 return'mid';
}
function hohRotateQuote(sides,natural){
 var cat=hohQuoteCategory(sides,natural);
 var pool=HOH_DICE_QUOTES[cat]||HOH_DICE_QUOTES.default;
 var idx=(HOH_QUOTE_INDEX[cat]||0)%pool.length;
 HOH_QUOTE_INDEX[cat]=idx+1;
 var el=document.querySelector('#hoh-dice-modal .hoh-pouch-modal-subtext');
 if(!el)return;
 el.classList.remove('hoh-dice-quote-in');
 el.classList.add('hoh-dice-quote-out');
 setTimeout(function(){
 el.textContent=pool[idx];
 el.classList.remove('hoh-dice-quote-out');
 el.classList.add('hoh-dice-quote-in');
 },180);
}
function hohResetQuote(){
 var el=document.querySelector('#hoh-dice-modal .hoh-pouch-modal-subtext');
 if(!el)return;
 el.textContent=HOH_DICE_QUOTES.default[0];
 el.classList.remove('hoh-dice-quote-in','hoh-dice-quote-out');
}

window.hohRollSelected=function(){
 if(window.HOH_POUCH_ROLLING)return;
 hohSetRollLock(true);
 var sides=HOH_POUCH_SELECTED;
 var shape=document.getElementById('hoh-dice-shape');
 var num=document.getElementById('hoh-dice-number');
 var detail=document.getElementById('hoh-dice-detail');
 if(!shape||!num||!detail){hohSetRollLock(false);return;}

 var isAdvDis=(sides===20&&HOH_POUCH_ADV!=='normal');

 if(isAdvDis){
 var rollA=hohPouchSecureRoll(20);
 var rollB=hohPouchSecureRoll(20);
 var keptValue,droppedValue,keptSide;
 if(HOH_POUCH_ADV==='advantage'){
  if(rollA>=rollB){keptValue=rollA;droppedValue=rollB;keptSide='a';}
  else{keptValue=rollB;droppedValue=rollA;keptSide='b';}
 }else{
  if(rollA<=rollB){keptValue=rollA;droppedValue=rollB;keptSide='a';}
  else{keptValue=rollB;droppedValue=rollA;keptSide='b';}
 }
 var extraClass='';
 if(keptValue===20)extraClass=' hoh-nat20';
 else if(keptValue===1)extraClass=' hoh-nat1';

 shape.classList.remove('hoh-rolling','hoh-landed');
 num.classList.remove('hoh-visible','hoh-nat20','hoh-nat1');
 num.textContent='';
 shape.innerHTML=
  '<div class="hoh-dice-pair">'+
  '<div class="hoh-dice-single" id="hoh-dice-single-a">'+hohDieShapeSvg(20)+
   '<div class="hoh-dice-single-num" id="hoh-dice-num-a"></div>'+
  '</div>'+
  '<div class="hoh-dice-single" id="hoh-dice-single-b">'+hohDieShapeSvg(20)+
   '<div class="hoh-dice-single-num" id="hoh-dice-num-b"></div>'+
  '</div>'+
  '</div>';
 detail.innerHTML='';

 var sA=document.getElementById('hoh-dice-single-a');
 var sB=document.getElementById('hoh-dice-single-b');
 var nA=document.getElementById('hoh-dice-num-a');
 var nB=document.getElementById('hoh-dice-num-b');

 void shape.offsetWidth;
 if(sA)sA.classList.add('hoh-rolling');
 if(sB)sB.classList.add('hoh-rolling-alt');

 setTimeout(function(){
  if(sA)sA.classList.remove('hoh-rolling');
  if(sB)sB.classList.remove('hoh-rolling-alt');

  if(nA){nA.textContent=rollA;nA.className='hoh-dice-single-num hoh-visible';}
  if(nB){nB.textContent=rollB;nB.className='hoh-dice-single-num hoh-visible';}

  var keptDieEl=null;
  if(keptSide==='a'){
  if(sA){sA.classList.add('hoh-kept');keptDieEl=sA;}
  if(sB)sB.classList.add('hoh-dropped');
  if(nA&&extraClass)nA.classList.add(extraClass.trim());
  }else{
  if(sB){sB.classList.add('hoh-kept');keptDieEl=sB;}
  if(sA)sA.classList.add('hoh-dropped');
  if(nB&&extraClass)nB.classList.add(extraClass.trim());
  }
  /* Apply nat styling to the kept die itself so the shimmer/shake hits the
   right hexagon. */
  if(extraClass==' hoh-nat20'&&keptDieEl)keptDieEl.classList.add('hoh-nat20');
  if(extraClass==' hoh-nat1'&&keptDieEl)keptDieEl.classList.add('hoh-nat1');

  var modeLabel=HOH_POUCH_ADV==='advantage'?'with advantage':'with disadvantage';
  var mAdv=hohApplyMod(keptValue);
  detail.innerHTML='d20 '+modeLabel+'. Result: '+keptValue+mAdv.suffix+'.';
  if(keptValue===20)hohDiceNat20Effects();
  /* Daily max bonus check on the kept value (modifier excluded). */
  hohClaimDiceFirstRoll(20,keptValue);
  /* Themed quote shifts with the result band. */
  hohRotateQuote(20,keptValue);
  hohSetRollLock(false);
 },900);
 return;
 }

 var rollOne=hohPouchSecureRoll(sides);
 var main=rollOne;
 var extraClass='';
 if(sides===20&&main===20)extraClass=' hoh-nat20';
 else if(sides===20&&main===1)extraClass=' hoh-nat1';

 shape.classList.remove('hoh-rolling','hoh-landed','hoh-nat20','hoh-nat1');
 shape.innerHTML=hohDieShapeSvg(sides);
 num.classList.remove('hoh-visible','hoh-nat20','hoh-nat1');
 num.textContent='';
 detail.innerHTML='';
 void shape.offsetWidth;
 shape.classList.add('hoh-rolling');

 setTimeout(function(){
 shape.classList.remove('hoh-rolling');
 shape.classList.add('hoh-landed');
 if(sides===20&&main===20)shape.classList.add('hoh-nat20');
 else if(sides===20&&main===1)shape.classList.add('hoh-nat1');
 num.textContent=main;
 num.className='hoh-dice-number hoh-visible'+extraClass;
 var m=hohApplyMod(main);
 /* Keep the concise label when there is no modifier. With a modifier, show
  the explicit math so players see the total they are hitting. */
 if(HOH_POUCH_MOD){detail.innerHTML=hohPouchLabelFor(sides)+'. Result: '+main+m.suffix+'.';}
 else{detail.innerHTML=hohPouchLabelFor(sides);}
 /* Nat effects. Confetti for 20, nothing special for 1 beyond the shake and
  red flash added by CSS (via the hoh-nat1 class). */
 if(sides===20&&main===20)hohDiceNat20Effects();
 /* Daily max bonus on the natural roll (excludes modifier). Handles
  d4-d100 with d100=100 firing extra confetti + 10-heart grant. */
 hohClaimDiceFirstRoll(sides,main);
 /* Themed quote shifts with the result band. */
 hohRotateQuote(sides,main);
 hohSetRollLock(false);
 },900);
};

/* Fire a short rainbow confetti burst when the user lands a natural 20.
 Uses the confetti library already loaded on the page. Silent fallback if
 the library is not yet loaded. */
function hohDiceNat20Effects(){
 try{
 if(typeof confetti!=='function')return;
 var stage=document.querySelector('.hoh-dice-stage');
 var rect=stage?stage.getBoundingClientRect():null;
 var originX=0.5,originY=0.4;
 if(rect){
  originX=(rect.left+rect.width/2)/window.innerWidth;
  originY=(rect.top+rect.height/2)/window.innerHeight;
 }
 confetti({particleCount:80,spread:75,startVelocity:45,gravity:0.55,ticks:200,origin:{x:originX,y:originY},colors:['#ff6b6b','#feca57','#48dbfb','#ff9ff3','#1dd1a1','#ffd966'],zIndex:999999});
 }catch(e){}
}

/* ============ THE TRIAL: COIN UNLOCK ============
 Three consecutive heads on the coin flip reveals the hidden Trial entry.
 Counter lives in sessionStorage so a refresh clears it but reopening the coin
 modal does not. If the Trial was already unlocked today, the pill stays
 visible immediately when the coin modal opens. */
var HOH_TRIAL_UNLOCK_KEY_PREFIX='hoh-trial-unlocked-';
function hohTrialUnlockedToday(){try{return localStorage.getItem(HOH_TRIAL_UNLOCK_KEY_PREFIX+hohTodayStr())==='1';}catch(e){return false;}}
function hohSetTrialUnlockedToday(){try{localStorage.setItem(HOH_TRIAL_UNLOCK_KEY_PREFIX+hohTodayStr(),'1');}catch(e){}}

function hohGetCoinHeadsStreak(){try{return parseInt(sessionStorage.getItem('hoh-coin-heads-streak'))||0;}catch(e){return 0;}}
function hohSetCoinHeadsStreak(n){try{sessionStorage.setItem('hoh-coin-heads-streak',String(n));}catch(e){}}

/* Dynamic coin subtitle. One element at the top of the modal rotates through
 phrases that reflect the current streak state. The hint text used to live
 in a separate element below the coin. It now lives in place of the intro
 subtitle so the flavor text and the reactive text are the same line. */
var HOH_COIN_PHRASES={
 initial:[
 'Sometimes when things align, a door opens.',
 'Edges remember what faces forget.',
 'The coin is old. It remembers.',
 'Three in a row matters.',
 'Three agreements and the coin listens.'
 ],
 heads1:['hm?','curious.','a pause.','the coin tilts.','noted.'],
 heads2:['something interesting is happening.','the coin warms.','a pattern is shaping.','fate leans in.','you have its attention now.'],
 heads3:['The coin listens.'],
 /* Two tails pools based on what streak just broke. Breaking a two-streak
  cuts deep, so that pool carries "oof, so close." and friends. Breaking a
  single-streak gets low-stakes shrugs since there was nothing at stake. */
 tailsBreak1:['meh.','a miss.','nothing.','and so.','try again.','a soft landing.','unremarkable.'],
 tailsBreak2:['oof, so close.','so close it almost hurt.','the pattern breaks.','the door stays shut.','fate looked the other way.','a cruel break.','close, but no.']
};
var HOH_COIN_LAST_PHRASE='';
function hohPickPhrase(pool){
 if(!pool||!pool.length)return'';
 if(pool.length===1)return pool[0];
 /* Avoid showing the same phrase twice in a row. */
 var pick;
 var tries=0;
 do{pick=pool[Math.floor(Math.random()*pool.length)];tries++;}
 while(pick===HOH_COIN_LAST_PHRASE&&tries<6);
 HOH_COIN_LAST_PHRASE=pick;
 return pick;
}
function hohSetCoinSubtitle(state){
 var el=document.getElementById('hoh-coin-subtitle');
 if(!el)return;
 var pool=HOH_COIN_PHRASES[state]||HOH_COIN_PHRASES.initial;
 var phrase=hohPickPhrase(pool);
 /* Guard against stacked timers from rapid flips. */
 if(window.hohCoinSubtitleTimer){clearTimeout(window.hohCoinSubtitleTimer);window.hohCoinSubtitleTimer=null;}
 el.classList.remove('hoh-coin-subtitle-heads1','hoh-coin-subtitle-heads2','hoh-coin-subtitle-heads3','hoh-coin-subtitle-tails');
 el.classList.add('hoh-coin-subtitle-fade');
 /* The CSS opacity transition runs 150ms. Give it 220ms of real time before
  swapping text so mobile browsers that lag on rAF never render both the
  old and new phrase at partial opacity in the same frame. */
 window.hohCoinSubtitleTimer=setTimeout(function(){
 window.hohCoinSubtitleTimer=null;
 el.textContent=phrase;
 var cls='';
 if(state==='heads1')cls='hoh-coin-subtitle-heads1';
 else if(state==='heads2')cls='hoh-coin-subtitle-heads2';
 else if(state==='heads3')cls='hoh-coin-subtitle-heads3';
 else if(state==='tailsBreak1'||state==='tailsBreak2')cls='hoh-coin-subtitle-tails';
 if(cls)el.classList.add(cls);
 /* Force a reflow so the browser registers opacity:0 before we transition
  back to 1. Without this, some mobile browsers skip the fade-in frame. */
 void el.offsetWidth;
 el.classList.remove('hoh-coin-subtitle-fade');
 },220);
}
function hohRevealTrialPill(){
 var wrap=document.getElementById('hoh-coin-trial-wrap');
 var pill=document.getElementById('hoh-coin-trial-pill');
 if(!wrap||!pill)return;
 wrap.style.display='flex';
 wrap.setAttribute('aria-hidden','false');
 // Trigger shimmer animation once.
 pill.classList.remove('hoh-coin-trial-pill-born');
 void pill.offsetWidth;
 pill.classList.add('hoh-coin-trial-pill-born');
}
function hohHideTrialPill(){
 var wrap=document.getElementById('hoh-coin-trial-wrap');
 var pill=document.getElementById('hoh-coin-trial-pill');
 if(wrap){wrap.style.display='none';wrap.setAttribute('aria-hidden','true');}
 if(pill){pill.classList.remove('hoh-coin-trial-pill-born');}
}

/* HERO20 (Jan, 2026-09-30): three heads in a row is a hidden achievement
   that reveals the HERO20 code, 20% off a portrait (an active Shopify code,
   checked 2026-10-01). Once found on this device, a small chip under the coin
   keeps the code one tap away, so nobody has to flip for it twice. */
var HOH_COIN_CODE='HERO20';
var HOH_COIN_CODE_KEY='hoh-coin-hero20-found';
function hohCoinCodeFound(){try{return localStorage.getItem(HOH_COIN_CODE_KEY)==='1';}catch(_){return false;}}
function hohSyncCoinCodeChip(){var b=document.getElementById('hoh-coin-code');if(b)b.hidden=!hohCoinCodeFound();}
function hohCopyCoinCode(btn){
 function done(){
  if(!btn)return;
  btn.classList.add('is-copied');
  var act=btn.querySelector('.hoh-coin-ach-code-act');if(act)act.textContent='Copied';
  btn.setAttribute('aria-label','Copied the code '+HOH_COIN_CODE);
 }
 function fallback(){
  try{
   var ta=document.createElement('textarea');ta.value=HOH_COIN_CODE;ta.setAttribute('readonly','');
   ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();
   document.execCommand('copy');document.body.removeChild(ta);done();
  }catch(_){}
 }
 try{
  if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(HOH_COIN_CODE).then(done,fallback);}
  else fallback();
 }catch(_){fallback();}
}
window.hohShowCoinAchievement=function(replay){
 try{localStorage.setItem(HOH_COIN_CODE_KEY,'1');}catch(_){}
 hohSyncCoinCodeChip();
 var old=document.getElementById('hoh-coin-ach-lightbox');
 if(old&&old.parentNode)old.parentNode.removeChild(old);
 var lb=document.createElement('div');
 lb.id='hoh-coin-ach-lightbox';
 lb.className='hoh-ff-ach-lightbox hoh-coin-ach';
 lb.setAttribute('role','dialog');
 lb.setAttribute('aria-modal','true');
 lb.setAttribute('aria-label',replay?'Your portrait code':'Hidden achievement unlocked');
 lb.innerHTML=
  '<div class="hoh-ff-ach-card">'+
   '<div class="hoh-ff-ach-eyebrow">'+(replay?'Hidden Achievement':'Hidden Achievement Unlocked')+'</div>'+
   '<div class="hoh-ff-ach-title">The Coin Listens</div>'+
   '<div class="hoh-ff-ach-sub">Three heads in a row. Take 20% off a portrait with Jan.</div>'+
   '<button type="button" class="hoh-coin-ach-code" data-coin-copy aria-label="Copy the code '+HOH_COIN_CODE+'">'+
    '<span class="hoh-coin-ach-code-text">'+HOH_COIN_CODE+'</span>'+
    '<span class="hoh-coin-ach-code-act">Copy</span>'+
   '</button>'+
   '<div class="hoh-coin-ach-note">Enter it at checkout.</div>'+
   '<button type="button" class="hoh-ff-ach-tap hoh-coin-ach-close" data-coin-close>Close</button>'+
  '</div>';
 function close(){
  document.removeEventListener('keydown',onKey,true);
  try{lb.classList.add('hoh-ff-ach-leaving');}catch(_){}
  setTimeout(function(){if(lb.parentNode)lb.parentNode.removeChild(lb);},260);
 }
 function onKey(e){if(e.key==='Escape'){e.stopPropagation();close();}}
 /* the code stays put until they choose to close it: only the backdrop and
    the Close button dismiss the card, so a tap on the code never loses it */
 lb.addEventListener('click',function(e){
  var t=e.target;
  var copy=t&&t.closest?t.closest('[data-coin-copy]'):null;
  if(copy){e.stopPropagation();hohCopyCoinCode(copy);return;}
  if(t===lb||(t&&t.closest&&t.closest('[data-coin-close]'))){e.stopPropagation();close();}
 });
 document.addEventListener('keydown',onKey,true);
 document.body.appendChild(lb);
 try{var c=lb.querySelector('[data-coin-copy]');if(c)c.focus({preventScroll:true});}catch(_){}
};
window.hohOpenCoinTool=function(){
 var coin=document.getElementById('hoh-coin');
 var out=document.getElementById('hoh-coin-result');
 window.hohCoinFlipping=false;
 hohSyncCoinCodeChip();
 if(coin){coin.classList.remove('hoh-coin-flipping','hoh-coin-heads-final','hoh-coin-tails-final','hoh-coin-shimmer');coin.style.removeProperty('--final-rot');}
 /* Seed the dynamic subtitle with a random initial phrase each open. */
 hohSetCoinSubtitle('initial');
 if(out){
 out.classList.remove('hoh-coin-heads-text','hoh-coin-tails-text');
 out.classList.add('hoh-coin-idle');
 out.textContent='Tap the coin or the button';
 }
 // Keep Trial pill visible if already unlocked today.
 if(hohTrialUnlockedToday()){hohRevealTrialPill();}else{hohHideTrialPill();}
 document.getElementById('hoh-coin-modal').style.display='flex';
 document.body.style.overflow='hidden';
};
window.hohCloseCoinTool=function(){
 document.getElementById('hoh-coin-modal').style.display='none';
 document.body.style.overflow='';
};
window.hohFlipCoin=function(){
 /* Spam guard against brute-forcing the unlock. */
 if(window.hohCoinFlipping)return;
 var coin=document.getElementById('hoh-coin');
 var out=document.getElementById('hoh-coin-result');
 if(!coin||!out)return;
 window.hohCoinFlipping=true;
 var isHeads=hohPouchSecureRoll(2)===1;
 var baseRotations=4+Math.floor(Math.random()*3);
 var finalRot=baseRotations*360+(isHeads?0:180);
 /* Restart the animation cleanly by dropping the class, forcing a reflow,
  setting the new final rotation, then re-adding the class. The animation
  uses fill-mode:forwards so the coin stays at its final rotation when it
  finishes. We do NOT swap in a heads-final/tails-final transform class
  afterwards because that was causing a second visible settle animation. */
 coin.classList.remove('hoh-coin-flipping','hoh-coin-heads-final','hoh-coin-tails-final','hoh-coin-shimmer');
 void coin.offsetWidth;
 coin.style.setProperty('--final-rot',finalRot+'deg');
 coin.classList.add('hoh-coin-flipping');
 out.classList.remove('hoh-coin-heads-text','hoh-coin-tails-text');
 out.classList.add('hoh-coin-idle');
 out.textContent='...';
 setTimeout(function(){
 /* Leave hoh-coin-flipping on the element so the forwards fill-mode keeps
  the coin parked at its final rotation. Only the result text updates. */
 out.classList.remove('hoh-coin-idle');
 out.classList.add(isHeads?'hoh-coin-heads-text':'hoh-coin-tails-text');
 out.textContent=isHeads?'Heads':'Tails';
 var streak=hohGetCoinHeadsStreak();
 var wasStreak=streak;
 if(isHeads){
  streak=Math.min(streak+1,3);
  hohSetCoinHeadsStreak(streak);
  if(streak===1)hohSetCoinSubtitle('heads1');
  else if(streak===2){coin.classList.add('hoh-coin-shimmer');hohSetCoinSubtitle('heads2');}
  else if(streak===3){
  coin.classList.add('hoh-coin-shimmer');
  hohSetCoinSubtitle('heads3');
  /* HERO20 (Jan, 2026-09-30): "after 3 heads show them a hidden 20% off
     code of HERO20 on a portrait, say hidden achievement unlocked". The
     streak landing on three opens the achievement card with confetti;
     more heads after that keep the streak at three and stay quiet. */
  if(wasStreak<3){
   try{
    if(typeof window.confetti==='function'){
     var rect=coin.getBoundingClientRect();
     window.confetti({
      particleCount:90,spread:80,startVelocity:38,
      origin:{
       x:(rect.left+rect.width/2)/window.innerWidth,
       y:(rect.top+rect.height/2)/window.innerHeight
      },
      colors:['#ed97fe','#f2d98e','#a4d8ff','#7ed49a','#fff5d8'],
      zIndex:999999
     });
    }
   }catch(_){}
   setTimeout(function(){ try{ hohShowCoinAchievement(); }catch(_){} },420);
  }
  /* The once-a-day heart flight stays as an effect; nothing names a count
     (Jan: "dont say they get +X hearts"). */
  try{
  var ck='hoh-coin-bonus-'+hohTodayStr();
  if(localStorage.getItem(ck)!=='1'){
   localStorage.setItem(ck,'1');
   if(typeof window.hohAddHeartsToBank==='function')window.hohAddHeartsToBank(30);
   hohUpdateHeartCounter();
   setTimeout(function(){
    /* Cap the visual heart-fly at 12 so the stagger doesn't drag
       on for 4 seconds. */
    if(typeof hohFlyHeartsToPill==='function')hohFlyHeartsToPill(coin,Math.min(30,12));
    if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(30,true);
   },240);
  }
  }catch(e){}
  }
 }else{
  hohSetCoinHeadsStreak(0);
  /* Pick a tails pool based on the streak that just broke. A streak of 2
   breaking gets the more painful pool. Streak of 0 going to tails just
   rotates to an initial phrase so the subtitle does not get repetitive. */
  if(wasStreak>=2)hohSetCoinSubtitle('tailsBreak2');
  else if(wasStreak===1)hohSetCoinSubtitle('tailsBreak1');
  else hohSetCoinSubtitle('initial');
 }
 /* Release the flip lockout quickly so repeat flips feel responsive but the
  user still cannot beat the animation. */
 setTimeout(function(){window.hohCoinFlipping=false;},120);
 },950);
};

/* === SCENE MODAL ===
 Procedural encounter generator. Pulls one real character from the Hall,
 combines with a random want and complication. Zero API cost. */

var HOH_SCENE_CURRENT={character:null,wantIdx:-1,compIdx:-1};
var HOH_SCENE_LAST_WHO_ID=null;
var HOH_SCENE_LAST_WANT=-1;
var HOH_SCENE_LAST_COMP=-1;
var HOH_SCENE_ROLLED=false;
var HOH_SCENE_ROLLING=false;
function hohSceneStartRoll(el,ghost){if(!el)return;el.setAttribute('data-ghost',ghost||'Rolling...');el.classList.add('hoh-scene-rolling');}
function hohSceneEndRoll(el){if(!el)return;el.classList.remove('hoh-scene-rolling');el.removeAttribute('data-ghost');}

/* Shared toggle state for the "Only my liked heroes" checkbox inside tool
 modals. Persists for the session so a user can flip it on once and have
 it apply across Scene, Tavern, Company, and Summon for that visit. */
window.hohLikedOnly=window.hohLikedOnly||{scene:false,tavern:false,company:false,summon:false};
window.hohToggleLikedOnly=function(tool,btn){
 var active=!window.hohLikedOnly[tool];
 window.hohLikedOnly[tool]=active;
 if(btn){btn.classList.toggle('hoh-tool-liked-on',active);}
 try{sessionStorage.setItem('hoh-liked-only-'+tool,active?'1':'0');}catch(e){}
};
function hohLikedOnlyActive(tool){
 try{var v=sessionStorage.getItem('hoh-liked-only-'+tool);if(v!=null)return v==='1';}catch(e){}
 return!!window.hohLikedOnly[tool];
}
/* Minimum liked heroes required before the "Only my liked heroes" filter
 shows up anywhere. Below this the checkbox is hidden and the state is
 force-reset to off so a saved-on toggle never quietly filters an empty
 pool. Above this the filter appears everywhere consistently. */
var HOH_LIKED_FILTER_MIN=10;
function hohLikedCount(){try{var h=getHearted();return(h&&h.length)||0;}catch(e){return 0;}}
window.hohLikedCount=hohLikedCount;
function hohLikedFilterEligible(){return hohLikedCount()>=HOH_LIKED_FILTER_MIN;}
window.hohLikedFilterEligible=hohLikedFilterEligible;

function hohRestoreLikedOnlyToggle(tool){
 var btn=document.getElementById('hoh-'+tool+'-liked-toggle');
 if(!btn)return;
 if(!hohLikedFilterEligible()){
 // Not enough likes: hide toggle and reset state.
 btn.style.display='none';
 window.hohLikedOnly[tool]=false;
 try{sessionStorage.setItem('hoh-liked-only-'+tool,'0');}catch(e){}
 btn.classList.remove('hoh-tool-liked-on');
 return;
 }
 btn.style.display='';
 var on=hohLikedOnlyActive(tool);
 window.hohLikedOnly[tool]=on;
 btn.classList.toggle('hoh-tool-liked-on',on);
}
window.hohRestoreLikedOnlyToggle=hohRestoreLikedOnlyToggle;
window.hohLikedOnlyActive=hohLikedOnlyActive;

function hohFilterPoolLiked(pool){
 /* Defensive guard: if the user somehow has the toggle on but fewer than
  the minimum likes (or none of their likes match the current pool),
  fall back to the full pool rather than returning an empty one. */
 if(!hohLikedFilterEligible())return pool;
 var hearted=getHearted();
 if(!hearted||!hearted.length)return pool;
 var filtered=pool.filter(function(c){return hearted.indexOf(c.id)!==-1;});
 return filtered.length?filtered:pool;
}
window.hohFilterPoolLiked=hohFilterPoolLiked;

/* ---------- Cast Only filter (Your Hall v2) ----------
   Parallel to the Liked Only filter above. Source of truth is the
   user's saved cast (hoh-saved-v1.heroes), not the legacy hoh-hearts
   map. Lets the DM run Scene / Tavern / Company / Summon against
   only the heroes they explicitly curated, which is the bullseye
   "at the table" experience. */
window.hohCastOnly=window.hohCastOnly||{scene:false,tavern:false,company:false,summon:false};
window.hohToggleCastOnly=function(tool,btn){
 var active=!window.hohCastOnly[tool];
 window.hohCastOnly[tool]=active;
 /* Use the SAME active class as the liked pill so both pills share
    visual treatment (filled gold checkbox, brighter text). The
    .hoh-tool-cast class still scopes the data hook and JS handler. */
 if(btn){btn.classList.toggle('hoh-tool-liked-on',active);}
 try{sessionStorage.setItem('hoh-cast-only-'+tool,active?'1':'0');}catch(e){}
};
function hohCastOnlyActive(tool){
 try{var v=sessionStorage.getItem('hoh-cast-only-'+tool);if(v!=null)return v==='1';}catch(e){}
 return!!window.hohCastOnly[tool];
}
function hohCastCount(){
 try {
  if(typeof window.hohHallGetHeroes === 'function') return (window.hohHallGetHeroes() || []).length;
 } catch(e){}
 return 0;
}
function hohCastFilterEligible(){ return hohCastCount() >= 2; }
window.hohCastFilterEligible = hohCastFilterEligible;
window.hohCastOnlyActive = hohCastOnlyActive;

function hohRestoreCastOnlyToggle(tool){
 var modalId = (tool==='scene')?'hoh-scene-modal':(tool==='tavern')?'hoh-tavern-modal':(tool==='company')?'hoh-company-modal':'hoh-modal';
 var modal = document.getElementById(modalId);
 if(!modal) return;
 var likedBtn = modal.querySelector('#hoh-'+tool+'-liked-toggle');
 if(!likedBtn) return;
 /* Wrap the liked button in a single shared row so both pills sit
    side by side as ONE filter UI. The row is created once and
    reused across re-opens of the modal. The cast pill mirrors the
    liked pill's class set so they look visually identical. */
 var row = likedBtn.parentNode.classList.contains('hoh-tool-filter-row')
  ? likedBtn.parentNode
  : null;
 if(!row){
  row = document.createElement('div');
  row.className = 'hoh-tool-filter-row';
  likedBtn.parentNode.insertBefore(row, likedBtn);
  row.appendChild(likedBtn);
 }
 var btn = row.querySelector('.hoh-tool-cast[data-tool-cast="'+tool+'"]');
 if(!btn){
  /* Use the SAME .hoh-tool-liked class as the liked pill so the
     visual style matches exactly (rounded pill, gold checkbox,
     italic Cormorant label). The .hoh-tool-cast class exists for
     identification (data hook + state class scoping). */
  btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'hoh-tool-liked hoh-tool-cast';
  btn.setAttribute('data-tool-cast', tool);
  btn.innerHTML = '<span class="hoh-tool-liked-check">&#10003;</span><span>Only my Favorites</span>';
  btn.addEventListener('click', function(e){
   e.preventDefault(); e.stopPropagation();
   window.hohToggleCastOnly(tool, btn);
  });
  row.appendChild(btn);
 }
 if(!hohCastFilterEligible()){
  btn.style.display = 'none';
  window.hohCastOnly[tool] = false;
  try { sessionStorage.setItem('hoh-cast-only-'+tool, '0'); } catch(_){}
  btn.classList.remove('hoh-tool-liked-on');
  return;
 }
 btn.style.display = '';
 var on = hohCastOnlyActive(tool);
 window.hohCastOnly[tool] = on;
 btn.classList.toggle('hoh-tool-liked-on', on);
}
window.hohRestoreCastOnlyToggle = hohRestoreCastOnlyToggle;

function hohFilterPoolCast(pool){
 if(!hohCastFilterEligible()) return pool;
 var setIds = (typeof window.hohHallSavedIdSet === 'function') ? window.hohHallSavedIdSet() : null;
 if(!setIds) return pool;
 var filtered = pool.filter(function(c){ return c && c.id && setIds[c.id]; });
 return filtered.length ? filtered : pool;
}
window.hohFilterPoolCast = hohFilterPoolCast;

function hohScenePickCharacter(){
 var pool=allCharacters.filter(function(c){return c&&c.id;});
 if(hohCastOnlyActive('scene'))pool=hohFilterPoolCast(pool);
 if(hohLikedOnlyActive('scene'))pool=hohFilterPoolLiked(pool);
 if(!pool.length)return null;
 if(HOH_SCENE_LAST_WHO_ID&&pool.length>1){
 pool=pool.filter(function(c){return c.id!==HOH_SCENE_LAST_WHO_ID;});
 }
 var pick=pool[Math.floor(Math.random()*pool.length)];
 HOH_SCENE_LAST_WHO_ID=pick.id;
 return pick;
}

function hohScenePickIndex(arrayLen,lastIdx){
 if(arrayLen<=1)return 0;
 var idx;
 do{idx=Math.floor(Math.random()*arrayLen);}while(idx===lastIdx);
 return idx;
}

function hohSceneRenderWho(c){
 var el=document.getElementById('hoh-scene-who-body');
 if(!el||!c)return;
 var imgUrl=c.image_thumb_url||c.image_url;
 var media=imgUrl
 ? '<img class="hoh-scene-who-img" src="'+imgUrl+'" alt="'+esc(c.name)+'" loading="lazy" decoding="async" crossorigin="anonymous">'
 : '<div class="hoh-scene-who-letter">'+esc((c.name||'?').charAt(0))+'</div>';
 var _dndLv=parseInt(c.dnd_level,10); var lv=(_dndLv>=1)?' &middot; Level '+Math.min(20,_dndLv):''; /* R224: static D&D level (1-20), not the My Hall XP level */
 /* Tag the row with the character's rarity so the Satchel inherits the
  same tier-colored stripe + halo as the grid cards. */
 var rar=hohGetRarity(c.hearts);
 ['common','uncommon','rare','epic','legendary'].forEach(function(t){el.classList.remove('hoh-scene-rar-'+t);});
 el.classList.add('hoh-scene-rar-'+rar.tier);
 el.setAttribute('data-hero-id',c.id);
 el.innerHTML=
 media+
 '<div class="hoh-scene-who-info">'+
  '<p class="hoh-scene-who-name">'+esc(c.name)+'</p>'+
  '<p class="hoh-scene-who-meta">'+esc(c.race||'')+' '+esc(c.character_class||'')+lv+'</p>'+
  '<p class="hoh-scene-who-byline">submitted by '+esc(c.player_name||'Anonymous')+'</p>'+
 '</div>';
 el.onclick=function(){
 hohCloseSceneTool();
 setTimeout(function(){hohOpenDetail(c.id);},120);
 };
 void el.offsetWidth;
 el.style.animation='none';
 void el.offsetWidth;
 el.style.animation='';
}

function hohSceneRenderWant(idx){
 var el=document.getElementById('hoh-scene-want');
 if(!el)return;
 el.textContent=HOH_SCENE_WANTS[idx];
 void el.offsetWidth;
 el.style.animation='none';
 void el.offsetWidth;
 el.style.animation='';
}

function hohSceneRenderComplication(idx){
 var el=document.getElementById('hoh-scene-complication');
 if(!el)return;
 el.textContent=HOH_SCENE_COMPLICATIONS[idx];
 void el.offsetWidth;
 el.style.animation='none';
 void el.offsetWidth;
 el.style.animation='';
}

function hohSceneSetEmpty(){
 var who=document.getElementById('hoh-scene-who-body');
 var want=document.getElementById('hoh-scene-want');
 var comp=document.getElementById('hoh-scene-complication');
 if(who){who.innerHTML='<div class="hoh-scene-empty">Press the button below to roll your first scene.</div>';who.onclick=null;}
 if(want)want.textContent='';
 if(comp)comp.textContent='';
 var modal=document.getElementById('hoh-scene-modal');
 if(modal){
 modal.querySelectorAll('.hoh-scene-reroll').forEach(function(b){b.style.display='none';});
 var share=document.getElementById('hoh-scene-share-btn');if(share)share.style.display='none';
 var roll=modal.querySelector('.hoh-pouch-roll-btn');if(roll)roll.innerHTML='<span>Roll the Scene</span>';
 }
}

function hohSceneShowControls(){
 var modal=document.getElementById('hoh-scene-modal');
 if(!modal)return;
 modal.querySelectorAll('.hoh-scene-reroll').forEach(function(b){b.style.display='';});
 var share=document.getElementById('hoh-scene-share-btn');if(share)share.style.display='';
 var roll=modal.querySelector('.hoh-pouch-roll-btn');if(roll)roll.innerHTML='<span>Roll a New Scene</span>';
}

window.hohOpenSceneTool=function(){
 document.getElementById('hoh-scene-modal').style.display='flex';
 document.body.style.overflow='hidden';
 hohRestoreLikedOnlyToggle('scene');
 if(!HOH_SCENE_ROLLED)hohSceneSetEmpty();
 hohRestoreCastOnlyToggle('scene');
};

/* Jan (2026-09-27): "dont save the roll history for the dm tools". Scene
   and Tavern rolls are no longer written to Your Hall, so their save and
   saved-roll export helpers are gone. The tools roll and show exactly as
   before. */
/* Helper used by toast "View" links and Run-Cast paths. Switches to
   Your Hall mode and the requested tab in a single jump. The legacy
   tab names (scenes_taverns, companies) are aliased into the new
   Satchel tab + a sub-mode hint persisted to localStorage so the
   Satchel renderer lands on the right sub-tool. */
function hohOpenYourHallTab(tabName){
 try {
  /* Persist a hint for the Satchel sub-tab so the renderer lands
     on the right tool surface. Falls through harmlessly for tabs
     that don't read this hint. */
  var subHint = null;
  if(tabName === 'scenes_taverns' || tabName === 'scene' || tabName === 'tavern'){
   subHint = (tabName === 'tavern') ? 'tavern' : 'scene';
   tabName = 'satchel';
  } else if(tabName === 'companies' || tabName === 'company'){
   subHint = 'company';
   tabName = 'satchel';
  }
  if(subHint){
   try {
    var saved = JSON.parse(localStorage.getItem('hoh-saved-v1') || '{}');
    saved.meta = saved.meta || {};
    saved.meta.lastSatchelMode = subHint;
    localStorage.setItem('hoh-saved-v1', JSON.stringify(saved));
   } catch(_){}
  }
  document.body.classList.add('hoh-page-mode-yours');
  if(typeof window.hohYhSetHeaderModeYours==='function') window.hohYhSetHeaderModeYours();
  if(typeof window.hohYourHallSwitchView==='function') window.hohYourHallSwitchView(tabName);
  if(typeof window.hohOpenYourHall==='function') window.hohOpenYourHall();
  if(typeof window.hohRefreshYhToggle==='function') window.hohRefreshYhToggle();
  /* Close any open Satchel or detail modal so Your Hall is the
     foreground after a "View" jump. */
  if(typeof window.hohCloseModal==='function'){
   var dm = document.getElementById('hoh-modal');
   if(dm && dm.style.display !== 'none') window.hohCloseModal();
  }
  var modals = ['hoh-scene-modal','hoh-tavern-modal','hoh-company-modal'];
  modals.forEach(function(id){ var m=document.getElementById(id); if(m) m.style.display='none'; });
  document.body.style.overflow='';
  window.scrollTo({ top:0, behavior:'smooth' });
 } catch(_){}
}
window.hohOpenYourHallTab = hohOpenYourHallTab;

window.hohCloseSceneTool=function(){
 document.getElementById('hoh-scene-modal').style.display='none';
 document.body.style.overflow='';
};

window.hohRollScene=function(){
 /* HALL-SPEED-02: a roll needs the full roster: it answers now and rolls when it lands */
 if(!allCharacters.length&&hohRosterArriving()){ hohQueueRosterOpen('scene',null,document.querySelector('#hoh-scene-modal .hoh-pouch-roll-btn')); return; }
 if(HOH_SCENE_ROLLING)return;
 HOH_SCENE_ROLLING=true;HOH_SCENE_ROLLED=true;hohSceneShowControls();
 hohClaimActionHeart('scene',document.querySelector('#hoh-scene-modal .hoh-pouch-roll-btn'),'For setting the scene.');
 var whoEl=document.getElementById('hoh-scene-who-body'),wantEl=document.getElementById('hoh-scene-want'),compEl=document.getElementById('hoh-scene-complication');
 hohSceneStartRoll(whoEl,'Who walks in...');hohSceneStartRoll(wantEl,'They want...');hohSceneStartRoll(compEl,'The complication...');
 HOH_SCENE_CURRENT.character=hohScenePickCharacter();
 HOH_SCENE_CURRENT.wantIdx=hohScenePickIndex(HOH_SCENE_WANTS.length,HOH_SCENE_LAST_WANT);
 HOH_SCENE_CURRENT.compIdx=hohScenePickIndex(HOH_SCENE_COMPLICATIONS.length,HOH_SCENE_LAST_COMP);
 HOH_SCENE_LAST_WANT=HOH_SCENE_CURRENT.wantIdx;HOH_SCENE_LAST_COMP=HOH_SCENE_CURRENT.compIdx;
 setTimeout(function(){hohSceneEndRoll(whoEl);if(HOH_SCENE_CURRENT.character)hohSceneRenderWho(HOH_SCENE_CURRENT.character);},650);
 setTimeout(function(){hohSceneEndRoll(wantEl);hohSceneRenderWant(HOH_SCENE_CURRENT.wantIdx);},900);
 setTimeout(function(){
  hohSceneEndRoll(compEl);
  hohSceneRenderComplication(HOH_SCENE_CURRENT.compIdx);
  HOH_SCENE_ROLLING=false;
 },1150);
};

function hohSceneRollOne(elId,ghost,fn){
 if(HOH_SCENE_ROLLING)return;
 HOH_SCENE_ROLLING=true;HOH_SCENE_ROLLED=true;hohSceneShowControls();
 var el=document.getElementById(elId);
 hohSceneStartRoll(el,ghost);
 fn();
 setTimeout(function(){
  hohSceneEndRoll(el);
  HOH_SCENE_ROLLING=false;
 },600);
}
window.hohRollSceneWho=function(){hohSceneRollOne('hoh-scene-who-body','Who walks in...',function(){HOH_SCENE_CURRENT.character=hohScenePickCharacter();if(HOH_SCENE_CURRENT.character)hohSceneRenderWho(HOH_SCENE_CURRENT.character);});};
window.hohRollSceneWant=function(){hohSceneRollOne('hoh-scene-want','They want...',function(){HOH_SCENE_CURRENT.wantIdx=hohScenePickIndex(HOH_SCENE_WANTS.length,HOH_SCENE_LAST_WANT);HOH_SCENE_LAST_WANT=HOH_SCENE_CURRENT.wantIdx;hohSceneRenderWant(HOH_SCENE_CURRENT.wantIdx);});};
window.hohRollSceneComplication=function(){hohSceneRollOne('hoh-scene-complication','The complication...',function(){HOH_SCENE_CURRENT.compIdx=hohScenePickIndex(HOH_SCENE_COMPLICATIONS.length,HOH_SCENE_LAST_COMP);HOH_SCENE_LAST_COMP=HOH_SCENE_CURRENT.compIdx;hohSceneRenderComplication(HOH_SCENE_CURRENT.compIdx);});};

function hohSceneLoadImg(url){
 return new Promise(function(resolve){
 if(!url){resolve(null);return;}
 var img=new Image();
 img.crossOrigin='anonymous';
 img.onload=function(){resolve(img);};
 img.onerror=function(){resolve(null);};
 img.src=url;
 });
}

function hohSceneWrap(ctx,text,x,y,maxW,lineH,maxLines){
 var words=text.split(' '),line='',lines=[];
 for(var i=0;i<words.length;i++){
 var test=line+words[i]+' ';
 if(ctx.measureText(test).width>maxW&&line!==''){
  lines.push(line.trim());
  line=words[i]+' ';
  if(maxLines&&lines.length>=maxLines){
  lines[lines.length-1]=lines[lines.length-1].replace(/\s*$/,'')+'...';
  break;
  }
 }else{
  line=test;
 }
 }
 if((!maxLines||lines.length<maxLines)&&line.trim())lines.push(line.trim());
 for(var j=0;j<lines.length;j++)ctx.fillText(lines[j],x,y+(j*lineH));
 return lines.length;
}

window.hohShareScene=async function(){
 if(!HOH_SCENE_CURRENT.character)return;
 var c=HOH_SCENE_CURRENT.character;
 var want=HOH_SCENE_WANTS[HOH_SCENE_CURRENT.wantIdx];
 var comp=HOH_SCENE_COMPLICATIONS[HOH_SCENE_CURRENT.compIdx];
 var btn=document.getElementById('hoh-scene-share-btn');
 if(btn){btn.disabled=true;btn.innerHTML='<span>Generating...</span>';}

 try{
 var W=1080,H=1350;
 var canvas=document.createElement('canvas');
 canvas.width=W;canvas.height=H;
 var ctx=canvas.getContext('2d');

 var bgG=ctx.createLinearGradient(0,0,0,H);
 bgG.addColorStop(0,'#15101f');
 bgG.addColorStop(1,'#0a0a14');
 ctx.fillStyle=bgG;ctx.fillRect(0,0,W,H);

 var imgH=Math.round(H*0.58);
 var img=await hohSceneLoadImg(c.image_url||c.image_thumb_url);
 if(img){
  var scale=Math.max(W/img.naturalWidth,imgH/img.naturalHeight);
  var dW=img.naturalWidth*scale,dH=img.naturalHeight*scale;
  ctx.save();
  ctx.beginPath();ctx.rect(0,0,W,imgH);ctx.clip();
  ctx.drawImage(img,(W-dW)/2,(imgH-dH)/2,dW,dH);
  ctx.restore();
  var fadeG=ctx.createLinearGradient(0,imgH-180,0,imgH);
  fadeG.addColorStop(0,'rgba(10,10,20,0)');
  fadeG.addColorStop(1,'rgba(10,10,20,1)');
  ctx.fillStyle=fadeG;ctx.fillRect(0,imgH-180,W,180);
 }else{
  var hash=0;for(var pi=0;pi<c.name.length;pi++)hash=c.name.charCodeAt(pi)+((hash<<5)-hash);
  var hue=Math.abs(hash%360);
  var pG=ctx.createLinearGradient(0,0,W,imgH);
  pG.addColorStop(0,'hsl('+hue+',30%,18%)');
  pG.addColorStop(1,'hsl('+((hue+40)%360)+',40%,14%)');
  ctx.fillStyle=pG;ctx.fillRect(0,0,W,imgH);
  ctx.font='200px Cinzel,serif';
  ctx.fillStyle='rgba(183,148,244,0.18)';
  ctx.textAlign='center';ctx.textBaseline='middle';
  ctx.fillText((c.name||'?').charAt(0),W/2,imgH/2);
  ctx.textAlign='left';ctx.textBaseline='top';
 }

 ctx.strokeStyle='rgba(183,148,244,0.35)';ctx.lineWidth=4;
 ctx.strokeRect(2,2,W-4,H-4);
 ctx.strokeStyle='rgba(183,148,244,0.1)';ctx.lineWidth=1;
 ctx.strokeRect(18,18,W-36,H-36);

 var pX=64,cY=imgH+28;
 ctx.textBaseline='top';ctx.textAlign='left';
 ctx.font='700 13px Cinzel,serif';
 ctx.fillStyle='#b794f4';
 ctx.fillText('THE SCENE',pX,cY);
 cY+=26;

 ctx.font='700 48px Cinzel,serif';
 ctx.fillStyle='#e8e0d0';
 var nameLines=hohSceneWrap(ctx,c.name,pX,cY,W-(pX*2),58,2);
 cY+=nameLines*58+6;

 ctx.font='500 22px Cormorant Garamond,serif';
 ctx.fillStyle='#a09aae';
 var metaT=(c.race||'')+' '+(c.character_class||'');
 if(c.level)metaT+='  \u00b7  Level '+c.level;
 ctx.fillText(metaT,pX,cY);
 cY+=36;

 var lineG=ctx.createLinearGradient(pX,0,W-pX,0);
 lineG.addColorStop(0,'rgba(183,148,244,0.4)');
 lineG.addColorStop(1,'rgba(183,148,244,0)');
 ctx.fillStyle=lineG;ctx.fillRect(pX,cY,W-(pX*2),1);
 cY+=28;

 ctx.font='700 12px Cinzel,serif';
 ctx.fillStyle='#b794f4';
 ctx.fillText('THEY WANT',pX,cY);
 cY+=22;
 ctx.font='italic 24px Cormorant Garamond,serif';
 ctx.fillStyle='#d0c8dc';
 var wantLines=hohSceneWrap(ctx,want,pX,cY,W-(pX*2),32,3);
 cY+=wantLines*32+22;

 ctx.font='700 12px Cinzel,serif';
 ctx.fillStyle='#b794f4';
 ctx.fillText('THE COMPLICATION',pX,cY);
 cY+=22;
 ctx.font='italic 24px Cormorant Garamond,serif';
 ctx.fillStyle='#d0c8dc';
 hohSceneWrap(ctx,comp,pX,cY,W-(pX*2),32,4);

 var bY=H-58;
 ctx.textAlign='center';ctx.textBaseline='middle';
 ctx.font='600 11px Cinzel,serif';
 ctx.fillStyle='rgba(183,148,244,0.4)';
 ctx.fillText('FRAMEDFANTASY.COM',W/2,bY);
 ctx.font='700 18px Cinzel,serif';
 ctx.fillStyle='rgba(183,148,244,0.75)';
 ctx.fillText('THE HALL OF HEROES',W/2,bY+24);
 ctx.textAlign='left';ctx.textBaseline='top';

 var blob=await new Promise(function(r){canvas.toBlob(r,'image/png');});
 var fileName=(c.name||'scene').replace(/[^a-zA-Z0-9]/g,'_')+'_Scene.png';

 /* Desktop browsers (Chrome desktop in particular) often expose the
    Web Share API but reject file sharing OR fail silently after the
    user dismisses the system sheet. The download path is far more
    reliable on desktop, so we gate the Web Share attempt behind a
    "is this actually a touch/mobile device" check. matchMedia is
    the most accurate signal — it returns true on phones and tablets
    where the system share sheet is genuinely useful. */
 var isTouchDevice=false;
 try { isTouchDevice = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches; } catch(_){}
 if(isTouchDevice && navigator.share && navigator.canShare){
  var file=new File([blob],fileName,{type:'image/png'});
  if(navigator.canShare({files:[file]})){
  try{
   await navigator.share({files:[file]});
   if(btn){btn.disabled=false;btn.innerHTML='<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg><span>Share as Image</span>';}
   return;
  }catch(e){
   if(e.name==='AbortError'){
   if(btn){btn.disabled=false;btn.innerHTML='<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg><span>Share as Image</span>';}
   return;
   }
   /* Non-abort error — fall through to download. */
  }
  }
 }
 /* Desktop + mobile fallback: trigger an actual file download. The
    blob URL is anchor-clicked then revoked. Browsers that have
    blocked auto-downloads will surface the file in the downloads
    bar; the button label updates so the user knows it landed. */
 var url=URL.createObjectURL(blob);
 var a=document.createElement('a');a.href=url;a.download=fileName;
 document.body.appendChild(a);a.click();document.body.removeChild(a);
 setTimeout(function(){URL.revokeObjectURL(url);},5000);
 if(btn){btn.disabled=false;btn.innerHTML='<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg><span>Saved to downloads</span>';}
 setTimeout(function(){
   if(btn){btn.innerHTML='<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg><span>Share as Image</span>';}
 }, 2200);
 }catch(err){
 console.error('Share scene error:',err);
 if(btn){btn.disabled=false;btn.innerHTML='<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg><span>Share as Image</span>';}
 alert('Could not generate share card. Please try again.');
 }
};

/* ============================================================
 TAVERN TOOL
 Data arrays (names/atmospheres/specials/rumors) live in
 assets/hoh-data.js to keep this template under the 256 KB limit.
 ============================================================ */

var HOH_TAVERN_CURRENT={nameIdx:-1,atmIdx:-1,specIdx:-1,patron:null,rumorIdx:-1};
var HOH_TAVERN_LAST_NAME=-1;
var HOH_TAVERN_LAST_ATM=-1;
var HOH_TAVERN_LAST_SPEC=-1;
var HOH_TAVERN_LAST_PATRON_ID=null;
var HOH_TAVERN_LAST_RUMOR=-1;
var HOH_TAVERN_ROLLED=false;
var HOH_TAVERN_ROLLING=false;

function hohTavernPickCharacter(){
 var pool=allCharacters.filter(function(c){return c&&c.id;});
 if(hohCastOnlyActive('tavern'))pool=hohFilterPoolCast(pool);
 if(hohLikedOnlyActive('tavern'))pool=hohFilterPoolLiked(pool);
 if(!pool.length)return null;
 if(HOH_TAVERN_LAST_PATRON_ID&&pool.length>1){
 pool=pool.filter(function(c){return c.id!==HOH_TAVERN_LAST_PATRON_ID;});
 }
 var pick=pool[Math.floor(Math.random()*pool.length)];
 HOH_TAVERN_LAST_PATRON_ID=pick.id;
 return pick;
}

function hohTavernPickIndex(arrayLen,lastIdx){
 if(arrayLen<=1)return 0;
 var idx;
 do{idx=Math.floor(Math.random()*arrayLen);}while(idx===lastIdx);
 return idx;
}

function hohTavernFade(el){
 if(!el)return;
 void el.offsetWidth;
 el.style.animation='none';
 void el.offsetWidth;
 el.style.animation='';
}

function hohTavernRenderName(idx){
 var el=document.getElementById('hoh-tavern-name');
 if(!el)return;
 el.textContent=TAVERN_NAMES[idx];
 hohTavernFade(el);
}

function hohTavernRenderAtmosphere(idx){
 var el=document.getElementById('hoh-tavern-atmosphere');
 if(!el)return;
 el.textContent=TAVERN_ATMOSPHERES[idx];
 hohTavernFade(el);
}

function hohTavernRenderSpecial(idx){
 var el=document.getElementById('hoh-tavern-special');
 if(!el)return;
 el.textContent=TAVERN_SPECIALS[idx];
 hohTavernFade(el);
}

function hohTavernRenderRumor(idx){
 var el=document.getElementById('hoh-tavern-rumor');
 if(!el)return;
 el.textContent=TAVERN_RUMORS[idx];
 hohTavernFade(el);
}

function hohTavernRenderPatron(c){
 var el=document.getElementById('hoh-tavern-patron-body');
 if(!el||!c)return;
 var imgUrl=c.image_thumb_url||c.image_url;
 var media=imgUrl
 ? '<img class="hoh-scene-who-img" src="'+imgUrl+'" alt="'+esc(c.name)+'" loading="lazy" decoding="async" crossorigin="anonymous">'
 : '<div class="hoh-scene-who-letter">'+esc((c.name||'?').charAt(0))+'</div>';
 var _dndLv=parseInt(c.dnd_level,10); var lv=(_dndLv>=1)?' &middot; Level '+Math.min(20,_dndLv):''; /* R224: static D&D level (1-20), not the My Hall XP level */
 /* Rarity accent on the tavern patron row. Same stripe treatment as the
  Scene tool so both tools speak the same visual language. */
 var rar=hohGetRarity(c.hearts);
 ['common','uncommon','rare','epic','legendary'].forEach(function(t){el.classList.remove('hoh-scene-rar-'+t);});
 el.classList.add('hoh-scene-rar-'+rar.tier);
 el.setAttribute('data-hero-id',c.id);
 el.innerHTML=
 media+
 '<div class="hoh-scene-who-info">'+
  '<p class="hoh-scene-who-name">'+esc(c.name)+'</p>'+
  '<p class="hoh-scene-who-meta">'+esc(c.race||'')+' '+esc(c.character_class||'')+lv+'</p>'+
  '<p class="hoh-scene-who-byline">submitted by '+esc(c.player_name||'Anonymous')+'</p>'+
 '</div>';
 el.onclick=function(){
 hohCloseTavernTool();
 setTimeout(function(){hohOpenDetail(c.id);},120);
 };
 hohTavernFade(el);
}

function hohTavernSetEmpty(){
 var nm=document.getElementById('hoh-tavern-name');
 var atm=document.getElementById('hoh-tavern-atmosphere');
 var spec=document.getElementById('hoh-tavern-special');
 var pat=document.getElementById('hoh-tavern-patron-body');
 var rum=document.getElementById('hoh-tavern-rumor');
 if(nm)nm.textContent='';
 if(atm)atm.textContent='';
 if(spec)spec.textContent='';
 if(pat){pat.innerHTML='<div class="hoh-scene-empty">Press the button below to roll your first tavern.</div>';pat.onclick=null;}
 if(rum)rum.textContent='';
 var modal=document.getElementById('hoh-tavern-modal');
 if(modal){
 modal.querySelectorAll('.hoh-scene-reroll').forEach(function(b){b.style.display='none';});
 var share=document.getElementById('hoh-tavern-share-btn');if(share)share.style.display='none';
 var roll=modal.querySelector('.hoh-pouch-roll-btn');if(roll)roll.innerHTML='<span>Roll the Tavern</span>';
 }
}

function hohTavernShowControls(){
 var modal=document.getElementById('hoh-tavern-modal');
 if(!modal)return;
 modal.querySelectorAll('.hoh-scene-reroll').forEach(function(b){b.style.display='';});
 var share=document.getElementById('hoh-tavern-share-btn');if(share)share.style.display='';
 var roll=modal.querySelector('.hoh-pouch-roll-btn');if(roll)roll.innerHTML='<span>Roll a New Tavern</span>';
}

window.hohOpenTavernTool=function(){
 document.getElementById('hoh-tavern-modal').style.display='flex';
 document.body.style.overflow='hidden';
 hohRestoreLikedOnlyToggle('tavern');
 if(!HOH_TAVERN_ROLLED)hohTavernSetEmpty();
 hohRestoreCastOnlyToggle('tavern');
};

window.hohCloseTavernTool=function(){
 document.getElementById('hoh-tavern-modal').style.display='none';
 document.body.style.overflow='';
};

window.hohRollTavern=function(){
 /* HALL-SPEED-02: a roll needs the full roster: it answers now and rolls when it lands */
 if(!allCharacters.length&&hohRosterArriving()){ hohQueueRosterOpen('tavern',null,document.querySelector('#hoh-tavern-modal .hoh-pouch-roll-btn')); return; }
 if(HOH_TAVERN_ROLLING)return;
 HOH_TAVERN_ROLLING=true;HOH_TAVERN_ROLLED=true;hohTavernShowControls();
 hohClaimActionHeart('tavern',document.querySelector('#hoh-tavern-modal .hoh-pouch-roll-btn'),'For rolling the tavern.');
 var nmEl=document.getElementById('hoh-tavern-name'),atmEl=document.getElementById('hoh-tavern-atmosphere'),specEl=document.getElementById('hoh-tavern-special'),patEl=document.getElementById('hoh-tavern-patron-body'),rumEl=document.getElementById('hoh-tavern-rumor');
 hohSceneStartRoll(nmEl,'Tonight\'s tavern...');hohSceneStartRoll(atmEl,'The room...');hohSceneStartRoll(specEl,'Tonight\'s special...');hohSceneStartRoll(patEl,'At the bar...');hohSceneStartRoll(rumEl,'Whispered tonight...');
 HOH_TAVERN_CURRENT.nameIdx=hohTavernPickIndex(TAVERN_NAMES.length,HOH_TAVERN_LAST_NAME);
 HOH_TAVERN_CURRENT.atmIdx=hohTavernPickIndex(TAVERN_ATMOSPHERES.length,HOH_TAVERN_LAST_ATM);
 HOH_TAVERN_CURRENT.specIdx=hohTavernPickIndex(TAVERN_SPECIALS.length,HOH_TAVERN_LAST_SPEC);
 HOH_TAVERN_CURRENT.patron=hohTavernPickCharacter();
 HOH_TAVERN_CURRENT.rumorIdx=hohTavernPickIndex(TAVERN_RUMORS.length,HOH_TAVERN_LAST_RUMOR);
 HOH_TAVERN_LAST_NAME=HOH_TAVERN_CURRENT.nameIdx;HOH_TAVERN_LAST_ATM=HOH_TAVERN_CURRENT.atmIdx;HOH_TAVERN_LAST_SPEC=HOH_TAVERN_CURRENT.specIdx;HOH_TAVERN_LAST_RUMOR=HOH_TAVERN_CURRENT.rumorIdx;
 setTimeout(function(){hohSceneEndRoll(nmEl);hohTavernRenderName(HOH_TAVERN_CURRENT.nameIdx);},500);
 setTimeout(function(){hohSceneEndRoll(atmEl);hohTavernRenderAtmosphere(HOH_TAVERN_CURRENT.atmIdx);},700);
 setTimeout(function(){hohSceneEndRoll(specEl);hohTavernRenderSpecial(HOH_TAVERN_CURRENT.specIdx);},900);
 setTimeout(function(){hohSceneEndRoll(patEl);if(HOH_TAVERN_CURRENT.patron)hohTavernRenderPatron(HOH_TAVERN_CURRENT.patron);},1100);
 setTimeout(function(){
  hohSceneEndRoll(rumEl);
  hohTavernRenderRumor(HOH_TAVERN_CURRENT.rumorIdx);
  HOH_TAVERN_ROLLING=false;
 },1300);
};

function hohTavernRollOne(elId,ghost,pickAndRender){
 if(HOH_TAVERN_ROLLING)return;
 HOH_TAVERN_ROLLING=true;HOH_TAVERN_ROLLED=true;hohTavernShowControls();
 var el=document.getElementById(elId);
 hohSceneStartRoll(el,ghost);
 pickAndRender();
 setTimeout(function(){
  hohSceneEndRoll(el);
  HOH_TAVERN_ROLLING=false;
 },550);
}

window.hohRollTavernName=function(){hohTavernRollOne('hoh-tavern-name','Tonight\'s tavern...',function(){HOH_TAVERN_CURRENT.nameIdx=hohTavernPickIndex(TAVERN_NAMES.length,HOH_TAVERN_LAST_NAME);HOH_TAVERN_LAST_NAME=HOH_TAVERN_CURRENT.nameIdx;hohTavernRenderName(HOH_TAVERN_CURRENT.nameIdx);});};
window.hohRollTavernAtmosphere=function(){hohTavernRollOne('hoh-tavern-atmosphere','The room...',function(){HOH_TAVERN_CURRENT.atmIdx=hohTavernPickIndex(TAVERN_ATMOSPHERES.length,HOH_TAVERN_LAST_ATM);HOH_TAVERN_LAST_ATM=HOH_TAVERN_CURRENT.atmIdx;hohTavernRenderAtmosphere(HOH_TAVERN_CURRENT.atmIdx);});};
window.hohRollTavernSpecial=function(){hohTavernRollOne('hoh-tavern-special','Tonight\'s special...',function(){HOH_TAVERN_CURRENT.specIdx=hohTavernPickIndex(TAVERN_SPECIALS.length,HOH_TAVERN_LAST_SPEC);HOH_TAVERN_LAST_SPEC=HOH_TAVERN_CURRENT.specIdx;hohTavernRenderSpecial(HOH_TAVERN_CURRENT.specIdx);});};
window.hohRollTavernPatron=function(){hohTavernRollOne('hoh-tavern-patron-body','At the bar...',function(){HOH_TAVERN_CURRENT.patron=hohTavernPickCharacter();if(HOH_TAVERN_CURRENT.patron)hohTavernRenderPatron(HOH_TAVERN_CURRENT.patron);});};
window.hohRollTavernRumor=function(){hohTavernRollOne('hoh-tavern-rumor','Whispered tonight...',function(){HOH_TAVERN_CURRENT.rumorIdx=hohTavernPickIndex(TAVERN_RUMORS.length,HOH_TAVERN_LAST_RUMOR);HOH_TAVERN_LAST_RUMOR=HOH_TAVERN_CURRENT.rumorIdx;hohTavernRenderRumor(HOH_TAVERN_CURRENT.rumorIdx);});};

window.hohShareTavern=async function(){
 if(!HOH_TAVERN_CURRENT.patron)return;
 var c=HOH_TAVERN_CURRENT.patron;
 var tavernName=TAVERN_NAMES[HOH_TAVERN_CURRENT.nameIdx];
 var atmosphere=TAVERN_ATMOSPHERES[HOH_TAVERN_CURRENT.atmIdx];
 var special=TAVERN_SPECIALS[HOH_TAVERN_CURRENT.specIdx];
 var rumor=TAVERN_RUMORS[HOH_TAVERN_CURRENT.rumorIdx];
 var btn=document.getElementById('hoh-tavern-share-btn');
 var resetBtn=function(){
 if(btn){
  btn.disabled=false;
  btn.innerHTML='<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg><span>Share as Image</span>';
 }
 };
 if(btn){btn.disabled=true;btn.innerHTML='<span>Generating...</span>';}

 try{
 var W=1080,H=1350;
 var canvas=document.createElement('canvas');
 canvas.width=W;canvas.height=H;
 var ctx=canvas.getContext('2d');

 var bgG=ctx.createLinearGradient(0,0,0,H);
 bgG.addColorStop(0,'#15101f');
 bgG.addColorStop(1,'#0a0a14');
 ctx.fillStyle=bgG;ctx.fillRect(0,0,W,H);

 var imgH=Math.round(H*0.45);
 var img=await hohSceneLoadImg(c.image_url||c.image_thumb_url);
 if(img){
  var scale=Math.max(W/img.naturalWidth,imgH/img.naturalHeight);
  var dW=img.naturalWidth*scale,dH=img.naturalHeight*scale;
  ctx.save();
  ctx.beginPath();ctx.rect(0,0,W,imgH);ctx.clip();
  ctx.drawImage(img,(W-dW)/2,(imgH-dH)/2,dW,dH);
  ctx.restore();
  var fadeG=ctx.createLinearGradient(0,imgH-180,0,imgH);
  fadeG.addColorStop(0,'rgba(10,10,20,0)');
  fadeG.addColorStop(1,'rgba(10,10,20,1)');
  ctx.fillStyle=fadeG;ctx.fillRect(0,imgH-180,W,180);
 }else{
  var hash=0;for(var pi=0;pi<c.name.length;pi++)hash=c.name.charCodeAt(pi)+((hash<<5)-hash);
  var hue=Math.abs(hash%360);
  var pG=ctx.createLinearGradient(0,0,W,imgH);
  pG.addColorStop(0,'hsl('+hue+',30%,18%)');
  pG.addColorStop(1,'hsl('+((hue+40)%360)+',40%,14%)');
  ctx.fillStyle=pG;ctx.fillRect(0,0,W,imgH);
  ctx.font='200px Cinzel,serif';
  ctx.fillStyle='rgba(226,198,122,0.18)';
  ctx.textAlign='center';ctx.textBaseline='middle';
  ctx.fillText((c.name||'?').charAt(0),W/2,imgH/2);
  ctx.textAlign='left';ctx.textBaseline='top';
 }

 ctx.strokeStyle='rgba(183,148,244,0.35)';ctx.lineWidth=4;
 ctx.strokeRect(2,2,W-4,H-4);
 ctx.strokeStyle='rgba(226,198,122,0.18)';ctx.lineWidth=1;
 ctx.strokeRect(18,18,W-36,H-36);

 var pX=64,cY=imgH+36;
 ctx.textBaseline='top';ctx.textAlign='center';

 ctx.font='700 14px Cinzel,serif';
 ctx.fillStyle='#e2c67a';
 ctx.fillText('THE TAVERN',W/2,cY);
 cY+=30;

 ctx.font='700 54px Cinzel,serif';
 ctx.fillStyle='#e8e0d0';
 var nameLines=hohSceneWrap(ctx,tavernName,W/2,cY,W-(pX*2),62,2);
 cY+=nameLines*62+10;

 ctx.font='italic 22px Cormorant Garamond,serif';
 ctx.fillStyle='#a09aae';
 ctx.fillText('at the bar tonight, '+(c.name||'a stranger'),W/2,cY);
 cY+=34;

 ctx.textAlign='left';
 var lineG=ctx.createLinearGradient(pX,0,W-pX,0);
 lineG.addColorStop(0,'rgba(183,148,244,0.4)');
 lineG.addColorStop(1,'rgba(183,148,244,0)');
 ctx.fillStyle=lineG;ctx.fillRect(pX,cY,W-(pX*2),1);
 cY+=22;

 ctx.font='700 12px Cinzel,serif';
 ctx.fillStyle='#b794f4';
 ctx.fillText('THE ROOM',pX,cY);
 cY+=22;
 ctx.font='italic 22px Cormorant Garamond,serif';
 ctx.fillStyle='#d0c8dc';
 var atmLines=hohSceneWrap(ctx,atmosphere,pX,cY,W-(pX*2),30,3);
 cY+=atmLines*30+16;

 ctx.font='700 12px Cinzel,serif';
 ctx.fillStyle='#b794f4';
 ctx.fillText('TONIGHT’S SPECIAL',pX,cY);
 cY+=22;
 ctx.font='italic 22px Cormorant Garamond,serif';
 ctx.fillStyle='#d0c8dc';
 var spcLines=hohSceneWrap(ctx,special,pX,cY,W-(pX*2),30,3);
 cY+=spcLines*30+16;

 ctx.font='700 12px Cinzel,serif';
 ctx.fillStyle='#b794f4';
 ctx.fillText('WHISPERED TONIGHT',pX,cY);
 cY+=22;
 ctx.font='italic 22px Cormorant Garamond,serif';
 ctx.fillStyle='#d0c8dc';
 hohSceneWrap(ctx,rumor,pX,cY,W-(pX*2),30,3);

 var bY=H-58;
 ctx.textAlign='center';ctx.textBaseline='middle';
 ctx.font='600 11px Cinzel,serif';
 ctx.fillStyle='rgba(226,198,122,0.4)';
 ctx.fillText('FRAMEDFANTASY.COM',W/2,bY);
 ctx.font='700 18px Cinzel,serif';
 ctx.fillStyle='rgba(226,198,122,0.75)';
 ctx.fillText('THE HALL OF HEROES',W/2,bY+24);
 ctx.textAlign='left';ctx.textBaseline='top';

 var blob=await new Promise(function(r){canvas.toBlob(r,'image/png');});
 var fileName=(tavernName||'Tavern').replace(/[^a-zA-Z0-9]/g,'_')+'_Tavern.png';

 /* Touch-only devices get the system share sheet; desktop falls
    straight to download since Chrome desktop's Web Share API is
    flaky for files. See hohShareScene for the same pattern. */
 var isTouchDevice2=false;
 try { isTouchDevice2 = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches; } catch(_){}
 if(isTouchDevice2 && navigator.share && navigator.canShare){
  var file=new File([blob],fileName,{type:'image/png'});
  if(navigator.canShare({files:[file]})){
  try{await navigator.share({files:[file]});resetBtn();return;}
  catch(e){if(e.name==='AbortError'){resetBtn();return;}}
  }
 }
 var url=URL.createObjectURL(blob);
 var a=document.createElement('a');a.href=url;a.download=fileName;
 document.body.appendChild(a);a.click();document.body.removeChild(a);
 setTimeout(function(){URL.revokeObjectURL(url);},5000);
 resetBtn();
 }catch(err){
 console.error('Share tavern error:',err);
 resetBtn();
 alert('Could not generate share card. Please try again.');
 }
};

/* ============================================================
 RAFFLE SIMULATOR + CONFETTI
 ============================================================ */
function hohFireConfetti(){
 if(typeof confetti!=='function'){console.warn('[Raffle] Confetti library not loaded');return;}
 var isMobile=window.innerWidth<768;
 var brandColors=['#ee99fe','#affcfe'];
 if(!isMobile){
 var desktopCommon={particleCount:270,spread:160,startVelocity:130,gravity:0.25,ticks:330,colors:brandColors,zIndex:999999};
 confetti(Object.assign({},desktopCommon,{origin:{x:1.2,y:0.1},angle:210}));
 confetti(Object.assign({},desktopCommon,{origin:{x:-0.2,y:0.5},angle:20}));
 }else{
 confetti({particleCount:150,spread:70,startVelocity:60,gravity:0.4,ticks:430,origin:{x:0.5,y:1.05},angle:90,colors:brandColors,zIndex:999999});
 }
}
/* R136-confetti-export: expose hohFireConfetti so other modules
   (hoh-fresh-faces.js Legendary Shop confetti pick, etc.) can call
   the same canvas-confetti burst the raffle uses. The canvas-confetti
   library renders to a canvas at zIndex:999999 so it survives DOM
   churn and CSS class issues that broke the home-grown spawnConfetti.
   Without this export the function was only callable from inside this
   file's scope. */
window.hohFireConfetti = hohFireConfetti;

function hohMonthName(off){var d=new Date();d.setDate(1);d.setMonth(d.getMonth()+(off||0));return d.toLocaleString('en-US',{month:'long'});}
/* R67 -> R230: Mythic ticket bonus history. R67 added +3 raffle entries
   for mythic heroes, computed LIVE at read time. That meant the raffle
   weight and the hover Total sat 3 above the stored Supabase count for
   every mythic (hover 35, pill and database 32). R230 bakes the +3 INTO
   characters.tickets exactly once per hero, latched by the new
   mythic_bonus_granted column (backfill + BEFORE trigger in
   sql/R230-ticket-single-source-of-truth.sql), so entries now read
   STRAIGHT from the stored count. One number everywhere: pill, hover
   Total, winner card, win %, draw weight, database row. */
function hohEntriesFor(c){
 return hohDecomposeTickets(c).stored;
}
/* Live win-% for a character vs current pool. */
function hohWinPercent(c){
 if(!c||!allCharacters.length)return 0;
 var total=0;
 for(var i=0;i<allCharacters.length;i++)total+=hohEntriesFor(allCharacters[i]);
 return total>0?(hohEntriesFor(c)/total)*100:0;
}
function hohTotalEntries(){
 var total=0;
 allCharacters.forEach(function(c){total+=hohEntriesFor(c);});
 return total;
}
/* R166: God-mode raffle override.
   =====================================
   Jangela (god-mode-only) can pre-select the winner of the next
   "Simulate the Raffle" roll via the floating debug pill (see
   hohJangelaDebug.js). The selection is ONE-SHOT: it's consumed by
   the next hohPickWeightedWinner call, then auto-clears so subsequent
   rolls return to random.
   Two safety gates ensure this never bleeds into normal users:
     1. The setter (hohSetForcedWinner) only writes if hohIsGodMode()
        is currently true.
     2. The picker (hohPickWeightedWinner) double-checks god mode
        before honoring a stored selection — if the user signs out
        of god mode, any stored selection is cleared and ignored.
   localStorage key is intentionally simple so it's easy to clear
   manually from devtools if anything goes sideways. */
var HOH_FORCED_WINNER_KEY = 'hoh-debug-forced-winner-id';
window.hohSetForcedWinner = function(charId){
 if(!charId) return false;
 var godNow = (typeof window.hohIsGodMode === 'function') && window.hohIsGodMode();
 if(!godNow) return false;
 try { localStorage.setItem(HOH_FORCED_WINNER_KEY, String(charId)); } catch(_){}
 try { document.dispatchEvent(new CustomEvent('hoh:forced-winner-changed', { detail: { charId: String(charId) } })); } catch(_){}
 return true;
};
window.hohGetForcedWinnerId = function(){
 try { return localStorage.getItem(HOH_FORCED_WINNER_KEY) || null; } catch(_){ return null; }
};
window.hohClearForcedWinner = function(){
 try { localStorage.removeItem(HOH_FORCED_WINNER_KEY); } catch(_){}
 try { document.dispatchEvent(new CustomEvent('hoh:forced-winner-changed', { detail: { charId: null } })); } catch(_){}
};
function hohPickWeightedWinner(){
 var pool=allCharacters.filter(function(c){return c&&c.id;});
 if(!pool.length)return null;
 /* R166: One-shot god-mode override. Consume the forced selection
    BEFORE running the weighted pick so that any subsequent call
    (e.g. the user clicks "Run It Again" right after) goes back to
    truly random. If the user signed out of god mode after setting
    the override, treat the stored value as stale and clear it.
    R166-Z: Dispatch hoh:forced-winner-consumed BEFORE clearing so
    suppression listeners can distinguish "consumed by the spin"
    (start 10s grace timer → restore debug UI) from "user clicked
    Clear" (restore debug UI immediately). The clear event still
    fires after consumption via hohClearForcedWinner, but listeners
    can read the `consumed` flag on the consumed event to choose
    their behaviour. */
 try {
   var forcedId = (typeof window.hohGetForcedWinnerId === 'function') ? window.hohGetForcedWinnerId() : null;
   if(forcedId){
     var godNow = (typeof window.hohIsGodMode === 'function') && window.hohIsGodMode();
     if(!godNow){
       /* Stored override but no longer in god mode — purge & fall through. */
       if(typeof window.hohClearForcedWinner === 'function') window.hohClearForcedWinner();
     } else {
       var forcedChar = null;
       for(var fi = 0; fi < pool.length; fi++){
         if(pool[fi] && String(pool[fi].id) === String(forcedId)){ forcedChar = pool[fi]; break; }
       }
       /* Fire the consumed event FIRST so listeners can mark the
          state as "in grace" before the clear event arrives and
          might otherwise be interpreted as a user-initiated clear. */
       try {
         document.dispatchEvent(new CustomEvent('hoh:forced-winner-consumed', {
           detail: { charId: String(forcedId), foundInPool: !!forcedChar }
         }));
       } catch(_){}
       /* Consume the one-shot whether or not we found the char — if
          the hero was deleted between selection and roll, we don't
          want a stale entry to keep silently failing. */
       if(typeof window.hohClearForcedWinner === 'function') window.hohClearForcedWinner();
       if(forcedChar) return forcedChar;
       /* Fell through to random; log so it's obvious in devtools. */
       try { console.warn('[Raffle] Forced winner id "' + forcedId + '" not found in pool — falling back to random.'); } catch(_){}
     }
   }
 } catch(_){}
 var total=0;
 pool.forEach(function(c){total+=hohEntriesFor(c);});
 if(total<=0)return pool[Math.floor(Math.random()*pool.length)];
 var r=Math.random()*total;
 var cumulative=0;
 for(var i=0;i<pool.length;i++){
 cumulative+=hohEntriesFor(pool[i]);
 if(r<cumulative)return pool[i];
 }
 return pool[pool.length-1];
}

window.hohOpenRaffle=function(){
 hohShowRaffleIntro();
 if(typeof window.hohPresentViewportModal==='function')window.hohPresentViewportModal('hoh-raffle-modal');
 else{document.getElementById('hoh-raffle-modal').style.display='flex';document.body.style.overflow='hidden';}
};
window.hohCloseRaffle=function(){
 if(typeof window.hohDismissViewportModal==='function')window.hohDismissViewportModal('hoh-raffle-modal');
 else document.getElementById('hoh-raffle-modal').style.display='none';
 document.body.style.overflow='';
 forceCardsVisible();
};

function hohShowRaffleIntro(){if(typeof window.hohRenderRaffleIntro==='function')window.hohRenderRaffleIntro({total:hohTotalEntries(),chars:allCharacters.length,monthName:hohMonthName(0),pending:hohRosterArriving()});} /* HALL-SPEED-02: pending while the full roster is on its way */

function hohBuildTickerQueue(winner){
 var pool=allCharacters.filter(function(c){return c&&c.id;});
 if(!pool.length)return{queue:[],winnerIndex:0};

 var weighted=[];
 pool.forEach(function(c){
 var n=hohEntriesFor(c);
 for(var i=0;i<n;i++)weighted.push(c);
 });

 for(var i=weighted.length-1;i>0;i--){
 var j=Math.floor(Math.random()*(i+1));
 var tmp=weighted[i];weighted[i]=weighted[j];weighted[j]=tmp;
 }

 var targetLen=Math.min(50,Math.max(30,weighted.length));
 var queue=weighted.slice(0,targetLen);

 var winnerIndex=Math.min(queue.length-15,Math.max(20,28+Math.floor(Math.random()*6)-3));
 queue[winnerIndex]=winner;

 if(winnerIndex>0&&queue[winnerIndex-1]&&queue[winnerIndex-1].id===winner.id){
 var swapIdx=winnerIndex-5;
 if(swapIdx>=0){var t=queue[swapIdx];queue[swapIdx]=queue[winnerIndex-1];queue[winnerIndex-1]=t;}
 }
 if(winnerIndex<queue.length-1&&queue[winnerIndex+1]&&queue[winnerIndex+1].id===winner.id){
 var swapIdx2=winnerIndex+5;
 if(swapIdx2<queue.length){var t2=queue[swapIdx2];queue[swapIdx2]=queue[winnerIndex+1];queue[winnerIndex+1]=t2;}
 }

 return{queue:queue,winnerIndex:winnerIndex};
}

function hohTicketHtml(c,index,isWinner,hideTickets){
 var ticketImg=c.image_thumb_url||c.image_url;
/* R366: reel rows honour the saved reframe. object-fit:cover on a 64px square
   was centring every face, so heroes reframed on their card still scrolled past
   here with their heads cut off. Same getter as the hall grid. */
var tkPos=(typeof window.hohImgObjPos==='function')?window.hohImgObjPos(c.id,'primary'):'50% 50%';
var tkStyle=(typeof window.hohImgStyle==='function')?window.hohImgStyle(c.id,'primary'):('object-position:'+tkPos+';');
var img=ticketImg
? '<img class="hoh-raffle-ticket-img" src="'+ticketImg+'" alt="'+esc(c.name)+'" loading="lazy" decoding="async" crossorigin="anonymous" style="'+tkStyle+'">'
: '<div class="hoh-raffle-ticket-letter">'+esc((c.name||'?').charAt(0))+'</div>';
 var entries=hideTickets?0:hohEntriesFor(c);
 var meta=esc(c.race||'')+' '+esc(c.character_class||'');
 var winnerAttr=isWinner?' data-winner="true"':'';
 /* Subtle rarity outline + halo on each raffle ticket so the lucky
  draw simulation reads its tier ladder while it scrolls. Same tier
  vocabulary as the gallery cards. */
 var rar=hohGetRarity(c.hearts);
 /* R225: hideTickets is set when the summon reel reuses this row, so the spinner reads like
    the raffle draw but without the ticket count. */
 return '<div class="hoh-raffle-ticket hoh-raffle-rar-'+rar.tier+'" data-hero-id="'+esc(String(c.id||''))+'" data-index="'+index+'"'+winnerAttr+'>'+
 img+
 '<div class="hoh-raffle-ticket-info">'+
  '<div class="hoh-raffle-ticket-name">'+esc(c.name||'Unnamed')+'</div>'+
  '<div class="hoh-raffle-ticket-meta">'+meta+'  \u00b7  by '+esc(c.player_name||'Anonymous')+'</div>'+
 '</div>'+
 (hideTickets?'':'<div class="hoh-raffle-ticket-entries">'+entries+' '+(entries===1?'ticket':'tickets')+'</div>')+
 '</div>';
}

function hohPreloadImage(url,timeoutMs){
 return new Promise(function(resolve){
 if(!url){resolve();return;}
 var img=new Image();
 var done=false;
 var finish=function(){if(!done){done=true;resolve();}};
 img.onload=finish;
 img.onerror=finish;
 img.crossOrigin='anonymous';
 img.src=url;
 setTimeout(finish,timeoutMs||1200);
 });
}

window.hohRunRaffle=async function(trigger){
 /* HALL-SPEED-02: the draw waits for the full roster (every ticket), answering at once */
 if(!allCharacters.length){ if(hohRosterArriving()){ hohQueueRosterOpen('raffle',null,trigger||null); return; } hohShowRaffleIntro(); return; }
 if(trigger){
  trigger.disabled=true;
  trigger.setAttribute('aria-busy','true');
  trigger.textContent='⚔ Drawing…';
 }
 var winner=hohPickWeightedWinner();
 if(!winner)return;
 /* R380 (2026-08-06, Jan): the draw preview no longer pays hearts. The
    simulation itself is the reward. hohClaimActionHeart stays for summon,
    scene and tavern, which still pay. */

 var built=hohBuildTickerQueue(winner);
 var queue=built.queue;
 var winnerIndex=built.winnerIndex;
 if(!queue.length)return;

 await hohPreloadImage(winner.image_url,1200);

 document.getElementById('hoh-raffle-inner').innerHTML=
 '<div class="hoh-raffle-stage">'+
  '<div class="hoh-raffle-stage-line"></div>'+
  '<div class="hoh-raffle-ticker" id="hoh-raffle-ticker">'+
  queue.map(function(c,i){return hohTicketHtml(c,i,i===winnerIndex);}).join('')+
  '</div>'+
 '</div>';

 var ticker=document.getElementById('hoh-raffle-ticker');
 var stage=document.querySelector('.hoh-raffle-stage');
 if(!ticker||!stage)return;

 ticker.style.transition='none';
 ticker.style.transform='translate3d(0,560px,0)';

 requestAnimationFrame(function(){
 requestAnimationFrame(function(){
  var winnerTicket=ticker.querySelector('[data-winner="true"]');
  if(!winnerTicket){
  console.error('[Raffle] Winner ticket not found in DOM');
  return;
  }

  var winnerCenterY=winnerTicket.offsetTop+(winnerTicket.offsetHeight/2);

  var targetY=-Math.round(winnerCenterY);

  ticker.style.transition='transform 4.2s cubic-bezier(0.12,0.62,0.26,1)';
  ticker.style.transform='translate3d(0,'+targetY+'px,0)';

  setTimeout(function(){hohShowWinner(winner);},4350);
 });
 });
};

function hohShowWinner(winner){
 /* R229: the winner is now on screen. Signal the suppression manager so
    it times the debug-UI grace from the reveal (a full minute after the
    character is actually rolled), not from the earlier pick call that
    fires ~4s before this. */
 try { document.dispatchEvent(new CustomEvent('hoh:forced-winner-revealed', { detail: { charId: winner && winner.id } })); } catch(_){}
 var total=hohTotalEntries();
 var entries=hohEntriesFor(winner);
 var pct=total>0?((entries/total)*100):0;
 var pctStr=pct<1?pct.toFixed(2):pct.toFixed(1);
 /* R165 -> R230: the winner card uses the SAME canonical decomposition as
    the hover breakdown (hohDecomposeTickets), so the two surfaces can
    never disagree. The buckets sum to entries === winner.tickets, the
    exact Supabase value the hero was drawn with. */
 var d=hohDecomposeTickets(winner);
 var breakdown=[];
 breakdown.push('<span>1</span> base ticket');
 if(d.ff>0)breakdown.push('<span>'+d.ff+'</span> FramedFantasy bonus');
 if(d.mythic>0)breakdown.push('<span>'+d.mythic+'</span> mythic bonus');
 if(d.earned>0)breakdown.push('<span>'+d.earned+'</span> earned &amp; applied ticket'+(d.earned===1?'':'s'));

 /* R366: the reveal card honours the saved reframe too. It was the loudest
    version of the bug: a 140px square hard-cropped to centre on the one screen
    the whole simulator builds toward. */
 var winPos=(typeof window.hohImgObjPos==='function')?window.hohImgObjPos(winner.id,'primary'):'50% 50%';
 var winStyle=(typeof window.hohImgStyle==='function')?window.hohImgStyle(winner.id,'primary'):('object-position:'+winPos+';');
 var img=winner.image_url
 ? '<img class="hoh-raffle-winner-img" data-hero-id="'+esc(String(winner.id||''))+'" src="'+winner.image_url+'" alt="'+esc(winner.name)+'" loading="lazy" decoding="async" crossorigin="anonymous" style="'+winStyle+'">'
 : '<div class="hoh-raffle-winner-letter">'+esc((winner.name||'?').charAt(0))+'</div>';

 var meta=esc(winner.race||'')+' '+esc(winner.character_class||'')+(winner.level?'  \u00b7  Level '+winner.level:'');

 document.getElementById('hoh-raffle-inner').innerHTML=
 '<div class="hoh-raffle-winner">'+
  '<div class="hoh-raffle-winner-label">'+hohMonthName(0)+'’s Winner</div>'+
  img+
  '<h2 class="hoh-raffle-winner-name">'+esc(winner.name||'Unnamed')+'</h2>'+
  '<p class="hoh-raffle-winner-meta">'+meta+'</p>'+
  '<p class="hoh-raffle-winner-player">Submitted by '+esc(winner.player_name||'Anonymous')+'</p>'+
  '<div class="hoh-raffle-winner-breakdown">'+
  '<div class="hoh-raffle-winner-bd-label">How they won</div>'+
  '<div class="hoh-raffle-winner-bd-line">'+breakdown.join(' + ')+' = <span>'+entries+'</span> total tickets</div>'+
  '<div class="hoh-raffle-winner-bd-line" style="margin-top:6px;">Drawn from <span>'+total.toLocaleString()+'</span> total tickets across <span>'+allCharacters.length+'</span> heroes ('+pctStr+'% chance)</div>'+
  '</div>'+
  '<div class="hoh-raffle-winner-actions">'+
  '<button type="button" class="hoh-raffle-again-btn" onclick="hohRunRaffle(this)">Run It Again</button>'+
  '<button type="button" class="hoh-raffle-view-btn" onclick="hohViewRaffleWinner(\''+winner.id+'\')">View Character</button>'+
  '</div>'+
 '</div>';

 if(typeof window.hohResetViewportModal==='function')window.hohResetViewportModal('hoh-raffle-modal');

 setTimeout(function(){hohFireConfetti();},200);
}

window.hohViewRaffleWinner=function(id){
 hohCloseRaffle();
 hohCloseRules();
 /* Open synchronously in the same frame. The old 150ms gap briefly exposed
    the Hall between two full-screen surfaces, which was especially obvious
    through Safari's translucent browser chrome. */
 hohOpenDetail(id);
};

var hohQuestHandoff=null;
function hohQuestNotice(message){
 var box=document.getElementById('hoh-draft-notice');
 if(box){box.style.display='block';box.textContent=message;}
}
/* The Hall PIN for a Quest hand-off: typed, or this device's Hall sign-in for the Quest's email (a 4-digit PIN, or a
   Google or emailed-code session, HALL-SIGNIN-03, also one still waiting for its first hero). */
function hohQuestPin(){
 var pin=hohWizVal('hoh-f-pin');
 if(!pin&&hohQuestHandoff&&!hohQuestHandoff.draft.debug&&!hohQuestHandoff.pinRejected){
  try{var s=typeof window!=='undefined'&&window.ffSignIn&&window.ffSignIn.session;
   var t=s?window.ffSignIn.session():JSON.parse(localStorage.getItem('hoh-your-hall-token')||'null');if(t&&String(t.email||'').toLowerCase()===hohQuestHandoff.draft.hero.email&&hohQuestPinOk(t.pin))pin=t.pin;}catch(_){}
 }
 return pin;
}
function hohQuestPinOk(v){return /^(?:\d{4}|g1\.[0-9a-f]{64})$/.test(v||'');}
function hohFillQuestForm(entry){
 var c=entry.hero;
 [['name','name'],['player','player_name'],['email','email'],['level','level'],['campaign','campaign'],['story','story'],
  ['npc-goal','npc_current_goal'],['npc-weakness','npc_hidden_weakness'],['npc-habit','npc_habit'],
  ['npc-catchphrase','npc_catchphrase'],['npc-secret','npc_secret'],['npc-enemy','npc_enemy']].forEach(function(pair){
   var el=document.getElementById('hoh-f-'+pair[0]);if(el)el.value=c[pair[1]]||'';
  });
 ['race','class'].forEach(function(key){
  var value=c[key==='race'?'race':'character_class']||'',el=document.getElementById('hoh-f-'+key);
  if(!value)return;
  var known=Array.prototype.some.call(el.options,function(o){return o.value===value;});
  el.value=known?value:'Other';
  if(!known){var custom=document.getElementById('hoh-f-custom-'+key);custom.value=value;custom.style.display='block';}
 });
 var em=document.getElementById('hoh-f-email');
 // The Quest email owns this draft. A different saved Hall session never replaces it.
 if(em&&c.email)em.readOnly=true;
 if(entry.draft.debug){
  if(em&&!em.value)em.value='jangela@example.test';
  var player=document.getElementById('hoh-f-player');if(player&&!player.value)player.value='Jangela';
 }
 var pin=document.getElementById('hoh-f-pin'),field=pin.closest('.hoh-field');
 field.querySelector('.hoh-label').textContent='Your Hall PIN *';
 pin.addEventListener('input',validateForm);
 field.querySelector('.hoh-field-note').textContent='Pick 4 digits, or use your existing Hall PIN. Your email and PIN let you return to edit this hero.';
 if(hohQuestPin())field.style.display='none';
 var ff=document.getElementById('hoh-f-ff-portrait');ff.checked=!!c.is_ff_portrait;window.__hohFfConfirmed=!!c.is_ff_portrait;
 if(window.hohTools)window.hohTools.stepRestore(c.card_meta||{});
 if(c.card_meta){
  if(c.card_meta.edited){document.getElementById('hoh-f-legend').value=c.card_meta.legend||'';document.getElementById('hoh-f-quote').value=c.card_meta.quote||'';}
  document.getElementById('hoh-f-artist').value=c.card_meta.artist||'';
 }
 try{hohResetNpcStatsModuleState(c.stats_block||null);}catch(_){}
 for(var i=0;i<2;i++){
  var url=c[i?'image_url_2':'image_url'];
  if(url){
   selectedFiles[i]='keep';
   var zone=document.getElementById('hoh-upload-zone-'+i);zone.onclick=null;zone.removeAttribute('onclick');
   zone.innerHTML='<img src="'+esc(url)+'" alt="Your Quest portrait"><button type="button" class="hoh-upload-overlay-replace" onclick="document.getElementById(\'hoh-file-'+i+'\').click()">Replace photo</button>';
  }else if(entry.files[i])handleFileForZone(i,entry.files[i]);
 }
 var questNote=entry.draft.debug?(entry.draft.debugSample?'Jangela preview. Blank Quest fields use sample details. Nothing will be published.':'Jangela preview. Review your Quest character through each step. Nothing will be published.'):'Your Quest character is filled in. Review each step and add anything missing. Publishing makes this hero visible in the Hall.';
 if(entry.draft.portraitCount&&!c.image_url&&!entry.files[0])questNote+=' Your browser could not carry the portrait over. Please upload it at the portrait step.';
 hohQuestNotice(questNote);
 hohWizGo(1,true);validateForm();
}
function hohQuestSuccess(c,preview){
 /* R795: a Quest hero just published (the submit armed the watch) goes to
    fill in its hero page, like any other submit. A preview, or a reopened
    handoff for a hero published earlier, keeps this screen. */
 if(!preview) hohSubmitConfetti();
 if(!preview&&c&&hohHeroFillHandoff(c.name,c.id)) return;
 document.getElementById('hoh-form-modal-title').textContent=preview?'Quest preview complete':"You're In!";
 document.getElementById('hoh-form-inner').innerHTML='<div class="hoh-success"><h3 class="hoh-success-title">'+esc(c.name)+(preview?' is ready for the Hall':' has entered the Hall')+'</h3>'+
  '<p class="hoh-success-text">'+(preview?'This was a Jangela preview. Nothing was published or sent to your marketing integrations.':'Your character is live. Your Quest blueprint and card stay connected to this hero.')+'</p>'+
  (preview?'<button class="hoh-btn-primary" onclick="hohOpenQuestHandoff()">Review the Quest character again</button>':'<button class="hoh-btn-primary" onclick="hohViewAfterSubmit(\''+esc(c.id)+'\')">View Your Hero</button>')+'</div>';
 try{if(window.hohResetViewportModal)window.hohResetViewportModal('hoh-form-modal');}catch(_){}
}
window.hohOpenQuestHandoff=async function(){
 var match=window.location.hash.match(/^#quest=([a-f0-9-]{36})$/i);
 if(!match||!window.FFQuestHall)return;
 var entry=await window.FFQuestHall.read(match[1]);
 if(!entry){hohOpenForm();hohQuestNotice('This Quest handoff has expired or could not be read. Your original Quest tab still has your character. Open the Hall link there again.');return;}
 try{
  var c=entry.draft.debug?null:await window.FFQuestHall.find(supabase,entry.draft,HOH_CHAR_COLS);
  entry.hero=window.FFQuestHall.merge(entry.draft,c);
  hohOpenForm(entry);
  if(c&&c.quest_meta&&c.quest_meta.hall_handoff_id===entry.draft.key&&c.approved===true&&c.is_hidden===false){entry.completed=true;hohQuestSuccess(c,false);}
 }catch(_){
  hohOpenForm();hohQuestNotice('Your Quest character could not be loaded. Keep your Quest tab open and tap its Hall link again.');
 }
};
// Open independently of the gallery request, which may be slow on an ad browser.
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){window.hohOpenQuestHandoff();});
else setTimeout(function(){window.hohOpenQuestHandoff();},0);
/* R800 (Battlegrounds 2, §11): the game's Add your hero links land on #add-hero, which opens this same
   Add a Hero form at once (the same form and tracking as the Hall's own button). The hash is cleared so
   Back or a reload does not open it again. */
function hohOpenAddHeroFromHash(){
 if(window.location.hash!=='#add-hero'||typeof window.hohOpenForm!=='function')return;
 try{history.replaceState(null,'',window.location.pathname+window.location.search);}catch(_){}
 window.hohOpenForm();
 try{hohTakeHomeBuild();}catch(_){}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',hohOpenAddHeroFromHash);
else setTimeout(hohOpenAddHeroFromHash,0);
/* HALL-GOOGLE-01: the answer to the form's "Continue with Google". It ran in its own window, so the form is normally
   still open with every word typed and the picture chosen: its name and email rows follow the sign-in in place
   (hohFormIdentity). If the form was closed meanwhile, it opens, filled in the same way. A sign-in that didn't finish
   says so and leaves the form as it was, so the email can be typed instead. */
if(window.hohGoogle)window.hohGoogle.onResult(function(res){
 if(!res||res.from!=='form')return;
 function say(t,l){ if(typeof window.hohShowHeartToast==='function'){ try{ window.hohShowHeartToast(t,l); }catch(_){} } }
 function go(){
  var modal=document.getElementById('hoh-form-modal');
  var open=!!(modal&&getComputedStyle(modal).display!=='none'&&document.getElementById('hoh-f-email')&&!window.hohEditingCharacterId&&!hohQuestHandoff);
  if(!res.ok){ if(res.message) say('Google sign-in',res.message); if(!open&&res.reason!=='cancel'&&typeof window.hohOpenForm==='function') window.hohOpenForm(); return; }
  if(!open){ if(typeof window.hohOpenForm==='function') window.hohOpenForm(); return; }
  hohFormIdentity();
  try{ validateForm(); }catch(_){}
  try{ if(HOH_WIZ.on) hohWizPaint(); }catch(_){}
  say('Signed in with Google',res.email);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else setTimeout(go,0);
});
/* The form's name, email and PIN rows for whoever is signed in (or not) right now. hohOpenForm runs it, and so does a
   Google sign-in that finishes while the form is open (HALL-GOOGLE-01), so its rows follow the sign-in in place. */
function hohFormIdentity(){
 /* R48: For signed-in users, HIDE the player name + email field
    wrappers entirely instead of locking them. The values get
    populated under the hood from the session so the submit still
    has them; the user just never sees the redundant inputs they
    already filled out at sign-in. For signed-out users both fields
    stay visible and editable as before.
    Defensive: also clear any stale readOnly / locked-class from a
    previous render so signed-out users don\'t inherit lock state
    from a prior signed-in session in the same tab. */
 try {
  var pNameEl = document.getElementById('hoh-f-player');
  var pEmailEl = document.getElementById('hoh-f-email');
  var pNameField = pNameEl && pNameEl.closest ? pNameEl.closest('.hoh-field') : null;
  var pEmailField = pEmailEl && pEmailEl.closest ? pEmailEl.closest('.hoh-field') : null;
  var signedInEmail = (typeof window.hohYourHallEmail === 'function')
    ? window.hohYourHallEmail() : '';
  /* R166 (Layer 2): Derive the canonical player_name from the user's
     OWN earliest character (email match in the global pool) before
     falling back to the cached display name. Belt-and-suspenders for
     the submit-time canonicalization in hohSubmitCharacter — even if
     that hook ever regresses, the form here shows the truth so the
     hidden value the submit handler reads is correct. */
  var signedInName = '';
  try {
    var emKey = String(signedInEmail || '').trim().toLowerCase();
    if(emKey && typeof window.hohGetAllCharacters === 'function'){
      var poolOF = window.hohGetAllCharacters() || [];
      var mineOF = poolOF.filter(function(ch){
        return ch && ch.email && String(ch.email).trim().toLowerCase() === emKey;
      });
      if(mineOF.length){
        mineOF.sort(function(a, b){
          var ta = a && a.created_at ? new Date(a.created_at).getTime() : Infinity;
          var tb = b && b.created_at ? new Date(b.created_at).getTime() : Infinity;
          return ta - tb;
        });
        for(var oi = 0; oi < mineOF.length; oi++){
          var pn = mineOF[oi] && mineOF[oi].player_name;
          if(pn && String(pn).trim()){ signedInName = String(pn).trim(); break; }
        }
      }
    }
  } catch(_){}
  /* Fall back to the cached display name only if we couldn't find a
     canonical one in the user's own characters. */
  if(!signedInName){
    signedInName = (typeof window.hohYourHallDisplayName === 'function')
      ? window.hohYourHallDisplayName() : '';
  }
  /* Player name shares a 2-column .hoh-row with Character Name. When
     player is hidden the row leaves an empty grid cell, so we also
     collapse the row to a single column so Character Name takes the
     full width. The parent row is the closest ancestor with class
     hoh-row above the player field. */
  var playerRow = pNameField && pNameField.parentNode && pNameField.parentNode.classList
    && pNameField.parentNode.classList.contains('hoh-row')
    ? pNameField.parentNode : null;
  if(signedInEmail){
   /* Signed in: write session values into the inputs, hide the
      wrappers. validateForm reads .value.trim() so the populated
      hidden inputs still pass the gate. The submit handler reads
      the same fields and persists them as the row\'s player_name
      and email. */
   if(pNameEl) pNameEl.value = signedInName || '';
   if(pEmailEl) pEmailEl.value = signedInEmail;
   if(pNameField) pNameField.style.display = 'none';
   if(pEmailField) pEmailField.style.display = 'none';
   if(playerRow) playerRow.style.gridTemplateColumns = '1fr';
   /* R381 (Jan): signed in = no Hall PIN question. The email field above is
      session-locked, and the submit handler already falls back to the
      session PIN when this field is empty (R106), so the input is pure
      noise for a signed-in user. Only hide when the session carries BOTH
      email and PIN — an email-only token (R103) still needs to set one. */
   try {
    if(typeof hohIsSignedInRobust === 'function' && hohIsSignedInRobust()){
      var _pinEl381 = document.getElementById('hoh-f-pin');
      var _pinField381 = _pinEl381 && _pinEl381.closest ? _pinEl381.closest('.hoh-field') : null;
      if(_pinField381) _pinField381.style.display = 'none';
    }
   } catch(_){}
  } else {
   /* Signed out: ensure the fields are visible and unlocked. This
      protects against a tab where the user signed out mid-session
      and hohOpenForm runs again — without these resets, the hide +
      lock state from the prior signed-in render would persist. */
   if(pNameField) pNameField.style.display = '';
   if(pEmailField) pEmailField.style.display = '';
   if(playerRow) playerRow.style.gridTemplateColumns = '';
   /* R381: mirror reset for the PIN field the signed-in branch hides. */
   try {
    var _pinEl381o = document.getElementById('hoh-f-pin');
    var _pinField381o = _pinEl381o && _pinEl381o.closest ? _pinEl381o.closest('.hoh-field') : null;
    if(_pinField381o) _pinField381o.style.display = '';
   } catch(_){}
   if(pNameEl){ pNameEl.readOnly = false; pNameEl.classList.remove('hoh-input-locked'); }
   if(pEmailEl){ pEmailEl.readOnly = false; pEmailEl.classList.remove('hoh-input-locked'); }
  }
 } catch(_){}
 /* HALL-GOOGLE-01: signed in (by PIN or Google) there is no Google offer. Back from Google with an email that has no
    hero yet, the email is Google's and locked, the name is filled in when empty, and the PIN is optional (the
    session waits in hoh-google-signin.js until this hero is in, then hohSubmitCharacter makes it the sign-in). */
 try {
  var _gBox=document.getElementById('hoh-form-google');
  var _gSigned=(typeof window.hohYourHallEmail==='function')&&!!window.hohYourHallEmail();
  var _gNew=(!_gSigned&&window.hohGoogle)?window.hohGoogle.pendingNew():null;
  if(_gBox){ _gBox.style.display=(_gSigned||_gNew)?'none':''; if(!_gSigned&&!_gNew&&window.hohGoogle) window.hohGoogle.fill(_gBox); }
  if(_gNew){
   var _gEm=document.getElementById('hoh-f-email'), _gPl=document.getElementById('hoh-f-player'), _gPin=document.getElementById('hoh-f-pin');
   if(_gEm){
    _gEm.value=_gNew.email; _gEm.readOnly=true; _gEm.classList.add('hoh-input-locked');
    var _gEmNote=_gEm.parentNode&&_gEm.parentNode.querySelector('.hoh-field-note');
    if(_gEmNote) _gEmNote.textContent='Signed in. No spam, and never shown publicly.';
   }
   if(_gPl&&!_gPl.value.trim()&&_gNew.name) _gPl.value=String(_gNew.name).trim().slice(0,40);
   /* HALL-SIGNIN-03: signed in by Google or an emailed code (which works inside Instagram and Facebook too), no PIN is asked */
   var _gPinField=_gPin&&_gPin.closest?_gPin.closest('.hoh-field'):null;
   if(_gPinField) _gPinField.style.display='none';
   try { hohUpdateSmsVisibility(); } catch(_){}
  }
 } catch(_){}
}
window.hohOpenForm=function(questEntry){
 hohQuestHandoff=questEntry&&questEntry.draft?questEntry:null;
 clearTimeout(hohDraftTimer);
 window.hohEditingCharacterId=null;
 /* R268: a fresh submit starts unconfirmed, so checking the FF box makes the
    submit gate ask for confirmation. */
 window.__hohFfConfirmed=false;
 if(typeof window.hohPresentViewportModal==='function')window.hohPresentViewportModal('hoh-form-modal');
 else document.getElementById('hoh-form-modal').style.display='flex';
 /* R257: keep the framed-fantasy bonus quiet for a first submission.
    The two DM completion-ticket chips stay visible because they explain
    the rewards available on this screen. Edit mode shows every chip. */
 try{
  var _fmEl=document.getElementById('hoh-form-modal');
  if(_fmEl) _fmEl.classList.toggle('hoh-first-run', !hohHasSubmittedBefore());
 }catch(_){}
 document.body.style.overflow='hidden';
 showFormView();
 if(hohQuestHandoff){hohFillQuestForm(hohQuestHandoff);return;}
 /* R140-Z3p: Reset the NPC stats module — fresh form gets a blank
    stats panel, mounted lazily once the story gate trips. */
 try { hohResetNpcStatsModuleState(null); } catch(_){}
 hohFormIdentity();
 /* Re-validate after the hide/show + value writes so the submit
    button enables/disables correctly on the new state. validateForm
    reads input values and updates the button gate. */
 try { validateForm(); } catch(_){}
};
/* R364: How it works is the one modal in this file that never listened for
 Escape. The pack modal, the unlock confirm and submit-to-earn all do, so a
 reader who learned Escape anywhere else in the Hall pressed it here and
 nothing happened. The listener is bound once and checks the modal is really
 on screen before it fires, so it cannot steal the key from a modal opened on
 top of this one. Opening also parks focus on the close button, which is what
 makes Tab continue inside the modal instead of behind it, and closing hands
 focus back to whatever opened it. */
window.hohOpenRules=function(){
 var m=document.getElementById('hoh-rules-modal');
 if(!m)return;
 try{ window._hohRulesOpener=document.activeElement; }catch(_){ window._hohRulesOpener=null; }
 m.style.display='flex';
 document.body.style.overflow='hidden';
 try{ m.scrollTop=0; var sc=m.querySelector('.hoh-rules-content'); if(sc)sc.scrollTop=0; }catch(_){}
 try{ var x=m.querySelector('.hoh-rules-close'); if(x)setTimeout(function(){try{x.focus({preventScroll:true});}catch(_){}} ,0); }catch(_){}
 if(!document._hohRulesEscBound){
  document._hohRulesEscBound=true;
  document.addEventListener('keydown',function(ev){
   if(ev.key!=='Escape')return;
   var mm=document.getElementById('hoh-rules-modal');
   if(mm&&mm.style.display!=='none'&&mm.style.display!==''){ window.hohCloseRules(); }
  });
 }
};
window.hohCloseRules=function(){
 var m=document.getElementById('hoh-rules-modal');
 if(m)m.style.display='none';
 document.body.style.overflow='';
 try{ var o=window._hohRulesOpener; window._hohRulesOpener=null;
      if(o&&o.focus&&document.contains(o))o.focus({preventScroll:true}); }catch(_){}
};
/* "What is this?" explainer modal. Opens via the link under the main
 CTA. Closing clears overflow so other modals (like the form, opened
 from the modal's CTA) can take over without inheriting locked scroll. */
window.hohOpenExplain=function(){var m=document.getElementById('hoh-explain-modal');if(!m)return;m.style.display='flex';document.body.style.overflow='hidden';};
window.hohCloseExplain=function(){var m=document.getElementById('hoh-explain-modal');if(m)m.style.display='none';document.body.style.overflow='';};
window.hohCloseForm=function(){window.hohEditingCharacterId=null;
 /* R574: release the preview's object URL. It is one URL per submission, so
    nothing dramatic, but a blob held after the form closes pins the whole
    image in memory for the rest of the session for no reason. */
 try{ if(_hohCardImgURL){ URL.revokeObjectURL(_hohCardImgURL); _hohCardImgURL=null; _hohCardImgFor=null; } }catch(_){ }if(typeof window.hohDismissViewportModal==='function')window.hohDismissViewportModal('hoh-form-modal');else document.getElementById('hoh-form-modal').style.display='none';document.body.style.overflow='';forceCardsVisible();hohFlashSubmissionBonusIfPending();var fid=window.hohJustSubmittedFreshId;if(fid){window.hohJustSubmittedFreshId=null;if(window.hohFreshFacesHighlight)window.hohFreshFacesHighlight(fid);}};
/* If the user just submitted, the pill and floating +N bubble were
 hidden behind the form modal. This fires the animation again the
 moment the modal closes so they actually see the cause-and-effect
 of submission unlocking new hearts. */
function hohFlashSubmissionBonusIfPending(){
 if(!window.hohPendingBonusFlash)return;
 window.hohPendingBonusFlash=false;
 setTimeout(function(){
 if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(HOH_HEART_BONUS,true);
 },220);
}
/* HALLFLOWS: the "What counts?" explainer is a real dialog now. It is named by
   its heading, takes focus when it opens, keeps Tab inside, closes on Escape
   (only itself, never the form under it) and gives focus back to the button
   that opened it. The markup lives in the section, so the dialog attributes
   are set here on the first open. */
function hohFfQualifyBox(m){ return m.querySelector('.hoh-ff-qualify-content') || m; }
function hohFfQualifyOpen(){ var m=document.getElementById('hoh-ff-qualify-modal'); return m && m.style.display && m.style.display!=='none' ? m : null; }
window.hohOpenFfQualify=function(trigger){
 var m=document.getElementById('hoh-ff-qualify-modal');if(!m)return;
 var box=hohFfQualifyBox(m),title=m.querySelector('.hoh-ff-qualify-title');
 if(title&&!title.id)title.id='hoh-ff-qualify-title';
 box.setAttribute('role','dialog');box.setAttribute('aria-modal','true');box.setAttribute('tabindex','-1');
 if(title)box.setAttribute('aria-labelledby',title.id);
 m.__hohOpener=(trigger&&typeof trigger.focus==='function')?trigger:document.activeElement;
 m.style.display='flex';document.body.style.overflow='hidden';
 try{box.focus({preventScroll:true});}catch(_){try{box.focus();}catch(__){}}
};
window.hohCloseFfQualify=function(){var m=document.getElementById('hoh-ff-qualify-modal');if(!m)return;m.style.display='none';var form=document.getElementById('hoh-form-modal');if(!form||form.style.display!=='flex')document.body.style.overflow='';
 var o=m.__hohOpener;m.__hohOpener=null;
 if(o&&o.isConnected&&typeof o.focus==='function'){try{o.focus({preventScroll:true});}catch(_){try{o.focus();}catch(__){}}}
};
/* Capture phase, so this runs before the Hall's own dialog keys (which stand
   aside while the explainer is up) and Escape can never reach the form. */
document.addEventListener('keydown',function(ev){
 var m=hohFfQualifyOpen();if(!m)return;
 if(ev.key==='Escape'){ev.preventDefault();ev.stopPropagation();window.hohCloseFfQualify();return;}
 if(ev.key!=='Tab')return;
 ev.stopPropagation();
 var box=hohFfQualifyBox(m),f=Array.prototype.filter.call(box.querySelectorAll('a[href],button:not([disabled])'),function(el){return el.getClientRects().length>0;});
 if(!f.length){ev.preventDefault();return;}
 var first=f[0],last=f[f.length-1],a=document.activeElement;
 if(!box.contains(a)||a===box){ev.preventDefault();(ev.shiftKey?last:first).focus();return;}
 if(ev.shiftKey&&a===first){ev.preventDefault();last.focus();}
 else if(!ev.shiftKey&&a===last){ev.preventDefault();first.focus();}
},true);
/* R769: the zoom row under an edit frame. Two small rings with thin stroked
   glyphs and no percentage readout: the portrait is the readout, and the
   number was colliding with the next frame's label on desktop. `opts.bare`
   leaves the inline handlers off so the hero reviewer can wire its own. */
var HOH_ZOOM_MINUS_SVG='<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M3 8h10"></path></svg>';
var HOH_ZOOM_PLUS_SVG='<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M3 8h10"></path><path d="M8 3v10"></path></svg>';
/* The grip badge in the frame corner: up/down chevrons for one axis (CSS turns
   them sideways for a wide image), four chevrons once the art can pan both ways. */
var HOH_GRIP_SVG_Y='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="8 6 12 2 16 6"></polyline><polyline points="8 18 12 22 16 18"></polyline></svg>';
var HOH_GRIP_SVG_XY='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M2 12h20"></path><polyline points="9 5 12 2 15 5"></polyline><polyline points="9 19 12 22 15 19"></polyline><polyline points="5 9 2 12 5 15"></polyline><polyline points="19 9 22 12 19 15"></polyline></svg>';
function hohEditZoomHtml(value, opts){
 var z=parseInt(value,10);if(isNaN(z))z=100;z=Math.max(100,Math.min(200,z));
 var bare=!!(opts&&opts.bare);
 return '<div class="hoh-edit-img-zoom" onclick="event.stopPropagation()">'+
  '<span class="hoh-edit-img-zoom-label">Zoom</span>'+
  '<button type="button" class="hoh-edit-img-zoom-step" aria-label="Zoom out"'+(bare?'':' onclick="hohStepImageZoom(this,-5)"')+'>'+HOH_ZOOM_MINUS_SVG+'</button>'+
  '<input class="hoh-edit-img-zoom-range" type="range" min="100" max="200" step="5" value="'+z+'" aria-label="Portrait zoom"'+(bare?'':' oninput="hohPreviewImageZoom(this)" onchange="hohCommitImageZoom(this)"')+'>'+
  '<button type="button" class="hoh-edit-img-zoom-step" aria-label="Zoom in"'+(bare?'':' onclick="hohStepImageZoom(this,5)"')+'>'+HOH_ZOOM_PLUS_SVG+'</button>'+
 '</div>';
}
window.hohEditZoomHtml=hohEditZoomHtml;
function handleFileForZone(idx,file){
 if(!file||!file.type.startsWith('image/'))return;
 selectedFiles[idx]=file;
 var r=new FileReader();
 r.onload=function(e){
  var zone=document.getElementById('hoh-upload-zone-'+idx);
  if(!zone) return;
  /* R65: render the SAME draggable frame the edit flow uses, so users
     can reposition the image right after upload. We track the offset
     under a temp key (__hoh_new_primary / __hoh_new_secondary) and
     read it back at submit time so the chosen crop SAVES to the
     server and applies for everyone. */
  var slot = idx === 0 ? 'primary' : 'secondary';
  var tempId = '__hoh_new_' + slot;
  /* FITEDITOR (Jan, 2026-10-14): the main picture opens in the fit editor
     (hohFitEditor) right here on the picture screen. The picture is measured
     first so it lands at its smart default (a tall picture starts at the
     top, where 77% of manual fixes moved it) instead of the centre crop that
     cuts heads off. The second picture keeps the frame below. */
  if(idx === 0 && typeof hohFitEditor === 'function'){
   var src0 = e.target.result, probe = new Image(), mounted = false;
   var mountFit = function(){
    if(mounted) return; mounted = true;
    if(selectedFiles[0] !== file) return; /* a newer pick already replaced this one */
    var d = hohFitSmartDefault(probe.naturalWidth, probe.naturalHeight);
    try { window.hohSetImageOffsetX(tempId, slot, d.x); window.hohSetImageOffsetY(tempId, slot, d.y); window.hohSetImageZoom(tempId, slot, d.zoom); } catch(_){}
    zone.classList.add('hoh-upload-edit', 'hoh-fit-host');
    hohFitEditor(zone, {
     mode: 'new', id: tempId, slot: slot, src: src0, base: d, alt: 'Your portrait',
     after: '<button type="button" class="hoh-upload-overlay-replace" onclick="event.stopPropagation();var input=document.getElementById(\'hoh-file-0\');if(input){input.value=\'\';input.click();}">Replace photo</button>'
    });
    /* HALL-BUILD: the live card takes the picture with this smart framing */
    try { hohLiveCardSync(); } catch(_){}
   };
   probe.onload = mountFit; probe.onerror = mountFit; probe.src = src0;
   return;
  }
  /* Default offset for a fresh upload: 50% (centered). Reset any
     stale temp from a previous attempt. */
  if(typeof window.hohSetImageOffsetY === 'function'){
   try { window.hohSetImageOffsetY(tempId, slot, 50); } catch(_){}
  }
  if(typeof window.hohSetImageOffsetX === 'function'){
   try { window.hohSetImageOffsetX(tempId, slot, 50); } catch(_){}
  }
  if(typeof window.hohSetImageZoom === 'function'){
   try { window.hohSetImageZoom(tempId, slot, 100); } catch(_){}
  }
  /* R136-mobile-reframe: tag the parent zone so CSS can drop the
     square aspect-ratio + overflow:hidden that otherwise CLIP the
     help text and Save Reframe button below the frame on mobile.
     Without this class the frame fills the entire 1:1 parent box
     and the controls below it disappear behind the parent's
     overflow boundary — the user could drag but never save. */
  zone.classList.add('hoh-upload-edit');
  zone.innerHTML =
    '<div class="hoh-edit-img-frame" data-offset="50" data-offset-x="50" data-zoom="100" data-charid="' + tempId + '" data-slot="' + slot + '">' +
      '<img src="' + e.target.result + '" alt="Preview" style="object-position:50% 50%;transform-origin:50% 50%;scale:1;" draggable="false">' +
      '<div class="hoh-edit-img-grip" aria-label="Drag to reposition">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' +
          '<polyline points="8 6 12 2 16 6"></polyline><polyline points="8 18 12 22 16 18"></polyline>' +
        '</svg>' +
      '</div>' +
    '</div>' +
    /* R79: Removed the hoh-upload-overlay class from the Replace
       button — that class is for the upload-zone overlay banner
       (position:absolute;bottom:0) and was making the Replace button
       sit on top of the help text. The button now uses only the
       replace-specific class which renders inline below the help. */
    '<div class="hoh-edit-img-help">Drag the portrait up or down to reframe.</div>' +
    hohEditZoomHtml(100) +
    '<button type="button" class="hoh-upload-overlay-replace" onclick="event.stopPropagation();var input=document.getElementById(\'hoh-file-' + idx + '\');if(input){input.value=\'\';input.click();}">Replace photo</button>';
  if(typeof hohWireImageReposition === 'function'){
   try { hohWireImageReposition(zone, tempId, slot); } catch(_){}
  }
 };
 r.readAsDataURL(file);
 validateForm();
}
window.hohPreviewImg=function(idx,input){if(input.files&&input.files[0])handleFileForZone(idx,input.files[0]);};
function setupDragDrop(){for(var i=0;i<2;i++){(function(idx){var zone=document.getElementById('hoh-upload-zone-'+idx);if(!zone)return;zone.addEventListener('dragover',function(e){e.preventDefault();e.stopPropagation();zone.classList.add('hoh-drag-over');});zone.addEventListener('dragleave',function(e){e.preventDefault();e.stopPropagation();zone.classList.remove('hoh-drag-over');});zone.addEventListener('drop',function(e){e.preventDefault();e.stopPropagation();zone.classList.remove('hoh-drag-over');if(e.dataTransfer.files&&e.dataTransfer.files[0])handleFileForZone(idx,e.dataTransfer.files[0]);});})(i);}}

/* ============ DEVICE RATE LIMITS ============
 Soft gates stored in localStorage. One character submission per day.
 Three Company gatherings per day. Timer resets at local midnight.
 Day key uses toDateString so browser timezone = user's felt day. */
var HOH_SUBMIT_DAY_KEY='hoh-submit-day-v1';
var HOH_COMPANY_USAGE_KEY='hoh-company-count-v1';
var HOH_COMPANY_DAILY_CAP=3;
function hohToday(){return new Date().toDateString();}
function hohHasSubmittedToday(){
 try{
  if(localStorage.getItem(HOH_SUBMIT_DAY_KEY)!==hohToday()) return false;
  /* Legendary Shop "extra submission" unlock: if the user picked the
     50-heart trade today, they get one extra submission today only.
     The shop sets hoh-extra-sub-{ymd} on pick. We CONSUME the flag
     here so the second submission doesn't accidentally enable a
     third — first call after the shop unlock returns false (i.e.
     "not yet submitted today" from the gate's perspective), then
     the flag is cleared so subsequent calls return true again. */
  var ymd = new Date().toISOString().slice(0,10);
  var flagKey = 'hoh-extra-sub-' + ymd;
  if(localStorage.getItem(flagKey) === '1'){
   localStorage.removeItem(flagKey);
   return false;
  }
  return true;
 }catch(e){return false;}
}
function hohMarkSubmittedToday(){
 try{localStorage.setItem(HOH_SUBMIT_DAY_KEY,hohToday());}catch(e){}
 /* R425: the same moment also records that this device has submitted at
    least once, ever — which is what lets the wizard's opening gate drop the
    "why submit" pitch for someone who has already been sold. Written here,
    on the one call every successful submission passes through, rather than
    in the submit handler where a future branch could miss it. */
 try{ if(typeof window.hohWizMarkSubmitted === 'function') window.hohWizMarkSubmitted(); }catch(e){}
}

/* R148-Z17: Pay-300-hearts second submission flow.
   When the user has already submitted today, validateForm renders a
   pay button that calls this. We check the heart bank, deduct 300,
   set the SAME `hoh-extra-sub-{ymd}` flag the Legendary Shop uses
   (so hohHasSubmittedToday's existing consumption logic applies) AND
   set a separate `hoh-extra-sub-paid-{ymd}` flag that the submission
   flow checks LATER to skip the ticket grant — paid extra subs don't
   get a raffle ticket per user spec. */
var HOH_EXTRA_SUB_COST = 300;
function hohExtraSubFlagKey(){
  var ymd = new Date().toISOString().slice(0,10);
  return 'hoh-extra-sub-' + ymd;
}
function hohExtraSubPaidFlagKey(){
  var ymd = new Date().toISOString().slice(0,10);
  return 'hoh-extra-sub-paid-' + ymd;
}
function hohExtraSubPaidToday(){
  try { return localStorage.getItem(hohExtraSubPaidFlagKey()) === '1'; }
  catch(_){ return false; }
}
function hohConsumeExtraSubPaid(){
  try { localStorage.removeItem(hohExtraSubPaidFlagKey()); } catch(_){}
}
window.hohPayForExtraSubmission = function(){
  var btn = document.getElementById('hoh-submit-cooldown-pay-btn');
  var bank = (typeof window.heartsRemainingToday === 'function') ? window.heartsRemainingToday() : 0;
  if(bank < HOH_EXTRA_SUB_COST){
    if(typeof window.hohShowHeartToast === 'function'){
      try { window.hohShowHeartToast('Need ' + (HOH_EXTRA_SUB_COST - bank) + ' more hearts', 'Second submissions cost 300 hearts.'); } catch(_){}
    }
    if(btn){
      btn.classList.add('hoh-submit-cooldown-pay-deny');
      setTimeout(function(){ btn.classList.remove('hoh-submit-cooldown-pay-deny'); }, 600);
    }
    return;
  }
  /* Deduct from wallet — fires hoh:hearts-bumped so the wallet pill
     counts down. */
  try {
    if(typeof window.hohRemoveHeartsFromBank === 'function'){
      window.hohRemoveHeartsFromBank(HOH_EXTRA_SUB_COST, 'spend_submission');
    }
  } catch(_){}
  /* Set BOTH flags. The first is the existing entitlement that
     hohHasSubmittedToday() consumes to allow today's submission. The
     second tells the submission flow this was paid → skip ticket. */
  try { localStorage.setItem(hohExtraSubFlagKey(), '1'); } catch(_){}
  try { localStorage.setItem(hohExtraSubPaidFlagKey(), '1'); } catch(_){}
  /* Toast confirmation. */
  if(typeof window.hohShowHeartToast === 'function'){
    try { window.hohShowHeartToast('Unlocked!', 'Submit your second hero. No raffle ticket this time.'); } catch(_){}
  }
  /* Re-run the form's validation pass so the cooldown notice hides
     and the submit button enables. hohValidateSubmitForm is the
     internal name; we trigger it indirectly by re-running validate
     on the name input which kicks the same chain. */
  try {
    var n = document.getElementById('hoh-f-name');
    if(n) n.dispatchEvent(new Event('input', { bubbles: true }));
  } catch(_){}
};

/* Edit access: gated by Your Hall sign-in (PIN + auth_email match). */
window.hohEditingCharacterId=null;
/* ============================================================
   IMAGE REPOSITION
   Drag-to-adjust the vertical crop on a hero's portrait. Stored
   per-device in localStorage for now (key: hoh-img-offsets-v1)
   so the user can fix a head-cropped portrait without re-uploading.
   The render layer (cards, detail modal, share canvases) reads
   the offset via hohGetImageOffsetY and applies object-position.

   UPGRADE PATH: when an image_offset_y INT2 column is added to the
   characters table, change hohGetImageOffsetY to read c.image_offset_y
   first (with the localStorage fallback for in-flight session edits)
   and add the field to updatePayload in the edit-save handler. The
   rest of the pipeline uses the same getter so no other changes are
   needed.
   ============================================================ */
var HOH_IMG_OFFSETS_KEY = 'hoh-img-offsets-v1';
/* R381b PERF: this map was localStorage.getItem + JSON.parse on EVERY call,
   and every card image asks for its crop twice (x and y) — hundreds of parses
   per grid paint on a big collection. Parse once, cache the object; the ONLY
   writer (hohWriteImageOffsets, below) replaces the cache, and a cross-tab
   write busts it via the storage listener (same pattern as the hearts cache
   near the top of this file). Callers that mutate the returned map and then
   write it back stay correct — writer and cache hold the same reference. */
var __hohImgOffCache = null;
try{ window.addEventListener('storage', function(e){ if(e && e.key === 'hoh-img-offsets-v1') __hohImgOffCache = null; }); }catch(_){}
function hohReadImageOffsets(){
  if(__hohImgOffCache) return __hohImgOffCache;
  try {
    var raw = localStorage.getItem(HOH_IMG_OFFSETS_KEY);
    __hohImgOffCache = raw ? (JSON.parse(raw) || {}) : {};
  } catch(_){ __hohImgOffCache = {}; }
  return __hohImgOffCache;
}
function hohWriteImageOffsets(map){
  __hohImgOffCache = map;   /* R381b PERF: the writer owns the cache */
  try { localStorage.setItem(HOH_IMG_OFFSETS_KEY, JSON.stringify(map)); }
  catch(_){}
}
/* Returns 0..100. 50 = center (default). 0 = top of image visible,
   100 = bottom. The slot lets us track primary + secondary portraits
   independently. */
/* R381b PERF: the offset getters ran a LINEAR find over the full character
   pool per call — and every card image calls twice (x then y). A hundred-tile
   grid over a 3000-row pool was ~600k comparisons per paint. This index maps
   id → row and rebuilds itself whenever the pool array is reassigned or its
   length changes, so answers stay identical. (A same-length in-place element
   swap would serve the old row until the next pool change; the reframe flow
   repaints via direct style writes, so no visible surface depends on that.) */
var __hohCharIdx = null, __hohCharIdxRef = null, __hohCharIdxLen = -1;
function __hohCharById(id){
  try {
    /* HALL-SPEED-02 follow-up (Jan, 2026-10-23: "all of the hall's reframes dont seem to be displayed in the main hall"):
       the grid paints from the light rows before the full roster lands, and they carry image_offset_x/y and image_zoom,
       so while they are all there is, the framing reads them. Reading only allCharacters drew every tile at the centre,
       and hohReconcileLightTiles never repainted it: both of its renders asked this same lookup, which by then had the
       full roster, so they matched while the grid on screen still showed the centre. */
    var pool = (typeof allCharacters !== 'undefined' && allCharacters && allCharacters.length) ? allCharacters
      : (typeof _hohRosterLight !== 'undefined' && _hohRosterLight && _hohRosterLight.length ? _hohRosterLight : null);
    if(!pool) return null;
    if(__hohCharIdxRef !== pool || __hohCharIdxLen !== pool.length){
      __hohCharIdx = {};
      for(var i = 0; i < pool.length; i++){
        var c = pool[i];
        if(c && c.id != null) __hohCharIdx[String(c.id)] = c;
      }
      __hohCharIdxRef = pool;
      __hohCharIdxLen = pool.length;
    }
    var hit = __hohCharIdx[String(id)] || null;
    if(hit) return hit;
    /* R769: a hidden hero is not in the visible pool, so its saved crop and
       zoom never reached these getters. The hero reviewer's card painted the
       centre and approve wrote that centre back over the owner's reframe.
       Misses are rare (hidden ids and the upload's temp ids), so a linear
       look through the hidden and review rows costs nothing on a grid paint. */
    var sid = String(id), extra = [window.__hohHidden, window.__hohReviewRows];
    for(var e = 0; e < extra.length; e++){
      var list = extra[e];
      if(!Array.isArray(list)) continue;
      for(var k = 0; k < list.length; k++){
        if(list[k] && list[k].id != null && String(list[k].id) === sid) return list[k];
      }
    }
    return null;
  } catch(_){ return null; }
}
window.hohGetImageOffsetY = function(charId, slot){
  if(!charId) return 50;
  var s = slot || 'primary';
  /* R45: server-column path. When the characters row has a saved
     image_offset_y (or image_offset_y_2 for the secondary slot),
     prefer that — it\'s the shared/canonical value visible to every
     visitor. localStorage stays as a per-device override that takes
     precedence (so a user who just dragged sees the new value
     instantly, before the next page load when the row re-fetches).
     Resolution order:
       1. localStorage (just-dragged, this session)
       2. characters.image_offset_y (server, shared)
       3. 50 (centered default)
     If the SQL columns don\'t exist yet, c.image_offset_y is just
     undefined and we fall through to localStorage / default. */
  var map = hohReadImageOffsets();
  var key = String(charId) + ':' + s;
  var local = map[key];
  if(typeof local === 'number' && local >= 0 && local <= 100) return local;
  try {
    var c = __hohCharById(charId);   /* R381b PERF: indexed, was a linear find */
    if(c){
      var serverVal = (s === 'secondary') ? c.image_offset_y_2 : c.image_offset_y;
      if(typeof serverVal === 'number' && serverVal >= 0 && serverVal <= 100) return serverVal;
    }
  } catch(_){}
  return 50;
};
window.hohSetImageOffsetY = function(charId, slot, offset){
  if(!charId) return;
  var map = hohReadImageOffsets();
  var key = String(charId) + ':' + (slot || 'primary');
  var clamped = Math.max(0, Math.min(100, parseInt(offset, 10) || 0));
  map[key] = clamped;
  hohWriteImageOffsets(map);
  /* Notify any rendered surfaces so they can re-paint object-position
     without a full re-render. The R44 listener below applies the
     repaint immediately to every img on the page that belongs to
     this character — works on the main hall gallery, Fresh Faces
     rail, detail modal, My Favorites cast cards, custom company
     builder, and any future surface that uses character cards. */
  try {
    document.dispatchEvent(new CustomEvent('hoh:image-offset-changed', {
      detail: { charId: charId, slot: slot, offset: clamped }
    }));
  } catch(_){}
};
/* R200: HORIZONTAL offset, the left/right twin of the vertical one above. Wide
   images overflow their square frame sideways, so they pan on X. Stored in the
   same localStorage map under a ':x' key so the vertical values are untouched,
   and mirrored to image_offset_x / image_offset_x_2 columns when present. 50 =
   centered. Degrades to centered if the columns aren't there yet. */
window.hohGetImageOffsetX = function(charId, slot){
  if(!charId) return 50;
  var s = slot || 'primary';
  var map = hohReadImageOffsets();
  var local = map[String(charId) + ':' + s + ':x'];
  if(typeof local === 'number' && local >= 0 && local <= 100) return local;
  try {
    var c = __hohCharById(charId);   /* R381b PERF: indexed, was a linear find */
    if(c){
      var serverVal = (s === 'secondary') ? c.image_offset_x_2 : c.image_offset_x;
      if(typeof serverVal === 'number' && serverVal >= 0 && serverVal <= 100) return serverVal;
    }
  } catch(_){}
  return 50;
};
window.hohSetImageOffsetX = function(charId, slot, offset){
  if(!charId) return;
  var map = hohReadImageOffsets();
  var clamped = Math.max(0, Math.min(100, parseInt(offset, 10) || 0));
  map[String(charId) + ':' + (slot || 'primary') + ':x'] = clamped;
  hohWriteImageOffsets(map);
  try {
    document.dispatchEvent(new CustomEvent('hoh:image-offset-changed', {
      detail: { charId: charId, slot: slot, offset: clamped, axis: 'x' }
    }));
  } catch(_){}
};
/* Zoom is stored beside the two position axes. 100 means the existing crop;
   values up to 200 let an owner trim borders or move closer to the artwork.
   Older rows have no zoom value and therefore render exactly as before. */
window.hohGetImageZoom = function(charId, slot){
  if(!charId) return 100;
  var s = slot || 'primary';
  var map = hohReadImageOffsets();
  var local = map[String(charId) + ':' + s + ':zoom'];
  if(typeof local === 'number' && local >= 100 && local <= 200) return local;
  try {
    var c = __hohCharById(charId);
    if(c){
      var serverVal = (s === 'secondary') ? c.image_zoom_2 : c.image_zoom;
      if(typeof serverVal === 'number' && serverVal >= 100 && serverVal <= 200) return serverVal;
    }
  } catch(_){}
  return 100;
};
window.hohSetImageZoom = function(charId, slot, zoom){
  if(!charId) return;
  var s = slot || 'primary';
  var parsed = parseInt(zoom, 10);
  var clamped = Math.max(100, Math.min(200, isNaN(parsed) ? 100 : parsed));
  var map = hohReadImageOffsets();
  map[String(charId) + ':' + s + ':zoom'] = clamped;
  hohWriteImageOffsets(map);
  var y = 50;
  try { y = window.hohGetImageOffsetY(charId, s); } catch(_){}
  try {
    document.dispatchEvent(new CustomEvent('hoh:image-offset-changed', {
      detail: { charId: charId, slot: s, offset: y, zoom: clamped, axis: 'zoom' }
    }));
  } catch(_){}
};
/* R200: the full object-position string (X% Y%) for a hero's slot. Every render
   surface and the repaint use this so the two axes always travel together. */
window.hohImgObjPos = function(charId, slot){
  var x = 50, y = 50;
  try { if(typeof window.hohGetImageOffsetX === 'function') x = window.hohGetImageOffsetX(charId, slot); } catch(_){}
  try { if(typeof window.hohGetImageOffsetY === 'function') y = window.hohGetImageOffsetY(charId, slot); } catch(_){}
  if(typeof x !== 'number') x = 50;
  if(typeof y !== 'number') y = 50;
  return x + '% ' + y + '%';
};
window.hohImgScale = function(charId, slot){
  var zoom = 100;
  try { zoom = window.hohGetImageZoom(charId, slot); } catch(_){}
  if(typeof zoom !== 'number' || zoom < 100 || zoom > 200) zoom = 100;
  return String(Math.round(zoom) / 100);
};
/* R769: how far a portrait can travel inside its frame, per axis, in screen
   pixels. object-fit:cover overflows one axis by the aspect difference, and any
   zoom above 100 overflows both, since the scaled art is `zoom` times the frame
   and its focal point rides object-position. A drag maps one to one against
   this so the art follows the finger and stops at its own edge. Zero means the
   axis cannot move at all. Shared by the edit frame and the hero reviewer. */
window.hohImgPanRange = function(img, box, zoom){
  var W = (box && box.width) || 0, H = (box && box.height) || 0;
  var z = parseInt(zoom, 10); if(isNaN(z)) z = 100; z = Math.max(100, Math.min(200, z)) / 100;
  var nw = (img && img.naturalWidth) || 0, nh = (img && img.naturalHeight) || 0;
  var ox = 0, oy = 0;
  if(W > 0 && H > 0 && nw > 0 && nh > 0){
    var s = Math.max(W / nw, H / nh);
    ox = Math.max(0, nw * s - W);
    oy = Math.max(0, nh * s - H);
  }
  return { x: W * (z - 1) + z * ox, y: H * (z - 1) + z * oy };
};
/* One safe inline-style value for every DOM portrait. `scale` is the
   independent transform property, so existing card flip/hover transforms keep
   working. The saved focal point is also the zoom origin. */
window.hohImgStyle = function(charId, slot){
  var pos = window.hohImgObjPos(charId, slot);
  return 'object-position:' + pos + ';transform-origin:' + pos + ';scale:' + window.hohImgScale(charId, slot) + ';';
};
/* SAVESTICK: one cleanup per account on this device (hoh-img-offsets-clean-v1),
   once the roster is loaded. Older saves never removed their device keys, and
   those beat the server here forever.
     - The signed-in owner's own heroes (auth_email is them): their device keys
       go, so the server value wins, including any fix Jan made since.
     - Jan's god-mode device: only keys equal to the server value go; the ones
       that differ stay and are listed in window.__hohLocalOnlyFraming.
     - Everyone else's overrides on a visitor's device are left alone. */
function hohCleanLocalFramingOnce(){
  try {
    if(typeof allCharacters === 'undefined' || !allCharacters || !allCharacters.length) return;
    var email = String((typeof window.hohYourHallEmail === 'function' && window.hohYourHallEmail()) || '').trim().toLowerCase();
    if(!email) return;
    var god = typeof window.hohIsGodMode === 'function' && !!window.hohIsGodMode();
    var FLAG = 'hoh-img-offsets-clean-v1', done = [];
    try { done = JSON.parse(localStorage.getItem(FLAG) || '[]') || []; } catch(_){ done = []; }
    if(!Array.isArray(done)) done = [];
    var tags = ['owner:' + email].concat(god ? ['god:' + email] : []).filter(function(t){ return done.indexOf(t) < 0; });
    if(!tags.length) return;
    var map = hohReadImageOffsets(), touched = {}, differ = [];
    Object.keys(map).forEach(function(k){
      var m = /^(.+):(primary|secondary)(?::(x|zoom))?$/.exec(k);
      if(!m || /^__hoh_new_/.test(m[1])) return;
      var c = __hohCharById(m[1]);
      if(!c) return;
      var mine = !!c.auth_email && String(c.auth_email).trim().toLowerCase() === email;
      if(mine && tags.indexOf('owner:' + email) >= 0){ delete map[k]; touched[m[1] + '|' + m[2]] = 1; return; }
      if(!god || tags.indexOf('god:' + email) < 0) return;
      var axis = m[3] || 'y', col = (axis === 'x' ? 'image_offset_x' : (axis === 'zoom' ? 'image_zoom' : 'image_offset_y')) + (m[2] === 'secondary' ? '_2' : '');
      var sv = c[col]; if(typeof sv !== 'number') sv = axis === 'zoom' ? 100 : 50;
      if(map[k] === sv){ delete map[k]; touched[m[1] + '|' + m[2]] = 1; } else differ.push(k);
    });
    if(Object.keys(touched).length){
      hohWriteImageOffsets(map);
      Object.keys(touched).slice(0, 400).forEach(function(t){ var p = t.split('|'); try { window.hohForceImageOffsetRepaint(p[0], p[1]); } catch(_){} });
    }
    if(god) window.__hohLocalOnlyFraming = differ;
    try { localStorage.setItem(FLAG, JSON.stringify(done.concat(tags))); } catch(_){}
  } catch(_){}
}
window.hohCleanLocalFramingOnce = hohCleanLocalFramingOnce;
document.addEventListener('hoh:characters-loaded', function(){ setTimeout(hohCleanLocalFramingOnce, 0); });
/* R128-F: Direct force-repaint helper. The save handler calls this
   AFTER the cache pin + AFTER renderGallery so the freshly-mounted (or
   FLIP-grid-reused) card IMG nodes get hit with the latest offset
   regardless of any listener race or DOM-reuse quirk.
   Why this exists despite the event-based listener: the FLIP grid
   reuses existing DOM nodes for keys that survived the rebuild, which
   means a card whose IMG carried the OLD inline style will still carry
   it after renderGallery. The listener fires from setImageOffsetY and
   from the save dispatch, but each fire targets the DOM at THAT
   moment — if the FLIP grid runs in between and reuses the old node,
   the old style sticks. By calling this helper explicitly from the
   save handler AFTER renderGallery, we guarantee the final-state DOM
   matches the saved offset, no matter what the FLIP grid did.
   Walks the same selector list as the listener (kept in sync), uses
   setProperty with !important + reflow so CSS rules can't win, and
   also targets party-slot images via the party data map. */
window.hohForceImageOffsetRepaint = function(charId, slot){
  if(!charId) return;
  var id = String(charId);
  var s = slot || 'primary';
  var offset;
  try {
    offset = (typeof window.hohGetImageOffsetY === 'function')
      ? window.hohGetImageOffsetY(charId, s)
      : 50;
  } catch(_){ offset = 50; }
  if(typeof offset !== 'number') offset = 50;
  /* R200: paint BOTH axes so a horizontal crop rides along with the vertical. */
  var posStyle = (typeof window.hohImgObjPos === 'function') ? window.hohImgObjPos(charId, s) : ('50% ' + offset + '%');
  var scaleStyle = (typeof window.hohImgScale === 'function') ? window.hohImgScale(charId, s) : '1';
  var sel = [
    '.hoh-card[data-hero-id="' + id + '"] img',
    '.hoh-fresh-card[data-id="' + id + '"] img',
    '.hoh-yh-card[data-hero-id="' + id + '"] img',
    '.hoh-cast-card[data-hero-id="' + id + '"] img',
    '.hoh-fresh-quiz-card[data-quiz-char-id="' + id + '"] img',
    '[data-cast-open="' + id + '"] img',
    '[data-hero-id="' + id + '"] .hoh-yh-media img',
    '[data-hero-id="' + id + '"] .hoh-fresh-media img',
    '.hoh-company-custom-hero[data-hero-id="' + id + '"] img',
    /* R134-C: Stream target cards (Underdog / Rich Get Richer / Feed
       Your Own / Promotion / Familiar Crowd hosts) and culprit-grid
       cards (Find the Culprit / Find the Imposter / Familiar Crowd
       cards) — these all show character portraits and need the
       reframe to apply live across Explore the Hall. */
    '.hoh-fresh-stream-target[data-stream-id="' + id + '"] img',
    '.hoh-fresh-culprit-card[data-id="' + id + '"] img',
    '.hoh-fresh-familiar-card[data-id="' + id + '"] img',
    '.hoh-fresh-pickcard-host .hoh-fresh-card-host[data-id="' + id + '"] img',
    /* R366: the Win a Free Portrait spotlight and the raffle simulator. Neither
       was on this list, so a reframe saved while the page was open left both
       surfaces on the old crop until a full reload. */
    '.hoh-spotlight-winner-media[data-hero-id="' + id + '"] img',
    '.hoh-spotlight-winner-media[data-hero-id="' + id + '"] video',
    '.hoh-raffle-winner-img[data-hero-id="' + id + '"]',
    '.hoh-raffle-ticket[data-hero-id="' + id + '"] .hoh-raffle-ticket-img',
    /* R667: THE MARQUEE UNDER THE TITLE. It has always BUILT with the saved
       crop (hohImgObjPos at build time), so it is right on every fresh load
       and was only ever wrong in the window between a save and the next
       reload, which is exactly the window Jan looks at after re-cropping a
       hero. Its tile is a button carrying data-hero, not data-hero-id, so
       not one of the selectors above could ever reach it. */
    '.hoh-mq-i[data-hero="' + id + '"] img',
    /* R793.1: Explore the Hall's square portrait is framed like the grid
       tile, so a saved reframe reaches it the moment it lands too. */
    '.hoh-xev-hero[data-hero-id="' + id + '"] .hoh-xev-portrait img'
  ].join(',');
  if(s === 'primary') sel += ',.hoh-hall-card-view[data-hero-id="' + id + '"] .is-front .ffshop-art img,.hoh-hall-card-view[data-hero-id="' + id + '"] .is-front .ffshop-artfull img';
  try {
    var imgs = document.querySelectorAll(sel);
    for(var i = 0; i < imgs.length; i++){
      try {
        imgs[i].style.setProperty('object-position', posStyle, 'important');
        imgs[i].style.setProperty('transform-origin', posStyle, 'important');
        imgs[i].style.setProperty('scale', scaleStyle, 'important');
        void imgs[i].offsetHeight;
      } catch(__){
        try { imgs[i].style.objectPosition = posStyle; imgs[i].style.transformOrigin = posStyle; imgs[i].style.scale = scaleStyle; } catch(___){}
      }
    }
  } catch(_){}
  /* Detail modal — repaint if currently open and matches. Important
     mostly for the secondary slot since the modal nav re-renders on
     swap; primary stays even with R127-B's object-fit: contain (the
     style is harmless when the IMG isn't being cropped, but stays
     correct if the card ever switches back to cover). */
  try {
    var modal = document.getElementById('hoh-modal');
    if(modal && modal.style.display === 'flex'){
      var detailHero = (typeof currentDetail !== 'undefined' && currentDetail) ? currentDetail : null;
      if(detailHero && String(detailHero.id) === id){
        var detailImg = modal.querySelector('.hoh-detail-img img');
        if(detailImg && (!detailImg.dataset.htArtwork || (detailImg.dataset.htArtProcessed !== 'true' && detailImg.dataset.htLegacySlot === s))){
          try {
            detailImg.style.setProperty('object-position', posStyle, 'important');
            detailImg.style.setProperty('transform-origin', posStyle, 'important');
            detailImg.style.setProperty('scale', scaleStyle, 'important');
            void detailImg.offsetHeight;
          } catch(__){
            try { detailImg.style.objectPosition = posStyle; detailImg.style.transformOrigin = posStyle; detailImg.style.scale = scaleStyle; } catch(___){}
          }
        }
      }
    }
  } catch(_){}
  /* Party slots — same loop as the listener uses. */
  try {
    var slots = document.querySelectorAll('.hoh-party-slot.hoh-party-slot-filled');
    if(slots.length && typeof window.hohHallGet === 'function'){
      var hall = window.hohHallGet();
      var partyMap = {};
      (hall && hall.parties || []).forEach(function(p){ partyMap[p.id] = p.slots || []; });
      for(var si = 0; si < slots.length; si++){
        var pid = slots[si].getAttribute('data-party-id');
        var idx = parseInt(slots[si].getAttribute('data-slot-idx'), 10);
        if(!pid || isNaN(idx)) continue;
        var heroIdAtSlot = (partyMap[pid] || [])[idx];
        if(heroIdAtSlot && String(heroIdAtSlot) === id){
          var slotImg = slots[si].querySelector('.hoh-party-slot-img');
          if(slotImg){
            try {
              slotImg.style.setProperty('object-position', posStyle, 'important');
              slotImg.style.setProperty('transform-origin', posStyle, 'important');
              slotImg.style.setProperty('scale', scaleStyle, 'important');
              void slotImg.offsetHeight;
            } catch(__){
              try { slotImg.style.objectPosition = posStyle; slotImg.style.transformOrigin = posStyle; slotImg.style.scale = scaleStyle; } catch(___){}
            }
          }
        }
      }
    }
  } catch(_){}
};
/* R44: live repaint on image-offset save. The hohWireImageReposition
   onUp handler calls hohSetImageOffsetY which dispatches the event
   above. Without this listener the new offset only takes effect on
   the next page render — users who saved a re-crop saw their cards
   in the grid stay at the OLD position until they refreshed.
   We query every selector pattern character cards use across the
   site (data-hero-id, data-id, data-quiz-char-id, data-cast-open,
   data-second-chance-id) so the repaint hits every surface. The
   primary slot covers card thumbnails; the detail modal might use
   primary or secondary depending on which image is open. */
/* R133-A: When a hero gets newly capped (cap_rejected just fired),
   live-tag every rendered card surface so the heart button visually
   disables without waiting for a re-render. Adds the same classes
   the card-render path uses on initial paint. */
document.addEventListener('hoh:char-capped-today', function(e){
  if(!e || !e.detail || !e.detail.charId) return;
  var id = String(e.detail.charId);
  try {
    /* Main hall cards */
    var mainCards = document.querySelectorAll('.hoh-card[data-hero-id="' + id + '"]');
    for(var i = 0; i < mainCards.length; i++){
      mainCards[i].classList.add('hoh-card-capped-today');
      var hb = mainCards[i].querySelector('.hoh-heart-btn');
      if(hb && !hb.classList.contains('hoh-heart-btn-mythic-locked')){
        hb.classList.add('hoh-heart-btn-capped-today');
      }
    }
    /* Detail modal — if the open hero matches, tag its big heart button. */
    var modal = document.getElementById('hoh-modal');
    if(modal && modal.style.display === 'flex'){
      var detailHero = (typeof currentDetail !== 'undefined' && currentDetail) ? currentDetail : null;
      if(detailHero && String(detailHero.id) === id){
        var dh = document.getElementById('hoh-detail-heart');
        if(dh) dh.classList.add('hoh-heart-btn-capped-today');
      }
    }
  } catch(_){}
});
document.addEventListener('hoh:image-offset-changed', function(e){
  if(!e || !e.detail || !e.detail.charId) return;
  var id = String(e.detail.charId);
  var slot = e.detail.slot || 'primary';
  var offset = e.detail.offset;
  if(typeof offset !== 'number') return;
  /* R200: re-read both axes so an X-only or Y-only change paints the combined crop. */
  var posStyle = (typeof window.hohImgObjPos === 'function') ? window.hohImgObjPos(id, slot) : ('50% ' + offset + '%');
  var scaleStyle = (typeof window.hohImgScale === 'function') ? window.hohImgScale(id, slot) : '1';
  /* CSS.escape would be cleaner but isn\'t supported in older Safari.
     Character IDs are UUIDs (no quotes/backslashes) so plain string
     interpolation is safe here. */
  /* R110: Party slots (.hoh-party-slot) don't carry data-hero-id — they
     have data-party-id + data-slot-idx. So the slot IMGs aren't matched
     by the standard selectors. We loop those separately below using the
     party-data API, which is the canonical hero-by-slot resolver. */
  var sel = [
    '.hoh-card[data-hero-id="' + id + '"] img',
    '.hoh-fresh-card[data-id="' + id + '"] img',
    '.hoh-yh-card[data-hero-id="' + id + '"] img',
    '.hoh-cast-card[data-hero-id="' + id + '"] img',
    '.hoh-fresh-quiz-card[data-quiz-char-id="' + id + '"] img',
    '[data-cast-open="' + id + '"] img',
    '[data-hero-id="' + id + '"] .hoh-yh-media img',
    '[data-hero-id="' + id + '"] .hoh-fresh-media img',
    '.hoh-company-custom-hero[data-hero-id="' + id + '"] img',
    /* R134-C: Stream target cards (Underdog / Rich Get Richer / Feed
       Your Own / Promotion / Familiar Crowd hosts) and culprit-grid
       cards (Find the Culprit / Find the Imposter / Familiar Crowd
       cards) — these all show character portraits and need the
       reframe to apply live across Explore the Hall. */
    '.hoh-fresh-stream-target[data-stream-id="' + id + '"] img',
    '.hoh-fresh-culprit-card[data-id="' + id + '"] img',
    '.hoh-fresh-familiar-card[data-id="' + id + '"] img',
    '.hoh-fresh-pickcard-host .hoh-fresh-card-host[data-id="' + id + '"] img',
    /* R366: the Win a Free Portrait spotlight and the raffle simulator. Neither
       was on this list, so a reframe saved while the page was open left both
       surfaces on the old crop until a full reload. */
    '.hoh-spotlight-winner-media[data-hero-id="' + id + '"] img',
    '.hoh-spotlight-winner-media[data-hero-id="' + id + '"] video',
    '.hoh-raffle-winner-img[data-hero-id="' + id + '"]',
    '.hoh-raffle-ticket[data-hero-id="' + id + '"] .hoh-raffle-ticket-img',
    /* R667: THE MARQUEE UNDER THE TITLE. It has always BUILT with the saved
       crop (hohImgObjPos at build time), so it is right on every fresh load
       and was only ever wrong in the window between a save and the next
       reload, which is exactly the window Jan looks at after re-cropping a
       hero. Its tile is a button carrying data-hero, not data-hero-id, so
       not one of the selectors above could ever reach it. */
    '.hoh-mq-i[data-hero="' + id + '"] img',
    /* R793.1: Explore the Hall's square portrait is framed like the grid
       tile, so a saved reframe reaches it the moment it lands too. */
    '.hoh-xev-hero[data-hero-id="' + id + '"] .hoh-xev-portrait img'
  ].join(',');
  if(slot === 'primary') sel += ',.hoh-hall-card-view[data-hero-id="' + id + '"] .is-front .ffshop-art img,.hoh-hall-card-view[data-hero-id="' + id + '"] .is-front .ffshop-artfull img';
  try {
    var imgs = document.querySelectorAll(sel);
    for(var i = 0; i < imgs.length; i++){
      /* R128-F: Force repaint with priority + reflow.
         Previous attempts at live offset propagation worked in
         theory but the user kept reporting the grid never updated
         after Save Changes. The most likely failure mode is the
         FLIP grid (hohSmoothGridUpdate) reusing existing DOM nodes
         whose IMG inline style was set BEFORE the listener fired —
         the new build output is computed and discarded. To make the
         repaint robust against any reuse path, we now:
           1. setProperty with 'important' so no class/CSS rule wins
           2. Force a reflow so the browser actually repaints (some
              browsers coalesce style changes across the same frame)
           3. Also clear and re-set in a microtask in case the FLIP
              grid is mid-animation and would otherwise stomp us.
         Setting style.objectPosition directly continues to work in
         the simple case; the priority + reflow only matters when the
         card was reused from the FLIP grid. */
      try {
        imgs[i].style.setProperty('object-position', posStyle, 'important');
        imgs[i].style.setProperty('transform-origin', posStyle, 'important');
        imgs[i].style.setProperty('scale', scaleStyle, 'important');
        /* Reflow: read offsetHeight forces layout, ensuring the
           style change actually paints. Without this, batched style
           updates can be optimized away by the browser when nothing
           else triggers a paint. */
        void imgs[i].offsetHeight;
      } catch(__){
        /* Last-resort fallback: plain assignment. */
        try { imgs[i].style.objectPosition = posStyle; imgs[i].style.transformOrigin = posStyle; imgs[i].style.scale = scaleStyle; } catch(___){}
      }
    }
  } catch(_){}
  /* R110: Party slot IMGs — walk every party slot button, look up the
     hero in that slot via the hall-party data, and repaint matching
     ones. This catches both the My Party tab and the dashboard
     Your Parties view. */
  try {
    var slots = document.querySelectorAll('.hoh-party-slot.hoh-party-slot-filled');
    if(slots.length && typeof window.hohHallGet === 'function'){
      var hall = window.hohHallGet();
      var partyMap = {};
      (hall && hall.parties || []).forEach(function(p){ partyMap[p.id] = p.slots || []; });
      for(var si = 0; si < slots.length; si++){
        var pid = slots[si].getAttribute('data-party-id');
        var idx = parseInt(slots[si].getAttribute('data-slot-idx'), 10);
        if(!pid || isNaN(idx)) continue;
        var heroIdAtSlot = (partyMap[pid] || [])[idx];
        if(heroIdAtSlot && String(heroIdAtSlot) === id){
          var slotImg = slots[si].querySelector('.hoh-party-slot-img');
          if(slotImg){ slotImg.style.objectPosition = posStyle; slotImg.style.transformOrigin = posStyle; slotImg.style.scale = scaleStyle; }
        }
      }
    }
  } catch(_){}
  /* Detail modal — only repaint if the open hero matches the edited
     id. The modal\'s img doesn\'t carry data-hero-id so we identify
     via the file-scoped currentDetail var (set in hohOpenDetail).
     We expose currentDetail on window for this listener since it
     lives at module scope. The slot check is conservative: we
     repaint regardless of slot because the detail image swaps via
     prev/next nav and we don\'t track which slot is currently
     visible — the worst case is a one-frame style write that
     doesn\'t match, which the next nav re-applies anyway. */
  try {
    var modal = document.getElementById('hoh-modal');
    if(modal && modal.style.display === 'flex'){
      var detailHero = (typeof currentDetail !== 'undefined' && currentDetail) ? currentDetail : null;
      if(detailHero && String(detailHero.id) === id){
        var detailImg = modal.querySelector('.hoh-detail-img img');
        if(detailImg && (!detailImg.dataset.htArtwork || (detailImg.dataset.htArtProcessed !== 'true' && detailImg.dataset.htLegacySlot === slot))){ detailImg.style.objectPosition = posStyle; detailImg.style.transformOrigin = posStyle; detailImg.style.scale = scaleStyle; }
      }
    }
  } catch(_){}
});
/* R129: Save-only-the-reframe handler. Wired to a dedicated "Save
   Reframe" button under the Character Portrait box in edit mode. Saves
   ONLY the offset (no full-form submit, no validation, no other
   fields) and updates every Hall card surface immediately.
   Why this exists despite the full Save Changes button also persisting
   the offset: the user repeatedly reported that Save Changes didn't
   propagate the new framing to the grid. Three rounds of fixes (R44,
   R109, R127-C, R128-F) tried to make the full save reliable, but the
   actual blocker was further upstream — the upload zone's parent
   onclick was opening the file picker on any click in the image area,
   so the drag never committed and the user never reached Save. R129
   removes that picker handler when an image exists AND adds this
   dedicated button so the user has a one-tap path to commit just the
   reframe with explicit, immediate visual confirmation. */
/* One server-persist path for a slot's full reframe. The zoom-aware RPC writes
   X, Y and zoom together and keeps the existing owner/admin authorization.
   The older offset RPC remains a compatibility fallback, but can only save X/Y;
   opts.warn tells the editor when zoom is still local to this device. */
/* ⛔ SAVESTICK (Jan, 2026-10-14: "make sure the reframe for users save").
   Three things made a reframe look saved when it was not:
     1. a refusal (ok:false, e.g. not_owner or bad_pin) fell through to an
        anon PATCH and then the old X/Y function, so the screen kept the
        player's crop whatever the server said;
     2. a confirmed save left this device's hoh-img-offsets-v1 keys behind,
        and those beat the server value forever on this device, so a later
        fix by Jan never showed there and the owner's next nudge saved the
        old crop back over it;
     3. nothing said what happened.
   Now a refusal stops. The PATCH and old-function fallbacks run only when
   set_character_image_reframe itself is missing (PGRST202 / 404). On the
   server's ok the in-memory row takes the saved values and this slot's device
   keys go (only those still equal to what was sent, so a newer change made
   during the save stays pending and is sent next). opts.onStatus(state,
   reason) hears 'saving', 'saved' or 'failed'. The boolean return is kept. */
function hohClearLocalFraming(charId, slot, only){
  if(!charId) return false;
  var s = (slot === 'secondary') ? 'secondary' : 'primary', base = String(charId) + ':' + s;
  var map = hohReadImageOffsets(), hit = false;
  [['', 'y'], [':x', 'x'], [':zoom', 'zoom']].forEach(function(p){
    var k = base + p[0];
    if(!Object.prototype.hasOwnProperty.call(map, k)) return;
    if(only && typeof only[p[1]] === 'number' && map[k] !== only[p[1]]) return;
    delete map[k]; hit = true;
  });
  if(hit) hohWriteImageOffsets(map);
  return hit;
}
window.hohClearLocalFraming = hohClearLocalFraming;
/* the add-hero form's temp framing (__hoh_new_primary / __hoh_new_secondary),
   removed once the hero exists */
function hohClearTempFraming(){
  var map = hohReadImageOffsets(), hit = false;
  Object.keys(map).forEach(function(k){ if(k.indexOf('__hoh_new_') === 0){ delete map[k]; hit = true; } });
  if(hit) hohWriteImageOffsets(map);
  return hit;
}
window.hohClearTempFraming = hohClearTempFraming;
window.hohPersistOffsetServer = function(charId, slot, opts){
  opts = opts || {};
  if(!charId || !/^[0-9a-f-]{36}$/i.test(String(charId))) return Promise.resolve(false);
  function status(state, reason){ try { if(typeof opts.onStatus === 'function') opts.onStatus(state, reason || ''); } catch(_){} }
  var sb = window.hohSupabaseClient;
  if(!sb){ status('failed', 'offline'); return Promise.resolve(false); }
  var s = (slot === 'secondary') ? 'secondary' : 'primary';
  var x = 50, y = 50, zoom = 100;
  try { if(typeof window.hohGetImageOffsetX === 'function') x = window.hohGetImageOffsetX(charId, s); } catch(_){}
  try { if(typeof window.hohGetImageOffsetY === 'function') y = window.hohGetImageOffsetY(charId, s); } catch(_){}
  try { if(typeof window.hohGetImageZoom === 'function') zoom = window.hohGetImageZoom(charId, s); } catch(_){}
  x = (typeof x === 'number') ? Math.round(Math.max(0, Math.min(100, x))) : 50;
  y = (typeof y === 'number') ? Math.round(Math.max(0, Math.min(100, y))) : 50;
  zoom = (typeof zoom === 'number') ? Math.round(Math.max(100, Math.min(200, zoom))) : 100;
  var colX = (s === 'secondary') ? 'image_offset_x_2' : 'image_offset_x';
  var colY = (s === 'secondary') ? 'image_offset_y_2' : 'image_offset_y';
  var colZoom = (s === 'secondary') ? 'image_zoom_2' : 'image_zoom';
  function warnLocalOnly(){
    if(!opts.warn) return;
    try { if(typeof hohShowHeartToast === 'function') hohShowHeartToast('Reframe saved on this device', 'The server didn\'t accept the zoom yet. Apply sql/R729-image-reframe-zoom.sql before the theme update.'); } catch(_){}
  }
  function persisted(withZoom){
    /* the server has it: the row says so, and this device stops overriding it */
    try {
      var row = __hohCharById(charId);
      if(row){ row[colX] = x; row[colY] = y; if(withZoom !== false) row[colZoom] = zoom; }
    } catch(_){}
    try { hohClearLocalFraming(charId, s, withZoom === false ? { x: x, y: y, zoom: -1 } : { x: x, y: y, zoom: zoom }); } catch(_){}
    try { if(typeof window.hohForceImageOffsetRepaint === 'function') window.hohForceImageOffsetRepaint(charId, s); } catch(_){}
    /* Push the new framing to every other open tab, live. */
    try { if(typeof window.hohBroadcastHeroChange === 'function') window.hohBroadcastHeroChange(charId); } catch(_){}
    return true;
  }
  function failed(reason){ status('failed', reason); return false; }
  function missingFn(res){
    var e = res && res.error;
    return !!e && (e.code === 'PGRST202' || res.status === 404 || /could not find the function/i.test(String(e.message || '')));
  }
  var email = (typeof window.hohYourHallEmail === 'function') ? (window.hohYourHallEmail() || '') : '';
  var pin = '';
  try { var t = JSON.parse(localStorage.getItem('hoh-your-hall-token') || 'null'); pin = (t && t.pin) || ''; } catch(_){}
  if(!pin){ try { pin = sessionStorage.getItem('hoh-admin-pin') || ''; } catch(_){} }
  function oldOffsetRpc(){
    try {
      return sb.rpc('set_character_image_offset', { p_email: email, p_pin: pin, p_id: charId, p_slot: s, p_x: x, p_y: y }).then(function(res){
        var d = (res && res.data) || {};
        if(Array.isArray(d)) d = d[0] || {};
        if(!res || res.error || d.ok !== true){ warnLocalOnly(); return failed('refused'); }
        persisted(false); warnLocalOnly();
        return failed('zoom_not_saved'); /* This fallback cannot confirm that zoom was saved. */
      }, function(){ warnLocalOnly(); return failed('network'); });
    } catch(_){ warnLocalOnly(); return Promise.resolve(failed('network')); }
  }
  function legacyWrite(){
    /* Only when set_character_image_reframe is not installed: a plain row
       update, then the old X/Y function as the last resort. */
    try {
      var payload = {}; payload[colX] = x; payload[colY] = y; payload[colZoom] = zoom;
      return sb.from('characters').update(payload).eq('id', charId).select('id').then(function(res){
        if(!res || res.error || !res.data || !res.data.length) return oldOffsetRpc();
        persisted(); status('saved'); return true;
      }, oldOffsetRpc);
    } catch(_){ return oldOffsetRpc(); }
  }
  /* the save is owner-or-admin, so it needs the Your Hall email and PIN */
  if(!(sb.rpc && email && pin)) return Promise.resolve(failed('signin'));
  status('saving');
  try {
    return sb.rpc('set_character_image_reframe', { p_email: email, p_pin: pin, p_id: charId, p_slot: s, p_x: x, p_y: y, p_zoom: zoom }).then(function(res){
      if(missingFn(res)) return legacyWrite();
      if(res && res.error) return failed('error');
      var d = (res && res.data) || {};
      if(Array.isArray(d)) d = d[0] || {};
      if(d.ok !== true) return failed(String(d.error || d.reason || 'refused'));
      persisted(); status('saved'); return true;
    }, function(){ return failed('network'); });
  } catch(_){ return Promise.resolve(failed('network')); }
};
window.hohSaveReframeOnly = function(charId, slot, btn){
  if(!charId) return;
  var s = slot || 'primary';
  var zone = document.getElementById('hoh-upload-zone-' + (s === 'secondary' ? 1 : 0));
  if(!zone) return;
  var frame = zone.querySelector('.hoh-edit-img-frame');
  if(!frame) return;
  /* R136-mobile-reframe: explicit isNaN check (was already correct
     here — kept for parity with the onUp fix). */
  var offset = parseInt(frame.getAttribute('data-offset'), 10);
  if(isNaN(offset)) offset = 50;
  offset = Math.max(0, Math.min(100, offset));
  var rawZoom = parseInt(frame.getAttribute('data-zoom'), 10);
  var zoom = Math.max(100, Math.min(200, isNaN(rawZoom) ? 100 : rawZoom));
  /* 1. Persist locally (also fires hoh:image-offset-changed event). */
  if(typeof window.hohSetImageOffsetY === 'function'){
    try { window.hohSetImageOffsetY(charId, s, offset); } catch(_){}
  }
  if(typeof window.hohSetImageZoom === 'function'){
    try { window.hohSetImageZoom(charId, s, zoom); } catch(_){}
  }
  /* 2. Pin into allCharacters cache so subsequent renders read the
        new value (the FLIP grid reuses DOM nodes; cache pinning makes
        the value correct for any fresh render). */
  try {
    if(typeof allCharacters !== 'undefined' && allCharacters && allCharacters.length){
      var idx = allCharacters.findIndex(function(ch){ return ch && String(ch.id) === String(charId); });
      if(idx >= 0){
        var key = (s === 'secondary') ? 'image_offset_y_2' : 'image_offset_y';
        allCharacters[idx][key] = offset;
        allCharacters[idx][s === 'secondary' ? 'image_zoom_2' : 'image_zoom'] = zoom;
      }
    }
  } catch(_){}
  /* 3. Server write — routed through hohPersistOffsetServer (R265). It prefers
        the SECURITY DEFINER RPC that bypasses RLS + the edit-cooldown trigger
        so the crop reaches EVERY visitor, and falls back to the legacy
        single-column UPDATE otherwise. warn:true surfaces a visible toast if
        the write ends up local-only. Persists BOTH axes together. */
  /* SAVESTICK: the Saved flash and toast wait for the server's ok; a refusal
     shows "Not saved. Tap to try again" under the help line instead. */
  var serverSave = Promise.resolve(false);
  try {
    if(typeof window.hohPersistOffsetServer === 'function'){
      serverSave = window.hohPersistOffsetServer(charId, s, { warn: true, onStatus: hohZoneReframeStatus(frame, charId, s) });
    }
  } catch(_){}
  /* 4. Force-repaint every card surface for this character. */
  try {
    if(typeof window.hohForceImageOffsetRepaint === 'function'){
      window.hohForceImageOffsetRepaint(charId, s);
    }
  } catch(_){}
  Promise.resolve(serverSave).then(function(ok){
    if(!ok) return;
    /* 5. UI feedback — clear dirty state, briefly flash a "Saved" label. */
    try {
      frame.classList.remove('hoh-edit-img-frame-dirty');
      var saveBtn = btn || zone.querySelector('.hoh-edit-img-save');
      if(saveBtn){
        saveBtn.classList.remove('hoh-edit-img-save-dirty');
        saveBtn.classList.add('hoh-edit-img-save-saved');
        saveBtn.textContent = 'Saved ✓';
        setTimeout(function(){
          try {
            saveBtn.classList.remove('hoh-edit-img-save-saved');
            saveBtn.textContent = 'Save Reframe';
          } catch(_){}
        }, 1600);
      }
    } catch(_){}
    /* 6. Toast for accessibility / extra confirmation. */
    try {
      if(typeof hohShowHeartToast === 'function'){
        hohShowHeartToast('Reframe saved', 'Hall card updated.');
      }
    } catch(_){}
  }, function(){});
};

/* SAVESTICK: the edit form's portrait (the ?edit= drag, its zoom and Save
   Reframe) shows the same status line as the opened card, under its help
   line. A failed save offers the same "Tap to try again". */
function hohZoneReframeStatus(frame, charId, slot){
  var zone = frame && frame.closest && frame.closest('.hoh-upload');
  if(!zone) return null;
  function onStatus(state){
    var el = zone.querySelector('.hoh-fit-status');
    if(!el){
      el = document.createElement('div');
      el.className = 'hoh-hall-reframe-status hoh-fit-status';
      el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      var help = zone.querySelector('.hoh-edit-img-help');
      if(help && help.parentNode) help.parentNode.insertBefore(el, help.nextSibling); else zone.appendChild(el);
    }
    el.innerHTML = hohReframeStatusHtml(state);
    el.setAttribute('data-state', state || '');
    var retry = el.querySelector('[data-fit-retry]');
    if(retry) retry.onclick = function(e){ e.stopPropagation(); window.hohPersistOffsetServer(charId, slot, { onStatus: onStatus }); };
  }
  return onStatus;
}
function hohMarkReframeDirty(frame){
  if(!frame) return;
  if(frame.__hohSaveReframe)return; /* The card editor saves each adjustment. */
  try {
    frame.classList.add('hoh-edit-img-frame-dirty');
    var zone = frame.closest('.hoh-upload');
    var saveBtn = zone && zone.querySelector('.hoh-edit-img-save');
    if(saveBtn){
      saveBtn.classList.add('hoh-edit-img-save-dirty');
      saveBtn.textContent = 'Save Reframe ✱';
    }
  } catch(_){}
}
window.hohPreviewImageZoom = function(input){
  if(!input) return;
  var zone = input.closest('.hoh-upload,.hoh-hall-card-view');
  var frame = zone && zone.querySelector('.hoh-edit-img-frame');
  if(!frame) return;
  var parsed = parseInt(input.value, 10);
  var zoom = Math.max(100, Math.min(200, isNaN(parsed) ? 100 : parsed));
  input.value = String(zoom);
  frame.setAttribute('data-zoom', String(zoom));
  var img = frame.querySelector('img');
  if(img) img.style.scale = String(zoom / 100);
  /* R769: zooming in opens the second axis, zooming back out closes it. The
     drag wiring owns the axis rule, so ask it to look again. */
  try { if(typeof frame.__hohPickAxes === 'function') frame.__hohPickAxes(); } catch(_){}
  hohMarkReframeDirty(frame);
};
window.hohCommitImageZoom = function(input){
  if(!input) return;
  window.hohPreviewImageZoom(input);
  var zone = input.closest('.hoh-upload,.hoh-hall-card-view');
  var frame = zone && zone.querySelector('.hoh-edit-img-frame');
  if(!frame) return;
  var charId = frame.getAttribute('data-charid');
  var slot = frame.getAttribute('data-slot') || 'primary';
  var zoom = parseInt(frame.getAttribute('data-zoom'), 10);
  if(isNaN(zoom)) zoom = 100;
  try { if(typeof window.hohSetImageZoom === 'function') window.hohSetImageZoom(charId, slot, zoom); } catch(_){}
  try {
    if(/^[0-9a-f-]{36}$/i.test(String(charId)) && typeof allCharacters !== 'undefined' && allCharacters){
      var c = allCharacters.find(function(row){ return row && String(row.id) === String(charId); });
      if(c) c[slot === 'secondary' ? 'image_zoom_2' : 'image_zoom'] = zoom;
    }
  } catch(_){}
  if(/^[0-9a-f-]{36}$/i.test(String(charId))){
    try {
      if(frame.__hohSaveReframe)frame.__hohSaveReframe();
      else if(typeof window.hohPersistOffsetServer === 'function')window.hohPersistOffsetServer(charId, slot, { onStatus: hohZoneReframeStatus(frame, charId, slot) });
    } catch(_){}
    try { if(typeof window.hohForceImageOffsetRepaint === 'function') window.hohForceImageOffsetRepaint(charId, slot); } catch(_){}
  }
};
window.hohStepImageZoom = function(btn, amount){
  if(!btn) return;
  var wrap = btn.closest('.hoh-edit-img-zoom');
  var input = wrap && wrap.querySelector('.hoh-edit-img-zoom-range');
  if(!input) return;
  input.value = String((parseInt(input.value, 10) || 100) + (parseInt(amount, 10) || 0));
  window.hohCommitImageZoom(input);
};

/* Swap the primary and secondary portraits for a character. Persists the
   exchange with one targeted UPDATE (the same lightweight path as
   hohSaveReframeOnly, so it doesn't go through the full edit-form save).
   Updates the in-memory cache, the open edit form, the gallery, and the
   server, so it actually shows in the Hall. */
window.hohSwapPortraits = function(charId, btn){
  if(!charId) return;
  var c = (typeof allCharacters !== 'undefined' && allCharacters)
    ? allCharacters.find(function(x){ return x && String(x.id) === String(charId); }) : null;
  if(!c){ try{ if(typeof hohShowHeartToast==='function') hohShowHeartToast('Swap failed','Could not find this hero in the loaded set.'); }catch(_){ } return; }
  if(!c.image_url_2){ try{ if(typeof hohShowHeartToast==='function') hohShowHeartToast('Add a second portrait','There is only one image. Add an Optional 2nd image, then you can swap.'); }catch(_){ } return; }
  var nUrl   = c.image_url_2,                               nUrl2   = c.image_url || null;
  var nThumb = c.image_thumb_url_2 || null,                 nThumb2 = c.image_thumb_url || null;
  var nOff   = (typeof c.image_offset_y_2 === 'number') ? c.image_offset_y_2 : 50;
  var nOff2  = (typeof c.image_offset_y   === 'number') ? c.image_offset_y   : 50;
  var nOffX  = (typeof c.image_offset_x_2 === 'number') ? c.image_offset_x_2 : 50;
  var nOffX2 = (typeof c.image_offset_x   === 'number') ? c.image_offset_x   : 50;
  var nZoom  = (typeof c.image_zoom_2 === 'number') ? c.image_zoom_2 : 100;
  var nZoom2 = (typeof c.image_zoom   === 'number') ? c.image_zoom   : 100;
  /* R204: swap the animated flags with the images so the grid dot + playback
     follow the new primary/secondary. */
  var nAnim  = !!c.is_animated_2;
  var nAnim2 = !!c.is_animated;
  /* 1. cache */
  c.image_url=nUrl; c.image_url_2=nUrl2; c.image_thumb_url=nThumb; c.image_thumb_url_2=nThumb2; c.image_offset_y=nOff; c.image_offset_y_2=nOff2; c.image_offset_x=nOffX; c.image_offset_x_2=nOffX2; c.image_zoom=nZoom; c.image_zoom_2=nZoom2; c.is_animated=nAnim; c.is_animated_2=nAnim2;
  /* R200: keep the local getters + live repaint in sync with the swapped crops. */
  try { if(typeof window.hohSetImageOffsetY==='function'){ window.hohSetImageOffsetY(charId,'primary',nOff); window.hohSetImageOffsetY(charId,'secondary',nOff2); } } catch(_){}
  try { if(typeof window.hohSetImageOffsetX==='function'){ window.hohSetImageOffsetX(charId,'primary',nOffX); window.hohSetImageOffsetX(charId,'secondary',nOffX2); } } catch(_){}
  try { if(typeof window.hohSetImageZoom==='function'){ window.hohSetImageZoom(charId,'primary',nZoom); window.hohSetImageZoom(charId,'secondary',nZoom2); } } catch(_){}
  /* R226: the offset event above repaints the CROP on every live card, but NOT the actual
     image. Push the new primary thumb into each card across the main Hall and Explore so the
     swap shows instantly without a refresh. The server write below makes it persist for
     everyone on their next load. Same selectors the reframe repaint uses, minus the FF badge
     and the animated overlay so only the main portrait is repointed. */
  try {
    var _sid = String(charId).replace(/"/g, '\\"');
    var _swapImgs = document.querySelectorAll([
      '.hoh-card[data-hero-id="' + _sid + '"] img',
      '.hoh-fresh-card[data-id="' + _sid + '"] img',
      '.hoh-yh-card[data-hero-id="' + _sid + '"] img',
      '.hoh-cast-card[data-hero-id="' + _sid + '"] img',
      '[data-hero-id="' + _sid + '"] .hoh-yh-media img',
      '[data-hero-id="' + _sid + '"] .hoh-fresh-media img',
      '.hoh-company-custom-hero[data-hero-id="' + _sid + '"] img',
      '.hoh-fresh-stream-target[data-stream-id="' + _sid + '"] img',
      '.hoh-fresh-culprit-card[data-id="' + _sid + '"] img',
      '.hoh-fresh-familiar-card[data-id="' + _sid + '"] img'
    ].join(','));
    var _newSrc = nThumb || nUrl;
    for(var _si = 0; _si < _swapImgs.length; _si++){
      var _im = _swapImgs[_si];
      if(_im.classList && (_im.classList.contains('hoh-ff-badge') || _im.classList.contains('hoh-card-anim'))) continue;
      try { _im.removeAttribute('srcset'); } catch(__){}
      try { _im.src = _newSrc; } catch(__){}
    }
  } catch(_){}
  /* 2. update the open edit form, if present */
  function _setZone(idx, url, off, offX, zoom){
    var zone=document.getElementById('hoh-upload-zone-'+idx); if(!zone) return;
    var frame=zone.querySelector('.hoh-edit-img-frame'); var img=zone.querySelector('.hoh-edit-img-frame img');
    if(frame){ frame.setAttribute('data-offset', String(off)); frame.setAttribute('data-offset-x', String(offX)); frame.setAttribute('data-zoom', String(zoom)); }
    if(img){ img.src=url; img.style.objectPosition=offX+'% '+off+'%'; img.style.transformOrigin=offX+'% '+off+'%'; img.style.scale=String(zoom/100); }
    var range=zone.querySelector('.hoh-edit-img-zoom-range');if(range)range.value=String(zoom);
    /* R769: the swapped-in art has its own aspect and zoom, so the pan axes,
       hint and grip are chosen again once it has loaded. */
    if(frame && img && typeof frame.__hohPickAxes==='function'){
      if(img.complete) frame.__hohPickAxes(); else img.addEventListener('load', frame.__hohPickAxes, { once:true });
    }
  }
  try{ _setZone(0, nUrl, nOff, nOffX, nZoom); _setZone(1, nUrl2, nOff2, nOffX2, nZoom2); }catch(_){}
  try{ if(typeof window.__hohSwapResizeFn==='function') window.__hohSwapResizeFn(); }catch(_){}
  /* 3. server write — one targeted multi-column update */
  try{
    var sb = window.hohSupabaseClient;
    if(sb && /^[0-9a-f-]{36}$/i.test(String(charId))){
      sb.from('characters').update({ image_url:nUrl, image_url_2:nUrl2, image_thumb_url:nThumb, image_thumb_url_2:nThumb2, image_offset_y:nOff, image_offset_y_2:nOff2 }).eq('id', charId).select('id').then(function(res){
        try{
          if(res && res.error){ if(typeof hohShowHeartToast==='function') hohShowHeartToast('Swapped on this device','Server rejected the change, it will not show for other visitors.'); }
          else if(res && res.data && !res.data.length){ if(typeof hohShowHeartToast==='function') hohShowHeartToast('Swap not saved','Server did not persist it (RLS may be blocking).'); }
          else if(typeof hohShowHeartToast==='function'){ hohShowHeartToast('Portraits swapped','Main and second image switched and saved.'); }
        }catch(_){}
      });
    }
  }catch(_){}
  /* R200: persist the swapped horizontal crops in a SEPARATE write so a missing
     image_offset_x column can never break the main swap update above. */
  try{
    var sbx = window.hohSupabaseClient;
    if(sbx && /^[0-9a-f-]{36}$/i.test(String(charId))){
      sbx.from('characters').update({ image_offset_x:nOffX, image_offset_x_2:nOffX2 }).eq('id', charId).then(function(){});
    }
  }catch(_){}
  /* Zoom follows the image just like its X/Y crop. Kept isolated so an older
     database can still complete the established image swap. */
  try{
    var sbz = window.hohSupabaseClient;
    if(sbz && /^[0-9a-f-]{36}$/i.test(String(charId))){
      sbz.from('characters').update({ image_zoom:nZoom, image_zoom_2:nZoom2 }).eq('id', charId).then(function(){});
    }
  }catch(_){}
  /* R204: same isolation for the swapped animated flags. */
  try{
    var sba = window.hohSupabaseClient;
    if(sba && /^[0-9a-f-]{36}$/i.test(String(charId))){
      sba.from('characters').update({ is_animated:nAnim, is_animated_2:nAnim2 }).eq('id', charId).then(function(){});
    }
  }catch(_){}
  /* 4. repaint card + gallery so the Hall reflects it now */
  try{ if(typeof window.hohForceImageOffsetRepaint==='function'){ window.hohForceImageOffsetRepaint(charId,'primary'); window.hohForceImageOffsetRepaint(charId,'secondary'); } }catch(_){}
  try{ if(typeof renderGallery==='function') renderGallery(); }catch(_){}
};

/* Mount a small circular swap icon centered BETWEEN the two portrait
   frames in the edit form. Replaces the old full-width "Swap with main"
   button. JS-positioned so it sits in the gap on desktop (side by side)
   and between the stacked images on mobile, and repositions on resize. */
window.hohMountSwapFab = function(charId, zone1){
  try{
    var grid = document.querySelector('.hoh-upload-grid');
    if(!grid) return;
    var old = grid.querySelector('.hoh-swap-fab');
    if(old && old.parentNode) old.parentNode.removeChild(old);
    grid.style.position = 'relative';
    var fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'hoh-swap-fab';
    fab.title = 'Swap main and second image';
    fab.setAttribute('aria-label', 'Swap main and second image');
    fab.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 4l3 3-3 3"></path><path d="M20 7H4"></path><path d="M7 20l-3-3 3-3"></path><path d="M4 17h16"></path></svg>';
    fab.onclick = function(e){ if(e){ e.preventDefault(); e.stopPropagation(); } try{ window.hohSwapPortraits(charId, fab); }catch(_){ } };
    grid.appendChild(fab);
    function reposition(){
      try{
        var z0 = document.getElementById('hoh-upload-zone-0');
        var z1 = document.getElementById('hoh-upload-zone-1');
        var f0 = z0 && z0.querySelector('.hoh-edit-img-frame');
        var f1 = z1 && z1.querySelector('.hoh-edit-img-frame');
        if(!f0 || !f1){ fab.style.display = 'none'; return; }
        fab.style.display = '';
        var g = grid.getBoundingClientRect();
        var r0 = f0.getBoundingClientRect();
        var r1 = f1.getBoundingClientRect();
        var stacked = (r1.top - r0.top) > Math.min(r0.height, 40);
        if(stacked){
          fab.style.left = (g.width / 2) + 'px';
          fab.style.top  = ((r0.bottom + r1.top) / 2 - g.top) + 'px';
        } else {
          fab.style.left = ((r0.right + r1.left) / 2 - g.left) + 'px';
          fab.style.top  = (r0.top + r0.height / 2 - g.top) + 'px';
        }
      }catch(_){}
    }
    reposition();
    setTimeout(reposition, 50);
    setTimeout(reposition, 260);
    try{
      [document.getElementById('hoh-upload-zone-0'), zone1].forEach(function(z){
        if(!z) return; var im = z.querySelector('.hoh-edit-img-frame img');
        if(im && !im.complete){ im.addEventListener('load', reposition, { once:true }); }
      });
    }catch(_){}
    if(window.__hohSwapResizeFn) { try{ window.removeEventListener('resize', window.__hohSwapResizeFn); }catch(_){ } }
    window.__hohSwapResizeFn = reposition;
    window.addEventListener('resize', reposition);
  }catch(_){}
};

/* Wire up drag/touch behavior on an edit-form image frame. The frame
   element is the .hoh-edit-img-frame; the inner <img> is the target
   we shift via object-position.
   R769: the drag follows the pointer on every axis the art can actually
   move on. At 100 that is the one axis object-fit:cover overflows (tall
   art pans up and down, wide art left and right), as before. Zoomed in,
   the art overflows the frame both ways, so both axes pan, and the hint
   and grip say so. Movement is one to one with the pointer, measured
   against hohImgPanRange, so the art stops at its own edge instead of
   sliding on a fixed factor. */
function hohWireImageReposition(zone, charId, slot){
  if(!zone || !charId) return;
  var frame = zone.querySelector('.hoh-edit-img-frame');
  var img = zone.querySelector('.hoh-edit-img-frame img');
  if(!frame || !img) return;
  var dragging = false;
  var startX = 0, startY = 0;          /* pointer at grab, screen px */
  var startOffX = 50, startOffY = 50;  /* object-position at grab */
  var canX = false, canY = true;       /* the axes this art can pan on right now */
  var range = { x: 0, y: 0 };
  function _zoom(){ var z = parseInt(frame.getAttribute('data-zoom'), 10); return isNaN(z) ? 100 : Math.max(100, Math.min(200, z)); }
  /* R200/R769: pick the pan axes from the art vs its frame and the zoom.
     Re-checks on image load, on every zoom change and at every grab. */
  function _pickAxes(){
    try {
      var box = frame.getBoundingClientRect();
      range = (typeof window.hohImgPanRange === 'function') ? window.hohImgPanRange(img, box, _zoom()) : { x: 0, y: box.height };
      canX = range.x > 0.5;
      canY = range.y > 0.5;
      if(!canX && !canY) canY = true; /* square art at 100: the same no-op drag and hint as before */
    } catch(_){ canX = false; canY = true; range = { x: 0, y: 0 }; }
    var axis = (canX && canY) ? 'xy' : (canX ? 'x' : 'y');
    try { frame.setAttribute('data-pan-axis', axis); } catch(_){}
    /* Match the hint text + handle icon to the pan direction. */
    try {
      var help = zone.querySelector('.hoh-edit-img-help');
      if(help) help.textContent = (axis === 'xy') ? 'Drag the portrait to reframe.' : (axis === 'x') ? 'Drag the portrait left or right to reframe.' : 'Drag the portrait up or down to reframe.';
      var grip = frame.querySelector('.hoh-edit-img-grip');
      if(grip){
        grip.classList.toggle('hoh-edit-img-grip-x', axis === 'x');
        grip.classList.toggle('hoh-edit-img-grip-xy', axis === 'xy');
        var shape = (axis === 'xy') ? 'xy' : 'y';
        if(grip.getAttribute('data-grip') !== shape){ grip.innerHTML = (shape === 'xy') ? HOH_GRIP_SVG_XY : HOH_GRIP_SVG_Y; grip.setAttribute('data-grip', shape); }
      }
    } catch(_){}
  }
  frame.__hohPickAxes = _pickAxes;
  _pickAxes();
  if(img && !img.complete){ try { img.addEventListener('load', _pickAxes, { once:true }); } catch(_){} }
  function _pt(e){ var t = (e.touches && e.touches[0]) || e; return { x: t.clientX, y: t.clientY }; }
  function _paint(x, y){
    var pos = x + '% ' + y + '%';
    img.style.objectPosition = pos; img.style.transformOrigin = pos;
    frame.setAttribute('data-offset-x', String(Math.round(x)));
    frame.setAttribute('data-offset', String(Math.round(y)));
  }
  function onMove(e){
    if(!dragging) return;
    if(e.cancelable)e.preventDefault();
    var p = _pt(e);
    /* Drag toward a side reveals that side (offset toward 0). One to one
       against the pan range, on each axis that can move. */
    var nx = (canX && range.x > 0) ? Math.max(0, Math.min(100, startOffX - ((p.x - startX) / range.x) * 100)) : startOffX;
    var ny = (canY && range.y > 0) ? Math.max(0, Math.min(100, startOffY - ((p.y - startY) / range.y) * 100)) : startOffY;
    _paint(nx, ny);
    /* R129: Mark dirty + ping the Save Reframe button so the user
       knows the change isn't persisted yet. The button gets a pulse
       class (CSS) and its label changes to "Save Reframe ✱". This
       makes the save action obvious and addresses the user's
       complaint that they didn't know whether to click Save or what.
       Idempotent — calling once per move is fine, the class only
       toggles state. */
    hohMarkReframeDirty(frame);
  }
  function onUp(){
    if(!dragging) return;
    dragging = false;
    document.body.classList.remove('hoh-edit-dragging');
    /* R136-mobile-reframe: parseInt('0') is 0, and 0 || 50 is 50 —
       so dragging the image all the way to the top (offset 0) used
       to silently revert to centered. Use isNaN guard so offset 0
       is preserved as a valid drag result. */
    var rawX = parseInt(frame.getAttribute('data-offset-x'), 10);
    var rawY = parseInt(frame.getAttribute('data-offset'), 10);
    var finalX = isNaN(rawX) ? 50 : Math.max(0, Math.min(100, rawX));
    var finalY = isNaN(rawY) ? 50 : Math.max(0, Math.min(100, rawY));
    /* R200/R769: commit each axis that could move, to its own column. */
    var colX = (slot === 'secondary') ? 'image_offset_x_2' : 'image_offset_x';
    var colY = (slot === 'secondary') ? 'image_offset_y_2' : 'image_offset_y';
    /* R110-B: Bulletproof drag-release commit. The standard call
       writes localStorage + dispatches the repaint event, but users
       were reporting that the new crop didn't propagate to gallery
       cards behind the form. Three additions here:
         1. Persist to server immediately. The drag is a deliberate
            commit gesture, so a single-column UPDATE goes out right
            now — every other visitor sees the new crop on their next
            page load without waiting for Save Changes.
         2. Mirror into allCharacters[idx] so any in-session render
            that re-reads from cache picks up the value.
         3. Re-dispatch the repaint event after a microtask in case
            the first dispatch raced against any concurrent render. */
    if(canX && typeof window.hohSetImageOffsetX === 'function'){
      try { window.hohSetImageOffsetX(charId, slot, finalX); } catch(_){}
    }
    if(canY && typeof window.hohSetImageOffsetY === 'function'){
      try { window.hohSetImageOffsetY(charId, slot, finalY); } catch(_){}
    }
    /* (2) — pin into allCharacters so cache reads see new value. */
    try {
      if(typeof allCharacters !== 'undefined' && allCharacters && allCharacters.length){
        var idx2 = allCharacters.findIndex(function(ch){ return ch && String(ch.id) === String(charId); });
        if(idx2 >= 0){
          if(canX) allCharacters[idx2][colX] = finalX;
          if(canY) allCharacters[idx2][colY] = finalY;
        }
      }
    } catch(_){}
    /* (3) — re-fire the event in next tick so any render that might
       have completed between drop and now also sees the new value. */
    setTimeout(function(){
      try {
        document.dispatchEvent(new CustomEvent('hoh:image-offset-changed', {
          detail: { charId: charId, slot: slot, offset: finalY }
        }));
      } catch(_){}
      /* R128-F: Direct force-repaint as backup — guarantees the grid
         card visually catches up to the drag immediately. */
      try {
        if(typeof window.hohForceImageOffsetRepaint === 'function'){
          window.hohForceImageOffsetRepaint(charId, slot);
        }
      } catch(_){}
    }, 0);
    /* (1) — persist to server. R265: routed through hohPersistOffsetServer,
       which prefers the SECURITY DEFINER RPC (bypasses RLS + the edit-cooldown
       trigger, so a drag-commit lands for every visitor even on a just-edited
       hero) and falls back to the legacy single-column UPDATE. The local
       setter above already wrote this axis, so the helper reads both axes and
       persists them together. Errors never roll back the committed local
       state. */
    try {
      if(frame.__hohSaveReframe){
        frame.__hohSaveReframe();
      }else if(typeof window.hohPersistOffsetServer === 'function'){
        window.hohPersistOffsetServer(charId, slot, { onStatus: hohZoneReframeStatus(frame, charId, slot) });
      }
    } catch(_){}
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', onUp);
    document.removeEventListener('touchmove', onMove);
    document.removeEventListener('touchend', onUp);
    document.removeEventListener('touchcancel', onUp);
  }
  function onDown(e){
    if(frame.__hohReframeEnabled===false)return;
    /* Allow mouse or touch. Skip if the click hit the Replace
       button — that's a separate interaction. */
    if(e.target && e.target.closest('.hoh-upload-overlay-replace')) return;
    e.preventDefault();
    _pickAxes();
    var curX = (typeof window.hohGetImageOffsetX === 'function') ? window.hohGetImageOffsetX(charId, slot) : 50;
    var curY = (typeof window.hohGetImageOffsetY === 'function') ? window.hohGetImageOffsetY(charId, slot) : 50;
    if(typeof curX !== 'number') curX = 50;
    if(typeof curY !== 'number') curY = 50;
    dragging = true;
    document.body.classList.add('hoh-edit-dragging');
    var p = _pt(e);
    startX = p.x; startY = p.y;
    var seedX = parseInt(frame.getAttribute('data-offset-x'), 10);
    var seedY = parseInt(frame.getAttribute('data-offset'), 10);
    startOffX = isNaN(seedX) ? curX : Math.max(0, Math.min(100, seedX));
    startOffY = isNaN(seedY) ? curY : Math.max(0, Math.min(100, seedY));
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onUp);
    document.addEventListener('touchcancel', onUp);
  }
  frame.addEventListener('mousedown', onDown);
  frame.addEventListener('touchstart', onDown, { passive: false });
}

/* ⛔ ===== FITEDITOR · FIT THE FACE ON THE CARD (Jan, 2026-10-14) =====
   Jan: "make sure the reframe for users save and when they are adding an image
   of their character the reframe button should be intuitively there designed
   with ux in mind so they can fit it on the card accurately a lot of images
   are cut off in the hall and i have to reframe them".
   One editor, two homes:
     mode 'new'    the add-hero picture screen builds it in the upload zone the
                   moment the main picture loads, under the temp id the insert
                   reads (__hoh_new_primary), seeded from the picture's shape.
     mode 'owner'  the opened card's Reframe portrait attaches it to the card's
                   real art window; o.onChange autosaves after each release.
   Gestures are Pointer Events with capture on the art window only
   (touch-action:none there): one finger drags one to one against
   hohImgPanRange, two fingers pinch around the saved focal point (the Hall's
   own transform-origin, so what they see is what is saved) while their
   midpoint pans, and a tap under 6px glides that spot toward the centre (the
   single-pointer way to move it, WCAG 2.5.7). While a finger is down the
   cut-off part shows at 25% outside the window, with a thirds grid. Keyboard
   on the window: arrows move 2 (Shift 10), + and - zoom 10, 0 starts over.
   Values reach the hohSet... helpers on release, never per pointer move, and
   the img is painted exactly as hohImgStyle paints the Hall. */
function hohFitReduced(){ try { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); } catch(_){ return false; } }
function hohFitTouch(){ try { return !!(window.matchMedia && matchMedia('(hover: none), (pointer: coarse)').matches); } catch(_){ return false; } }
function hohFitClamp(v, lo, hi){ v = +v; if(isNaN(v)) v = lo; return Math.max(lo, Math.min(hi, v)); }
/* r is height over width. Tall art starts at the top (the face), very tall art
   a little below it; anything else keeps the centre. A starting guess the
   player confirms, never a decision made for them. */
function hohFitSmartDefault(nw, nh){
  var r = (nw > 0 && nh > 0) ? nh / nw : 1;
  if(r >= 1.6) return { x: 50, y: 20, zoom: 100 };
  if(r >= 1.15) return { x: 50, y: 0, zoom: 100 };
  return { x: 50, y: 50, zoom: 100 };
}
/* At least 300 real pixels stay across the frame. Uploads are stored 800px
   wide (resizeImage), so the stored short side is what limits the zoom. */
function hohFitMaxZoom(nw, nh){
  if(!(nw > 0 && nh > 0)) return 200;
  var k = nw > 800 ? 800 / nw : 1;
  return Math.max(100, Math.min(200, Math.round(Math.min(nw, nh) * k / 300 * 100)));
}
window.hohFitSmartDefault = hohFitSmartDefault;
function hohFitWords(st, canX, canY){
  var v = canY ? (st.y <= 15 ? 'top' : (st.y >= 85 ? 'bottom' : '')) : '';
  var h = canX ? (st.x <= 15 ? 'left' : (st.x >= 85 ? 'right' : '')) : '';
  var s = 'Showing the ' + ((v && h) ? v + ' ' + h : (v || (h ? h + ' side' : 'middle'))) + ' of the picture.';
  if(st.zoom > 100) s += ' Zoom ' + Math.round(st.zoom) + ' percent.';
  return s;
}
var __hohFitN = 0;
function hohFitEditor(host, o){
  if(!host) return null;
  o = o || {};
  var id = String(o.id || ''), slot = o.slot === 'secondary' ? 'secondary' : 'primary';
  var owner = o.mode === 'owner';
  var reduce = hohFitReduced(), touch = hohFitTouch();
  var uid = 'hoh-fit-' + (++__hohFitN);
  if(host.__hohFit){ try { host.__hohFit.destroy(); } catch(_){} }
  var how = touch ? 'Drag to move it and pinch to zoom.' : 'Drag to move it and pinch your trackpad to zoom.';
  var help = owner ? how + ' It saves <b>for everyone</b> as you go.'
    : 'Now <b>fit their face</b> on the card. ' + how + ' The Hall shows <b>exactly this</b>.';
  var controls =
    '<p class="hoh-edit-img-help hoh-fit-help" id="' + uid + '-help">' + help + '</p>' +
    '<p class="hoh-fit-note" aria-hidden="true"></p>' +
    '<div class="hoh-fit-row">' +
      '<figure class="hoh-fit-tile"><span class="hoh-fit-tile-box"><img alt="" draggable="false"></span><figcaption>In the Hall</figcaption></figure>' +
      '<div class="hoh-edit-img-zoom hoh-fit-zoom">' +
        '<button type="button" class="hoh-edit-img-zoom-step" data-fit-zoom="-10" aria-label="Zoom out">' + HOH_ZOOM_MINUS_SVG + '</button>' +
        '<input class="hoh-edit-img-zoom-range" type="range" min="100" max="200" step="1" value="100" aria-label="Zoom">' +
        '<button type="button" class="hoh-edit-img-zoom-step" data-fit-zoom="10" aria-label="Zoom in">' + HOH_ZOOM_PLUS_SVG + '</button>' +
      '</div>' +
      '<p class="hoh-fit-small" hidden>This picture is small, so it looks best at full size.</p>' +
    '</div>' +
    '<button type="button" class="hoh-fit-reset" hidden>' + (owner ? 'Undo' : 'Start over') + '</button>' +
    (o.after || '') +
    /* reached by a screen reader's swipe, kept out of the Tab order: they sit
       inside a 1px clip, so a keyboard user tabbing past Replace photo would
       land on four stops nobody can see (the arrow keys on the window do the
       same job for them) */
    '<div class="hoh-hall-visually-hidden hoh-fit-sr">' +
      '<button type="button" tabindex="-1" data-fit-move="ArrowUp">Move up</button><button type="button" tabindex="-1" data-fit-move="ArrowDown">Move down</button>' +
      '<button type="button" tabindex="-1" data-fit-move="ArrowLeft">Move left</button><button type="button" tabindex="-1" data-fit-move="ArrowRight">Move right</button>' +
    '</div>' +
    '<div class="hoh-hall-visually-hidden hoh-fit-live" role="status" aria-live="polite"></div>';
  var root, frame, img, added = [];
  if(owner){
    frame = o.frame; img = frame && frame.querySelector('img');
    if(!frame || !img) return null;
    root = document.createElement('div');
    root.className = 'hoh-fit hoh-fit-owner';
    root.innerHTML = controls;
    host.appendChild(root);
    ['<span class="hoh-fit-grid" aria-hidden="true"></span>', '<span class="hoh-fit-outline" aria-hidden="true"></span>',
     '<span class="hoh-edit-img-grip hoh-edit-img-grip-xy hoh-fit-grip" aria-hidden="true">' + HOH_GRIP_SVG_XY + '</span>'].forEach(function(h){
      var t = document.createElement('div'); t.innerHTML = h; var n = t.firstChild; frame.appendChild(n); added.push(n);
    });
    frame.classList.add('hoh-fit-frame');
  } else {
    host.innerHTML =
      '<div class="hoh-fit hoh-fit-new">' +
        '<div class="hoh-fit-stage">' +
          '<div class="hoh-edit-img-frame hoh-fit-frame" data-offset="50" data-offset-x="50" data-zoom="100" data-charid="' + esc(id) + '" data-slot="' + slot + '">' +
            '<img alt="' + esc(o.alt || 'Your portrait') + '" draggable="false">' +
            '<span class="hoh-fit-grid" aria-hidden="true"></span>' +
            '<span class="hoh-fit-guide" aria-hidden="true"><span>Keep faces above the line</span></span>' +
            '<span class="hoh-edit-img-grip hoh-edit-img-grip-xy hoh-fit-grip" aria-hidden="true">' + HOH_GRIP_SVG_XY + '</span>' +
          '</div>' +
        '</div>' + controls +
      '</div>';
    root = host.querySelector('.hoh-fit');
    frame = root.querySelector('.hoh-fit-frame'); img = frame.querySelector('img');
    img.src = o.src || '';
  }
  frame.setAttribute('tabindex', '0');
  frame.setAttribute('role', 'group');
  frame.setAttribute('aria-label', owner ? 'Picture position for ' + (o.name || 'this hero') : 'Picture position');
  frame.setAttribute('aria-describedby', uid + '-help');
  var stage = root.querySelector('.hoh-fit-stage') || frame;
  var tileImg = root.querySelector('.hoh-fit-tile img');
  tileImg.src = img.currentSrc || img.src;
  var rangeEl = root.querySelector('.hoh-edit-img-zoom-range');
  var zoomRow = root.querySelector('.hoh-fit-zoom'), smallEl = root.querySelector('.hoh-fit-small');
  var resetBtn = root.querySelector('.hoh-fit-reset'), noteEl = root.querySelector('.hoh-fit-note'), live = root.querySelector('.hoh-fit-live');
  function read(){
    return { x: hohFitClamp(window.hohGetImageOffsetX(id, slot), 0, 100), y: hohFitClamp(window.hohGetImageOffsetY(id, slot), 0, 100), zoom: hohFitClamp(window.hohGetImageZoom(id, slot), 100, 200) };
  }
  var st = read();
  var base = o.base ? { x: o.base.x, y: o.base.y, zoom: o.base.zoom } : { x: st.x, y: st.y, zoom: st.zoom };
  var maxZoom = 200, range = { x: 0, y: 0 }, canX = false, canY = false, box = null, bandX = 0, bandY = 0, ghost = null, glideRaf = 0;
  /* The window's inner box in screen pixels. The card view is scaled by a
     transform, so the layout size is multiplied back to what the finger moves. */
  function measure(){
    var r = frame.getBoundingClientRect(), k = frame.offsetWidth ? r.width / frame.offsetWidth : 1;
    box = { left: r.left + frame.clientLeft * k, top: r.top + frame.clientTop * k, width: (frame.clientWidth || frame.offsetWidth) * k, height: (frame.clientHeight || frame.offsetHeight) * k, k: k || 1 };
    range = (typeof window.hohImgPanRange === 'function') ? window.hohImgPanRange(img, box, st.zoom) : { x: 0, y: 0 };
    canX = range.x > 0.5; canY = range.y > 0.5;
    frame.setAttribute('data-pan-axis', canX && canY ? 'xy' : (canX ? 'x' : (canY ? 'y' : 'none')));
    return box;
  }
  function styleOf(s){ var pos = (Math.round(s.x * 10) / 10) + '% ' + (Math.round(s.y * 10) / 10) + '%'; return { pos: pos, scale: String(Math.round(s.zoom) / 100) }; }
  function apply(el, sty){
    try { el.style.setProperty('object-position', sty.pos, 'important'); el.style.setProperty('transform-origin', sty.pos, 'important'); el.style.setProperty('scale', sty.scale, 'important'); } catch(_){}
  }
  function same(a, b){ return Math.round(a.x) === Math.round(b.x) && Math.round(a.y) === Math.round(b.y) && Math.round(a.zoom) === Math.round(b.zoom); }
  function syncReset(){
    var show = !same(st, base);
    if(resetBtn.hidden === !show) return;
    resetBtn.hidden = !show;
    if(show && !reduce){ resetBtn.classList.remove('hoh-fit-in'); void resetBtn.offsetWidth; resetBtn.classList.add('hoh-fit-in'); }
  }
  function paint(){
    var sty = styleOf(st);
    apply(img, sty); apply(tileImg, sty);
    frame.setAttribute('data-offset-x', String(Math.round(st.x)));
    frame.setAttribute('data-offset', String(Math.round(st.y)));
    frame.setAttribute('data-zoom', String(Math.round(st.zoom)));
    if(document.activeElement !== rangeEl) rangeEl.value = String(Math.round(st.zoom));
    if(ghost) placeGhost();
    syncReset();
  }
  function setBand(x, y, spring){
    bandX = x; bandY = y;
    if(spring && !reduce){ img.classList.add('hoh-fit-spring'); setTimeout(function(){ img.classList.remove('hoh-fit-spring'); }, 240); }
    var k = (box && box.k) || 1;
    if(!x && !y) img.style.removeProperty('translate');
    else img.style.setProperty('translate', (x / k).toFixed(1) + 'px ' + (y / k).toFixed(1) + 'px');
  }
  var noteT = 0, liveT = 0;
  function say(text, show){
    clearTimeout(liveT);
    liveT = setTimeout(function(){ live.textContent = ''; live.textContent = text; }, 60);
    if(!show) return;
    noteEl.textContent = text; noteEl.classList.add('hoh-fit-note-on');
    clearTimeout(noteT); noteT = setTimeout(function(){ noteEl.classList.remove('hoh-fit-note-on'); }, 2400);
  }
  function fitsText(){ return maxZoom > 100 ? 'It already fits. Zoom in to move closer.' : 'It already fits.'; }
  function commit(source){
    st = { x: Math.round(hohFitClamp(st.x, 0, 100)), y: Math.round(hohFitClamp(st.y, 0, 100)), zoom: Math.round(hohFitClamp(st.zoom, 100, 200)) };
    paint();
    var cur = read(), changed = false;
    try {
      if(cur.x !== st.x){ window.hohSetImageOffsetX(id, slot, st.x); changed = true; }
      if(cur.y !== st.y){ window.hohSetImageOffsetY(id, slot, st.y); changed = true; }
      if(cur.zoom !== st.zoom){ window.hohSetImageZoom(id, slot, st.zoom); changed = true; }
    } catch(_){}
    if(!changed) return;
    measure();
    say(hohFitWords(st, canX, canY), false);
    try { if(typeof o.onChange === 'function') o.onChange({ x: st.x, y: st.y, zoom: st.zoom }, source); } catch(_){}
  }
  function setZoom(z, keep){
    st.zoom = hohFitClamp(Math.round(z), 100, maxZoom);
    measure(); paint();
    if(!keep) commit('zoom');
  }
  function setMaxZoom(){
    var m = hohFitMaxZoom(img.naturalWidth, img.naturalHeight);
    maxZoom = Math.max(m, Math.round(st.zoom), Math.round(base.zoom));
    rangeEl.max = String(maxZoom);
    var tiny = maxZoom <= 100;
    zoomRow.hidden = tiny;
    smallEl.hidden = !(tiny && img.naturalWidth > 0);
  }
  function isOn(){ return !(o.enabled && !o.enabled()); }
  /* ---------- ghost: the part the window cuts off, at 25% outside it ---------- */
  function placeGhost(){
    if(!ghost || !box) return;
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if(!(nw > 0 && nh > 0 && box.width > 0)){ ghost.style.display = 'none'; return; }
    var s = Math.max(box.width / nw, box.height / nh), z = st.zoom / 100, gw = nw * s * z, gh = nh * s * z;
    var r = window.hohImgPanRange(img, box, st.zoom);
    var left = box.left - st.x / 100 * r.x + bandX, top = box.top - st.y / 100 * r.y + bandY;
    var fx = box.left - left, fy = box.top - top, fx2 = fx + box.width, fy2 = fy + box.height;
    ghost.style.cssText = 'left:' + left.toFixed(1) + 'px;top:' + top.toFixed(1) + 'px;width:' + gw.toFixed(1) + 'px;height:' + gh.toFixed(1) + 'px;';
    var P = function(a, b){ return a.toFixed(1) + 'px ' + b.toFixed(1) + 'px'; };
    ghost.style.clipPath = 'polygon(evenodd,' + [P(0, 0), P(gw, 0), P(gw, gh), P(0, gh), P(0, 0), P(fx, fy), P(fx, fy2), P(fx2, fy2), P(fx2, fy), P(fx, fy)].join(',') + ')';
  }
  function aids(on){
    frame.classList.toggle('hoh-fit-active', on);
    try { document.body.classList.toggle('hoh-edit-dragging', on); } catch(_){}
    if(on){
      if(!ghost){
        ghost = document.createElement('div');
        ghost.className = 'hoh-fit-ghost'; ghost.setAttribute('aria-hidden', 'true');
        var gi = document.createElement('img'); gi.alt = ''; gi.draggable = false; gi.src = img.currentSrc || img.src;
        ghost.appendChild(gi); document.body.appendChild(ghost);
        placeGhost();
        var g0 = ghost; requestAnimationFrame(function(){ if(g0 === ghost) g0.classList.add('hoh-fit-ghost-on'); });
      }
    } else if(ghost){
      var g = ghost; ghost = null; g.classList.remove('hoh-fit-ghost-on');
      setTimeout(function(){ try { g.remove(); } catch(_){} }, reduce ? 0 : 200);
    }
  }
  /* ---------- gestures ---------- */
  var pointers = {}, drag = null, pinch = null, warned = false;
  function pts(){ return Object.keys(pointers).map(function(k){ return pointers[k]; }); }
  function begin(){
    var p = pts(); measure();
    if(p.length >= 2){
      var mx = (p[0].x + p[1].x) / 2, my = (p[0].y + p[1].y) / 2;
      pinch = { d0: Math.max(1, Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y)), z0: st.zoom, mx: mx, my: my, x0: st.x, y0: st.y };
      drag = null;
    } else if(p.length === 1){
      drag = { sx: p[0].x, sy: p[0].y, x0: st.x, y0: st.y, moved: !!(drag && drag.moved) || !!pinch, t0: Date.now() };
      pinch = null;
    }
  }
  function cap(v){ return Math.max(-22, Math.min(22, v * 0.3)); }
  function onDown(e){
    if(!isOn() || (e.button != null && e.button > 0)) return;
    cancelAnimationFrame(glideRaf);
    try { frame.setPointerCapture(e.pointerId); } catch(_){}
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    if(e.cancelable) e.preventDefault();
    warned = false;
    begin();
    aids(true);
  }
  function onMove(e){
    if(!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    if(e.cancelable) e.preventDefault();
    var p = pts();
    if(pinch && p.length >= 2){
      var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y), mx = (p[0].x + p[1].x) / 2, my = (p[0].y + p[1].y) / 2;
      st.zoom = hohFitClamp(pinch.z0 * d / pinch.d0, 100, maxZoom);
      measure();
      if(canX) st.x = hohFitClamp(pinch.x0 - (mx - pinch.mx) / range.x * 100, 0, 100);
      if(canY) st.y = hohFitClamp(pinch.y0 - (my - pinch.my) / range.y * 100, 0, 100);
      paint();
      return;
    }
    if(!drag || p.length !== 1) return;
    var dx = p[0].x - drag.sx, dy = p[0].y - drag.sy;
    if(!drag.moved && Math.hypot(dx, dy) < 6) return;
    drag.moved = true;
    var rx = canX ? drag.x0 - dx / range.x * 100 : drag.x0, ry = canY ? drag.y0 - dy / range.y * 100 : drag.y0;
    /* past an edge the art gives a little, then springs back on release */
    var ox = canX ? (rx < 0 ? -rx / 100 * range.x : (rx > 100 ? -(rx - 100) / 100 * range.x : 0)) : dx;
    var oy = canY ? (ry < 0 ? -ry / 100 * range.y : (ry > 100 ? -(ry - 100) / 100 * range.y : 0)) : dy;
    st.x = hohFitClamp(rx, 0, 100); st.y = hohFitClamp(ry, 0, 100);
    setBand(cap(ox), cap(oy), false);
    paint();
    if(!canX && !canY && !warned){ warned = true; say(fitsText(), true); }
  }
  function onUp(e){
    if(!pointers[e.pointerId]) return;
    delete pointers[e.pointerId];
    if(pts().length){ begin(); return; }
    var tap = drag && !drag.moved && e.type === 'pointerup' && (Date.now() - drag.t0) < 600;
    drag = null; pinch = null;
    setBand(0, 0, bandX || bandY);
    aids(false);
    if(tap) glide(e.clientX, e.clientY);
    else commit('drag');
  }
  /* A tap brings that spot toward the centre: solve for the X/Y that puts the
     tapped point of the art under the window's middle, within its range. */
  function glide(cx, cy){
    measure();
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if(!(nw > 0 && nh > 0) || (!canX && !canY)){ if(!canX && !canY) say(fitsText(), true); return; }
    var s = Math.max(box.width / nw, box.height / nh), z = st.zoom / 100, gw = nw * s * z, gh = nh * s * z;
    var u = (cx - (box.left - st.x / 100 * range.x)) / gw, v = (cy - (box.top - st.y / 100 * range.y)) / gh;
    var to = { x: canX ? hohFitClamp((u * gw - box.width / 2) / range.x * 100, 0, 100) : st.x, y: canY ? hohFitClamp((v * gh - box.height / 2) / range.y * 100, 0, 100) : st.y };
    var from = { x: st.x, y: st.y }, t0 = 0;
    if(reduce){ st.x = to.x; st.y = to.y; commit('tap'); return; }
    function step(t){
      if(!t0) t0 = t;
      var q = Math.min(1, (t - t0) / 240), ease = 1 - Math.pow(1 - q, 3);
      st.x = from.x + (to.x - from.x) * ease; st.y = from.y + (to.y - from.y) * ease;
      paint();
      if(q < 1) glideRaf = requestAnimationFrame(step); else commit('tap');
    }
    glideRaf = requestAnimationFrame(step);
  }
  function nudge(key, step){
    measure();
    var dx = key === 'ArrowLeft' ? -step : (key === 'ArrowRight' ? step : 0), dy = key === 'ArrowUp' ? -step : (key === 'ArrowDown' ? step : 0);
    if((dx && !canX) || (dy && !canY)){ say(fitsText(), true); return; }
    st.x = hohFitClamp(st.x + dx, 0, 100); st.y = hohFitClamp(st.y + dy, 0, 100);
    commit('key');
  }
  function reset(){ st = { x: base.x, y: base.y, zoom: base.zoom }; measure(); commit('reset'); paint(); }
  function onKey(e){
    if(!isOn()) return;
    var k = e.key;
    if(/^Arrow(Up|Down|Left|Right)$/.test(k)) nudge(k, e.shiftKey ? 10 : 2);
    else if(k === '+' || k === '=') setZoom(st.zoom + 10);
    else if(k === '-' || k === '_') setZoom(st.zoom - 10);
    else if(k === '0') reset();
    else return;
    e.preventDefault(); e.stopPropagation();
  }
  /* A trackpad pinch arrives as ctrl+wheel (Chrome, Edge, Firefox) or as
     gesture events (Safari). A plain wheel keeps scrolling the page. */
  var wheelT = 0;
  function onWheel(e){
    if(!isOn() || !e.ctrlKey) return;
    e.preventDefault();
    setZoom(st.zoom * Math.exp(-Math.max(-40, Math.min(40, e.deltaY)) / 100), true);
    clearTimeout(wheelT); wheelT = setTimeout(function(){ commit('zoom'); }, 250);
  }
  var gz = null;
  function onGStart(e){ if(e.cancelable) e.preventDefault(); gz = pts().length ? null : st.zoom; }
  function onGChange(e){ if(e.cancelable) e.preventDefault(); if(gz != null && isOn()) setZoom(gz * (e.scale || 1), true); }
  function onGEnd(e){ if(e.cancelable) e.preventDefault(); if(gz != null && isOn()) commit('zoom'); gz = null; }
  function onRoot(e){
    var b = e.target.closest && e.target.closest('[data-fit-zoom],[data-fit-move],.hoh-fit-reset');
    if(!b || !root.contains(b)) return;
    if(b.hasAttribute('data-fit-zoom')) setZoom(st.zoom + (+b.getAttribute('data-fit-zoom')));
    else if(b.hasAttribute('data-fit-move')) nudge(b.getAttribute('data-fit-move'), 10);
    else { reset(); try { frame.focus({ preventScroll: true }); } catch(_){} }
  }
  function onRangeInput(){ setZoom(+rangeEl.value, true); }
  function onRangeChange(){ setZoom(+rangeEl.value); }
  var ffEl = owner ? null : document.getElementById('hoh-f-ff-portrait');
  function syncFF(){ root.classList.toggle('hoh-fit-ff', !!(ffEl && ffEl.checked)); }
  function ready(first){
    measure(); setMaxZoom(); paint();
    if(!first || owner || reduce) return;
    /* it lands: the kept glow once, and on a first visit a small nudge that
       shows the picture moves */
    stage.classList.remove('hoh-fit-glow'); void stage.offsetWidth; stage.classList.add('hoh-fit-glow');
    var seen = false; try { seen = localStorage.getItem('hoh-fit-hint-v1') === '1'; localStorage.setItem('hoh-fit-hint-v1', '1'); } catch(_){}
    if(!seen && (canX || canY)){ img.classList.add(canY ? 'hoh-fit-hint-y' : 'hoh-fit-hint-x'); setTimeout(function(){ img.classList.remove('hoh-fit-hint-y', 'hoh-fit-hint-x'); }, 1100); }
  }
  frame.addEventListener('pointerdown', onDown);
  frame.addEventListener('pointermove', onMove);
  frame.addEventListener('pointerup', onUp);
  frame.addEventListener('pointercancel', onUp);
  frame.addEventListener('lostpointercapture', onUp);
  frame.addEventListener('keydown', onKey);
  frame.addEventListener('wheel', onWheel, { passive: false });
  frame.addEventListener('gesturestart', onGStart);
  frame.addEventListener('gesturechange', onGChange);
  frame.addEventListener('gestureend', onGEnd);
  root.addEventListener('click', onRoot);
  rangeEl.addEventListener('input', onRangeInput);
  rangeEl.addEventListener('change', onRangeChange);
  if(ffEl) ffEl.addEventListener('change', syncFF);
  syncFF();
  if(img.complete && img.naturalWidth) ready(true);
  else img.addEventListener('load', function(){ ready(true); }, { once: true });
  paint();
  var api = {
    el: root, frame: frame,
    get: function(){ return { x: Math.round(st.x), y: Math.round(st.y), zoom: Math.round(st.zoom) }; },
    reset: reset,
    refresh: function(){ st = read(); measure(); paint(); },
    destroy: function(){
      cancelAnimationFrame(glideRaf); clearTimeout(wheelT); clearTimeout(noteT); clearTimeout(liveT);
      aids(false); setBand(0, 0, false);
      frame.removeEventListener('pointerdown', onDown); frame.removeEventListener('pointermove', onMove);
      frame.removeEventListener('pointerup', onUp); frame.removeEventListener('pointercancel', onUp); frame.removeEventListener('lostpointercapture', onUp);
      frame.removeEventListener('keydown', onKey); frame.removeEventListener('wheel', onWheel);
      frame.removeEventListener('gesturestart', onGStart); frame.removeEventListener('gesturechange', onGChange); frame.removeEventListener('gestureend', onGEnd);
      if(ffEl) ffEl.removeEventListener('change', syncFF);
      if(owner){
        added.forEach(function(n){ try { n.remove(); } catch(_){} });
        frame.classList.remove('hoh-fit-frame', 'hoh-fit-active');
        ['tabindex', 'role', 'aria-label', 'aria-describedby', 'data-pan-axis'].forEach(function(a){ frame.removeAttribute(a); });
        try { root.remove(); } catch(_){}
      }
      if(host.__hohFit === api) host.__hohFit = null;
    }
  };
  host.__hohFit = api;
  return api;
}
window.hohFitEditor = hohFitEditor;

window.hohOpenEditForm=async function(id,opts){
 hohQuestHandoff=null;
 var c=allCharacters.find(function(ch){return ch.id===id;}) || ((window.__hohHidden||[]).find(function(ch){return ch && ch.id===id;})) || hohFindOwnHidden(id);
 /* R168: an owner's hidden quest hero is not in the visible list, so pull it
    by id so they can open its edit form. The save is still gated server-side
    by ownership, so opening the form for a non-owned hero changes nothing. */
 if(!c){ try{ var _ef=await supabase.from('characters').select(HOH_CHAR_COLS).eq('id',id).limit(1); if(_ef && _ef.data && _ef.data[0]) c=_ef.data[0]; }catch(_){} }
 if(!c) return;
 /* R65: god-mode bypass. When Jangela is signed in (god mode), the
    ownership gate is OFF — they can edit any character\'s info,
    swap the image, recenter the crop, etc. The change persists via
    the standard edit RPC (server-side ownership policy may also
    need to whitelist the god-mode email — that\'s a separate
    backend concern; the client surface is unblocked here). For
    everyone else the existing ownership gate stays put. */
 var isGod = (typeof window.hohIsGodMode === 'function') && window.hohIsGodMode();
 if(!isGod && window.hohYourHallCanEditCharacter && !window.hohYourHallCanEditCharacter(c)){
  hohShowHeartToast('Sign in to edit','Open Your Hall and sign in to edit your hero.');
  return;
 }
 if(!isGod && typeof window.hohCheckEditCooldown==='function'){
  var ck=await window.hohCheckEditCooldown(id);
  if(ck&&ck.allowed===false){hohShowHeartToast(ck.title,ck.sub);return;}
 }
 window.hohEditingCharacterId=id;
 /* ⛔ ====== R609 · THE EDIT FORM OPENS THE SAME DOOR AS THE SUBMIT FORM ======
    Jan, on a phone: "when you press edit your hero ... on mobile it's
    essentially impossible to scroll once you click it."
    ROOT CAUSE, and it is one missing call. `hohOpenForm` presents through
    `hohPresentViewportModal`, which adds `.hoh-viewport-modal`. THAT class is
    where `--hoh-vm-top` / `--hoh-vm-bottom` are declared. This function set
    `display:flex` by hand, so on a phone the modal never carried the class,
    both custom properties were UNDEFINED, and the `@media (max-width:820px)`
    rule `max-height:calc(100vh - var(--hoh-vm-top) - var(--hoh-vm-bottom))`
    became invalid at computed-value time — which resolves `max-height` to its
    initial value, `none`. That same media block also sets `overflow:hidden` on
    the wrap and on `#hoh-form-inner`, unconditionally.
    So the edit sheet was a box with NO height cap and NO scroller, holding a
    form far taller than the screen, over a body pinned with the old
    `overflow:hidden` that iOS Safari ignores. Everything below the fold was
    unreachable. Desktop was always fine, because none of those rules apply
    above 820px — which is exactly why this only ever showed up on a phone.
    Presenting through the helper also buys the R580 position:fixed scroll
    lock, the inert background, the dialog focus and the Escape contract that
    this path has never had. The matching CSS gives the non-wizard body its own
    scroller, because edit mode deliberately has no wizard step to scroll. */
 var dm=document.getElementById('hoh-modal');
 if(dm){
  if(typeof window.hohDismissViewportModal==='function')window.hohDismissViewportModal(dm);
  else dm.style.display='none';
 }
 if(typeof window.hohPresentViewportModal==='function')window.hohPresentViewportModal('hoh-form-modal');
 else document.getElementById('hoh-form-modal').style.display='flex';
 /* R257: edit mode always shows the ticket chips (earn-on-edit, R267). */
 try{ var _fmE=document.getElementById('hoh-form-modal'); if(_fmE) _fmE.classList.remove('hoh-first-run'); }catch(_){}
 document.body.style.overflow='hidden';
 showFormView(c);
 /* The form is rebuilt after the present call, so the reset that helper ran
    measured the OLD content. Put the fresh sheet at its top. */
 try{ if(typeof window.hohResetViewportModal==='function')window.hohResetViewportModal('hoh-form-modal'); }catch(_){}
 /* R140-Z3p: Seed the NPC stats module with existing stats_block (if
    any) so the form prefills with what was saved. The story is already
    filled (edit-mode), so the visibility gate will trip on first
    update + the panel will mount with the seed values. */
 try { hohResetNpcStatsModuleState(c && c.stats_block ? c.stats_block : null); } catch(_){}
 try { hohUpdateNpcStatsVisibility(); } catch(_){}
 /* PLAYTESTER 2026-10-04: opened from a hero page's edit link, land on the
    part the link named. After hohPresentViewportModal's queued reset (it puts
    every scroller back at the top and focuses the dialog on the next tick), so
    this runs second and stays. */
 var part=opts&&opts.part;
 if(part==='story'||part==='sheet'){
  var forId=id;
  setTimeout(function(){ if(String(window.hohEditingCharacterId)===String(forId)){ try{ hohEditGoTo(part); }catch(_){ } } },60);
 }
};
/* PLAYTESTER 2026-10-04 · the part of the edit form a hero page link asked for.
   story: the story box, in view under the sticky header, focused at its end.
   sheet: the hero's game numbers together under "At the table" (the hero
   page's own heading for the sheet). The Level box and the D&D 5e stat block
   are moved there, the stat block opens, and the Level box takes focus. The
   form is rebuilt on every open, so nothing here outlives this one edit. The
   scroll is instant, as every screen change in the Hall is. */
function hohEditScrollTo(el){
 if(!el)return;
 var box=null;
 for(var p=el.parentElement;p&&p!==document.body&&p!==document.documentElement;p=p.parentElement){
  var cs=getComputedStyle(p);
  if(/(auto|scroll)/.test(cs.overflowY)&&p.scrollHeight>p.clientHeight+2){box=p;break;}
 }
 if(!box){ try{ el.scrollIntoView({block:'start',behavior:'instant'}); }catch(_){ el.scrollIntoView(true); } return; }
 var clear=16;
 var hdr=document.querySelector('#hoh-form-modal .hoh-form-header');
 if(hdr&&box.contains(hdr)&&getComputedStyle(hdr).position==='sticky')clear+=hdr.getBoundingClientRect().height;
 var top=el.getBoundingClientRect().top-box.getBoundingClientRect().top+box.scrollTop-clear;
 box.scrollTop=Math.max(0,Math.round(top));
}
function hohEditSheetGroup(){
 var lvl=document.getElementById('hoh-f-level');
 var field=lvl&&lvl.closest('.hoh-field');
 var row=field&&field.closest('.hoh-row');
 var wrap=document.getElementById('hoh-npc-stats-wrap');
 if(!field||!row||!wrap||!row.parentNode)return null;
 var h=document.getElementById('hoh-edit-sheet-h');
 if(!h){ h=document.createElement('h3'); h.id='hoh-edit-sheet-h'; h.className='hoh-add-legend hoh-edit-sheet-h'; h.textContent='At the table'; }
 row.parentNode.insertBefore(h,row.nextSibling);
 h.parentNode.insertBefore(field,h.nextSibling);
 field.classList.add('hoh-edit-sheet-level');
 field.parentNode.insertBefore(wrap,field.nextSibling);
 row.classList.add('hoh-row-one');
 return h;
}
function hohOpenNpcStatsPanel(){
 var wrap=document.getElementById('hoh-npc-stats-wrap');
 var trig=document.getElementById('hoh-npc-stats-trigger');
 var panel=document.getElementById('hoh-npc-stats-panel');
 var mount=document.getElementById('hoh-npc-stats-mount');
 if(!wrap||!trig||!panel)return;
 wrap.style.display='';
 if(mount&&!mount.firstChild&&typeof window.hohRenderNpcStatsForm==='function'){
  try{
   _hohNpcStatsReader=window.hohRenderNpcStatsForm(mount,_hohNpcStatsSeed);
   var quickAc=document.getElementById('hoh-f-quick-ac'),fullAc=document.getElementById('hoh-stats-ac-value');
   if(quickAc&&quickAc.value&&fullAc)fullAc.value=quickAc.value;
   _hohNpcStatsMounted=true;
  }catch(_){ }
 }
 trig.classList.add('hoh-npc-open');
 panel.classList.add('hoh-npc-open');
}
function hohEditGoTo(part){
 if(part==='story'){
  var ta=document.getElementById('hoh-f-story');
  if(!ta)return;
  hohEditScrollTo(ta.closest('.hoh-field')||ta);
  try{ ta.focus({preventScroll:true}); var n=ta.value.length; ta.setSelectionRange(n,n); }catch(_){ }
  return;
 }
 if(part==='sheet'){
  var h=hohEditSheetGroup();
  hohOpenNpcStatsPanel();
  if(h)hohEditScrollTo(h);
  var lv=document.getElementById('hoh-f-level');
  if(lv){ try{ lv.focus({preventScroll:true}); }catch(_){ } }
 }
}
window.hohEditGoTo=hohEditGoTo;
window.hohGetCompanyUsage=function(){
 try{
 var raw=localStorage.getItem(HOH_COMPANY_USAGE_KEY);
 if(!raw)return{day:hohToday(),count:0};
 var parsed=JSON.parse(raw);
 if(!parsed||parsed.day!==hohToday())return{day:hohToday(),count:0};
 return{day:parsed.day,count:parseInt(parsed.count,10)||0};
 }catch(e){return{day:hohToday(),count:0};}
};
window.hohCompanyUsesLeft=function(){
 var u=window.hohGetCompanyUsage();
 return Math.max(0,HOH_COMPANY_DAILY_CAP-u.count);
};
window.hohIncrementCompanyUsage=function(){
 var u=window.hohGetCompanyUsage();
 try{localStorage.setItem(HOH_COMPANY_USAGE_KEY,JSON.stringify({day:u.day,count:u.count+1}));}catch(e){}
};
window.hohCompanyDailyCap=HOH_COMPANY_DAILY_CAP;

function validateForm(){
 var n=document.getElementById('hoh-f-name'),p=document.getElementById('hoh-f-player'),e=document.getElementById('hoh-f-email'),r=document.getElementById('hoh-f-race'),c=document.getElementById('hoh-f-class'),s=document.getElementById('hoh-f-story'),btn=document.getElementById('hoh-submit-btn'),ffWrap=document.getElementById('hoh-ff-toggle-wrap');
 if(!n||!p||!e||!r||!c||!s||!btn)return;
 /* Live updates run on every form change so the user sees feedback as
  they type, not only on submit. */
 hohUpdateStoryProgress();
 hohUpdateSmsVisibility();
 hohUpdateNpcVisibility();
 /* Debug link visibility — surfaces under the name field the moment
    "jangela" (any case) is typed, letting the developer skip past
    the rest of the form straight to the success view. R49: case
    insensitive so typing on mobile keyboards (where autocaps may
    fail or override) still triggers it. */
 var dbg=document.getElementById('hoh-f-debug-btn');
 if(dbg){
  var nameVal = String(n.value || '').trim().toLowerCase();
  dbg.style.display = (nameVal === 'jangela'&&!hohQuestHandoff) ? 'inline-block' : 'none';
 }
 /* Submit gate now requires a valid email format and a story long
  enough to clear the soft 80-char floor. The full quality check still
  runs on actual submit for the deeper gibberish heuristics. */
 var storyOk=s.value.trim().length>=80;
 /* R795b: the short wizard asks for the story on the hero page, after the
    submit. And a hero that came in that way may have no story yet, so an
    edit that leaves the story exactly as it was must still save (the hero
    page fills it). A story someone types here still needs its 80 characters. */
 if(!storyOk&&typeof HOH_WIZ!=='undefined'&&HOH_WIZ.short)storyOk=true;
 if(!storyOk&&window.hohEditingCharacterId&&hohHeroPageBase()&&typeof s.__hohWas==='string'&&s.value.trim()===s.__hohWas.trim())storyOk=true;
 var allFilled=n.value.trim()&&p.value.trim()&&hohValidEmail(e.value)&&r.value&&c.value&&storyOk&&selectedFiles[0];
 if(hohQuestHandoff)allFilled=allFilled&&hohQuestPinOk(hohQuestPin());
 // In edit mode the daily submission cooldown does not apply.
 /* HERO-CARD-01: a portrait from a client's own commission never waits for tomorrow */
 var cooldown=!window.hohEditingCharacterId&&!hohQuestHandoff&&!window.hohPortalCard&&hohHasSubmittedToday();
 if(cooldown){
 btn.disabled=true;
 btn.textContent='One Hero per Day \u00b7 Come Back Tomorrow';
 btn.classList.add('hoh-btn-cooldown');
 }else{
 btn.disabled=!allFilled;
 btn.classList.remove('hoh-btn-cooldown');
 if(btn.textContent==='One Hero per Day \u00b7 Come Back Tomorrow')btn.textContent=window.hohEditingCharacterId?'Save Changes':'Submit to the Hall of Heroes';
 }
 if(ffWrap){if(allFilled&&!cooldown)ffWrap.classList.add('hoh-ff-visible');else ffWrap.classList.remove('hoh-ff-visible');}
 var notice=document.getElementById('hoh-submit-cooldown');
 if(notice)notice.style.display=cooldown?'block':'none';
 /* R148-Z17: Sync the pay-300 button state against the live wallet.
    Disabled + "Need N more hearts" when bank < 300, enabled + price
    chip otherwise. Hidden entirely in edit mode. */
 try {
   var payBtn = document.getElementById('hoh-submit-cooldown-pay-btn');
   var hintEl = document.getElementById('hoh-submit-cooldown-pay-hint');
   if(payBtn){
     var bankNow = (typeof window.heartsRemainingToday === 'function') ? window.heartsRemainingToday() : 0;
     var cost = (typeof HOH_EXTRA_SUB_COST === 'number') ? HOH_EXTRA_SUB_COST : 300;
     var canPay = bankNow >= cost;
     payBtn.disabled = !canPay;
     payBtn.classList.toggle('hoh-submit-cooldown-pay-disabled', !canPay);
     /* Compact label: only the cost chip changes. The "Submit another"
        copy stays static for clarity. */
     if(!canPay && hintEl){
       hintEl.textContent = 'Need ' + (cost - bankNow) + ' more heart' + (cost - bankNow === 1 ? '' : 's') + '. Second submission won\'t earn a ticket.';
     } else if(hintEl){
       hintEl.textContent = 'Second submission won\'t earn a raffle ticket.';
     }
   }
 } catch(_){}
 /* R424: validateForm is this form's canonical "something changed" call —
    the file picker, the drag-drop zone and the race/class selects all end
    here — so the wizard's nav repaints from it and can never go stale
    against a control that fires no input event. Guarded so the wizard
    never breaks validation if it is off (edit mode) or half-built. */
 try { if(typeof HOH_WIZ !== 'undefined' && HOH_WIZ.on) hohWizPaint(); } catch(_){}
}

var HOH_DRAFT_KEY='hoh-form-draft';
var hohDraftTimer=null;
function hohSaveDraft(){
 /* R433: edit mode shares every field id with the new-hero form, so every
    keystroke while fixing an existing hero was overwriting the NEW-hero
    draft with that hero's data. Anyone who edited one hero and then opened
    the submit form found it pre-filled with somebody else's. The draft is
    for new submissions only. */
 if(window.hohEditingCharacterId||hohQuestHandoff) return;
 clearTimeout(hohDraftTimer);
 hohDraftTimer=setTimeout(function(){
 try{
  var ffEl=document.getElementById('hoh-f-ff-portrait');
  var smsEl=document.getElementById('hoh-f-sms-optin');
  var draft={
  name:(document.getElementById('hoh-f-name')||{}).value||'',
  player:(document.getElementById('hoh-f-player')||{}).value||'',
  email:(document.getElementById('hoh-f-email')||{}).value||'',
  race:(document.getElementById('hoh-f-race')||{}).value||'',
  customRace:(document.getElementById('hoh-f-custom-race')||{}).value||'',
  charClass:(document.getElementById('hoh-f-class')||{}).value||'',
  customClass:(document.getElementById('hoh-f-custom-class')||{}).value||'',
  level:(document.getElementById('hoh-f-level')||{}).value||'',
  campaign:(document.getElementById('hoh-f-campaign')||{}).value||'',
  story:(document.getElementById('hoh-f-story')||{}).value||'',
  /* R574: the card step is part of the draft too. A person who writes their
     card line and then closes the tab must not come back to an empty box. */
  legend:(document.getElementById('hoh-f-legend')||{}).value||'',
  quote:(document.getElementById('hoh-f-quote')||{}).value||'',
  artist:(document.getElementById('hoh-f-artist')||{}).value||'',
  dmDetails:window.hohTools?window.hohTools.stepRead():null,
  npcGoal:(document.getElementById('hoh-f-npc-goal')||{}).value||'',
  npcWeakness:(document.getElementById('hoh-f-npc-weakness')||{}).value||'',
  npcHabit:(document.getElementById('hoh-f-npc-habit')||{}).value||'',
  npcCatchphrase:(document.getElementById('hoh-f-npc-catchphrase')||{}).value||'',
  npcSecret:(document.getElementById('hoh-f-npc-secret')||{}).value||'',
  npcEnemy:(document.getElementById('hoh-f-npc-enemy')||{}).value||'',
  isFFPortrait:ffEl?ffEl.checked:false,
  phone:(document.getElementById('hoh-f-phone')||{}).value||'',
  smsOptin:smsEl?smsEl.checked:false,
  /* R433 (Jan): "make sure each step feels intuitive and actually saves so
     if they lose it they can regain it back." The field VALUES always came
     back; the POSITION never did, so a person who closed the tab on step 4
     reopened on the gate and had to walk five screens to find out nothing
     was missing. The step rides along now. */
  step:(typeof HOH_WIZ!=='undefined'&&HOH_WIZ.on)?HOH_WIZ.step:null,
  savedAt:Date.now()
  };
  localStorage.setItem(HOH_DRAFT_KEY,JSON.stringify(draft));
 }catch(e){}
 },250);
}
function hohRestoreDraft(){
 try{
 var raw=localStorage.getItem(HOH_DRAFT_KEY);
 if(!raw)return;
 var d=JSON.parse(raw);
 if(!d||typeof d!=='object')return;
 if(d.savedAt&&(Date.now()-d.savedAt>7*24*60*60*1000)){localStorage.removeItem(HOH_DRAFT_KEY);return;}
 var hasContent=(d.name||d.player||d.email||d.story||d.race||d.charClass);
 if(!hasContent)return;
 function setVal(id,v){var el=document.getElementById(id);if(el&&v)el.value=v;}
 /* R795b: the short wizard never shows the story or DM steps, so a draft's
    words are not put back into fields nobody can see (the submit would carry
    them unseen). The hero page asks for them right after the submit. */
 var _wizShort=(typeof HOH_WIZ!=='undefined'&&HOH_WIZ.short);
 setVal('hoh-f-name',d.name);setVal('hoh-f-player',d.player);setVal('hoh-f-email',d.email);setVal('hoh-f-level',d.level);setVal('hoh-f-campaign',d.campaign);if(!_wizShort)setVal('hoh-f-story',d.story);setVal('hoh-f-legend',d.legend);setVal('hoh-f-quote',d.quote);setVal('hoh-f-artist',d.artist);
 if(window.hohTools&&!_wizShort)window.hohTools.stepRestore(d.dmDetails);
 if(!_wizShort){
 setVal('hoh-f-npc-goal',d.npcGoal);setVal('hoh-f-npc-weakness',d.npcWeakness);setVal('hoh-f-npc-habit',d.npcHabit);
 setVal('hoh-f-npc-catchphrase',d.npcCatchphrase);setVal('hoh-f-npc-secret',d.npcSecret);setVal('hoh-f-npc-enemy',d.npcEnemy);
 }
 setVal('hoh-f-phone',d.phone);
 var smsEl2=document.getElementById('hoh-f-sms-optin');
 if(smsEl2&&d.smsOptin){smsEl2.checked=true;hohToggleSmsField(smsEl2);}
 if(d.race){var rEl=document.getElementById('hoh-f-race');if(rEl){for(var i=0;i<rEl.options.length;i++){if(rEl.options[i].value===d.race){rEl.value=d.race;if(d.race==='Other'){document.getElementById('hoh-f-custom-race').style.display='block';setVal('hoh-f-custom-race',d.customRace);}break;}}}}
 if(d.charClass){var cEl=document.getElementById('hoh-f-class');if(cEl){for(var j=0;j<cEl.options.length;j++){if(cEl.options[j].value===d.charClass){cEl.value=d.charClass;if(d.charClass==='Other'){document.getElementById('hoh-f-custom-class').style.display='block';setVal('hoh-f-custom-class',d.customClass);}break;}}}}
 var ffEl=document.getElementById('hoh-f-ff-portrait');if(ffEl&&d.isFFPortrait)ffEl.checked=true;
 if(!_wizShort&&(d.npcGoal||d.npcWeakness||d.npcHabit||d.npcCatchphrase||d.npcSecret||d.npcEnemy)){var trig=document.getElementById('hoh-npc-panel-trigger'),panel=document.getElementById('hoh-npc-panel');if(trig&&panel){trig.classList.add('hoh-npc-open');panel.classList.add('hoh-npc-open');}}
 var notice=document.getElementById('hoh-draft-notice');if(notice)notice.style.display='flex';
 validateForm();
 /* R433: back to the step they left. The one thing that CANNOT survive
    localStorage is the portrait — File objects do not serialise — so a
    draft written on step 3 or later still reopens with an empty step 2.
    Sending them to step 4 would strand them behind a gate they cannot see,
    so the jump is clamped to the portrait step whenever the image is gone.
    Step 0 is skipped either way: a draft means they already read the gate. */
 try{
  if(typeof HOH_WIZ!=='undefined'&&HOH_WIZ.on){
   var _st=parseInt(d.step,10);
   if(_st>0){
    if(!selectedFiles[0])_st=Math.min(_st,2);
    hohWizGo(_st,true);
   }
  }
 }catch(_){}
 }catch(e){}
}
window.hohClearDraft=function(e){if(e)e.preventDefault();try{localStorage.removeItem(HOH_DRAFT_KEY);}catch(err){}showFormView();};
window.hohToggleNpcPanel=function(){
 var trig=document.getElementById('hoh-npc-panel-trigger'),panel=document.getElementById('hoh-npc-panel');
 if(!trig||!panel)return;
 var opening=!panel.classList.contains('hoh-npc-open');
 trig.classList.toggle('hoh-npc-open');panel.classList.toggle('hoh-npc-open');
 if(opening&&typeof hohScrollTriggerIntoModal==='function')hohScrollTriggerIntoModal(trig);
};

/* ============================================================
   R424 (Jan) · THE SUBMISSION WIZARD
   ============================================================
   Jan's screenshots show the problem without a word of explanation: the
   modal opens on two boxes of reading, and BELOW the fold sit a portrait
   uploader, seven required fields, a story box, two collapsible panels of
   optional detail, a PIN, an SMS toggle and a submit button. One scroll,
   twenty decisions, no sense of how far away the end is. Long forms are
   abandoned in the middle, and the middle is exactly where this one keeps
   its most valuable field — the story.

   WHAT DECIDED THE ORDER (the barrier ranking, hardest first):
     1. the PORTRAIT — they need a file in hand; the single biggest reason
        someone bounces having given nothing
     2. the STORY — real writing effort, and the field the Hall lives on
     3. EMAIL and PIN — trivial to type, but the moment a stranger asks for
        contact details is the moment people reconsider
     4. name / race / class / level — near-zero effort
   Asking in that order would be exactly wrong, so the wizard inverts it:

     GATE  what the Hall is for, and the quality bar. No inputs at all, so
           the first screen costs nothing and can only motivate. Jan asked
           for this explicitly, and it doubles as the first tiny commitment
           — people who take one step take the next.
     1     THE HERO — name, race, class, level, campaign. Five easy fields.
           Naming a character is an act of ownership; from here on it is
           THEIR hero being left unfinished, not a form.
     2     THE PORTRAIT — asked only after the hero has a name, so the trip
           to find the file is on behalf of someone who already exists. The
           "I commissioned this from FramedFantasy" tick moves here too: it
           is a fact about the image, and it used to sit six fields away at
           the bottom of the page.
     3     THEIR STORY — alone on its own screen. The most valuable field in
           the Hall gets undivided attention instead of being the ninth
           thing on a wall.
     4     FOR DMS — the two optional panels, at the point of deepest
           investment, with their one-ticket rewards stated plainly. Optional
           detail is given most freely by people who have already finished
           something, which is why this step sits fourth and not first.
     5     YOU — alias, email, PIN, texts, submit. Contact details last,
           when the hero is already built and abandoning costs something.

   HOW IT IS BUILT, and why this way: every field stays exactly where it
   was in the DOM, wrapped into step containers by data-wstep. Nothing that
   reads the form by id changes — validateForm, hohSaveDraft,
   hohRestoreDraft, hohSubmitCharacter and the stat-block module all keep
   working untouched. The wizard is chrome around the same form, not a
   rewrite of it, which is the difference between a UX change and a
   regression surface.

   EDIT MODE KEEPS THE SINGLE FORM. Someone editing a hero they wrote knows
   what they came to change; making them page through five steps to fix one
   typo would be worse, not better. */
/* R574 (Jan): "show them a preview of what their card is going to look like ...
   right before this last step ... after they put in the character image, and
   before they are prompted to put in their email." That is a new step 5, and
   "You" moves to 6. Every element that carried data-wstep="5" was retagged in
   the same change, because hohWizInit files panes by that attribute and a
   stale 5 would have stranded the email field on the card step. */
/* ⛔ R795 · SCREENS GROUP THE STEPS; THE STEP NUMBERS NEVER CHANGE.
   The approved Add screen (prototype round 2) puts the portrait uploader on
   top of the hero's fields, so steps 2 and 1 share screen 1 (in that order).
   The logical steps keep their numbers because other code depends on them:
   hoh-tools.js files its block under data-wstep="4", the submit path jumps
   with hohWizGo(6) and walks hohWizMissing(1..6), and a saved draft stores a
   step. HOH_WIZ.step stays a logical step (a screen's lowest), the panes,
   rail, counter and Continue/Back work by screen. */
/* ⛔ Jan (2026-09-23): "when adding the hero initially, make sure you leverage
   what we already had which was filling out the info in steps instead of
   presenting a huge form to them". R795 had put the portrait and the hero on
   one screen; every step is its own screen again, in the order the wizard had
   before R795: the hero, then the portrait. */
var HOH_WIZ = {
  on: false, step: 0, max: 6, dir: 0, short: false,
  screens: [[0], [1], [2], [3], [4], [5], [6]],
  screenMeta: {},
  meta: [
    /* HALLFLOWS (2026-09-25): no subtitle on the gate. "What the Hall is for"
       said what the box under it already says ("Why submit?"), so the first
       screen stacked four headings before its first sentence. */
    { t: 'Before you begin', s: '' },
    { t: 'The hero',         s: 'Who are they?' },
    { t: 'The portrait',     s: 'Show the Hall their face' },
    { t: 'Their story',      s: 'The part that wins the spotlight' },
    { t: 'Bring them to life', s: 'Two quick answers, plus optional DM details' },
    { t: 'Your card',        s: 'How they will hang in the Hall' },
    { t: 'You',              s: 'Your name goes on the hero' }
  ]
};
/* ⛔ R795b (Jan, 2026-09-23: "yes ... now implement"). Once the hero page
   exists, "Their story" (step 3) and "Bring them to life" (step 4) are asked
   on the hero page as questions, so a NEW submission skips both screens:
   Before you begin, the hero, the portrait, Your card, You. Their fields stay
   in the DOM (hidden, empty), so the draft, validateForm and the submit read
   the same form and send the same payload. Edit mode keeps its single form,
   a Quest handoff keeps every screen, and with no hero page the wizard is
   exactly as before. showFormView picks the list on every open. */
var HOH_WIZ_FULL = [[0], [1], [2], [3], [4], [5], [6]];
var HOH_WIZ_SHORT = [[0], [1], [2], [5], [6]];
/* HERO-CARD-01 (Jan, 2026-10-28): a client's finished portrait, sent from their commission page with the blueprint
   filled in (hoh-your-hall.js takePortalHero). The gate is skipped, since they came to do this one thing. The story
   screen shows when the blueprint had one, so they read what goes public, and "Bring them to life" waits for the hero
   page as on any short add. Nothing is locked: every field stays theirs to change. */
var HOH_WIZ_PORTAL = [[1], [2], [3], [5], [6]], HOH_WIZ_PORTAL_NOSTORY = [[1], [2], [5], [6]];
window.hohPortalCardMode = function(hasStory){
  if(!HOH_WIZ.on || window.hohEditingCharacterId || hohQuestHandoff) return false;
  HOH_WIZ.short = true;
  HOH_WIZ.screens = hasStory ? HOH_WIZ_PORTAL : HOH_WIZ_PORTAL_NOSTORY;
  /* no gate, so every screen is a numbered step with its own pip */
  var rail = document.querySelector('#hoh-form-inner .hoh-wiz-rail');
  if(rail) rail.innerHTML = new Array(HOH_WIZ.screens.length + 1).join('<span class="hoh-wiz-pip"></span>');
  hohWizGo(1, true);
  try{ validateForm(); }catch(_){ }
  return true;
};
function hohWizVal(id){ var el = document.getElementById(id); return el ? String(el.value || '').trim() : ''; }
/* R795: the screen a logical step is shown on, a screen's lead step (its
   lowest, which HOH_WIZ.step holds), and what a whole screen still needs, in
   the order its panes are shown. */
function hohWizScreen(step){
  for(var i = 0; i < HOH_WIZ.screens.length; i++){ if(HOH_WIZ.screens[i].indexOf(step) !== -1) return i; }
  /* R795b: a step the short wizard leaves out (a draft saved on the story or
     DM step) opens on the next screen that is shown */
  for(var j = 0; j < HOH_WIZ.screens.length; j++){ if(Math.min.apply(null, HOH_WIZ.screens[j]) > step) return j; }
  return Math.max(0, HOH_WIZ.screens.length - 1);
}
function hohWizLead(sc){
  sc = Math.max(0, Math.min(HOH_WIZ.screens.length - 1, sc | 0));
  return Math.min.apply(null, HOH_WIZ.screens[sc]);
}
function hohWizScreenMissing(sc){
  var out = [];
  (HOH_WIZ.screens[sc] || []).forEach(function(s){ out = out.concat(hohWizMissing(s)); });
  return out;
}
/* ⛔ R588 (Jan): "on the logged in mode, it says you at the top, and your name
   goes on the hero, but nothing is there ... logged in mode already has that
   information."
   The last step promises a thing it then does not ask for. A signed-in visitor
   has their name and email written into hidden inputs and both wrappers set to
   `display:none` further up this file, so the screen reads "You / Your name
   goes on the hero" above a lone phone box. The words were describing a step
   that only exists when signed out.
   ⛔ THIS TESTS THE SAME CONDITION THAT DOES THE HIDING, on purpose. A separate
   "is signed in" flag could drift from it and put the words back out of step
   with the fields, which is the whole defect. `hohYourHallEmail()` returning
   something is exactly what hides the credit fields, so the copy and the form
   can never disagree.
   Deliberately NOT `hohIsSignedInRobust()`: an email-only token still hides the
   name and email while leaving the PIN box, and the name really is already on
   the hero in that case too. */
function hohWizKnowsYou(){
  if(hohQuestHandoff)return false;
  try{
    return !!(typeof window.hohYourHallEmail === 'function' &&
              String(window.hohYourHallEmail() || '').trim());
  }catch(_){ return false; }
}
/* ⛔ ============ R574 · THE CARD STEP ============
   Jan: "show them a preview of what their card is going to look like ... this
   one will just say Customize your card ... and that way they can type in
   their character's description box, basically the stuff that we are
   generating." */
var HOH_LEGEND_MAX = 260, HOH_QUOTE_MAX = 120;
var _hohCardImgURL = null, _hohCardImgFor = null;
function hohCardStepIsFF(){
  var el = document.getElementById('hoh-f-ff-portrait');
  return !!(el && el.checked);
}
/* The credit field appears only once there is an image to credit, and never on
   a FramedFantasy portrait, whose credit line already reads "Portrait by
   FramedFantasy" and would contradict a second artist. */
function hohArtistFieldSync(){
  var wrap = document.getElementById('hoh-artist-wrap');
  if(!wrap) return;
  var has = false;
  try{ has = !!(selectedFiles && selectedFiles[0]); }catch(_){ }
  wrap.style.display = (has && !hohCardStepIsFF()) ? '' : 'none';
}
/* ⛔ THE IMAGE IS NOT A URL YET. What the form holds is a File, so the preview
   makes one object URL and reuses it until the file changes, revoking the old
   one rather than leaking a URL per keystroke. On the EDIT path selectedFiles[0]
   is the STRING 'keep', which means "the image already on the row", so fall
   back to that hero's stored art instead of rendering a card with no face. */
function hohCardStepImage(){
  var f = null;
  try{ f = selectedFiles && selectedFiles[0]; }catch(_){ }
  if(f && f !== 'keep' && typeof f !== 'string'){
    if(_hohCardImgFor !== f){
      if(_hohCardImgURL){ try{ URL.revokeObjectURL(_hohCardImgURL); }catch(_){ } }
      try{ _hohCardImgURL = URL.createObjectURL(f); _hohCardImgFor = f; }catch(_){ _hohCardImgURL = null; }
    }
    return _hohCardImgURL || '';
  }
  if(f==='keep'&&hohQuestHandoff)return hohQuestHandoff.hero.image_url||'';
  if(window.hohEditingCharacterId){
    try{
      var ex = (allCharacters || []).find(function(ch){ return ch.id === window.hohEditingCharacterId; });
      if(ex) return ex.image_url || ex.image_thumb_url || '';
    }catch(_){ }
  }
  return '';
}
/* Preview-only hero. A blank card description borrows the story, or a labelled
   example before the story is written. Neither fallback is put into the form
   or the saved metadata assembled separately by hohCardStepMeta. */
function hohCardStepHero(){
  var race = hohWizVal('hoh-f-race');
  if(race === 'Other') race = hohWizVal('hoh-f-custom-race') || race;
  var cls = hohWizVal('hoh-f-class');
  if(cls === 'Other') cls = hohWizVal('hoh-f-custom-class') || cls;
  var ff = hohCardStepIsFF();
  var meta = {};
  var legend = hohWizVal('hoh-f-legend');
  var story = hohWizVal('hoh-f-story');
  var quote = ff ? hohWizVal('hoh-f-quote') : '';
  meta.legend = legend || story || 'Example: A wandering mapmaker carries a chart that changes overnight. Its roads always lead to someone in trouble. They keep following it, hoping one road will finally lead home.';
  if(quote) meta.quote = quote;
  /* Let the renderer display the story in this preview. The renderer bounds
     it to the card's text limit; this transient flag is never saved. */
  meta.edited = true;
  return {
    id: window.hohEditingCharacterId || null,
    name: hohWizVal('hoh-f-name') || 'Your hero',
    race: race, character_class: cls,
    story: story,
    image_url: hohCardStepImage(), image_thumb_url: hohCardStepImage(),
    is_ff_portrait: ff, hearts: 100, card_meta: meta
  };
}
/* ⛔ R574 · WHAT GETS SAVED, AND WHAT MUST NOT BE DESTROYED.
   `existing` is the row's current card_meta on the EDIT path. It is MERGED, not
   replaced, because that object also carries `title`, `epithet`, `source`,
   `model` and `updated_at` written by the AI, and an update payload replaces a
   column wholesale. Building a fresh object here would have silently wiped all
   of that the first time anybody edited a hero.
   `edited:true` is the flag the AI backfill and the worker both refuse to
   overwrite, so it is set only when a person really typed something. Clearing
   the box on an edit removes the flag as well, which hands the card back to the
   generator rather than freezing it on an empty line. */
function hohCardStepMeta(existing){
  var ff = hohCardStepIsFF();
  var legend = hohWizVal('hoh-f-legend');
  var quote = ff ? hohWizVal('hoh-f-quote') : '';
  var artist = hohWizVal('hoh-f-artist');
  var had = (existing && typeof existing === 'object') ? existing : null;
  var base = {}, touched = false, k;
  if(had){ for(k in had){ if(Object.prototype.hasOwnProperty.call(had, k)) base[k] = had[k]; } }
  if(legend){
    if(base.legend !== legend.slice(0, HOH_LEGEND_MAX) || !base.edited) touched = true;
    base.legend = legend.slice(0, HOH_LEGEND_MAX); base.edited = true;
  } else if(had && base.legend){
    delete base.legend; delete base.edited; touched = true;
  }
  if(ff && quote){
    if(base.quote !== quote.slice(0, HOH_QUOTE_MAX)) touched = true;
    base.quote = quote.slice(0, HOH_QUOTE_MAX); base.edited = true;
  } else if(base.quote){
    /* a hero that is not a FramedFantasy portrait prints no quote at all, so
       storing one would keep a value no card will ever show */
    delete base.quote; touched = true;
  }
  if(artist){
    if(base.artist !== artist.slice(0, 60)) touched = true;
    base.artist = artist.slice(0, 60);
  } else if(base.artist){ delete base.artist; touched = true; }
  if(window.hohTools && document.getElementById('hoh-f-alignment')){
   var dm=window.hohTools.stepRead();
   if(dm.alignment){base.alignment=dm.alignment; touched=true;}
   if(dm.personality_traits.length){base.personality_traits=dm.personality_traits; touched=true;}
   if(dm.armor_class!==null){base.armor_class=dm.armor_class; touched=true;}else if(base.armor_class!==undefined){delete base.armor_class;touched=true;}
  }
  return touched ? base : null;
}
function hohCardStepCount(id, out, max){
  var el = document.getElementById(id), lbl = document.getElementById(out);
  if(el && lbl) lbl.textContent = String(String(el.value || '').length);
}
/* Repaint the preview and both counters. Cheap enough to run on input: it is
   one innerHTML of a single card, on a step that holds nothing else moving. */
function hohCardStepPaint(){
  var host = document.getElementById('hoh-cardstep-preview');
  var qw = document.getElementById('hoh-quote-wrap');
  if(qw) qw.style.display = hohCardStepIsFF() ? '' : 'none';
  hohCardStepCount('hoh-f-legend', 'hoh-legend-count', HOH_LEGEND_MAX);
  hohCardStepCount('hoh-f-quote', 'hoh-quote-count', HOH_QUOTE_MAX);
  if(!host) return;
  if(typeof window.hohShopCardHtml !== 'function'){
    /* the shop bundle owns the renderer and may not have loaded yet. Say so
       rather than leaving an empty box that reads as a broken step. */
    host.innerHTML = '<p class="hoh-cardstep-nopreview">Your card preview will appear here in a moment.</p>';
    return;
  }
  try{
    /* The id is passed as well as the hero on the EDIT path, because hearts and
       the collector number are still resolved from it. A brand new hero has no
       id and correctly shows zero. */
    /* FITEDITOR: a picture chosen in this form has no row yet, so the card
       paints the framing the player set on the picture screen (the temp id
       the insert reads), never the centre crop. */
    var _f0 = null; try{ _f0 = selectedFiles && selectedFiles[0]; }catch(_){ }
    var _fresh = !!(_f0 && typeof _f0 !== 'string');
    host.innerHTML = window.hohShopCardHtml(window.hohEditingCharacterId || null, {
      hero: hohCardStepHero(), showCollectorNumber: false, framingId: _fresh ? '__hoh_new_primary' : null
    });
    var _mv = document.getElementById('hoh-cardstep-move');
    if(_mv) _mv.hidden = !(_fresh && HOH_WIZ.on);
    /* ⛔ THE CARD IS 380px WIDE AND THIS FORM IS NARROWER. R554 paid for this
       once already: a native .ffshop-cardbox was dropped into a 310px stage and
       simply overflowed, because every scaling rule in hoh-shop.css is scoped to
       .ffshop-insp and this container is not inside it. So scale it here, the
       same way the Hall's own card stage does, and give the host the scaled
       height so the step's layout does not keep a card-sized hole under it.
       ⛔ AND IT IS DELIBERATELY NOT WIRED. hohShopWireCard binds a hover tilt
       that writes an INLINE transform onto the same tiltwrap, which would wipe
       this scale on the first mouse move, which is the exact R339 fault that
       forced a deck card to stand its tilt down. A preview does not need to
       flip either: the back face is the ability side and a hero being
       submitted has none. The CSS marks it pointer-events:none so nothing
       invites a tap that would do nothing. */
    var tw = host.querySelector('.ffshop-tiltwrap');
    var card = host.querySelector('.ffshop-card');
    if(tw){
      /* ⛔ measure the ROOM, not the host: the host is about to be resized to
         the scaled card, so reading its own width on a repaint would ratchet
         the card smaller every keystroke. The parent pane is the honest box. */
      var room = 320;
      try{ room = (host.parentNode && host.parentNode.clientWidth) || host.clientWidth || 320; }catch(_){ }
      var k = Math.min(1, Math.max(0.2, (room - 2) / 380));
      var natH = (card && card.offsetHeight) || 650;
      tw.style.transformOrigin = 'top left';
      tw.style.transform = 'scale(' + k.toFixed(4) + ')';
      /* A scaled element keeps its 380px LAYOUT box, so the host is sized to
         what is actually visible and centred as a block. Flex-centring the
         380px box instead would shove the drawn card off to one side. */
      host.style.width = Math.round(380 * k) + 'px';
      host.style.height = Math.round(natH * k) + 'px';
    }
  }catch(_){
    host.innerHTML = '<p class="hoh-cardstep-nopreview">Your card preview will appear here in a moment.</p>';
  }
}
/* What is still missing on THIS step, in plain words. A disabled button
   with no reason is the most common dead end in a multi-step form, so the
   button never sits dark without a line underneath naming the gap. */
function hohWizMissing(step){
  var out = [];
  if(step === 1){
    if(!hohWizVal('hoh-f-name')) out.push('a character name');
    if(!hohWizVal('hoh-f-race')) out.push('a race');
    if(!hohWizVal('hoh-f-class')) out.push('a class');
    if(hohWizVal('hoh-f-race') === 'Other' && !hohWizVal('hoh-f-custom-race')) out.push('the custom race');
    if(hohWizVal('hoh-f-class') === 'Other' && !hohWizVal('hoh-f-custom-class')) out.push('the custom class');
  } else if(step === 2){
    if(!selectedFiles[0]) out.push('a main portrait');
  } else if(step === 3){
    var n = hohWizVal('hoh-f-story').length;
    if(n < 80) out.push((80 - n) + ' more characters of story');
  } else if(step === 4){
    if(window.hohTools)out=out.concat(window.hohTools.stepMissing());
  } else if(step === 6){
    /* ⛔ R574: this was step 5 until the card step was inserted ahead of it. A
       stale number here would have demanded an email on the card step and let
       people leave the real one blank. Step 5 itself asks for nothing: every
       field on it is optional by design, so it returns no gaps and Continue is
       never dark there. */
    if(!hohWizVal('hoh-f-player')) out.push('your name or alias');
    if(!hohValidEmail(hohWizVal('hoh-f-email'))) out.push('a valid email');
  }
  return out;
}
/* HALLFLOWS: the last screen's button is Submit, so its line says "to submit" */
function hohWizPhrase(list, verb){
  if(!list.length) return '';
  var to = ' to ' + (verb || 'continue') + '.';
  if(list.length === 1) return 'Add ' + list[0] + to;
  if(list.length === 2) return 'Add ' + list[0] + ' and ' + list[1] + to;
  return 'Add ' + list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1] + to;
}
/* Paint the progress rail, the heading, and the nav for the current step. */
/* Counters and the quote box answer instantly, because they are the feedback
   for the key that was just pressed. The card redraw rides a short debounce so
   a fast typist is not re-rendering a whole card on every keystroke. */
var _hohCardPaintT = 0;
function hohCardStepSync(){
  var qw = document.getElementById('hoh-quote-wrap');
  if(qw) qw.style.display = hohCardStepIsFF() ? '' : 'none';
  hohCardStepCount('hoh-f-legend', 'hoh-legend-count');
  hohCardStepCount('hoh-f-quote', 'hoh-quote-count');
  clearTimeout(_hohCardPaintT);
  _hohCardPaintT = setTimeout(hohCardStepPaint, 140);
}
/* ⛔ ============ HALL-BUILD · THE CARD FILLS AS THEY GO ============
   Jan (2026-10-19): "even for submitting their hoh character if they click into it it can even visually show the
   card filling as they type it during certain steps (near the beginning) then the rest of the questions can be the
   same." The hero and portrait screens carry the same real card the card step draws (hohShopCardHtml through
   hohCardStepHero, so it cannot drift from what they will get). What is still empty reads as a faint placeholder,
   in the home page's words ("Your character", "Race · Class", "Your portrait", "Your description ..."), and each
   part glows once as it fills. Only the pane on show is painted, on a short debounce, and nothing here touches the
   form's values, the draft or the submit. */
var HOH_LC_WORDS = 'Your description goes here. A line or two about who they are.';
var HOH_LC_ART = '<div class="hoh-lc-art"><svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="7" y="9" width="34" height="30" rx="4"/><circle cx="18" cy="20" r="3.2"/><path d="m9 35 9-8.5 6.5 6 5-4.5 9.5 8"/><path d="M38 4v9M33.5 8.5h9"/></svg><span>Your portrait</span></div>';
var _hohLiveT = 0, _hohLiveWas = null;
function hohLiveCardSync(){ clearTimeout(_hohLiveT); _hohLiveT = setTimeout(hohLiveCardPaint, 90); }
function hohLiveCardPaint(){
  if(!HOH_WIZ.on) return;
  var pane = document.querySelector('#hoh-form-inner .hoh-wiz-step.hoh-wiz-on');
  var host = pane && pane.querySelector('.hoh-livecard-host');
  /* a phone keeps the portrait screen to the fit editor, which is the card's own art frame (CSS hides this card) */
  if(!host || !host.getClientRects().length || typeof window.hohShopCardHtml !== 'function') return;
  var lcEsc = function(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return '&#' + c.charCodeAt(0) + ';'; }); };
  var hero = hohCardStepHero(), race = hero.race, cls = hero.character_class;
  var now = { name: !!hohWizVal('hoh-f-name'), type: !!(race && cls), art: !!hero.image_url, words: !!(hohWizVal('hoh-f-legend') || hohWizVal('hoh-f-story')) };
  if(!now.name) hero.name = 'Your character';
  if(!now.words) hero.card_meta.legend = HOH_LC_WORDS;
  hero.race = race || 'Race'; hero.character_class = cls || 'Class';
  try{
    var _f0 = null; try{ _f0 = selectedFiles && selectedFiles[0]; }catch(_){ }
    var _fresh = !!(_f0 && typeof _f0 !== 'string');
    host.innerHTML = window.hohShopCardHtml(null, { hero: hero, showCollectorNumber: false, framingId: _fresh ? '__hoh_new_primary' : null });
  }catch(_){ return; }
  /* a player's own card has the square art box (.ffshop-art); a FramedFantasy portrait the full-art face */
  var nm = host.querySelector('.ffshop-cname'), ty = host.querySelector('.ffshop-type');
  var lg = host.querySelector('.ffshop-legend-block p'), art = host.querySelector('.ffshop-artfull, .ffshop-art');
  if(nm && !now.name) nm.classList.add('hoh-lc-ph');
  if(ty) ty.innerHTML = (race ? lcEsc(race) : '<span class="hoh-lc-ph">Race</span>') + ' &middot; ' + (cls ? lcEsc(cls) : '<span class="hoh-lc-ph">Class</span>');
  if(lg && !now.words) lg.classList.add('hoh-lc-ph');
  if(art && !now.art) art.innerHTML = HOH_LC_ART;
  var was = _hohLiveWas;
  if(was){
    if(now.name && !was.name && nm) nm.classList.add('hoh-lc-pop');
    if(now.type && !was.type && ty) ty.classList.add('hoh-lc-pop');
    if(now.art && !was.art && art) art.classList.add('hoh-lc-pop');
  }
  _hohLiveWas = now;
  /* sized like the card step's preview (a scaled 380px card, the host given the scaled box). A phone shows a window of
     the card where the screen writes: the name and race and class under the lower art on the hero screen (the name
     sits at 381-438 and the type line at 412-463 of the card's 650, by layout), the art and the name on the portrait
     screen. */
  var tw = host.querySelector('.ffshop-tiltwrap'), card = host.querySelector('.ffshop-card');
  if(!tw) return;
  var wide = false; try{ wide = window.matchMedia('(min-width: 760px)').matches; }catch(_){ }
  var w = wide ? 196 : Math.min(210, Math.max(150, ((pane.clientWidth || 320) - 2) * 0.6));
  /* the Hall card is never shorter than 650; a first paint can measure it before it has settled */
  var k = w / 380, natH = Math.max(650, (card && card.offsetHeight) || 0);
  var win = wide ? null : (HOH_WIZ.step === 1 ? [150, 490] : [20, 470]);
  tw.style.transformOrigin = 'top left';
  tw.style.transform = (win ? 'translateY(' + (-win[0] * k).toFixed(1) + 'px) ' : '') + 'scale(' + k.toFixed(4) + ')';
  host.style.width = Math.round(380 * k) + 'px';
  host.style.height = Math.round((win ? win[1] - win[0] : natH) * k) + 'px';
  host.classList.toggle('is-crop', !wide);
}
/* HALL-BUILD: the home page's Build your card (sections/ff-home-hall.liquid) arrives with #add-hero and a name, or
   none. It opens the hero screen, where the card is; a name goes into an empty name field only, never over a
   restored draft. */
function hohTakeHomeBuild(){
  var b = null;
  try{ b = JSON.parse(sessionStorage.getItem('ff-build-hero') || 'null'); sessionStorage.removeItem('ff-build-hero'); }catch(_){ b = null; }
  if(!b || typeof b !== 'object' || !(Date.now() - (+b.at || 0) < 30 * 60 * 1000)) return;
  var el = document.getElementById('hoh-f-name');
  if(!el || !HOH_WIZ.on || HOH_WIZ.step !== 0) return;
  var nm = String(b.name || '').trim().slice(0, 60);
  if(nm && !String(el.value || '').trim()){
    el.value = nm;
    try{ el.dispatchEvent(new Event('input', { bubbles: true })); }catch(_){ }
  }
  hohWizGo(1);
}
function hohWizPaint(){
  if(!HOH_WIZ.on) return;
  var body = document.querySelector('#hoh-form-inner .hoh-form-body');
  if(!body) return;
  /* R574: the credit field's two conditions are an image and the FF box, and
     both live on other steps, so it is re-checked on every repaint rather than
     bound to one control. */
  try{ hohArtistFieldSync(); }catch(_){ }
  if(HOH_WIZ.step === 5){ try{ hohCardStepSync(); }catch(_){ } }
  var step = HOH_WIZ.step, i;
  /* R795: panes, heading, rail and nav work by SCREEN (HOH_WIZ.screens) */
  var sc = hohWizScreen(step), onScreen = HOH_WIZ.screens[sc] || [step];
  var lastSc = HOH_WIZ.screens.length - 1;
  /* HERO-CARD-01: a portrait from the commission page has no gate, so its first screen is Step 1 */
  var gate = (HOH_WIZ.screens[0] || [])[0] === 0, num = gate ? sc : sc + 1, total = gate ? lastSc : lastSc + 1;
  var panes = body.querySelectorAll('.hoh-wiz-step');
  for(i = 0; i < panes.length; i++){
    panes[i].classList.toggle('hoh-wiz-on', onScreen.indexOf(+panes[i].getAttribute('data-s')) !== -1);
  }
  body.setAttribute('data-screen', String(sc));
  var head = body.querySelector('.hoh-wiz-head');
  var m = HOH_WIZ.screenMeta[sc] || HOH_WIZ.meta[step] || { t: '', s: '' };
  if(head){
    /* a new screen's heading comes in with it (the motion rule) */
    if(head.__hohSc !== sc){
      head.__hohSc = sc;
      head.classList.remove('hoh-wiz-head-in'); void head.offsetWidth; head.classList.add('hoh-wiz-head-in');
    }
    head.querySelector('.hoh-wiz-h-t').textContent = m.t;
    head.querySelector('.hoh-wiz-h-s').textContent = m.s;
    head.querySelector('.hoh-wiz-h-c').textContent = num ? ('Step ' + num + ' of ' + total) : '';
    head.classList.toggle('hoh-wiz-head-gate', step === 0);
    if(step === 0 && hohWizSeenBefore()){
      var intro = document.querySelector('.hoh-form-intro');
      if(intro) intro.classList.add('hoh-form-intro-brief');
      head.querySelector('.hoh-wiz-h-t').textContent = 'Another hero';
      head.querySelector('.hoh-wiz-h-s').textContent = 'You know the drill. The bar has not moved.';
    }
    /* HALLWIZ (Jan: "this last page ... needs to be designed better"). The
       last step opens on the hero's reveal, whose heading is "{Name} is ready
       for the Hall", so the head keeps only "Step N of N" there. This replaces
       R588's "Stay updated" override: the R588 rule (a signed-in visitor is
       never told about fields the step does not show) now lives in the line
       under the reveal, painted below. */
    head.classList.toggle('hoh-wiz-head-final', sc === lastSc);
  }
  var rail = body.querySelector('.hoh-wiz-rail');
  if(rail){
    rail.style.display = num ? 'flex' : 'none';
    var pips = rail.querySelectorAll('.hoh-wiz-pip');
    for(i = 0; i < pips.length; i++){
      pips[i].classList.toggle('hoh-wiz-pip-done', (i + 1) < num);
      pips[i].classList.toggle('hoh-wiz-pip-now', (i + 1) === num);
    }
    /* the last step is the finish line: the whole bar fills */
    rail.classList.toggle('hoh-wiz-rail-done', sc === lastSc);
  }
  var nav = body.querySelector('.hoh-wiz-nav');
  if(nav){
    var back = nav.querySelector('.hoh-wiz-back');
    var next = nav.querySelector('.hoh-wiz-next');
    var hint = nav.querySelector('.hoh-wiz-hint');
    back.style.display = sc === 0 ? 'none' : 'inline-flex';
    /* HALLFLOWS: the last screen keeps the footer (it used to step aside for
       a Submit, a hint, a next line and a Back scattered through the step).
       The class stays as the last screen's styling hook. */
    nav.classList.toggle('hoh-wiz-nav-last', sc === lastSc);
    /* the last screen's action is the real submit button, moved into this
       footer by hohWizInit. It already carries its own disabled logic from
       validateForm, so Continue simply steps aside there: two buttons could
       disagree about whether the form is ready. */
    next.style.display = sc === lastSc ? 'none' : 'inline-flex';
    var wizSubmit = document.getElementById('hoh-submit-btn');
    if(wizSubmit && nav.contains(wizSubmit)) wizSubmit.style.display = sc === lastSc ? '' : 'none';
    /* HALLFLOWS: "Already have a hero? Sign in" under Start my hero, for a
       signed-out visitor only. Never on a Quest handoff: closing the form to
       sign in would drop the hero the Quest handed over. */
    var signIn = nav.querySelector('.hoh-wiz-signin');
    if(signIn){
      var _signedIn = hohWizKnowsYou() || document.documentElement.classList.contains('hoh-hall-signed-in');
      signIn.hidden = !(sc === 0 && gate && !hohQuestHandoff && !_signedIn && typeof window.hohSignInToYourHall === 'function');
    }
    /* Jan (2026-09-27): the gate's footer sits closer to the quality note, with
       a quiet Back (it closes the form) under Start my hero */
    nav.classList.toggle('hoh-wiz-nav-gate', sc === 0 && gate);
    var leave = nav.querySelector('.hoh-wiz-leave');
    if(leave) leave.hidden = !(sc === 0 && gate);
    /* R433 (Jan): the em dash is out (house rule) and so is the sentence
       shape it was propping up. A CTA that reads as a declaration makes the
       player pause to parse it; "Start my hero" is the action, in their
       words, and it still carries the ownership the old line was after. */
    next.textContent = step === 0 ? 'Start my hero' : (step === 4 ? 'Skip for now' : 'Continue');
    var miss = hohWizScreenMissing(sc);
    /* Alignment and traits are required; the two bonus panels are optional. */
    var blocked = miss.length > 0;
    next.disabled = blocked;
    next.classList.toggle('hoh-wiz-next-off', blocked);
    if(step === 4){
      var filled = ['hoh-f-npc-goal','hoh-f-npc-secret','hoh-f-npc-weakness','hoh-f-npc-enemy','hoh-f-npc-habit','hoh-f-npc-catchphrase']
        .filter(function(id){ return !!hohWizVal(id); }).length;
      var statsDraft = null;
      try{ if(typeof _hohNpcStatsReader === 'function') statsDraft = _hohNpcStatsReader(); }catch(_){}
      var npcDone = filled >= 6;
      var statsDone = _hohStatsComplete(statsDraft);
      var ticketCount = (npcDone?1:0) + (statsDone?1:0);
      next.textContent = (filled || statsDraft) ? 'Continue' : 'Skip for now';
      hint.textContent = ticketCount >= 2 ? 'Both complete. This hero starts with 3 tickets.'
                       : (ticketCount === 1 ? '1 bonus ticket earned. Complete the other section for one more.'
                       : ((filled || statsDraft) ? 'Keep going. Each completed section adds x1 ticket.'
                                                 : 'Each completed section adds x1 ticket to this hero.'));
    } else if(sc === lastSc){
      /* HALLFLOWS: one status line above Submit. A Quest hero's Submit also
         waits for the Hall PIN (validateForm), so the line names it rather
         than leaving a dark button with no reason. */
      var lastMiss = miss.slice();
      if(hohQuestHandoff && !hohQuestPinOk(hohQuestPin())) lastMiss.push('a 4 digit Hall PIN');
      hint.textContent = hohWizPhrase(lastMiss, 'submit');
    } else {
      hint.textContent = blocked ? hohWizPhrase(miss) : '';
    }
    if(step === 4 && blocked)hint.textContent=hohWizPhrase(miss);
    hint.style.display = hint.textContent ? 'block' : 'none';
    /* HALLFLOWS: once nothing is missing, the status line says what comes
       after the submit (the approved Add screen's line, with the hero's name).
       Only with the hero page on, and never beside the one-per-day notice. */
    var nextNote = document.getElementById('hoh-add-next');
    if(nextNote){
      var _hpOn = !!hohHeroPageBase() && sc === lastSc && !hint.textContent && !(wizSubmit && wizSubmit.classList.contains('hoh-btn-cooldown'));
      if(_hpOn){
        var _nn = hohWizVal('hoh-f-name').split(/\s+/)[0];
        /* HERO-CARD-01: a portrait from the commission page ends on its card, not the hero page's questions */
        nextNote.textContent = window.hohPortalCard
          ? 'Next, you can design ' + (_nn ? hohPossessive(_nn) : 'their') + ' card.'
          : 'Next, a few short questions fill in ' + (_nn ? hohPossessive(_nn) : 'their') + ' page and raise their rarity. Skip any you like.';
      }
      nextNote.hidden = !_hpOn;
    }
  }
  /* R433 (Jan): "format the last page more cleanly as well and make it more
     about them". The last step was four admin fields under a label — the
     one screen in the whole flow with nothing of THEIRS on it, arriving
     right when they are deciding whether the last stretch is worth it. It
     opens on the hero they just wrote instead, by name. */
  /* HALLWIZ (Jan: "try to make it higher dopamine"). The recap is now the
     hero's reveal: the portrait exactly as framed on the portrait step, in its
     rarity ring (FramedFantasy colours when the box is ticked, as its Hall
     border will be), "{Name} is ready for the Hall" with the name large, and
     race and class under it. It comes in once per arrival (a keystroke on this
     step repaints the words, never the entrance). */
  var recap = document.getElementById('hoh-wiz-recap');
  if(recap){
    if(step === HOH_WIZ.max){
      var nm = hohWizVal('hoh-f-name');
      recap.style.display = 'flex';
      recap.querySelector('.hoh-wiz-recap-n').textContent = nm || 'Your hero';
      var _rc = recap.querySelector('.hoh-wiz-reveal-c');
      if(_rc){
        var _race = hohWizVal('hoh-f-race'), _cls = hohWizVal('hoh-f-class'), _lvl = hohWizVal('hoh-f-level');
        if(_race === 'Other') _race = hohWizVal('hoh-f-custom-race');
        if(_cls === 'Other') _cls = hohWizVal('hoh-f-custom-class');
        var _line = [_race, _cls].filter(Boolean).join(' ');
        if(_lvl) _line += (_line ? ' · ' : '') + 'Level ' + _lvl;
        _rc.textContent = _line;
        _rc.hidden = !_line;
      }
      recap.classList.toggle('hoh-wiz-reveal-ff', hohCardStepIsFF());
      /* R588: the same lie as the heading, one line lower. "Who to credit and
         where to reach you" are both already on file for a signed-in visitor,
         and neither field is on the screen, so it asked for two things it had
         already taken. Jan named the heading; this is the same sentence problem
         and fixing one without the other would leave half the step wrong. */
      recap.querySelector('.hoh-wiz-recap-s').textContent = hohWizKnowsYou()
        ? 'Send them in when you are ready.'
        : 'Tell the Hall who to credit and where to reach you.';
      if(!recap.__hohIn){
        recap.__hohIn = true;
        /* the new upload's reframe frame, or a Quest portrait kept as a bare img */
        var _src = document.querySelector('#hoh-upload-zone-0 .hoh-edit-img-frame img') || document.querySelector('#hoh-upload-zone-0 > img');
        var _img = recap.querySelector('.hoh-wiz-reveal-img');
        if(_img){
          if(_src){
            if(_img.getAttribute('src') !== _src.getAttribute('src')) _img.setAttribute('src', _src.getAttribute('src'));
            _img.setAttribute('style', _src.getAttribute('style') || '');
          }
          recap.classList.toggle('hoh-wiz-reveal-noart', !_src);
        }
        recap.classList.remove('hoh-wiz-reveal-go'); void recap.offsetWidth; recap.classList.add('hoh-wiz-reveal-go');
      }
    } else {
      recap.style.display = 'none';
      recap.__hohIn = false;
    }
  }
  /* R795: once the hero page exists, the footer says what comes after the
     submit (HALLFLOWS moved it into the footer's status line, above). */
  /* the FF tick belongs to the image, and only makes sense once there IS
     one. Its stock rule keys off the whole form being valid, which can
     never be true on step 2, so the wizard owns it here. */
  var ffw = document.getElementById('hoh-ff-toggle-wrap');
  if(ffw) ffw.classList.toggle('hoh-ff-visible', !!selectedFiles[0]);
  /* the DM panel's stock gate wants a 280-char story AND an email AND an
     alias — fields that live on a LATER step now, so it could never open.
     Reaching step 4 at all is the investment it was testing for. */
  var npcw = document.querySelector('.hoh-npc-wrap');
  if(npcw) npcw.classList.add('hoh-npc-wrap-visible');
  /* Both optional sections start minimized. The ticket chips explain why the
     rows are worth opening without dropping six fields onto the screen before
     the player asks for them. Collapse only on the first arrival; after that,
     their open/closed choice survives Back/Continue navigation. */
  if(step === 4 && !HOH_WIZ.opened4){
    HOH_WIZ.opened4 = true;
    [['hoh-npc-panel-trigger','hoh-npc-panel'],['hoh-npc-stats-trigger','hoh-npc-stats-panel']].forEach(function(ids){
      var trig = document.getElementById(ids[0]), pan = document.getElementById(ids[1]);
      if(trig) trig.classList.remove('hoh-npc-open');
      if(pan) pan.classList.remove('hoh-npc-open');
    });
    /* The stat block's own reveal is driven by story length; by step 4 the
       story is written, so ask it to reveal and lazily mount while leaving
       its top-level accordion closed. */
    try { if(typeof hohUpdateNpcStatsVisibility === 'function') hohUpdateNpcStatsVisibility(); } catch(_){}
  }
}
function hohWizGo(step, noScroll){
  if(!HOH_WIZ.on) return;
  step = Math.max(0, Math.min(HOH_WIZ.max, step | 0));
  /* R795: any step of a screen lands on that screen's lead step, and the
     direction of travel picks the entrance's slide (hoh-wiz-dir-fwd/back).
     ⛔ HALLWIZ: these were "hoh-wiz-fwd" and "hoh-wiz-back", and the second is
     the Back BUTTON's class, so after any Back press the whole form body wore
     the button's fill, border, radius and inline-flex width: the narrower dark
     box Jan saw behind the buttons. */
  var _sc = hohWizScreen(step), _was = hohWizScreen(HOH_WIZ.step);
  step = hohWizLead(_sc);
  HOH_WIZ.dir = _sc > _was ? 1 : (_sc < _was ? -1 : 0);
  try {
    var _body = document.querySelector('#hoh-form-inner .hoh-form-body');
    if(_body && _sc !== _was){
      _body.classList.toggle('hoh-wiz-dir-fwd', HOH_WIZ.dir > 0);
      _body.classList.toggle('hoh-wiz-dir-back', HOH_WIZ.dir < 0);
    }
  } catch(_){ }
  HOH_WIZ.step = step;
  /* R433: the step is part of the draft, so moving between steps IS a
     change worth writing. Debounced inside hohSaveDraft, so paging back and
     forth costs one write, not one per click. */
  try { hohSaveDraft(); } catch(_){}
  hohWizPaint();
  /* R574: landing on the card step draws immediately rather than waiting out
     the typing debounce, or the step opens on an empty frame. */
  if(step === 5){ try{ clearTimeout(_hohCardPaintT); hohCardStepPaint(); }catch(_){ } }
  if(step === 1 || step === 2){ try{ clearTimeout(_hohLiveT); hohLiveCardPaint(); }catch(_){ } }
  try { validateForm(); } catch(_){}
  if(noScroll) return;
  /* R795: straight to the top, never a smooth scroll on a screen change
     (the entrance animation is the transition, and the two fought). */
  try {
    var box = document.querySelector('#hoh-form-modal .hoh-modal-content');
    if(box) box.scrollTo({ top: 0, behavior: 'auto' });
    /* On phones the active pane, not the full dialog, is the scrollport so the
       navigation remains reachable. Reset both paths when changing steps. */
    var activePanes = document.querySelectorAll('#hoh-form-modal .hoh-wiz-step.hoh-wiz-on');
    for(var _ap = 0; _ap < activePanes.length; _ap++) activePanes[_ap].scrollTo({ top: 0, behavior: 'auto' });
  } catch(_){ }
  /* move focus to the step's first real control so keyboard and screen
     reader users land where the work is, not back at the modal title.
     Skipped on touch: focusing a text input there throws the keyboard up
     over the screen the moment it opens. R795: the first one SHOWN on the
     screen (screen 1's credit field waits for an image). */
  try {
    if(!window.matchMedia || !window.matchMedia('(hover: none)').matches){
      var f = null, order = HOH_WIZ.screens[_sc] || [step];
      for(var _o = 0; _o < order.length && !f; _o++){
        var pane = document.querySelector('#hoh-form-inner .hoh-wiz-step[data-s="' + order[_o] + '"]');
        var cands = pane ? pane.querySelectorAll('input:not([type=hidden]):not([type=file]):not([readonly]), textarea, select') : [];
        for(var _c = 0; _c < cands.length; _c++){ if(cands[_c].getClientRects().length){ f = cands[_c]; break; } }
      }
      if(f) setTimeout(function(){ try { f.focus({ preventScroll: true }); } catch(_){ } }, 120);
    }
  } catch(_){ }
}
function hohWizReduced(){ try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(_){ return false; } }
/* R795: Continue and Back move a whole screen */
window.hohWizNext = function(){ hohWizGo(hohWizLead(hohWizScreen(HOH_WIZ.step) + 1)); };
/* FITEDITOR: "Move the picture" on the card step returns to the picture
   screen with the art window focused (keyboard) and in view */
window.hohWizMovePicture = function(){
  hohWizGo(2);
  setTimeout(function(){
    try {
      var f = document.querySelector('#hoh-upload-zone-0 .hoh-fit-frame');
      if(!f) return;
      f.scrollIntoView({ block: 'center', behavior: 'auto' });
      if(!window.matchMedia || !window.matchMedia('(hover: none)').matches) f.focus({ preventScroll: true });
    } catch(_){ }
  }, 160);
};
window.hohWizBack = function(){ hohWizGo(hohWizLead(hohWizScreen(HOH_WIZ.step) - 1)); };
/* HALLFLOWS: "Already have a hero? Sign in" closes the form FIRST and then
   opens the Hall's own sign-in (email, then PIN). Opened on top of the form,
   the sign-in's close would unlock the page under a form still open, and the
   form would never pick up the signed-in email. Signing in from the Hall lands
   them in the Hall with Your Hall arriving (hohYhCelebrateTab); the draft is
   kept, so Add your hero reopens where they were, their email filled in. */
window.hohWizSignIn = function(){
  if(typeof window.hohSignInToYourHall !== 'function') return;
  try { window.hohCloseForm(); } catch(_){ }
  window.hohSignInToYourHall();
};
/* A submit-time rejection can point at a field on a step the player is no
   longer looking at — the story quality gate is the live example, and it
   calls scrollIntoView on an element the wizard has hidden, which silently
   does nothing. Jump to the owning step first, then let the existing code
   scroll and highlight. */
window.hohWizRevealField = function(id){
  try {
    if(!HOH_WIZ.on) return;
    var el = document.getElementById(id);
    var pane = el && el.closest ? el.closest('.hoh-wiz-step') : null;
    if(!pane) return;
    var s = +pane.getAttribute('data-s');
    if(hohWizScreen(s) !== hohWizScreen(HOH_WIZ.step)) hohWizGo(s, true);
  } catch(_){ }
};
/* R425 — answering my own question from R424: should a repeat submitter
   skip the gate? No, but they should not read the sales pitch twice either.
   The gate does two different jobs. "Why submit" SELLS, and it is wasted on
   someone already sold. "Quality heroes only" POLICES, and it matters MORE
   the second time — the person about to post a throwaway is by definition a
   returning submitter. So the pitch collapses for anyone who has submitted
   before and the quality bar stays at full size. One localStorage flag,
   written on a successful submit. */
function hohWizSeenBefore(){
  try { return localStorage.getItem('hoh-has-submitted') === '1'; } catch(_){ return false; }
}
window.hohWizMarkSubmitted = function(){
  try { localStorage.setItem('hoh-has-submitted', '1'); } catch(_){}
};
function hohWizInit(){
  var body = document.querySelector('#hoh-form-inner .hoh-form-body');
  if(!body || body.getAttribute('data-wiz') === '1') return;
  var kids = Array.prototype.slice.call(body.children);
  if(!kids.length) return;
  body.setAttribute('data-wiz', '1');
  body.classList.add('hoh-wiz');
  /* head + rail ride above the panes, nav below them */
  var head = document.createElement('div');
  head.className = 'hoh-wiz-head';
  head.innerHTML = '<div class="hoh-wiz-h-c"></div><div class="hoh-wiz-h-t"></div><div class="hoh-wiz-h-s"></div>';
  var rail = document.createElement('div');
  rail.className = 'hoh-wiz-rail';
  rail.setAttribute('aria-hidden', 'true');
  var r = '';
  /* R795: one pip per screen after the gate */
  for(var i = 1; i < HOH_WIZ.screens.length; i++) r += '<span class="hoh-wiz-pip"></span>';
  rail.innerHTML = r;
  /* R433: the restored-draft notice used to live inside step 1. Now that a
     draft can drop you straight onto step 4, a notice buried on step 1 is a
     notice nobody reads — so it is hoisted out of the panes and sits under
     the rail, visible from wherever they land. */
  var notice = null;
  /* R795: ONE pane per screen, carrying its lead step as data-s. On a phone
     the active pane is the only scroller (R609), so a screen made of two
     panes would scroll in two places. Steps that share a screen share its
     pane, in the markup's order: screen 1's portrait block comes first. */
  var panes = {};
  HOH_WIZ.screens.forEach(function(scr){
    var pane = document.createElement('div');
    pane.className = 'hoh-wiz-step';
    pane.setAttribute('data-s', String(Math.min.apply(null, scr)));
    scr.forEach(function(st){ panes[st] = pane; });
  });
  for(var st = 0; st <= HOH_WIZ.max; st++){
    if(!panes[st]){ var lone = document.createElement('div'); lone.className = 'hoh-wiz-step'; lone.setAttribute('data-s', String(st)); panes[st] = lone; }
  }
  kids.forEach(function(k){
    if(k.id === 'hoh-draft-notice'){ notice = k; return; }
    var s = k.getAttribute && k.getAttribute('data-wstep');
    /* anything unlabelled rides with the final step rather than vanishing —
       a field that silently disappears is worse than one in the wrong place */
    var n = (s == null || s === '') ? HOH_WIZ.max : Math.max(0, Math.min(HOH_WIZ.max, parseInt(s, 10) || 0));
    panes[n].appendChild(k);
  });
  body.appendChild(head);
  body.appendChild(rail);
  if(notice) body.appendChild(notice);
  /* R795: the panes go in in screen order */
  HOH_WIZ.screens.forEach(function(scr){ body.appendChild(panes[scr[0]]); });
  for(var st3 = 0; st3 <= HOH_WIZ.max; st3++){ if(!panes[st3].parentNode) body.appendChild(panes[st3]); }
  var nav = document.createElement('div');
  nav.className = 'hoh-wiz-nav';
  /* HALLWIZ (Jan, 2026-09-23: "under continue it should say back not next to
     continue"). Continue comes first, full width, and Back sits under it as
     the quieter button, in the DOM too, so the tab order matches the eye. */
  /* HALLFLOWS (Jan, 2026-09-25: "under start my hero should be the prompt to
     say already have a hero log in here"). The first screen has no Back, so
     the sign-in line takes Back's slot and the footer keeps one height on
     every screen. hohWizPaint shows it only there, and only when signed out. */
  nav.innerHTML =
    '<div class="hoh-wiz-hint" role="status"></div>' +
    '<div class="hoh-wiz-btns">' +
      '<button type="button" class="hoh-wiz-next" onclick="hohWizNext()">Continue</button>' +
      '<button type="button" class="hoh-wiz-back" onclick="hohWizBack()">Back</button>' +
      '<button type="button" class="hoh-wiz-signin" onclick="hohWizSignIn()" hidden>Already have a hero? <span class="hoh-wiz-signin-u">Sign in</span></button>' +
      /* Jan (2026-09-27): a subtle "Back" under Start my hero. The first
         screen has nothing to go back to, so it leaves the form, as the X does. */
      '<button type="button" class="hoh-wiz-leave" onclick="hohCloseForm()" hidden>Back</button>' +
    '</div>';
  body.appendChild(nav);
  /* HALLFLOWS (Jan: the last step's bottom is "horrendously designed, very
     ununiform text and just random texts everywhere"). The last screen uses
     the same footer as every other screen: one status line, the gold button,
     Back under it. The real Submit (its id, onclick, disabled and cooldown
     logic and the duplicate-tap lock all travel with the element) and the
     line about what comes next move in here; hohWizPaint shows them only on
     the last screen. Edit mode has no wizard, so its Save stays in the form. */
  var _wizSubmit = document.getElementById('hoh-submit-btn');
  if(_wizSubmit) nav.querySelector('.hoh-wiz-btns').insertBefore(_wizSubmit, nav.querySelector('.hoh-wiz-back'));
  var _wizNextLine = document.getElementById('hoh-add-next');
  if(_wizNextLine) nav.insertBefore(_wizNextLine, nav.querySelector('.hoh-wiz-btns'));
  HOH_WIZ.on = true; HOH_WIZ.step = 0;
  /* ⛔ R574: the preview's scale is computed from the pane's width at paint
     time and written inline, so a phone turned sideways mid-form would leave a
     card sized for the old orientation. Repaint on resize, but only while the
     card step is the one on screen, so this costs nothing on every other step. */
  if(!body.__hohCardResizeBound){
    body.__hohCardResizeBound = 1;
    var _cardRz = 0;
    window.addEventListener('resize', function(){
      if(!HOH_WIZ.on || HOH_WIZ.step !== 5) return;
      clearTimeout(_cardRz);
      _cardRz = setTimeout(function(){ try{ hohCardStepPaint(); }catch(_){ } }, 120);
    }, { passive: true });
  }
  /* every keystroke and change repaints the nav, so "what is missing"
     and the button's state answer the field the moment it is filled */
  body.addEventListener('input', hohWizPaint);
  body.addEventListener('change', hohWizPaint);
  /* HALL-BUILD: the live card answers the same keystrokes, and the fit editor's drags on the portrait screen */
  _hohLiveWas = null;
  body.addEventListener('input', hohLiveCardSync);
  body.addEventListener('change', hohLiveCardSync);
  body.addEventListener('pointerup', function(){ if(HOH_WIZ.step === 2) hohLiveCardSync(); });
  if(!window.__hohLiveResizeBound){
    window.__hohLiveResizeBound = 1;
    window.addEventListener('resize', function(){ if(HOH_WIZ.on && (HOH_WIZ.step === 1 || HOH_WIZ.step === 2)) hohLiveCardSync(); }, { passive: true });
  }
  /* Enter advances from a single-line field — never from the story box,
     where Enter is a paragraph break. */
  body.addEventListener('keydown', function(e){
    if(e.key !== 'Enter') return;
    var t = e.target;
    if(!t || t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON' || t.tagName === 'A') return;
    if(t.tagName !== 'INPUT' && t.tagName !== 'SELECT') return;
    if(t.type === 'file' || t.type === 'checkbox') return;
    if(HOH_WIZ.step === HOH_WIZ.max) return;      /* the submit button owns Enter there */
    if(hohWizScreenMissing(hohWizScreen(HOH_WIZ.step)).length) return;
    e.preventDefault();
    hohWizNext();
  });
  hohWizGo(0, true);
}
window.hohWizInit = hohWizInit;

function showFormView(editChar){
 var isEdit=!!editChar;
 /* R795b: the short wizard (see HOH_WIZ_SHORT) for a new submission once the
    hero page exists; a Quest handoff and edit mode keep the full form */
 HOH_WIZ.short=!isEdit&&!hohQuestHandoff&&!!hohHeroPageBase();
 HOH_WIZ.screens=HOH_WIZ.short?HOH_WIZ_SHORT:HOH_WIZ_FULL;
 document.getElementById('hoh-form-modal-title').textContent=isEdit?'Edit Your Hero':'Immortalize Your Hero';
 selectedFiles=[null,null];
 var inner=document.getElementById('hoh-form-inner');
 inner.innerHTML='<div class="hoh-form-body">'+
 '<div class="hoh-form-intro" data-wstep="0">'+
  '<div class="hoh-form-intro-headline">Why submit?</div>'+
  '<ul class="hoh-form-intro-list">'+
  /* Each list item is a flex container (icon + text). Wrap the text
     content (including any inline <strong>) in a single <span> so the
     whole sentence becomes ONE flex item with normal inline text flow.
     Without the wrapper, the bare text nodes and <strong> become
     SEPARATE flex items — that broke the layout on mobile, pushing
     "free" / "portrait" into their own column instead of flowing
     inline with the surrounding sentence. */
  '<li><span class="hoh-form-intro-dot" style="color:#c8a45e;">&#10022;&#xFE0E;</span><span class="hoh-form-intro-text">A permanent page for their story, shareable anywhere.</span></li>'+
  '<li><span class="hoh-form-intro-dot" style="color:#b794f4;"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 4v5c0 4.5-3.4 8.5-8 9.5-4.6-1-8-5-8-9.5V7l8-4z"/><circle cx="12" cy="11" r="2"/><path d="M9 16c.8-1.2 2-2 3-2s2.2.8 3 2"/></svg></span><span class="hoh-form-intro-text">DMs across the Hall can pull them into their next session as an NPC.</span></li>'+
  /* R94: 5th bullet — social/community angle. Other players can heart
     your hero and run into them in the Hall. */
  '<li><span class="hoh-form-intro-dot" style="color:#7ed4ff;"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg></span><span class="hoh-form-intro-text">Other players in the Hall can heart your hero, see them in events, and meet them in their own campaigns.</span></li>'+
  '<li><span class="hoh-form-intro-dot hoh-form-intro-dot-ticket" aria-hidden="true"><span class="hoh-tk-icon"></span></span><span class="hoh-form-intro-text">Every hero gets an entry in the monthly spotlight draw for a <strong style="color:#f2d98e;">free portrait</strong>.</span></li>'+
  '</ul>'+
  '<p class="hoh-form-intro-note">One submission per device per day, so make it count.</p>'+
 '</div>'+
 /* R94: Quality message rewritten to be DIRECT instead of poetic.
    The previous "Make them feel real / Lived-in heroes..." line read
    as flavor copy; users skimmed past it. The new line states the
    bar plainly: this isn't a quantity site, send something real. */
 '<div class="hoh-form-quality" role="note" data-wstep="0">'+
  '<span class="hoh-form-quality-icon" aria-hidden="true">&#9876;&#xFE0E;</span>'+
  '<span class="hoh-form-quality-text">'+
   '<strong>Quality heroes only.</strong>'+
   ' If they\'re a real character from one of your campaigns, submit them. '+(HOH_WIZ.short?'Their story comes next, on their own page.':'Drop in a story you\'d be proud to read back.')+' Test submissions and one-line throwaways get hidden automatically.'+
  '</span>'+
 '</div>'+
 /* ⛔ R795 (Jan, on the approved prototype round 2: "make sure this is
    centered better ... look good on mobile and desktop ... add more padding
    per question"). The portrait uploader is centred, with the FramedFantasy
    box and the credit under it; the hero's fields sit in a clean grid on
    their own step. Every element keeps its id, class, data-wstep and handler,
    so validateForm, the draft, the upload, moderation and the submit read
    exactly the same form. Edit mode reads top to bottom, portrait first.
    Nothing under the FramedFantasy box promises or explains Mythic.
    ⛔ Jan (2026-09-23): the image-rules box ("What the Hall accepts", added
    in R433) is removed: "remove this : One character, painted or drawn,
    filling most of the frame. No text, sheets or real photos." Moderation
    still hides an image that breaks the rules, and Your Hall tells the owner
    why (hoh-your-hall.js). */
 /* FITEDITOR: the empty zone opens the file picker; a tap or drag inside the
    fit editor it later holds must not */
 /* HALL-BUILD (Jan, 2026-10-19): the live card on the portrait screen; hohLiveCardPaint fills it */
 '<div class="hoh-livecard" data-wstep="2" aria-hidden="true"><div class="hoh-livecard-host"></div></div>'+
 '<div class="hoh-field hoh-add-pic" data-wstep="2"><label class="hoh-label hoh-hall-visually-hidden">Character portrait</label><div class="hoh-upload-grid"><div id="hoh-upload-zone-0" class="hoh-upload" onclick="if(!(event.target.closest&&event.target.closest(\'.hoh-fit\')))document.getElementById(\'hoh-file-0\').click()"><span class="hoh-upload-plus" aria-hidden="true"><svg viewBox="0 0 24 24" width="34" height="34"><rect x="3.5" y="4.5" width="17" height="15" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="9" cy="10" r="1.8" fill="currentColor"/><path fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" d="m4 17 5-4.5 4 3.5 3-2.5 4 3.5"/></svg></span><span class="hoh-upload-text">Add a portrait</span></div><div id="hoh-upload-zone-1" class="hoh-upload" onclick="document.getElementById(\'hoh-file-1\').click()"><span class="hoh-upload-plus" aria-hidden="true">+</span><span class="hoh-upload-text">Second image <span class="hoh-label-opt">Optional</span></span></div></div><input type="file" id="hoh-file-0" accept="image/*" style="display:none" onchange="hohPreviewImg(0,this)"><input type="file" id="hoh-file-1" accept="image/*" style="display:none" onchange="hohPreviewImg(1,this)"><p class="hoh-image-use-note">Your images stay in the Hall. I do not train AI on them or use them anywhere else.</p></div>'+
 /* R795: the FramedFantasy box and the credit belong to the image, so they
    sit right under it (edit mode reads top to bottom too). */
 /* HALLFLOWS (Jan: "this box from submitting your character looks really
    ugly and bad ux"). One calm row with one label style; the explanation
    sits OUTSIDE the label, so a near miss on it never ticks the claim and a
    screen reader no longer reads it as part of the checkbox's name. The
    input keeps its id, class and listeners, so the draft, the confirm gate at
    submit, the payload and the CAPI is_ff_portrait property are unchanged. */
 '<div class="hoh-ff-toggle-wrap" id="hoh-ff-toggle-wrap" data-wstep="2">'+
  '<label class="hoh-ff-toggle" for="hoh-f-ff-portrait">'+
  '<input type="checkbox" id="hoh-f-ff-portrait" class="hoh-ff-checkbox" aria-describedby="hoh-ff-note-t">'+
  '<span class="hoh-ff-check-visual" aria-hidden="true"><span class="hoh-ff-checkmark">&#10003;</span></span>'+
  '<span class="hoh-ff-toggle-body">I commissioned this portrait from <span class="hoh-ff-brand-framed">Framed</span><span class="hoh-ff-brand-fantasy">Fantasy</span> <span class="hoh-ff-toggle-reward">+10 tickets</span></span>'+
  '</label>'+
  '<p class="hoh-ff-note"><span id="hoh-ff-note-t">Only for paid commissions.</span> <button type="button" class="hoh-ff-learn" aria-haspopup="dialog" onclick="hohOpenFfQualify(this)">What counts?</button></p>'+
 '</div>'+
 /* ⛔ R574 (Jan): "once they put in an image, open an author credit thing where
    they can literally write in the artist who did it. They can write in the
    artist's name if they want to. It's optional."
    HIDDEN UNTIL THERE IS AN IMAGE, because a credit field with nothing to
    credit is noise on the busiest step of the form. And hidden again when the
    FramedFantasy box is ticked, because that hero's credit line already reads
    "Portrait by FramedFantasy" and asking for a second artist there would
    contradict it. hohArtistFieldSync owns both rules. */
 '<div class="hoh-field hoh-artist-wrap" id="hoh-artist-wrap" data-wstep="2" style="display:none;">'+
  '<label class="hoh-label" for="hoh-f-artist">Who drew this? <span class="hoh-label-opt">Optional</span></label>'+
  '<input type="text" id="hoh-f-artist" class="hoh-input" maxlength="60" autocomplete="off" placeholder="Artist name or handle">'+
  '<p class="hoh-field-note">Credit the artist who made this piece. It shows on your hero\'s page. Leave it empty if you made it yourself or you would rather not say.</p>'+
 '</div>'+
 '<div id="hoh-draft-notice" class="hoh-draft-notice" role="status" style="display:none;" data-wstep="1">'+
  '<span class="hoh-draft-notice-icon" aria-hidden="true">&#8634;</span>'+
  '<span class="hoh-draft-notice-body">'+
   '<strong>Draft restored from this device.</strong>'+
   ' Pick up where you left off, or '+
   '<button type="button" class="hoh-draft-clear" onclick="hohClearDraft(event)">start fresh</button>.'+
  '</span>'+
 '</div>'+
 /* HALL-BUILD: the live card on the hero screen, above (phone) or beside (wider) the fields */
 '<div class="hoh-livecard" data-wstep="1" aria-hidden="true"><div class="hoh-livecard-host"></div></div>'+
 '<h3 class="hoh-add-legend" data-wstep="1">The hero</h3>'+
 /* R424 (Jan): the hero's name and the SUBMITTER's name were side by side
    in one row, which quietly said they were the same kind of fact. They are
    not — one is the character, one is you — and the wizard puts them on
    different steps, so they are separate fields now. */
 '<div class="hoh-field" data-wstep="1"><label class="hoh-label" for="hoh-f-name">Hero name</label><input type="text" id="hoh-f-name" class="hoh-input" placeholder="Vaelith Dawntracker"><a href="#" id="hoh-f-debug-btn" class="hoh-debug-link" style="display:none;" onclick="event.preventDefault();hohDebugSuccessView();">Continue &rarr;</a></div>'+
 '<div class="hoh-row" data-wstep="1"><div class="hoh-field"><label class="hoh-label" for="hoh-f-race">Race</label><select id="hoh-f-race" class="hoh-select hoh-input"><option value="" disabled selected>Select race</option></select><input type="text" id="hoh-f-custom-race" class="hoh-input" placeholder="Enter custom race" style="display:none;margin-top:8px;"></div><div class="hoh-field"><label class="hoh-label" for="hoh-f-class">Class</label><select id="hoh-f-class" class="hoh-select hoh-input"><option value="" disabled selected>Select class</option></select><input type="text" id="hoh-f-custom-class" class="hoh-input" placeholder="Enter custom class" style="display:none;margin-top:8px;"></div></div>'+
 '<div class="hoh-row" data-wstep="1"><div class="hoh-field"><label class="hoh-label" for="hoh-f-level">Level <span class="hoh-label-opt">Optional</span></label><input type="number" id="hoh-f-level" class="hoh-input" min="1" max="20" placeholder="14"></div><div class="hoh-field"><label class="hoh-label" for="hoh-f-campaign">Campaign <span class="hoh-label-opt">Optional</span></label><input type="text" id="hoh-f-campaign" class="hoh-input" placeholder="The Shattered Wilds"></div></div>'+
 '<div class="hoh-field" data-wstep="3"><label class="hoh-label" for="hoh-f-story">Their story</label><p class="hoh-field-prompt">This is what wins the spotlight. Tell us about the moment that defined them.</p><textarea id="hoh-f-story" class="hoh-input hoh-textarea" placeholder="She was supposed to be a throwaway character for a one-shot..."></textarea><div id="hoh-f-story-progress" class="hoh-story-progress hoh-story-progress-empty"><div class="hoh-story-progress-bar"><div class="hoh-story-progress-fill" id="hoh-f-story-fill"></div></div><div class="hoh-story-progress-text" id="hoh-f-story-text">Start writing your hero\'s story.</div></div><div id="hoh-f-story-error" class="hoh-form-error" style="display:none;"></div></div>'+
 (window.hohTools?window.hohTools.stepHtml():'')+
 '<div class="hoh-npc-wrap" data-wstep="4">'+
  '<div id="hoh-npc-panel-trigger" class="hoh-npc-panel-trigger" onclick="hohToggleNpcPanel()">'+
  '<span class="hoh-npc-panel-arrow">&rsaquo;</span>'+
  '<span>Add NPC details for DMs</span>'+
  '<span class="hoh-npc-reward" id="hoh-npc-reward" aria-label="Earn one raffle ticket">'+_hohTicketRewardHtml(false)+'</span>'+
  '<span class="hoh-npc-done" id="hoh-npc-done" aria-label="Complete" style="display:none;">&#10003;</span>'+
  '</div>'+
  '<div id="hoh-npc-panel" class="hoh-npc-panel">'+
  '<p class="hoh-npc-panel-intro">Only if a DM pulls your hero as an NPC. Fill all six hints to earn the ticket above and help DMs run your hero without changing who they are.</p>'+
  '<div class="hoh-npc-field-mini"><label class="hoh-npc-label-mini">What they want right now</label><input type="text" id="hoh-f-npc-goal" class="hoh-npc-input-mini" maxlength="100" placeholder="Find her brother\'s killer"></div>'+
  '<div class="hoh-npc-field-mini"><label class="hoh-npc-label-mini">A secret they\'re hiding</label><input type="text" id="hoh-f-npc-secret" class="hoh-npc-input-mini" maxlength="120" placeholder="Working both sides of the war"></div>'+
  '<div class="hoh-npc-field-mini"><label class="hoh-npc-label-mini">One thing they\'d never admit</label><input type="text" id="hoh-f-npc-weakness" class="hoh-npc-input-mini" maxlength="100" placeholder="Scared of open water"></div>'+
  '<div class="hoh-npc-field-mini"><label class="hoh-npc-label-mini">Someone they\'d never forgive</label><input type="text" id="hoh-f-npc-enemy" class="hoh-npc-input-mini" maxlength="120" placeholder="The guard captain who framed her"></div>'+
  '<div class="hoh-npc-field-mini"><label class="hoh-npc-label-mini">A weird habit or tell</label><input type="text" id="hoh-f-npc-habit" class="hoh-npc-input-mini" maxlength="120" placeholder="Taps her dagger hilt when thinking"></div>'+
  '<div class="hoh-npc-field-mini"><label class="hoh-npc-label-mini">A line they\'d actually say</label><input type="text" id="hoh-f-npc-catchphrase" class="hoh-npc-input-mini" maxlength="120" placeholder="Gold first, questions later"></div>'+
  '</div>'+
 '</div>'+
 /* R140-Z3p: NPC Stat Block (D&D 5e) panel. HIDDEN until the story
    is filled (>=80 chars) so casual submitters don't see a 30-field
    form, only experienced creators who've already invested in their
    hero's narrative. Inner content rendered by hoh-npc-stats.js once
    visibility is unlocked. The wrapper stays in the DOM so we have
    a stable mount point. */
 '<div id="hoh-npc-stats-wrap" class="hoh-npc-stats-wrap" style="display:none;" data-wstep="4">'+
  '<div id="hoh-npc-stats-trigger" class="hoh-npc-panel-trigger hoh-npc-stats-trigger" onclick="hohToggleNpcStatsPanel()">'+
   '<span class="hoh-npc-panel-arrow">&rsaquo;</span>'+
   '<span>Add D&amp;D 5e stat block for DMs</span>'+
   '<span class="hoh-npc-reward" id="hoh-stats-reward" aria-label="Earn one raffle ticket">'+_hohTicketRewardHtml(false)+'</span>'+
   '<span class="hoh-npc-done" id="hoh-stats-done" aria-label="Complete" style="display:none;">&#10003;</span>'+
  '</div>'+
  '<div id="hoh-npc-stats-panel" class="hoh-npc-panel hoh-npc-stats-panel">'+
   '<div id="hoh-npc-stats-mount"></div>'+
  '</div>'+
 '</div>'+
 /* ⛔ R574 · "CUSTOMIZE YOUR CARD". Jan: "they see a preview of the character
    card already ... that way when they're entering, they already know that they
    can edit the card text."
    THE PREVIEW IS THE REAL CARD, not a lookalike. It is drawn by the same
    fullCardHtml the Hall uses, through a hero object the step assembles from
    the form, so it cannot drift from what they will actually get.
    The quote only exists for FramedFantasy portraits, which is the same rule
    the card itself follows: cardText() reads a quote for FF cards only, so
    offering the box to anyone else would collect words no card ever prints. */
 '<div class="hoh-cardstep" data-wstep="5">'+
   '<div class="hoh-cardstep-preview" id="hoh-cardstep-preview"></div>'+
   /* FITEDITOR: back to the picture screen to move the picture on the card */
   '<button type="button" class="hoh-cardstep-move" id="hoh-cardstep-move" hidden onclick="hohWizMovePicture()">Move the picture</button>'+
   '<p class="hoh-cardstep-lead">This is your card. Write the line that sits under the art, or leave it and one will be written for you.</p>'+
   '<div class="hoh-field">'+
     '<label class="hoh-label" for="hoh-f-legend">Card description <span class="hoh-label-opt">Optional</span></label>'+
     '<textarea id="hoh-f-legend" class="hoh-input hoh-cardstep-area" rows="3" maxlength="260" placeholder="A couple of sentences about who they are."></textarea>'+
     /* Jan: "make sure that they know that they just need to write flavor text
        as description ... but don't say anything about card mechanics." So it
        names flavor and stops there. */
     '<p class="hoh-field-note"><span id="hoh-legend-count">0</span> of 260. Just flavor text, in your own words. A line or two about who they are.</p>'+
   '</div>'+
   '<div class="hoh-field hoh-quote-wrap" id="hoh-quote-wrap" style="display:none;">'+
     '<label class="hoh-label" for="hoh-f-quote">Their quote <span class="hoh-label-opt">Optional</span></label>'+
     '<input type="text" id="hoh-f-quote" class="hoh-input" maxlength="120" autocomplete="off" placeholder="Something only they would say.">'+
     '<p class="hoh-field-note"><span id="hoh-quote-count">0</span> of 120. A FramedFantasy portrait carries a spoken line under the art.</p>'+
   '</div>'+
 '</div>'+
 /* R433 · the close. Painted by hohWizPaint with the hero's own name so
    the final ask arrives attached to something they made, not to a blank
    contact form. Hidden until the wizard paints it, so edit mode (which
    has no wizard) never shows an empty card. */
 /* HALLWIZ: the recap is the hero's reveal card (hohWizPaint fills it). The
    art is decorative here (aria-hidden): the heading names the hero. The
    sparks are placed by their custom properties and only play on arrival. */
 '<div id="hoh-wiz-recap" class="hoh-wiz-recap hoh-wiz-reveal" data-wstep="6" style="display:none;">'+
  '<div class="hoh-wiz-reveal-card">'+
   '<div class="hoh-wiz-reveal-art" aria-hidden="true"><div class="hoh-wiz-reveal-in"><img class="hoh-wiz-reveal-img" alt="" draggable="false"></div><i class="hoh-wiz-shine"></i></div>'+
   '<span class="hoh-wiz-spark" aria-hidden="true" style="--sx:-92px;--sy:-46px;--sd:.10s;--ss:1"></span>'+
   '<span class="hoh-wiz-spark" aria-hidden="true" style="--sx:88px;--sy:-58px;--sd:.22s;--ss:.8"></span>'+
   '<span class="hoh-wiz-spark" aria-hidden="true" style="--sx:-104px;--sy:18px;--sd:.34s;--ss:.7"></span>'+
   '<span class="hoh-wiz-spark" aria-hidden="true" style="--sx:100px;--sy:8px;--sd:.16s;--ss:1"></span>'+
   '<span class="hoh-wiz-spark" aria-hidden="true" style="--sx:-60px;--sy:-84px;--sd:.42s;--ss:.6"></span>'+
   '<span class="hoh-wiz-spark" aria-hidden="true" style="--sx:56px;--sy:-88px;--sd:.30s;--ss:.75"></span>'+
   '<span class="hoh-wiz-spark" aria-hidden="true" style="--sx:-82px;--sy:62px;--sd:.50s;--ss:.65"></span>'+
   '<span class="hoh-wiz-spark" aria-hidden="true" style="--sx:84px;--sy:58px;--sd:.46s;--ss:.85"></span>'+
   '<h3 class="hoh-wiz-reveal-h"><span class="hoh-wiz-recap-n"></span> <span class="hoh-wiz-reveal-t">is ready for the Hall</span></h3>'+
   '<p class="hoh-wiz-reveal-c"></p>'+
  '</div>'+
  '<p class="hoh-wiz-recap-s"></p>'+
 '</div>'+
 /* R148-Z17: Cooldown notice now offers a 300-heart "pay to submit
    another" option. Per user: "i also want to add a functionality
    where it costs 300 hearts so submit a second hero for the day...
    but it doesnt give a second ticket or anything." validateForm()
    re-renders this region's pay button on every keystroke so the
    enabled/disabled state stays accurate against the live wallet. */
 '<div id="hoh-submit-cooldown" class="hoh-submit-cooldown" style="display:none;" data-wstep="6">'+
   '<div class="hoh-submit-cooldown-msg">You\'ve added a hero today. To keep the Hall fair, each device can submit one character per day.</div>'+
   '<div class="hoh-submit-cooldown-pay" id="hoh-submit-cooldown-pay">'+
     '<button type="button" class="hoh-submit-cooldown-pay-btn" id="hoh-submit-cooldown-pay-btn" onclick="hohPayForExtraSubmission()">'+
       '<span class="hoh-submit-cooldown-pay-label">Submit another</span>'+
       '<span class="hoh-submit-cooldown-pay-cost">300 <span aria-hidden="true">&#10084;</span></span>'+
     '</button>'+
     '<div class="hoh-submit-cooldown-pay-hint" id="hoh-submit-cooldown-pay-hint">Second submission won\'t earn a raffle ticket.</div>'+
   '</div>'+
 '</div>'+
 /* R795: name and email sit side by side on a wide screen (hoh-add-half);
    signed in, both are hidden and the PIN leads. */
 /* HALL-GOOGLE-01: signed out, Google can fill in the name and email right where they are asked. It runs in its own
    window (data-hgs-tab), so this form, its words and its picture stay exactly as they are; hohFormIdentity takes the
    answer in place. hoh-google-signin.js fills the slot only where Google sign-in works, and it is hidden for anyone
    already signed in. */
 (!isEdit&&!hohQuestHandoff?'<div class="hoh-form-google" id="hoh-form-google" data-wstep="6">'+
  '<div class="hgs-slot" data-hgs-from="form" data-hgs-tab="1" data-hgs-or="after" data-hgs-lead="Google can fill in your name and email."></div>'+
 '</div>':'')+
 '<div class="hoh-field hoh-add-half" data-wstep="6"><label class="hoh-label" for="hoh-f-player">Your name or alias</label><input type="text" id="hoh-f-player" class="hoh-input" placeholder="Marcus" autocomplete="nickname"><p class="hoh-field-note">Shown on your hero\'s page as the submitter. A first name or a handle is fine.</p></div>'+
 '<div class="hoh-field hoh-add-half" data-wstep="6"><label class="hoh-label" for="hoh-f-email">Your email</label><input type="email" id="hoh-f-email" class="hoh-input" placeholder="your@email.com" autocomplete="email"><p class="hoh-field-note">No spam, ever. Never shown publicly. I use it for raffle results and news about your hero.</p></div>'+
 '<div id="hoh-claim-scan" data-wstep="6"></div>'+
 '<div class="hoh-field" data-wstep="6"><label class="hoh-label" for="hoh-f-pin">Your Hall PIN</label><input type="text" inputmode="numeric" pattern="[0-9]{4}" maxlength="4" id="hoh-f-pin" class="hoh-input hoh-form-pin-input" autocomplete="off" placeholder="1234"><p class="hoh-field-note">Pick any 4 digits. Your email plus this PIN signs you in to Your Hall, where you can edit your heroes and track your tickets.</p></div>'+
 /* SMS opt-in lives directly under the Hall PIN — both are
    sign-in / contact-method controls, so they group cleanly. */
 '<div class="hoh-field hoh-sms-wrap" data-wstep="6">'+
  '<label class="hoh-sms-toggle" for="hoh-f-sms-optin">'+
   '<input type="checkbox" id="hoh-f-sms-optin" class="hoh-ff-checkbox" onchange="hohToggleSmsField(this);">'+
   '<span class="hoh-ff-check-visual"><span class="hoh-ff-checkmark">&#10003;</span></span>'+
   '<span class="hoh-sms-toggle-body">Get updates and raffle results by text <span class="hoh-sms-toggle-sub">Optional, US only</span></span>'+
  '</label>'+
  '<div class="hoh-sms-phone-wrap" id="hoh-sms-phone-wrap">'+
   '<input type="tel" id="hoh-f-phone" class="hoh-input hoh-sms-phone" placeholder="+1 415 555 1234" autocomplete="tel">'+
   '<div id="hoh-f-phone-error" class="hoh-form-error" style="display:none;"></div>'+
   '<p class="hoh-field-note">Standard rates may apply. Used for spotlight news and the monthly raffle.</p>'+
  '</div>'+
 '</div>'+
 /* HALLFLOWS: in the wizard, hohWizInit moves Submit and the next line below
    into the footer (the same footer every screen has); what is still missing
    is that footer's status line, and its Back is the one Back. Edit mode has
    no wizard and keeps both here. */
 '<button id="hoh-submit-btn" class="hoh-btn-primary hoh-btn-full" data-wstep="6" onclick="hohSubmitCharacter()" disabled>'+(isEdit?'Save Changes':'Submit to the Hall of Heroes')+'</button>'+
 /* R795: what happens next, once the hero page exists (painted by hohWizPaint
    with the hero's name; hidden otherwise and in edit mode) */
 '<p class="hoh-add-next" id="hoh-add-next" data-wstep="6" hidden></p>'+
 /* HALLWIZ: the permanent-page promise and the Terms are one fine-print block,
    the last thing in the step */
 '<p class="hoh-permanence-pledge" data-wstep="6">Every hero submitted has a permanent page. <span class="hoh-pledge-more">I do not delete, paywall, or break URLs. <a href="https://framedfantasy.com/policies/terms-of-service" target="_blank" rel="noopener" class="hoh-form-tos-link">Terms of Service</a></span></p>'+
 '<button class="hoh-cancel-btn" data-wstep="6" onclick="hohCloseForm()">Cancel</button>'+
 '</div>';

 var rfo=document.getElementById('hoh-f-race'),cfo=document.getElementById('hoh-f-class');
 RACES.forEach(function(r){rfo.innerHTML+='<option value="'+r+'">'+r+'</option>';});
 rfo.innerHTML+='<option value="Other">Other</option>';
 CLASSES.forEach(function(c){cfo.innerHTML+='<option value="'+c+'">'+c+'</option>';});
 cfo.innerHTML+='<option value="Other">Other</option>';
 rfo.addEventListener('change',function(){document.getElementById('hoh-f-custom-race').style.display=this.value==='Other'?'block':'none';validateForm();hohSaveDraft();});
 cfo.addEventListener('change',function(){document.getElementById('hoh-f-custom-class').style.display=this.value==='Other'?'block':'none';validateForm();hohSaveDraft();});
 ['hoh-f-name','hoh-f-player','hoh-f-email','hoh-f-race','hoh-f-class','hoh-f-story','hoh-f-level','hoh-f-campaign','hoh-f-custom-race','hoh-f-custom-class','hoh-f-npc-goal','hoh-f-npc-weakness','hoh-f-npc-habit','hoh-f-npc-catchphrase','hoh-f-npc-secret','hoh-f-npc-enemy','hoh-f-phone','hoh-f-legend','hoh-f-quote','hoh-f-artist'].forEach(function(id){var el=document.getElementById(id);if(el){el.addEventListener('input',function(){validateForm();hohSaveDraft();hohClearFieldError(id);try{if(typeof window.hohUpdateCompletionMarks==='function')window.hohUpdateCompletionMarks();}catch(_){}});el.addEventListener('change',function(){validateForm();hohSaveDraft();});}});
 /* R267: keep the section completion marks live as the stat block is edited,
    and paint their initial state as soon as the form opens. */
 try { var _statsMount=document.getElementById('hoh-npc-stats-mount'); if(_statsMount) _statsMount.addEventListener('input',function(){ try{ if(typeof window.hohUpdateCompletionMarks==='function') window.hohUpdateCompletionMarks(); }catch(_){} }); } catch(_){}
 try { setTimeout(function(){ try{ if(typeof window.hohUpdateCompletionMarks==='function') window.hohUpdateCompletionMarks(); }catch(_){} }, 0); } catch(_){}
 var ffChk=document.getElementById('hoh-f-ff-portrait');if(ffChk)ffChk.addEventListener('change',hohSaveDraft);
 var smsChk=document.getElementById('hoh-f-sms-optin');if(smsChk)smsChk.addEventListener('change',hohSaveDraft);
 setupDragDrop();
 /* R424: the wizard wraps NEW submissions only. Edit mode keeps the single
    scrolling form — someone fixing one line on their own hero should not
    have to page through five steps to reach it. Wrapped BEFORE the draft is
    restored so restored values land in already-built panes and the notice
    shows on the step it belongs to. */
 HOH_WIZ.on = false; HOH_WIZ.opened4 = false;
 if(!isEdit){ try { hohWizInit(); } catch(_){} }
 if(isEdit){hohPrefillForm(editChar);}else if(!hohQuestHandoff){hohRestoreDraft();if(window.hohApplySignedInForm)hohApplySignedInForm();}
 validateForm();
 if(window.hohTools)window.hohTools.wireStep();
 try { if(HOH_WIZ.on) hohWizPaint(); } catch(_){}
}

/* Populate form fields from an existing character when entering edit mode. */
function hohPrefillForm(c){
 function setVal(id,v){var el=document.getElementById(id);if(el&&v!=null)el.value=v;}
 setVal('hoh-f-name',c.name);
 setVal('hoh-f-player',c.player_name);
 setVal('hoh-f-email',c.email);
 /* ⛔ R574: an editor must open on the words that are already there, or they
    will retype them and the merge will read as a change that was never made.
    Only a person's OWN text is prefilled: `edited` is false on an AI-written
    line, and showing that back as if they had typed it would invite them to
    accept it and quietly claim it, which then locks the card out of ever being
    rewritten. The artist credit is theirs either way. */
 try{
  var _m = c.card_meta || {};
  if(_m.edited === true){
   setVal('hoh-f-legend', _m.legend || '');
   setVal('hoh-f-quote', _m.quote || '');
  }
  setVal('hoh-f-artist', _m.artist || '');
  if(window.hohTools)window.hohTools.stepRestore(_m);
 }catch(_){ }
 /* PLAYTESTER 2026-10-04: the Level box is the D&D level, the one the card,
    the hero page and the sheet show (dnd_level, R224). It used to open on
    c.level, which is the Hall XP level (R148-Z22, 52 on a busy hero) and is
    not shown anywhere as a D&D level, so a player who raised their level here
    changed nothing they could see and reset their Hall XP level instead. */
 var _dl=parseInt(c.dnd_level,10);
 setVal('hoh-f-level',_dl>=1?String(_dl):'');
 setVal('hoh-f-campaign',c.campaign);
 setVal('hoh-f-story',c.story);
 /* R795b: what the story held when the edit opened (validateForm lets an
    unchanged story save, however short, once the hero page exists) */
 try{ var _stEl=document.getElementById('hoh-f-story'); if(_stEl) _stEl.__hohWas=String(c.story||''); }catch(_){ }
 setVal('hoh-f-npc-goal',c.npc_current_goal);
 setVal('hoh-f-npc-weakness',c.npc_hidden_weakness);
 setVal('hoh-f-npc-habit',c.npc_habit);
 setVal('hoh-f-npc-catchphrase',c.npc_catchphrase);
 setVal('hoh-f-npc-secret',c.npc_secret);
 setVal('hoh-f-npc-enemy',c.npc_enemy);
 // Race
 var rEl=document.getElementById('hoh-f-race');
 if(rEl&&c.race){
 var matched=false;
 for(var i=0;i<rEl.options.length;i++){if(rEl.options[i].value===c.race){rEl.value=c.race;matched=true;break;}}
 if(!matched){rEl.value='Other';var custR=document.getElementById('hoh-f-custom-race');if(custR){custR.style.display='block';custR.value=c.race;}}
 }
 var cEl=document.getElementById('hoh-f-class');
 if(cEl&&c.character_class){
 var matchedC=false;
 for(var j=0;j<cEl.options.length;j++){if(cEl.options[j].value===c.character_class){cEl.value=c.character_class;matchedC=true;break;}}
 if(!matchedC){cEl.value='Other';var custC=document.getElementById('hoh-f-custom-class');if(custC){custC.style.display='block';custC.value=c.character_class;}}
 }
 var ffEl=document.getElementById('hoh-f-ff-portrait');if(ffEl)ffEl.checked=!!c.is_ff_portrait;
 /* R268: an already-FF hero counts as pre-confirmed, so a normal save never
    re-prompts. Newly ticking the box on a non-FF hero flips this to false via
    the change listener, so that claim still gets the confirm gate. */
 window.__hohFfConfirmed=!!(c&&c.is_ff_portrait);
 // Pre-mark uploads so validator passes; new uploads overwrite.
 if(c.image_url){
 var zone0=document.getElementById('hoh-upload-zone-0');
 if(zone0){
   var initialOffset0 = hohGetImageOffsetY(c.id, 'primary');
   var initialOffsetX0 = (typeof window.hohGetImageOffsetX==='function') ? window.hohGetImageOffsetX(c.id, 'primary') : 50;
   var initialZoom0 = (typeof window.hohGetImageZoom==='function') ? window.hohGetImageZoom(c.id, 'primary') : 100;
   var initialPos0 = (typeof window.hohImgObjPos==='function') ? window.hohImgObjPos(c.id, 'primary') : ('50% '+initialOffset0+'%');
   var initialStyle0 = (typeof window.hohImgStyle==='function') ? window.hohImgStyle(c.id, 'primary') : ('object-position:'+initialPos0+';');
   /* R129: Remove the parent zone's onclick (which opens the file
      picker on any click). With an existing image, the user wants
      to DRAG to reframe, not re-upload. Only the explicit "Replace
      photo" button should open the picker. The drag handler's
      preventDefault on mousedown doesn't stop the synthetic click
      event from bubbling to the parent on mouseup, so we kill the
      handler entirely here. */
   zone0.onclick = null;
   zone0.removeAttribute('onclick');
   /* R136-mobile-reframe: tag for the CSS overrides that drop the
      parent's 1:1 aspect-ratio + overflow:hidden so the Save Reframe
      button under the frame stays VISIBLE on mobile. */
   zone0.classList.add('hoh-upload-edit');
   /* R129: Fixed the broken Replace Photo button — the file input
      id on the page is hoh-file-0, not hoh-upload-input-0. The old
      reference made the button silently dead.
      R129: Added a dedicated "Save Reframe" button right under the
      Drag-to-reframe hint. It saves ONLY the offset (no full-form
      submit needed) and updates the Hall grid card live. The dirty
      indicator on the frame flips when the user starts dragging so
      the button visually demands a click. */
   zone0.innerHTML='<div class="hoh-edit-img-frame" data-offset="'+initialOffset0+'" data-offset-x="'+initialOffsetX0+'" data-zoom="'+initialZoom0+'" data-charid="'+esc(c.id)+'" data-slot="primary"><img src="'+esc(c.image_url)+'" alt="Current portrait" style="'+initialStyle0+'" draggable="false"><div class="hoh-edit-img-grip" aria-label="Drag to reposition"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="8 6 12 2 16 6"></polyline><polyline points="8 18 12 22 16 18"></polyline></svg></div></div><div class="hoh-edit-img-help">Drag the portrait up or down to reframe.</div>'+hohEditZoomHtml(initialZoom0)+'<div class="hoh-edit-img-actions"><button type="button" class="hoh-edit-img-save" id="hoh-edit-img-save-0" onclick="hohSaveReframeOnly(\''+esc(c.id)+'\',\'primary\',this)">Save Reframe</button><button type="button" class="hoh-upload-overlay-replace" onclick="document.getElementById(\'hoh-file-0\').click()">Replace photo</button></div>';
   hohWireImageReposition(zone0, c.id, 'primary');
 }
 selectedFiles[0]='keep';
 }
 if(c.image_url_2){
 var zone1=document.getElementById('hoh-upload-zone-1');
 if(zone1){
   var initialOffset1 = hohGetImageOffsetY(c.id, 'secondary');
   var initialOffsetX1 = (typeof window.hohGetImageOffsetX==='function') ? window.hohGetImageOffsetX(c.id, 'secondary') : 50;
   var initialZoom1 = (typeof window.hohGetImageZoom==='function') ? window.hohGetImageZoom(c.id, 'secondary') : 100;
   var initialPos1 = (typeof window.hohImgObjPos==='function') ? window.hohImgObjPos(c.id, 'secondary') : ('50% '+initialOffset1+'%');
   var initialStyle1 = (typeof window.hohImgStyle==='function') ? window.hohImgStyle(c.id, 'secondary') : ('object-position:'+initialPos1+';');
   /* R129: same parent-onclick removal + Replace Photo fix +
      Save Reframe button as zone0 above. */
   zone1.onclick = null;
   zone1.removeAttribute('onclick');
   /* R136-mobile-reframe: see zone0 — drops 1:1 + overflow:hidden so
      Save Reframe stays visible on mobile. */
   zone1.classList.add('hoh-upload-edit');
   zone1.innerHTML='<div class="hoh-edit-img-frame" data-offset="'+initialOffset1+'" data-offset-x="'+initialOffsetX1+'" data-zoom="'+initialZoom1+'" data-charid="'+esc(c.id)+'" data-slot="secondary"><img src="'+esc(c.image_url_2)+'" alt="Second portrait" style="'+initialStyle1+'" draggable="false"><div class="hoh-edit-img-grip" aria-label="Drag to reposition"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="8 6 12 2 16 6"></polyline><polyline points="8 18 12 22 16 18"></polyline></svg></div></div><div class="hoh-edit-img-help">Drag the portrait up or down to reframe.</div>'+hohEditZoomHtml(initialZoom1)+'<div class="hoh-edit-img-actions"><button type="button" class="hoh-edit-img-save" id="hoh-edit-img-save-1" onclick="hohSaveReframeOnly(\''+esc(c.id)+'\',\'secondary\',this)">Save Reframe</button><button type="button" class="hoh-upload-overlay-replace" onclick="document.getElementById(\'hoh-file-1\').click()">Replace photo</button></div>';
   hohWireImageReposition(zone1, c.id, 'secondary');
   try{ if(typeof window.hohMountSwapFab==='function') window.hohMountSwapFab(c.id, zone1); }catch(_){}
 }
 selectedFiles[1]='keep';
 }
 /* Edit intro: signed-in owners can edit freely. No countdown. */
 var introEl=document.querySelector('#hoh-form-inner .hoh-form-intro');
 if(introEl){
 introEl.innerHTML='<div class="hoh-form-intro-headline">Edit '+esc(c.name)+'</div>'+
  '<p class="hoh-form-intro-note">You can update the portrait, story, and character details any time.</p>';
 }
 /* Edit-mode locks. Email always locks (the user signed in with it).
    Phone locks ONLY if a number was already submitted — otherwise we
    leave it editable so a user can add SMS opt-in on edit when they
    skipped it the first time. The SMS opt-in checkbox follows the
    same rule: hidden if already opted in, visible if new. PIN is
    always hidden on edit since it's set once. */
 var emEl=document.getElementById('hoh-f-email');if(emEl){emEl.readOnly=true;emEl.classList.add('hoh-input-locked');}
 var hasExistingPhone=!!(c && c.phone_number && String(c.phone_number).trim());
 var phEl=document.getElementById('hoh-f-phone');
 if(phEl && hasExistingPhone){phEl.readOnly=true;phEl.classList.add('hoh-input-locked');phEl.value=c.phone_number;}
 var smsWrap=document.querySelector('.hoh-sms-wrap');
 if(smsWrap){
  if(hasExistingPhone){smsWrap.style.display='none';}
  else{
   /* Allow opting in on edit. Add a small note so the user knows
      this is an opt-in, not a re-edit. */
   smsWrap.style.display='';
  }
 }
 var pinWrap=document.getElementById('hoh-f-pin');if(pinWrap){var pinField=pinWrap.closest('.hoh-field');if(pinField)pinField.style.display='none';}
}

/* R257: has this device/account ever submitted? Drives the first-run
   chip hiding in the form. Flag set on every successful submit; owning
   heroes on the signed-in account counts too. */
function hohHasSubmittedBefore(){
 try{ if(localStorage.getItem('hoh-has-submitted-v1')==='1') return true; }catch(_){}
 try{ var own=(typeof window.hohOwnHeroes==='function')?window.hohOwnHeroes():[]; if(own&&own.length) return true; }catch(_){}
 return false;
}
/* ⛔ ============ R795 · AFTER A SUBMIT, FILL IN THE HERO PAGE ============
   Once the hero page exists, a successful submit takes the player to their
   new hero's page to start filling it in (/pages/hero?h=<new id>&fill=1).
   Without the page, today's success view stays exactly as it is.
   ⛔ THE PAGE MUST NOT CHANGE UNDER THE TRACKING. By the time the success
   path gets here every tracking call has STARTED (Klaviyo's profile and list
   calls, the CAPI Lead), but they are plain fetches, a page change cancels a
   fetch in flight, and Klaviyo's run one after another, so leaving at once
   would drop the list subscriptions. So a watch counts the fetches a submit
   starts (armed as the submit begins, only when the hero page exists), and
   the handoff follows the link once they have all answered and the network
   has been quiet for a moment, with a floor so the moment reads and a cap so
   a hung request can never trap the player. The watch never delays, alters
   or reads a request. */
var _hohNetWatch=null;
function hohArmSubmitNetWatch(){
 if(_hohNetWatch||!hohHeroPageBase()||typeof window.fetch!=='function') return;
 var w={pending:0,lastSettle:0,lastStart:0,orig:window.fetch,wrapped:null};
 w.wrapped=function(){
  var p=w.orig.apply(window,arguments);
  if(_hohNetWatch!==w||!p||typeof p.then!=='function') return p;
  w.pending++; w.lastStart=Date.now();
  var done=function(){ w.pending=Math.max(0,w.pending-1); w.lastSettle=Date.now(); };
  p.then(done,done);
  return p;
 };
 _hohNetWatch=w;
 window.fetch=w.wrapped;
}
function hohDisarmSubmitNetWatch(){
 var w=_hohNetWatch;
 if(!w) return;
 _hohNetWatch=null;
 try{ if(window.fetch===w.wrapped) window.fetch=w.orig; }catch(_){ }
}
/* Calls back once no watched request is open and none has started or ended
   for `quiet` ms, and at least `min` ms have passed; `max` always wins. */
function hohWhenSubmitSettled(cb,o){
 var t0=Date.now(),fired=false;
 (function tick(){
  if(fired) return;
  var w=_hohNetWatch,now=Date.now(),el=now-t0;
  var idle=!w||(w.pending===0&&now-Math.max(w.lastSettle,w.lastStart,t0)>=o.quiet);
  if((el>=o.min&&idle)||el>=o.max){ fired=true; cb(); return; }
  setTimeout(tick,100);
 })();
}
function hohPossessive(n){ n=String(n||'').trim(); return n?(/s$/i.test(n)?n+'’':n+'’s'):''; }
/* HALLWIZ: a confetti burst the moment a submit succeeds, from the dialog,
   in the Hall's gold and the FramedFantasy colours. Only after a real submit
   (the submit wrapper arms _hohNetWatch; a reopened Quest link or a preview
   never does), never under reduced motion, and a no-op if canvas-confetti did
   not load. It draws on its own canvas and sends nothing. */
function hohSubmitConfetti(){
 try{
  if(!_hohNetWatch||typeof window.confetti!=='function'||hohWizReduced()) return;
  var box=document.querySelector('#hoh-form-modal .hoh-form-wrap');
  var r=box?box.getBoundingClientRect():null, vw=window.innerWidth||1, vh=window.innerHeight||1;
  var ox=r?Math.max(.1,Math.min(.9,(r.left+r.width/2)/vw)):.5;
  var oy=r?Math.max(.15,Math.min(.6,(r.top+Math.min(r.height*.35,220))/vh)):.35;
  var o={particleCount:vw<600?70:110,spread:vw<600?62:78,startVelocity:vw<600?34:42,gravity:.95,ticks:200,scalar:.9,
   colors:['#f2d98e','#e3c27e','#c8a45e','#fff4d6','#ef94ff','#b3f5ee'],zIndex:999999,disableForReducedMotion:true};
  window.confetti(Object.assign({},o,{angle:62,origin:{x:Math.max(.05,ox-.1),y:oy}}));
  window.confetti(Object.assign({},o,{angle:118,origin:{x:Math.min(.95,ox+.1),y:oy}}));
 }catch(_){ }
}
var _hohHandoffUrl='';
function hohHeroFillHandoff(name,id){
 var base=hohHeroPageBase();
 if(!base||!id||!_hohNetWatch) return false;
 var url=window.location.origin+base+'?h='+encodeURIComponent(String(id))+'&fill=1';
 _hohHandoffUrl=url;
 var nm=String(name||'').trim();
 /* the first name, the way the approved Add screen speaks ("Lyra's page") */
 var poss=nm?hohPossessive(nm.split(/\s+/)[0]):'their';
 try{ document.getElementById('hoh-form-modal-title').textContent='You’re In!'; }catch(_){ }
 var inner=document.getElementById('hoh-form-inner');
 if(inner){
  inner.innerHTML='<div class="hoh-success hoh-hero-handoff" role="status" aria-live="polite">'+
   '<div class="hoh-success-icon" aria-hidden="true">&#9876;</div>'+
   '<h3 class="hoh-success-title">'+(nm?esc(nm)+' has entered the Hall':'Your hero has entered the Hall')+'</h3>'+
   '<p class="hoh-success-text">Opening '+esc(poss)+' page. A few short questions fill it in and raise their rarity. Skip any you like.</p>'+
   '<div class="hoh-handoff-bar" aria-hidden="true"><i></i></div>'+
   '<a class="hoh-handoff-link" href="'+esc(url)+'" onclick="if(!event.metaKey&&!event.ctrlKey&&!event.shiftKey){event.preventDefault();hohHeroHandoffNow();}">Open '+esc(poss)+' page</a>'+
  '</div>';
 }
 try{ if(window.hohResetViewportModal) window.hohResetViewportModal('hoh-form-modal'); }catch(_){ }
 hohWhenSubmitSettled(function(){ hohDisarmSubmitNetWatch(); hohGoToHeroPage(url); },{min:1500,quiet:450,max:7000});
 return true;
}
/* The link on the handoff: go as soon as the open requests answer. */
window.hohHeroHandoffNow=function(){
 if(!_hohHandoffUrl) return;
 var url=_hohHandoffUrl;
 hohWhenSubmitSettled(function(){ hohDisarmSubmitNetWatch(); hohGoToHeroPage(url); },{min:0,quiet:300,max:4000});
};
function showSuccessView(charName,charId,pending){
 try{ localStorage.setItem('hoh-has-submitted-v1','1'); }catch(_){}
 if(!pending) hohSubmitConfetti();
 /* HERO-CARD-01: a portrait from the commission page ends on its own screen (hoh-your-hall.js): the card comes first */
 if(!pending&&window.hohPortalCard&&typeof window.hohPortalCardSuccess==='function'&&window.hohPortalCardSuccess(charName,charId)) return;
 /* R795: the hero page exists and a real submit just ran: go fill it in */
 if(!pending&&hohHeroFillHandoff(charName,charId)) return;
 var url=hohHeroShareUrl(charId);var safeName=esc(charName);var escUrl=esc(url);
 /* Five sample archetype cards fanned out as a teaser preview. These
  are not the actual reveals — those are generated by the Quest based
  on choices — they exist to show the user what kind of card they will
  get back. Each tier color suggests the variety of possible reveals. */
 var fanCards=
 '<div class="hoh-letter-cards" aria-hidden="true">'+
  '<div class="hoh-letter-card hoh-letter-card-1"><div class="hoh-letter-card-eyebrow">Archetype</div><div class="hoh-letter-card-name">The Verdant Defector</div><div class="hoh-letter-card-tagline">"Walked away from the green crown and never looked back."</div></div>'+
  '<div class="hoh-letter-card hoh-letter-card-2"><div class="hoh-letter-card-eyebrow">Archetype</div><div class="hoh-letter-card-name">The Tethered Warden</div><div class="hoh-letter-card-tagline">"Bound to a cause they did not choose. Holding the line anyway."</div></div>'+
  '<div class="hoh-letter-card hoh-letter-card-3"><div class="hoh-letter-card-eyebrow">Archetype</div><div class="hoh-letter-card-name">The Ash-Marked Sovereign</div><div class="hoh-letter-card-tagline">"They turned ruin into a throne, and the road still asks for more."</div></div>'+
  '<div class="hoh-letter-card hoh-letter-card-4"><div class="hoh-letter-card-eyebrow">Archetype</div><div class="hoh-letter-card-name">The Coward\'s Witness</div><div class="hoh-letter-card-tagline">"Saw it all. Said nothing. Carries it everywhere."</div></div>'+
  '<div class="hoh-letter-card hoh-letter-card-5"><div class="hoh-letter-card-eyebrow">Archetype</div><div class="hoh-letter-card-name">The Self-Forged Heir</div><div class="hoh-letter-card-tagline">"Built their own crown out of what others left behind."</div></div>'+
 '</div>';
 document.getElementById('hoh-form-modal-title').textContent=pending?'Submitted for review':'You\'re In!';
 document.getElementById('hoh-form-inner').innerHTML=
 '<div class="hoh-success">'+
  '<div class="hoh-success-icon">&#9876;</div>'+
  '<h3 class="hoh-success-title">'+(pending?(safeName+' is in for review'):(safeName+' has entered the Hall'))+'</h3>'+
  '<p class="hoh-success-text">'+(pending?'Your hero is saved. The story is short, so it is waiting on a quick review before it joins the Hall. You can still open and share this link.':'Your character is live. Share this link to get hearts and boost your spotlight chances.')+'</p>'+
  '<div class="hoh-success-link-box"><span class="hoh-success-link-url">'+escUrl+'</span><button class="hoh-success-copy" onclick="navigator.clipboard.writeText(\''+url+'\');this.textContent=\'Copied!\';var b=this;setTimeout(function(){b.textContent=\'Copy\';},2000);">Copy</button></div>'+
  '<div class="hoh-success-bonus"><span class="hoh-success-bonus-icon hoh-success-bonus-icon-clickable" role="button" tabindex="0" aria-label="Claim hidden heart" onclick="hohClaimSuccessHeart(this,event);" onkeydown="if(event.key===\'Enter\'||event.key===\' \'){hohClaimSuccessHeart(this,event);}">&#9829;&#xFE0E;</span><span class="hoh-success-bonus-text"><strong>7 bonus hearts</strong> unlocked for today. Give them to your hero to lift their rarity and stack entries for the draw.</span></div>'+
  '<button class="hoh-btn-primary" onclick="hohViewAfterSubmit(\''+charId+'\')" style="margin-top:8px;">View Your Hero</button>'+
  /* Teaser pill: the prospect-grabbing hook. Mirrors the FB ad copy:
   short, intriguing, archetype-focused. */
  '<button id="hohLetterTeaser" class="hoh-letter-teaser" onclick="hohOpenLetter()">'+
   '<span class="hoh-letter-seal"></span>'+
   '<span class="hoh-letter-teaser-text">What archetype is <span class="hoh-letter-name">'+safeName+'</span> really?</span>'+
   '<span class="hoh-letter-arrow">&rarr;</span>'+
  '</button>'+
  /* Expanded letter — restructured around the archetype reveal. Lifts
   voice and cadence from the high-performing FB ad: conversational,
   concrete details, social proof, no-pressure offer. */
  '<div id="hohLetter" class="hoh-letter">'+
   '<button class="hoh-letter-close-x" onclick="hohCloseLetter()" aria-label="Close">&times;</button>'+
   '<div class="hoh-letter-eyebrow">One more thing</div>'+
   '<h4 class="hoh-letter-headline">What archetype is <span class="hoh-letter-name-strong">'+safeName+'</span> really?</h4>'+
   '<p class="hoh-letter-sub">5 minutes. Real dice. A custom reveal at the end.</p>'+
   fanCards+
   '<p>I built a short interactive quest for D&amp;D players. Real dice. Story choices only a player would recognize. At the end it gives you a custom <strong>archetype card</strong> for your character. A one-line tagline written like a pull quote from a fantasy novel.</p>'+
   '<p>Most players say it is weirdly accurate. A few have said it was the first time someone had named their character properly.</p>'+
   '<p class="hoh-letter-prooftext"><span class="hoh-letter-proofdot"></span>Free. No catch. 500+ players in so far.</p>'+
   '<a class="hoh-letter-cta" href="/pages/quest" target="_blank" rel="noopener">Find out in 5 minutes &rarr;</a>'+
   '<button type="button" class="hoh-letter-skip" onclick="hohCloseLetter();">Skip for now</button>'+
  '</div>'+
  '<button class="hoh-cancel-btn" onclick="hohCloseForm()" style="margin-top:8px;">Close</button>'+
 '</div>';
}

window.hohOpenLetter=function(){var t=document.getElementById('hohLetterTeaser');var l=document.getElementById('hohLetter');if(t)t.style.display='none';if(l)l.classList.add('hoh-letter-open');};
window.hohCloseLetter=function(){var t=document.getElementById('hohLetterTeaser');var l=document.getElementById('hohLetter');if(l)l.classList.remove('hoh-letter-open');if(t)t.style.display='inline-flex';};
window.hohViewAfterSubmit=function(id){document.getElementById('hoh-form-modal').style.display='none';try{document.body.classList.remove('hoh-form-modal-open');}catch(_){}/* R609: this path closes the sheet by hand, so it owes the corner wallet the same release hohDismissViewportModal gives it. */document.body.style.overflow='';forceCardsVisible();hohFlashSubmissionBonusIfPending();window.hohJustSubmitted=true;hohOpenDetail(id);};
/* Post-submit spend coach was retired in R20 (functions became no-ops)
 and the asset was removed in R25. The call sites still exist below
 (hohShowSpendCoach, hohUpdateSpendCoach, hohDeactivateSpendMode,
 hohSpendCoachCapHit) but they're all guarded with typeof X ===
 'function' checks so they cleanly skip when the script is absent. */
window.heartsRemainingToday=heartsRemainingToday;
function resizeImage(file,maxW){return new Promise(function(resolve){var img=new Image();img.onload=function(){var w=img.width,h=img.height;if(w<=maxW){resolve(file);return;}var ratio=maxW/w;var c=document.createElement('canvas');c.width=maxW;c.height=Math.round(h*ratio);c.getContext('2d').drawImage(img,0,0,c.width,c.height);c.toBlob(function(blob){resolve(blob);},'image/webp',0.85);};img.onerror=function(){/* R318: a corrupt file left this promise hanging forever, freezing the submit button. Fall through with the original file so the upload path decides. */resolve(file);};img.src=URL.createObjectURL(file);});}
/* R204: detect an ANIMATED webp from its bytes. The WebP container is
   'RIFF'....'WEBP'; animated files carry a 'VP8X' header with the animation
   bit set (offset 20, 0x02) plus an 'ANIM' chunk near the start. We read only
   the first 8KB — the ANIM chunk sits right after the VP8X header. Returns a
   Promise<boolean>. Anything that is not a webp resolves false. */
function fileIsAnimatedWebp(file){return new Promise(function(resolve){try{
  if(!file){resolve(false);return;}
  var type=(file.type||'').toLowerCase(),name=(file.name||'').toLowerCase();
  if(type.indexOf('webp')===-1 && name.slice(-5)!=='.webp'){resolve(false);return;}
  var fr=new FileReader();
  fr.onload=function(){try{
    var b=new Uint8Array(fr.result||[]);
    if(b.length<21){resolve(false);return;}
    var anim=false,lim=Math.min(b.length-4,4096);
    for(var i=12;i<lim;i++){ if(b[i]===0x41&&b[i+1]===0x4E&&b[i+2]===0x49&&b[i+3]===0x4D){anim=true;break;} } /* 'ANIM' */
    if(!anim && b[12]===0x56&&b[13]===0x50&&b[14]===0x38&&b[15]===0x58){ if((b[20]&0x02)!==0)anim=true; } /* 'VP8X' anim flag */
    resolve(anim);
  }catch(_){resolve(false);}};
  fr.onerror=function(){resolve(false);};
  fr.readAsArrayBuffer(file.slice(0,8192));
}catch(_){resolve(false);}});}
/* R204: build a STILL first-frame poster. Always draws through a canvas (no
   early return), so even an animated webp yields a flat thumbnail for the
   light grid. drawImage on an animated source paints frame one. */
function makeStaticPoster(file,maxW){return new Promise(function(resolve){try{
  var img=new Image();
  img.onload=function(){try{
    var w=img.width||maxW,h=img.height||maxW,tw=Math.min(w,maxW),ratio=tw/(w||tw);
    var c=document.createElement('canvas');
    c.width=Math.max(1,Math.round(tw));c.height=Math.max(1,Math.round(h*ratio));
    c.getContext('2d').drawImage(img,0,0,c.width,c.height);
    c.toBlob(function(blob){resolve(blob||file);},'image/webp',0.85);
  }catch(_){resolve(file);}};
  img.onerror=function(){resolve(file);};
  img.src=URL.createObjectURL(file);
}catch(_){resolve(file);}});}
async function uploadFile(file){
var animated=await fileIsAnimatedWebp(file);
/* Animated webps must NOT pass through the canvas resize — that flattens them
   to a single still. Keep the ORIGINAL as the full image so the motion
   survives, and build a flat first-frame poster for the light grid thumb.
   Static images keep the original resize path unchanged. */
var full=animated?file:await resizeImage(file,800);
var thumb=animated?await makeStaticPoster(file,400):await resizeImage(file,400);
var baseName=Date.now()+'_'+Math.random().toString(36).substr(2,6);
var fullName=baseName+'.webp';
var thumbName=baseName+'_thumb.webp';
var up1=await supabase.storage.from('portraits').upload(fullName,full,{contentType:'image/webp'});
if(up1.error)return null;
var up2=await supabase.storage.from('portraits').upload(thumbName,thumb,{contentType:'image/webp'});
var fullUrl=supabase.storage.from('portraits').getPublicUrl(fullName).data.publicUrl;
var thumbUrl=up2.error?fullUrl:supabase.storage.from('portraits').getPublicUrl(thumbName).data.publicUrl;
return {full:fullUrl,thumb:thumbUrl,animated:animated};
}

/* Debug: render the success/letter view immediately. Also grants the
 submission heart bonus so the hearts pill advances past "Summon a
 hero" and we can iterate on Phase 3/4 (Want more hearts? + timer)
 without a real submission. Skips the daily-submit lock and the
 my-characters registration so the form stays usable for repeated
 testing. */
window.hohDebugSuccessView=function(){
 var ember=allCharacters.find(function(c){return c.name&&c.name.toLowerCase()==='ember';});
 var debugId=ember?ember.id:('debug-jangela-'+Date.now());
 /* Jangela debug signs in as the real fondlyframed@gmail.com / 1592
    so god-mode actions hit the server with valid credentials. */
 var debugEmail='fondlyframed@gmail.com';
 var debugPin='1592';
 hohGrantHeartsBonus();
 hohUpdateHeartCounter();
 try{hohMarkSubmittedToday();}catch(e){}
 try{if(window.hohYourHallSetSession)window.hohYourHallSetSession(debugEmail,debugPin);}catch(e){}
 try{if(window.hohYourHallSetName)window.hohYourHallSetName('Jangela');}catch(e){}
 /* R50: set the persistent debug flag so god mode survives the
    character-data load that re-overwrites the display name from
    "Jangela" back to whatever the most-recent submitted hero\'s
    player_name happens to be. The flag + email check together gate
    god mode in hohIsGodMode. */
 try{if(window.hohYourHallSetGodModeFlag)window.hohYourHallSetGodModeFlag(true);}catch(e){}
 /* DEBUG: flip ALL daily quest flags locally so the ticket pill
    + Daily Raffle modal both show 4/4 and the all-quests reward
    fires. We deliberately AVOID calling hohOnSubmissionTicket
    here — that helper triggers hohFetchRaffleState, which would
    hit the server and overwrite our local flags with whatever
    server state Jangela actually has (no submission rows). The
    debug mode is meant to feel like a real completion locally
    without persisting anything server-side. */
 try{
  var ymd=new Date().toISOString().slice(0,10);
  try{localStorage.setItem('hoh-daily-tinder-'+ymd,'1');}catch(_){}
  if(window.hohTicketState){
   window.hohTicketState.submitted_today=true;
   window.hohTicketState.tinder_today=true;
   window.hohTicketState.tickets_today=Math.max(window.hohTicketState.tickets_today||0,4);
   window.hohTicketState.tickets_today_max=4;
  }
  /* Replicate hohOnSubmissionTicket's visual side effects (pill
     re-render + ticket celebration) WITHOUT the server fetch. */
  if(typeof window.hohRenderHeaderCounter==='function')window.hohRenderHeaderCounter();
  if(typeof window.celebrateTicketEarned==='function'){ try { window.celebrateTicketEarned(); } catch(_){} }
  /* Trigger the 4/4 reward immediately (gated by date key so it
     only fires once per day). */
  if(typeof window.hohMaybeFireAllTicketsReward==='function')window.hohMaybeFireAllTicketsReward();
 }catch(_){}
 try{if(window.hohRefreshYhToggle)window.hohRefreshYhToggle();}catch(e){}
 try{
 if(!allCharacters.find(function(c){return c.id===debugId;})){
  var fakeChar=ember?Object.assign({},ember,{auth_email:debugEmail,player_name:'Jangela'}):{
  id:debugId,name:'Jangela',race:'Human',character_class:'Fighter',
  hearts:0,tickets:12,is_ff_portrait:true,ff_bonus_granted:true,
  auth_email:debugEmail,player_name:'Jangela',created_at:new Date().toISOString()
  };
  allCharacters.unshift(fakeChar);
 }
 }catch(e){}
 var hohDbgBtn=document.getElementById('hoh-f-debug-btn');
 if(hohDbgBtn&&typeof hohFlyHeartsToPill==='function')hohFlyHeartsToPill(hohDbgBtn,HOH_HEART_BONUS);
 setTimeout(function(){if(typeof hohRefillHeartsAnimation==='function')hohRefillHeartsAnimation(HOH_HEART_BONUS,true);},320);
 showSuccessView('Jangela',debugId);
};
window.hohSubmitCharacter=async function(){
 var btn=document.getElementById('hoh-submit-btn');
 var questSubmit=hohQuestHandoff;
 if(questSubmit){
  if(questSubmit.busy||questSubmit.completed)return;
  for(var qs=1;qs<=6;qs++){if(hohWizMissing(qs).length){hohWizGo(qs,true);return;}}
  if(!hohQuestPinOk(hohQuestPin())){hohQuestNotice('Enter a 4 digit Hall PIN. Use your existing PIN if you already have one.');return;}
  if(questSubmit.draft.debug){questSubmit.completed=true;hohQuestSuccess({name:hohWizVal('hoh-f-name')},true);return;}
  questSubmit.busy=true;
 }
 var isEdit=!!window.hohEditingCharacterId;
 // Edit mode skips the daily cooldown and grants no bonus hearts.
 if(!isEdit&&!questSubmit&&!window.hohPortalCard&&hohHasSubmittedToday()){
 btn.disabled=true;
 btn.textContent='One Hero per Day \u00b7 Come Back Tomorrow';
 btn.classList.add('hoh-btn-cooldown');
 var notice=document.getElementById('hoh-submit-cooldown');
 if(notice)notice.style.display='block';
 return;
 }
 /* R268: FF-commission confirm GATE. If the "I commissioned this from
    FramedFantasy" box is checked and they have NOT confirmed it this session,
    PAUSE the submit and pop the confirm modal (which now sits above this form
    via z-index). The modal's "Yes, I commissioned it" sets __hohFfConfirmed and
    re-calls this submit so it passes; "Nevermind" unchecks the box. Editing an
    already-FF hero pre-sets the flag (see the edit populate) so it never nags on
    a normal save. This is the sole gate — the old on-check auto-popup is gone. */
 var _ffChkGate=document.getElementById('hoh-f-ff-portrait');
 if(_ffChkGate && _ffChkGate.checked && !window.__hohFfConfirmed){
   if(questSubmit)questSubmit.busy=false;
   if(typeof window.hohFfConfirmShow==='function'){ try{ window.hohFfConfirmShow(); }catch(_){} }
   return;
 }
 // Edit mode requires Your Hall sign-in (PIN-based ownership check).
 // R127-C: God-mode bypass mirrors hohOpenEditForm's gate. Without
 // this, Jangela could OPEN the edit form for a non-owned hero
 // (because hohOpenEditForm allowed it) but the Save Changes click
 // here would fail the same ownership check and early-return —
 // result was the symptom the user reported: "click save changes,
 // nothing happens, image is the exact same." Two checks need to
 // agree on the god-mode escape hatch.
 var isGodSave=(typeof window.hohIsGodMode==='function')&&window.hohIsGodMode();
 if(!isGodSave&&isEdit&&window.hohYourHallCanEditCharacter){
 var ec=allCharacters.find(function(x){return x.id===window.hohEditingCharacterId;});
 if(!window.hohYourHallCanEditCharacter(ec)){
 btn.disabled=true;btn.textContent='Sign in to edit';
 hohShowHeartToast('Sign in required','Open Your Hall and sign in to edit your hero.');
 return;
 }
 }
 btn.disabled=true;btn.textContent=isEdit?'Saving...':'Entering the Hall...';
 try{
 if(questSubmit)await window.FFQuestHall.authorize(supabase,questSubmit.draft,hohQuestPin());
 var rv=document.getElementById('hoh-f-race').value;if(rv==='Other')rv=document.getElementById('hoh-f-custom-race').value.trim()||'Other';
 var cv=document.getElementById('hoh-f-class').value;if(cv==='Other')cv=document.getElementById('hoh-f-custom-class').value.trim()||'Other';
 var urls=questSubmit?[selectedFiles[0]==='keep'?questSubmit.hero.image_url||null:null,selectedFiles[1]==='keep'?questSubmit.hero.image_url_2||null:null]:[null,null];
var thumbs=questSubmit?[selectedFiles[0]==='keep'?questSubmit.hero.image_thumb_url||null:null,selectedFiles[1]==='keep'?questSubmit.hero.image_thumb_url_2||null:null]:[null,null];
var animFlags=[false,false];
for(var i=0;i<2;i++){
if(selectedFiles[i]&&selectedFiles[i]!=='keep'){
 var uploaded=await uploadFile(selectedFiles[i]);
 if(uploaded){urls[i]=uploaded.full;thumbs[i]=uploaded.thumb;animFlags[i]=!!uploaded.animated;}
 /* R318: a failed portrait upload used to fall through SILENTLY — the hero
    entered the Hall portraitless while the submitter saw a full success
    screen. Fail loudly; the catch below re-enables the form untouched. */
 else throw new Error('Your portrait could not be uploaded, so nothing was submitted. Check the image file and try again.');
}
}
 if(questSubmit&&hohQuestHandoff!==questSubmit)return;
 var charName=document.getElementById('hoh-f-name').value.trim();
 var playerName=document.getElementById('hoh-f-player').value.trim();
 var submitterEmail=document.getElementById('hoh-f-email').value.trim();
 /* R166: PROFILE CONSISTENCY GUARANTEE (Layer 1).
    =================================================
    Bug: a stale display name in localStorage (set by loadCharacters
    from the MOST RECENT character — see hoh-your-hall.js) was getting
    silently prefilled into the HIDDEN player_name field when signed-in
    users opened the submit form. They couldn't see it, the submit
    handler read it verbatim, and every new character got the stale
    name attached — even though their email was correct. Result: a
    single user's characters showed bylines from someone else (the
    name that happened to be cached). A user reported this with the
    exact symptom: "they all say submitted by Eldest, and I can edit
    them but they don't show up as my created in my hall."
    Fix: for SIGNED-IN, NEW (non-edit) submissions, ignore whatever
    happens to be in the form field and instead derive the canonical
    player_name from the user's OWN earliest character. Email is the
    identity key (matches what the user said: "if the email matches
    on a character, it needs to all save to the same profile"). Once
    a user submits their first character as "Alex", every subsequent
    submission MUST also be "Alex" — the form's hidden value cannot
    override that.
    God-mode bypass: Jangela can submit characters under arbitrary
    names for testing, so the canonicalization is skipped when
    hohIsGodMode is true. Anonymous (signed-out) submissions are
    also skipped — they have no identity to canonicalize against. */
 if(!isEdit && !isGodSave && !questSubmit){
   try {
     var sessionEmail = (typeof window.hohYourHallEmail === 'function')
       ? String(window.hohYourHallEmail() || '').trim().toLowerCase()
       : '';
     /* Only canonicalize when the submitter is signed-in (has a session
        email) AND the form's email matches it. If the user typed a
        different email manually for some reason, respect their input. */
     if(sessionEmail && submitterEmail.toLowerCase() === sessionEmail){
       var poolForCanon = (typeof window.hohGetAllCharacters === 'function')
         ? (window.hohGetAllCharacters() || []) : [];
       var mine = poolForCanon.filter(function(ch){
         if(!ch || !ch.email) return false;
         return String(ch.email).trim().toLowerCase() === sessionEmail;
       });
       if(mine.length){
         /* Earliest first — the FIRST name they chose is the canonical
            one. If a stale "Eldest" snuck in on a later submission,
            that one loses to the original. */
         mine.sort(function(a, b){
           var ta = a && a.created_at ? new Date(a.created_at).getTime() : Infinity;
           var tb = b && b.created_at ? new Date(b.created_at).getTime() : Infinity;
           return ta - tb;
         });
         for(var ci = 0; ci < mine.length; ci++){
           var canonName = mine[ci] && mine[ci].player_name
             ? String(mine[ci].player_name).trim() : '';
           if(canonName){
             if(canonName !== playerName){
               try { console.info('[ProfileConsistency] Overriding form player_name "' + playerName + '" with canonical "' + canonName + '" for ' + sessionEmail); } catch(_){}
             }
             playerName = canonName;
             /* Heal the cached display name too so the next form open
                shows the truth. */
             try {
               if(typeof window.hohYourHallSetName === 'function'){
                 window.hohYourHallSetName(canonName);
               }
             } catch(_){}
             break;
           }
         }
       }
     }
   } catch(_){}
 }
 var charLevel=parseInt(document.getElementById('hoh-f-level').value)||null;
 var campaignName=document.getElementById('hoh-f-campaign').value.trim()||null;
 var charStory=document.getElementById('hoh-f-story').value.trim();
 var ffChk=document.getElementById('hoh-f-ff-portrait');var isFFPortrait=ffChk?ffChk.checked:false;
 var smsChkEl=document.getElementById('hoh-f-sms-optin');
 var smsOptin=smsChkEl?smsChkEl.checked:false;
 var phoneRaw=(document.getElementById('hoh-f-phone')||{}).value||'';
 /* Quality gate. Catches gibberish placeholder text before any DB write
  so Hall stories stay readable. New character submissions only — edits
  skip this since the character is already approved. */
 /* R795b: the short wizard has no story step; the hero page fills the story */
 if(!isEdit&&!HOH_WIZ.short){
 var qc=hohStoryQuality(charStory);
 if(!qc.ok){
  var errEl=document.getElementById('hoh-f-story-error');
  if(errEl){errEl.textContent=qc.message;errEl.style.display='block';}
  /* R424: the story lives on step 3. Without this jump the wizard is still
     showing step 5, scrollIntoView on a hidden element does nothing at all,
     and the submit button just re-enables with no visible reason why. */
  try{ if(window.hohWizRevealField) window.hohWizRevealField('hoh-f-story'); }catch(_){}
  var storyEl=document.getElementById('hoh-f-story');
  if(storyEl){storyEl.classList.add('hoh-input-error');storyEl.scrollIntoView({behavior:'smooth',block:'center'});}
  btn.disabled=false;btn.textContent='Submit to the Hall of Heroes';
  return;
 }
 }
 /* SMS opt-in must have a valid phone if the box is checked. */
 if(smsOptin&&!hohValidPhone(phoneRaw)){
 var pErr=document.getElementById('hoh-f-phone-error');
 if(pErr){pErr.textContent='Add a valid phone number, or uncheck the text-me box.';pErr.style.display='block';}
 try{ if(window.hohWizRevealField) window.hohWizRevealField('hoh-f-phone'); }catch(_){}
 var phoneEl=document.getElementById('hoh-f-phone');
 if(phoneEl){phoneEl.classList.add('hoh-input-error');phoneEl.scrollIntoView({behavior:'smooth',block:'center'});}
 btn.disabled=false;btn.textContent=isEdit?'Save Changes':'Submit to the Hall of Heroes';
 return;
 }
 var normalizedPhone=phoneRaw?hohNormalizePhone(phoneRaw):'';
 var npcGoal=(document.getElementById('hoh-f-npc-goal')||{}).value||'';
 var npcWeakness=(document.getElementById('hoh-f-npc-weakness')||{}).value||'';
 var npcHabit=(document.getElementById('hoh-f-npc-habit')||{}).value||'';
 var npcCatchphrase=(document.getElementById('hoh-f-npc-catchphrase')||{}).value||'';
 var npcSecret=(document.getElementById('hoh-f-npc-secret')||{}).value||'';
 var npcEnemy=(document.getElementById('hoh-f-npc-enemy')||{}).value||'';
 if(isEdit){
 // Build an update payload. Only include image fields when the user uploaded new files.
 var existing=allCharacters.find(function(ch){return ch.id===window.hohEditingCharacterId;});
 /* R168: hidden heroes are not in the visible list, so fetch the row when an
    owner edits one. Lets the ff_bonus, phone, sms, and the quest auto-unhide
    logic below read its real current state. */
 if(!existing){ try{ var _exr=await supabase.from('characters').select(HOH_CHAR_COLS).eq('id',window.hohEditingCharacterId).limit(1); if(_exr && _exr.data && _exr.data[0]) existing=_exr.data[0]; }catch(_){} }
 /* PLAYTESTER 2026-10-04: an edit writes the Level box to dnd_level (the D&D
    level every surface shows) and leaves level, the Hall XP level that
    grant_character_xp owns, alone. A changed level is kept to 1 to 20; an
    unchanged one is sent back as it was, and an empty box clears it. A new
    submission still writes level as before. */
 var _dlWas=parseInt(existing&&existing.dnd_level,10)||null;
 var dndLevel=charLevel>=1?(charLevel===_dlWas?_dlWas:Math.min(20,charLevel)):null;
 var updatePayload={
  name:charName,race:rv,character_class:cv,dnd_level:dndLevel,campaign:campaignName,
  player_name:playerName,email:submitterEmail,story:charStory,
  is_ff_portrait:isFFPortrait,
  npc_current_goal:npcGoal.trim()||null,
  npc_hidden_weakness:npcWeakness.trim()||null,
  npc_habit:npcHabit.trim()||null,
  npc_catchphrase:npcCatchphrase.trim()||null,
  npc_secret:npcSecret.trim()||null,
  npc_enemy:npcEnemy.trim()||null
 };
 /* ⛔ R574: MERGED onto whatever the row already holds, never rebuilt. An
    update payload replaces the column outright, and card_meta also carries the
    AI's title, epithet, source, model and updated_at. Only included when
    something on the card step actually changed, so an ordinary edit that never
    opened that step cannot touch it at all. */
 try{
  var _cmU = hohCardStepMeta((existing && existing.card_meta) || null);
  if(_cmU) updatePayload.card_meta = _cmU;
 }catch(_){ }
 /* R140-Z3p: Update stats_block on edit. If the user opened the
    stats panel and filled it, write it; if they had stats before
    and now have nothing meaningful, NULL it. */
 try {
   if(typeof _hohNpcStatsReader === 'function'){
     var statsBlockEdit = _hohNpcStatsReader();
     updatePayload.stats_block = statsBlockEdit; /* may be null — intentional */
   }
 } catch(_){}
 updatePayload.npc_card=null;
 // First-time FF toggle on edit grants +10 (no claw-back if unchecked).
 if(isFFPortrait&&existing&&!existing.ff_bonus_granted){updatePayload.tickets=(existing.tickets||1)+10;updatePayload.ff_bonus_granted=true;
  /* R234: a hero just became an FF portrait — generate its card text so
     the first pack pull already reads finished. Fired on a delay so the
     save above lands first (the worker checks is_ff_portrait). Fire and
     forget; the Shop inspector lazy-generates as a fallback anyway. */
  try{ (function(cid){ setTimeout(function(){
    /* R569: card text is a quest-ai job now, not a gift-cards one. */
    try{ fetch('https://quest-ai.fondlyframed.workers.dev/card-text',{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({character_id:cid})}).catch(function(){}); }catch(_){}
  }, 6000); })(window.hohEditingCharacterId); }catch(_){}
 }
 /* One-time completion tickets (+1 NPC details, +1 stat block). Latched in
    quest_meta so each awards once per character and cannot be farmed. The
    count rides on this same server save, so a failed save never pays. */
 window.__hohCompletionAward = null;
 try {
   var _qmC = {}; try{ _qmC = Object.assign({}, updatePayload.quest_meta || (existing && existing.quest_meta) || {}); }catch(_){}
   var _award = 0; var _awardWhat = [];
   var _npcVals = { npc_current_goal:npcGoal, npc_hidden_weakness:npcWeakness, npc_habit:npcHabit, npc_catchphrase:npcCatchphrase, npc_secret:npcSecret, npc_enemy:npcEnemy };
   if(!_qmC.npcTicketGranted && _hohNpcFieldsComplete(_npcVals)){ _qmC.npcTicketGranted = true; _award++; _awardWhat.push('NPC details'); }
   if(!_qmC.statsTicketGranted && _hohStatsComplete(updatePayload.stats_block)){ _qmC.statsTicketGranted = true; _award++; _awardWhat.push('the stat block'); }
   if(_award > 0){
     var _curT = (updatePayload.tickets != null) ? updatePayload.tickets : ((existing && existing.tickets) || 1);
     updatePayload.tickets = _curT + _award;
     updatePayload.quest_meta = _qmC;
     window.__hohCompletionAward = { n:_award, what:_awardWhat };
   }
 } catch(_){ window.__hohCompletionAward = null; }
 if(urls[0]){updatePayload.image_url=urls[0];updatePayload.image_thumb_url=thumbs[0];}
 if(urls[1]){updatePayload.image_url_2=urls[1];updatePayload.image_thumb_url_2=thumbs[1];}
 /* A replacement image owns a new reframe. Carry its preview position and zoom
    into the same row update instead of leaving the prior image's crop behind. */
 try{
  if(urls[0]){
   updatePayload.image_offset_y=window.hohGetImageOffsetY('__hoh_new_primary','primary');
   updatePayload.image_offset_x=window.hohGetImageOffsetX('__hoh_new_primary','primary');
   updatePayload.image_zoom=window.hohGetImageZoom('__hoh_new_primary','primary');
  }
  if(urls[1]){
   updatePayload.image_offset_y_2=window.hohGetImageOffsetY('__hoh_new_secondary','secondary');
   updatePayload.image_offset_x_2=window.hohGetImageOffsetX('__hoh_new_secondary','secondary');
   updatePayload.image_zoom_2=window.hohGetImageZoom('__hoh_new_secondary','secondary');
  }
 }catch(_){}
 /* R130: In EDIT mode, Save Changes does NOT touch image_offset_y.
    The dedicated Save Reframe button under the portrait is now the
    SOLE owner of offset persistence (writes localStorage, server,
    cache, and force-repaints all surfaces). Including the offset
    here was causing a revert after Save Reframe — somewhere in the
    post-save pipeline (server response, RLS strip, schema-tolerance
    retry, or cache replace) the offset value was getting lost
    between Save Reframe and Save Changes. By isolating the two
    saves entirely, Save Changes can no longer revert the offset
    because it never sends one. New-hero submissions still capture
    the offset further below in the insertPayload branch (line
    ~6022) via the __hoh_new_primary temp id, which the upload
    preview drag-handler writes. */
 /* R140-Z3p: SMS edit handling expanded. Three cases now covered:
      A. First-time opt-in (no phone before, user added one + checked)
         → persist phone + opt-in, sync to Klaviyo.
      B. Toggling SMS opt-in on an existing phone (had phone, was
         opted in/out, user changed the box) → persist new opt-in
         state + sync to Klaviyo so subscription status is current.
      C. No change → no sync, no DB write.
    The existing behavior only handled (A); (B) silently dropped
    changes so a user re-opting in or opting out via edit had no
    effect on their Klaviyo subscription state. */
 var existingPhoneOnEdit = existing && existing.phone_number ? String(existing.phone_number).trim() : '';
 var existingSmsOptinOnEdit = !!(existing && existing.sms_opt_in);
 var addedSmsOnEdit = false;
 var smsOptinChangedOnEdit = false;
 if(!existingPhoneOnEdit && smsOptin && normalizedPhone){
  /* Case A — first-time opt-in. */
  updatePayload.phone_number = normalizedPhone;
  updatePayload.sms_opt_in = true;
  addedSmsOnEdit = true;
 } else if(existingPhoneOnEdit && smsOptin !== existingSmsOptinOnEdit){
  /* Case B — toggled opt-in on an existing phone. */
  updatePayload.sms_opt_in = !!smsOptin;
  smsOptinChangedOnEdit = true;
 }
 /* R245 (supersedes the R168 auto-unhide): a hidden hero that just gained
    its FIRST image goes BACK INTO THE APPROVAL POOL — still hidden, stamped
    pending — instead of self-publishing past review. The reviewer is the
    only door to the public Hall. Owner saves only; admin-hidden heroes stay
    put; a previously rejected hero re-enters the queue with its strike kept.
    Merges ON TOP of any quest_meta this save already staged (completion
    ticket latches above), so nothing gets clobbered. */
 try{
  var _eqm = (existing && existing.quest_meta) ? existing.quest_meta : null;
  /* ⛔ R664 (Jan): "if the user goes back and updates the image it goes back
     into my queued pile where the quest characters go and i can approve it
     again to go back into the hall."
     Two conditions above refused exactly that and both are lifted here.
       (a) `!existing.image_url` fired only on a hero's FIRST image, so a hero
           Jan rejected — which by definition HAS a picture — could have it
           replaced ten times and never return to the queue. The test is now
           that the image CHANGED, which covers the first one and every
           replacement after it.
       (b) `admin_hidden` blocked hand-hidden heroes outright. R168 added that
           so an owner edit could never resurrect a hero Jan hid, and that fear
           does not apply to what happens here: `is_hidden` stays TRUE on the
           line below, so a new picture buys a hero a second LOOK and never a
           way onto the public Hall. Jan remains the only door.
     Owner saves only. A god save still writes exactly what Jan typed. */
  var _imgWas = (existing && existing.image_url) || '';
  var _imgNow = urls[0] || '';
  if(!isGodSave && existing && existing.is_hidden === true && _imgNow && _imgNow !== _imgWas){
   var _qmRe={}; try{ _qmRe=Object.assign({}, _eqm||{}, updatePayload.quest_meta||{}); }catch(_){}
   _qmRe.review_state='pending';
   /* OWNHIDDEN: when the new picture arrived, so Jan's queue (HIDDEN-OWNER-01) puts a returning hero at the top
      instead of behind every newer hero, and the owner's note can say it is waiting. Jan's note stays for Jan. */
   _qmRe.resubmitted_at=new Date().toISOString();
   /* The strike count RIDES ALONG unchanged. A hero on its second strike is
      still on its second strike when it comes back, so the review tool's
      delete-on-next-reject rule keeps its memory. */
   updatePayload.quest_meta=_qmRe;
   updatePayload.is_hidden = true;
  }
 }catch(_){}
 var editRes=await supabase.from('characters').update(updatePayload).eq('id',window.hohEditingCharacterId).select(HOH_CHAR_COLS);
 /* R45 schema-tolerance: if the image_offset_y columns don\'t exist
    yet on the characters table, Supabase rejects the whole update
    with a "column does not exist" or PGRST204 schema error. Strip
    the offset keys and retry once so the rest of the edit still
    saves. The user can run the SQL migration documented above to
    enable server-side persistence. */
 if(editRes.error && /image_(?:offset_y|zoom)/i.test(editRes.error.message || '')){
   /* R113-F: Loud warning so we KNOW the columns are missing. Without
      this, the strip-and-retry was silent — the editor saw their crop
      via localStorage but every other visitor saw the default. Now the
      console screams so the migration gets applied. SQL fix lives at
      sql/R113-image-offset-columns.sql. */
   try {
     console.error(
       '[ImageOffset] characters.image_offset_y columns missing on the server. ' +
       'Crop changes will NOT propagate to other visitors until the migration runs. ' +
       'Apply sql/R113-image-offset-columns.sql in Supabase SQL Editor.',
       editRes.error
     );
   } catch(_){}
   delete updatePayload.image_offset_y;
   delete updatePayload.image_offset_y_2;
   delete updatePayload.image_zoom;
   delete updatePayload.image_zoom_2;
   editRes = await supabase.from('characters').update(updatePayload).eq('id',window.hohEditingCharacterId).select(HOH_CHAR_COLS);
 }
 /* R204: persist animated flags in a SEPARATE, isolated write so a missing
    is_animated column can never break the edit (mirrors the offset-x split).
    Only writes flags for slots the user actually replaced this save, and patches
    the local cache so the grid animates immediately without a reload. */
 if(!editRes.error){
   try{
     var _animUpd={};
     if(urls[0]) _animUpd.is_animated=!!animFlags[0];
     if(urls[1]) _animUpd.is_animated_2=!!animFlags[1];
     if(Object.keys(_animUpd).length && window.hohEditingCharacterId){
       supabase.from('characters').update(_animUpd).eq('id',window.hohEditingCharacterId).then(function(){});
       var _ec=(typeof allCharacters!=='undefined'&&allCharacters)?allCharacters.find(function(x){return x&&String(x.id)===String(window.hohEditingCharacterId);}):null;
       if(_ec){ if(urls[0]) _ec.is_animated=!!animFlags[0]; if(urls[1]) _ec.is_animated_2=!!animFlags[1]; }
     }
   }catch(_){}
   /* R267: keep the submitter's display name (player_name) consistent across
      the WHOLE account. When the alias changed on THIS save, rewrite it on
      every OTHER hero that shares this hero's account (auth_email, or the
      submitter email as a fallback) so the Hall shows one name for the person.
      The just-saved hero is excluded (its name already updated, and re-touching
      it would trip the per-hero edit cooldown). Patches the local cache too. */
   try{
     var _acct = existing && (existing.auth_email || existing.email);
     var _prevAlias = existing ? (existing.player_name||'') : '';
     if(_acct && playerName && playerName !== _prevAlias){
       var _acol = (existing && existing.auth_email) ? 'auth_email' : 'email';
       /* Local cache first: show the new name on EVERY hero I submitted right
          away, and collect the sibling ids so the change can go out live. */
       var _sibIds = [];
       try{
         if(typeof allCharacters!=='undefined' && allCharacters){
           allCharacters.forEach(function(c){
             if(c && (String(c.auth_email||'')===String(_acct) || String(c.email||'')===String(_acct))){
               c.player_name = playerName;
               if(String(c.id)!==String(existing.id)) _sibIds.push(c.id);
             }
           });
         }
       }catch(_){}
       /* R272: authoritative, PIN-verified rename across the WHOLE account in one
          atomic call. The R166 canonicalization trigger used to revert any
          player_name UPDATE (it forced the earliest name back on), which is why
          renames never stuck — R272 changes that trigger to fire on INSERT only,
          so this write persists. If the RPC is not deployed we fall back to a
          direct multi-row update, which the same trigger change now also allows. */
       var _pin=''; try{ var _tk=JSON.parse(localStorage.getItem('hoh-your-hall-token')||'null'); _pin=(_tk&&_tk.pin)||''; }catch(_){}
       var _directRename = function(){ try{ supabase.from('characters').update({ player_name: playerName }).eq(_acol, _acct).neq('id', existing.id).then(function(){}, function(){}); }catch(_){} };
       if(_pin && supabase && typeof supabase.rpc==='function'){
         supabase.rpc('rename_player', { p_email: _acct, p_pin: _pin, p_new_name: playerName }).then(function(r){
           if(r && r.error) _directRename();
         }, function(){ _directRename(); });
       } else { _directRename(); }
       /* Live: push each sibling to every other open client so their byline
          updates without a refresh (the edited hero is broadcast below). */
       try{ if(typeof window.hohBroadcastHeroChange==='function'){ _sibIds.forEach(function(sid){ window.hohBroadcastHeroChange(sid); }); } }catch(_){}
     }
   }catch(_){}
 }
 if(editRes.error){
 var em=editRes.error.message||'';
 /* R127-C: In god-mode, RLS will commonly reject UPDATE on heroes
    Jangela doesn't own server-side. The user's intent here is "I
    know I'm not the owner, just let me reframe this card." We log
    the server error so it's diagnosable, then fall through to the
    LOCAL cache pin + render — the new offset shows up on this
    device immediately. Persisting cross-device requires either an
    RLS policy that allows the god-mode email to update any row, or
    a SECURITY DEFINER RPC the client can call. Both are server-side
    follow-ups; the client surface is unblocked here. */
 if(isGodSave){
   try { console.warn('[GodModeEdit] server rejected update; continuing with local-only change.', editRes.error); } catch(_){}
 } else {
   if(em.indexOf('edit_cooldown')!==-1){hohShowHeartToast('This hero was just edited','Each hero can be edited once a day.');}
   else{alert('Could not save. Please try again.');}
   btn.disabled=false;btn.textContent='Save Changes';return;
 }
 }
 // Merge the updated record into our local cache.
 var idx=allCharacters.findIndex(function(ch){return ch.id===window.hohEditingCharacterId;});
 if(idx>=0&&editRes.data&&editRes.data[0])allCharacters[idx]=editRes.data[0];
 /* OWNHIDDEN: an owner's hidden hero is not in allCharacters; its saved row goes back into the owner's list */
 if(editRes.data&&editRes.data[0]){ try{ hohOwnHiddenPatch(editRes.data[0]); }catch(_){} }
 /* R127-C: When the server SELECT comes back empty (RLS filtered)
    but we want the local cache to reflect the user's edit anyway,
    merge updatePayload into the cached row by hand. This is the
    god-mode case — Jangela's update fired, server may or may not
    have persisted, but Jangela's screen needs to look right. We
    only do this when the cache wasn't already replaced above
    (otherwise we'd be writing over the server's authoritative row). */
 if(idx>=0 && allCharacters[idx] && (!editRes.data || !editRes.data[0])){
   try {
     Object.keys(updatePayload).forEach(function(k){
       allCharacters[idx][k] = updatePayload[k];
     });
   } catch(_){}
 }
 /* R265: Save Changes (text/field edits) must NEVER disturb the portrait or
    its framing. The server SELECT we just merged can carry a STALE image or
    offset — a prior Save Reframe / Replace Photo that didn't persist
    server-side (common in god mode under RLS, or a plain timing race) — which
    surfaces as the image "reverting to a previous version" or the reframe
    getting undone the moment an unrelated field is saved. So for any slot the
    user did NOT re-upload in THIS save, re-apply the pre-save image state
    (url, thumb, both offset axes, animated flag) from the cached row we held
    before the round-trip. Covers image_offset_x too, which the R109 block
    below (y-only) never restored. */
 try {
   if(idx>=0 && allCharacters[idx] && existing){
     if(!urls[0]){
       allCharacters[idx].image_url       = existing.image_url;
       allCharacters[idx].image_thumb_url = existing.image_thumb_url;
       allCharacters[idx].image_offset_y  = existing.image_offset_y;
       allCharacters[idx].image_offset_x  = existing.image_offset_x;
       allCharacters[idx].image_zoom      = existing.image_zoom;
       allCharacters[idx].is_animated     = existing.is_animated;
     }
     if(!urls[1]){
       allCharacters[idx].image_url_2       = existing.image_url_2;
       allCharacters[idx].image_thumb_url_2 = existing.image_thumb_url_2;
       allCharacters[idx].image_offset_y_2  = existing.image_offset_y_2;
       allCharacters[idx].image_offset_x_2  = existing.image_offset_x_2;
       allCharacters[idx].image_zoom_2      = existing.image_zoom_2;
       allCharacters[idx].is_animated_2     = existing.is_animated_2;
     }
   }
 } catch(_){}
 var editedId=window.hohEditingCharacterId;
 /* SAVESTICK (Jan, 2026-10-14): a replaced picture's framing went out in this
    update and the server sent the row back, so this device's keys for that
    slot (left from the old picture, e.g. a reframe that never saved) stop
    overriding it here. Without this the new picture showed the old crop on
    this device, and the pass below copied that crop into the row. */
 if(!editRes.error && editRes.data && editRes.data[0]){
  /* The server's row replaced the cached one in place above (same array,
     same length), so the id index (__hohCharById) would keep answering with
     the OLD object, and the pass below would copy the old picture's framing
     into the new row. Rebuild it on the next lookup. */
  __hohCharIdxRef = null;
  try{
   if(urls[0] && ('image_offset_y' in updatePayload)) hohClearLocalFraming(editedId,'primary');
   if(urls[1] && ('image_offset_y_2' in updatePayload)) hohClearLocalFraming(editedId,'secondary');
  }catch(_){}
 }
 /* R109: Belt-and-suspenders pass for image-offset live update.
    The R44 + R79 chain re-fires the event so listeners can repaint
    inline objectPosition. But three subtle failure modes existed:
      1. allCharacters[idx] holds the SERVER row, which may have NULL
         image_offset_y if the column doesn't exist or didn't save.
         Subsequent renders that DON'T hit localStorage first would
         render with the wrong value. Solution: write the localStorage
         offset back into allCharacters[idx] explicitly so EVERY
         render path sees the new value.
      2. hohSmoothGridUpdate REUSES existing DOM nodes for keys that
         survived the rebuild. The reused node's IMG keeps whatever
         inline style it had; the listener event paints it AGAIN, but
         if the listener fires BEFORE the rebuild, the rebuild's
         existing-node logic preserves the painted style. If it fires
         AFTER, same. Either way fine — but only if the listener
         actually picked up the IMG. Safer: dispatch the event AGAIN
         after renderGallery so any freshly-mounted nodes get hit.
      3. The detail modal opens 220ms later and reads via
         hohGetImageOffsetY which reads localStorage first. With (1)
         allCharacters is also correct, so any path is safe. */
 try {
   if(typeof window.hohGetImageOffsetY === 'function' && idx >= 0){
     ['primary','secondary'].forEach(function(s){
       var off = window.hohGetImageOffsetY(editedId, s);
       if(typeof off !== 'number') return;
       /* (1) — pin the value into allCharacters too. */
       try {
         var key = (s === 'secondary') ? 'image_offset_y_2' : 'image_offset_y';
         if(allCharacters[idx]) allCharacters[idx][key] = off;
         if(allCharacters[idx] && typeof window.hohGetImageZoom === 'function') allCharacters[idx][s === 'secondary' ? 'image_zoom_2' : 'image_zoom'] = window.hohGetImageZoom(editedId, s);
       } catch(_){}
       /* Fire the repaint event immediately. */
       try {
         document.dispatchEvent(new CustomEvent('hoh:image-offset-changed', {
           detail: { charId: editedId, slot: s, offset: off }
         }));
       } catch(_){}
     });
   }
 } catch(_){}
 /* R79: The hoh:image-offset-changed event listener (defined above)
    queries .hoh-yh-card[data-hero-id="X"] img selectors so Your Hall
    cards repaint automatically alongside the main gallery. No extra
    Your Hall API call needed — the event-driven path covers it. */
 /* R140-Z3p: Klaviyo sync on edit fires whenever SMS state actually
    changes — first-time add OR toggle on existing phone. The
    Klaviyo helper dedupes on email so re-syncing the same lead is
    safe; we pass the CURRENT opt-in state (true or false) so
    Klaviyo's subscription bit is kept current. */
 var shouldSyncKlaviyo = (addedSmsOnEdit || smsOptinChangedOnEdit) && editRes.data && editRes.data[0];
 if(shouldSyncKlaviyo){
   var syncPhone = normalizedPhone || existingPhoneOnEdit || '';
   try { if(window.syncHohLeadToKlaviyo) window.syncHohLeadToKlaviyo(editRes.data[0], syncPhone, !!smsOptin); } catch(e){ console.error(e); }
   if(addedSmsOnEdit && window.hohYourHallSetPhoneFlag){
     window.hohYourHallSetPhoneFlag(true);
   }
 }
 window.hohEditingCharacterId=null;
 /* R128-F: Direct force-repaint BEFORE renderGallery. If renderGallery's
    FLIP grid reuses existing DOM nodes (the common case for an edit
    where keys survive), this hits the still-mounted IMG with the new
    inline style now, so when reuse happens the new style is ALREADY
    on the node — the FLIP grid doesn't overwrite IMG inline styles,
    it just keeps the node. Belt-and-suspenders since the listener
    should also handle this; doubled to defeat any timing race. */
 try {
   if(typeof window.hohForceImageOffsetRepaint === 'function'){
     window.hohForceImageOffsetRepaint(editedId, 'primary');
     window.hohForceImageOffsetRepaint(editedId, 'secondary');
   }
 } catch(_){}
 renderGallery(editedId);
 /* R265: tell every other open tab to pull this hero's fresh fields/image
    live (no refresh). Only lands what actually persisted server-side. */
 try { if(typeof window.hohBroadcastHeroChange === 'function') window.hohBroadcastHeroChange(editedId); } catch(_){}
 /* R128-F: Force-repaint AGAIN after renderGallery. If FLIP grid created
    fresh IMG nodes, those have correct inline style baked in by
    hohBuildCardHtml. If FLIP grid reused old nodes, the pre-render
    repaint above already hit them. This second pass guarantees both
    code paths converge on the right state. */
 try {
   if(typeof window.hohForceImageOffsetRepaint === 'function'){
     window.hohForceImageOffsetRepaint(editedId, 'primary');
     window.hohForceImageOffsetRepaint(editedId, 'secondary');
   }
 } catch(_){}
 /* R109 (2) — kept for any listeners on the event that aren't covered
    by the direct force-repaint helper. */
 try {
   if(typeof window.hohGetImageOffsetY === 'function'){
     ['primary','secondary'].forEach(function(s){
       var offAfter = window.hohGetImageOffsetY(editedId, s);
       if(typeof offAfter !== 'number') return;
       try {
         document.dispatchEvent(new CustomEvent('hoh:image-offset-changed', {
           detail: { charId: editedId, slot: s, offset: offAfter }
         }));
       } catch(_){}
     });
   }
 } catch(_){}
 hohCloseForm();
 /* Celebrate the one-time ticket award only after its server save succeeds. */
 if(window.__hohCompletionAward && window.__hohCompletionAward.n > 0){
   var _ca = window.__hohCompletionAward; window.__hohCompletionAward = null;
   try { hohShowHeartToast('+'+_ca.n+(_ca.n===1?' ticket earned':' tickets earned'), 'Added to this hero for finishing '+_ca.what.join(' and ')+'.'); }
   catch(_){ hohShowHeartToast('Saved','Your character was updated.'); }
 } else {
   hohShowHeartToast('Saved','Your character was updated.');
 }
 setTimeout(function(){
   hohOpenDetail(editedId);
   /* R128-F: Final force-repaint after detail modal opens, so its IMG
      gets the latest framing. R127-B made the modal use object-fit:
      contain so positioning is mostly irrelevant there, but the helper
      stays correct for any surface the user may have visible behind
      the modal. */
   try {
     if(typeof window.hohForceImageOffsetRepaint === 'function'){
       window.hohForceImageOffsetRepaint(editedId, 'primary');
       window.hohForceImageOffsetRepaint(editedId, 'secondary');
     }
   } catch(_){}
   try {
     if(typeof window.hohGetImageOffsetY === 'function'){
       ['primary','secondary'].forEach(function(s){
         var offD = window.hohGetImageOffsetY(editedId, s);
         if(typeof offD !== 'number') return;
         try {
           document.dispatchEvent(new CustomEvent('hoh:image-offset-changed', {
             detail: { charId: editedId, slot: s, offset: offD }
           }));
         } catch(_){}
       });
     }
   } catch(_){}
 },220);
 return;
 }
 // Insert flow (new character).
 /* R271: heroes added through "+ Add Your Hero" in the Hall now go STRAIGHT to
    the grid. The old gate (hohStoryAutoHide hides anything under 200 chars / 35
    words / 2 real sentences) pushed most casual submissions into the keeper's
    approval pool, which is exactly why new portraits stopped appearing in the
    Hall. ONLY Character Quest heroes go through review now — the quest inserts
    its own rows with is_hidden:true + review_state:'pending' (character-quest.js),
    and that path is deliberately left untouched. */
 var _autoHidden = false;
 var insertPayload={
  name:charName,race:rv,character_class:cv,level:charLevel,campaign:campaignName,
  player_name:playerName,email:submitterEmail,story:charStory,
  image_url:urls[0],image_url_2:urls[1],
image_thumb_url:thumbs[0],image_thumb_url_2:thumbs[1],hearts:100,featured:false,
  is_ff_portrait:isFFPortrait,
  auth_email:(submitterEmail||'').trim().toLowerCase(),
  tickets:isFFPortrait?11:1,
  /* R230: latch the FF +10 ONLY when the 10 is actually inside the
     starting count (FF submit = 11 = 1 baseline + 10). This used to be a
     hard-coded true for EVERY submit, which (a) marked hundreds of non-FF
     heroes as "FF bonus paid" so the breakdown drew a fictional +10 row,
     and (b) pre-tripped the one-time latch, so a hero marked as a real FF
     portrait LATER never received its +10 — the edit grant above and the
     R230 server trigger both skip when the latch is already set. */
  ff_bonus_granted:!!isFFPortrait,
  /* R271: approve + unhide explicitly so the hero lands in the grid the moment
     they finish. The Hall grid filters .eq('approved',true) AND drops hidden
     rows; .eq excludes NULL, so leaving these to the column default risked a
     brand new hero never showing at all. The quest path sets these explicitly
     too (approved:true, is_hidden:true) — this is the Hall's mirror of that. */
  approved:true,
  is_hidden:false
 };
 /* R574: the words and the credit from the card step. Nothing is written when
    they left it all blank, so the AI backfill can still write that card later. */
 try{ var _cm = hohCardStepMeta(questSubmit?questSubmit.hero.card_meta:null); if(_cm) insertPayload.card_meta = _cm; }catch(_){ }
 if(npcGoal.trim())insertPayload.npc_current_goal=npcGoal.trim();
 if(npcWeakness.trim())insertPayload.npc_hidden_weakness=npcWeakness.trim();
 if(npcHabit.trim())insertPayload.npc_habit=npcHabit.trim();
 if(npcCatchphrase.trim())insertPayload.npc_catchphrase=npcCatchphrase.trim();
 if(npcSecret.trim())insertPayload.npc_secret=npcSecret.trim();
 if(npcEnemy.trim())insertPayload.npc_enemy=npcEnemy.trim();
 /* R140-Z3p: NPC stat block. Only included when the user actually
    opened + filled the stats panel. The reader returns null when the
    form has no meaningful content (defaults still in place), which
    keeps the column NULL for casual submitters. */
 try {
   if(typeof _hohNpcStatsReader === 'function'){
     var statsBlock = _hohNpcStatsReader();
     if(statsBlock) insertPayload.stats_block = statsBlock;
   }
 } catch(_){}
 /* R65: image-offset persistence on NEW submit. The user dragged
    each image after upload; the chosen offset was stashed under a
    temp id (__hoh_new_primary / __hoh_new_secondary). Read it
    back here and add to the insert payload so the crop the user
    picked SAVES to the server and applies for every viewer. */
 /* FITEDITOR (Jan, 2026-10-14): every picture chosen in this form sends all
    three values, centred ones included. Only values that differed from the
    default used to go, so a picture left centred saved nothing and its row
    stayed null. A Quest-kept portrait ('keep') takes the Quest hero's own
    framing below instead. */
 try {
  if(typeof window.hohGetImageOffsetY === 'function'){
   [[0, 'primary', ''], [1, 'secondary', '_2']].forEach(function(p){
    var f = selectedFiles[p[0]];
    if(!f || typeof f === 'string') return;
    var tid = '__hoh_new_' + p[1];
    var fx = window.hohGetImageOffsetX(tid, p[1]), fy = window.hohGetImageOffsetY(tid, p[1]), fz = window.hohGetImageZoom(tid, p[1]);
    insertPayload['image_offset_x' + p[2]] = Math.round(Math.max(0, Math.min(100, typeof fx === 'number' ? fx : 50)));
    insertPayload['image_offset_y' + p[2]] = Math.round(Math.max(0, Math.min(100, typeof fy === 'number' ? fy : 50)));
    insertPayload['image_zoom' + p[2]] = Math.round(Math.max(100, Math.min(200, typeof fz === 'number' ? fz : 100)));
   });
  }
 } catch(_){}
 /* Filled DM sections pay their tickets from the FIRST save, using the same
    completion rules and one-time quest_meta latches as edit mode. Starting
    count: 1 baseline (+10 FF when applicable), +1 complete NPC details, +1
    complete stat block = up to 3 tickets for a new non-FF hero. */
 try{
  var _npcOkS = _hohNpcFieldsComplete({ npc_current_goal:npcGoal, npc_hidden_weakness:npcWeakness, npc_habit:npcHabit, npc_catchphrase:npcCatchphrase, npc_secret:npcSecret, npc_enemy:npcEnemy });
  var _stOkS  = _hohStatsComplete(insertPayload.stats_block);
  var _bonusS = (_npcOkS?1:0) + (_stOkS?1:0);
  if(_bonusS > 0){
   insertPayload.tickets = (insertPayload.tickets!=null?insertPayload.tickets:1) + _bonusS;
   var _qmTk={}; try{ _qmTk=Object.assign({}, insertPayload.quest_meta||{}); }catch(_){}
   if(_npcOkS) _qmTk.npcTicketGranted = true;
   if(_stOkS)  _qmTk.statsTicketGranted = true;
   insertPayload.quest_meta = _qmTk;
   window.__hohCompletionAward = { n:_bonusS, what:[].concat(_npcOkS?['NPC details']:[], _stOkS?['the stat block']:[]) };
  }
 }catch(_){}
 /* R243: .select() with no argument means RETURNING * — under the R233
    column grants that touches the two revoked secret columns and the
    WHOLE insert gets rejected ("Adding New Hero isn't working", both
    paths). Echo only the granted columns. */
 if(questSubmit){
  for(var qi=0;qi<2;qi++){
   insertPayload[qi?'is_animated_2':'is_animated']=selectedFiles[qi]==='keep'?!!questSubmit.hero[qi?'is_animated_2':'is_animated']:!!animFlags[qi];
   if(selectedFiles[qi]==='keep'){
    ['image_offset_y','image_offset_x','image_zoom'].forEach(function(key){var col=key+(qi?'_2':'');if(questSubmit.hero[col]!=null)insertPayload[col]=questSubmit.hero[col];});
   }
  }
  var questHero=await window.FFQuestHall.publish(supabase,questSubmit.draft,insertPayload,hohQuestPin(),HOH_CHAR_COLS);
  questSubmit.completed=true;
  try{hohClearTempFraming();}catch(_){}
  allCharacters=allCharacters.filter(function(c){return c.id!==questHero.id;});allCharacters.unshift(questHero);
  if(window.hohYourHallSetSession)window.hohYourHallSetSession(questSubmit.draft.hero.email,hohQuestPin());
  if(window.hohYourHallSetName)window.hohYourHallSetName(playerName);
  try{if(window.syncHohLeadToKlaviyo)window.syncHohLeadToKlaviyo(questHero,normalizedPhone,smsOptin);}catch(_){}
  try{trackHoHCAPI(questHero);}catch(_){}
  try{renderGallery(questHero.id);document.dispatchEvent(new CustomEvent('hoh:characters-loaded'));}catch(_){}
  window.__hohCompletionAward=null;
  hohQuestSuccess(questHero,false);return;
 }
 var{data,error}=await supabase.from('characters').insert([insertPayload]).select(HOH_CHAR_COLS);
 /* R65: schema-tolerance — if the column doesn\'t exist yet, retry
    without the offset fields (mirrors the edit-path fallback). */
 var _framingDropped=false;
 if(error && /image_(?:offset_[xy]|zoom)/i.test(error.message || '')){
  _framingDropped=true;
  delete insertPayload.image_offset_y;
  delete insertPayload.image_offset_y_2;
  delete insertPayload.image_offset_x;
  delete insertPayload.image_offset_x_2;
  delete insertPayload.image_zoom;
  delete insertPayload.image_zoom_2;
  var retry = await supabase.from('characters').insert([insertPayload]).select(HOH_CHAR_COLS);
  data = retry.data;
  error = retry.error;
 }
 if(error){alert('Something went wrong. Please try again.');btn.disabled=false;btn.textContent='Submit to the Hall of Heroes';window.__hohCompletionAward=null;return;}
 /* Announce the ticket bonus only now that both the inserted count and its
    anti-farming latches are real on the character row. */
 try {
   if(window.__hohCompletionAward && window.__hohCompletionAward.n > 0){
     var _caIns = window.__hohCompletionAward; window.__hohCompletionAward = null;
     try { hohShowHeartToast('+'+_caIns.n+(_caIns.n===1?' ticket earned':' tickets earned'), 'Added to this hero for finishing '+_caIns.what.join(' and ')+'.'); } catch(_){}
   }
 } catch(_){}
 /* R204: set animated flags in a SEPARATE write so the insert + its offset
    retry above stay untouched — a missing is_animated column can never affect
    submission or crop saving. Only fires when something is actually animated.
    Patch the returned row so the new card animates immediately on this device. */
 try{
   if(data && data[0] && data[0].id && (animFlags[0] || animFlags[1])){
     data[0].is_animated=!!animFlags[0]; data[0].is_animated_2=!!animFlags[1];
     supabase.from('characters').update({is_animated:!!animFlags[0],is_animated_2:!!animFlags[1]}).eq('id',data[0].id).then(function(){});
   }
 }catch(_){}
 /* R65 / FITEDITOR: the inserted row carries the framing, so the new card
    reads it from the row like every other hero and this device keeps no key
    for it. Only when the retry above had to drop the framing columns does the
    player's crop stay on this device under the new id (X, Y and zoom), so it
    still shows here. Then the temp keys go, so the next hero starts fresh. */
 try {
  if(data && data[0] && data[0].id && typeof window.hohSetImageOffsetY === 'function'){
   var newId = data[0].id;
   if(_framingDropped){
    [[0, 'primary'], [1, 'secondary']].forEach(function(p){
     var f = selectedFiles[p[0]];
     if(!f || typeof f === 'string') return;
     var tid = '__hoh_new_' + p[1];
     window.hohSetImageOffsetX(newId, p[1], window.hohGetImageOffsetX(tid, p[1]));
     window.hohSetImageOffsetY(newId, p[1], window.hohGetImageOffsetY(tid, p[1]));
     window.hohSetImageZoom(newId, p[1], window.hohGetImageZoom(tid, p[1]));
    });
   }
   hohClearTempFraming();
  }
 } catch(_){}
 /* R433: kill the pending debounced write too. Without this, a save
    scheduled by the last keystroke lands 250ms AFTER the submit wiped the
    draft and puts an empty one straight back. */
 try{clearTimeout(hohDraftTimer);}catch(e){}
 try{localStorage.removeItem(HOH_DRAFT_KEY);}catch(e){}
 /* R430 (Jan): a hero you just submitted IS a new card — R422 grants it by
    trigger the moment the row lands — but the grid had no way to know that.
    first_pulled_at only exists for cards that came out of a pack, so a
    submitted hero would have shown up in the collection wearing nothing.
    Marked here, at the one point every successful submission passes, so the
    badge is waiting on the tile by the time the profile grid next paints. */
 try{
   /* data[0].id, not newId: newId is only assigned inside the image-offset
      branch above, which is gated on hohSetImageOffsetY existing. A
      submission with no reframe to save would have left it undefined and the
      badge unset, even though the hero landed fine. This reads the insert's
      own reply, which is true on every successful path. */
   var _newCardId = (data && data[0] && data[0].id) || null;
   if(typeof window.hohShopMarkNewCard==='function' && _newCardId) window.hohShopMarkNewCard(_newCardId);
 }catch(e){}
 if(!window.hohPortalCard)hohMarkSubmittedToday();
 hohGrantHeartsBonus();
 /* Push the +7 submission bonus to the spendable bank so the visible
  counter ticks up immediately. The hohGrantHeartsBonus flag alone
  only counts toward the daily cap calculation, not the actual
  spendable wallet. UNLESS the user already claimed the hidden
  yellow heart (which also added 7 via hohClaimFormHeart) — in
  that case skip to avoid double-grant. */
 if(typeof window.hohAddHeartsToBank==='function' && !hohFormHeartClaimed()){
  window.hohAddHeartsToBank(HOH_HEART_BONUS);
  /* Mark the form-heart key claimed so the secret yellow heart
     also greys out (the user effectively claimed it via submit). */
  try{localStorage.setItem(HOH_FORM_HEART_KEY,hohTodayStr());}catch(e){}
 }
 hohUpdateHeartCounter();
 /* Fly unlocked hearts from Submit button to the pill (detach to body
  so it survives the form-to-success modal swap). */
 var hohSubmitOriginBtn=document.getElementById('hoh-submit-btn');
 if(hohSubmitOriginBtn&&typeof hohFlyHeartsToPill==='function')hohFlyHeartsToPill(hohSubmitOriginBtn,HOH_HEART_BONUS);
 /* Pill pulse + "+N" bubble fires after the hearts have time to arrive. */
 setTimeout(function(){hohRefillHeartsAnimation(HOH_HEART_BONUS,true);},320);
 window.hohPendingBonusFlash=true;
 allCharacters.unshift(data[0]);
 renderGallery(data[0].id);
 window.hohJustSubmittedFreshId=data[0].id;
 try{document.dispatchEvent(new CustomEvent('hoh:characters-loaded'));}catch(e){}
 /* R148-Z41: Auto-sign-in by email immediately after the insert
    resolves — before the PIN branch below, which only fires when
    the user filled the optional PIN field. Owning a row with this
    email is enough identity for the first-timer gate to flip the
    visitor into the signed-in experience (wallet pill, Explore the
    Hall, Three Doors). The PIN flow below still runs when applicable
    and writes the same token with the PIN added on top. setStoredToken
    is idempotent on the email — second write with the same email
    won't re-dispatch the sign-in event. */
 try {
  if(submitterEmail && typeof window.hohYourHallSetEmailOnly === 'function'){
    window.hohYourHallSetEmailOnly(submitterEmail);
  }
 } catch(_){}
 /* Optional 4-digit PIN: hash via set_pin + auto-sign-in.
    R106: If the form PIN field is empty (returning user who didn't
    re-type), fall back to the PIN stored in the local session token.
    Without this fallback, returning users created rows with auth_email
    but no auth_pin_hash. The personal-hall RPC validates each row's
    pin hash via crypt(), so a hashless row got filtered out of the
    user's own hall even though the email matched (the original Cautious
    bug). Reading the token directly from localStorage avoids script-
    load-order issues. */
 /* HALL-GOOGLE-01: back from Google with no hero yet, the session waited for this one (hoh-google-signin.js). It
    becomes the sign-in now; a PIN typed on the form is set through it, on every hero of the account. */
 var _gNewSub=window.hohGoogle?window.hohGoogle.takeNew(submitterEmail):null;
 if(_gNewSub){
  var _gTyped=(document.getElementById('hoh-f-pin')||{}).value||'', _gPinSet=false;
  if(/^\d{4}$/.test(_gTyped)){ try{ _gPinSet=await window.hohGoogle.setPin(submitterEmail,_gNewSub.pin,_gTyped); }catch(_){ } }
  try{ if(window.hohYourHallSetSession) window.hohYourHallSetSession(String(submitterEmail).trim().toLowerCase(),_gPinSet?_gTyped:_gNewSub.pin); }catch(_){}
  try{ var _gName=((document.getElementById('hoh-f-player')||{}).value||'').trim(); if(_gName&&window.hohYourHallSetName) window.hohYourHallSetName(_gName); }catch(_){}
 }
 var pinVal=_gNewSub?'':((document.getElementById('hoh-f-pin')||{}).value||'');
 if(!pinVal&&!_gNewSub){
   try {
     var raw=localStorage.getItem('hoh-your-hall-token');
     if(raw){
       var sessionToken=JSON.parse(raw);
       if(sessionToken && sessionToken.pin && /^\d{4}$/.test(sessionToken.pin)){
         pinVal=sessionToken.pin;
       }
     }
   } catch(_){}
 }
 /* HALL-SIGNIN-03: signed in by Google or an emailed code, the new hero gets the account's own PIN at once (set_pin with
    the session; a session never becomes a PIN), so a PIN sign-in on another device sees it too. */
 if(!pinVal&&!_gNewSub){
  try{
   var _sTok=JSON.parse(localStorage.getItem('hoh-your-hall-token')||'null'), _sEm=String(submitterEmail||'').trim().toLowerCase();
   if(_sTok&&/^g1\.[0-9a-f]{64}$/.test(String(_sTok.pin||''))&&String(_sTok.email||'').trim().toLowerCase()===_sEm)
    await supabase.rpc('set_pin',{user_email:_sEm,old_pin:null,new_pin:_sTok.pin});
  }catch(_){}
 }
 if(/^\d{4}$/.test(pinVal)){
 try{
  await supabase.rpc('set_pin',{user_email:(submitterEmail||'').trim().toLowerCase(),old_pin:null,new_pin:pinVal});
  if(window.hohYourHallSetSession)window.hohYourHallSetSession((submitterEmail||'').trim().toLowerCase(),pinVal);
  /* Cache the typed player name so Your Hall reads "[Name]'s Hall"
     on the very next render — without this the hall fell back to the
     email prefix until characters reloaded. */
  try {
   var typedName=(document.getElementById('hoh-f-player')||{}).value||'';
   typedName=typedName.trim();
   if(typedName && window.hohYourHallSetName) window.hohYourHallSetName(typedName);
  } catch(_){}
 }catch(e){console.error('set_pin',e);}
 }
 /* HERO-CARD-01: a hero added from a finished commission is linked to that portrait now, with the sign-in above, so it
    waits for Jan to sign with no studio step (hoh-your-hall.js hohPortalCardLink). The success screen reads the answer. */
 try{if(!isEdit&&data&&data[0]&&window.hohPortalCard&&window.hohPortalCardLink)window.hohPortalCardLink(data[0].id,submitterEmail);}catch(_){}
 /* PORTAL-106: the stamp card hears about the new hero once its owner is signed in, so a FramedFantasy portrait can go to
    Jan for the stamp card when the box under the FramedFantasy tick asked for it (hoh-stamps.js). A portrait from the
    commission page (portal) already has its stamp. */
 try{if(!isEdit&&data&&data[0])document.dispatchEvent(new CustomEvent('hoh:hero-submitted',{detail:{id:data[0].id,ff:!!data[0].is_ff_portrait,email:String(submitterEmail||'').trim().toLowerCase(),portal:!!window.hohPortalCard}}));}catch(_){}
 try{if(window.syncHohLeadToKlaviyo)window.syncHohLeadToKlaviyo(data[0],normalizedPhone,smsOptin);}catch(e){console.error(e);}
 if(smsOptin&&normalizedPhone&&window.hohYourHallSetPhoneFlag)window.hohYourHallSetPhoneFlag(true);
 /* R148-Z17: Skip the submission-ticket grant when this was a paid
    extra submission (user spent 300 hearts to unlock a second-of-the-
    day post). The flag survives from hohPayForExtraSubmission, gets
    consumed here so future first-of-day submissions earn their ticket
    normally. Same +20 heart payout below still fires — only the
    ticket is suppressed, not the heart welcome bonus. */
 var paidExtraSub = (typeof hohExtraSubPaidToday === 'function') && hohExtraSubPaidToday();
 /* R793: submitting no longer grants a raffle ticket. A hero's tickets come
    only from its owner giving one a day on its own page. */
 var _r793Sub = hohR793Live();
 if(paidExtraSub){
  try { if(typeof hohConsumeExtraSubPaid === 'function') hohConsumeExtraSubPaid(); } catch(_){}
 } else if(!_r793Sub) {
  try{if(submitterEmail)supabase.rpc('grant_submission_ticket',{user_email:submitterEmail.toLowerCase(),character_id:data[0].id}).then(function(r){if(r&&r.data&&r.data.granted&&window.hohOnSubmissionTicket)window.hohOnSubmissionTicket();});}catch(e){}
 }
 /* R377 (2026-08-06): submitting a hero also grants their battlegrounds
    card with one free play (a database trigger does the granting). Refresh
    the shop state so the new card is standing in the grid when the player
    looks, instead of waiting for the next full load. */
 try{ if(!isEdit && typeof window.hohShopEnsureState==='function') setTimeout(function(){ try{ window.hohShopEnsureState(true); }catch(_){ } }, 1200); }catch(e){}
 /* R101: +20 hearts on first-time submission. Guarded on !isEdit so
    editing an existing hero doesn't re-grant. The wallet helper also
    fires hoh:hearts-bumped so other surfaces (Fresh Faces, header
    counter) live-update to the new balance. */
 if(!isEdit && typeof window.hohAddHeartsToBank==='function'){
  try { window.hohAddHeartsToBank(20); } catch(_){}
  /* R793: the Hall no longer shows a heart wallet, so it does not announce
     one. The 20 still land (the Battlegrounds spends them until gold). */
  if(!_r793Sub) setTimeout(function(){
   if(typeof window.hohShowHeartToast==='function'){
    try{window.hohShowHeartToast('Thanks for adding your hero','They are in the Hall now.',true);}catch(_){}
   }
  }, 1500);
 }
 /* Auto-favorite the user's OWN submission. This is the only path
    that auto-saves a hero — hearting other people's heroes does NOT
    auto-favorite anymore (per request: only your own characters
    should land in My Favorites by default). */
 try { if(typeof window.hohHallSaveHero==='function') window.hohHallSaveHero(data[0].id,'submit'); } catch(_){}
 try{trackHoHCAPI(data[0]);}catch(e){console.error(e);}
 showSuccessView(charName,data[0].id,_autoHidden);
 }catch(err){
 if(questSubmit){
  hohQuestNotice(err.message||'Could not publish your hero. Please try again.');
  if(/PIN/.test(err.message||'')){
   questSubmit.pinRejected=true;
   var retryPin=document.getElementById('hoh-f-pin');
   if(retryPin){retryPin.closest('.hoh-field').style.display='';hohWizGo(6,true);retryPin.focus();}
  }
  btn.disabled=false;btn.textContent='Submit to the Hall of Heroes';window.__hohCompletionAward=null;return;
 }
 console.error(err);
 /* R318: surface OUR portrait-upload message verbatim; anything else keeps
    the generic line so raw database errors never reach the player. */
 alert((err&&err.message&&String(err.message).indexOf('portrait')>=0)?err.message:'Something went wrong. Please try again.');
 btn.disabled=false;btn.textContent=isEdit?'Save Changes':'Submit to the Hall of Heroes';
 }finally{if(questSubmit)questSubmit.busy=false;}
};
/* R795: arm the post-submit watch as a submit begins (see hohHeroFillHandoff).
   A wrapper, so the submit itself is the same function it was: the submit
   button and the FramedFantasy confirm both call window.hohSubmitCharacter.
   A submit that ends without the handoff (refused, failed, an edit) disarms. */
(function(){
 var _sub=window.hohSubmitCharacter;
 if(typeof _sub!=='function'||_sub.__hohR795) return;
 var wrapped=function(){
  try{ if(!window.hohEditingCharacterId) hohArmSubmitNetWatch(); }catch(_){ }
  var r=_sub.apply(this,arguments);
  var end=function(){ if(!_hohHandoffUrl) hohDisarmSubmitNetWatch(); };
  if(r&&typeof r.then==='function') r.then(end,end); else end();
  return r;
 };
 wrapped.__hohR795=1;
 window.hohSubmitCharacter=wrapped;
})();

var scrollObserver=null;
/* PERF-1 (2026-08-06): the reveal stagger used to run
   document.querySelectorAll('.hoh-card') + indexOf INSIDE the observer
   callback, once per revealed card. With N cards that is N full-document
   queries and N*N/2 comparisons fired from the scroll path, which is the
   single biggest scroll jank source on a big hall. The grid index is now
   stamped ONCE per (re)observe pass and the callback reads the attribute.
   Same stagger math, same delays, no per-reveal query. */
/* R415: the stagger used to hardcode 4 columns on desktop while the gallery
   is 5 wide above 1200px (4, then 3, then 2 as it narrows), so the reveal
   wave was off beat on the widest screens — the fifth card in a row landed
   with the first. Read the real rendered track count off the grid instead,
   cached per viewport width so the observer callback never pays a
   getComputedStyle. Falls back to the old 2/4 heuristic whenever the grid
   is hidden or unparsable. */
var _hohGalColsW=0,_hohGalCols=0;
function _hohGalleryCols(){
 var w=window.innerWidth||0;
 if(_hohGalCols&&_hohGalColsW===w)return _hohGalCols;
 var cols=0;
 try{
  var g=document.getElementById('hoh-gallery');
  if(g&&g.children.length&&g.style.display!=='none'){
   var tpl=window.getComputedStyle(g).gridTemplateColumns||'';
   if(tpl&&tpl!=='none'&&tpl.indexOf('repeat')===-1)cols=tpl.split(' ').length;
  }
 }catch(_){}
 if(!cols)cols=(w<=768)?2:4;
 _hohGalColsW=w;_hohGalCols=cols;
 return cols;
}
/* ⛔ R793.1 fix (measured 2026-09-22, the verifiers' "always-running CSS
   animations" behind the 4x long tasks): every grid tile is
   content-visibility:auto, and a Mythic tile also runs its border shift
   (hohMythicShift) forever. On a tile the browser is SKIPPING (off screen)
   that animation took the tile out of layout and put it back on every
   frame: on a 1,100 hero Hall 128 tiles x 60 frames, about 45ms of layout a
   second at full speed on a Mac, all of it for tiles nobody can see, and it
   ran under the card view and through its move too. The browser says when
   a tile starts and stops being skipped; a skipped tile's animations hold
   still and pick up again the moment it comes back into view, so on screen
   nothing looks any different. Browsers without the event change nothing. */
if(typeof window.ContentVisibilityAutoStateChangeEvent==='function'&&!document.__hohCvPause){
 document.__hohCvPause=true;
 document.addEventListener('contentvisibilityautostatechange',function(e){
  var t=e&&e.target;
  if(t&&t.classList&&t.classList.contains('hoh-card'))t.classList.toggle('hoh-card-cv-skipped',!!e.skipped);
 },true);
}
function observeElements(){if(!scrollObserver)return;var _gal=document.getElementById('hoh-gallery');var _all=document.querySelectorAll('.hoh-card');var _gi=0;for(var _i=0;_i<_all.length;_i++){var _el=_all[_i];var _in=_gal?_gal.contains(_el):false;_el.setAttribute('data-hoh-reveal-idx',_in?String(_gi++):'-1');}document.querySelectorAll('.hoh-card:not(.hoh-visible):not(.hoh-card-new)').forEach(function(el){scrollObserver.observe(el);});}
function setupScrollAnimations(){_hohRevealSetupRan=true;if(!('IntersectionObserver' in window)){document.querySelectorAll('.hoh-card,.hoh-featured,.hoh-spotlight').forEach(function(el){el.classList.add('hoh-visible');});return;}scrollObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){var el=entry.target,idx=parseInt(el.getAttribute('data-hoh-reveal-idx')||'-1',10),mob=window.innerWidth<=768,cols=_hohGalleryCols(),pos=idx>=0?idx%cols:0,delay=pos*(mob?40:50);setTimeout(function(){el.classList.add('hoh-visible');},delay);scrollObserver.unobserve(el);}});},{threshold:0.05,
/* R415: the top margin is huge on purpose. IntersectionObserver only fires on
   status CHANGES sampled per rendered frame, so a fast flick (or an instant
   anchor/scroll-restore jump) can carry a whole row from "below the viewport"
   to "above the viewport" without ever intersecting the bare viewport — no
   event, card stuck invisible, and the user finds a hole when they scroll back
   up. Extending the root 12000px upward makes "at or above the screen" count
   as intersecting, so passed-over rows get their event the moment the jump
   lands. Reveal-on-the-way-down still triggers at the same 60px early line as
   before; the entrance the user actually sees is unchanged. */
rootMargin:'12000px 0px 60px 0px'});observeElements();}

/* R415: back to top arrow. A minimal gold on dark circle, centred along the
   bottom edge (R432), that fades in once the visitor is genuinely deep in the
   page and smooth scrolls home on tap. Injected from JS so the section file
   stays under the 256KB cap and no other template changes.
   Details that matter:
   - passive scroll listener plus one rAF coalesced class toggle per frame, so
     it adds zero scroll latency and zero per scroll layout work;
   - z-index 900: above all page content (max 200), below every modal,
     sheet and overlay (9970 and up), so it can never cover game UI;
   - hidden state also drops pointer-events and tabIndex so it cannot be
     clicked or tabbed to while invisible;
   - honors prefers-reduced-motion (instant jump instead of smooth);
   - env(safe-area-inset-bottom) in the CSS keeps it clear of iOS bars. */
/* R444 (Jan): "dont show this arrow immediately only show it after they
   scroll for a bit down."
   Her sentence has two halves, so the reveal now has two gates.
   1. HOW FAR. It used to wake at a viewport and a half, which is 1350px on a
      900px desktop and 1140px on a phone. That is about four rows of the
      grid, so it turned up while the visitor was still on their first look
      around. Now two and a half screens with a hard 1800px floor, so it
      cannot appear until scrolling back by hand would actually be tedious.
      Pure distance on purpose, with no scaling to page length: a predictable
      line beats a clever one, and a page too short to reach the line is a
      page short enough to flick home without help.
   2. AN ACTUAL SCROLL. The old build revealed it straight out of boot()
      whenever the page opened already scrolled, which happens on a reload
      restore, a hash jump, or the grid rendering late and shifting the
      anchor. The arrow could sit there before the visitor had touched
      anything, which is the literal complaint. It now needs 40px of real
      movement during this page life before it will ever show. 40px rather
      than any movement at all, because browsers fire a scroll event of their
      own while restoring position. Either direction counts, so someone who
      reloads deep and scrolls UP still gets the button on their first
      gesture, which is exactly when a back to top is wanted.
   Resize is wired to the same handler because the threshold is viewport
   relative, so an orientation change has to re evaluate or the state stays
   stale until the next scroll. */
/* HALLFIX (2026-10-29): centred at the foot, it sat on the grid's cards the
   whole way down. It keeps both gates and its place, and only shows while the
   visitor is heading back up (24px of upward scrolling), which is when a way
   home is wanted; 12px of scrolling down puts it away again. */
(function(){
 var btn=null,shown=false,ticking=false,moved=false,startY=null,lastY=null,climb=0,dive=0,rising=false;
 function ensure(){
  if(btn||!document.body)return btn;
  btn=document.createElement('button');
  btn.id='hoh-back-top';
  btn.type='button';
  btn.setAttribute('aria-label','Back to top');
  btn.setAttribute('aria-hidden','true');
  btn.tabIndex=-1;
  btn.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 14.5 12 7.5l7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  btn.addEventListener('click',function(){
   var r=_hohReducedMotion();
   try{window.scrollTo({top:0,behavior:r?'auto':'smooth'});}catch(_){window.scrollTo(0,0);}
   try{btn.blur();}catch(_){}
  });
  document.body.appendChild(btn);
  return btn;
 }
 function deep(){
  var vh=window.innerHeight||document.documentElement.clientHeight||0;
  return Math.max(1800,vh*2.5);
 }
 function update(){
  ticking=false;
  var y=window.pageYOffset||document.documentElement.scrollTop||0;
  if(startY===null)startY=y;
  if(!moved&&Math.abs(y-startY)>40)moved=true;
  if(lastY!==null){
   var dy=y-lastY;
   if(dy<0){ climb-=dy; dive=0; if(climb>24)rising=true; }
   else if(dy>0){ dive+=dy; climb=0; if(dive>12)rising=false; }
  }
  lastY=y;
  var show=moved&&rising&&y>deep();
  if(show===shown)return;
  shown=show;
  var b=ensure();
  if(!b)return;
  b.classList.toggle('hoh-back-top-show',show);
  b.setAttribute('aria-hidden',show?'false':'true');
  b.tabIndex=show?0:-1;
 }
 function onScroll(){
  if(ticking)return;
  ticking=true;
  if(window.requestAnimationFrame)requestAnimationFrame(update);else setTimeout(update,80);
 }
 try{window.addEventListener('scroll',onScroll,{passive:true});}catch(_){window.addEventListener('scroll',onScroll);}
 try{window.addEventListener('resize',onScroll,{passive:true});}catch(_){window.addEventListener('resize',onScroll);}
 function boot(){try{ensure();update();}catch(_){}}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
 else boot();
})();

function wrapCanvasText(ctx,text,x,y,mw,lh,ml){var words=text.split(' '),line='',lines=[];for(var i=0;i<words.length;i++){var t=line+words[i]+' ';if(ctx.measureText(t).width>mw&&line!==''){lines.push(line.trim());line=words[i]+' ';if(lines.length>=ml){lines[lines.length-1]=lines[lines.length-1].slice(0,-1)+'...';break;}}else{line=t;}}if(lines.length<ml&&line.trim())lines.push(line.trim());for(var j=0;j<lines.length;j++)ctx.fillText(lines[j],x,y+(j*lh));return lines.length;}
/* R142: Path-drawn icons for the stat trio. Drawing them as paths
   instead of using unicode glyphs guarantees crisp rendering at every
   zoom level and consistent look across user systems (some don't have
   ticket/star glyph fonts). Each helper draws an icon CENTERED at
   (cx,cy) sized to `size` (icon's bounding box width in px). */
function _hohDrawHeartIcon(ctx, cx, cy, size, color){
  var s = size / 24;
  ctx.save();
  ctx.translate(cx, cy);
  ctx.scale(s, s);
  ctx.fillStyle = color;
  ctx.beginPath();
  /* Classic heart: two arcs meeting at top, point at bottom. Path
     in a 24x24 coordinate system, baseline-balanced. */
  ctx.moveTo(0, 9);
  ctx.bezierCurveTo(-2, 5, -10, 5, -10, -1);
  ctx.bezierCurveTo(-10, -7, -4, -10, 0, -4);
  ctx.bezierCurveTo(4, -10, 10, -7, 10, -1);
  ctx.bezierCurveTo(10, 5, 2, 5, 0, 9);
  ctx.closePath();
  ctx.fill();
  ctx.restore();
}
function _hohDrawTicketIcon(ctx, cx, cy, size, color){
  /* Stylized raffle ticket: rounded rect with two circular notches
     on left + right edges (the classic ticket silhouette). Drawn in
     a 24x16 coordinate system. */
  var s = size / 24;
  ctx.save();
  ctx.translate(cx, cy);
  ctx.scale(s, s);
  ctx.fillStyle = color;
  ctx.beginPath();
  /* Outer rounded rectangle */
  var w = 22, h = 13, r = 2.2;
  ctx.moveTo(-w/2 + r, -h/2);
  ctx.lineTo(w/2 - r, -h/2);
  ctx.quadraticCurveTo(w/2, -h/2, w/2, -h/2 + r);
  ctx.lineTo(w/2, h/2 - r);
  ctx.quadraticCurveTo(w/2, h/2, w/2 - r, h/2);
  ctx.lineTo(-w/2 + r, h/2);
  ctx.quadraticCurveTo(-w/2, h/2, -w/2, h/2 - r);
  ctx.lineTo(-w/2, -h/2 + r);
  ctx.quadraticCurveTo(-w/2, -h/2, -w/2 + r, -h/2);
  ctx.closePath();
  ctx.fill();
  /* Two notches on left + right side (knock out with darker fill so
     they read as the classic ticket silhouette). */
  ctx.globalCompositeOperation = 'destination-out';
  ctx.beginPath();
  ctx.arc(-w/2, 0, 2.6, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.arc(w/2, 0, 2.6, 0, Math.PI * 2);
  ctx.fill();
  ctx.globalCompositeOperation = 'source-over';
  /* Dashed center line for ticket-stub look */
  ctx.strokeStyle = 'rgba(0,0,0,0.18)';
  ctx.lineWidth = 0.9;
  ctx.setLineDash([1.4, 1.4]);
  ctx.beginPath();
  ctx.moveTo(-w/2 + 4, 0);
  ctx.lineTo(w/2 - 4, 0);
  ctx.stroke();
  ctx.setLineDash([]);
  ctx.restore();
}
function _hohDrawStarIcon(ctx, cx, cy, size, color){
  /* 5-point star, point up. Standard golden-ratio proportions. */
  var s = size / 24;
  ctx.save();
  ctx.translate(cx, cy);
  ctx.scale(s, s);
  ctx.fillStyle = color;
  ctx.beginPath();
  var outerR = 11, innerR = 4.6;
  for(var i = 0; i < 10; i++){
    var ang = -Math.PI / 2 + (i * Math.PI) / 5;
    var r = (i % 2 === 0) ? outerR : innerR;
    var px = Math.cos(ang) * r;
    var py = Math.sin(ang) * r;
    if(i === 0) ctx.moveTo(px, py);
    else ctx.lineTo(px, py);
  }
  ctx.closePath();
  ctx.fill();
  ctx.restore();
}
/* R142: Rarity → frame visual treatment. Each tier has its own
   color set, glow strength, and overlay style. The frame is the
   STRONGEST signal of the card's tier on a thumbnail. */
function _hohRarityFrameStyle(tier){
  var t = (tier || 'common').toLowerCase();
  if(t === 'mythic'){
    /* R142-fix: Mythic uses the FF brand palette — pink, purple, cyan,
       green, blue. No gold/yellow on purpose; that's the "premium"
       look (Legendary's territory), not the brand-rainbow look.
       Matches .hoh-card-featured + the mythic CSS treatment so the
       exported card is consistent with the gallery. */
    return {
      stops: [
        { at: 0.00, color: '#ED97FE' },
        { at: 0.22, color: '#b794f4' },
        { at: 0.44, color: '#7ed4ff' },
        { at: 0.66, color: '#7ed49a' },
        { at: 0.88, color: '#a4d8ff' },
        { at: 1.00, color: '#ED97FE' }
      ],
      glow: 'rgba(237,151,254,0.40)',
      glowSize: 16,
      innerStroke: 'rgba(237,151,254,0.35)',
      label: '#f4e6ff',
      pillBg: 'rgba(20,15,30,0.85)',
      pillBorder: 'rgba(237,151,254,0.6)'
    };
  }
  if(t === 'legendary'){
    return {
      stops: [
        { at: 0.00, color: '#c9962a' },
        { at: 0.30, color: '#f2d98e' },
        { at: 0.55, color: '#fff5d4' },
        { at: 0.80, color: '#f2d98e' },
        { at: 1.00, color: '#9a721d' }
      ],
      glow: 'rgba(242,217,142,0.50)',
      glowSize: 22,
      innerStroke: 'rgba(255,245,212,0.55)',
      label: '#fff5d4',
      pillBg: 'rgba(40,28,12,0.82)',
      pillBorder: 'rgba(242,217,142,0.7)'
    };
  }
  if(t === 'epic'){
    return {
      stops: [
        { at: 0.00, color: '#6a3fb8' },
        { at: 0.50, color: '#b794f4' },
        { at: 1.00, color: '#5a2a9a' }
      ],
      glow: 'rgba(183,148,244,0.42)',
      glowSize: 18,
      innerStroke: 'rgba(216,180,254,0.45)',
      label: '#e8d4ff',
      pillBg: 'rgba(28,18,42,0.85)',
      pillBorder: 'rgba(183,148,244,0.7)'
    };
  }
  if(t === 'rare'){
    return {
      stops: [
        { at: 0.00, color: '#5d8fcf' },
        { at: 0.50, color: '#a4d8ff' },
        { at: 1.00, color: '#3b6cab' }
      ],
      glow: 'rgba(164,216,255,0.32)',
      glowSize: 14,
      innerStroke: 'rgba(200,228,255,0.4)',
      label: '#d4e8ff',
      pillBg: 'rgba(14,22,36,0.85)',
      pillBorder: 'rgba(164,216,255,0.65)'
    };
  }
  if(t === 'uncommon'){
    return {
      stops: [
        { at: 0.00, color: '#7d5a2c' },
        { at: 0.50, color: '#c89860' },
        { at: 1.00, color: '#5d3f1f' }
      ],
      glow: 'rgba(200,152,96,0.22)',
      glowSize: 10,
      innerStroke: 'rgba(220,180,130,0.35)',
      label: '#f0d5a8',
      pillBg: 'rgba(28,20,12,0.85)',
      pillBorder: 'rgba(200,152,96,0.6)'
    };
  }
  /* common */
  return {
    stops: [
      { at: 0.00, color: '#5a5466' },
      { at: 0.50, color: '#9a92ae' },
      { at: 1.00, color: '#3e3a48' }
    ],
    glow: 'rgba(160,154,174,0.18)',
    glowSize: 6,
    innerStroke: 'rgba(200,196,212,0.3)',
    label: '#d8d4e2',
    pillBg: 'rgba(16,14,22,0.85)',
    pillBorder: 'rgba(160,154,174,0.55)'
  };
}
/* R142: Format a created_at timestamp as "MAY '26" — month short +
   apostrophe + 2-digit year. Used for the mint-date footer field. */
function _hohFormatMintDate(iso){
  try {
    var d = new Date(iso);
    if(isNaN(d.getTime())) return '';
    var months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    var yy = String(d.getFullYear()).slice(-2);
    return months[d.getMonth()] + " '" + yy;
  } catch(_){ return ''; }
}
/* ====================================================================
   R148-Z1: Character Card export unlocks
   ====================================================================
   Spending 100 hearts permanently unlocks the Character Card export
   for one specific character on the current account. Owners (the
   character's submitter, matched by email) get free unlocks. Once
   unlocked the right is stored server-side in character_card_unlocks
   so it persists across devices for the same email.

   Module exports (all on window for cross-file calls):
     hohCardUnlockedSet    — Set<charId> populated from server
     hohLoadCardUnlocks()  — async fetch on sign-in / page boot
     hohIsCharacterOwner(c) — bool by email compare
     hohIsCardUnlocked(id) — set membership
     hohCardUnlockState(c) — 'free' | 'locked' | 'signed_out'
     hohCardUnlockCost     — constant 100
     hohUnlockCard(c)      — async: RPC -> deduct hearts -> favorite
     hohBuildShareBtnHtml(c) — returns the share-button HTML in the
       right state for the current user

   The favorite side-effect uses the existing hohHallForceSaveHero
   helper so the unlocked hero shows up in Your Hall immediately. The
   heart deduction uses hohRemoveHeartsFromBank (client bank — same
   pool used by every heart-spend surface) AFTER the RPC confirms,
   so a failed unlock never charges the user. */
/* R148-Z36: Legacy single-cost constant. Kept for backward compat
   in case any external surface reads it, but the actual cost is now
   per-character via hohGetCardUnlockCost(c). Common is free; the
   higher tiers scale up from 10. The cap at Legendary/Mythic stays
   at 100 so the most valuable cards aren't gated behind a wall the
   user can never afford from a normal day's hearts. */
window.hohCardUnlockCost = 100;
window.hohCardUnlockCostByTier = {
  common:    0,
  uncommon:  10,
  rare:      25,
  epic:      50,
  legendary: 100,
  mythic:    100
};
window.hohGetCardUnlockCost = function(c){
  if(!c) return window.hohCardUnlockCost;
  var rar = (typeof window.hohGetRarity === 'function')
    ? window.hohGetRarity(c.hearts || 0)
    : { tier: 'common' };
  /* Mythic is also gated by hohIsMythicCharacter (special promoted
     heroes) — they always cost 100, same as natural-tier mythic. */
  var tier = rar && rar.tier;
  if(typeof window.hohIsMythicCharacter === 'function' && window.hohIsMythicCharacter(c)){
    tier = 'mythic';
  }
  var cost = window.hohCardUnlockCostByTier[tier];
  return (typeof cost === 'number') ? cost : window.hohCardUnlockCost;
};
window.hohCardUnlockedSet = window.hohCardUnlockedSet || new Set();
/* In-flight load promise — multiple callers can await the same fetch
   without racing N parallel RPC calls. */
var __hohCardUnlocksLoadPromise = null;
/* Loaded-for-email guard. If the user signs out + signs in as another
   account, we need to refetch; the email gate lets us notice that. */
var __hohCardUnlocksLoadedFor = null;
/* R148-Z8: localStorage persistence layer. Keyed by email so multi-
   account sign-ins on the same device stay separate. Stored as JSON:
     { "email@x.com": ["uuid1","uuid2",...], ... }
   The local store is the FALLBACK source of truth when the server
   RPC is unavailable (e.g. SQL migration not run yet). Without this,
   unlocking → refreshing the page would re-lock the card because the
   in-memory Set rebuilds from an empty server response. With this,
   the set re-hydrates from localStorage on page boot AND merges with
   whatever the server returns, so the unlock persists across refreshes
   regardless of backend state. */
var HOH_CARD_UNLOCKS_LS_KEY = 'hoh-card-unlocks-v1';
function __hohReadLocalUnlocks(){
  try {
    var raw = localStorage.getItem(HOH_CARD_UNLOCKS_LS_KEY);
    if(!raw) return {};
    var obj = JSON.parse(raw);
    return (obj && typeof obj === 'object') ? obj : {};
  } catch(_){ return {}; }
}
function __hohWriteLocalUnlocks(map){
  try { localStorage.setItem(HOH_CARD_UNLOCKS_LS_KEY, JSON.stringify(map || {})); } catch(_){}
}
function __hohGetLocalUnlocksFor(email){
  var em = (email || '').toLowerCase().trim();
  if(!em) return [];
  var map = __hohReadLocalUnlocks();
  var arr = map[em];
  return Array.isArray(arr) ? arr : [];
}
function __hohAddLocalUnlock(email, charId){
  var em = (email || '').toLowerCase().trim();
  if(!em || !charId) return;
  var map = __hohReadLocalUnlocks();
  var arr = Array.isArray(map[em]) ? map[em] : [];
  if(arr.indexOf(charId) === -1){
    arr.push(charId);
    map[em] = arr;
    __hohWriteLocalUnlocks(map);
  }
}

window.hohLoadCardUnlocks = function(force){
  var email = (typeof window.hohYourHallEmail === 'function')
    ? (window.hohYourHallEmail() || '').toLowerCase().trim() : '';
  if(!email){
    /* Signed out — clear the set so a stale prior session doesn't
       linger. The button always renders "signed_out" until login. */
    window.hohCardUnlockedSet = new Set();
    __hohCardUnlocksLoadedFor = null;
    return Promise.resolve(window.hohCardUnlockedSet);
  }
  /* R148-Z8: SYNC seed from localStorage BEFORE awaiting the server
     fetch. This is the fix for "unlock disappears after refresh" —
     even if the server RPC returns nothing (because the SQL migration
     hasn't been run or there's a server hiccup), the locally stored
     unlocks repopulate the set immediately on page load so the user
     keeps what they paid for. The server fetch (below) will MERGE in
     anything it returns, so true cross-device unlocks still flow
     down once the backend is in place. */
  var localIds = __hohGetLocalUnlocksFor(email);
  if(localIds.length){
    if(!window.hohCardUnlockedSet) window.hohCardUnlockedSet = new Set();
    for(var li = 0; li < localIds.length; li++){
      window.hohCardUnlockedSet.add(localIds[li]);
    }
    /* Refresh any visible share button now — important because the
       detail modal may have already opened with the cached "locked"
       state from before this hydration. */
    try { window.hohRefreshShareBtn(); } catch(_){}
  }
  if(!force && __hohCardUnlocksLoadedFor === email && !__hohCardUnlocksLoadPromise){
    return Promise.resolve(window.hohCardUnlockedSet);
  }
  if(__hohCardUnlocksLoadPromise) return __hohCardUnlocksLoadPromise;
  if(typeof supabase === 'undefined' || !supabase || !supabase.rpc){
    /* No supabase available — local set is the truth. Mark the
       email as loaded so we don't keep re-running this branch. */
    __hohCardUnlocksLoadedFor = email;
    return Promise.resolve(window.hohCardUnlockedSet);
  }
  __hohCardUnlocksLoadPromise = supabase.rpc('get_user_card_unlocks', { p_user_email: email })
    .then(function(res){
      /* R148-Z6: Surface server-side errors at warning level so it's
         obvious when the SQL migration hasn't been deployed yet. The
         load still no-ops gracefully (empty set) so the UI works.
         R148-Z8: We do NOT replace the locally-hydrated set on error;
         we just keep the local unlocks. */
      if(res && res.error){
        console.warn('[hohLoadCardUnlocks] Server fetch failed (run the character_card_unlocks SQL migration if get_user_card_unlocks is missing):', res.error);
        __hohCardUnlocksLoadedFor = email;
        return window.hohCardUnlockedSet;
      }
      var rows = (res && res.data) || [];
      /* R148-Z8: MERGE server + local instead of replacing. Server
         is canonical for cross-device; localStorage covers offline /
         pre-migration unlocks. Union of both means a user never
         loses an unlock they legitimately paid for. */
      var s = new Set(window.hohCardUnlockedSet || []);
      for(var i = 0; i < rows.length; i++){
        if(rows[i] && rows[i].character_id) s.add(rows[i].character_id);
      }
      window.hohCardUnlockedSet = s;
      __hohCardUnlocksLoadedFor = email;
      /* If the detail modal is currently open and showing a share
         button for a character the user has actually unlocked, the
         button was rendered with the empty set and is showing the
         wrong (locked) state. Re-render it now that the data is in. */
      try { window.hohRefreshShareBtn(); } catch(_){}
      return s;
    })
    .catch(function(e){
      console.warn('[hohLoadCardUnlocks] Exception:', e);
      return window.hohCardUnlockedSet;
    })
    .finally(function(){ __hohCardUnlocksLoadPromise = null; });
  return __hohCardUnlocksLoadPromise;
};

window.hohIsCharacterOwner = function(c){
  if(!c) return false;
  var owner = (c.email || '').toString().toLowerCase().trim();
  if(!owner) return false;
  var me = (typeof window.hohYourHallEmail === 'function')
    ? (window.hohYourHallEmail() || '').toString().toLowerCase().trim() : '';
  return !!me && owner === me;
};

window.hohIsCardUnlocked = function(id){
  return !!(id && window.hohCardUnlockedSet && window.hohCardUnlockedSet.has(id));
};

/* ⛔ ====== R609 · EVERY EXPORT IS FREE (Jan) ======
   "everything should be free and not cost any hearts."

   ⛔ CHANGED HERE AND NOWHERE ELSE, ON PURPOSE. Four surfaces read this one
   function to decide what to show and what to charge: the export menu row, the
   plain share button, its aria-label, and `hohShareCard`'s spend branch. Making
   each of them free on its own would be four chances to leave a stale "100 ♥"
   on a screen, which is the worst possible way to get this wrong — a price
   printed on a thing that is free. `locked` simply no longer exists.

   `signed_out` STAYS, because it is not a price. These exports are tied to an
   account so a hero's own page can carry them, and the sign-in nudge is the
   same one the NPC card and the Archetype card have always used.

   The unlock plumbing below (`hohGetCardUnlockCost`, `hohUnlockCard`, the
   Scroll of Lineage) is deliberately left installed rather than deleted:
   already-purchased unlock rows stay valid and readable, and nothing now asks
   them for a price. Deleting a live economy table's client half to change a
   price to zero would be a much bigger blast radius than this one line. */
window.hohCardUnlockState = function(c){
  if(!c) return 'signed_out';
  var signedIn = (typeof window.hohYourHallEmail === 'function')
    && !!(window.hohYourHallEmail() || '').toString().trim();
  if(!signedIn) return 'signed_out';
  return 'free';
};

/* Returns the FULL <button> markup so the detail-modal renderer can
   drop one expression in place of the old hardcoded button. Three
   shapes:
     - free (owner or already unlocked): plain CHARACTER CARD button
     - locked (signed in, not owner, not yet unlocked): button shows
       the 100h lock badge + cost suffix
     - signed_out: button still says CHARACTER CARD but tapping it
       triggers the sign-in flow instead of generating the export */
window.hohBuildShareBtnHtml = function(c){
  var state = window.hohCardUnlockState(c);
  var shareIcon = '<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>';
  /* R148-Z3: Locked state swaps the share-out icon for a lock icon
     so the lock context lives in the icon slot — not jammed into a
     separate badge on the right. The cost chip then only needs to
     carry the number + heart, which keeps the button content within
     its flex:1 slot share (same width as Copy Link / Use as NPC). */
  var lockIcon = '<svg class="hoh-share-icon hoh-share-icon-lock" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2" ry="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>';
  /* R148-Z44: signed_out is rendered with the SAME locked button a
     signed-in visitor sees — lock icon + hearts cost. A brand-new
     visitor should never see a bare "Character Card" button that
     does nothing when clicked; showing the price up front makes the
     button honest, and hohShareCard's signed_out branch turns the
     click into a "submit a hero to start earning hearts" popup. */
  if(state === 'locked' || state === 'signed_out'){
    /* R198: a signed-out visitor sees NO price on the Character Card button — they
       have no hearts to spend yet. The plain button still routes through
       hohShareCard's signed_out gate, which prompts them to submit a hero first. */
    if(state === 'signed_out'){
      return '<button id="hoh-share-btn" class="hoh-share-btn" data-state="signed_out" onclick="hohShareCard(\''+c.id+'\')">'+shareIcon+' Character Card</button>';
    }
    /* R148-Z36: Per-character cost via the tier ladder. Common = 0
       (free unlock, no cost chip, no lock icon — just the regular
       Character Card button). Other tiers show the lock + cost. */
    var cost = window.hohGetCardUnlockCost(c);
    if(cost <= 0){
      /* Common: free. Render the standard non-locked Character Card
         button so the click flows straight to hohShareCard which will
         see state === 'locked' but cost === 0 and unlock instantly.
         For a signed_out visitor the click still routes through the
         signed_out gate in hohShareCard → submit-to-earn popup. */
      return '<button id="hoh-share-btn" class="hoh-share-btn hoh-share-btn-free" data-state="'+(state === 'signed_out' ? 'signed-out-free' : 'locked-free')+'" onclick="hohShareCard(\''+c.id+'\')" aria-label="Unlock Character Card (free for Common heroes)">'+
        shareIcon+' Character Card'+
      '</button>';
    }
    /* R148-Z30: Scroll-of-Lineage priority indicator. If the user
       owns the Scroll, the locked button advertises FREE UNLOCK
       (using the scroll) instead of the hearts cost. Clicking the
       button consumes the Scroll automatically — the user doesn't
       have to manually choose.
       R148-Z44: Scroll branch is signed-in only — an anonymous
       visitor can't hold a Scroll of Lineage under the first-timer
       gate, so signed_out always shows the plain hearts cost. */
    var hasScroll = (state === 'locked') && (typeof window.hohInventoryHas === 'function') && window.hohInventoryHas('scrollOfLineage');
    if(hasScroll){
      return '<button id="hoh-share-btn" class="hoh-share-btn hoh-share-btn-locked hoh-share-btn-scroll" data-state="locked" onclick="hohShareCard(\''+c.id+'\')" aria-label="Unlock Character Card with Scroll of Lineage">'+
        '<span class="hoh-share-btn-top">'+
          lockIcon+
          '<span class="hoh-share-btn-label">Character Card</span>'+
        '</span>'+
        '<span class="hoh-share-btn-cost hoh-share-btn-cost-scroll">'+
          '<span class="hoh-share-btn-scroll-icon" aria-hidden="true">&#167;</span>'+
          '<span class="hoh-share-btn-scroll-label">Free with Scroll</span>'+
        '</span>'+
      '</button>';
    }
    /* R148-Z4: Two-row layout for the locked button so "Character
       Card" reads in FULL on row 1 (no ellipsis-truncation) and the
       cost chip drops to row 2. Icon + label share the top row in a
       hoh-share-btn-top wrapper; the cost sits centered below. */
    return '<button id="hoh-share-btn" class="hoh-share-btn hoh-share-btn-locked" data-state="'+state+'" onclick="hohShareCard(\''+c.id+'\')" aria-label="Unlock Character Card export for '+cost+' hearts">'+
      '<span class="hoh-share-btn-top">'+
        lockIcon+
        '<span class="hoh-share-btn-label">Character Card</span>'+
      '</span>'+
      '<span class="hoh-share-btn-cost">'+cost+'<span class="hoh-share-btn-heart" aria-hidden="true">&#10084;</span></span>'+
    '</button>';
  }
  return '<button id="hoh-share-btn" class="hoh-share-btn" data-state="'+state+'" onclick="hohShareCard(\''+c.id+'\')">'+
    shareIcon+' Character Card'+
  '</button>';
};

/* Re-render the share button in place after state changes (unlock
   succeeded, user signed in/out, etc.). The detail modal might be
   open or closed; we just no-op if there's no button on the page. */
window.hohRefreshShareBtn = function(){
  var btn = document.getElementById('hoh-share-btn');
  if(!btn) return;
  /* R261: read the hero id from data-hero-id first. The Export DROPDOWN
     trigger's onclick is hohToggleExportMenu(event,this) — no id in it — so the
     old onclick-regex parse returned null and bailed EARLY, leaving the button
     stuck on "Generating..." after a dropdown export. Fall back to the onclick
     parse for the plain button. */
  var charId = btn.getAttribute('data-hero-id') || null;
  if(!charId){ try { charId = btn.getAttribute('onclick').match(/'([^']+)'/)[1]; } catch(_){} }
  var c = (charId && typeof allCharacters !== 'undefined' && allCharacters)
    ? allCharacters.find(function(ch){ return ch.id === charId; }) : null;
  /* Belt-and-braces: even if we can't resolve the character, at least clear the
     Generating state so the button is never permanently stuck. */
  if(!c){ try { btn.disabled = false; } catch(_){} return; }
  /* Re-render with the SAME builder the button came from: the Export dropdown is
     wrapped in .hoh-export-wrap (replace the whole wrapper), the plain Character
     Card button is standalone. */
  var wrap = btn.closest ? btn.closest('.hoh-export-wrap') : null;
  if(wrap && typeof window.hohBuildExportBtnHtml === 'function'){
    wrap.outerHTML = window.hohBuildExportBtnHtml(c);
  } else if(typeof window.hohBuildShareBtnHtml === 'function'){
    btn.outerHTML = window.hohBuildShareBtnHtml(c);
  } else {
    try { btn.disabled = false; } catch(_){}
  }
};

/* R148-Z30: Refresh the share button when inventory changes so a
   newly-acquired Scroll (from a Sage's Bazaar purchase) immediately
   flips the "Character Card 100 ♥" button to "Free with Scroll"
   without requiring the user to close + reopen the detail modal.
   Same listener pattern as the inventory-changed handler in tickets. */
try {
  if(!window.__hohScrollBtnListenerBound){
    window.__hohScrollBtnListenerBound = true;
    document.addEventListener('hoh:inventory-changed', function(){
      try { window.hohRefreshShareBtn(); } catch(_){}
    });
  }
} catch(_){}

/* Async unlock path. Returns a Promise that resolves to a result
   object:
     { ok:true, alreadyUnlocked, wasOwner, hearts_spent }
     { ok:false, reason: 'no_account' | 'insufficient' | 'rpc' | ... }
   On success the caller can immediately proceed with the export
   flow; this function has already deducted hearts (if needed) and
   force-saved the hero into Your Hall. */
/* R148-Z6: Rewritten as a SYNCHRONOUS optimistic unlock. The function
   does ALL its UI work inline (deduction, fly, favorite, refresh,
   toast) and fires the server-sync RPC in the background. If the RPC
   fails the local unlock still stands — the user got their card.
   This is the right tradeoff because:
     - The bank is client-side localStorage anyway (no server-side
       wallet to refund), so deduct-then-refund-on-RPC-fail would be a
       jarring user experience while the SQL migration is still being
       deployed.
     - The unlock cache will be replayed from the server next time the
       cache loads (if RPC succeeded), so legitimate unlocks persist
       cross-device.
     - If the RPC truly fails forever (server outage / migration not
       run), the unlock still works locally and the user can still
       export — they just won't see it on a fresh device until the
       backend catches up.
   Return shape stays compatible with old callers: { ok, reason? }. */
window.hohUnlockCard = function(c){
  if(!c || !c.id) return { ok:false, reason:'bad_input' };
  var email = (typeof window.hohYourHallEmail === 'function')
    ? (window.hohYourHallEmail() || '').toLowerCase().trim() : '';
  if(!email) return { ok:false, reason:'no_account' };
  /* R148-Z36: Per-character cost via the tier ladder. Common = 0
     (free unlock — needsHearts goes false even without scroll). */
  var cost = window.hohGetCardUnlockCost(c);
  var isOwner = window.hohIsCharacterOwner(c);
  var alreadyUnlocked = window.hohIsCardUnlocked(c.id);
  var needsHearts = !isOwner && !alreadyUnlocked && cost > 0;
  /* R148-Z30: Scroll of Lineage priority. If the user owns the Scroll
     AND would otherwise need to spend hearts, burn the Scroll FIRST
     and skip the hearts deduction. This is the contract the inventory
     item promises: "one free hero unlock on the house". The Scroll
     beats hearts every time — the user shouldn't have to manually
     choose; the cheaper path wins automatically. The animation runs
     on the scroll-spent path so the user sees the trade happen, not
     just a silent unlock. */
  var usedScroll = false;
  if(needsHearts && typeof window.hohInventoryHas === 'function' && window.hohInventoryHas('scrollOfLineage')){
    try {
      if(typeof window.hohConsumeScrollForUnlock === 'function'){
        usedScroll = window.hohConsumeScrollForUnlock();
      } else if(typeof window.hohInventoryConsume === 'function'){
        usedScroll = window.hohInventoryConsume('scrollOfLineage');
      }
    } catch(_){}
    if(usedScroll){
      needsHearts = false; /* skip hearts deduction below */
    }
  }
  if(needsHearts){
    var bank = (typeof getHeartBank === 'function') ? getHeartBank() : 0;
    if(bank < cost) return { ok:false, reason:'insufficient', have:bank, need:cost };
  }
  /* Optimistic local mark. Subsequent state reads see this as
     unlocked even if the RPC is still in flight (or fails).
     R148-Z8: ALSO persist to localStorage so the unlock survives a
     page refresh on the same device, regardless of whether the
     server RPC succeeds. This is the fix for "unlock disappears
     after refresh". */
  if(!window.hohCardUnlockedSet) window.hohCardUnlockedSet = new Set();
  window.hohCardUnlockedSet.add(c.id);
  try { __hohAddLocalUnlock(email, c.id); } catch(_){}
  var spent = 0;
  /* R148-Z30: If the Scroll consumed, fire the dedicated scroll-burn
     animation instead of the hearts-fly. The scroll animation reads
     as "the relic does its work" — a parchment ember that lands on
     the share button. */
  if(usedScroll){
    try {
      var scrollTarget = document.getElementById('hoh-share-btn')
        || document.querySelector('#hoh-modal-body .hoh-detail-img img')
        || document.querySelector('#hoh-modal-body');
      if(scrollTarget && typeof window.hohFireScrollUnlockAnim === 'function'){
        window.hohFireScrollUnlockAnim(scrollTarget);
      }
    } catch(_){}
    if(typeof window.hohRenderHeaderCounter === 'function'){
      try { window.hohRenderHeaderCounter(); } catch(_){}
    }
  } else if(needsHearts){
    /* Capture the fly target BEFORE the deduction so coords are read
       while the wallet pill still shows the pre-spend balance. */
    var flyTarget = document.getElementById('hoh-share-btn')
      || document.querySelector('#hoh-modal-body .hoh-detail-img img')
      || document.querySelector('#hoh-modal-body');
    if(typeof window.hohRemoveHeartsFromBank === 'function'){
      /* R284: this is a share/feature unlock, not a guess-game loss. Without
         the explicit reason it fell into hohRemoveHeartsFromBank's default
         'spend_penalty' bucket and polluted the penalty stats on the hub. */
      try { spent = window.hohRemoveHeartsFromBank(cost, 'spend_feature'); } catch(_){}
    }
    /* Heart-fly volley — 14 hearts arc from the wallet pill to the
       share button. Subtle + clean per existing helper. */
    if(flyTarget && typeof window.hohFlyHeartsFromPillToTarget === 'function'){
      try { window.hohFlyHeartsFromPillToTarget(flyTarget, 14); } catch(_){}
    }
  }
  /* R380: the auto-favorite that rode a card unlock is gone with favoriting. */
  try { window.hohRefreshShareBtn(); } catch(_){}
  /* Background RPC — fire-and-forget. We don't await it; we don't
     refund on failure. If it succeeds, the unlock persists to other
     devices. If it fails (e.g. SQL migration not run yet), we log a
     warning to the console and the unlock stays local-only. */
  try {
    if(typeof supabase !== 'undefined' && supabase && supabase.rpc && needsHearts){
      supabase.rpc('unlock_character_card', {
        p_user_email: email,
        p_character_id: c.id
      }).then(function(res){
        if(res && res.error){
          console.warn('[hohUnlockCard] Server sync failed (the unlock still works locally). Run sql/R148-Z1-character-card-unlocks.sql if the RPC is missing.', res.error);
        }
      }).catch(function(e){
        console.warn('[hohUnlockCard] Server sync exception:', e);
      });
    }
  } catch(_){}
  return { ok:true, hearts_spent:spent };
};

/* R148-Z30: Scroll-of-Lineage unlock animation. Fires when a Scroll
   is consumed for a card unlock. Visual: a parchment scroll glyph
   travels from the wallet pill to the share button on an arc, then
   bursts into golden sparkles. The Scroll inventory chip in the
   header pill fades out as part of the same beat (handled by the
   inventory-changed event the consume already dispatches). The
   animation lasts ~900ms total — long enough to feel ceremonial,
   short enough to not block follow-up interaction. */
window.hohFireScrollUnlockAnim = function(targetEl){
  if(!targetEl) return;
  /* Source: the wallet pill (header). Fall back to viewport corner
     if the pill isn't on screen. */
  var pill = document.getElementById('hoh-tk-header');
  var srcRect, tgtRect;
  try {
    tgtRect = targetEl.getBoundingClientRect();
    if(!tgtRect.width || !tgtRect.height) return;
    if(pill){
      srcRect = pill.getBoundingClientRect();
    } else {
      srcRect = { left: window.innerWidth - 80, top: window.innerHeight - 80, width: 40, height: 40 };
    }
  } catch(_){ return; }
  var startX = srcRect.left + srcRect.width / 2;
  var startY = srcRect.top + srcRect.height / 2;
  var endX = tgtRect.left + tgtRect.width / 2;
  var endY = tgtRect.top + tgtRect.height / 2;
  var dx = endX - startX;
  var dy = endY - startY;
  /* The flying scroll glyph. */
  var scroll = document.createElement('div');
  scroll.className = 'hoh-scroll-unlock-fly';
  scroll.innerHTML = '<span class="hoh-scroll-unlock-fly-glyph" aria-hidden="true">&#167;</span>';
  scroll.style.cssText =
    'position:fixed;left:' + startX + 'px;top:' + startY + 'px;' +
    'transform:translate(-50%,-50%) scale(0.6) rotate(-12deg);' +
    'opacity:0;pointer-events:none;z-index:100001;';
  document.body.appendChild(scroll);
  /* Inject keyframe inline so the arc respects per-call dx/dy. */
  var styleId = 'hoh-scroll-unlock-keyframes-' + Date.now();
  var styleEl = document.createElement('style');
  styleEl.id = styleId;
  styleEl.textContent =
    '@keyframes ' + styleId + '{' +
      '0%{transform:translate(-50%,-50%) scale(0.6) rotate(-12deg);opacity:0;}' +
      '15%{transform:translate(-50%,-50%) scale(1.2) rotate(0deg);opacity:1;}' +
      '70%{transform:translate(calc(-50% + ' + (dx * 0.95) + 'px), calc(-50% + ' + (dy * 0.95 - 30) + 'px)) scale(1.05) rotate(18deg);opacity:1;}' +
      '100%{transform:translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(1.4) rotate(24deg);opacity:0;}' +
    '}';
  document.head.appendChild(styleEl);
  scroll.style.animation = styleId + ' 820ms cubic-bezier(0.42, 0.0, 0.4, 1.0) forwards';
  /* On arrival, fire a small sparkle burst on the target. */
  setTimeout(function(){
    try {
      var burst = document.createElement('div');
      burst.className = 'hoh-scroll-unlock-burst';
      burst.style.cssText =
        'position:fixed;left:' + endX + 'px;top:' + endY + 'px;' +
        'transform:translate(-50%,-50%);pointer-events:none;z-index:100000;';
      /* 8 sparkles radiating outward. */
      for(var i = 0; i < 8; i++){
        var ang = (i / 8) * Math.PI * 2;
        var spark = document.createElement('span');
        spark.className = 'hoh-scroll-unlock-spark';
        spark.style.setProperty('--spark-x', Math.cos(ang) * 36 + 'px');
        spark.style.setProperty('--spark-y', Math.sin(ang) * 36 + 'px');
        spark.style.animationDelay = (i * 24) + 'ms';
        burst.appendChild(spark);
      }
      document.body.appendChild(burst);
      setTimeout(function(){
        try { burst.parentNode && burst.parentNode.removeChild(burst); } catch(_){}
      }, 1000);
    } catch(_){}
  }, 750);
  /* Cleanup. */
  setTimeout(function(){
    try { scroll.parentNode && scroll.parentNode.removeChild(scroll); } catch(_){}
    try { styleEl.parentNode && styleEl.parentNode.removeChild(styleEl); } catch(_){}
  }, 900);
  /* Toast for unambiguous feedback. */
  if(typeof window.hohShowHeartToast === 'function'){
    try {
      window.hohShowHeartToast('Scroll of Lineage burned', 'Hero unlocked for free.');
    } catch(_){}
  }
};

/* R148-Z6: Unlock-confirmation modal RETIRED. The flow is now
   direct (hohShareCard → hohUnlockCard) with no intermediary "are you
   sure?" step. The functions below are kept as no-op shims so any
   stale onclick attributes or browser-cached pages don't throw if
   they happen to fire after a soft reload. Safe to delete entirely
   once you're sure no cached HTML references them. */
window.hohOpenUnlockConfirmModal_REMOVED = function(c){
  if(!c) return;
  var existing = document.getElementById('hoh-card-unlock-modal');
  if(existing) existing.remove();
  var cost = window.hohCardUnlockCost;
  var bank = (typeof getHeartBank === 'function') ? getHeartBank() : 0;
  var balAfter = Math.max(0, bank - cost);
  var insufficient = bank < cost;
  var shortBy = insufficient ? (cost - bank) : 0;
  var heart = '<span class="hoh-cu-heart" aria-hidden="true">&#10084;</span>';
  var wrap = document.createElement('div');
  wrap.id = 'hoh-card-unlock-modal';
  wrap.className = 'hoh-card-unlock-modal';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.innerHTML =
   '<div class="hoh-cu-backdrop" onclick="hohCloseUnlockConfirmModal()"></div>'+
   '<div class="hoh-cu-card">'+
    '<button class="hoh-cu-close" aria-label="Close" onclick="hohCloseUnlockConfirmModal()">&times;</button>'+
    '<div class="hoh-cu-title">Unlock '+(c.name ? c.name.replace(/[<>&"]/g, '') : 'this hero')+'’s Card?</div>'+
    '<div class="hoh-cu-sub">A permanent unlock on your account. You’ll be able to export this Character Card any time, on any device.</div>'+
    '<div class="hoh-cu-cost-row">'+
     '<div class="hoh-cu-cost-label">Cost</div>'+
     '<div class="hoh-cu-cost-value">'+cost+heart+'</div>'+
    '</div>'+
    '<div class="hoh-cu-balance-row">'+
     '<span class="hoh-cu-bal-label">Your hearts</span>'+
     '<span class="hoh-cu-bal-value '+(insufficient ? 'hoh-cu-bal-short' : '')+'">'+bank+heart+(insufficient ? '' : ' → '+balAfter+heart)+'</span>'+
    '</div>'+
    '<div class="hoh-cu-bonus"><span class="hoh-cu-bonus-icon" aria-hidden="true">&#9733;</span> Auto-favorites this hero so they’re saved to Your Hall.</div>'+
    (insufficient
      ? '<div class="hoh-cu-short-msg">Need <strong>'+shortBy+'</strong> more heart'+(shortBy===1?'':'s')+'. Keep playing — every roll earns hearts toward your bank.</div>'
      : '')+
    '<div class="hoh-cu-actions">'+
     '<button class="hoh-cu-cancel" onclick="hohCloseUnlockConfirmModal()">Not now</button>'+
     '<button class="hoh-cu-confirm" '+(insufficient ? 'disabled aria-disabled="true"' : 'onclick="hohConfirmCardUnlock(\''+c.id+'\')"')+'>'+
      (insufficient ? 'Need '+shortBy+' more' : 'Unlock for '+cost+heart)+
     '</button>'+
    '</div>'+
   '</div>';
  document.body.appendChild(wrap);
  /* Keyboard: escape closes; tab is trapped via focus on the
     confirm button if available, cancel otherwise. */
  var onKey = function(e){
    if(e.key === 'Escape'){ window.hohCloseUnlockConfirmModal(); }
  };
  wrap.__hohKey = onKey;
  document.addEventListener('keydown', onKey);
  setTimeout(function(){
    var focusBtn = wrap.querySelector(insufficient ? '.hoh-cu-cancel' : '.hoh-cu-confirm');
    if(focusBtn) focusBtn.focus();
  }, 20);
};
window.hohCloseUnlockConfirmModal = function(){
  var m = document.getElementById('hoh-card-unlock-modal');
  if(!m) return;
  if(m.__hohKey) try { document.removeEventListener('keydown', m.__hohKey); } catch(_){}
  m.remove();
};
window.hohConfirmCardUnlock = async function(id){
  var c = (typeof allCharacters !== 'undefined' && allCharacters)
    ? allCharacters.find(function(ch){ return ch.id === id; }) : null;
  if(!c) return;
  var m = document.getElementById('hoh-card-unlock-modal');
  var confirmBtn = m ? m.querySelector('.hoh-cu-confirm') : null;
  if(confirmBtn){ confirmBtn.disabled = true; confirmBtn.innerHTML = 'Unlocking…'; }
  /* R148-Z5: Close the unlock-confirm modal FIRST, then run hohUnlock-
     Card. With the modal out of the way the share button (the fly's
     target) is visible in the detail modal underneath, so the heart-
     fly ceremony reads clearly. If the RPC fails we surface a toast
     with the error rather than re-opening the modal — closing-then-
     toasting is the standard "thing happened" feel. */
  window.hohCloseUnlockConfirmModal();
  var result = await window.hohUnlockCard(c);
  if(result.ok){
    if(typeof window.hohShowHallToast === 'function'){
      try { window.hohShowHallToast('Unlocked! Saved to Your Hall.'); } catch(_){}
    }
    /* R148-Z5: Brief pause (800ms) before chaining to the export.
       The heart-fly animation takes ~1.1s total; 800ms is enough for
       the user to see hearts launch from the wallet + land at the
       share button before the export's canvas-generation freezes the
       UI for a moment. Without the pause the spend ceremony reads
       as a flash and the export feels like it cuts in too quickly. */
    setTimeout(function(){
      try { window.hohShareCard(id); } catch(_){}
    }, 800);
  } else {
    var msg = 'Unlock failed. Please try again.';
    if(result.reason === 'no_account') msg = 'Please sign in first to unlock cards.';
    else if(result.reason === 'insufficient') msg = 'Not enough hearts.';
    if(typeof window.hohShowHeartToast === 'function'){
      try { window.hohShowHeartToast('Hmm', msg); } catch(_){}
    } else { alert(msg); }
  }
};

/* R148-Z44: "Start earning hearts" popup. Shown when a signed-out
   visitor taps a locked Character Card button. Replaces the old
   toast + hohOpenYourHall() nudge, which went nowhere now that Your
   Hall is hidden behind the first-timer gate (R148-Z41). The popup
   explains the path in one screen: this card costs N hearts, submit
   a hero to start earning them. Reuses the hoh-cu-* modal styling
   (same family as the retired unlock-confirm modal) so it matches
   the rest of the Hall with zero new CSS. Distinct DOM id so it
   never collides with any other hoh-card-unlock modal instance. */
window.hohOpenSubmitToEarnModal = function(c){
  var existing = document.getElementById('hoh-submit-earn-modal');
  if(existing) existing.remove();
  var cost = (c && typeof window.hohGetCardUnlockCost === 'function')
    ? window.hohGetCardUnlockCost(c) : 0;
  var heart = '<span class="hoh-cu-heart" aria-hidden="true">&#10084;</span>';
  /* Common heroes are free to unlock once you have an account, so
     there's no hearts cost to show — the popup still nudges the
     visitor to submit a hero since exports are account-tied. */
  var costRow = (cost > 0)
    ? '<div class="hoh-cu-cost-row">'+
        '<div class="hoh-cu-cost-label">This card</div>'+
        '<div class="hoh-cu-cost-value">'+cost+heart+'</div>'+
      '</div>'
    : '';
  /* Sub copy adapts to the trigger. With a character + cost it's a
     locked Character Card. With no character (c == null) it's a
     generic heart-spend block — a signed-out visitor tried to give
     or spend hearts somewhere. */
  var sub;
  if(!c){
    sub = 'Hearts are yours to earn once you join the Hall.';
  } else if(cost > 0){
    sub = 'Character Cards unlock with hearts you earn across the Hall.';
  } else {
    sub = 'Character Card exports are saved to your hall.';
  }
  var wrap = document.createElement('div');
  wrap.id = 'hoh-submit-earn-modal';
  wrap.className = 'hoh-card-unlock-modal';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.innerHTML =
   '<div class="hoh-cu-backdrop" onclick="hohCloseSubmitToEarnModal()"></div>'+
   '<div class="hoh-cu-card">'+
    '<button class="hoh-cu-close" aria-label="Close" onclick="hohCloseSubmitToEarnModal()">&times;</button>'+
    '<div class="hoh-cu-title">Start earning hearts</div>'+
    '<div class="hoh-cu-sub">'+sub+'</div>'+
    costRow+
    '<div class="hoh-cu-bonus">'+
      '<span class="hoh-cu-bonus-icon" aria-hidden="true">&#9733;</span> '+
      'Add your own hero to the Hall and you start earning hearts right away.'+
    '</div>'+
    '<div class="hoh-cu-actions">'+
     '<button class="hoh-cu-cancel" onclick="hohCloseSubmitToEarnModal()">Not now</button>'+
     '<button class="hoh-cu-confirm" onclick="hohCloseSubmitToEarnModal();if(window.hohOpenForm)hohOpenForm();">Add Your Hero</button>'+
    '</div>'+
   '</div>';
  document.body.appendChild(wrap);
  var onKey = function(e){ if(e.key === 'Escape'){ window.hohCloseSubmitToEarnModal(); } };
  wrap.__hohKey = onKey;
  document.addEventListener('keydown', onKey);
  setTimeout(function(){
    var b = wrap.querySelector('.hoh-cu-confirm');
    if(b) b.focus();
  }, 20);
};
window.hohCloseSubmitToEarnModal = function(){
  var m = document.getElementById('hoh-submit-earn-modal');
  if(!m) return;
  if(m.__hohKey) try { document.removeEventListener('keydown', m.__hohKey); } catch(_){}
  m.remove();
};

/* Boot-time + sign-in-event hook. Load the user's unlocks once we
   know who they are. This binds to multiple events because the
   sign-in flow can complete on the auth page, the inline modal, or
   via PIN unlock. */
(function(){
  function tryLoad(){ try { window.hohLoadCardUnlocks(); } catch(_){} }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', tryLoad);
  } else { tryLoad(); }
  /* Re-fetch when the account changes. */
  try {
    document.addEventListener('hoh:signed-in', function(){ tryLoad(); });
    document.addEventListener('hoh:signed-out', function(){
      window.hohCardUnlockedSet = new Set();
      __hohCardUnlocksLoadedFor = null;
    });
  } catch(_){}
})();

window.hohShareCard = async function(id){
 var c = allCharacters.find(function(ch){ return ch.id === id; });
 if(!c) return;
 /* R148-Z6: Direct optimistic unlock — NO confirmation modal. Per
    user, tapping the button should just do the thing: check funds,
    spend, animate, unlock, export. No intermediary step.
    Three gates checked in order:
      1. signed_out → nudge sign-in toast + open Your Hall.
      2. locked + insufficient hearts → "Need N more" toast, no spend.
      3. locked + funds present → spend ceremony then re-enter this
         function to run the actual export path with state == free.
    The free-path code below is the existing canvas-generation flow,
    untouched. */
 var state = window.hohCardUnlockState(c);
 if(state === 'signed_out'){
   /* R148-Z44: A brand-new visitor has no account and no hearts.
      The old path fired a toast then called hohOpenYourHall(), but
      Your Hall lives inside the Three Doors section, which the
      first-timer gate hides until the visitor submits a hero — so
      the click went nowhere visible and the button felt broken.
      Show a real popup that explains the path: submit a hero, start
      earning hearts, then unlock cards. */
   if(typeof window.hohOpenSubmitToEarnModal === 'function'){
     try { window.hohOpenSubmitToEarnModal(c); } catch(_){}
   } else if(typeof window.hohOpenForm === 'function'){
     /* Defensive fallback if the modal helper didn't load. */
     try { window.hohOpenForm(); } catch(_){}
   }
   return;
 }
 if(state === 'locked'){
   /* R148-Z36: Per-character cost via the tier ladder. Common = 0
      so the bank check is bypassed entirely (Common is free). */
   var cost = window.hohGetCardUnlockCost(c);
   /* R148-Z30: Scroll of Lineage check happens BEFORE the bank gate.
      Previously this function blocked at `bank < cost` returning a
      "Need N more hearts" toast — even when the user had a Scroll
      that would let them unlock for free. The Scroll bypasses the
      hearts cost entirely, so the bank check is irrelevant in that
      branch. hohUnlockCard handles the consume + animation; we just
      need to let the call through. Common heroes (cost === 0) also
      skip the bank check naturally. */
   var hasScroll = (typeof window.hohInventoryHas === 'function') && window.hohInventoryHas('scrollOfLineage');
   if(cost > 0 && !hasScroll){
     var bank = (typeof getHeartBank === 'function') ? getHeartBank() : 0;
     if(bank < cost){
       var shortBy = cost - bank;
       if(typeof window.hohShowHeartToast === 'function'){
         try { window.hohShowHeartToast('Need ' + shortBy + ' more heart' + (shortBy === 1 ? '' : 's'), 'Explore the Hall to earn more, or buy a Scroll of Lineage at the Sage\'s Bazaar.'); } catch(_){}
       }
       return;
     }
   }
   /* Sufficient funds OR Scroll-owned — run the optimistic unlock
      (deducts hearts OR consumes Scroll, fires fly/scroll animation,
      auto-favorites, refreshes the button, kicks off background RPC
      sync). hohUnlockCard is now synchronous and does all UI work
      inline. */
   var result = window.hohUnlockCard(c);
   if(!result.ok){
     if(typeof window.hohShowHeartToast === 'function'){
       try { window.hohShowHeartToast('Hmm', 'Unlock failed. Try again in a moment.'); } catch(_){}
     }
     return;
   }
   if(typeof window.hohShowHallToast === 'function'){
     try { window.hohShowHallToast('Unlocked! Saved to Your Hall.'); } catch(_){}
   }
   /* Hold 800ms so the heart-fly volley reads clearly before we
      hand control to the canvas export (which freezes the UI briefly
      during PNG generation). Re-enter hohShareCard so the now-free
      state takes the normal export branch. */
   setTimeout(function(){
     try { window.hohShareCard(id); } catch(_){}
   }, 800);
   return;
 }
 var btn = document.getElementById('hoh-share-btn');
 if(btn){ btn.disabled = true; btn.innerHTML = 'Generating...'; }
 try {
  /* R142: 5:7 trading-card aspect (1080x1512). Same width as the old
     1080x1350 layout but 162px taller — the extra height all goes
     to the info zone so the portrait can be a full 1080x1080 square
     and the stat trio + story + footer get proper breathing room. */
  var W = 1080, H = 1512;
  var canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  var ctx = canvas.getContext('2d');
  /* Rarity lookup happens FIRST — the entire card design keys off
     this. Frame color, pill accent, info-zone divider color. */
  var rar = (typeof window.hohGetRarity === 'function')
    ? window.hohGetRarity(c.hearts || 0)
    : { tier: 'common', label: 'Common' };
  var isMythicC = (typeof window.hohIsMythicCharacter === 'function')
    ? window.hohIsMythicCharacter(c)
    : false;
  if(isMythicC){
    rar = { tier: 'mythic', label: 'Mythic' };
  }
  /* MYTHICFF: only a FramedFantasy portrait prints a Mythic frame */
  if(!c.is_ff_portrait && rar.tier === 'mythic'){
    rar = { tier: 'legendary', label: 'Legendary' };
  }
  var frame = _hohRarityFrameStyle(rar.tier);
  /* Frame dimensions. The portrait sits inside the frame so the
     trading-card identity reads from the edge.
     R143-G: FRAME 12 → 8, image crop 10% → 12% (1064 × 936). Even at
     12 the frame was reading thick; 8px reads as a clean halo. The
     extra image crop frees more room for the info zone so the story
     and meta line can occupy the spotlight (user feedback: stats
     trio was over-emphasized, race/class/lvl + story under-served). */
  /* R144-C: FRAME 8 → 5. Even at 8 the frame still felt heavy. 5px
     is a hairline halo — barely visible as a frame, mostly read as
     a rarity glow on the edge. Image moves up to 1070 wide.
     R147: 5 → 3 per user — frame should feel like a whisper of
     rarity around the card edge, not a visible bezel.
     R148-v7: 3 → 2 per user — even thinner so the frame reads as
     a single-pixel tinted edge rather than a visible band. The
     inner stroke below was also softened (1.5px -> 0.6px) so the
     whole frame system whispers instead of asserting. */
  var FRAME = 2;                             /* frame thickness on all sides */
  var INNER_W = W - FRAME * 2;               /* 1070 — content area width */
  var IMG_W = INNER_W;                       /* image fills the inner width */
  /* R148-v6: Image crop ratio bumped 0.88 -> 0.91 per user. The
     image now claims ~974px of vertical real estate (was ~942), so
     the portrait reads larger AND the info zone starts ~32px lower,
     pulling the whole text stack (stats, name, meta, campaign,
     story) further down the card. */
  var IMG_H = Math.round(INNER_W * 0.91);    /* crop 9% off the bottom — 974 */
  /* Back-compat alias — older sub-paths still reference IMG_SIZE; we
     keep it pointing at the WIDTH so corner / square calculations
     don't break. Anything that should track height now uses IMG_H. */
  var IMG_SIZE = IMG_W;
  var INFO_TOP = FRAME + IMG_H;              /* y-coord where info zone starts */
  var INFO_BOTTOM = H - FRAME;
  var INFO_H = INFO_BOTTOM - INFO_TOP;       /* 1500 - 944 = 568 */
  /* === Background === */
  var bgG = ctx.createLinearGradient(0, 0, 0, H);
  bgG.addColorStop(0, '#0c0c14');
  bgG.addColorStop(1, '#0a0a0f');
  ctx.fillStyle = bgG;
  ctx.fillRect(0, 0, W, H);
  /* === Image (top ~63% of card, 10:9 rectangle) === */
  /* R142-fix2: portrait is now cropped to a 10:9 (W:H) rectangle, not
     a square \u2014 the bottom 10% was eating the part of the portrait
     that's usually least informative (feet/floor) and that real
     estate now goes to the info zone. Cover-fit anchored to the TOP
     of the portrait so we lose the bottom slice, not the face. */
  var imgH = IMG_H;
  var imgLoaded = false;
  var IMG_X = FRAME;
  var IMG_Y = FRAME;
  if(c.image_url){
   try {
    var modalImg = document.querySelector('#hoh-modal-body .hoh-detail-img img');
    if(modalImg && modalImg.complete && modalImg.naturalWidth > 0){
     var tc = document.createElement('canvas');
     tc.width = modalImg.naturalWidth;
     tc.height = modalImg.naturalHeight;
     tc.getContext('2d').drawImage(modalImg, 0, 0);
     var di = new Image();
     di.src = tc.toDataURL('image/png');
     await new Promise(function(r){ di.onload = r; di.onerror = r; });
     /* Cover-fit into the IMG_W \u00d7 IMG_H rectangle. We scale so the
        shorter axis fills the target, then crop the overflow on the
        longer axis. Vertical crop is anchored to the top of the
        image so we drop the bottom slice (where most character art
        has feet/floor) instead of the face. */
     var _exZoom = 100;
     try { if(typeof window.hohGetImageZoom === 'function') _exZoom = window.hohGetImageZoom(c.id, 'primary'); } catch(_){}
     if(typeof _exZoom !== 'number' || _exZoom < 100 || _exZoom > 200) _exZoom = 100;
     var scale = Math.max(IMG_W / di.width, IMG_H / di.height) * (_exZoom / 100);
     var dW = di.width * scale, dH = di.height * scale;
     ctx.save();
     ctx.beginPath();
     ctx.rect(IMG_X, IMG_Y, IMG_W, IMG_H);
     ctx.clip();
     /* R265: honor the SAVED reframe so the exported PNG matches exactly
        what the card shows on screen. This is CSS object-fit:cover +
        object-position math: the draw offset on each axis is the overflow
        (IMG - scaled, always <= 0) times the position fraction. 50%/50% =
        centered (the on-screen default); a user who reframed to the face
        exports the face. Replaces the old fixed top-anchor (Y=0), which
        ignored the reframe and cropped everyone to the top. */
     var _exOx = 50, _exOy = 50;
     try { if(typeof window.hohGetImageOffsetX === 'function') _exOx = window.hohGetImageOffsetX(c.id, 'primary'); } catch(_){}
     try { if(typeof window.hohGetImageOffsetY === 'function') _exOy = window.hohGetImageOffsetY(c.id, 'primary'); } catch(_){}
     if(typeof _exOx !== 'number') _exOx = 50;
     if(typeof _exOy !== 'number') _exOy = 50;
     ctx.drawImage(di,
       IMG_X + (IMG_W - dW) * (_exOx / 100),
       IMG_Y + (IMG_H - dH) * (_exOy / 100),
       dW, dH);
     /* R148-v7: Bottom gradient fade smoothed per user. The old fade
        was a hard 120px ramp from 0% -> 95% opacity which read as a
        visible band. The new version stretches across 220px with
        five eased stops so the image dissolves into the info zone
        background imperceptibly — no visible band edge. The final
        stop reaches the EXACT background color (#0a0a0f matches the
        bg gradient's bottom stop) at full opacity so the seam is
        invisible. */
     var FADE_H = 220;
     var fG = ctx.createLinearGradient(0, IMG_Y + IMG_H - FADE_H, 0, IMG_Y + IMG_H);
     fG.addColorStop(0,    'rgba(10,10,15,0)');
     fG.addColorStop(0.35, 'rgba(10,10,15,0.20)');
     fG.addColorStop(0.65, 'rgba(10,10,15,0.55)');
     fG.addColorStop(0.85, 'rgba(10,10,15,0.85)');
     fG.addColorStop(1,    'rgba(10,10,15,1)');
     ctx.fillStyle = fG;
     ctx.fillRect(IMG_X, IMG_Y + IMG_H - FADE_H, IMG_W, FADE_H);
     ctx.restore();
     imgLoaded = true;
    }
   } catch(e){ console.warn('Share card image failed:', e); }
  }
  if(!imgLoaded){
   /* Fallback: hashed gradient block with first letter monogram. */
   var hash = 0;
   for(var pi = 0; pi < c.name.length; pi++) hash = c.name.charCodeAt(pi) + ((hash << 5) - hash);
   var hue = Math.abs(hash % 360);
   var pG = ctx.createLinearGradient(IMG_X, IMG_Y, IMG_X + IMG_W, IMG_Y + IMG_H);
   pG.addColorStop(0, 'hsl(' + hue + ',30%,15%)');
   pG.addColorStop(1, 'hsl(' + ((hue + 40) % 360) + ',40%,12%)');
   ctx.fillStyle = pG;
   ctx.fillRect(IMG_X, IMG_Y, IMG_W, IMG_H);
   ctx.font = '320px Cinzel,serif';
   ctx.fillStyle = 'rgba(200,164,94,0.12)';
   ctx.textAlign = 'center';
   ctx.textBaseline = 'middle';
   ctx.fillText(hohInitial(c.name), IMG_X + IMG_W / 2, IMG_Y + IMG_H / 2);
   ctx.textAlign = 'left';
   ctx.textBaseline = 'top';
  }
  /* === Rarity frame === */
  /* Outer frame is FRAME (32) thick around the entire canvas. The
     frame is drawn as a thick colored ring with rarity-specific
     gradient stops. Inside the frame edge we draw a thin inner
     stroke for depth. Mythic/Legendary additionally get a subtle
     outer glow that bleeds beyond the canvas edge a little (handled
     via the inset stroke pattern). */
  ctx.save();
  var frameGrad = ctx.createLinearGradient(0, 0, W, H);
  for(var fi = 0; fi < frame.stops.length; fi++){
    frameGrad.addColorStop(frame.stops[fi].at, frame.stops[fi].color);
  }
  /* Draw the frame as 4 rectangles around the content area (top,
     bottom, left, right). This is cleaner than a thick strokeRect
     because the gradient evaluates across each band uniformly. */
  ctx.fillStyle = frameGrad;
  ctx.fillRect(0, 0, W, FRAME);                          /* top */
  ctx.fillRect(0, H - FRAME, W, FRAME);                  /* bottom */
  ctx.fillRect(0, 0, FRAME, H);                          /* left */
  ctx.fillRect(W - FRAME, 0, FRAME, H);                  /* right */
  /* R148-v7: Inner stroke softened from 1.5px to 0.6px so the frame
     reads as a single tinted edge instead of two visible lines.
     Combined with FRAME 3 -> 2 above, the overall card border is
     now significantly more subtle. */
  ctx.strokeStyle = frame.innerStroke;
  ctx.lineWidth = 0.6;
  ctx.strokeRect(FRAME - 1, FRAME - 1, INNER_W + 2, H - FRAME * 2 + 2);
  ctx.restore();
  /* === Floating corner overlays on the portrait === */
  /* Featured Champion crown \u2014 drawn ABOVE the rarity pill if set */
  var hasCrown = !!c.featured;
  /* Rarity pill (always shown) \u2014 top-right of portrait */
  var pillTier = (rar.label || 'Common').toUpperCase();
  ctx.font = '700 18px Cinzel,serif';
  var pillTextW = ctx.measureText(pillTier).width;
  var pillPadX = 18, pillPadY = 10;
  var pillW = pillTextW + pillPadX * 2 + 22;     /* extra space for the diamond glyph */
  var pillH = 18 + pillPadY * 2;
  var pillX = IMG_X + IMG_W - pillW - 22;
  /* R166: When the character is the Featured raffle winner, drop the
     rarity pill DOWN to make room for the crown drawn above it.
     FRAME is only 2px on this canvas, so IMG_Y=2. With the old pillY
     = IMG_Y + 22 = 24, the crown center landed at y=2 and its peaks
     at y=-8 \u2014 i.e. drawn OFF-CANVAS. Only the crown's bottom band
     sneaked into the visible frame.
     For featured heroes we use IMG_Y + 64 so the crown center sits
     at y=42, peaks at y=32, band at y=48 \u2014 fully on-canvas with ~32px
     of breathing room from the top edge. Non-featured cards keep the
     tighter 22px offset since there's no crown to clear. */
  var pillY = IMG_Y + (hasCrown ? 64 : 22);
  /* Pill background */
  ctx.save();
  ctx.fillStyle = frame.pillBg;
  ctx.beginPath();
  var pillR = pillH / 2;
  ctx.moveTo(pillX + pillR, pillY);
  ctx.lineTo(pillX + pillW - pillR, pillY);
  ctx.arc(pillX + pillW - pillR, pillY + pillR, pillR, -Math.PI/2, Math.PI/2);
  ctx.lineTo(pillX + pillR, pillY + pillH);
  ctx.arc(pillX + pillR, pillY + pillR, pillR, Math.PI/2, -Math.PI/2);
  ctx.closePath();
  ctx.fill();
  ctx.lineWidth = 1.4;
  ctx.strokeStyle = frame.pillBorder;
  ctx.stroke();
  ctx.restore();
  /* Pill content: diamond glyph + rarity label */
  ctx.save();
  ctx.font = '700 18px Cinzel,serif';
  ctx.textBaseline = 'middle';
  if(rar.tier === 'mythic'){
    /* R142-fix2: Mythic label gradient uses the FF brand palette only —
       same five colors as the frame and .hoh-card-featured CSS treatment
       (pink → purple → cyan → green → blue). No gold/yellow. The
       gradient runs horizontally across the LABEL TEXT so the pill
       reads as a single coherent brand-tinted unit. */
    var labelX = pillX + pillPadX + 22;
    var labelW = ctx.measureText(pillTier).width;
    var mythicGrad = ctx.createLinearGradient(labelX, 0, labelX + labelW, 0);
    mythicGrad.addColorStop(0.00, '#ED97FE');
    mythicGrad.addColorStop(0.25, '#b794f4');
    mythicGrad.addColorStop(0.50, '#7ed4ff');
    mythicGrad.addColorStop(0.75, '#7ed49a');
    mythicGrad.addColorStop(1.00, '#ED97FE');
    /* Star glyph picks up the brand pink so it complements without
       fighting the gradient text. */
    _hohDrawStarIcon(ctx, pillX + pillPadX + 8, pillY + pillH/2, 16, '#ED97FE');
    ctx.fillStyle = mythicGrad;
    ctx.fillText(pillTier, labelX, pillY + pillH/2 + 1);
  } else {
    ctx.fillStyle = frame.label;
    /* Diamond \u2014 small filled rotated square */
    ctx.save();
    ctx.translate(pillX + pillPadX + 8, pillY + pillH/2);
    ctx.rotate(Math.PI / 4);
    ctx.fillRect(-5, -5, 10, 10);
    ctx.restore();
    ctx.fillText(pillTier, pillX + pillPadX + 22, pillY + pillH/2 + 1);
  }
  ctx.restore();
  /* Featured Champion crown \u2014 small gold crown ABOVE the pill */
  if(hasCrown){
    var crownCx = pillX + pillW / 2;
    var crownCy = pillY - 22;
    ctx.save();
    ctx.fillStyle = '#f2d98e';
    ctx.beginPath();
    /* 3-point crown silhouette */
    ctx.moveTo(crownCx - 22, crownCy + 6);
    ctx.lineTo(crownCx - 22, crownCy - 4);
    ctx.lineTo(crownCx - 12, crownCy + 2);
    ctx.lineTo(crownCx - 4, crownCy - 10);
    ctx.lineTo(crownCx + 4, crownCy - 10);
    ctx.lineTo(crownCx + 12, crownCy + 2);
    ctx.lineTo(crownCx + 22, crownCy - 4);
    ctx.lineTo(crownCx + 22, crownCy + 6);
    ctx.closePath();
    ctx.fill();
    /* Crown band underline */
    ctx.fillRect(crownCx - 22, crownCy + 6, 44, 3);
    ctx.restore();
  }
  /* R142-fix: FF Commissioned ribbon removed per request. The FF
     status is already implicit in the rarity treatment + the
     character's hearts/tickets data. Cleaner portrait without it. */
  /* === Info zone === */
  /* The info zone is exactly INFO_H tall (432px). Layout, top to
     bottom:
       1. Title block (name + campaign): 110px
       2. Meta line (race \u00b7 class \u00b7 level):  36px
       3. Hairline divider:                  18px (incl padding)
       4. Stat trio:                        130px
       5. Hairline divider:                  18px
       6. Story preview:                     72px
       7. Footer (byline + mint + brand):    48px
     Total: 432px. We track y as we go. */
  /* R143-G: New info-zone hierarchy. The user said the stats trio
     was dominating and meta/story were under-served. Reordered:
       Name → Campaign → BIG meta (race·class·lvl) → Story (longer)
       → compact stat row (minimal) → footer. */
  /* R146: Layout reorder + breathing room.
     The stats row moves ABOVE the story so the eye reads
       Name → Campaign → Meta → Stats → Story
     Story now anchors at the bottom and gets MORE LINES (5-6) so
     the empty space at the bottom of the card disappears. Title
     block + meta get extra vertical padding so they read as a
     proper headline stack instead of stacked tightly. */
  var INFO_PAD_X = FRAME + 32;        /* 37 from canvas edge */
  var INFO_W = W - INFO_PAD_X * 2;    /* 1006 */
  var infoY = INFO_TOP + 26;
  /* --- Compact stats row (R148-v4: ABOVE the name title) --- */
  /* R148-v4: Stats row relocated above the headline per user.
     The old order was Name -> Meta -> Campaign -> Stats -> Story
     which buried the heart/ticket/rarity readout in the middle of
     the card. Putting the trio at the very top makes it the FIRST
     thing a reader scans — quick stat-card vibe — while the name
     and identity block reads as the dominant headline below. */
  var hearts = c.hearts || 0;
  var tickets = c.tickets || 0;
  /* Win chance. R230: stored tickets IS the raffle weight (the mythic +3
     is baked into c.tickets now), so the share card reads hohEntriesFor
     like every other surface instead of re-adding a live +3 here. */
  var totalPool = 0;
  try {
    if(typeof allCharacters !== 'undefined' && allCharacters && allCharacters.length){
      for(var ai = 0; ai < allCharacters.length; ai++){
        var ach = allCharacters[ai];
        if(ach && ach.approved !== false && !ach.is_hidden){
          totalPool += hohEntriesFor(ach);
        }
      }
    }
  } catch(_){}
  var myTickets = hohEntriesFor(c);
  var winPct = (totalPool > 0)
    ? Math.max(0, Math.min(100, (myTickets / totalPool) * 100))
    : 0;
  var winPctStr;
  if(winPct === 0) winPctStr = '\u2014';
  else if(winPct < 0.1) winPctStr = '<0.1%';
  else if(winPct < 1) winPctStr = winPct.toFixed(2) + '%';
  else if(winPct < 10) winPctStr = winPct.toFixed(2) + '%';
  else winPctStr = winPct.toFixed(1) + '%';
  var statRow = [
    { kind: 'heart',  num: hearts.toLocaleString(),  color: '#d683e8' },
    { kind: 'ticket', num: tickets.toLocaleString(), color: '#d4b86a' },
    { kind: 'star',   num: winPctStr,                color: '#b0a8bc' }
  ];
  ctx.font = '600 18px Cinzel,serif';
  var numWidths = statRow.map(function(s){ return ctx.measureText(s.num).width; });
  var ICON_SIZE = 16;
  /* R148-v5: Stats row tightened per user. Icon-to-number gap pulled
     from 8 to 5, group gap (the space between each icon/number pair)
     pulled from 32 to 18. The trio now reads as a single compact
     strip instead of three loosely-spaced fragments. */
  var ICON_TO_NUM = 5;
  var GROUP_GAP = 18;
  var totalRowW = 0;
  for(var sw = 0; sw < statRow.length; sw++){
    totalRowW += ICON_SIZE + ICON_TO_NUM + numWidths[sw];
    if(sw < statRow.length - 1) totalRowW += GROUP_GAP;
  }
  /* R148-v2: Centering correction. The heart icon paints from x=-10
     to x=+10 inside a 24-unit coord system (scaled to ICON_SIZE=16),
     leaving ~1.33px of empty space on its LEFT inside its allotted
     box. The star icon (last icon) leaves a similar gap on its right
     visually, but the row's right edge is actually the last NUMBER's
     right edge — not the star's. So the true visual span is
     [rowStartX + heartLeftPad, rowStartX + totalRowW], which means
     bounding-box centering leaves the row visually shifted LEFT by
     half the heart-pad. We shift right by that amount so the visual
     center lines up with W/2 (matching the title, meta, campaign,
     story, and teaser lines). */
  var HEART_LEFT_PAD = (16 - 20 * (16 / 24)) / 2; /* ≈ 1.33px */
  var rowStartX = (W - totalRowW) / 2 + HEART_LEFT_PAD / 2;
  /* R148-v2: rowY pulled tighter against the new infoY (14 -> 10) so
     the stats sit visually right under the campaign without losing
     icon vertical breathing room. */
  var rowY = infoY + 10;
  ctx.textBaseline = 'middle';
  var cursorX = rowStartX;
  for(var sj = 0; sj < statRow.length; sj++){
    var s = statRow[sj];
    var iconCx = cursorX + ICON_SIZE / 2;
    if(s.kind === 'heart'){
      _hohDrawHeartIcon(ctx, iconCx, rowY, ICON_SIZE, s.color);
    } else if(s.kind === 'ticket'){
      _hohDrawTicketIcon(ctx, iconCx, rowY, ICON_SIZE + 2, s.color);
    } else {
      _hohDrawStarIcon(ctx, iconCx, rowY, ICON_SIZE, s.color);
    }
    cursorX += ICON_SIZE + ICON_TO_NUM;
    ctx.fillStyle = '#d8c8a0';
    ctx.font = '600 18px Cinzel,serif';
    ctx.textAlign = 'left';
    ctx.fillText(s.num, cursorX, rowY + 1);
    cursorX += numWidths[sj];
    if(sj < statRow.length - 1){
      ctx.fillStyle = 'rgba(200,184,140,0.5)';
      ctx.font = '600 16px Cinzel,serif';
      var dotX = cursorX + GROUP_GAP / 2;
      ctx.textAlign = 'center';
      ctx.fillText('\u00b7', dotX, rowY);
      cursorX += GROUP_GAP;
    }
  }
  ctx.textBaseline = 'top';
  ctx.textAlign = 'center';
  /* R148-v5: Stats-to-name gap widened (32 -> 48) so the headline
     gets visible breathing room below the stats strip. Previously
     the name felt grafted onto the stats; with +48 the name reads
     as the dominant beat with the stats as a quieter cap above. */
  infoY += 48;
  /* --- Title block --- */
  ctx.textBaseline = 'top';
  ctx.textAlign = 'center';
  ctx.fillStyle = '#f2d98e';
  /* R142-fix: name max trimmed 62 \u2192 56. Less vertical real estate
     consumed by the title so the stat trio + story + footer have
     room to breathe below. */
  var nameStr = (c.name || '');
  /* R148-v6: Name title bumped from 56 -> 66 per user. Trial ladder
     widens accordingly so very long names still autoscale down
     cleanly instead of running into the inner padding. */
  var nameSize = 66;
  var nameTrials = [66, 60, 54, 48, 42];
  for(var nt = 0; nt < nameTrials.length; nt++){
    ctx.font = '700 ' + nameTrials[nt] + 'px Cinzel,serif';
    if(ctx.measureText(nameStr).width <= INFO_W - 40){
      nameSize = nameTrials[nt];
      break;
    }
    nameSize = nameTrials[nt];
  }
  ctx.font = '700 ' + nameSize + 'px Cinzel,serif';
  ctx.fillText(nameStr, W / 2, infoY);
  /* R147: name → meta gap bumped 10 → 22 so the headline + identity
     line breathe as two distinct beats. */
  infoY += nameSize + 22;
  /* --- Meta line (RACE \u00b7 CLASS \u00b7 LVL) \u2014 visual primary --- */
  /* R147: Reordered. Old order was Name \u2192 Campaign \u2192 Meta. New
     order puts Meta directly below the name (the identity readout
     follows the name), then Campaign as a smaller italic UNDER the
     meta line. This matches what a reader scans for first
     (class/race) and pushes the campaign quote into a quieter
     subtitle beat. */
  /* R148-v6: Level removed from the meta line per user — the row
     now shows only RACE · CLASS, dropping "LVL X" entirely. Level
     was the least universally meaningful field (some campaigns
     don't track it the same way) and pulling it lets the two
     remaining tokens sit more centered and balanced. */
  var metaParts = [];
  if(c.race) metaParts.push(c.race.toUpperCase());
  if(c.character_class) metaParts.push(c.character_class.toUpperCase());
  if(metaParts.length){
    var metaStr = metaParts.join('   \u00b7   ');
    var metaSize = 26;
    var metaTrials = [26, 23, 20];
    for(var mt = 0; mt < metaTrials.length; mt++){
      ctx.font = '700 ' + metaTrials[mt] + 'px Cinzel,serif';
      if(ctx.measureText(metaStr).width <= INFO_W - 30){
        metaSize = metaTrials[mt];
        break;
      }
      metaSize = metaTrials[mt];
    }
    ctx.font = '700 ' + metaSize + 'px Cinzel,serif';
    ctx.fillStyle = '#e8c87a';
    ctx.fillText(metaStr, W / 2, infoY);
    infoY += metaSize + 18;
  } else {
    infoY += 28;
  }
  /* R147: Campaign italic \u2014 now BELOW the meta line. Reads as a
     quiet subtitle rather than competing with the name. Extra
     padding around it so it doesn't crowd the divider rule below. */
  if(c.campaign){
    ctx.font = 'italic 22px Cormorant Garamond,serif';
    ctx.fillStyle = '#a09aae';
    ctx.fillText('"' + c.campaign + '"', W / 2, infoY);
    /* R148-v4: Campaign-to-story gap retuned now that stats no
       longer sit between them. Previous v3 gap (22+18) was sized to
       breathe AGAINST the stats strip — with stats gone, that gap
       reads as empty space, so we tighten it to 22+8. */
    infoY += 22 + 8;
  } else {
    /* R148-v4: No-campaign branch tightened in lockstep (16 -> 6). */
    infoY += 6;
  }
  /* R148-v4: Modest residual buffer where the stats row used to
     render. Combined with the campaign post-gap above this gives a
     ~38px campaign-to-story zone — enough that the italic subtitle
     and the body quote read as distinct beats without leaving a
     dead band of empty space. */
  infoY += 16;
  /* --- Story preview --- */
  /* R148: Story shortened. Truncate at the LAST PERIOD before the cap
     so the excerpt ends on a complete sentence instead of a mid-thought
     ellipsis. Cap dropped 720 -> 420 chars and max lines 8 -> 5 to keep
     the card breathing. A teaser line directing readers to the full
     story sits below this block. */
  if(c.story){
    ctx.font = 'italic 22px Cormorant Garamond,serif';
    ctx.fillStyle = '#c0b8cc';
    ctx.textAlign = 'center';
    var sn = c.story;
    /* R148-v6: Story trimmed back partway (620 -> 500 chars,
       7 -> 6 lines). v5's 7-line cap was too generous and the body
       block visually outweighed the portrait above. Last-sentence
       truncation still applies so the cut lands on a period. */
    var STORY_MAX_CHARS = 500;
    var STORY_MAX_LINES = 6;
    /* End-on-period truncation. Cut the story at the last sentence
       boundary that fits under STORY_MAX_CHARS. If no terminator
       exists within the cap (rare) fall back to space-cut and append
       a period so the excerpt still closes on a sentence. */
    if(sn.length > STORY_MAX_CHARS){
      var slice = sn.substring(0, STORY_MAX_CHARS);
      var lastPeriod = Math.max(
        slice.lastIndexOf('.'),
        slice.lastIndexOf('!'),
        slice.lastIndexOf('?')
      );
      if(lastPeriod > 40){
        sn = slice.substring(0, lastPeriod + 1).replace(/\s+$/, '');
      } else {
        var lastSpace = slice.lastIndexOf(' ');
        sn = (lastSpace > 0 ? slice.substring(0, lastSpace) : slice)
          .replace(/[\s,;:—–-]+$/, '');
        if(!/[.!?]$/.test(sn)) sn += '.';
      }
    }
    var words = sn.split(' ');
    var lines = [];
    var line = '';
    for(var wi = 0; wi < words.length; wi++){
      var trial = line + (line ? ' ' : '') + words[wi];
      if(ctx.measureText(trial).width > INFO_W - 40 && line){
        lines.push(line);
        line = words[wi];
        if(lines.length >= STORY_MAX_LINES){
          line = '';
          break;
        }
      } else {
        line = trial;
      }
    }
    if(line && lines.length < STORY_MAX_LINES) lines.push(line);
    var STORY_LINE_H = 30;
    for(var li = 0; li < lines.length; li++){
      var openQ = li === 0 ? '"' : '';
      var closeQ = li === lines.length - 1 ? '"' : '';
      ctx.fillText(openQ + lines[li] + closeQ, W / 2, infoY + li * STORY_LINE_H);
    }
    /* R148-v4: Teaser line removed per user. The story block now
       closes itself without a "read more" caption — the brand line
       in the footer ("HALL OF HEROES  ·  FRAMEDFANTASY") provides
       the implicit pointer to the live site. */
    infoY += lines.length * STORY_LINE_H + 12;
  } else {
    infoY += 24;
  }
      /* --- Footer --- */
  /* R142-fix: footer positioned relative to bottom frame so it always
     has a guaranteed margin instead of getting squeezed up into the
     stat trio. Brand line sits 44px above bottom frame edge; byline
     row 36px above brand line.
     Byline left + mint date right, then brand line centered below. */
  /* R143-G: tightened from 44/36 to 36/30 — with the info zone now
     fuller (longer story, bigger meta), footer needs less gap from
     bottom frame to avoid floating awkwardly in empty space.
     R148-v7: byline (by AUTHOR / date) pulled DOWN to sit on the
     same horizontal line as the brand line — previously it floated
     30px above the brand line which read as a stray pair of corner
     labels. Now the bottom of the card has one single footer band
     with left = byline, center = brand mark, right = mint date. */
  var brandY = H - FRAME - 36;
  var footerY = brandY;
  var mintDate = _hohFormatMintDate(c.created_at);
  ctx.textBaseline = 'middle';
  if(c.player_name){
    ctx.font = 'italic 18px Cormorant Garamond,serif';
    ctx.fillStyle = '#6a6478';
    ctx.textAlign = 'left';
    ctx.fillText('by ' + c.player_name, INFO_PAD_X, footerY);
  }
  if(mintDate){
    ctx.font = '600 14px Cinzel,serif';
    ctx.fillStyle = '#6a6478';
    ctx.textAlign = 'right';
    ctx.fillText(mintDate, W - INFO_PAD_X, footerY);
  }
  /* Brand line \u2014 centered, smaller, faded */
  ctx.textAlign = 'center';
  ctx.fillStyle = 'rgba(200,164,94,0.55)';
  ctx.font = '700 16px Cinzel,serif';
  /* R148-v4: Brand line reorder per user \u2014 HALL OF HEROES leads, the
     studio mark follows. Hall is the surface they're inside; the
     studio is the publisher behind it. Reading order now matches
     the way users describe the product back ("I posted my char in
     the Hall on Framed Fantasy"). */
  ctx.fillText('HALL OF HEROES  \u00b7  FRAMEDFANTASY', W / 2, brandY);
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';
  /* Export */
  var blob = await new Promise(function(r){ canvas.toBlob(r, 'image/png'); });
  if(!blob) throw new Error('Canvas toBlob returned null');
  var fN = c.name.replace(/[^a-zA-Z0-9]/g, '_') + '_HallOfHeroes.png';
  /* Mobile: prefer the native share sheet so users can post to IG /
     Stories / Discord etc. directly. Desktop: ALWAYS download \u2014 the
     desktop share API is inconsistent (some browsers expose
     navigator.share but the share sheet either fails silently or
     opens a confusing app picker). The download path works reliably
     across every desktop browser. */
  var isMobileShare = false;
  try {
   isMobileShare = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent || '')
    && typeof navigator.share === 'function'
    && typeof navigator.canShare === 'function';
  } catch(_){}
  if(isMobileShare){
   try {
    var file = new File([blob], fN, { type: 'image/png' });
    if(navigator.canShare({ files: [file] })){
     await navigator.share({ files: [file] });
     hohResetShareBtn();
     return;
    }
   } catch(e){
    if(e && e.name === 'AbortError'){ hohResetShareBtn(); return; }
    /* fall through to download */
   }
  }
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = fN;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function(){ URL.revokeObjectURL(url); }, 5000);
  hohResetShareBtn();
 } catch(err){
  console.error('Share card error:', err);
  alert('Could not generate share card. Please try again.');
  hohResetShareBtn();
 }
};
/* R148-Z1: Reset routes through hohRefreshShareBtn so the button
   re-renders in whatever state the user is in NOW (which may have
   changed mid-flight: they could have just unlocked via the modal).
   If the helper isn't available we fall back to the old plain reset. */
function hohResetShareBtn(){
  if(typeof window.hohRefreshShareBtn === 'function'){
    try { window.hohRefreshShareBtn(); return; } catch(_){}
  }
  var b=document.getElementById('hoh-share-btn');
  if(b){b.disabled=false;b.innerHTML='<svg class="hoh-share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg> Character Card';}
}
/* R363: THE DRAW IS SYNCED TO THE SLOT DROP.
   The winner used to be announced at 23:59:59 on the last day of the month,
   which had nothing to do with when commissions actually open. Both moments
   are now the same instant, and both places derive it the same way, so they
   cannot drift apart without someone editing both:
     1. an explicit override, window.HOH_NEXT_DROP_AT or a data-next-drop
        attribute on the countdown, so one line moves both clocks
     2. the scheduled drop, Monday August 3 2026 at 15:00 UTC, which is
        9:00 AM Mountain, 8:00 AM Pacific and Arizona, 10:00 AM Central,
        while that moment is still ahead
     3. after it passes, the first of the next month at 12:00 noon Eastern,
        which is the exact fallback templates/product.d-d-custom-sales.json
        runs for the waitlist countdown
   The target is recomputed on every tick, so the clock rolls itself over to
   the next month the second the drop lands, with no reload. */
function hohNextDropAt() { return hohDropAt(Date.now()); }
/* DRAWDAY: the first drop after refMs (hohNextDropAt is the one after now). */
function hohDropAt(refMs) {
  var raw = '';
  try { raw = window.HOH_NEXT_DROP_AT || ''; } catch (e) { raw = ''; }
  if (!raw) {
    try {
      var el = document.getElementById('hoh-cd-date');
      var box = el && el.closest ? el.closest('[data-next-drop]') : null;
      raw = (box && box.getAttribute('data-next-drop')) || (el && el.getAttribute('data-next-drop')) || '';
    } catch (e2) { raw = ''; }
  }
  if (raw) { var parsed = new Date(raw); if (!isNaN(parsed.getTime())) return parsed; }

  var scheduled = new Date('2026-08-03T15:00:00Z');
  if (scheduled.getTime() > refMs) return scheduled;

  /* first of next month, 12:00 PM Eastern, DST safe. Copied in shape from the
     sales page so the two clocks agree to the second. */
  try {
    var now = new Date(refMs);
    var fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hour12: false });
    var p = {};
    fmt.formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    var y = +p.year, m = +p.month;
    var past = (+p.day > 1) || (+p.day === 1 && +p.hour >= 12);
    if (past) { m += 1; if (m > 12) { m = 1; y += 1; } }
    var t = new Date(Date.UTC(y, m - 1, 1, 14, 0, 0));
    var hFmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', hour12: false });
    t = new Date(t.getTime() + (12 - +hFmt.format(t)) * 3600000);
    return t;
  } catch (e3) {
    var n2 = new Date(refMs);
    return new Date(n2.getFullYear(), n2.getMonth() + 1, 1, 12, 0, 0);
  }
}
/* DRAWDAY (Jan, 2026-10-01): "when the timer countdown hits 0 we need to have
   something replacing ... for 24 hours to let people know the announcement
   for this months winner is coming". True for the 24 hours after a drop:
   the first drop after (now - 24h) has already happened. */
var HOH_DRAW_PENDING_MS = 24 * 3600000;
function hohDrawPending() {
  var now = Date.now(), last = hohDropAt(now - HOH_DRAW_PENDING_MS).getTime();
  return last <= now && now - last < HOH_DRAW_PENDING_MS;
}
window.hohDrawPending = hohDrawPending;
/* ⛔ WINNERPICK (Jan, 2026-10-01): "make it easy for me to select a winner and
   put the featured banner over so i can easily pick the winner on my debug
   mode to set it as this months winner". Debug mode's card view carries a
   "Make <Month>'s winner" button (hohHallCardAdminHtml). It sets that hero
   featured (the FEATURED banner, the first grid slot, the winner panel),
   clears every other featured hero, and stamps quest_meta.winner_month, so
   the winner panel names the right month and the "Jan is picking the
   winner" card ends the moment a winner is chosen.
   The draw month: the draw lands on the 1st at noon Eastern, so the latest
   draw's month is the Eastern month of (now - 12h). */
function hohEtMonthKey(ms) {
  try {
    var p = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit' })
      .formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month;
  } catch (_) { var d = new Date(ms); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2); }
}
function hohDrawMonthKey() { return hohEtMonthKey(Date.now() - 12 * 3600000); }
function hohMonthKeyName(key) {
  var m = /^(\d{4})-(\d{2})$/.exec(String(key || ''));
  if (!m) return '';
  return new Date(Date.UTC(+m[1], +m[2] - 1, 15)).toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
}
function hohWinnerMonthOf(c) {
  var q = c && c.quest_meta;
  return (q && typeof q === 'object' && typeof q.winner_month === 'string') ? q.winner_month : '';
}
function hohFeaturedHero() {
  return (allCharacters || []).find(function (c) { return c && c.featured; }) || null;
}
/* rebuild these heroes' grid cards in place, keeping their reveal state */
function hohRepaintGridCards(ids) {
  var g = document.getElementById('hoh-gallery');
  if (!g || typeof window.hohBuildCardHtml !== 'function') return;
  var tmp = document.createElement('div');
  (ids || []).forEach(function (id) {
    var card = null, kids = g.querySelectorAll('.hoh-card[data-hero-id]');
    for (var i = 0; i < kids.length; i++) { if (kids[i].getAttribute('data-hero-id') === String(id)) { card = kids[i]; break; } }
    var c = card && (allCharacters || []).find(function (x) { return x && String(x.id) === String(id); });
    if (!c) return;
    try { tmp.innerHTML = window.hohBuildCardHtml(c, Array.prototype.indexOf.call(g.children, card)); } catch (_) { return; }
    var fresh = tmp.firstElementChild;
    if (!fresh) return;
    if (card.classList.contains('hoh-visible')) fresh.classList.add('hoh-visible');
    fresh.style.cssText = card.style.cssText;
    card.replaceWith(fresh);
  });
  tmp.innerHTML = '';
  try { hohRefreshCardReveal(); } catch (_) {}
}
/* the current draw already has its winner (crowned through the button) */
function hohDrawWinnerChosen() { return hohWinnerMonthOf(hohFeaturedHero()) === hohDrawMonthKey(); }
window.hohSetMonthWinner = async function (id) {
  if (!id || typeof window.hohIsGodMode !== 'function' || !window.hohIsGodMode()) return;
  var c = (allCharacters || []).find(function (x) { return x && String(x.id) === String(id); });
  if (!c) return;
  var key = hohDrawMonthKey(), month = hohMonthKeyName(key);
  var prev = hohFeaturedHero();
  if (prev && String(prev.id) === String(c.id) && hohWinnerMonthOf(prev) === key) return;
  var touched = [String(c.id)];
  (allCharacters || []).forEach(function (x) { if (x && x.featured && touched.indexOf(String(x.id)) < 0) touched.push(String(x.id)); });
  var msg = 'Make ' + (c.name || 'this hero') + ' ' + month + '’s winner?' +
    ((prev && String(prev.id) !== String(c.id)) ? ' They take the featured spot from ' + (prev.name || 'the current winner') + '.' : '') +
    ' They also get the Raffle Winner badge.';
  var ok = false;
  try { ok = window.confirm(msg); } catch (_) { ok = true; }
  if (!ok) return;
  var qm = {};
  try { qm = Object.assign({}, c.quest_meta || {}); } catch (_) {}
  qm.winner_month = key;
  /* WINNERPICK (Jan, 2026-10-01: "it should be automatic if i select them to be
     the months winner"): the Raffle Winner badge rides the same write. The list
     is read the way the debug badge grant reads it (hohJangelaToggleBadge), and a
     badge the owner had hidden is shown again. Earlier winners keep theirs. */
  var earned = Array.isArray(qm.earned) ? qm.earned.slice()
             : (Array.isArray(qm.badges) ? qm.badges.slice()
             : (qm.source ? [qm.source] : []));
  if (earned.indexOf('raffle-winner') === -1) earned.push('raffle-winner');
  qm.earned = earned;
  if (Array.isArray(qm.hidden)) qm.hidden = qm.hidden.filter(function (k) { return k !== 'raffle-winner'; });
  try {
    /* the new winner first, so the Hall is never left without one */
    var r1 = await supabase.from('characters').update({ featured: true, quest_meta: qm }).eq('id', c.id).select('id');
    if (r1.error || !r1.data || !r1.data.length) {
      try { alert('Could not set the winner' + (r1.error && r1.error.message ? ': ' + r1.error.message : '. The database did not accept the change.')); } catch (_) {}
      return;
    }
    var r2 = await supabase.from('characters').update({ featured: false }).eq('featured', true).neq('id', c.id).select('id');
    if (r2.error) { try { alert(c.name + ' is the winner, but the old featured hero could not be cleared: ' + (r2.error.message || 'error')); } catch (_) {} }
  } catch (e) {
    try { alert('Could not set the winner.'); } catch (_) {}
    return;
  }
  (allCharacters || []).forEach(function (x) { if (x) x.featured = String(x.id) === String(c.id); });
  c.quest_meta = qm;
  /* a fresh crown puts the picker away again (hohHallWinnerBtnHtml) */
  try { _hohWinnerRepick = false; } catch (_) {}
  try { if (typeof window.hohBuildAccountBadgeMaps === 'function') await window.hohBuildAccountBadgeMaps(); } catch (_) {}
  try { renderFeatured(); } catch (_) {}
  try { renderGallery(); } catch (_) {}
  /* the grid keeps a card's node when its hero stays in view (hohSmoothGridUpdate),
     so the new and old winners' cards are rebuilt to move the FEATURED banner now */
  try { hohRepaintGridCards(touched); } catch (_) {}
  try {
    var view = document.querySelector('#hoh-modal .hoh-hall-card-view');
    if (view && view.getAttribute('data-hero-id') === String(c.id) && typeof window.hohOpenHallCard === 'function') window.hohOpenHallCard(c.id, null, true);
  } catch (_) {}
  try { if (typeof window.hohShowHallToast === 'function') window.hohShowHallToast((c.name || 'Your pick') + ' is ' + month + '’s winner.'); } catch (_) {}
};
/* R364: THE DATE IS THE HEADLINE, THE CLOCK IS THE DETAIL.
   One long "Monday, August 3 · 8:00 AM MST / 10:00 AM CDT" at 17px Cinzel
   wrapped mid-phrase on every phone, which read as broken rather than as two
   facts. The day keeps the gold headline; the times drop underneath it,
   smaller and quieter, where they can wrap without hurting anything. */
function hohDropDateLine(target) {
  try {
    var dayFmt = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
    var timeFmt = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
    var times = timeFmt.format(target);
    /* a second reference zone, compared in a fixed locale so a visitor already
       on Central never reads the same clock twice */
    var localCmp = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(target);
    var altCmp = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short', timeZone: 'America/Chicago' }).format(target);
    if (localCmp !== altCmp) times += ' / ' + altCmp;
    /* R364: the day and the times are two block lines on screen, but a screen
       reader walks textContent and ran them together as "Monday, August
       33:00 PM UTC". This comma is 1px and clipped, so it changes nothing you
       can see and gives the reader the pause it needs. */
    return dayFmt.format(target) +
      '<span style="position:absolute;width:1px;height:1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap;">, </span>' +
      /* R437 (Jan): the time line was 12px under a 17px date, close enough
         that the pair read as one grey blur, so it got its own line and
         leading. SPOTLIGHT-READ (Jan 2026-09-27, "hard to read and really
         small"): its look moved out of this inline style into
         .hoh-spotlight-cd-time in hall-of-heroes.css, readable sans at
         16-17px, so the stylesheet sizes it per screen with the date. */
      '<span class="hoh-spotlight-cd-time">' + times + '</span>';
  } catch (e) { return target.toLocaleString(); }
}
function startCountdown(){
  var labelEl = document.getElementById('hoh-cd-date');
  /* DRAWDAY: the winner-coming card replaces the clock for 24 hours after it reaches zero */
  var cdBox = labelEl && labelEl.closest ? labelEl.closest('.hoh-spotlight-countdown') : null;
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function put(id, v){ var el = document.getElementById(id); if (el) el.textContent = v; }
  var lastLine = '';
  function tick(){
    if (cdBox) { try { cdBox.classList.toggle('is-draw-pending', hohDrawPending() && !hohDrawWinnerChosen()); } catch (_) {} }
    var target = hohNextDropAt();
    /* only rewrite the date when it actually changes, so the clock does not
       reparse a fragment of html once a second */
    if (labelEl) {
      var line = hohDropDateLine(target);
      if (line !== lastLine) { labelEl.innerHTML = line; lastLine = line; }
    }
    var diff = target.getTime() - Date.now();
    if (diff < 0) diff = 0;
    var d = Math.floor(diff / 86400000),
        h = Math.floor((diff % 86400000) / 3600000),
        m = Math.floor((diff % 3600000) / 60000),
        s = Math.floor((diff % 60000) / 1000);
    put('hoh-cd-days', pad(d)); put('hoh-cd-hours', pad(h));
    put('hoh-cd-mins', pad(m)); put('hoh-cd-secs', pad(s));
    setTimeout(tick, 1000);
  }
  tick();
}

populateFilterDropdowns();startCountdown();
var hohTip=null;
/* R140-Z3c: Defensive cleanup. The mouseenter/leave pair below leaks
   tooltips in three known cases: (1) the user hovers two badges in
   rapid succession — each mouseenter overwrites the hohTip variable
   without removing the previous DOM node; (2) the gallery re-renders
   while the mouse is over a badge — the badge gets removed from the
   DOM, mouseleave never fires, the tooltip stays orphaned; (3) the
   user clicks the badge — the click activates the FF Portraits sort
   which re-renders the grid, again skipping mouseleave. The helper
   below sweeps every .hoh-ff-tooltip in the DOM and resets the state,
   and is called from the click path + every hohApplyFilters fire. */
function hohClearFfTooltips(){
 try {
  var nodes=document.querySelectorAll('.hoh-ff-tooltip');
  for(var i=0;i<nodes.length;i++){
   if(nodes[i].parentNode) nodes[i].parentNode.removeChild(nodes[i]);
  }
 } catch(_){}
 hohTip=null;
}
window.hohClearFfTooltips=hohClearFfTooltips;
document.addEventListener('mouseenter',function(e){
 if(!e.target.classList||!e.target.classList.contains('hoh-ff-badge'))return;
 /* Sweep any stale tooltip(s) before mounting a new one — even when
    mouseleave failed to fire on the previous badge, we land in a clean
    state here. */
 hohClearFfTooltips();
 hohTip=document.createElement('div');
 hohTip.className='hoh-ff-tooltip';
 hohTip.textContent='Portrait by FramedFantasy';
 document.body.appendChild(hohTip);
 var r=e.target.getBoundingClientRect();
 hohTip.style.left=(r.left+r.width+8)+'px';
 hohTip.style.top=(r.top+r.height/2-hohTip.offsetHeight/2)+'px';
},true);
document.addEventListener('mouseleave',function(e){
 if(!e.target.classList||!e.target.classList.contains('hoh-ff-badge'))return;
 hohClearFfTooltips();
},true);
/* Dismiss the entry veil on Hall ready. Enforces a 600ms minimum on
 screen (so very-fast loads do not just flash) and a 1400ms hard cap
 so the veil never sticks if something errors. Fade is 420ms via the
 inline transition on the element; we wait that long before removing
 it so it exits cleanly instead of popping. */
var hohVeilStart=Date.now();
var hohVeilDone=false;
function hohDismissEnterVeil(){
 if(hohVeilDone)return;hohVeilDone=true;
 var v=document.getElementById('hoh-enter-veil');
 if(!v)return;
 v.classList.add('hoh-enter-veil-out');
 setTimeout(function(){if(v.parentNode)v.parentNode.removeChild(v);},480);
}
function hohScheduleVeilDismiss(){
 var elapsed=Date.now()-hohVeilStart;
 var wait=Math.max(0,600-elapsed);
 setTimeout(hohDismissEnterVeil,wait);
}
/* Safety net: no matter what, the veil is gone within 1400ms. */
setTimeout(hohDismissEnterVeil,1400);

loadCharacters().then(function(){
 /* R140-Z3e: Order changed so the characters-loaded dispatch fires
    FIRST, before any of the scroll/resize/counter helpers. If any of
    those throws, the dispatch happened already and downstream
    listeners (Fresh Faces renderer, etc.) still get notified. The
    explicit hohRenderFreshFaces() call is belt-and-suspenders — even
    if the event listener wasn't bound for some reason, we kick the
    renderer directly. */
 try{document.dispatchEvent(new CustomEvent('hoh:characters-loaded'));}catch(e){}
 try{if(typeof window.hohRenderFreshFaces==='function')window.hohRenderFreshFaces();}catch(e){}
 try{setTimeout(setupScrollAnimations,100);}catch(e){}
 try{hohResizeSort();}catch(e){}
 try{hohUpdateHeartCounter();}catch(e){}
 try{hohScheduleVeilDismiss();}catch(e){}
 try{ if(typeof hohSetupHeroEditRealtime==='function') hohSetupHeroEditRealtime(); }catch(e){}
 /* R380 (2026-08-06, Jan): a signed in player landed straight in their own
    hall, and the main hall was one tap away on the header pill.
    ⛔ R667 (2026-09-04, Jan) REVERSES THAT: "reset the default view, like if
    they are logged in they should still go to the main page of hall of
    heroes instead of the profile page." The Hall of Heroes IS the product
    a returning player should meet, and the auto-route meant a signed in
    visitor never saw the title, the marquee, the giveaway or the grid
    without first tapping back out of a page they never asked for.
    ⛔ NOTHING ELSE ABOUT YOUR HALL CHANGES, and that is the whole reason
    this is a deletion rather than a rewrite. Every deliberate way in still
    works: the header pill (hohYhToggleClick), the profile deep links
    (hohOpenYourHallProfile, hohOpenYourHallTab), the Shop's own entry, and
    the "#my-hall" mark in the URL, which is written when a player walks
    into their hall on purpose and is read back by hoh-your-hall.js on load
    so a REFRESH still holds their place (its v20 rule, untouched). What is
    gone is only the unasked-for redirect on a clean load. */
 /* R376: pull the Battlegrounds Ticket balance once the page knows who
    you are, so the header, the Shop and the door all paint real numbers. */
 try{ if(typeof window.hohSyncBgTickets==='function') window.hohSyncBgTickets(); }catch(e){}
})
/* ============ R472 · THE BOOT MUST NEVER FAIL SILENTLY ============
   Every line inside the .then above is individually guarded, and the promise
   itself was not. So anything that made loadCharacters REJECT skipped the
   whole block with nothing logged: no hoh:characters-loaded, no Fresh Faces
   render, and no relocation of #hoh-fresh-faces into #hoh-yh-page. Combined
   with body.hoh-page-mode-yours, which hides the rest of the page with
   !important, that is a literally blank screen and no console line to explain
   it. hohInitial() above fixes the throw we FOUND. This is the net under
   whatever throws next. */
['catch'](function(err){
 try{ console.error('[hoh] the hall failed to load:', err); }catch(_){}
 /* let every downstream listener run anyway. They all guard themselves and
    several of them can paint useful things from cache. */
 try{ document.dispatchEvent(new CustomEvent('hoh:characters-loaded')); }catch(_){}
 try{ if(typeof window.hohRenderFreshFaces==='function') window.hohRenderFreshFaces(); }catch(_){}
 /* and never leave the reader on an empty screen. The mode class hides the
    whole main hall, so it may only stay on if something actually filled the
    container it hides everything else in favour of. */
 try{
  var pg = document.getElementById('hoh-yh-page');
  if(document.body.classList.contains('hoh-page-mode-yours') && (!pg || !pg.children.length)){
   document.body.classList.remove('hoh-page-mode-yours');
   if(typeof window.hohYhSetHeaderModeHome==='function') window.hohYhSetHeaderModeHome();
  }
 }catch(_){}
 /* the loader was already hidden before the throw, so say what happened
    rather than showing an empty grid that looks like an empty collection */
 try{
  var ld = document.getElementById('hoh-loading'); if(ld) ld.style.display='none';
  var g = document.getElementById('hoh-gallery');
  if(g && !g.children.length){
   var em = document.getElementById('hoh-empty');
   if(em){ em.style.display=''; em.innerHTML = 'The Hall could not load just now. Refresh the page to try again.'; }
  }
 }catch(_){}
});
/* R265: LIVE edit propagation for EVERYONE, no page refresh.
   Uses Realtime BROADCAST rather than postgres_changes on the characters
   table — so ONLY genuine edits push (fields, reframe, hide/unhide), never
   the constant heart increments, and no table replication has to be enabled.
   When anyone saves an edit they call hohBroadcastHeroChange(id); every other
   open tab refetches just that one row, patches its caches, and repaints in
   place. Everything is guarded, so if Realtime is unavailable it silently
   no-ops and the change still shows on the next normal load. */
var _hohEditChan = null;
var _hohRtRerenderT = 0;
function _hohRtScheduleRerender(){
  if(_hohRtRerenderT) return;
  _hohRtRerenderT = setTimeout(function(){
    _hohRtRerenderT = 0;
    try { if(typeof renderGallery === 'function') renderGallery(); } catch(_){}
    try { if(typeof window.hohRenderFreshFaces === 'function') window.hohRenderFreshFaces(); } catch(_){}
    try { if(typeof window.hohRenderYourHall === 'function') window.hohRenderYourHall(); } catch(_){}
  }, 350);
}
function _hohRtRefetchAndPatch(id){
  if(!id) return;
  try {
    supabase.from('characters').select(HOH_CHAR_COLS).eq('id', id).limit(1).then(function(r){
      if(!r || r.error || !r.data || !r.data[0]) return;
      var row = r.data[0];
      var patched = false;
      try {
        var i = allCharacters.findIndex(function(c){ return c && String(c.id) === String(id); });
        if(i >= 0){
          if(row.is_hidden === true){ allCharacters.splice(i, 1); }
          else { allCharacters[i] = row; }
          patched = true;
        } else if(row.is_hidden !== true){ allCharacters.push(row); patched = true; }
      } catch(_){}
      try { if(hohOwnHiddenPatch(row)) patched = true; } catch(_){}
      try {
        if(Array.isArray(window.__hohHidden)){
          var j = window.__hohHidden.findIndex(function(c){ return c && String(c.id) === String(id); });
          if(j >= 0){ if(row.is_hidden === true) window.__hohHidden[j] = row; else window.__hohHidden.splice(j, 1); }
          else if(row.is_hidden === true){ window.__hohHidden.unshift(row); }
        }
      } catch(_){}
      try { if(typeof window.hohForceImageOffsetRepaint === 'function'){ window.hohForceImageOffsetRepaint(id, 'primary'); window.hohForceImageOffsetRepaint(id, 'secondary'); } } catch(_){}
      /* Refresh the detail modal in place if it's showing this hero. */
      try {
        if(currentDetail && String(currentDetail.id) === String(id) && typeof hohOpenDetail === 'function'){
          var _m = document.getElementById('hoh-modal');
          if(_m && _m.style.display !== 'none') hohOpenDetail(id);
        }
      } catch(_){}
      if(patched) _hohRtScheduleRerender();
    }, function(){});
  } catch(_){}
}
function hohSetupHeroEditRealtime(){
  try {
    if(_hohEditChan || !supabase || typeof supabase.channel !== 'function') return;
    _hohEditChan = supabase.channel('hoh-hero-edits', { config: { broadcast: { self: false } } });
    _hohEditChan.on('broadcast', { event: 'hero-changed' }, function(msg){
      var id = msg && msg.payload && msg.payload.id;
      if(id) _hohRtRefetchAndPatch(id);
    });
    _hohEditChan.subscribe();
  } catch(_){}
}
/* Called by every edit path (fields, reframe, hide/unhide) after a successful
   save, so other open tabs pull the change live. No-op until the channel
   subscribes. */
window.hohBroadcastHeroChange = function(id){
  if(!id) return;
  try { if(_hohEditChan && typeof _hohEditChan.send === 'function') _hohEditChan.send({ type: 'broadcast', event: 'hero-changed', payload: { id: String(id) } }); } catch(_){}
};
/* Automatic nightly heart grants were removed at the owner's request. */

/* Summon bar hover sweep. Runs a requestAnimationFrame loop that translates
 the ::before band across the bar. Each sweep starts slightly faster than
 the previous one for as long as the cursor stays on the bar. Smooth and
 continuous because rAF drives a single CSS custom property every frame. */
(function(){
 if(!window.matchMedia||!window.matchMedia('(hover:hover)').matches)return;
 if(window.matchMedia('(prefers-reduced-motion:reduce)').matches)return;
 var bar=document.querySelector('.hoh-pouch-summon-bar');
 if(!bar)return;
 var SWEEP_START_MS=1800;
 var SWEEP_MIN_MS=260;
 var SWEEP_DECAY=0.78;
 var state={active:false,rafId:null,sweepStart:0,sweepDur:SWEEP_START_MS};
 function frame(ts){
 if(!state.active)return;
 var dt=ts-state.sweepStart;
 var p=dt/state.sweepDur;
 if(p>=1){
  /* Start the next sweep, faster than the last down to the min floor. */
  state.sweepStart=ts;
  state.sweepDur=Math.max(SWEEP_MIN_MS,state.sweepDur*SWEEP_DECAY);
  p=0;
 }
 /* Translate from -130% to +130% of the bar width so the band enters
  fully off-screen left and exits fully off-screen right. */
 var x=(-130+p*260).toFixed(2);
 bar.style.setProperty('--sweep-x',x+'%');
 state.rafId=requestAnimationFrame(frame);
 }
 bar.addEventListener('mouseenter',function(){
 if(state.active)return;
 state.active=true;
 state.sweepStart=performance.now();
 state.sweepDur=SWEEP_START_MS;
 bar.classList.add('hoh-summon-sweeping');
 state.rafId=requestAnimationFrame(frame);
 });
 bar.addEventListener('mouseleave',function(){
 state.active=false;
 if(state.rafId){cancelAnimationFrame(state.rafId);state.rafId=null;}
 bar.classList.remove('hoh-summon-sweeping');
 bar.style.setProperty('--sweep-x','-130%');
 });
})();
})();
